// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/bg-profile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/auth-layer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/auth-bg-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/dashboard/search.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/coming-soon-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/details_open.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/details_close.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/landing/home/main_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/landing/background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/landing/widgets-bck.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/landing/home/pattern.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/dashboard/whether.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/whether-widgetbg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/mobile-clock-wallpaper.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/clock-face.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/sec.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/min.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/hour.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/calender-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/sidebar-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/dashboard/search-white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/maintence-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-----------------------------------------------------------------------------------

    Template Name: Universal Admin
    Template URI: themes.pixelstrap.com/universal
    Description: This is Admin theme
    Author: Pixelstrap
    Author URI: https://themeforest.net/user/pixelstrap

-----------------------------------------------------------------------------------

01. General CSS
  02. Generic CSS
  03. Card CSS
  04. Loader CSS
  05. Header CSS
  06. Button CSS
  07. Color CSS
  08. GRID CSS
  09. Error-page  CSS
  10. Icon css
  11. Form Builder 1 CSS
  12. Form Builder 2 CSS
   13.  Email Application  CSS
   14. Chat CSS
   15. Alert CSS
   16. Popover CSS
   17. List CSS
   18. Switch  CSS
   19. Mega option CSS
   20. Touchspin  CSS
    21. Select 2 CSS
	22. User profile css
	23. Progress CSS
	24. According CSS
	25. Authentication CSS
	26. Form CSS
	27. Coming Soon CSS
	28. Radio CSS
	29. Form Input CSS
	30. Data-table CSS
	 31. JS datagrid CSS
	 32. Page CSS
	 33. Ecommerce  CSS
	 34. Pricing CSS
	 35. Form builder css
	 36. NAV CSS
	 37. Dropdown CSS
	 38. Landing CSS
	 39.Table  CSS
	 40. Alertbox-call-out CSS
	 41. Chart CSS
	 42. Timeline CSS
	 43. Timeline 2 CSS
	 44. Tabs CSS
	 45. Gallery CSS
	 46. Blog CSS
	 47. Footer CSS
	 48. Form Wizard
	 49. Badge CSS
	 50. Tree CSS
	 51. Search CSS
	 52. Datepicker CSS
	 53. Dashboard CSS  Dashboard CSS
	 54. Tour  CSS
	 55. theme layout CSS
	 56. Ribbon CSS
	 57. breadcrumb CSS
	 58. Steps  CSS
	 59.Customizer CSS
	 60. RTL CSS
	 62. base_inputs CSS
	 63. Responsive css
 */
/**=====================
     01. General CSS Start
==========================**/
body {
  background-color: rgba(246, 246, 246, 0.6);
  font-size: 14px;
  overflow-x: hidden;
  font-family: Raleway;
  color: #333333;
}

ul {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
}

* a {
  color: #ab8ce4;
}

*.btn:focus {
  box-shadow: none !important;
}

p {
  font-size: 13px;
  line-height: 1.7;
  letter-spacing: 0.7px;
}

code {
  color: #ab8ce4 !important;
  background-color: #eeeeee;
  padding: 3px;
  margin: 0 3px;
  border-radius: 2px;
}

blockquote {
  border-left: 4px solid #cccccc;
  padding: 15px;
}

blockquote.text-center {
  border: none;
  padding: 15px;
}

blockquote.text-right {
  border-left: none;
  border-right: 4px solid #cccccc;
  padding: 15px;
}

:focus {
  outline-color: #ab8ce4;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.ace-editor {
  height: 400px;
  width: 100%;
}

.editor-toolbar {
  width: 100% !important;
}

.CodeMirror {
  top: 0 !important;
}

.typography h1,
.typography .h1,
.typography h2,
.typography .h2,
.typography h3,
.typography .h3,
.typography h4,
.typography .h4,
.typography h5,
.typography .h5,
.typography h6,
.typography .h6 {
  margin: 20px 0;
  margin-top: 0;
}

.typography h1:last-child,
.typography .h1:last-child,
.typography h2:last-child,
.typography .h2:last-child,
.typography h3:last-child,
.typography .h3:last-child,
.typography h4:last-child,
.typography .h4:last-child,
.typography h5:last-child,
.typography .h5:last-child,
.typography h6:last-child,
.typography .h6:last-child {
  margin-bottom: 0;
}

.typography small {
  padding-left: 10px;
  color: #2a3142;
}

pre {
  background-color: #f9f7ff;
  padding: 20px 0;
}

a:hover {
  text-decoration: none;
}

.owl-theme .owl-dots .owl-dot span {
  background: #e7dff7;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #ab8ce4;
}

.owl-theme .owl-nav.disabled+.owl-dots {
  margin-bottom: -10px;
  margin-top: 25px;
}

.click2edit~.note-editor.note-frame {
  margin-bottom: 30px;
}

.note-editor.note-frame {
  border-color: #eeeeee;
}

.note-editor.note-frame {
  border-color: #eeeeee;
}

.modal-dialog .modal-content .modal-body p a {
  margin-right: 0;
}

/**=====================
      01. General CSS Ends
==========================**/
/**=====================
     02. Generic CSS Start
==========================**/
/*====== Padding css starts ======*/
.p-0 {
  padding: 0px;
}

.p-5 {
  padding: 5px;
}

.p-10 {
  padding: 10px;
}

.p-15 {
  padding: 15px;
}

.p-20 {
  padding: 20px;
}

.p-25 {
  padding: 25px;
}

.p-30 {
  padding: 30px;
}

.p-35 {
  padding: 35px;
}

.p-40 {
  padding: 40px;
}

.p-45 {
  padding: 45px;
}

.p-50 {
  padding: 50px;
}

/*====== Padding css ends ======*/
/*====== Padding-left css starts ======*/
.p-l-0 {
  padding-left: 0px;
}

.p-l-5 {
  padding-left: 5px;
}

.p-l-10 {
  padding-left: 10px;
}

.p-l-15 {
  padding-left: 15px;
}

.p-l-20 {
  padding-left: 20px;
}

.p-l-25 {
  padding-left: 25px;
}

.p-l-30 {
  padding-left: 30px;
}

.p-l-35 {
  padding-left: 35px;
}

.p-l-40 {
  padding-left: 40px;
}

.p-l-45 {
  padding-left: 45px;
}

.p-l-50 {
  padding-left: 50px;
}

/*====== Padding-left css ends ======*/
/*====== Padding-top css starts ======*/
.p-t-0 {
  padding-top: 0px !important;
}

.p-t-5 {
  padding-top: 5px !important;
}

.p-t-10 {
  padding-top: 10px !important;
}

.p-t-15 {
  padding-top: 15px !important;
}

.p-t-20 {
  padding-top: 20px !important;
}

.p-t-25 {
  padding-top: 25px !important;
}

.p-t-30 {
  padding-top: 30px !important;
}

.p-t-35 {
  padding-top: 35px !important;
}

.p-t-40 {
  padding-top: 40px !important;
}

.p-t-45 {
  padding-top: 45px !important;
}

.p-t-50 {
  padding-top: 50px !important;
}

/*====== Padding-top css ends ======*/
/*====== Padding-bottom css starts ======*/
.p-b-0 {
  padding-bottom: 0px !important;
}

.p-b-5 {
  padding-bottom: 5px !important;
}

.p-b-10 {
  padding-bottom: 10px !important;
}

.p-b-15 {
  padding-bottom: 15px !important;
}

.p-b-20 {
  padding-bottom: 20px !important;
}

.p-b-25 {
  padding-bottom: 25px !important;
}

.p-b-30 {
  padding-bottom: 30px !important;
}

.p-b-35 {
  padding-bottom: 35px !important;
}

.p-b-40 {
  padding-bottom: 40px !important;
}

.p-b-45 {
  padding-bottom: 45px !important;
}

.p-b-50 {
  padding-bottom: 50px !important;
}

/*====== Padding-bottom css ends ======*/
/*====== Padding-right css starts ======*/
.p-r-0 {
  padding-right: 0px;
}

.p-r-5 {
  padding-right: 5px;
}

.p-r-10 {
  padding-right: 10px;
}

.p-r-15 {
  padding-right: 15px;
}

.p-r-20 {
  padding-right: 20px;
}

.p-r-25 {
  padding-right: 25px;
}

.p-r-30 {
  padding-right: 30px;
}

.p-r-35 {
  padding-right: 35px;
}

.p-r-40 {
  padding-right: 40px;
}

.p-r-45 {
  padding-right: 45px;
}

.p-r-50 {
  padding-right: 50px;
}

/*====== Padding-right css ends ======*/
/*====== Margin css starts ======*/
.m-0 {
  margin: 0px !important;
}

.m-5 {
  margin: 5px !important;
}

.m-10 {
  margin: 10px !important;
}

.m-15 {
  margin: 15px !important;
}

.m-20 {
  margin: 20px !important;
}

.m-25 {
  margin: 25px !important;
}

.m-30 {
  margin: 30px !important;
}

.m-35 {
  margin: 35px !important;
}

.m-40 {
  margin: 40px !important;
}

.m-45 {
  margin: 45px !important;
}

.m-50 {
  margin: 50px !important;
}

/*====== Margin css ends ======*/
/*====== Margin-top css starts ======*/
.m-t-0 {
  margin-top: 0px !important;
}

.m-t-5 {
  margin-top: 5px !important;
}

.m-t-10 {
  margin-top: 10px !important;
}

.m-t-15 {
  margin-top: 15px !important;
}

.m-t-20 {
  margin-top: 20px !important;
}

.m-t-25 {
  margin-top: 25px !important;
}

.m-t-30 {
  margin-top: 30px !important;
}

.m-t-35 {
  margin-top: 35px !important;
}

.m-t-40 {
  margin-top: 40px !important;
}

.m-t-45 {
  margin-top: 45px !important;
}

.m-t-50 {
  margin-top: 50px !important;
}

/*====== Margin-top css ends ======*/
/*====== Margin-Bottom css starts ======*/
.m-b-0 {
  margin-bottom: 0px !important;
}

.m-b-5 {
  margin-bottom: 5px !important;
}

.m-b-10 {
  margin-bottom: 10px !important;
}

.m-b-15 {
  margin-bottom: 15px !important;
}

.m-b-20 {
  margin-bottom: 20px !important;
}

.m-b-25 {
  margin-bottom: 25px !important;
}

.m-b-30 {
  margin-bottom: 30px !important;
}

.m-b-35 {
  margin-bottom: 35px !important;
}

.m-b-40 {
  margin-bottom: 40px !important;
}

.m-b-45 {
  margin-bottom: 45px !important;
}

.m-b-50 {
  margin-bottom: 50px !important;
}

/*====== Margin-Bottom css ends ======*/
/*====== Margin-left css starts ======*/
.m-l-0 {
  margin-left: 0px !important;
}

.m-l-5 {
  margin-left: 5px !important;
}

.m-l-10 {
  margin-left: 10px !important;
}

.m-l-15 {
  margin-left: 15px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.m-l-25 {
  margin-left: 25px !important;
}

.m-l-30 {
  margin-left: 30px !important;
}

.m-l-35 {
  margin-left: 35px !important;
}

.m-l-40 {
  margin-left: 40px !important;
}

.m-l-45 {
  margin-left: 45px !important;
}

.m-l-50 {
  margin-left: 50px !important;
}

/*====== Margin-left css ends ======*/
/*====== Margin-right css starts ======*/
.m-r-0 {
  margin-right: 0px;
}

.m-r-5 {
  margin-right: 5px;
}

.m-r-10 {
  margin-right: 10px;
}

.m-r-15 {
  margin-right: 15px;
}

.m-r-20 {
  margin-right: 20px;
}

.m-r-25 {
  margin-right: 25px;
}

.m-r-30 {
  margin-right: 30px;
}

.m-r-35 {
  margin-right: 35px;
}

.m-r-40 {
  margin-right: 40px;
}

.m-r-45 {
  margin-right: 45px;
}

.m-r-50 {
  margin-right: 50px;
}

/*====== Margin-right css ends ======*/
/*====== Border-radius css starts ======*/
.b-r-0 {
  border-radius: 0px !important;
}

.b-r-1 {
  border-radius: 1px !important;
}

.b-r-2 {
  border-radius: 2px !important;
}

.b-r-3 {
  border-radius: 3px !important;
}

.b-r-4 {
  border-radius: 4px !important;
}

.b-r-5 {
  border-radius: 5px !important;
}

.b-r-6 {
  border-radius: 6px !important;
}

.b-r-7 {
  border-radius: 7px !important;
}

.b-r-8 {
  border-radius: 8px !important;
}

.b-r-9 {
  border-radius: 9px !important;
}

.b-r-10 {
  border-radius: 10px !important;
}

/*====== Border-radius css ends ======*/
/*====== Font-size css starts ======*/
.f-12 {
  font-size: 12px;
}

.f-14 {
  font-size: 14px;
}

.f-16 {
  font-size: 16px;
}

.f-18 {
  font-size: 18px;
}

.f-20 {
  font-size: 20px;
}

.f-22 {
  font-size: 22px;
}

.f-24 {
  font-size: 24px;
}

.f-26 {
  font-size: 26px;
}

.f-28 {
  font-size: 28px;
}

.f-30 {
  font-size: 30px;
}

.f-32 {
  font-size: 32px;
}

.f-34 {
  font-size: 34px;
}

.f-36 {
  font-size: 36px;
}

.f-38 {
  font-size: 38px;
}

.f-40 {
  font-size: 40px;
}

.f-42 {
  font-size: 42px;
}

.f-44 {
  font-size: 44px;
}

.f-46 {
  font-size: 46px;
}

.f-48 {
  font-size: 48px;
}

.f-50 {
  font-size: 50px;
}

.f-52 {
  font-size: 52px;
}

.f-54 {
  font-size: 54px;
}

.f-56 {
  font-size: 56px;
}

.f-58 {
  font-size: 58px;
}

.f-60 {
  font-size: 60px;
}

.f-62 {
  font-size: 62px;
}

.f-64 {
  font-size: 64px;
}

.f-66 {
  font-size: 66px;
}

.f-68 {
  font-size: 68px;
}

.f-70 {
  font-size: 70px;
}

.f-72 {
  font-size: 72px;
}

.f-74 {
  font-size: 74px;
}

.f-76 {
  font-size: 76px;
}

.f-78 {
  font-size: 78px;
}

.f-80 {
  font-size: 80px;
}

.f-82 {
  font-size: 82px;
}

.f-84 {
  font-size: 84px;
}

.f-86 {
  font-size: 86px;
}

.f-88 {
  font-size: 88px;
}

.f-90 {
  font-size: 90px;
}

.f-92 {
  font-size: 92px;
}

.f-94 {
  font-size: 94px;
}

.f-96 {
  font-size: 96px;
}

.f-98 {
  font-size: 98px;
}

.f-100 {
  font-size: 100px;
}

/*====== Font-size css ends ======*/
/*====== Font-weight css starts ======*/
.f-w-100 {
  font-weight: 100;
}

.f-w-300 {
  font-weight: 300;
}

.f-w-400 {
  font-weight: 400;
}

.f-w-600 {
  font-weight: 600;
}

.f-w-700 {
  font-weight: 700;
}

.f-w-900 {
  font-weight: 900;
}

/*====== Font-weight css ends ======*/
/*====== Font-style css starts ======*/
.f-s-normal {
  font-style: normal;
}

.f-s-italic {
  font-style: italic;
}

.f-s-oblique {
  font-style: oblique;
}

.f-s-initial {
  font-style: normal;
  font-style: initial;
}

.f-s-inherit {
  font-style: inherit;
}

/*====== Font-style css ends ======*/
/*====== Text-Decoration css starts ======*/
.text-overline {
  text-decoration: overline;
}

.text-line-through {
  text-decoration: line-through;
}

.text-underline {
  text-decoration: underline;
}

.text-dashed {
  -webkit-text-decoration: dashed;
  text-decoration: dashed;
}

.text-blink {
  text-decoration: blink;
}

.text-dotted {
  -webkit-text-decoration: dotted;
  text-decoration: dotted;
}

.text-initial {
  text-decoration: none;
  text-decoration: initial;
}

.text-none {
  text-decoration: none;
}

.text-solid {
  -webkit-text-decoration: solid;
  text-decoration: solid;
}

.text-wavy {
  -webkit-text-decoration: wavy;
  text-decoration: wavy;
}

.text-inherit {
  text-decoration: inherit;
}

.text-double {
  -webkit-text-decoration: double;
  text-decoration: double;
}

/*====== Text-Decoration css ends ======*/
/*====== Vertical-Align css starts ======*/
.baseline {
  vertical-align: baseline;
}

.sub {
  vertical-align: sub;
}

.super {
  vertical-align: super;
}

.top {
  vertical-align: top;
}

.text-top {
  vertical-align: text-top;
}

.middle {
  vertical-align: middle;
}

.bottom {
  vertical-align: bottom;
}

.text-bottom {
  vertical-align: text-bottom;
}

.initial {
  vertical-align: baseline;
  vertical-align: initial;
}

.inherit {
  vertical-align: inherit;
}

/*====== Vertical-Align css ends ======*/
/*====== Position css starts ======*/
.p-static {
  position: static;
}

.p-absolute {
  position: absolute;
}

.p-fixed {
  position: fixed;
}

.p-relative {
  position: relative;
}

.p-initial {
  position: static;
  position: initial;
}

.p-inherit {
  position: inherit;
}

/*====== Position css ends ======*/
/*====== Float css starts ======*/
.f-left {
  float: left;
}

.f-right {
  float: right;
}

.f-none {
  float: none;
}

/*====== Float css ends ======*/
/*====== Overflow css starts ======*/
.o-hidden {
  overflow: hidden;
}

.o-visible {
  overflow: visible;
}

.o-auto {
  overflow: auto;
}

/*====== Overflow css ends ======*/
/*====== Image-sizes css starts ======*/
.img-10 {
  width: 10px !important;
}

.img-20 {
  width: 20px !important;
}

.img-30 {
  width: 30px !important;
}

.img-40 {
  width: 40px !important;
}

.img-50 {
  width: 50px !important;
}

.img-60 {
  width: 60px !important;
}

.img-70 {
  width: 70px !important;
}

.img-80 {
  width: 80px !important;
}

.img-90 {
  width: 90px !important;
}

.img-100 {
  width: 100px !important;
}

/*====== Image-sizes css ends ======*/
/*======= Text css starts ===========*/
.font-primary {
  color: #ab8ce4 !important;
}

.font-secondary {
  color: #26c6da !important;
}

.font-success {
  color: #00c292 !important;
}

.font-danger {
  color: #FF5370 !important;
}

.font-info {
  color: #4099ff !important;
}

.font-light {
  color: #eeeeee !important;
}

.font-dark {
  color: #2a3142 !important;
}

.font-warning {
  color: #f3d800 !important;
}

/*======= Text css ends ===========*/
/*======= Label-color css starts  ======= */
.label {
  border-radius: 2px;
  color: #fff;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 0;
  text-transform: capitalize;
}

.label-theme {
  background-color: #ab8ce4;
}

.label-primary {
  background-color: #ab8ce4;
}

.label-secondary {
  background-color: #26c6da;
}

.label-success {
  background-color: #00c292;
}

.label-danger {
  background-color: #FF5370;
}

.label-info {
  background-color: #4099ff;
}

.label-light {
  background-color: #eeeeee;
}

.label-dark {
  background-color: #2a3142;
}

.label-warning {
  background-color: #f3d800;
}

/*======= Label-color css ends  ======= */
/*======= Badge-color css starts  ======= */
.badge-primary {
  background-color: #ab8ce4;
}

.badge-secondary {
  background-color: #26c6da;
}

.badge-success {
  background-color: #00c292;
}

.badge-danger {
  background-color: #FF5370;
}

.badge-info {
  background-color: #4099ff;
}

.badge-light {
  background-color: #eeeeee;
}

.badge-dark {
  background-color: #2a3142;
}

.badge-warning {
  background-color: #f3d800;
}

/*======= Badge-color css end  ======= */
/*======= Background-color css starts  ======= */
.bg-primary {
  background-color: #ab8ce4 !important;
  color: #fff;
}

.bg-secondary {
  background-color: #26c6da !important;
  color: #fff;
}

.bg-success {
  background-color: #00c292 !important;
  color: #fff;
}

.bg-danger {
  background-color: #FF5370 !important;
  color: #fff;
}

.bg-info {
  background-color: #4099ff !important;
  color: #fff;
}

.bg-light {
  background-color: #eeeeee !important;
  color: #fff;
}

.bg-dark {
  background-color: #2a3142 !important;
  color: #fff;
}

.bg-warning {
  background-color: #f3d800 !important;
  color: #fff;
}

/*======= Background-color css end  ======= */
/*======= Font-color css starts  ======= */
.txt-primary {
  color: #ab8ce4 !important;
}

.txt-secondary {
  color: #26c6da !important;
}

.txt-success {
  color: #00c292 !important;
}

.txt-danger {
  color: #FF5370 !important;
}

.txt-info {
  color: #4099ff !important;
}

.txt-light {
  color: #eeeeee !important;
}

.txt-dark {
  color: #2a3142 !important;
}

.txt-warning {
  color: #f3d800 !important;
}

.txt-google-plus {
  color: #c64e40 !important;
}

.txt-twitter {
  color: #6fa2d8 !important;
}

.txt-linkedin {
  color: #0077B5 !important;
}

.txt-fb {
  color: #50598e !important;
}

.txt-white {
  color: #fff !important;
}

/*======= Font-color css end  ======= */
/*======= Button-color css starts  ======= */
.btn-primary {
  background-color: #ab8ce4 !important;
  border-color: #ab8ce4 !important;
}

.btn-primary.disabled {
  background-color: #ab8ce4 !important;
  border-color: #ab8ce4 !important;
}

.btn-primary:disabled {
  background-color: #ab8ce4 !important;
  border-color: #ab8ce4 !important;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active {
  background-color: #8d63da !important;
  border-color: #8d63da !important;
}

.btn-primary:focus {
  box-shadow: 0 0 0 0.2rem white;
}

.btn-secondary {
  background-color: #26c6da !important;
  border-color: #26c6da !important;
}

.btn-secondary.disabled {
  background-color: #26c6da !important;
  border-color: #26c6da !important;
}

.btn-secondary:disabled {
  background-color: #26c6da !important;
  border-color: #26c6da !important;
}

.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary:active,
.btn-secondary.active {
  background-color: #1e9faf !important;
  border-color: #1e9faf !important;
}

.btn-secondary:focus {
  box-shadow: 0 0 0 0.2rem #a9e8f0;
}

.btn-success {
  background-color: #00c292 !important;
  border-color: #00c292 !important;
}

.btn-success.disabled {
  background-color: #00c292 !important;
  border-color: #00c292 !important;
}

.btn-success:disabled {
  background-color: #00c292 !important;
  border-color: #00c292 !important;
}

.btn-success:hover,
.btn-success:focus,
.btn-success:active,
.btn-success.active {
  background-color: #008f6c !important;
  border-color: #008f6c !important;
}

.btn-success:focus {
  box-shadow: 0 0 0 0.2rem #5cffd7;
}

.btn-danger {
  background-color: #FF5370 !important;
  border-color: #FF5370 !important;
}

.btn-danger.disabled {
  background-color: #FF5370 !important;
  border-color: #FF5370 !important;
}

.btn-danger:disabled {
  background-color: #FF5370 !important;
  border-color: #FF5370 !important;
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active {
  background-color: #ff2046 !important;
  border-color: #ff2046 !important;
}

.btn-danger:focus {
  box-shadow: 0 0 0 0.2rem #ffecef;
}

.btn-info {
  background-color: #4099ff !important;
  border-color: #4099ff !important;
}

.btn-info.disabled {
  background-color: #4099ff !important;
  border-color: #4099ff !important;
}

.btn-info:disabled {
  background-color: #4099ff !important;
  border-color: #4099ff !important;
}

.btn-info:hover,
.btn-info:focus,
.btn-info:active,
.btn-info.active {
  background-color: #0d7eff !important;
  border-color: #0d7eff !important;
}

.btn-info:focus {
  box-shadow: 0 0 0 0.2rem #d9ebff;
}

.btn-light {
  background-color: #eeeeee !important;
  border-color: #eeeeee !important;
}

.btn-light.disabled {
  background-color: #eeeeee !important;
  border-color: #eeeeee !important;
}

.btn-light:disabled {
  background-color: #eeeeee !important;
  border-color: #eeeeee !important;
}

.btn-light:hover,
.btn-light:focus,
.btn-light:active,
.btn-light.active {
  background-color: #d5d5d5 !important;
  border-color: #d5d5d5 !important;
}

.btn-light:focus {
  box-shadow: 0 0 0 0.2rem white;
}

.btn-dark {
  background-color: #2a3142 !important;
  border-color: #2a3142 !important;
}

.btn-dark.disabled {
  background-color: #2a3142 !important;
  border-color: #2a3142 !important;
}

.btn-dark:disabled {
  background-color: #2a3142 !important;
  border-color: #2a3142 !important;
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active {
  background-color: #161a23 !important;
  border-color: #161a23 !important;
}

.btn-dark:focus {
  box-shadow: 0 0 0 0.2rem #67779e;
}

.btn-warning {
  background-color: #f3d800 !important;
  border-color: #f3d800 !important;
}

.btn-warning.disabled {
  background-color: #f3d800 !important;
  border-color: #f3d800 !important;
}

.btn-warning:disabled {
  background-color: #f3d800 !important;
  border-color: #f3d800 !important;
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning:active,
.btn-warning.active {
  background-color: #c0ab00 !important;
  border-color: #c0ab00 !important;
}

.btn-warning:focus {
  box-shadow: 0 0 0 0.2rem #fff28d;
}

/*======= Button-color css ends  ======= */
.btn-outline-primary-2x {
  border-width: 2px;
  border-color: #ab8ce4;
  color: #ab8ce4;
  background-color: transparent;
}

.btn-outline-primary-2x:hover,
.btn-outline-primary-2x:focus,
.btn-outline-primary-2x:active,
.btn-outline-primary-2x.active {
  color: white;
  background-color: #8d63da !important;
  border-color: #8d63da !important;
  box-shadow: none;
}

.btn-outline-secondary-2x {
  border-width: 2px;
  border-color: #26c6da;
  color: #26c6da;
  background-color: transparent;
}

.btn-outline-secondary-2x:hover,
.btn-outline-secondary-2x:focus,
.btn-outline-secondary-2x:active,
.btn-outline-secondary-2x.active {
  color: white;
  background-color: #1e9faf !important;
  border-color: #1e9faf !important;
  box-shadow: none;
}

.btn-outline-success-2x {
  border-width: 2px;
  border-color: #00c292;
  color: #00c292;
  background-color: transparent;
}

.btn-outline-success-2x:hover,
.btn-outline-success-2x:focus,
.btn-outline-success-2x:active,
.btn-outline-success-2x.active {
  color: white;
  background-color: #008f6c !important;
  border-color: #008f6c !important;
  box-shadow: none;
}

.btn-outline-danger-2x {
  border-width: 2px;
  border-color: #FF5370;
  color: #FF5370;
  background-color: transparent;
}

.btn-outline-danger-2x:hover,
.btn-outline-danger-2x:focus,
.btn-outline-danger-2x:active,
.btn-outline-danger-2x.active {
  color: white;
  background-color: #ff2046 !important;
  border-color: #ff2046 !important;
  box-shadow: none;
}

.btn-outline-info-2x {
  border-width: 2px;
  border-color: #4099ff;
  color: #4099ff;
  background-color: transparent;
}

.btn-outline-info-2x:hover,
.btn-outline-info-2x:focus,
.btn-outline-info-2x:active,
.btn-outline-info-2x.active {
  color: white;
  background-color: #0d7eff !important;
  border-color: #0d7eff !important;
  box-shadow: none;
}

.btn-outline-light-2x {
  border-width: 2px;
  border-color: #eeeeee;
  color: #eeeeee;
  background-color: transparent;
}

.btn-outline-light-2x:hover,
.btn-outline-light-2x:focus,
.btn-outline-light-2x:active,
.btn-outline-light-2x.active {
  color: white;
  background-color: #d5d5d5 !important;
  border-color: #d5d5d5 !important;
  box-shadow: none;
}

.btn-outline-dark-2x {
  border-width: 2px;
  border-color: #2a3142;
  color: #2a3142;
  background-color: transparent;
}

.btn-outline-dark-2x:hover,
.btn-outline-dark-2x:focus,
.btn-outline-dark-2x:active,
.btn-outline-dark-2x.active {
  color: white;
  background-color: #161a23 !important;
  border-color: #161a23 !important;
  box-shadow: none;
}

.btn-outline-warning-2x {
  border-width: 2px;
  border-color: #f3d800;
  color: #f3d800;
  background-color: transparent;
}

.btn-outline-warning-2x:hover,
.btn-outline-warning-2x:focus,
.btn-outline-warning-2x:active,
.btn-outline-warning-2x.active {
  color: white;
  background-color: #c0ab00 !important;
  border-color: #c0ab00 !important;
  box-shadow: none;
}

.btn-outline-primary {
  border-color: #ab8ce4;
  color: #ab8ce4;
  background-color: transparent;
}

.btn-outline-primary.disabled {
  color: #ab8ce4;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:active,
.btn-outline-primary.active {
  color: white;
  background-color: #8d63da !important;
  border-color: #8d63da !important;
}

.btn-outline-secondary {
  border-color: #26c6da;
  color: #26c6da;
  background-color: transparent;
}

.btn-outline-secondary.disabled {
  color: #26c6da;
}

.btn-outline-secondary:hover,
.btn-outline-secondary:focus,
.btn-outline-secondary:active,
.btn-outline-secondary.active {
  color: white;
  background-color: #1e9faf !important;
  border-color: #1e9faf !important;
}

.btn-outline-success {
  border-color: #00c292;
  color: #00c292;
  background-color: transparent;
}

.btn-outline-success.disabled {
  color: #00c292;
}

.btn-outline-success:hover,
.btn-outline-success:focus,
.btn-outline-success:active,
.btn-outline-success.active {
  color: white;
  background-color: #008f6c !important;
  border-color: #008f6c !important;
}

.btn-outline-danger {
  border-color: #FF5370;
  color: #FF5370;
  background-color: transparent;
}

.btn-outline-danger.disabled {
  color: #FF5370;
}

.btn-outline-danger:hover,
.btn-outline-danger:focus,
.btn-outline-danger:active,
.btn-outline-danger.active {
  color: white;
  background-color: #ff2046 !important;
  border-color: #ff2046 !important;
}

.btn-outline-info {
  border-color: #4099ff;
  color: #4099ff;
  background-color: transparent;
}

.btn-outline-info.disabled {
  color: #4099ff;
}

.btn-outline-info:hover,
.btn-outline-info:focus,
.btn-outline-info:active,
.btn-outline-info.active {
  color: white;
  background-color: #0d7eff !important;
  border-color: #0d7eff !important;
}

.btn-outline-light {
  border-color: #eeeeee;
  color: #eeeeee;
  background-color: transparent;
  color: #2a3142;
}

.btn-outline-light.disabled {
  color: #eeeeee;
}

.btn-outline-light:hover,
.btn-outline-light:focus,
.btn-outline-light:active,
.btn-outline-light.active {
  color: white;
  background-color: #d5d5d5 !important;
  border-color: #d5d5d5 !important;
}

.btn-outline-dark {
  border-color: #2a3142;
  color: #2a3142;
  background-color: transparent;
}

.btn-outline-dark.disabled {
  color: #2a3142;
}

.btn-outline-dark:hover,
.btn-outline-dark:focus,
.btn-outline-dark:active,
.btn-outline-dark.active {
  color: white;
  background-color: #161a23 !important;
  border-color: #161a23 !important;
}

.btn-outline-warning {
  border-color: #f3d800;
  color: #f3d800;
  background-color: transparent;
}

.btn-outline-warning.disabled {
  color: #f3d800;
}

.btn-outline-warning:hover,
.btn-outline-warning:focus,
.btn-outline-warning:active,
.btn-outline-warning.active {
  color: white;
  background-color: #c0ab00 !important;
  border-color: #c0ab00 !important;
}

.btn-primary:not([disabled]):not(.disabled).active {
  background-color: #8d63da;
  border-color: #8d63da;
  box-shadow: none !important;
}

.btn-primary:not([disabled]):not(.disabled).active:hover,
.btn-primary:not([disabled]):not(.disabled).active:focus,
.btn-primary:not([disabled]):not(.disabled).active:active,
.btn-primary:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #8d63da;
  border-color: #8d63da;
}

.btn-secondary:not([disabled]):not(.disabled).active {
  background-color: #1e9faf;
  border-color: #1e9faf;
  box-shadow: none !important;
}

.btn-secondary:not([disabled]):not(.disabled).active:hover,
.btn-secondary:not([disabled]):not(.disabled).active:focus,
.btn-secondary:not([disabled]):not(.disabled).active:active,
.btn-secondary:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #1e9faf;
  border-color: #1e9faf;
}

.btn-success:not([disabled]):not(.disabled).active {
  background-color: #008f6c;
  border-color: #008f6c;
  box-shadow: none !important;
}

.btn-success:not([disabled]):not(.disabled).active:hover,
.btn-success:not([disabled]):not(.disabled).active:focus,
.btn-success:not([disabled]):not(.disabled).active:active,
.btn-success:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #008f6c;
  border-color: #008f6c;
}

.btn-danger:not([disabled]):not(.disabled).active {
  background-color: #ff2046;
  border-color: #ff2046;
  box-shadow: none !important;
}

.btn-danger:not([disabled]):not(.disabled).active:hover,
.btn-danger:not([disabled]):not(.disabled).active:focus,
.btn-danger:not([disabled]):not(.disabled).active:active,
.btn-danger:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #ff2046;
  border-color: #ff2046;
}

.btn-info:not([disabled]):not(.disabled).active {
  background-color: #0d7eff;
  border-color: #0d7eff;
  box-shadow: none !important;
}

.btn-info:not([disabled]):not(.disabled).active:hover,
.btn-info:not([disabled]):not(.disabled).active:focus,
.btn-info:not([disabled]):not(.disabled).active:active,
.btn-info:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #0d7eff;
  border-color: #0d7eff;
}

.btn-light:not([disabled]):not(.disabled).active {
  background-color: #d5d5d5;
  border-color: #d5d5d5;
  box-shadow: none !important;
}

.btn-light:not([disabled]):not(.disabled).active:hover,
.btn-light:not([disabled]):not(.disabled).active:focus,
.btn-light:not([disabled]):not(.disabled).active:active,
.btn-light:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #d5d5d5;
  border-color: #d5d5d5;
}

.btn-dark:not([disabled]):not(.disabled).active {
  background-color: #161a23;
  border-color: #161a23;
  box-shadow: none !important;
}

.btn-dark:not([disabled]):not(.disabled).active:hover,
.btn-dark:not([disabled]):not(.disabled).active:focus,
.btn-dark:not([disabled]):not(.disabled).active:active,
.btn-dark:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #161a23;
  border-color: #161a23;
}

.btn-warning:not([disabled]):not(.disabled).active {
  background-color: #c0ab00;
  border-color: #c0ab00;
  box-shadow: none !important;
}

.btn-warning:not([disabled]):not(.disabled).active:hover,
.btn-warning:not([disabled]):not(.disabled).active:focus,
.btn-warning:not([disabled]):not(.disabled).active:active,
.btn-warning:not([disabled]):not(.disabled).active.active {
  color: white;
  background-color: #c0ab00;
  border-color: #c0ab00;
}

.btn-outline-primary-2x:not([disabled]):not(.disabled).active {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  box-shadow: none !important;
  color: white;
}

.btn-outline-primary-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-primary-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-primary-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-primary-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #8d63da !important;
  border-color: #8d63da !important;
}

.btn-outline-secondary-2x:not([disabled]):not(.disabled).active {
  background-color: #26c6da;
  border-color: #26c6da;
  box-shadow: none !important;
  color: white;
}

.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-secondary-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #1e9faf !important;
  border-color: #1e9faf !important;
}

.btn-outline-success-2x:not([disabled]):not(.disabled).active {
  background-color: #00c292;
  border-color: #00c292;
  box-shadow: none !important;
  color: white;
}

.btn-outline-success-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-success-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-success-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-success-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #008f6c !important;
  border-color: #008f6c !important;
}

.btn-outline-danger-2x:not([disabled]):not(.disabled).active {
  background-color: #FF5370;
  border-color: #FF5370;
  box-shadow: none !important;
  color: white;
}

.btn-outline-danger-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-danger-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-danger-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-danger-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #ff2046 !important;
  border-color: #ff2046 !important;
}

.btn-outline-info-2x:not([disabled]):not(.disabled).active {
  background-color: #4099ff;
  border-color: #4099ff;
  box-shadow: none !important;
  color: white;
}

.btn-outline-info-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-info-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-info-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-info-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #0d7eff !important;
  border-color: #0d7eff !important;
}

.btn-outline-light-2x:not([disabled]):not(.disabled).active {
  background-color: #eeeeee;
  border-color: #eeeeee;
  box-shadow: none !important;
  color: white;
}

.btn-outline-light-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-light-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-light-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-light-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #d5d5d5 !important;
  border-color: #d5d5d5 !important;
}

.btn-outline-dark-2x:not([disabled]):not(.disabled).active {
  background-color: #2a3142;
  border-color: #2a3142;
  box-shadow: none !important;
  color: white;
}

.btn-outline-dark-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-dark-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-dark-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-dark-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #161a23 !important;
  border-color: #161a23 !important;
}

.btn-outline-warning-2x:not([disabled]):not(.disabled).active {
  background-color: #f3d800;
  border-color: #f3d800;
  box-shadow: none !important;
  color: white;
}

.btn-outline-warning-2x:not([disabled]):not(.disabled).active:hover,
.btn-outline-warning-2x:not([disabled]):not(.disabled).active:focus,
.btn-outline-warning-2x:not([disabled]):not(.disabled).active:active,
.btn-outline-warning-2x:not([disabled]):not(.disabled).active.active {
  color: white;
  box-shadow: none !important;
  background-color: #c0ab00 !important;
  border-color: #c0ab00 !important;
}

/*======= Table-Border-Bottom-color css starts  ======= */
table thead .border-bottom-primary th,
table tbody .border-bottom-primary th,
table tbody .border-bottom-primary td {
  border-bottom: 1px solid #ab8ce4;
}

table thead .border-bottom-secondary th,
table tbody .border-bottom-secondary th,
table tbody .border-bottom-secondary td {
  border-bottom: 1px solid #26c6da;
}

table thead .border-bottom-success th,
table tbody .border-bottom-success th,
table tbody .border-bottom-success td {
  border-bottom: 1px solid #00c292;
}

table thead .border-bottom-danger th,
table tbody .border-bottom-danger th,
table tbody .border-bottom-danger td {
  border-bottom: 1px solid #FF5370;
}

table thead .border-bottom-info th,
table tbody .border-bottom-info th,
table tbody .border-bottom-info td {
  border-bottom: 1px solid #4099ff;
}

table thead .border-bottom-light th,
table tbody .border-bottom-light th,
table tbody .border-bottom-light td {
  border-bottom: 1px solid #eeeeee;
}

table thead .border-bottom-dark th,
table tbody .border-bottom-dark th,
table tbody .border-bottom-dark td {
  border-bottom: 1px solid #2a3142;
}

table thead .border-bottom-warning th,
table tbody .border-bottom-warning th,
table tbody .border-bottom-warning td {
  border-bottom: 1px solid #f3d800;
}

/*======= Table-Border-Bottom-color css ends  ======= */
/*======= Table styling css starts  ======= */
.table-styling .table-primary,
.table-styling.table-primary {
  background-color: #ab8ce4;
  color: #fff;
  border: 3px solid #ab8ce4;
}

.table-styling .table-primary thead,
.table-styling.table-primary thead {
  background-color: #8d63da;
  border: 3px solid #8d63da;
}

.table-styling .table-secondary,
.table-styling.table-secondary {
  background-color: #26c6da;
  color: #fff;
  border: 3px solid #26c6da;
}

.table-styling .table-secondary thead,
.table-styling.table-secondary thead {
  background-color: #1e9faf;
  border: 3px solid #1e9faf;
}

.table-styling .table-success,
.table-styling.table-success {
  background-color: #00c292;
  color: #fff;
  border: 3px solid #00c292;
}

.table-styling .table-success thead,
.table-styling.table-success thead {
  background-color: #008f6c;
  border: 3px solid #008f6c;
}

.table-styling .table-danger,
.table-styling.table-danger {
  background-color: #FF5370;
  color: #fff;
  border: 3px solid #FF5370;
}

.table-styling .table-danger thead,
.table-styling.table-danger thead {
  background-color: #ff2046;
  border: 3px solid #ff2046;
}

.table-styling .table-info,
.table-styling.table-info {
  background-color: #4099ff;
  color: #fff;
  border: 3px solid #4099ff;
}

.table-styling .table-info thead,
.table-styling.table-info thead {
  background-color: #0d7eff;
  border: 3px solid #0d7eff;
}

.table-styling .table-light,
.table-styling.table-light {
  background-color: #eeeeee;
  color: #fff;
  border: 3px solid #eeeeee;
}

.table-styling .table-light thead,
.table-styling.table-light thead {
  background-color: #d5d5d5;
  border: 3px solid #d5d5d5;
}

.table-styling .table-dark,
.table-styling.table-dark {
  background-color: #2a3142;
  color: #fff;
  border: 3px solid #2a3142;
}

.table-styling .table-dark thead,
.table-styling.table-dark thead {
  background-color: #161a23;
  border: 3px solid #161a23;
}

.table-styling .table-warning,
.table-styling.table-warning {
  background-color: #f3d800;
  color: #fff;
  border: 3px solid #f3d800;
}

.table-styling .table-warning thead,
.table-styling.table-warning thead {
  background-color: #c0ab00;
  border: 3px solid #c0ab00;
}

/*======= Table styling css ends  ======= */
/*======= All-Borders-color css starts  ======= */
.b-primary {
  border: 1px solid #ab8ce4 !important;
}

.b-t-primary {
  border-top: 1px solid #ab8ce4 !important;
}

.b-b-primary {
  border-bottom: 1px solid #ab8ce4 !important;
}

.b-l-primary {
  border-left: 1px solid #ab8ce4 !important;
}

.b-r-primary {
  border-right: 1px solid #ab8ce4 !important;
}

.b-secondary {
  border: 1px solid #26c6da !important;
}

.b-t-secondary {
  border-top: 1px solid #26c6da !important;
}

.b-b-secondary {
  border-bottom: 1px solid #26c6da !important;
}

.b-l-secondary {
  border-left: 1px solid #26c6da !important;
}

.b-r-secondary {
  border-right: 1px solid #26c6da !important;
}

.b-success {
  border: 1px solid #00c292 !important;
}

.b-t-success {
  border-top: 1px solid #00c292 !important;
}

.b-b-success {
  border-bottom: 1px solid #00c292 !important;
}

.b-l-success {
  border-left: 1px solid #00c292 !important;
}

.b-r-success {
  border-right: 1px solid #00c292 !important;
}

.b-danger {
  border: 1px solid #FF5370 !important;
}

.b-t-danger {
  border-top: 1px solid #FF5370 !important;
}

.b-b-danger {
  border-bottom: 1px solid #FF5370 !important;
}

.b-l-danger {
  border-left: 1px solid #FF5370 !important;
}

.b-r-danger {
  border-right: 1px solid #FF5370 !important;
}

.b-info {
  border: 1px solid #4099ff !important;
}

.b-t-info {
  border-top: 1px solid #4099ff !important;
}

.b-b-info {
  border-bottom: 1px solid #4099ff !important;
}

.b-l-info {
  border-left: 1px solid #4099ff !important;
}

.b-r-info {
  border-right: 1px solid #4099ff !important;
}

.b-light {
  border: 1px solid #eeeeee !important;
}

.b-t-light {
  border-top: 1px solid #eeeeee !important;
}

.b-b-light {
  border-bottom: 1px solid #eeeeee !important;
}

.b-l-light {
  border-left: 1px solid #eeeeee !important;
}

.b-r-light {
  border-right: 1px solid #eeeeee !important;
}

.b-dark {
  border: 1px solid #2a3142 !important;
}

.b-t-dark {
  border-top: 1px solid #2a3142 !important;
}

.b-b-dark {
  border-bottom: 1px solid #2a3142 !important;
}

.b-l-dark {
  border-left: 1px solid #2a3142 !important;
}

.b-r-dark {
  border-right: 1px solid #2a3142 !important;
}

.b-warning {
  border: 1px solid #f3d800 !important;
}

.b-t-warning {
  border-top: 1px solid #f3d800 !important;
}

.b-b-warning {
  border-bottom: 1px solid #f3d800 !important;
}

.b-l-warning {
  border-left: 1px solid #f3d800 !important;
}

.b-r-warning {
  border-right: 1px solid #f3d800 !important;
}

/*======= All-Borders-color css ends  ======= */
/*====== Border width css starts ======*/
.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-6 {
  border-width: 6px !important;
}

.border-7 {
  border-width: 7px !important;
}

.border-8 {
  border-width: 8px !important;
}

.border-9 {
  border-width: 9px !important;
}

.border-10 {
  border-width: 10px !important;
}

/*====== Border width css ends ======*/
.card {
  box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  border: 0;
  transition: all 0.3s ease;
}

.card:hover {
  transition: all 0.3s ease;
  box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.12);
}

.card .card-header {
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
  padding: 30px;
}

.card .card-header h5 {
  font-size: 18px;
  margin-bottom: 0;
  text-transform: uppercase;
  font-weight: 600;
}

.card .card-header>span {
  font-size: 12px;
  margin-top: 5px;
  display: block;
  letter-spacing: 1px;
  color: #777777;
}

.card .card-body2 {
  padding:55px 0px;
}
.card .card-body {
  padding:30px;
}
.card .card-body1 {
  padding: 27px;
}

.card .card-body p:last-child {
  margin-bottom: 0;
}

.card .sub-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 5px;
  margin-bottom: 8px;
  font-size: 18px;
}

.card .card-footer {
  background-color: #fff;
  border-top: 1px solid #eeeeee;
  padding: 30px;
}

.opacity-0 {
  opacity: 0;
}

.shadow-0 {
  box-shadow: none;
}

.map-block {
  height: 350px;
  width: 100%;
}

/**====== custom scrollbar css start ======**/
.digits {
  font-family: Open Sans;
}

.custom-scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #cccccc;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #cccccc;
}

/**====== Custom scrollbar css end ======**/
/**====== Animation css Start ======**/
.comment {
  color: #9f9ba5;
  font-style: italic;
}

.line {
  color: #2a3142;
}

.line pre {
  font-size: 100%;
}

/**====== Animation css end ======**/
/**====== list style css Start ======**/
.list-circle {
  list-style: circle;
}

/**====== list style css end ======**/
/**====== Modal style css Start ======**/
.theme-close {
  opacity: 1;
  height: 40px;
  width: 40px;
  position: absolute;
  z-index: 1;
  right: 0;
  background-color: #fff !important;
  border-radius: 5px;
}

/**====== Modal style css end ======**/
/**====== Animation css start ======**/
.options>div {
  color: #999999;
  display: inline-block;
  padding: 2px 10px;
  border: 1px solid;
  margin: 0 8px 8px 0;
  transition: all 0.3s ease;
}

.options>div:hover {
  background-color: #999999;
  color: #fff;
  transition: all 0.3s ease;
}

/**====== Animation css Ends ======**/
.modal-footer {
  flex-wrap: wrap;
}

.img-cropper #putData {
  margin-bottom: 0;
}

.img-cropper .img-container {
  min-height: auto;
  margin-bottom: 0;
}

.img-cropper .docs-data>.input-group:last-child {
  margin-bottom: 0;
}

.img-cropper .docs-preview {
  margin-top: 20px;
  margin-bottom: 10px;
}

.bootstrap-datetimepicker-widget {
  font-family: Open Sans;
}

.dropzone .dz-preview .dz-error-message {
  background: #fff !important;
  color: #ab8ce4 !important;
  border: 1px solid #ab8ce4;
}

.dropzone .dz-preview .dz-error-message:after {
  border-bottom: 6px solid #ab8ce4 !important;
}

.typeahead .theme-form .form-group {
  margin-bottom: 0;
}

.editor-statusbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.page-builder .ge-canvas.ge-editing .row {
  padding: 30px;
  margin-bottom: 0;
}

.page-builder .ge-canvas.ge-layout-desktop [class*="col-"] {
  width: inherit !important;
}

.page-builder .btn-screen {
  padding: 0 18px 0 0;
}

.datepicker {
  z-index: 99;
}

/**=====================
     02. Generic CSS Ends
==========================**/
/**=====================
    03.  Card CSS Start
==========================**/
.card .card-header .card-header-right {
  border-radius: 0 0 0 7px;
  right: 20px;
  top: 23px;
  display: inline-block;
  float: right;
  padding: 7px 0;
  position: absolute;
}

.card .card-header .card-header-right .card-option {
  text-align: right;
  width: 35px;
  height: 20px;
  overflow: hidden;
  transition: 0.3s ease-in-out;
}

.card .card-header .card-header-right .card-option li {
  display: inline-block;
}

.card .card-header .card-header-right i {
  margin: 0 5px;
  cursor: pointer;
  color: #2a3142;
  line-height: 20px;
}

.card .card-header .card-header-right i.icofont-refresh {
  font-size: 13px;
}

.card.card-load .card-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
  align-items: center;
  justify-content: center;
}

.card.card-load .card-loader i {
  margin: 0 auto;
  color: #ab8ce4;
  font-size: 20px;
}

.card.full-card {
  position: fixed;
  top: 80px;
  z-index: 99999;
  box-shadow: none;
  right: 0;
  border-radius: 0;
  border: 1px solid #ddd;
  width: calc(100vw - 270px);
  height: calc(100vh - 80px);
}

.card-absolute {
  margin-top: 20px;
}

.card-absolute .card-header {
  position: absolute;
  top: -20px;
  margin-bottom: 30px;
  left: 15px;
  border-radius: 0.25rem;
  padding: 10px 15px;
}

.card-absolute .card-header h5 {
  font-size: 17px;
}

.card-absolute .card-body {
  margin-top: 10px;
}

.card-header .nav-material {
  margin-bottom: -13px;
}

.custom-card {
  overflow: hidden;
  padding: 30px;
}

.custom-card .card-header {
  padding: 0;
}

.custom-card .card-header img {
  border-radius: 50%;
  margin-top: -100px;
  transform: scale(1.5);
}

.custom-card .card-profile {
  text-align: center;
}

.custom-card .card-profile img {
  height: 150px;
  padding: 7px;
  background-color: #fff;
  z-index: 1;
  position: relative;
}

.custom-card .card-social {
  text-align: center;
}

.custom-card .card-social li {
  display: inline-block;
  padding: 15px 0;
}

.custom-card .card-social li a {
  padding: 13px;
  color: #ddd;
  font-size: 16px;
  transition: all 0.3s ease;
}

.custom-card .card-social li a:hover {
  color: #ab8ce4;
  transition: all 0.3s ease;
}

.custom-card .profile-details h6 {
  margin-bottom: 30px;
  margin-top: 10px;
  color: #777777;
  font-size: 14px;
}

.custom-card .card-footer {
  padding: 0;
}

.custom-card .card-footer>div {
  padding: 15px;
  text-align: center;
}

.custom-card .card-footer>div+div {
  border-left: 1px solid #ddd;
}

.custom-card .card-footer>div h3 {
  margin-bottom: 0;
  font-family: Open Sans;
  font-size: 24px;
}

.custom-card .card-footer>div h6 {
  font-size: 14px;
  color: #777777;
}

.custom-card .card-footer>div i {
  font-size: 24px;
  display: inline-block;
  margin-bottom: 15px;
}

.custom-card .card-footer>div .m-b-card {
  margin-bottom: 10px;
}

/**=====================
    03. Card CSS End
==========================**/
/**=====================
     04. Loader CSS Start
==========================**/
.loader-wrapper {
  height: 100%;
  width: 100%;
  display: block;
  align-items: center;
  justify-content: center;
  position: fixed;
  background-color: #fff;
  z-index: 11;
  top: 0;
}

.loader-wrapper .loader {
  position: absolute;
  top: 50%;
  left: 0;
  text-align: center;
  right: 0;
  margin: 0 auto;
}

.loader-wrapper .loader h4 {
  margin-top: 50px;
  margin-bottom: 0;
}

.loader-wrapper .loader h4 span {
  font-size: 34px;
  color: #FFC107;
}

.loader .line {
  animation: expand 1s ease-in-out infinite;
  border-radius: 10px;
  display: inline-block;
  transform-origin: center center;
  margin: 0 3px;
  width: 1px;
  height: 25px;
}

.loader .line:nth-child(1) {
  background: #00c292;
}

.loader .line:nth-child(2) {
  animation-delay: 180ms;
  background: #ab8ce4;
}

.loader .line:nth-child(3) {
  animation-delay: 360ms;
  background: #FF5370;
}

.loader .line:nth-child(4) {
  animation-delay: 540ms;
  background: #4099ff;
}

@keyframes expand {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(2);
  }
}

.loader-box {
  height: 150px;
  text-align: center;
  display: flex;
  align-items: center;
}

.rotate {
  animation-timing-function: linear;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-name: rotate;
  border: 3px dotted #ab8ce4;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  display: block;
  margin: 1em;
  float: left;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

.solid {
  border-style: solid;
  border-color: #00c292 #008f6c;
}

.dotted {
  border-style: dotted;
}

.dashed {
  border-style: dashed;
}

.double {
  border-style: double;
}

.groove {
  border-style: groove;
}

.ridge {
  border-style: ridge;
}

.inset {
  border-style: inset;
}

.outset {
  border-style: outset;
}

.colored {
  border-color: #FF5370 #ab8ce4 #00c292 #4099ff;
}

/**=====================
     04. Loader CSS Ends
==========================**/
/**=====================
    05. Header CSS Start
==========================**/
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a,
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li.active>a,
body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {
  /* color: #000; */
  color: #ab8ce4;;
  border-left-color: #2a3142;
  transition: all 0.3s ease;
}

.onhover-show-div {
  box-shadow: 0 0 2px 2px #eeeeee;
  transform: translateY(30px);
  opacity: 0;
  visibility: hidden;
  left: 0;
}

.onhover-dropdown:hover .onhover-show-div {
  opacity: 1;
  transform: translateY(0px);
  visibility: visible;
}

.onhover-dropdown:hover .onhover-show-div:before {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #fff;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 2;
}

.onhover-dropdown:hover .onhover-show-div:after {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #717171;
  content: "";
  top: -7px;
  position: absolute;
  left: 10px;
  z-index: 1;
}

/**======Main Header css Start ======**/
.page-main-header {
  max-width: 100vw;
}

.page-main-header .main-header-left {
  width: 280px;
  display: inline-flex;
  height: 100%;
  padding: 12px;
  align-items: center;
  background-color: #fff;
  z-index: -9;
}

.page-main-header .main-header-left .logo-wrapper {
  display: block;
  position: relative;
}

.page-main-header .main-header-left .logo-wrapper img {
  height: 65px;
  margin-top: 10px;
}

.page-main-header .main-header-left .logo-wrapper a .image-dark {
  display: block;
}

.page-main-header .main-header-left .logo-wrapper a .image-light {
  display: none;
}

.page-main-header .main-header-left .mobile-sidebar {
  display: inline-block;
}

.page-main-header .main-header-left .mobile-sidebar i {
  color: #ab8ce4;
  font-size: 20px;
  margin-left: 30px;
}

.page-main-header .main-header-left .mobile-sidebar .switch {
  margin-bottom: 0;
  width: 30px;
  height: 17px;
  margin-left: 40px;
  margin-top: 10px;
}

.page-main-header .main-header-left .mobile-sidebar .switch .switch-state:before {
  height: 11px;
  width: 11px;
  background-color: #ffffff;
}

.page-main-header .main-header-left .mobile-sidebar input:checked+.switch-state:before {
  left: -10px;
}

.page-main-header .main-header-right {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.page-main-header .main-header-right .switch-state {
  background-color: transparent;
  border: 1px solid #ab8ce4;
}

.page-main-header .main-header-right .switch-sm .switch .switch-state:before {
  bottom: 3px;
  background-color: #ab8ce4;
}

.page-main-header .main-header-right .switch input:checked+.switch-state:before {
  background-color: #fff;
}

.page-main-header .main-header-right .nav-left i {
  margin-right: 20px;
}

.page-main-header .main-header-right .nav-left input:focus {
  outline: 0 !important;
}

.page-main-header .main-header-right .nav-right {
  text-align: right;
}

.page-main-header .main-header-right .nav-right ul li i {
  font-size: 20px;
}

.page-main-header .main-header-right .nav-right .notification {
  position: absolute;
  top: 21px;
  right: -1px;
  font-size: 9px;
  animation: blink 1.5s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  70% {
    opacity: 1;
  }

  80% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

.page-main-header .main-header-right .nav-right .icon-user {
  font-size: 16px;
}

@keyframes heartbit {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  25% {
    transform: scale(0.1);
    opacity: 0.1;
  }

  50% {
    transform: scale(0.5);
    opacity: 0.3;
  }

  75% {
    transform: scale(0.8);
    opacity: 0.5;
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.page-main-header .main-header-right .nav-right>ul {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.page-main-header .main-header-right .nav-right>ul>li {
  margin-left: 20px;
  position: relative;
  /* padding: 30px 0; */
}

.page-main-header .main-header-right .nav-right>ul>li h6 {
  color: #ab8ce4;
}

.page-main-header .main-header-right .nav-right>ul>li h6 ul {
  left: inherit;
  right: -10px;
  width: 130px;
}

.page-main-header .main-header-right .nav-right>ul>li h6 ul:before,
.page-main-header .main-header-right .nav-right>ul>li h6 ul:after {
  left: inherit;
  right: 10px;
}

.page-main-header .main-header-right .nav-right>ul>li h6 ul li {
  display: block;
}

.page-main-header .main-header-right .nav-right>ul>li h6 ul li a {
  font-size: 14px;
  color: #2a3142;
}

.page-main-header .main-header-right .nav-right>ul>li h6 ul li a i {
  margin-left: 10px;
  font-size: 13px;
  color: #2a3142;
}

.page-main-header .main-header-right .nav-right>ul .flag-icon {
  font-size: 16px;
}

.page-main-header .main-header-right .nav-right .language-dropdown {
  width: 160px;
  text-align: left;
}

.page-main-header .main-header-right .nav-right .language-dropdown li {
  padding-top: 10px;
}

.page-main-header .main-header-right .nav-right .language-dropdown li a {
  color: #2a3142;
}

.page-main-header .main-header-right .nav-right .language-dropdown li a i {
  margin-right: 10px;
}

.page-main-header .main-header-right .nav-right .language-dropdown li:first-child {
  padding-top: 0;
}

.page-main-header .main-header-right .nav-right .profile-dropdown {
  right: -10px;
  left: inherit;
  /* width: 150px; */
  text-wrap: nowrap;
}

.page-main-header .main-header-right .nav-right .profile-dropdown:before,
.page-main-header .main-header-right .nav-right .profile-dropdown:after {
  left: inherit;
  right: 10px;
}

.page-main-header .main-header-right .nav-right .profile-dropdown li {
  display: block;
  text-align: left;
  padding-top: 10px;
}

.page-main-header .main-header-right .nav-right .profile-dropdown li:first-child {
  padding-top: 0;
}

.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a {
  color: #ab8ce4;
  transition: all 0.3s ease;
}

.page-main-header .main-header-right .nav-right .profile-dropdown li a {
  color: #2a3142;
  transition: all 0.3s ease;
}

.page-main-header .main-header-right .nav-right .profile-dropdown li i {
  font-size: 16px;
  margin-right: 10px;
}

.page-main-header .main-header-right li {
  display: inline-block;
  position: relative;
}

.onhover-dropdown {
  cursor: pointer;
  position: relative;
}

ul.notification-dropdown.onhover-show-div {
  width: 330px;
  right: -30px;
  left: auto;
  left: initial;
}

ul.notification-dropdown.onhover-show-div:before,
ul.notification-dropdown.onhover-show-div:after {
  left: inherit !important;
  right: 35px !important;
}

ul.notification-dropdown.onhover-show-div li {
  display: block;
  padding: 12px 20px;
  border-bottom: 1px solid #eeeeee;
  text-align: left;
}

ul.notification-dropdown.onhover-show-div li span {
  font-size: 12px;
  color: #2a3142;
  font-family: Open Sans;
}

ul.notification-dropdown.onhover-show-div li span i {
  font-size: 11px !important;
  color: #2a3142;
}

ul.notification-dropdown.onhover-show-div li .notification-icon {
  padding: 15px;
  border-radius: 100%;
  margin-right: 20px;
}

.onhover-show-div {
  top: 80px;
  position: absolute;
  z-index: 9;
  background-color: #fff;
  transition: all linear 0.3s;
}

/**======Main Header css Ends ======**/
/*======= Page Header css Start ======= */
.page-wrapper .page-main-header {
  background-color: #ffffff;
  height: 80px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  box-shadow: 0 0 1px 1px #eeeeee;
}

.page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar-open {
  left: -150px;
  transition: all 0.5s ease;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar~.page-body {
  margin-left: 150px;
  width: 100%;
}

.page-wrapper .page-body-wrapper .page-sidebar {
  width: 255px;
  position: fixed;
  background: #ffffff;
  top: 80px;
  box-shadow: 0 0 11px rgba(0, 0, 0, 0.13);
  height: calc(100vh - 80px);
  overflow: auto;
  z-index: 9;
  transform: translate(0px);
  transition: 0.5s;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {
  background-color: #f6f7fb;
  padding: 25px 10px;
  box-shadow: 3px 2px 8px -1px rgba(0, 0, 0, 0.13);
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user img {
  border: 3px solid #fff;
  box-shadow: 0px 5px 22px 0px rgba(0, 0, 0, 0.2);
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {
  color: #2a3142;
  position: relative;
  text-transform: uppercase;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 i {
  margin-right: 10px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {
  color: #fff;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown {
  top: 44px;
  right: 8px;
  left: inherit;
  width: 130px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown:before,
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown:after {
  left: inherit;
  right: 10px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown li {
  display: block;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown li a {
  padding-bottom: 10px;
  display: block;
  color: #2a3142;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown li:last-child a {
  padding-bottom: 0;
}

.page-wrapper .page-body-wrapper .page-sidebar~.page-body {
  /* margin-left: 250px; */
  transition: 0.5s;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {
  list-style: none;
  margin: 0;
  padding: 20px;
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  list-style-type: none;
  white-space: nowrap;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {
  text-transform: uppercase;
  font-weight: 600;
  color: #ab8ce4;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 5px;
  letter-spacing: 1px;
  font-size: 14px;
  margin-top: 25px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {
  font-size: 13px;
  letter-spacing: 1px;
  padding-bottom: 7px;
  padding-top: 7px;
  /* text-transform: uppercase; */
  font-weight: 500;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {
  display: block;
  color: #2a3142;
  font-size: 14px;
  transition: all 0.3s ease;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {
  color: #ab8ce4;
  transition: all 0.3s ease;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {
  color: #ab8ce4;
  padding-left: 5px;
  transition: all 0.3s ease;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i {
  margin-right: 7px;
  text-align: right;
  margin-top: 3px;
  font-size: 15px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i.pull-right {
  position: absolute;
  right: 20px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i~i {
  margin-right: 0;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {
  margin-top: 3px;
  margin-right: 5px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .badge {
  margin-top: 3px;
  margin-right: 5px;
  text-transform: capitalize;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {
  margin-bottom: 0;
  padding: 15px;
  color: #ab8ce4;
  font-weight: 600;
  transition: all 0.3s ease;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>a>.fa-angle-right {
  transform: rotate(90deg);
  transition: all 0.3s ease;
  vertical-align: -7px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>.sidebar-submenu {
  position: relative;
  display: block;
  transform: rotateX(0deg);
  transform-origin: 10% 10%;
  transition: transform 0.3s, opacity 0.3s;
  transform-style: preserve-3d;
  margin-left: 5px;
  list-style: none;
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  list-style-type: none;
  white-space: nowrap;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>.sidebar-submenu>li {
  width: 100%;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>.sidebar-submenu>li>a {
  width: 100%;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li>a>.fa-angle-down {
  width: auto;
  height: auto;
  padding: 0;
  margin-right: 10px;
  margin-top: 3px;
  transition: all 0.3s ease;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {
  color: #2a3142;
  text-decoration: none;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu {
  display: none;
  transform-style: preserve-3d;
  transform: rotateX(-90deg);
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  list-style-type: none;
  white-space: nowrap;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu .sidebar-submenu {
  padding-left: 20px;
  padding-top: 0 !important;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {
  padding-bottom: 7px;
  padding-top: 7px;
  display: block;
  font-size: 14px;
  color: #333333;
  transition: all 0.3s ease;
  text-transform: capitalize;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>.fa {
  width: 20px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>i {
  width: auto;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>.fa-angle-down {
  width: auto;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {
  color: #ab8ce4;
  transition: all 0.3s ease;
  padding-left: 5px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {
  color: #ab8ce4 !important;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li.active>a {
  color: #2a3142;
}

.page-wrapper .page-body-wrapper .page-body {
  min-height: calc(100vh - 80px);
  margin-top: 80px;
  padding: 0 20px;
  position: relative;
  background-color: #f6f7fb;
}

.page-wrapper .page-body-wrapper .page-header {
  padding-top: 30px;
  padding-bottom: 30px;
}

.page-wrapper .page-body-wrapper .page-header .row {
  align-items: center;
}

.page-wrapper .page-body-wrapper .page-header .row h3 {
  font-size: 24px;
  margin-bottom: 0;
  font-weight: 600;
  text-transform: uppercase;
}

.page-wrapper .page-body-wrapper .page-header .row h3 small {
  display: block;
  font-size: 12px;
  margin-top: 7px;
  letter-spacing: 1px;
  text-transform: capitalize;
  color: #777777;
}

.page-wrapper .page-body-wrapper .page-header .breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 0;
}

.page-wrapper .sidebar-close .page-sidebar {
  transition: 0.5s;
  transform: translate(-255px);
}

.page-wrapper .sidebar-close .page-body {
  transition: 0.5s;
  margin-left: 0 !important;
}

/*======= Page Header css ends  ======= */
ul .submenu {
  width: 0;
  overflow: hidden;
  list-style-type: none;
  background: #fff;
  transition: width 0.5s ease-out;
  position: absolute;
  top: -8px;
  right: -12px;
}

ul .submenu input {
  padding: 6px 12px;
  width: 200px;
}

.scorlled .page-sidebar {
  top: 0 !important;
  height: 100vh !important;
}

/** ===== Vertical Menu css Start=====**/
.page-wrapper .vertical-menu-main {
  position: fixed;
  top: 80px;
  width: 100%;
  z-index: 9;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.vertical-menu-mt {
  margin-top: 133px !important;
}

.vertical-menu-mt .custom-card .card-header img {
  margin-top: -146px !important;
}

.vertical-menu-main #main-nav #main-menu li a i {
  margin-right: 8px;
  font-size: 15px;
}

.vertical-menu-main .mega-menu {
  width: 1500px !important;
  max-width: 1500px !important;
  padding: 0;
  left: -182px !important;
}

/** ===== Vertical Menu css Ends=====**/
/* ========sidebar icon vertical menu start=======*/
.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,
.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu,
.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {
  display: block;
  transform: rotateX(0deg);
  z-index: 1;
  background-color: #fff;
  color: #717171;
  font-size: 14px;
  opacity: 1;
  margin-top: -70px;
  padding: 10px 0;
  text-align: left;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);
  position: absolute;
  width: 245px;
  margin-left: 115px;
}

.compact-switch {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-icon {
  display: flex;
  flex-direction: row;
  flex: 1 0 auto;
  position: relative;
}

.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-header {
  margin-top: 5px;
  text-align: center;
}

.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-header>span {
  display: block !important;
  font-size: 11px;
  margin-top: 2px;
  color: #777777;
  letter-spacing: 0;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar {
  opacity: 1;
  z-index: 1;
  position: fixed;
  height: auto;
  display: table;
  width: 145px;
  left: 0;
  transition: all 0.5s ease;
  min-height: calc(100vh - 80px);
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user {
  padding: 10px;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu {
  padding: 20px 0;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li {
  padding: 0 20px;
  width: 100%;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li.active a i,
.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li.active a span {
  color: #ab8ce4;
  transition: all 0.3s ease;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li a {
  width: 100%;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li>a:hover {
  padding-left: 0;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li>a:hover i,
.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li>a:hover span {
  color: #ab8ce4;
  transition: all 0.3s ease;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header {
  margin-top: 5px;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {
  font-size: 25px;
  margin: 0;
  color: #717171;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover ul li .sidebar-submenu {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li .icon-sidebar {
  font-size: 25px;
  margin: 0;
  color: #717171;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li .sub-header-title {
  display: block;
  font-size: 11px;
  margin-top: 2px;
  color: #777777;
  letter-spacing: 0;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li.active:hover>.sidebar-submenu {
  display: block;
  position: relative;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li.active>.sidebar-submenu {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li ul li:hover .sidebar-submenu {
  display: block;
  transform: rotateX(0deg);
  z-index: 1;
  background-color: #fff;
  color: #717171;
  font-size: 14px;
  opacity: 1;
  margin-top: -70px;
  padding: 10px 0;
  text-align: left;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);
  position: absolute;
  width: 245px;
  margin-left: 225px;
}

.page-wrapper .page-body-wrapper.sidebar-icon .main-sidebar-menu {
  padding: 0 !important;
  text-align: center;
}

.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-title {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-submenu {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-icon.page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {
  padding: 10px 20px;
}

.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-header span {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-menu>li>a .fa-angle-right {
  display: none;
}

.sidebar-toggle-btn {
  font-size: 18px;
  margin-left: 10px;
  cursor: pointer;
}

/* ========sidebar icon vertical menu end=======*/
/* ========sidebar hover vertical menu start=======*/
.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar {
  transform: translate(-180px);
  transition: 0.5s;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-user,
.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-header {
  text-align: right !important;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover {
  transform: translate(0px);
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-user {
  text-align: center !important;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-header {
  text-align: left !important;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-menu li .icon-sidebar {
  margin-right: 5px;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-menu li .icon-sidebar {
  margin: 0;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-menu li.active>.sidebar-submenu {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-menu li:hover ul li .sidebar-submenu {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-body {
  margin-left: 75px !important;
}

.page-wrapper .page-body-wrapper.sidebar-hover .page-body #customer-review .owl-stage-outer {
  width: 92%;
  margin: 0 auto;
}

.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-title {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-submenu {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-hover .active {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-menu .sidebar-header {
  text-align: left;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-menu li.active>.sidebar-submenu {
  display: inline-block;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-menu>li>a .fa-angle-right {
  display: inline-block;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-user {
  padding: 25px 10px;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-user h6 {
  display: inline-block;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-title {
  display: inline-block;
  width: 100%;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .active {
  display: inline-block;
  width: 100%;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-header span {
  display: inline-block;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {
  text-align: center;
}

.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar .sidebar-user h6 {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-header span {
  display: none;
}

.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-menu>li>a .fa-angle-right {
  display: none;
}

/* ========sidebar hover vertical menu ends=======*/
/*=======Mega menu css start=======*/
.mega-menu {
  perspective: inherit;
  position: static !important;
  padding-top: 5px;
  padding-left: 30px;
}

.mega-menu .default-according .card .btn-link {
  font-weight: 500;
  color: gray;
}

.mega-menu .default-according .card .card-body {
  font-size: 12px;
}

.mega-menu .onhover-show-div {
  width: 1500px;
}

.mega-menu .card-body {
  padding: 20px;
}

.mega-menu .title {
  color: #333333;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
  padding-bottom: 15px;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.mega-menu div>div a {
  margin-bottom: 0px;
  display: inline-block;
  color: #777777;
}

.mega-menu .custom-nav-img {
  position: static;
}

.mega-menu .custom-nav-img .desk {
  line-height: 25px;
  font-size: 14px;
  color: #777777;
}

.mega-menu .list-unstyled div a {
  padding: 8px 35px 8px 0;
  transition: all 0.3s ease;
}

.mega-menu .list-unstyled div a:hover {
  padding: 8px 35px 8px 10px;
  transition: all 0.3s ease;
}

.mega-menu .galleria div {
  margin-bottom: 5px;
}

.mega-menu .galleria div:hover {
  transform: translateY(4px) scale(1.04);
}

.mega-menu .galleria-list .galleria>div {
  width: 25%;
  font-size: 12px;
  float: left;
  color: #000;
  transition: ease-in 0.3s;
}

.mega-menu .galleria-list .galleria>div>a {
  display: block;
  margin: 5px 0 10px;
  padding: 0 0 !important;
}

.mega-menu .galleria-list .galleria>div img {
  border-radius: 3px;
  max-width: 100%;
}

.mega-menu .galleria-list .galleria>div .username {
  font-size: 12px;
  color: #333333;
  margin-bottom: 5px;
}

.mega-menu .galleria-list .galleria>div .username small {
  display: block;
  font-size: 11px;
  color: #777777;
  margin-top: 3px;
}

.mega-menu .drilldown {
  overflow: hidden;
  width: 100%;
  padding: 0;
  transform: translate3d(0, 0, 0);
}

.mega-menu .drilldown a {
  width: 100%;
}

.mega-menu .drilldown a:hover {
  background-color: transparent;
  color: #ab8ce4;
}

.mega-menu .drilldown-sub {
  display: none;
}

.mega-menu .drilldown-back {
  font-weight: bold;
}

/*=======Mega menu css end=======*/
/*page chat quickview model start*/
.quickview-wrapper {
  position: fixed;
  right: -285px;
  top: 80px;
  width: 285px;
  background: #fff;
  bottom: 0;
  z-index: 10;
  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);
  border-left: 1px solid rgba(222, 227, 231, 0.56);
  transition: transform 400ms cubic-bezier(0.05, 0.74, 0.27, 0.99);
  height: calc(100% - 80px);
}

.quickview-wrapper.open {
  transform: translate3d(-100%, 0, 0);
}

.quickview-wrapper .friend-list-search {
  position: relative;
  background-color: #eeeeee;
  padding: 20px;
}

.quickview-wrapper .friend-list-search input {
  color: #717171;
  width: 100%;
  background-color: #fff;
  border: 1px solid #eeeeee;
  padding: 10px 15px;
  border-radius: 4px;
  letter-spacing: 1px;
}

.quickview-wrapper .friend-list-search .fa {
  position: absolute;
  right: 35px;
  top: 35px;
  font-size: 14px;
  color: #cccccc;
}

.quickview-wrapper .recent-activity {
  padding: 20px 40px;
  margin-left: 25px;
  position: relative;
}

.quickview-wrapper .recent-activity .user-first-letter:after {
  content: "";
  position: absolute;
  height: 100%;
  left: 0;
  top: 10px;
  float: left;
  border: 1px dashed #eeeeee;
}

.quickview-wrapper .recent-activity .user-first-letter span {
  position: absolute;
  left: -23px;
  width: 45px;
  text-align: center;
  color: #fff;
  height: 45px;
  border-radius: 50%;
  z-index: 1;
  font-size: 20px;
  align-items: center;
  display: flex;
  justify-content: center;
  top: 10px;
}

.quickview-wrapper .recent-activity .activity-content h6 {
  color: #444444;
}

.quickview-wrapper .recent-activity .activity-content p {
  font-size: 14px;
  color: #aaaaaa;
  margin: 0;
}

.quickview-wrapper .modal-header .modal-title {
  font-size: 15px;
  color: #444444;
  letter-spacing: 1px;
  font-weight: 500;
}

.quickview-wrapper .modal-header i {
  font-size: 16px;
  color: #717171;
}

.quickview-wrapper .quickview-box .quickview-box-toggle {
  position: absolute;
  width: 54px;
  height: 50px;
  top: 45%;
  left: -50px;
  text-align: center;
  line-height: 54px;
  cursor: pointer;
  padding: 0 !important;
}

.quickview-wrapper .quickview-box:before {
  position: absolute;
  content: '';
  width: 48px;
  height: 50px;
  background-color: #fff;
  top: 45%;
  left: -47px;
  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);
  border-left: 1px solid rgba(222, 227, 231, 0.56);
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.quickview-wrapper .quickview-box:after {
  position: absolute;
  content: '';
  background-color: #fff;
  width: 5px;
  height: 50px;
  left: 0;
  top: 45%;
}

.quickview-wrapper .quickview-recent-activity .quickview-box-toggle {
  position: absolute;
  width: 54px;
  height: 50px;
  top: 52%;
  left: -50px;
  text-align: center;
  line-height: 54px;
  cursor: pointer;
  padding: 0 !important;
}

.quickview-wrapper .quickview-recent-activity:before {
  position: absolute;
  content: '';
  width: 48px;
  height: 50px;
  background-color: #fff;
  top: 52%;
  left: -47px;
  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);
  border-left: 1px solid rgba(222, 227, 231, 0.56);
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.quickview-wrapper .quickview-recent-activity:after {
  position: absolute;
  content: '';
  background-color: #fff;
  width: 5px;
  height: 50px;
  left: 0;
  top: 52%;
}

.quickview-wrapper .chat-box .friend-list {
  margin-top: 20px;
}

.chat-quickview {
  right: -400px;
  width: 400px;
}

.chat-quickview .chat-box .chat-left-aside .chat .chat-msg-box {
  height: 650px;
}

.chat-quickview .chat-box .chat-left-aside .chat .chat-msg-box .message {
  width: 100%;
}

.chat-quickview .chat-box .chat-left-aside .chat .chat-message {
  padding: 30px 0;
  margin: 30px 0;
  border-top: 1px solid #eeeeee;
}

/*page chat quickview model end*/
/*box layout start*/
.box-layout.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar {
  width: 75px;
  transform: translate(0px);
}

.box-layout.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover {
  width: 255px;
}

.box-layout.page-wrapper .sidebar-close .page-sidebar.page-sidebar-open {
  display: none;
}

.box-layout.page-wrapper .page-body-wrapper.sidebar-close .page-sidebar {
  display: none;
}

.box-layout.page-wrapper .page-body-wrapper.sidebar-icon {
  overflow: hidden;
}

.box-layout.page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar-open {
  transform: translateX(-150px);
  left: auto;
  left: initial;
}

.box-layout.page-wrapper .sidebar-icon .page-sidebar {
  position: absolute;
}

.box-layout.page-wrapper .sidebar-icon .page-sidebar>div {
  position: fixed;
  background-color: #fff;
  height: 100vh;
  width: 145px;
  box-shadow: 0 0 11px rgba(0, 0, 0, 0.13);
}

.box-layout.page-wrapper .page-main-header .main-header-right {
  margin: 0;
}

.box-layout.page-wrapper .page-main-header .vertical-menu-main .mega-menu {
  width: 1050px !important;
  max-width: 1050px !important;
  left: -80px !important;
}

.box-layout.page-wrapper .page-body-wrapper {
  width: 1280px;
  box-shadow: 1px 3px 25px rgba(0, 0, 0, 0.07);
  margin: 0 auto;
}

.box-layout.page-wrapper .page-body-wrapper .footer-fix {
  width: 1027px;
  margin: 0 auto;
  left: 256px;
  right: 0;
  padding-right: 0;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content>div {
  height: 450px;
  z-index: 9;
  background-color: rgba(255, 255, 255, 0.75);
  background-blend-mode: overlay;
  width: 100%;
  padding: 30px;
  left: 15px;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content button {
  width: 40%;
  font-size: 14px;
  margin: 0 auto;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons {
  margin-top: 20px;
  margin-bottom: 20px;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons ul li {
  border: 1px solid #717171;
  width: 50px;
  height: 50px;
  padding: 8px;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img {
  margin-top: 30px;
  margin-bottom: 30px;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img img {
  width: 38%;
}

.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .total-time h2 {
  font-size: 28px;
  color: #717171;
}

.box-layout.page-wrapper .page-body-wrapper canvas#myLineCharts {
  width: 100%;
}

.box-layout.page-wrapper .page-body-wrapper .chat-right-aside {
  flex: 0 0 60%;
  max-width: 60%;
  overflow: hidden;
}

.box-layout.page-wrapper .page-body-wrapper .caller-img {
  position: absolute;
  width: 100%;
  max-width: 100%;
  left: 15px;
}

.box-layout.page-wrapper .page-body-wrapper .caller-img img {
  opacity: 0.7;
}

.box-layout.page-wrapper .page-body-wrapper .browser-widget img {
  height: 65px;
}

.box-layout.page-wrapper .page-body-wrapper .weather-widget-two .bottom-whetherinfo .whether-content {
  top: 39px;
}

.box-layout.page-wrapper .page-body-wrapper .custom-card .card-header img {
  margin-top: -73px;
}

.box-layout.page-wrapper .page-body-wrapper .custom-card .card-profile img {
  height: 130px;
  top: -17px;
}

.box-layout.page-wrapper .page-body-wrapper .height-scroll {
  max-height: 444px;
}

.box-layout.page-wrapper .page-body-wrapper .select2 {
  width: 901.781px;
}

.box-layout.page-wrapper .page-body-wrapper.sidebar-hover .page-body #customer-review .owl-stage-outer {
  width: 85%;
}

.box-layout.page-wrapper .page-main-header {
  max-width: 1280px;
  margin: 0 auto;
  left: 0;
  right: 0;
}

.box-layout.page-wrapper .page-builder .ge-canvas.ge-layout-desktop {
  margin-top: 50px;
}

.box-layout.page-wrapper .page-builder .ge-addRowGroup {
  margin-bottom: 10px;
}

.box-layout.page-wrapper .pricing-wrapper-card {
  padding: 50px 20px;
}

.box-layout.page-wrapper .card .blog-box.blog-grid.set-min-height {
  min-height: 400px;
}

.box-layout.page-wrapper .card .card-body .top-sale-chart canvas#myLineCharts {
  min-height: 410px;
}

.box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris-daily {
  min-height: 430px;
}

.box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris {
  min-height: 430px;
}

.box-layout.page-wrapper .set-col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.box-layout.page-wrapper .set-col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.box-layout.page-wrapper .set-col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.box-layout.page-wrapper .set-col-7 {
  flex: 0 0 60%;
  max-width: 60%;
}

.box-layout.page-wrapper .set-col-5 {
  flex: 0 0 40%;
  max-width: 40%;
}

.box-layout.page-wrapper .chat-box .chat-right-aside {
  flex: 0 0 100%;
  max-width: calc(100% - 15px);
  overflow: hidden;
}

.box-layout.page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
  font-size: 19px;
}

.box-layout.page-wrapper .chat-box .toogle-bar {
  display: inline-block;
  margin-right: 0 !important;
}

.box-layout.page-wrapper .chat-menu {
  right: 0;
  border-top: 1px solid #ddd;
  opacity: 0;
  transform: translateY(-30px);
  visibility: hidden;
  top: 81px;
  position: absolute;
  z-index: 9;
  background-color: #fff;
  transition: all linear 0.3s;
}

.box-layout.page-wrapper .chat-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0px);
  transition: all linear 0.3s;
  padding-bottom: 25px;
}

.box-layout.page-wrapper .ct-10.total-chart .ct-chart-bar .ct-series .ct-bar {
  stroke-width: 23px !important;
}

.box-layout.page-wrapper .email-wrap .email-body .email-compose .cke_contents.cke_reset {
  max-height: 197px;
}

.box-layout.page-wrapper .email-wrap .email-right-aside .email-body .inbox {
  height: 734px;
}

.box-layout.page-wrapper .email-wrap .email-content .email-top .user-emailid:after {
  right: -10px;
  top: -21px;
}

.box-layout.page-wrapper .todo .notification-popup {
  right: 320px;
}

.box-layout.page-wrapper .touchspin {
  padding: 0 10px;
}

.box-layout.page-wrapper .vertical-menu-main {
  width: 1280px;
  margin: 0 auto;
  left: 0;
  right: 0;
}

.box-layout.page-wrapper .vertical-menu-main .mega-menu {
  width: 1050px !important;
  max-width: 1050px !important;
  left: -320px !important;
}

.box-layout.page-wrapper .comingsoon video {
  min-width: 67%;
  width: 67%;
}

.box-layout.page-wrapper .authentication-main .auth-innerleft {
  width: 22.333333%;
}

.box-layout.page-wrapper .auth-bg-effect .second-effect {
  left: 55%;
}

.box-layout.page-wrapper .auth-bg-video video {
  min-width: 67%;
  width: 67%;
}

/*box layout Ends*/
.sidebar-widget {
  padding-top: 20px;
  border-top: 1px solid #eeeeee;
  padding-bottom: 20px;
}

.sidebar-widget .sidebar-widget-top {
  margin-bottom: -50px;
}

.sidebar-widget .sidebar-widget-top i {
  height: 60px;
  width: 60px;
  background-color: #fff;
  display: inline-block;
  font-size: 24px;
  border-radius: 100%;
  line-height: 2.3;
}

.sidebar-widget .sidebar-widget-bottom {
  background-color: #eeeeee;
  text-align: center;
}

.sidebar-widget .sidebar-widget-bottom p {
  line-height: 2.3;
  padding-top: 26px;
  font-size: 15px;
  margin-bottom: 0;
}

/**=====================
    05. Header CSS Ends
==========================**/
/**=====================
    06. Button CSS start
==========================**/
.btn-air-primary {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-primary:hover,
.btn-air-primary:active,
.btn-air-primary:not([disabled]):not(.disabled):active {
  background-color: #8d63da;
  border-color: #8d63da;
}

.btn-air-secondary {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-secondary:hover,
.btn-air-secondary:active,
.btn-air-secondary:not([disabled]):not(.disabled):active {
  background-color: #1e9faf;
  border-color: #1e9faf;
}

.btn-air-success {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-success:hover,
.btn-air-success:active,
.btn-air-success:not([disabled]):not(.disabled):active {
  background-color: #008f6c;
  border-color: #008f6c;
}

.btn-air-danger {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-danger:hover,
.btn-air-danger:active,
.btn-air-danger:not([disabled]):not(.disabled):active {
  background-color: #ff2046;
  border-color: #ff2046;
}

.btn-air-info {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-info:hover,
.btn-air-info:active,
.btn-air-info:not([disabled]):not(.disabled):active {
  background-color: #0d7eff;
  border-color: #0d7eff;
}

.btn-air-light {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-light:hover,
.btn-air-light:active,
.btn-air-light:not([disabled]):not(.disabled):active {
  background-color: #d5d5d5;
  border-color: #d5d5d5;
}

.btn-air-dark {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-dark:hover,
.btn-air-dark:active,
.btn-air-dark:not([disabled]):not(.disabled):active {
  background-color: #161a23;
  border-color: #161a23;
}

.btn-air-warning {
  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;
}

.btn-air-warning:hover,
.btn-air-warning:active,
.btn-air-warning:not([disabled]):not(.disabled):active {
  background-color: #c0ab00;
  border-color: #c0ab00;
}

.input-air-primary {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-primary:focus {
  border-color: #ab8ce4;
}

.input-air-secondary {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-secondary:focus {
  border-color: #26c6da;
}

.input-air-success {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-success:focus {
  border-color: #00c292;
}

.input-air-danger {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-danger:focus {
  border-color: #FF5370;
}

.input-air-info {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-info:focus {
  border-color: #4099ff;
}

.input-air-light {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-light:focus {
  border-color: #eeeeee;
}

.input-air-dark {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-dark:focus {
  border-color: #2a3142;
}

.input-air-warning {
  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;
}

.input-air-warning:focus {
  border-color: #f3d800;
}

.form-bg-primary {
  background: #ab8ce4;
  border-color: #ab8ce4;
  color: #fff;
}

.form-bg-primary:focus {
  border-color: #ab8ce4;
  background: #ab8ce4;
  color: #fff;
}

.form-bg-primary:focus:active {
  border-color: #ab8ce4;
  background: #ab8ce4;
  color: #fff;
}

.form-bg-secondary {
  background: #26c6da;
  border-color: #26c6da;
  color: #fff;
}

.form-bg-secondary:focus {
  border-color: #26c6da;
  background: #26c6da;
  color: #fff;
}

.form-bg-secondary:focus:active {
  border-color: #26c6da;
  background: #26c6da;
  color: #fff;
}

.form-bg-success {
  background: #00c292;
  border-color: #00c292;
  color: #fff;
}

.form-bg-success:focus {
  border-color: #00c292;
  background: #00c292;
  color: #fff;
}

.form-bg-success:focus:active {
  border-color: #00c292;
  background: #00c292;
  color: #fff;
}

.form-bg-danger {
  background: #FF5370;
  border-color: #FF5370;
  color: #fff;
}

.form-bg-danger:focus {
  border-color: #FF5370;
  background: #FF5370;
  color: #fff;
}

.form-bg-danger:focus:active {
  border-color: #FF5370;
  background: #FF5370;
  color: #fff;
}

.form-bg-info {
  background: #4099ff;
  border-color: #4099ff;
  color: #fff;
}

.form-bg-info:focus {
  border-color: #4099ff;
  background: #4099ff;
  color: #fff;
}

.form-bg-info:focus:active {
  border-color: #4099ff;
  background: #4099ff;
  color: #fff;
}

.form-bg-light {
  background: #eeeeee;
  border-color: #eeeeee;
  color: #2a3142;
}

.form-bg-light:focus {
  border-color: #eeeeee;
  background: #eeeeee;
  color: #2a3142;
}

.form-bg-light:focus:active {
  border-color: #eeeeee;
  background: #eeeeee;
  color: #2a3142;
}

.form-bg-dark {
  background: #2a3142;
  border-color: #2a3142;
  color: #fff;
}

.form-bg-dark:focus {
  border-color: #2a3142;
  background: #2a3142;
  color: #fff;
}

.form-bg-dark:focus:active {
  border-color: #2a3142;
  background: #2a3142;
  color: #fff;
}

.form-bg-warning {
  background: #f3d800;
  border-color: #f3d800;
  color: #fff;
}

.form-bg-warning:focus {
  border-color: #f3d800;
  background: #f3d800;
  color: #fff;
}

.form-bg-warning:focus:active {
  border-color: #f3d800;
  background: #f3d800;
  color: #fff;
}

.btn-primary-gradien {
  background-image: linear-gradient(to right, #c3adec 0%, #936bdc 51%, #c3adec 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-primary-gradien:focus,
.btn-primary-gradien:active,
.btn-primary-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #c3adec, 0%, #936bdc, 100%, #fff) !important;
}

.btn-secondary-gradien {
  background-image: linear-gradient(to right, #49cfe0 0%, #1fa7b8 51%, #49cfe0 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-secondary-gradien:hover,
.btn-secondary-gradien:focus,
.btn-secondary-gradien:active,
.btn-secondary-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #49cfe0, 0%, #1fa7b8, 100%, #fff) !important;
}

.btn-success-gradien {
  background-image: linear-gradient(to right, #00ebb1 0%, #009973 51%, #00ebb1 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-success-gradien:hover,
.btn-success-gradien:focus,
.btn-success-gradien:active,
.btn-success-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #00ebb1, 0%, #009973, 100%, #fff) !important;
}

.btn-danger-gradien {
  background-image: linear-gradient(to right, #ff7c92 0%, #ff2a4e 51%, #ff7c92 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-danger-gradien:hover,
.btn-danger-gradien:focus,
.btn-danger-gradien:active,
.btn-danger-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #ff7c92, 0%, #ff2a4e, 100%, #fff) !important;
}

.btn-warning-gradien {
  background-image: linear-gradient(to right, #ffe61d 0%, #cab400 51%, #ffe61d 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-warning-gradien:hover,
.btn-warning-gradien:focus,
.btn-warning-gradien:active,
.btn-warning-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #ffe61d, 0%, #cab400, 100%, #fff) !important;
}

.btn-info-gradien {
  background-image: linear-gradient(to right, #69afff 0%, #1783ff 51%, #69afff 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-info-gradien:hover,
.btn-info-gradien:focus,
.btn-info-gradien:active,
.btn-info-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #69afff, 0%, #1783ff, 100%, #fff) !important;
}

.btn-light-gradien {
  background-image: linear-gradient(to right, white 0%, #dadada 51%, white 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-light-gradien:hover,
.btn-light-gradien:focus,
.btn-light-gradien:active,
.btn-light-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, white, 0%, #dadada, 100%, #fff) !important;
}

.btn-dark-gradien {
  background-image: linear-gradient(to right, #3a445b 0%, #1a1e29 51%, #3a445b 100%);
  border: none;
  color: #fff;
  background-size: auto 200%;
  transition: all 0.3s ease;
}

.btn-dark-gradien:hover,
.btn-dark-gradien:focus,
.btn-dark-gradien:active,
.btn-dark-gradien.active {
  transition: 1.5s;
  background-position: right center;
  background-image: linear-gradient(to right, #3a445b, 0%, #1a1e29, 100%, #fff) !important;
}

[class*='-gradien']:hover {
  background-size: 50% 100%;
  transition: all 0.3s ease;
}

.large-btn {
  margin-bottom: -20px;
}

.large-btn .btn {
  margin-right: 5px;
  margin-bottom: 15px;
}

.btn-square {
  border-radius: 0px;
}

.btn-pill {
  border-radius: 60px;
}

.btn-group-pill .btn:first-child {
  border-radius: 60px 0 0 60px;
}

.btn-group-pill .btn:last-child {
  border-radius: 0 60px 60px 0;
}

.btn-group-square .btn:first-child {
  border-radius: 0px 0 0 0px;
}

.btn-group-square .btn:last-child {
  border-radius: 0 0px 0px 0;
}

.btn-showcase {
  margin-bottom: -10px;
}

.btn-showcase .btn {
  margin-bottom: 10px;
  margin-right: 18px;
}

.btn-dropdown-showcase {
  margin-bottom: -10px;
}

.btn-dropdown-showcase .dropdown {
  margin-bottom: 10px;
  margin-right: 18px;
}

.btn-dropdown-showcase .btn-group {
  margin-bottom: 10px;
  margin-right: 18px;
}

.btn-group .radio label::before {
  top: 2px;
}

.btn-group .radio label::after {
  top: 7px;
}

.btn-group .checkbox label {
  margin-top: 3px;
}

.btn-group-showcase>div {
  margin-bottom: -20px;
}

.btn-group-showcase>div label {
  margin-bottom: 0;
}

.btn-group-showcase .btn-group {
  margin-right: 20px;
  margin-bottom: 20px;
}

.btn {
  font-size: 14px;
  padding: 0.375rem 1.75rem;
}

.btn-lg {
  font-size: 1.25rem;
}

.btn-sm {
  font-size: 12px;
}

.btn-xs {
  padding: 0.05rem 0.4rem;
  font-size: 11px;
}

.tooltiptext {
  visibility: visible;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 1;
  transition: opacity 0.3s;
}

.tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/**=====================
     06. Button CSS end
==========================**/
/**=====================
     07. Color CSS Start
==========================**/
.color-box {
  margin-bottom: -10px;
}

.primary-color ul li:nth-child(13) {
  background-color: #b092e5;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(13) span:before {
  content: "#b092e5";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(12) {
  background-color: #b498e7;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(12) span:before {
  content: "#b498e7";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(11) {
  background-color: #b99fe8;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(11) span:before {
  content: "#b99fe8";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(10) {
  background-color: #bda5ea;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(10) span:before {
  content: "#bda5ea";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(9) {
  background-color: #c2abeb;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(9) span:before {
  content: "#c2abeb";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(8) {
  background-color: #c6b1ed;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(8) span:before {
  content: "#c6b1ed";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(7) {
  background-color: #cbb7ee;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(7) span:before {
  content: "#cbb7ee";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(6) {
  background-color: #cfbef0;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(6) span:before {
  content: "#cfbef0";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(5) {
  background-color: #d4c4f1;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(5) span:before {
  content: "#d4c4f1";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(4) {
  background-color: #d8caf3;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(4) span:before {
  content: "#d8caf3";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(3) {
  background-color: #ddd0f4;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(3) span:before {
  content: "#ddd0f4";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(2) {
  background-color: #e1d6f5;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(2) span:before {
  content: "#e1d6f5";
  display: block;
  color: #fff;
  text-align: center;
}

.primary-color ul li:nth-child(1) {
  background-color: #e6ddf7;
  padding: 10px 15px;
}

.primary-color ul li:nth-child(1) span:before {
  content: "#e6ddf7";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(13) {
  background-color: #33c9dc;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(13) span:before {
  content: "#33c9dc";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(12) {
  background-color: #40cdde;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(12) span:before {
  content: "#40cdde";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(11) {
  background-color: #4dd0e1;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(11) span:before {
  content: "#4dd0e1";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(10) {
  background-color: #5ad4e3;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(10) span:before {
  content: "#5ad4e3";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(9) {
  background-color: #67d7e5;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(9) span:before {
  content: "#67d7e5";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(8) {
  background-color: #74dbe7;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(8) span:before {
  content: "#74dbe7";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(7) {
  background-color: #81deea;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(7) span:before {
  content: "#81deea";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(6) {
  background-color: #8fe1ec;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(6) span:before {
  content: "#8fe1ec";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(5) {
  background-color: #9ce5ee;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(5) span:before {
  content: "#9ce5ee";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(4) {
  background-color: #a9e8f0;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(4) span:before {
  content: "#a9e8f0";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(3) {
  background-color: #b6ecf3;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(3) span:before {
  content: "#b6ecf3";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(2) {
  background-color: #c3eff5;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(2) span:before {
  content: "#c3eff5";
  display: block;
  color: #fff;
  text-align: center;
}

.secondary-color ul li:nth-child(1) {
  background-color: #d0f3f7;
  padding: 10px 15px;
}

.secondary-color ul li:nth-child(1) span:before {
  content: "#d0f3f7";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(13) {
  background-color: #00c795;
  padding: 10px 15px;
}

.success-color ul li:nth-child(13) span:before {
  content: "#00c795";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(12) {
  background-color: #00cb99;
  padding: 10px 15px;
}

.success-color ul li:nth-child(12) span:before {
  content: "#00cb99";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(11) {
  background-color: #00d09c;
  padding: 10px 15px;
}

.success-color ul li:nth-child(11) span:before {
  content: "#00d09c";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(10) {
  background-color: #00d4a0;
  padding: 10px 15px;
}

.success-color ul li:nth-child(10) span:before {
  content: "#00d4a0";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(9) {
  background-color: #00d9a3;
  padding: 10px 15px;
}

.success-color ul li:nth-child(9) span:before {
  content: "#00d9a3";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(8) {
  background-color: #00dea7;
  padding: 10px 15px;
}

.success-color ul li:nth-child(8) span:before {
  content: "#00dea7";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(7) {
  background-color: #00e2aa;
  padding: 10px 15px;
}

.success-color ul li:nth-child(7) span:before {
  content: "#00e2aa";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(6) {
  background-color: #00e7ae;
  padding: 10px 15px;
}

.success-color ul li:nth-child(6) span:before {
  content: "#00e7ae";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(5) {
  background-color: #00ebb1;
  padding: 10px 15px;
}

.success-color ul li:nth-child(5) span:before {
  content: "#00ebb1";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(4) {
  background-color: #00f0b5;
  padding: 10px 15px;
}

.success-color ul li:nth-child(4) span:before {
  content: "#00f0b5";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(3) {
  background-color: #00f4b8;
  padding: 10px 15px;
}

.success-color ul li:nth-child(3) span:before {
  content: "#00f4b8";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(2) {
  background-color: #00f9bb;
  padding: 10px 15px;
}

.success-color ul li:nth-child(2) span:before {
  content: "#00f9bb";
  display: block;
  color: #fff;
  text-align: center;
}

.success-color ul li:nth-child(1) {
  background-color: #00febf;
  padding: 10px 15px;
}

.success-color ul li:nth-child(1) span:before {
  content: "#00febf";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(13) {
  background-color: #4da0ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(13) span:before {
  content: "#4da0ff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(12) {
  background-color: #5aa7ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(12) span:before {
  content: "#5aa7ff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(11) {
  background-color: #66adff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(11) span:before {
  content: "#66adff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(10) {
  background-color: #73b4ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(10) span:before {
  content: "#73b4ff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(9) {
  background-color: #80bbff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(9) span:before {
  content: "#80bbff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(8) {
  background-color: #8dc2ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(8) span:before {
  content: "#8dc2ff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(7) {
  background-color: #99c9ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(7) span:before {
  content: "#99c9ff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(6) {
  background-color: #a6cfff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(6) span:before {
  content: "#a6cfff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(5) {
  background-color: #b3d6ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(5) span:before {
  content: "#b3d6ff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(4) {
  background-color: #c0ddff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(4) span:before {
  content: "#c0ddff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(3) {
  background-color: #cce4ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(3) span:before {
  content: "#cce4ff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(2) {
  background-color: #d9ebff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(2) span:before {
  content: "#d9ebff";
  display: block;
  color: #fff;
  text-align: center;
}

.info-color ul li:nth-child(1) {
  background-color: #e6f2ff;
  padding: 10px 15px;
}

.info-color ul li:nth-child(1) span:before {
  content: "#e6f2ff";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(13) {
  background-color: #ffe303;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(13) span:before {
  content: "#ffe303";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(12) {
  background-color: #ffe513;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(12) span:before {
  content: "#ffe513";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(11) {
  background-color: #ffe622;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(11) span:before {
  content: "#ffe622";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(10) {
  background-color: #ffe831;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(10) span:before {
  content: "#ffe831";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(9) {
  background-color: #ffea41;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(9) span:before {
  content: "#ffea41";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(8) {
  background-color: #ffec50;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(8) span:before {
  content: "#ffec50";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(7) {
  background-color: #ffed5f;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(7) span:before {
  content: "#ffed5f";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(6) {
  background-color: #ffef6e;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(6) span:before {
  content: "#ffef6e";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(5) {
  background-color: #fff17e;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(5) span:before {
  content: "#fff17e";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(4) {
  background-color: #fff28d;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(4) span:before {
  content: "#fff28d";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(3) {
  background-color: #fff49c;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(3) span:before {
  content: "#fff49c";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(2) {
  background-color: #fff6ac;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(2) span:before {
  content: "#fff6ac";
  display: block;
  color: #fff;
  text-align: center;
}

.yellow-color ul li:nth-child(1) {
  background-color: #fff7bb;
  padding: 10px 15px;
}

.yellow-color ul li:nth-child(1) span:before {
  content: "#fff7bb";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(13) {
  background-color: #ff5d78;
  padding: 10px 15px;
}

.red-color ul li:nth-child(13) span:before {
  content: "#ff5d78";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(12) {
  background-color: #ff6781;
  padding: 10px 15px;
}

.red-color ul li:nth-child(12) span:before {
  content: "#ff6781";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(11) {
  background-color: #ff7289;
  padding: 10px 15px;
}

.red-color ul li:nth-child(11) span:before {
  content: "#ff7289";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(10) {
  background-color: #ff7c92;
  padding: 10px 15px;
}

.red-color ul li:nth-child(10) span:before {
  content: "#ff7c92";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(9) {
  background-color: #ff869a;
  padding: 10px 15px;
}

.red-color ul li:nth-child(9) span:before {
  content: "#ff869a";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(8) {
  background-color: #ff90a3;
  padding: 10px 15px;
}

.red-color ul li:nth-child(8) span:before {
  content: "#ff90a3";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(7) {
  background-color: #ff9aab;
  padding: 10px 15px;
}

.red-color ul li:nth-child(7) span:before {
  content: "#ff9aab";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(6) {
  background-color: #ffa5b4;
  padding: 10px 15px;
}

.red-color ul li:nth-child(6) span:before {
  content: "#ffa5b4";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(5) {
  background-color: #ffafbc;
  padding: 10px 15px;
}

.red-color ul li:nth-child(5) span:before {
  content: "#ffafbc";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(4) {
  background-color: #ffb9c5;
  padding: 10px 15px;
}

.red-color ul li:nth-child(4) span:before {
  content: "#ffb9c5";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(3) {
  background-color: #ffc3cd;
  padding: 10px 15px;
}

.red-color ul li:nth-child(3) span:before {
  content: "#ffc3cd";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(2) {
  background-color: #ffcdd6;
  padding: 10px 15px;
}

.red-color ul li:nth-child(2) span:before {
  content: "#ffcdd6";
  display: block;
  color: #fff;
  text-align: center;
}

.red-color ul li:nth-child(1) {
  background-color: #ffd8de;
  padding: 10px 15px;
}

.red-color ul li:nth-child(1) span:before {
  content: "#ffd8de";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(13) {
  background-color: #eb2067;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(13) span:before {
  content: "#eb2067";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(12) {
  background-color: #ec2e70;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(12) span:before {
  content: "#ec2e70";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(11) {
  background-color: #ed3c7a;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(11) span:before {
  content: "#ed3c7a";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(10) {
  background-color: #ee4a83;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(10) span:before {
  content: "#ee4a83";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(9) {
  background-color: #f0588d;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(9) span:before {
  content: "#f0588d";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(8) {
  background-color: #f16696;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(8) span:before {
  content: "#f16696";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(7) {
  background-color: #f274a0;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(7) span:before {
  content: "#f274a0";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(6) {
  background-color: #f482aa;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(6) span:before {
  content: "#f482aa";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(5) {
  background-color: #f590b3;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(5) span:before {
  content: "#f590b3";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(4) {
  background-color: #f69ebd;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(4) span:before {
  content: "#f69ebd";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(3) {
  background-color: #f7acc6;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(3) span:before {
  content: "#f7acc6";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(2) {
  background-color: #f9bad0;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(2) span:before {
  content: "#f9bad0";
  display: block;
  color: #fff;
  text-align: center;
}

.pink-color ul li:nth-child(1) {
  background-color: #fac8d9;
  padding: 10px 15px;
}

.pink-color ul li:nth-child(1) span:before {
  content: "#fac8d9";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(13) {
  background-color: #797979;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(13) span:before {
  content: "#797979";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(12) {
  background-color: gray;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(12) span:before {
  content: "gray";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(11) {
  background-color: #888888;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(11) span:before {
  content: "#888888";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(10) {
  background-color: #909090;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(10) span:before {
  content: "#909090";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(9) {
  background-color: #979797;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(9) span:before {
  content: "#979797";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(8) {
  background-color: #9f9f9f;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(8) span:before {
  content: "#9f9f9f";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(7) {
  background-color: #a7a7a7;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(7) span:before {
  content: "#a7a7a7";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(6) {
  background-color: #aeaeae;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(6) span:before {
  content: "#aeaeae";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(5) {
  background-color: #b6b6b6;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(5) span:before {
  content: "#b6b6b6";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(4) {
  background-color: #bebebe;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(4) span:before {
  content: "#bebebe";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(3) {
  background-color: #c5c5c5;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(3) span:before {
  content: "#c5c5c5";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(2) {
  background-color: #cdcdcd;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(2) span:before {
  content: "#cdcdcd";
  display: block;
  color: #fff;
  text-align: center;
}

.gray-color ul li:nth-child(1) {
  background-color: #d4d4d4;
  padding: 10px 15px;
}

.gray-color ul li:nth-child(1) span:before {
  content: "#d4d4d4";
  display: block;
  color: #fff;
  text-align: center;
}

/**=====================
     07. Color CSS Ends
==========================**/
/**=====================
      08. GRID CSS Start
==========================**/
.grid-showcase {
  margin-bottom: -10px;
}

.grid-showcase span {
  display: block;
  border: 1px solid #eeeeee;
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-color: #fff;
}

.grid-align {
  margin-bottom: -30px;
}

.grid-align .row {
  padding: 15px 0;
  min-height: 10rem;
  border: 1px solid #eeeeee;
  margin-bottom: 30px;
  background-color: #eeeeee;
}

/**=====================
      08. GRID CSS Ends
==========================**/
/**=====================
     09. Error-page  CSS Start
==========================**/
.error-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
}

.error-wrapper .maintenance-icons li i {
  color: #eeeeee;
  font-size: 50px;
  animation: rotate-effect 40s infinite linear reverse;
}

.error-wrapper .maintenance-icons li:nth-child(2) i {
  font-size: 100px;
  margin-left: 110px;
  margin-top: -25px;
  animation: rotate-effect 40s linear infinite reverse;
}

.error-wrapper .maintenance-icons li:nth-child(3) i {
  animation: rotate-effect 30s infinite linear;
  font-size: 150px;
  margin-top: -85px;
  margin-right: 120px;
}

.error-wrapper .maintenance-heading {
  margin-top: 70px;
}

.error-wrapper .maintenance-heading .cloud-first {
  z-index: 0;
  width: 600px;
}

.error-wrapper .maintenance-heading .cloud-second {
  z-index: 3;
  width: 400px;
  margin-top: -55px;
  position: relative;
}

.error-wrapper .maintenance-heading .headline {
  font-size: 99px;
  font-weight: 900;
  letter-spacing: 10px;
  color: #4099ff;
  z-index: 2;
  position: relative;
  margin-top: -150px;
}

.error-wrapper .error-heading {
  margin-top: 115px;
}

.error-wrapper .error-heading .cloud-first {
  z-index: 0;
  width: 755px;
}

.error-wrapper .error-heading .cloud-second {
  z-index: 3;
  width: 450px;
  margin-top: -90px;
  position: relative;
}

.error-wrapper .error-heading .headline {
  font-size: 285px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: -370px;
  font-family: Open Sans;
}

.error-wrapper .sub-content {
  font-size: 18px;
  color: #333333;
  letter-spacing: 1px;
  font-weight: normal;
  line-height: 35px;
  z-index: 3;
  position: relative;
  margin-top: 30px;
  margin-bottom: 0;
}

.error-wrapper .btn {
  margin-top: 40px;
}

.error {
  margin: 70px 0 100px;
  color: #000;
}

.error .error-title {
  font-size: 9.5rem;
  color: #fff;
  text-shadow: 6px 6px 7px rgba(0, 0, 0, 0.32);
}

.error .line-bottom {
  width: 10%;
  height: 5px;
  background-color: #f3d800;
  border: none;
}

.error .c-white {
  color: #fff;
}

.error .error-btn {
  text-align: center;
}

.error .padd {
  padding: 10px 30px 10px 30px;
}

.error .btn-back-home {
  background-color: #eeeeee;
  color: #000;
}

.error .btn-back-home:hover {
  background-color: #f3d800;
  color: #fff;
  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);
}

.error .btn-adnc-serc {
  background-color: #2a3142;
  color: #fff;
}

.error .btn-adnc-serc:hover {
  background-color: #f3d800;
  color: #fff;
  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);
}

/**=====================
     09. Error-page CSS Ends
==========================**/
/**=====================
    10.  ICON CSS Start
==========================**/
.icons-page .notify-alert {
  width: auto !important;
  min-width: 170px;
  padding: 7px 40px 7px 30px;
  letter-spacing: 1.5px;
  font-weight: 600;
  background-color: #ab8ce4;
}

.icons-page .notify-alert button {
  top: 3px !important;
  color: #fff;
}

.icon-lists div {
  cursor: pointer;
  line-height: 60px;
  white-space: nowrap;
  border-radius: 4px;
  font-family: Raleway;
  display: flex;
  align-items: center;
}

.icon-lists div:hover {
  background-color: #fafafa;
}

.icon-lists div i {
  margin: 0 15px 0 10px;
  font-size: 30px;
  color: #717171;
}

.icon-lists.whether-icon svg {
  height: 50px;
  width: 50px;
}

.flag-icons {
  margin-bottom: -15px;
  margin-top: -15px;
}

.flag-icons div {
  line-height: 1;
  word-wrap: break-word;
  overflow: auto;
  font-family: Raleway;
}

.flag-icons div .flag-icon {
  height: 50px;
  width: 50px;
}

.flag-icons div .media {
  padding-top: 15px;
  padding-bottom: 15px;
}

.flag-icons div .media-body h6 {
  margin-bottom: 0;
  font-size: 14px;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.flag-icons div .media-body h5 {
  background-color: #ab8ce4;
  display: inline-block;
  padding: 3px 5px;
  font-size: 11px;
  border-radius: 3px;
  margin-bottom: 5px;
  color: #fff;
}

.icon-hover-bottom {
  background-color: #f6f6f6;
  width: 100%;
  bottom: 0;
  left: 0;
  box-shadow: 0px 0px 1px 1px #eeeeee;
  z-index: 999;
}

.icon-hover-bottom .icon-popup {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
}

.icon-hover-bottom .icon-popup .close-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 20px;
  color: #999999;
  cursor: pointer;
}

.icon-hover-bottom .icon-popup>div {
  display: inline-block;
  font-family: Raleway;
}

.icon-hover-bottom .icon-popup>div .flag-icon {
  width: 60px;
  height: 60px;
}

.icon-hover-bottom .icon-popup .icon-class {
  margin: 0 20px;
  cursor: pointer;
  font-family: Raleway;
}

.icon-hover-bottom .icon-title {
  display: block;
  color: #2a3142;
  text-transform: uppercase;
  font-weight: 500;
  font-family: Raleway;
}

.icon-hover-bottom .form-group input {
  min-width: 300px;
  background-color: #fff;
}

.fa-fa-icon-show-div,
.icons-show-div {
  display: none;
}

.icon-first i {
  color: #717171;
}

/**=====================
    10.  ICON CSS Ends
==========================**/
/**=====================
     11. Form Builder 1 CSS Start
==========================**/
.form-builder .drag-box {
  -webkit-user-select: none;
  user-select: none;
}

.form-builder .drag-box fieldset {
  border: 1px dotted #cccccc;
  min-height: 655px;
  padding: 30px;
  width: 100%;
  overflow: hidden;
  margin-top: 30px;
  border-radius: 4px;
}

.form-builder .component {
  cursor: pointer;
}

.form-builder .component label {
  padding-top: 8px;
}

.form-builder .component .form-group input,
.form-builder .component .form-group textarea,
.form-builder .component .form-group select {
  border-radius: 4px;
}

.form-builder .component .form-group .input-group #prependedcheckbox,
.form-builder .component .form-group .input-group #prependedtext {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-builder .component .form-group .input-group #appendedcheckbox {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-color: transparent;
}

.form-builder .component .form-group .input-group #appendedtext,
.form-builder .component .form-group .input-group #buttondropdown {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.form-builder .component .form-group .input-group #buttondropdown {
  margin-right: -1px;
}

.form-builder .component .form-group .input-group .input-group-btn button {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-builder .component .form-group .input-group .input-group-prepend .btn-right,
.form-builder .component .form-group .input-group .input-group-prepend .checkbox-radius {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-builder .component .form-group .pl-md-radios {
  padding-left: 37px;
}

.form-builder input {
  cursor: pointer;
}

.form-builder textarea {
  resize: vertical;
}

.form-builder .popover {
  z-index: 8;
  opacity: 1;
  left: -290px !important;
  top: 95px !important;
}

.form-builder .popover .control-group {
  cursor: default;
}

.form-builder .popover input {
  cursor: pointer;
}

.form-builder .render {
  min-height: 500px;
  width: 100%;
  border-radius: 4px;
}

.form-builder .popover .controls {
  margin-left: 0;
}

.form-builder .popover .control-label {
  text-align: left;
}

.form-builder .popover form {
  width: 100%;
}

.form-builder .popover .fade.left.in {
  left: -215px;
}

.form-builder .target:after {
  float: left;
  content: " ";
  height: 77px;
  margin-top: 3px;
  background: #eeeeee;
  width: 100%;
  border: 1px dashed #cccccc;
}

.drag form {
  padding: 10px 5px;
  border: 1px dotted #cccccc;
  position: absolute;
  background: #fff;
  box-shadow: 0 0 30px #cccccc;
  overflow: hidden;
}

.drag form input {
  border-radius: 5px;
}

.form-builder-header-1 {
  background-color: #eeeeee;
  padding: 15px;
  border-radius: 5px;
  min-height: 67px;
}

.form-builder-header-1 h6 {
  margin-bottom: 0;
  margin-top: 10px;
}

.form-builder .help-block {
  font-size: 12px;
}

.form-builder input {
  border-radius: 4px !important;
}

.form-builder .form-group .col-md-12 {
  padding: 0;
}

.form-builder .popover {
  width: 300px;
}

.form-builder .popover-header {
  background-color: #ab8ce4;
  padding: 15px;
}

.form-builder .popover-body {
  padding: 15px;
}

/**=====================
    11. Form Builder 1 CSS Ends
==========================**/
/**=====================
     12. Form Builder 2 CSS Start
==========================**/
.form-builder-column #pills-tabContent .theme-form .form-group,
.form-builder-column #pills-tabContent .theme-form .ui-draggable {
  margin-bottom: 0 !important;
}

.form-builder-column #pills-tabContent .theme-form .form-group .checkbox label,
.form-builder-column #pills-tabContent .theme-form .ui-draggable .checkbox label {
  margin-top: 0;
}

.form-builder-column #pills-tabContent .theme-form .form-group input,
.form-builder-column #pills-tabContent .theme-form .ui-draggable input {
  border-radius: 4px;
}

.form-builder-column #pills-tabContent .theme-form .form-group .input-group #prependedcheckbox,
.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group #prependedcheckbox {
  margin-right: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-builder-column #pills-tabContent .theme-form .form-group .input-group input,
.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group input {
  margin-right: 15px;
}

.form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-prepend .input-group-text input,
.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-prepend .input-group-text input {
  margin-right: 0;
}

.form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-btn button,
.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-btn button {
  border-radius: 4px;
}

.form-builder-column #pills-tabContent .theme-form .form-group select,
.form-builder-column #pills-tabContent .theme-form .ui-draggable select {
  border-radius: 4px;
}

.form-builder-column #pills-tabContent .theme-form .form-group .m-t-help-block,
.form-builder-column #pills-tabContent .theme-form .ui-draggable .m-t-help-block {
  margin-top: -3px;
}

.form-builder-column #pills-tabContent #pills-button .theme-form button {
  margin-bottom: 6px;
}

.form-builder-column .droppable-active {
  background-color: #ab8ce4 !important;
  opacity: 0.1;
}

.form-builder-column .form-body {
  min-height: 540px;
}

.form-builder-column .draggable {
  cursor: move;
}

.form-builder-column .drag-bx {
  border: 1px dotted #cccccc;
  border-radius: 4px;
}

.form-builder-column .help-block {
  color: #cccccc;
}

.form-builder-column .tools a {
  cursor: pointer;
  font-size: 80%;
}

.form-builder-2 .form-group {
  margin-bottom: 0 !important;
}

.form-builder-2 .form-group .checkbox label {
  margin-top: 0;
}

.form-builder-2 .form-group input {
  border-radius: 4px;
}

.form-builder-2 .form-group .input-group #prependedcheckbox {
  margin-right: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.form-builder-2 .form-group .input-group input {
  margin-right: 15px;
}

.form-builder-2 .form-group .input-group .input-group-prepend .input-group-text input {
  margin-right: 0;
}

.form-builder-2 .form-group .input-group .input-group-btn button {
  border-radius: 4px;
}

.form-builder-2 .form-group select {
  border-radius: 4px;
}

.form-builder-2 .form-group .m-t-help-block {
  margin-top: -3px;
}

.form-builder-2-header {
  background-color: #eeeeee;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  margin-bottom: 30px;
}

.form-builder-2-header>div {
  display: inline-block;
  width: 49%;
}

.form-builder-2-header>div nav {
  text-align: right;
  float: right;
}

.draggable input {
  border-radius: 5px;
}

.draggable select {
  border-radius: 4px;
}

/**=====================
     12. Form Builder 2 CSS Ends
==========================**/
/**=====================
    13.  Email Application  CSS Start
==========================**/
.email-wrap .row .col-xl-3+.col-xl-3 {
  padding-right: 0;
}

.email-wrap .row .col-xl-6 {
  padding-left: 0;
}

.email-wrap .email-app-sidebar .media img {
  border: 2px solid #cccccc;
}

.email-wrap .email-app-sidebar .main-menu>li {
  width: 100%;
  text-align: left;
}

.email-wrap .email-app-sidebar .main-menu>li a {
  color: #717171;
  line-height: 39px;
  text-transform: uppercase;
  border-radius: 3px;
}

.email-wrap .email-app-sidebar .main-menu>li a i {
  margin-right: 10px;
}

.email-wrap .email-app-sidebar .main-menu>li a.active>a {
  color: #000;
}

.email-wrap .email-app-sidebar .main-menu>li a:hover {
  background-color: #eeeeee;
  text-decoration: none;
}

.email-wrap .email-app-sidebar ul li a {
  display: flex;
  padding-left: 20px;
  align-items: center;
}

.email-wrap .email-app-sidebar ul li a>.title {
  width: 100%;
}

.email-wrap .email-app-sidebar ul li a>.badge {
  align-self: center;
}

.email-wrap .email-left-aside {
  float: left;
  width: 100%;
}

.email-wrap .email-left-aside .card-body {
  padding: 20px;
}

.email-wrap .email-right-aside .email-body {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.email-wrap .email-right-aside .email-body .inbox {
  overflow: auto;
}

.email-wrap .email-right-aside .email-body .inbox .media {
  padding: 20px;
}

.email-wrap .email-right-aside .email-body .inbox .media.active {
  background-color: #f8f8f8;
}

.email-wrap .email-right-aside .radius-left {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-radius: 4px;
}

.email-wrap .btn-mail {
  border-radius: 2px;
  text-align: left;
  padding: 13px 15px;
  margin: 20px 0 20px;
  letter-spacing: 1px;
  line-height: 12px !important;
  color: #fff !important;
}

.email-wrap p {
  margin-bottom: 0;
  color: #717171;
}

.email-wrap .media-body {
  margin-top: 5px;
}

.email-wrap .media-body h6 {
  margin-bottom: 2px;
  color: #444444;
  margin-top: 3px;
}

.email-wrap .media-body h6 small span {
  color: #777777;
}

.email-wrap .media-body p {
  color: #777777;
  font-size: 12px;
}

.email-wrap .email-top {
  padding: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  line-height: 49px;
}

.email-wrap .email-top h5 {
  margin-bottom: 0;
  padding: 12px 0;
}

.email-wrap .email-top .d-flex {
  padding: 13px 0;
}

.email-wrap .email-wrapper {
  padding: 20px;
}

.email-wrap .email-wrapper hr {
  margin-top: 0;
  margin-bottom: 20px;
}

.email-wrap .email-wrapper .d-inline-block {
  width: 100%;
}

.email-wrap .email-wrapper h6 {
  margin-bottom: 11px;
  float: left;
}

.email-wrap .email-wrapper .right-download {
  float: right;
}

.email-wrap .email-wrapper p+p {
  margin-bottom: 20px;
}

.email-wrap .email-wrapper h5 {
  margin-bottom: 20px;
}

.email-wrap .email-content .email-top .user-emailid:after {
  content: "";
  position: relative;
  height: 20px;
  width: 1px;
  right: 0;
  top: 3px;
  z-index: 2;
  border: 1px solid #ddd;
  float: right;
  padding: 0;
  margin: 0 20px;
}

.email-wrap .email-body .attachment ul li img {
  margin-bottom: 20px;
  width: 117px;
  height: 117px;
}

.email-wrap .email-body .attachment .list-inline .list-inline-item {
  padding-right: 13px;
}

.email-wrap .email-body .email-compose .cke_contents.cke_reset {
  max-height: 184px;
  width: 100%;
}

.email-wrap .email-body .email-compose .email-top h4 {
  padding: 11px 0;
}

.email-wrap .email-body .email-compose .compose-border {
  margin: -1px;
}

.email-wrap .email-body .email-compose .compose-border .btn-middle {
  padding-top: 5px;
}

.email-wrap .actions li {
  display: inline-block;
  margin-right: 25px;
}

/**=====================
    13.  Email Application  CSS Ends
==========================**/
/**=====================
     14. Chat CSS Start
==========================**/
.chat-box .toogle-bar {
  display: none;
}

.chat-box .chat-menu {
  max-width: 340px;
}

.chat-box .people-list .search {
  position: relative;
}

.chat-box .people-list .search .form-control {
  background-color: #f7f7f7;
  border: 1px solid #eeeeee;
}

.chat-box .people-list .search .form-control::placeholder {
  color: #aaaaaa;
}

.chat-box .people-list .search i {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 14px;
  color: #cccccc;
}

.chat-box .people-list ul {
  padding: 0;
}

.chat-box .people-list ul li {
  padding-bottom: 15px;
}

.chat-box .people-list ul li:last-child {
  padding-bottom: 0;
}

.chat-box .user-image {
  float: left;
  width: 52px;
  height: 52px;
  margin-bottom: 5px;
  margin-right: 5px;
}

.chat-box .about {
  float: left;
  margin-top: 5px;
  padding-left: 10px;
}

.chat-box .about .name {
  color: #2a3142;
  letter-spacing: 1px;
  font-weight: 600;
}

.chat-box .status {
  color: #aaaaaa;
  letter-spacing: 1px;
  font-size: 12px;
  margin-top: 5px;
}

.chat-box .status .chat-status {
  font-weight: 600;
  color: #333333;
}

.chat-box .status p {
  font-size: 14px;
}

.chat-box .chat-right-aside .chat .chat-header {
  padding: 15px;
  border-bottom: 1px solid #eeeeee;
}

.chat-box .chat-right-aside .chat .chat-header img {
  float: left;
  width: 50px;
  height: 50px;
  box-shadow: 1px 1px 4px 1px #cccccc;
}

.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {
  margin-top: 15px;
}

.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {
  margin-right: 24px;
}

.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
  color: #777777;
  font-size: 25px;
  cursor: pointer;
}

.chat-box .chat-right-aside .chat .chat-msg-box {
  padding: 20px;
  overflow-y: auto;
  height: 560px;
  margin-bottom: 90px;
}

.chat-box .chat-right-aside .chat .chat-msg-box .chat-user-img {
  margin-top: -35px;
}

.chat-box .chat-right-aside .chat .chat-msg-box .message-data {
  margin-bottom: 10px;
}

.chat-box .chat-right-aside .chat .chat-msg-box .message-data-time {
  letter-spacing: 1px;
  font-size: 12px;
  color: #aaaaaa;
  font-family: Raleway;
}

.chat-box .chat-right-aside .chat .chat-msg-box .message {
  color: #2a3142;
  padding: 20px;
  line-height: 1.9;
  letter-spacing: 1px;
  font-size: 14px;
  margin-bottom: 30px;
  width: 50%;
  position: relative;
}

.chat-box .chat-right-aside .chat .chat-msg-box .my-message {
  border: 1px solid #eeeeee;
  border-radius: 10px;
  border-top-left-radius: 0;
}

.chat-box .chat-right-aside .chat .chat-msg-box .other-message {
  background-color: #f6f6f6;
  border-radius: 10px;
  border-top-right-radius: 0;
}

.chat-box .chat-right-aside .chat .chat-message {
  padding: 20px;
  border-top: 1px solid #f7f7f7;
  position: absolute;
  width: calc(100% - 15px);
  background-color: #fff;
  bottom: 0;
}

.chat-box .chat-right-aside .chat .chat-message .smiley-box {
  background: #ddd;
  padding: 10px;
  display: block;
  border-radius: 4px;
  margin-right: 0.5rem;
}

.chat-box .chat-right-aside .chat .chat-message .text-box {
  position: relative;
}

.chat-box .chat-right-aside .chat .chat-message .text-box .input-txt-bx {
  height: 50px;
  border: 2px solid #ab8ce4;
  padding-left: 18px;
  font-size: 12px;
  letter-spacing: 1px;
}

.chat-box .chat-right-aside .chat .chat-message .text-box i {
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 20px;
  color: #cccccc;
  cursor: pointer;
}

.chat-box .chat-right-aside .chat .chat-message .text-box .btn {
  font-size: 16px;
  font-weight: 500;
}

.chat-box .chat-menu {
  border-left: 1px solid #eeeeee;
}

.chat-box .chat-menu .tab-pane {
  padding: 0 15px;
}

.chat-box .chat-menu ul li .about .status i {
  font-size: 10px;
}

.chat-box .chat-menu .user-profile {
  margin-top: 30px;
}

.chat-box .chat-menu .user-profile .user-content h5 {
  margin: 25px 0;
}

.chat-box .chat-menu .user-profile .user-content hr {
  margin: 25px 0;
}

.chat-box .chat-menu .user-profile .user-content p {
  font-size: 16px;
}

.chat-box .chat-menu .user-profile .image {
  position: relative;
}

.chat-box .chat-menu .user-profile .image .icon-wrapper {
  position: absolute;
  bottom: 0;
  left: 55%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  overflow: hidden;
  margin: 0 auto;
  font-size: 14px;
  box-shadow: 1px 1px 3px 1px #eeeeee;
}

.chat-box .chat-menu .user-profile .image .avatar img {
  border-radius: 50%;
  border: 5px solid #eeeeee;
}

.chat-box .chat-menu .user-profile .border-right {
  border-right: 1px solid #eeeeee;
}

.chat-box .chat-menu .user-profile .follow {
  margin-top: 0;
}

.chat-box .chat-menu .user-profile .follow .follow-num {
  font-size: 22px;
  color: #000;
}

.chat-box .chat-menu .user-profile .follow span {
  color: #444444;
  font-size: 14px;
  letter-spacing: 1px;
}

.chat-box .chat-menu .user-profile .social-media a {
  color: #aaaaaa;
  font-size: 15px;
  padding: 0 7px;
}

.chat-box .chat-menu .user-profile .chat-profile-contact p {
  font-size: 14px;
  color: #aaaaaa;
}

.chat-box .chat-menu .nav {
  margin-bottom: 20px;
}

.chat-box .chat-menu .nav-tabs .nav-item {
  width: 33.33%;
}

.chat-box .chat-menu .nav-tabs .nav-item a {
  padding: 15px !important;
  color: #aaaaaa !important;
  letter-spacing: 1px;
  font-size: 14px;
  font-weight: 600;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chat-box .chat-menu .nav-tabs .nav-item .material-border {
  border-width: 1px;
  border-color: #ab8ce4;
}

.chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {
  color: #000 !important;
}

.chat-box .chat-history .call-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
}

.chat-box .chat-history .total-time h2 {
  font-size: 50px;
  color: #ddd;
  font-weight: 600;
  margin-bottom: 30px;
}

.chat-box .chat-history .receiver-img {
  margin-top: 55px;
}

.chat-box .chat-history .receiver-img img {
  border-radius: 5px;
}

.chat-box .chat-history .call-icons {
  margin-bottom: 35px;
}

.chat-box .chat-history .call-icons ul li {
  width: 60px;
  height: 60px;
  border: 1px solid #eeeeee;
  border-radius: 50%;
  padding: 12px;
}

.chat-box .chat-history .call-icons ul li+li {
  margin-left: 10px;
}

.chat-box .chat-history .call-icons ul li a {
  color: #999;
  font-size: 25px;
}

.chat-left-aside>.media {
  margin-bottom: 15px;
}

.chat-left-aside .people-list {
  height: 625px;
}

.chat-left-aside ul li {
  position: relative;
}

.chat-left-aside .status-circle {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 40px;
  left: 40px;
  border-radius: 50%;
  border: 1px solid #fff;
}

.chat-left-aside .away {
  background-color: #f3d800;
}

.chat-left-aside .online {
  background-color: #00c292;
}

.chat-left-aside .offline {
  background-color: #FF5370;
}

.chat-container .aside-chat-left {
  width: 320px;
}

.chat-container .chat-right-aside {
  width: 320px;
}

.call-chat-sidebar {
  max-width: 320px;
}

.call-chat-sidebar .card .card-body,
.chat-body .card .card-body {
  padding: 15px;
}

/**=====================
    14.  Chat CSS Ends
==========================**/
/**=====================
     15. Alert CSS start
==========================**/
.alert-dismissible .close {
  padding: 10px 1.25rem;
  top: 2px;
}

.alert-dismissible .close:hover {
  color: #2a3142;
}

.card-body .alert:last-child {
  margin-bottom: 0;
}

.alert-primary {
  background-color: rgba(171, 140, 228, 0.8);
  border-color: rgba(171, 140, 228, 0.9);
  color: #fff;
}

.alert-primary .progress {
  height: 5px;
  background-color: #a888e3;
  border-radius: 0;
}

.alert-primary .progress-bar {
  background-color: white;
}

.alert-primary .alert-link {
  color: #ab8ce4;
}

.alert-primary hr {
  border-top-color: #ab8ce4;
}

.alert-primary.dark {
  background-color: #ab8ce4 !important;
  border-color: #ab8ce4 !important;
  color: #fafafa;
}

.alert-primary.dark .alert-link {
  color: #fff;
}

.alert-primary.outline,
.alert-primary.outline-2x {
  background-color: transparent !important;
  border-color: #ab8ce4 !important;
  color: #ab8ce4;
}

.alert-primary.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #ab8ce4;
  color: #333333;
}

.alert-primary.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #ab8ce4;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-primary.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #ab8ce4 !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.alert-secondary {
  background-color: rgba(38, 198, 218, 0.8);
  border-color: rgba(38, 198, 218, 0.9);
  color: #fff;
}

.alert-secondary .progress {
  height: 5px;
  background-color: #25c3d6;
  border-radius: 0;
}

.alert-secondary .progress-bar {
  background-color: white;
}

.alert-secondary .alert-link {
  color: #26c6da;
}

.alert-secondary hr {
  border-top-color: #26c6da;
}

.alert-secondary.dark {
  background-color: #26c6da !important;
  border-color: #26c6da !important;
  color: #fafafa;
}

.alert-secondary.dark .alert-link {
  color: #fff;
}

.alert-secondary.outline,
.alert-secondary.outline-2x {
  background-color: transparent !important;
  border-color: #26c6da !important;
  color: #26c6da;
}

.alert-secondary.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #26c6da;
  color: #333333;
}

.alert-secondary.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #26c6da;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-secondary.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #26c6da !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.alert-success {
  background-color: rgba(0, 194, 146, 0.8);
  border-color: rgba(0, 194, 146, 0.9);
  color: #fff;
}

.alert-success .progress {
  height: 5px;
  background-color: #00bd8e;
  border-radius: 0;
}

.alert-success .progress-bar {
  background-color: #c2fff0;
}

.alert-success .alert-link {
  color: #00c292;
}

.alert-success hr {
  border-top-color: #00c292;
}

.alert-success.dark {
  background-color: #00c292 !important;
  border-color: #00c292 !important;
  color: #fafafa;
}

.alert-success.dark .alert-link {
  color: #fff;
}

.alert-success.outline,
.alert-success.outline-2x {
  background-color: transparent !important;
  border-color: #00c292 !important;
  color: #00c292;
}

.alert-success.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #00c292;
  color: #333333;
}

.alert-success.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #00c292;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-success.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #00c292 !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.alert-danger {
  background-color: rgba(255, 83, 112, 0.8);
  border-color: rgba(255, 83, 112, 0.9);
  color: #fff;
}

.alert-danger .progress {
  height: 5px;
  background-color: #ff4e6c;
  border-radius: 0;
}

.alert-danger .progress-bar {
  background-color: white;
}

.alert-danger .alert-link {
  color: #FF5370;
}

.alert-danger hr {
  border-top-color: #FF5370;
}

.alert-danger.dark {
  background-color: #FF5370 !important;
  border-color: #FF5370 !important;
  color: #fafafa;
}

.alert-danger.dark .alert-link {
  color: #fff;
}

.alert-danger.outline,
.alert-danger.outline-2x {
  background-color: transparent !important;
  border-color: #FF5370 !important;
  color: #FF5370;
}

.alert-danger.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #FF5370;
  color: #333333;
}

.alert-danger.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #FF5370;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-danger.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #FF5370 !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.alert-warning {
  background-color: rgba(243, 216, 0, 0.8);
  border-color: rgba(243, 216, 0, 0.9);
  color: #fff;
}

.alert-warning .progress {
  height: 5px;
  background-color: #eed300;
  border-radius: 0;
}

.alert-warning .progress-bar {
  background-color: #fffef3;
}

.alert-warning .alert-link {
  color: #f3d800;
}

.alert-warning hr {
  border-top-color: #f3d800;
}

.alert-warning.dark {
  background-color: #f3d800 !important;
  border-color: #f3d800 !important;
  color: #fafafa;
}

.alert-warning.dark .alert-link {
  color: #fff;
}

.alert-warning.outline,
.alert-warning.outline-2x {
  background-color: transparent !important;
  border-color: #f3d800 !important;
  color: #f3d800;
}

.alert-warning.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #f3d800;
  color: #333333;
}

.alert-warning.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #f3d800;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-warning.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #f3d800 !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.alert-info {
  background-color: rgba(64, 153, 255, 0.8);
  border-color: rgba(64, 153, 255, 0.9);
  color: #fff;
}

.alert-info .progress {
  height: 5px;
  background-color: #3b96ff;
  border-radius: 0;
}

.alert-info .progress-bar {
  background-color: white;
}

.alert-info .alert-link {
  color: #4099ff;
}

.alert-info hr {
  border-top-color: #4099ff;
}

.alert-info.dark {
  background-color: #4099ff !important;
  border-color: #4099ff !important;
  color: #fafafa;
}

.alert-info.dark .alert-link {
  color: #fff;
}

.alert-info.outline,
.alert-info.outline-2x {
  background-color: transparent !important;
  border-color: #4099ff !important;
  color: #4099ff;
}

.alert-info.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #4099ff;
  color: #333333;
}

.alert-info.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #4099ff;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-info.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #4099ff !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.alert-light {
  background-color: rgba(238, 238, 238, 0.8);
  border-color: rgba(238, 238, 238, 0.9);
  color: #fff;
  color: #2a3142;
  background-color: #eeeeee;
}

.alert-light .progress {
  height: 5px;
  background-color: #ebebeb;
  border-radius: 0;
}

.alert-light .progress-bar {
  background-color: white;
}

.alert-light .alert-link {
  color: #eeeeee;
  color: #2a3142;
}

.alert-light hr {
  border-top-color: #eeeeee;
}

.alert-light.dark {
  background-color: #eeeeee !important;
  border-color: #eeeeee !important;
  color: #fafafa;
  color: #2a3142;
}

.alert-light.dark .alert-link {
  color: #fff;
  color: #2a3142;
}

.alert-light.outline,
.alert-light.outline-2x {
  background-color: transparent !important;
  border-color: #eeeeee !important;
  color: #eeeeee;
  color: #2a3142;
}

.alert-light.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #eeeeee;
  color: #333333;
}

.alert-light.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #eeeeee;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-light.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #eeeeee !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.alert-dark {
  background-color: rgba(42, 49, 66, 0.8);
  border-color: rgba(42, 49, 66, 0.9);
  color: #fff;
}

.alert-dark .progress {
  height: 5px;
  background-color: #282f3f;
  border-radius: 0;
}

.alert-dark .progress-bar {
  background-color: #a5afc6;
}

.alert-dark .alert-link {
  color: #2a3142;
}

.alert-dark hr {
  border-top-color: #2a3142;
}

.alert-dark.dark {
  background-color: #2a3142 !important;
  border-color: #2a3142 !important;
  color: #fafafa;
}

.alert-dark.dark .alert-link {
  color: #fff;
}

.alert-dark.outline,
.alert-dark.outline-2x {
  background-color: transparent !important;
  border-color: #2a3142 !important;
  color: #2a3142;
}

.alert-dark.inverse {
  background-color: transparent;
  padding: 13px 20px 13px 65px;
  border-color: #2a3142;
  color: #333333;
}

.alert-dark.inverse:before {
  top: 16px;
  content: "";
  position: absolute;
  left: 54px;
  width: 0;
  height: 0;
  border-left: 7px solid #2a3142;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.alert-dark.inverse i {
  padding: 17px 20px;
  display: inline-block;
  background-color: #2a3142 !important;
  color: #fff;
  border-radius: 3px 0 0 3px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.outline-2x {
  border-width: 2px;
  padding: 11px 1.25rem;
}

.alert {
  border-radius: 0.15rem;
  padding: 15px;
}

.alert .progress {
  margin-top: 15px;
}

.alert [data-notify='message'] {
  display: block;
}

.alert i {
  margin-right: 5px;
  font-size: 16px;
}

.alert p {
  margin-bottom: 0;
}

.alert .close {
  opacity: 1;
}

.alert .close span {
  font-size: 24px;
  font-weight: 400;
  display: inline-block;
  border-radius: 3px;
  text-shadow: none;
  padding: 0 5px;
}

/**=====================
     15. Alert CSS end
==========================**/
/**=====================
     16. Popover CSS Start
==========================**/
.popover-header {
  background-color: #2a3142;
  color: #fff;
}

.popover-main .btn-showcase a {
  color: #fff;
}

.popover-main .btn-showcase button:last-child {
  margin-right: 0;
}

/**=====================
     16. Popover CSS Ends
==========================**/
/**=====================
     17. List CSS Start
==========================**/
.list-group-item.active {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
}

.list-group i {
  margin-right: 10px;
}

.list-group img {
  height: 40px;
  width: 40px;
  margin-right: 10px;
}

/**=====================
     17. List CSS Ends
==========================**/
/**=====================
    18. Switch  CSS Start
==========================**/
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  display: none;
}

.switch input:checked+.switch-state {
  background-color: #ab8ce4;
}

.switch input:checked+.switch-state:before {
  transform: translateX(26px);
}

.switch input:focus+.switch-state {
  box-shadow: 0 0 1px #ab8ce4;
}

.switch-state {
  border-radius: 20px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #eeeeee;
  transition: .4s;
}

.switch-state:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: #fff;
  transition: .4s;
  border-radius: 20px;
}

.icon-state .switch-state:after {
  content: "\\efb8";
  font-family: IcoFont;
  left: 10px;
  position: absolute;
  top: 11px;
  color: #2a3142;
  transition: .4s;
  opacity: 0.3;
}

.icon-state input:checked+.switch-state:after {
  content: "\\efad";
  left: 35px;
  opacity: 1;
  transition: .4s;
}

.switch-lg .switch {
  width: 75px;
  height: 40px;
}

.switch-lg .switch .switch-state:before {
  height: 30px;
  width: 30px;
  left: 7px;
  bottom: 5px;
  top: 4px;
}

.switch-sm .switch {
  width: 25px;
  height: 16px;
  margin-top: 10px;
  margin-bottom: 0px;
}

.switch-sm .switch .switch-state:before {
  height: 8px;
  width: 8px;
  left: 4px;
  bottom: 4px;
}

.switch-sm input:checked+.switch-state:before {
  left: -13px;
}

.switch-lg.icon-state .switch .switch-state:after {
  left: 12px;
  font-size: 18px;
}

.switch-lg.icon-state .switch input:checked+.switch-state:after {
  left: 47px;
}

.switch-lg.icon-state .switch input:checked+.switch-state:before {
  transform: translateX(32px);
}

.switch-sm.icon-state .switch .switch-state:after {
  top: 4px;
  left: 4px;
  font-size: 8px;
}

.switch-sm.icon-state .switch input:checked+.switch-state:after {
  left: 13px;
  top: 4px;
}

.switch-outline .switch-state {
  background-color: #fff;
  border: 1px solid #ab8ce4;
  transition: .4s;
}

.switch-outline .switch-state:before {
  background-color: #eeeeee;
  bottom: 3px;
  color: #fff;
}

.switch-outline .switch input {
  display: none;
}

.switch-outline .switch input:checked+.switch-state {
  background-color: transparent;
  border: 1px solid #ab8ce4;
}

.switch-outline .switch input:checked+.switch-state:before {
  background-color: #ab8ce4;
  bottom: 3px;
  transform: translateX(26px);
}

.switch-outline .switch input:checked+.switch-state:after {
  color: #fff;
}

.switch-outline .switch-state.bg-primary {
  border: 1px solid #ab8ce4;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-primary {
  background-color: transparent !important;
  border: 1px solid #ab8ce4;
}

.switch-outline .switch input:checked+.switch-state.bg-primary:before {
  background-color: #ab8ce4;
}

.switch-outline .switch-state.bg-dark {
  border: 1px solid #2a3142;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-dark {
  background-color: transparent !important;
  border: 1px solid #2a3142;
}

.switch-outline .switch input:checked+.switch-state.bg-dark:before {
  background-color: #2a3142;
}

.switch-outline .switch-state.bg-warning {
  border: 1px solid #f3d800;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-warning {
  background-color: transparent !important;
  border: 1px solid #f3d800;
}

.switch-outline .switch input:checked+.switch-state.bg-warning:before {
  background-color: #f3d800;
}

.switch-outline .switch-state.bg-success {
  border: 1px solid #00c292;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-success {
  background-color: transparent !important;
  border: 1px solid #00c292;
}

.switch-outline .switch input:checked+.switch-state.bg-success:before {
  background-color: #00c292;
}

.switch-outline .switch-state.bg-info {
  border: 1px solid #4099ff;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-info {
  background-color: transparent !important;
  border: 1px solid #4099ff;
}

.switch-outline .switch input:checked+.switch-state.bg-info:before {
  background-color: #4099ff;
}

.switch-outline .switch-state.bg-danger {
  border: 1px solid #FF5370;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-danger {
  background-color: transparent !important;
  border: 1px solid #FF5370;
}

.switch-outline .switch input:checked+.switch-state.bg-danger:before {
  background-color: #FF5370;
}

.switch-outline .switch-state.bg-primary {
  border: 1px solid #ab8ce4;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-primary {
  background-color: transparent !important;
  border: 1px solid #ab8ce4;
}

.switch-outline .switch input:checked+.switch-state.bg-primary:before {
  background-color: #ab8ce4;
}

.switch-outline .switch-state.bg-secondary {
  border: 1px solid #26c6da;
  background-color: transparent !important;
}

.switch-outline .switch input:checked+.switch-state.bg-secondary {
  background-color: transparent !important;
  border: 1px solid #26c6da;
}

.switch-outline .switch input:checked+.switch-state.bg-secondary:before {
  background-color: #26c6da;
}

.switch-showcase {
  margin-bottom: -8px;
}

.switch-showcase .media {
  line-height: 1;
}

/**=====================
     18. Switch  CSS Ends
==========================**/
/**=====================
   19. Mega option CSS Start
==========================**/
.mega-inline {
  margin-bottom: -30px;
  display: flex;
}

.mega-inline .mega-title-badge {
  display: table;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.mega-inline .media .radio {
  margin-left: 3px;
}

.mega-vertical {
  display: flex;
  flex-wrap: wrap;
}

.mega-vertical .mega-title-badge {
  display: table;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.mega-vertical .media .radio {
  margin-left: 3px;
}

.mega-title {
  font-weight: 600;
}

.mega-horizontal {
  display: flex;
  flex-wrap: wrap;
}

.mega-horizontal .mega-title-badge {
  display: table;
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.mega-horizontal .media .radio {
  margin-left: 3px;
}

.plain-style .card {
  box-shadow: none;
}

.border-style .card {
  box-shadow: none;
  border: 1px solid #cccccc;
}

.offer-style .card {
  box-shadow: none;
  border: 1px dashed #cccccc;
}

.rating-star-wrapper {
  color: #ddd;
}

/**=====================
     19. Mega option CSS Ends
==========================**/
/**=====================
    20.  Touchspin  CSS Start
==========================**/
.bootstrap-touchspin .touchspin-vertical-tab .input-group {
  width: 98% !important;
}

.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical {
  position: relative;
  white-space: nowrap;
  width: 1%;
  vertical-align: middle;
  display: table-cell;
}

.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical .bootstrap-touchspin-down {
  margin-top: -2px;
}

.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical i {
  position: absolute;
  top: 5px;
  left: 7px;
  font-size: 10px;
  font-weight: normal;
}

.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical>.btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
  padding: 10px;
  margin-left: -1px;
  position: relative;
}

.bootstrap-touchspin .input-group {
  font-family: Open Sans;
}

.bootstrap-touchspin .input-group .btn {
  border-radius: 0;
}

.bootstrap-touchspin .dropdown-basic .dropdown .dropbtn {
  padding: 12px 30px;
}

.bootstrap-touchspin .dropdown-basic .dropdown .dropdown-content {
  z-index: 9999;
}

/**=====================
     20. Touchspin  CSS Ends
==========================**/
/**=====================
     21. Select 2 CSS Start
==========================**/
.select2-drpdwn .select2-selection {
  border-radius: 0 !important;
  border-color: #eeeeee !important;
  height: 40px !important;
  padding: 5px;
}

.select2-drpdwn .form-control {
  border-radius: 5px;
}

.select2-drpdwn .form-control-primary {
  border-color: #ab8ce4;
  color: #ab8ce4;
}

.select2-drpdwn .form-control-secondary {
  border-color: #26c6da;
  color: #26c6da;
}

.select2-drpdwn .form-control-success {
  border-color: #00c292;
  color: #00c292;
}

.select2-drpdwn .form-control-info {
  border-color: #4099ff;
  color: #4099ff;
}

.select2-drpdwn .form-control-warning {
  border-color: #f3d800;
  color: #f3d800;
}

.select2-drpdwn .form-control-danger {
  border-color: #FF5370;
  color: #FF5370;
}

.select2-drpdwn .form-control-inverse {
  border-color: #2a3142;
  color: #2a3142;
}

.select2-drpdwn .form-control-primary-fill {
  background-color: #ab8ce4;
  color: #fff;
}

.select2-drpdwn .form-control-secondary-fill {
  background-color: #26c6da;
  color: #fff;
}

.select2-drpdwn .form-control-success-fill {
  background-color: #00c292;
  color: #fff;
}

.select2-drpdwn .form-control-info-fill {
  background-color: #4099ff;
  color: #fff;
}

.select2-drpdwn .form-control-warning-fill {
  background-color: #f3d800;
  color: #fff;
}

.select2-drpdwn .form-control-danger-fill {
  background-color: #FF5370;
  color: #fff;
}

.select2-drpdwn .form-control-inverse-fill {
  background-color: #2a3142;
  color: #fff;
}

.selection .select2-selection {
  font-family: Open Sans;
  border-radius: 5px !important;
}

.selection .select2-selection .select2-search__field {
  margin-top: 0;
  padding: 3px;
}

.select2-container--classic .select2-selection--multiple .select2-selection__choice {
  padding: 2px 6px !important;
  margin-top: 0 !important;
  background-color: #ab8ce4 !important;
  border-color: #8d63da !important;
  color: #fff;
  margin-right: 8px !important;
}

.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff !important;
  float: right;
  margin-left: 0.5rem;
}

.select2-container--classic .select2-results__option--highlighted[aria-selected] {
  background-color: #e0e0e0 !important;
  color: #424242 !important;
}

.select2-container--classic .select2-results__options .select2-results__option[aria-selected=true] {
  background-color: #ab8ce4 !important;
  color: #fff !important;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
  top: 7px !important;
  right: 10px !important;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  padding: 2px 6px !important;
  margin-top: 0 !important;
  background-color: #ab8ce4 !important;
  border-color: #8d63da !important;
  color: #fff;
  margin-right: 8px !important;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff !important;
  float: right;
  margin-left: 0.5rem;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #e0e0e0 !important;
  color: #424242 !important;
}

.select2-container--default .select2-results__options .select2-results__option[aria-selected=true] {
  background-color: #ab8ce4 !important;
  color: #fff !important;
}

/**=====================
     21. Select 2 CSS Ends
==========================**/
/**=====================
     22. User profile css start
==========================**/
.user-profile .ttl-info h6 {
  font-size: 12px;
  color: #aaaaaa;
}

.user-profile .ttl-info span {
  font-size: 14px;
  color: #444444;
  font-weight: 500;
}

.user-profile .border-right {
  border-right: 1px solid #eeeeee;
}

.user-profile hr {
  margin: 30px 0;
}

.user-profile .hovercard .cardheader {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: 10%;
  height: 470px;
}

.user-profile .hovercard .user-image {
  position: relative;
}

.user-profile .hovercard .user-image .avatar {
  margin-top: -90px;
}

.user-profile .hovercard .user-image .avatar img {
  width: 155px;
  height: 155px;
  max-width: 155px;
  max-height: 155px;
  border-radius: 50%;
  border: 10px solid #fff;
}

.user-profile .hovercard .user-image .icon-wrapper {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #fff;
  cursor: pointer;
  overflow: hidden;
  margin: 0 auto;
  font-size: 17px;
}

.user-profile .hovercard .user-image .icon-wrapper:hover {
  color: #ab8ce4;
  font-size: 15px;
}

.user-profile .hovercard .info {
  padding: 30px;
}

.user-profile .hovercard .info .title {
  margin-bottom: 4px;
  font-size: 24px;
  line-height: 1;
  color: #2a3142;
  vertical-align: middle;
}

.user-profile .hovercard .info .title a {
  color: #444444;
  font-size: 24px;
  text-transform: uppercase;
  font-weight: 600;
}

.user-profile .hovercard .info .desc {
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  color: #aaaaaa;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

.user-profile .follow {
  margin-top: 20px;
}

.user-profile .follow .follow-num {
  font-size: 36px;
  color: #444444;
  font-family: Open Sans;
}

.user-profile .follow span {
  color: #aaaaaa;
}

.user-profile .profile-img-style {
  padding: 30px;
}

.user-profile .profile-img-style .img-container {
  margin-top: 30px;
}

.user-profile .profile-img-style .user-name {
  font-size: 14px;
  color: #444444;
  margin: 0;
  font-weight: 600;
}

.user-profile .profile-img-style p {
  line-height: 30px;
  font-size: 14px;
  color: #717171;
  margin-bottom: 0;
}

.user-profile .profile-img-style .media img {
  width: 75px;
}

.user-profile .like-comment a {
  color: #717171;
}

.user-profile .like-comment a:hover {
  color: #FF5370;
}

.user-profile .like-comment span {
  font-family: Open Sans;
}

.user-profile .social-media a {
  padding: 0 15px;
  color: #aaaaaa;
  font-size: 24px;
  cursor: pointer;
}

.user-profile .social-media a:hover {
  color: #ab8ce4;
}

/**=====================
     22. User profile css Ends
==========================**/
/**=====================
     23. Progress CSS Start
==========================**/
.progress-showcase .progress {
  margin-bottom: 10px;
}

.progress-showcase .progress:last-child {
  margin-bottom: 0;
}

.sm-progress-bar {
  height: 6px;
}

.lg-progress-bar {
  height: 20px;
}

/**=====================
     23. Progress CSS Ends
==========================**/
/**=====================
    24. According CSS start
==========================**/
.default-according .card {
  margin-bottom: 0;
}

.default-according .card+.card {
  margin-top: 10px;
}

.default-according .card .btn-link {
  font-weight: 600;
  color: #333333;
}

.default-according .card .btn-link:focus,
.default-according .card .btn-link:hover {
  text-decoration: none;
}

.default-according .card .card-header {
  padding: 0.75rem 1.25rem;
}

.default-according .card .card-header i {
  position: absolute;
  left: 18px;
  font-size: 20px;
  top: 20px;
}

.default-according .card .card-header h5 {
  margin-top: 2px;
}

.default-according.style-1 button {
  width: 100%;
  text-align: left;
}

.default-according.style-1 button[aria-expanded="true"]:before {
  content: "\\eb73";
  font-family: IcoFont;
  right: 20px;
  position: absolute;
  transition: 0.4s;
}

.default-according.style-1 button[aria-expanded="false"]:before {
  content: "\\eb7a";
  font-family: IcoFont;
  right: 20px;
  position: absolute;
}

/**=====================
     24. According CSS Ends
==========================**/
/**=====================
    25. Authentication CSS Start
==========================**/
.authentication-main .auth-innerleft,
.authentication-main .auth-innerright {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 50px 100px;
}

.authentication-main {
  background: #fafafa;
}

.authentication-main .auth-innerleft {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), #fff;
  box-shadow: 1px 1px 1px 0 #eeeeee;
  background-repeat: no-repeat;
  position: fixed;
  width: 33.3333333333%;
  height: 100%;
}

.authentication-main .auth-innerleft hr {
  width: 250px;
}

.authentication-main .auth-innerleft .logo-login {
  width: 35%;
}

.authentication-main .auth-innerleft .social-media li {
  color: #717171;
  font-size: 18px;
}

.authentication-main .auth-innerleft .social-media li:hover {
  color: #26c6da;
  cursor: pointer;
}

.authentication-main .auth-innerright {
  background: #fafafa;
  justify-content: left;
}

.authentication-box {
  width: 645px;
  z-index: 2;
}

.authentication-box h3 {
  color: #2a3142;
  font-weight: 600;
  letter-spacing: 1px;
}

.authentication-box h4 {
  color: #333333;
  font-weight: 600;
  letter-spacing: 1px;
}

.authentication-box h6 {
  color: #777777;
  letter-spacing: 1px;
  font-size: 14px;
}

.auth-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 50px 100px;
}

.auth-bg-video {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: rgba(255, 255, 255, 0.31);
  padding: 50px 0;
}

.auth-bg-video video {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  transform: translateX(-50%) translateY(-50%);
  transition: 1s opacity;
}

.auth-bg-effect {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.auth-bg-effect .first-effect {
  width: 250px;
  height: 250px;
  /* background: url(../images/flower/01.png) no-repeat; */
  background-size: cover;
  animation: rotate-effect 40s infinite linear;
  position: absolute;
  bottom: 130px;
}

.auth-bg-effect .second-effect {
  width: 220px;
  height: 220px;
  /* background: url(../images/flower/02.png) no-repeat; */
  background-size: cover;
  animation: rotate-effect 40s infinite linear;
  position: absolute;
  bottom: 65px;
  left: 61%;
}

.auth-bg-effect .third-effect {
  width: 200px;
  height: 200px;
  /* background: url(../images/flower/03.png) no-repeat; */
  background-size: cover;
  animation: rotate-effect 40s infinite linear;
  position: absolute;
  bottom: 45px;
  left: 38%;
}

.auth-bg-effect .fourth-effect {
  width: 200px;
  height: 200px;
  /* background: url(../images/flower/04.png) no-repeat; */
  background-size: cover;
  animation: rotate-effect 40s infinite linear;
  position: absolute;
  bottom: 407px;
  left: 1%;
}

.reset-password-box {
  width: 645px;
  z-index: 2;
}

.reset-password-box .card {
  padding: 30px;
}

.reset-password-box .theme-form .form-group label {
  font-size: 12px;
  color: #777777;
}

.reset-password-box .theme-form .form-group .form-control {
  font-size: 18px;
}

.reset-password-box .theme-form .form-group .btn {
  font-size: 18px;
  padding: 6px 24px;
}

.reset-password-box .theme-form .opt-box {
  background: #f7f7f7;
}

.reset-password-box .theme-form .opt-box .opt-text {
  font-size: 36px;
  padding: 0;
}

.reset-password-box .reset-password-link {
  color: #777777;
}

.reset-password-box .reset-password-box h6 {
  letter-spacing: 1px;
  font-size: 16px;
}

@keyframes rotate-effect {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

/**=====================
    25. Authentication CSS Ends
==========================**/
/**=====================
    26. Form CSS Start
==========================**/
.height-35 {
  height: 35px !important;
}

.theme-form .form-control :focus {
  box-shadow: 0 0 0 0.2rem rgba(171, 140, 228, 0.05);
}

.theme-form.sm-form .form-group {
  margin-bottom: 14px;
}

.theme-form.form {
  margin-bottom: -20px;
}

.theme-form .form-group {
  margin-bottom: 20px;
}

.theme-form .form-group textarea {
  border-color: #ddd;
}

.theme-form .form-group textarea::-webkit-input-placeholder {
  color: #aaaaaa;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 100;
}

.theme-form .form-group input[type=text],
.theme-form .form-group input[type=email],
.theme-form .form-group input[type=search],
.theme-form .form-group input[type=password],
.theme-form .form-group input[type=number],
.theme-form .form-group input[type=tel],
.theme-form .form-group input[type=date],
.theme-form .form-group input[type=datetime-local],
.theme-form .form-group input[type=time],
.theme-form .form-group input[type=datetime-local],
.theme-form .form-group input[type=month],
.theme-form .form-group input[type=week],
.theme-form .form-group input[type=url],
.theme-form .form-group input[type=file],
.theme-form .form-group select {
  border-color: #ddd;
  background-color: #fff;
  font-size: 14px;
  color: #717171;
  font-family: Open Sans;
}

.theme-form .form-group input[type=text]::-webkit-input-placeholder,
.theme-form .form-group input[type=email]::-webkit-input-placeholder,
.theme-form .form-group input[type=search]::-webkit-input-placeholder,
.theme-form .form-group input[type=password]::-webkit-input-placeholder,
.theme-form .form-group input[type=number]::-webkit-input-placeholder,
.theme-form .form-group input[type=tel]::-webkit-input-placeholder,
.theme-form .form-group input[type=date]::-webkit-input-placeholder,
.theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
.theme-form .form-group input[type=time]::-webkit-input-placeholder,
.theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
.theme-form .form-group input[type=month]::-webkit-input-placeholder,
.theme-form .form-group input[type=week]::-webkit-input-placeholder,
.theme-form .form-group input[type=url]::-webkit-input-placeholder,
.theme-form .form-group input[type=file]::-webkit-input-placeholder,
.theme-form .form-group select::-webkit-input-placeholder {
  color: #717171;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 100;
}

.theme-form .form-group select.form-control:not([size]):not([multiple]) {
  border-color: #ddd;
  font-size: 14px;
}

.theme-form .checkbox label {
  padding-left: 10px;
}

.theme-form .form-divider {
  position: relative;
  clear: both;
  height: 0;
  margin: 30px 0;
  border-top: 1px solid #ddd;
}

.theme-form .form-divider:before {
  position: absolute;
  top: -11px;
  left: 40%;
  margin-left: -10px;
  padding: 0 5px;
  content: "Or Signup With";
  color: #444444;
  background: #fff;
}

.theme-form .btn-fb {
  background-color: #50598e;
  color: #fff;
  width: 100%;
}

.theme-form .btn-twitter {
  background-color: #6fa2d8;
  color: #fff;
  width: 100%;
}

.theme-form .btn-google {
  background-color: #c64e40;
  color: #fff;
  width: 100%;
}

.form-inline .form-group {
  margin-right: 15px;
}

.form-inline .form-group .col-form-label {
  margin-right: 5px;
}

.search-form input {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: 95%;
}

.form-label-align-right label {
  text-align: right;
  padding-top: 17px;
  font-weight: 500;
}

.custom-file-label {
  line-height: 1.8;
}

.custom-file-label::after {
  line-height: 1.8;
}

/**=====================
    26. Form CSS Ends
==========================**/
/**=====================
     27. Coming Soon CSS Start
==========================**/
.comingsoon-bgimg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: bottom;
  background-size: cover;
}

.comingsoon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 50px 0;
}

.comingsoon .comingsoon-inner h5 {
  font-size: 18px;
  letter-spacing: 1px;
  color: #777777;
  font-weight: 500;
  margin-bottom: 30px;
  margin-top: 30px;
}

.comingsoon .comingsoon-inner .countdown {
  padding: 30px 0;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}

.comingsoon .comingsoon-inner .countdown .time {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #fff;
  font-weight: 500;
  width: 100px;
  height: 100px;
  font-size: 36px;
  background: #4099ff;
}

.comingsoon .comingsoon-inner .countdown .title {
  padding-top: 13px;
  font-size: 14px;
  font-weight: 400;
  color: #777777;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.comingsoon .comingsoon-inner .countdown ul li {
  display: inline-block;
  text-transform: uppercase;
  margin: 0 20px;
}

.comingsoon .comingsoon-inner .countdown ul li span {
  display: block;
}

.comingsoon .comingsoon-inner .coming-soon-bottom-link {
  margin-top: 30px;
}

.comingsoon .comingsoon-inner .coming-soon-bottom-link a {
  font-size: 18px;
  color: #000;
  text-decoration: none;
  font-weight: 600;
}

.comingsoon video {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  transform: translateX(-50%) translateY(-50%);
  transition: 1s opacity;
}

/**=====================
    27. Coming Soon CSS Ends
==========================**/
/**=====================
     28. Radio CSS Start
==========================**/
.checkbox label {
  display: inline-block;
  position: relative;
  padding-left: 16px;
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
}

.checkbox label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  left: 0;
  margin-left: -16px;
  border: 1px solid #cccccc;
  border-radius: 3px;
  background-color: #fff;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.checkbox label::after {
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 16px;
  left: 0;
  top: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 11px;
  color: #444444;
}

.checkbox input[type="checkbox"] {
  opacity: 0;
}

.checkbox input[type="checkbox"]:focus {
  outline-offset: -2px;
}

.checkbox input[type="checkbox"]:focus+label::before {
  outline-offset: -2px;
}

.checkbox input[type="checkbox"]:checked+label::before {
  font-family: themify;
  content: "\\e64c";
  text-align: center;
  line-height: 1.2;
}

.checkbox input[type="checkbox"]:disabled+label {
  opacity: 0.65;
}

.checkbox input[type="checkbox"]:disabled+label::before {
  background-color: #eeeeee;
  cursor: not-allowed;
}

.checkbox .checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox .checkbox-inline {
  margin-top: 0;
}

.m-squar label::before {
  border-radius: 0;
}

.m-squar .checkbox-circle label::before {
  border-radius: 50%;
}

.m-squar .checkbox-inline {
  margin-top: 0;
}

.checkbox-primary input[type="checkbox"]:checked+label::before {
  border-color: #ab8ce4;
  color: #ab8ce4;
}

.checkbox-primary input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-secondary input[type="checkbox"]:checked+label::before {
  border-color: #26c6da;
  color: #26c6da;
}

.checkbox-secondary input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-success input[type="checkbox"]:checked+label::before {
  border-color: #00c292;
  color: #00c292;
}

.checkbox-success input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-danger input[type="checkbox"]:checked+label::before {
  border-color: #FF5370;
  color: #FF5370;
}

.checkbox-danger input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-info input[type="checkbox"]:checked+label::before {
  border-color: #4099ff;
  color: #4099ff;
}

.checkbox-info input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-light input[type="checkbox"]:checked+label::before {
  border-color: #eeeeee;
  color: #eeeeee;
}

.checkbox-light input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-dark input[type="checkbox"]:checked+label::before {
  border-color: #2a3142;
  color: #2a3142;
}

.checkbox-dark input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-warning input[type="checkbox"]:checked+label::before {
  border-color: #f3d800;
  color: #f3d800;
}

.checkbox-warning input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-primary label:before {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  color: #fff;
}

.checkbox-solid-primary input[type="checkbox"]:checked+label::before {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  color: #fff;
}

.checkbox-solid-primary input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-secondary label:before {
  background-color: #26c6da;
  border-color: #26c6da;
  color: #fff;
}

.checkbox-solid-secondary input[type="checkbox"]:checked+label::before {
  background-color: #26c6da;
  border-color: #26c6da;
  color: #fff;
}

.checkbox-solid-secondary input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-success label:before {
  background-color: #00c292;
  border-color: #00c292;
  color: #fff;
}

.checkbox-solid-success input[type="checkbox"]:checked+label::before {
  background-color: #00c292;
  border-color: #00c292;
  color: #fff;
}

.checkbox-solid-success input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-danger label:before {
  background-color: #FF5370;
  border-color: #FF5370;
  color: #fff;
}

.checkbox-solid-danger input[type="checkbox"]:checked+label::before {
  background-color: #FF5370;
  border-color: #FF5370;
  color: #fff;
}

.checkbox-solid-danger input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-info label:before {
  background-color: #4099ff;
  border-color: #4099ff;
  color: #fff;
}

.checkbox-solid-info input[type="checkbox"]:checked+label::before {
  background-color: #4099ff;
  border-color: #4099ff;
  color: #fff;
}

.checkbox-solid-info input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-light label:before {
  background-color: #eeeeee;
  border-color: #eeeeee;
  color: #fff;
}

.checkbox-solid-light input[type="checkbox"]:checked+label::before {
  background-color: #eeeeee;
  border-color: #eeeeee;
  color: #fff;
}

.checkbox-solid-light input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-dark label:before {
  background-color: #2a3142;
  border-color: #2a3142;
  color: #fff;
}

.checkbox-solid-dark input[type="checkbox"]:checked+label::before {
  background-color: #2a3142;
  border-color: #2a3142;
  color: #fff;
}

.checkbox-solid-dark input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-solid-warning label:before {
  background-color: #f3d800;
  border-color: #f3d800;
  color: #fff;
}

.checkbox-solid-warning input[type="checkbox"]:checked+label::before {
  background-color: #f3d800;
  border-color: #f3d800;
  color: #fff;
}

.checkbox-solid-warning input[type="checkbox"]:checked+label::after {
  color: #fff;
}

.checkbox-primary label::before {
  border-color: #ab8ce4;
}

.checkbox-secondary label::before {
  border-color: #26c6da;
}

.checkbox-success label::before {
  border-color: #00c292;
}

.checkbox-danger label::before {
  border-color: #FF5370;
}

.checkbox-info label::before {
  border-color: #4099ff;
}

.checkbox-light label::before {
  border-color: #eeeeee;
}

.checkbox-dark label::before {
  border-color: #2a3142;
}

.checkbox-warning label::before {
  border-color: #f3d800;
}

.m-checkbox-inline .checkbox {
  display: inline-block;
}

.m-checkbox-inline .radio {
  display: inline-block;
}

.m-checkbox-inline label {
  margin-right: 20px;
}

.radio label {
  display: inline-block;
  position: relative;
  padding-left: 5px;
  cursor: pointer;
}

.radio label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  left: 0;
  margin-left: -20px;
  border: 1px solid #cccccc;
  border-radius: 50%;
  background-color: #fff;
  transition: border 0.15s ease-in-out;
}

.radio label::after {
  display: inline-block;
  position: absolute;
  content: " ";
  width: 9px;
  height: 9px;
  left: 5px;
  top: 5px;
  margin-left: -20px;
  border-radius: 50%;
  background-color: #717171;
  transform: scale(0, 0);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
}

.radio input[type="radio"] {
  opacity: 0;
}

.radio input[type="radio"]:focus+label::before {
  outline-offset: -2px;
}

.radio input[type="radio"]:checked+label::after {
  transform: scale(1, 1);
}

.radio input[type="radio"]:disabled+label {
  opacity: 0.65;
}

.radio input[type="radio"]:disabled+label::before {
  cursor: not-allowed;
}

.radio .radio-inline {
  margin-top: 0;
}

.radio-primary input[type="radio"]+label::before {
  border-color: #ab8ce4;
}

.radio-primary input[type="radio"]+label::after {
  background-color: #ab8ce4;
}

.radio-primary input[type="radio"]:checked+label::before {
  border-color: #ab8ce4;
}

.radio-primary input[type="radio"]:checked+label::after {
  background-color: #ab8ce4;
}

.radio-secondary input[type="radio"]+label::before {
  border-color: #26c6da;
}

.radio-secondary input[type="radio"]+label::after {
  background-color: #26c6da;
}

.radio-secondary input[type="radio"]:checked+label::before {
  border-color: #26c6da;
}

.radio-secondary input[type="radio"]:checked+label::after {
  background-color: #26c6da;
}

.radio-success input[type="radio"]+label::before {
  border-color: #00c292;
}

.radio-success input[type="radio"]+label::after {
  background-color: #00c292;
}

.radio-success input[type="radio"]:checked+label::before {
  border-color: #00c292;
}

.radio-success input[type="radio"]:checked+label::after {
  background-color: #00c292;
}

.radio-danger input[type="radio"]+label::before {
  border-color: #FF5370;
}

.radio-danger input[type="radio"]+label::after {
  background-color: #FF5370;
}

.radio-danger input[type="radio"]:checked+label::before {
  border-color: #FF5370;
}

.radio-danger input[type="radio"]:checked+label::after {
  background-color: #FF5370;
}

.radio-info input[type="radio"]+label::before {
  border-color: #4099ff;
}

.radio-info input[type="radio"]+label::after {
  background-color: #4099ff;
}

.radio-info input[type="radio"]:checked+label::before {
  border-color: #4099ff;
}

.radio-info input[type="radio"]:checked+label::after {
  background-color: #4099ff;
}

.radio-light input[type="radio"]+label::before {
  border-color: #eeeeee;
}

.radio-light input[type="radio"]+label::after {
  background-color: #eeeeee;
}

.radio-light input[type="radio"]:checked+label::before {
  border-color: #eeeeee;
}

.radio-light input[type="radio"]:checked+label::after {
  background-color: #eeeeee;
}

.radio-dark input[type="radio"]+label::before {
  border-color: #2a3142;
}

.radio-dark input[type="radio"]+label::after {
  background-color: #2a3142;
}

.radio-dark input[type="radio"]:checked+label::before {
  border-color: #2a3142;
}

.radio-dark input[type="radio"]:checked+label::after {
  background-color: #2a3142;
}

.radio-warning input[type="radio"]+label::before {
  border-color: #f3d800;
}

.radio-warning input[type="radio"]+label::after {
  background-color: #f3d800;
}

.radio-warning input[type="radio"]:checked+label::before {
  border-color: #f3d800;
}

.radio-warning input[type="radio"]:checked+label::after {
  background-color: #f3d800;
}

/**=====================
     28. Radio CSS Ends
==========================**/
/**=====================
     29. Form Input CSS Start
==========================**/
.icon-addon .addon-md .glyphicon,
.icon-addon .addon-md .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 10px 0;
  top: 1px;
}

.icon-addon .glyphicon,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 10px 0;
  top: 1px;
}

.input-group-square .input-group-text,
.input-group-square .form-control {
  border-radius: 0;
}

.input-group-solid .input-group-text,
.input-group-solid .form-control {
  background: #eeeeee;
}

.input-group-air {
  box-shadow: 0 3px 20px 0 #ddd;
}

.icon-addon {
  position: relative;
  color: #4c5667;
  display: block;
}

.icon-addon:after {
  display: table;
  content: "";
  clear: both;
}

.icon-addon:before {
  display: table;
  content: "";
}

.icon-addon .addon-md .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.pill-input-group div:last-child span {
  border-top-right-radius: 1.3rem;
  border-bottom-right-radius: 1.3rem;
}

.pill-input-group div:first-child span {
  border-top-left-radius: 1.3rem;
  border-bottom-left-radius: 1.3rem;
}

/**=====================
     29. Form Input CSS Ends
==========================**/
/**=====================
    30. Data-table CSS Start
==========================**/
div.dt-button-background {
  display: none !important;
}

.dataTables_wrapper {
  padding: 0;
  width: 100%;
}

.dataTables_wrapper.no-footer .dataTables_scrollBody {
  border-bottom: 1px solid #cccccc;
}

.dataTables_wrapper button {
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  color: #fff;
}

.dataTables_wrapper+.dataTables_wrapper {
  margin-top: 20px;
}

.dataTables_wrapper .dataTables_paginate {
  margin-left: 15px !important;
  border: 1px solid #eeeeee;
  border-radius: 0.25rem;
  padding-top: 0;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  margin: 0;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.current,
.dataTables_wrapper .dataTables_paginate .paginate_button:active {
  background: #ab8ce4;
  color: #fff !important;
  box-shadow: none;
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
  border: 1px solid #ab8ce4;
  color: #2a3142 !important;
  background: transparent !important;
}

.dataTables_wrapper .dataTables_length {
  margin-bottom: 30px;
}

.dataTables_wrapper .dataTables_length select {
  border-color: #eeeeee;
  color: #2a3142;
  padding: 0 10px;
  margin: 0 10px;
  height: 2.7142em;
}

.dataTables_wrapper table.dataTable {
  border: 1px solid #ddd;
}

.dataTables_wrapper table.dataTable thead th,
.dataTables_wrapper table.dataTable thead td {
  border-bottom: 2px solid #ddd;
}

.dataTables_wrapper table.dataTable th,
.dataTables_wrapper table.dataTable td {
  padding: 0.75rem;
}

.dataTables_wrapper .dataTables_filter {
  margin-bottom: 25px;
  margin-left: 15px;
}

.dataTables_wrapper .dataTables_filter input[type="search"] {
  border: 1px solid #ddd;
  padding: 0 10px;
  margin-left: 10px;
  height: 37px;
  border-radius: 0;
}

.dataTables_scrollHeadInner {
  width: 100% !important;
}

table .fixedHeader-floating {
  position: fixed !important;
  background-color: #fff;
}

table .box>div {
  padding: 5px 15px;
  background-color: #ab8ce4;
  display: inline-block;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 15px;
  margin-right: 15px;
}

table.dataTable.fixedHeader-locked,
table.dataTable.fixedHeader-floating {
  width: calc(100vw - 250px) !important;
  max-width: calc(100vw - 250px) !important;
  overflow: hidden !important;
  right: 0 !important;
  z-index: 99;
  left: 260px !important;
}

table.dataTable:not(.fixedHeader-locked):not(.fixedHeader-floating) {
  width: 100% !important;
}

table.dataTable {
  border-collapse: collapse !important;
  margin-top: 0 !important;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  bottom: 12px !important;
}

table.dataTable input,
table.dataTable select {
  border: 1px solid #ddd;
  padding: 0 10px;
  height: 37px;
}

.toolbar {
  padding: 5px 15px;
  background-color: #ab8ce4;
  display: inline-block;
  color: #fff;
  border-radius: 5px;
  margin-bottom: 15px;
  margin-right: 15px;
}

code.option {
  color: #FF5370 !important;
}

code.api {
  color: #00c292 !important;
}

.dt-ext .dataTables_wrapper .page-item.active .page-link {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  color: #fff;
}

.dt-ext .dataTables_wrapper .dataTables_paginate {
  border: none;
}

.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button {
  padding: 0;
  border: none;
}

.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.disabled,
.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.hover,
.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.active {
  border: none !important;
}

.dt-ext .dataTables_wrapper .dataTables_paginate .page-link {
  margin-left: 0px;
  color: #ab8ce4;
}

.dt-ext .dataTables_wrapper button.dt-button,
.dt-ext .dataTables_wrapper div.dt-button,
.dt-ext .dataTables_wrapper a.dt-button,
.dt-ext .dataTables_wrapper button.dt-button:focus:not(.disabled),
.dt-ext .dataTables_wrapper div.dt-button:focus:not(.disabled),
.dt-ext .dataTables_wrapper a.dt-button:focus:not(.disabled),
.dt-ext .dataTables_wrapper button.dt-button:active:not(.disabled),
.dt-ext .dataTables_wrapper button.dt-button.active:not(.disabled),
.dt-ext .dataTables_wrapper div.dt-button:active:not(.disabled),
.dt-ext .dataTables_wrapper div.dt-button.active:not(.disabled),
.dt-ext .dataTables_wrapper a.dt-button:active:not(.disabled),
.dt-ext .dataTables_wrapper a.dt-button.active:not(.disabled) {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  border-radius: 2px;
  color: #fff;
  background-image: none;
  font-size: 14px;
}

.dt-ext .dataTables_wrapper button.dt-button.btn-success,
.dt-ext .dataTables_wrapper div.dt-button.btn-success,
.dt-ext .dataTables_wrapper a.dt-button.btn-success {
  background-color: #00c292;
  border-color: #00c292;
}

.dt-ext .dataTables_wrapper button.dt-button.btn-secondary,
.dt-ext .dataTables_wrapper div.dt-button.btn-secondary,
.dt-ext .dataTables_wrapper a.dt-button.btn-secondary {
  background-color: #26c6da;
  border-color: #26c6da;
}

.dt-ext .dataTables_wrapper button.dt-button.btn-danger,
.dt-ext .dataTables_wrapper div.dt-button.btn-danger,
.dt-ext .dataTables_wrapper a.dt-button.btn-danger {
  background-color: #FF5370;
  border-color: #FF5370;
}

.dt-ext .dataTables_wrapper table.dataTable th.focus,
.dt-ext .dataTables_wrapper table.dataTable td.focus {
  outline: 3px solid #ab8ce4;
}

.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.odd.selected>.sorting_1,
.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_1 {
  background-color: #e7dff7;
}

.dt-ext .dataTables_wrapper table.dataTable.stripe tbody>tr.odd.selected,
.dt-ext .dataTables_wrapper table.dataTable.stripe tbody>tr.odd>.selected,
.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.odd.selected,
.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.odd>.selected {
  background-color: #e7dff7;
}

.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.even.selected>.sorting_1,
.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_1 {
  background-color: #e7dff7;
}

.dt-ext .dataTables_wrapper table.dataTable tbody>tr.selected,
.dt-ext .dataTables_wrapper table.dataTable tbody>tr>.selected {
  background-color: #e7dff7;
}

td.highlight {
  background-color: #eeeeee !important;
}

td.details-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
  cursor: pointer;
}

tr.shown td.details-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center center;
}

.dataTables_scroll~.dataTables_paginate {
  margin-top: 20px !important;
}

.product-table th:last-child {
  min-width: 120px;
}

.product-table h6 {
  font-weight: 600;
  color: #2a3142;
}

table.dataTable.display tbody tr.odd>.sorting_1 {
  background-color: #f6f6f6;
}

/**=====================
     30. Data-table CSS Ends
==========================**/
/**=====================
     31. JS datagrid CSS Start
==========================**/
.jsgrid .jsgrid-grid-body .jsgrid-cell {
  padding: 0.75rem;
}

.jsgrid .jsgrid-pager-container {
  text-align: right;
}

.jsgrid .jsgrid-pager {
  padding: 0;
  margin-top: 20px;
}

.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button {
  margin-right: -5px;
}

.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button:first-child {
  border-radius: 5px 0 0 5px;
}

.jsgrid .jsgrid-pager .jsgrid-pager-page~.jsgrid-pager-nav-button {
  margin-left: -5px;
}

.jsgrid .jsgrid-pager .jsgrid-pager-page~.jsgrid-pager-nav-button:last-child {
  border-radius: 0 5px 5px 0;
}

.jsgrid .jsgrid-pager [class*="jsgrid-pager"] {
  display: inline-block;
  min-width: 1.5em;
  padding: 0.5em 1em;
  border: 1px solid #eeeeee;
}

.jsgrid .jsgrid-pager .jsgrid-pager-page a {
  color: #2a3142;
}

.jsgrid .jsgrid-pager .jsgrid-pager-current-page {
  color: #2a3142;
}

.jsgrid .jsgrid-selected-row>.jsgrid-cell {
  background: #eeeeee;
  border-color: #fafafa;
}

.jsgrid .jsgrid-header-row>.jsgrid-header-cell {
  padding: 0.75rem;
}

/**=====================
     31. JS datagrid CSS Ends
==========================**/
/**=====================
     32. Page CSS Start
==========================**/
/*test Nav bar color */
.pagination-theme .page-item .page-link {
  color: #ab8ce4;
}

.pagination-theme .page-item.active .page-link {
  color: #fff;
  background-color: #ab8ce4;
  border-color: #ab8ce4;
}

.pagination-primary .page-item .page-link {
  color: #ab8ce4;
}

.pagination-primary .page-item.active .page-link {
  color: #fff;
  background-color: #ab8ce4;
  border-color: #ab8ce4;
}

.pagination-secondary .page-item .page-link {
  color: #26c6da;
}

.pagination-secondary .page-item.active .page-link {
  color: #fff;
  background-color: #26c6da;
  border-color: #26c6da;
}

.pagination-success .page-item .page-link {
  color: #00c292;
}

.pagination-success .page-item.active .page-link {
  color: #fff;
  background-color: #00c292;
  border-color: #00c292;
}

.pagination-danger .page-item .page-link {
  color: #FF5370;
}

.pagination-danger .page-item.active .page-link {
  color: #fff;
  background-color: #FF5370;
  border-color: #FF5370;
}

.pagination-info .page-item .page-link {
  color: #4099ff;
}

.pagination-info .page-item.active .page-link {
  color: #fff;
  background-color: #4099ff;
  border-color: #4099ff;
}

.pagination-dark .page-item .page-link {
  color: #2a3142;
}

.pagination-dark .page-item.active .page-link {
  color: #fff;
  background-color: #2a3142;
  border-color: #2a3142;
}

.pagination-warning .page-item .page-link {
  color: #f3d800;
}

.pagination-warning .page-item.active .page-link {
  color: #fff;
  background-color: #f3d800;
  border-color: #f3d800;
}

/**=====================
     32. Page CSS Ends
==========================**/
/**=====================
    33.  Ecommerce  CSS Start
==========================**/
/**====== Product Start ======**/
.credit-card .text-center img {
  margin-bottom: 20px;
}

.product-box .product-details {
  padding: 25px;
  text-align: center;
}

.product-box .product-details h6 {
  color: #333333;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.product-box .product-details span {
  color: #717171;
}

.product-box .product-img {
  position: relative;
}

.product-box .product-img .product-hover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  opacity: 0;
  border-radius: 100%;
  transform: scale(0);
  transition: all 0.3s ease;
}

.product-box .product-img .product-hover ul li {
  display: inline-block;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);
  padding: 10px 15px;
  background-color: #fff;
  font-size: 18px;
  border-radius: 5px;
}

.product-box .product-img .product-hover ul li:hover {
  background-color: #333333;
  color: #fff;
  transition: all 0.3s ease;
}

.product-box:hover .product-hover {
  opacity: 1;
  border-radius: 0%;
  transform: scale(1);
  transition: all 0.3s ease;
}

.product-page-main {
  padding: 30px;
}

.product-page-main .owl-item .item {
  border: 1px solid #eeeeee;
  border-radius: 5px;
}

.product-page-main .owl-item.current .item {
  border: 1px solid #ab8ce4;
}

.product-page-main .product-slider {
  margin-bottom: 20px;
}

.product-page-details h4 {
  color: #333333;
  text-transform: uppercase;
  font-size: 18px;
}

.product-page-details span {
  padding-left: 15px;
}

.br-theme-fontawesome-stars .br-widget a,
.br-theme-fontawesome-stars .br-widget a.br-selected:after,
.br-theme-fontawesome-stars .br-widget a.br-active:after {
  color: #ffa800;
  font: normal normal normal 14px/1 FontAwesome;
}

.product-price {
  font-size: 18px;
  font-weight: 700;
  font-family: Open Sans;
}

.product-price del {
  color: #aaaaaa;
  padding-right: 20px;
}

.product-color li {
  display: inline-block;
  border-radius: 100%;
  height: 30px;
  width: 30px;
  margin: 0 2px;
}

.product-page-main p {
  font-size: 15px;
}

.product-page-main .nav-link {
  text-transform: uppercase;
  font-weight: 600;
}

/**====== Product  Ends ======**/
.payment-opt li {
  display: inline-block;
}

.payment-opt li img {
  height: 20px;
  margin: 15px 15px 0 0;
}

/**=====================
    33. Ecommerce  CSS End
==========================**/
/**=====================
     34. Pricing CSS Start
==========================**/
.pricing-wrapper-card .card-ribbon::before,
.pricing-wrapper-card .card-ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #ab8ce4;
  border-top-color: transparent;
  border-left-color: transparent;
}

.pricing-wrapper-card {
  padding: 50px 100px;
}

.pricing-wrapper-card .pricing-card {
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.11);
  flex: 1 1;
  margin: 8px;
  padding: 30px;
  position: relative;
  text-align: center;
  transition: all 0.5s ease-in-out;
}

.pricing-wrapper-card .pricing-card.popular {
  margin-top: -10px;
  margin-bottom: -10px;
}

.pricing-wrapper-card .pricing-card.popular .card-price {
  margin: 50px;
}

.pricing-wrapper-card .pricing-card.popular .card-price h1 {
  color: #ab8ce4;
  font-size: 100px;
}

.pricing-wrapper-card .pricing-card.popular .card-title h3 {
  color: #ab8ce4;
  font-size: 22px;
}

.pricing-wrapper-card .pricing-card.popular .card-action button {
  background-color: #ab8ce4;
  border-radius: 80px;
  color: #fff;
  font-size: 17px;
  margin-top: -15px;
  padding: 15px;
  height: 80px;
}

.pricing-wrapper-card .pricing-card.popular .card-action button:hover {
  background-color: #ab8ce4;
}

.pricing-wrapper-card .pricing-card:hover {
  box-shadow: 6px 5px 17px 2px rgba(0, 0, 0, 0.08);
}

.pricing-wrapper-card .card-ribbon {
  position: absolute;
  overflow: hidden;
  top: -10px;
  left: -10px;
  width: 114px;
  height: 112px;
}

.pricing-wrapper-card .card-ribbon span {
  position: absolute;
  display: block;
  width: 160px;
  padding: 10px 0;
  background-color: #ab8ce4;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  color: #fff;
  font-size: 13px;
  text-transform: uppercase;
  text-align: center;
  left: -35px;
  top: 25px;
  transform: rotate(-45deg);
}

.pricing-wrapper-card .card-ribbon::before {
  top: 0;
  right: 0;
}

.pricing-wrapper-card .card-ribbon::after {
  bottom: 0;
  left: 0;
}

.pricing-wrapper-card .card-title h3 {
  color: rgba(0, 0, 0, 0.3);
  font-size: 15px;
  text-transform: uppercase;
}

.pricing-wrapper-card .card-title h5 {
  color: rgba(0, 0, 0, 0.6);
  margin-top: 15px;
  line-height: 1.8;
}

.pricing-wrapper-card .card-price {
  margin: 60px 0;
}

.pricing-wrapper-card .card-price h1 {
  font-size: 80px;
}

.pricing-wrapper-card .card-price h1 sup {
  font-size: 15px;
  display: inline-block;
  margin-left: -20px;
  width: 10px;
}

.pricing-wrapper-card .card-price h1 small {
  color: rgba(0, 0, 0, 0.3);
  display: block;
  font-size: 11px;
  text-transform: uppercase;
}

.pricing-wrapper-card .card-description ul {
  display: block;
  list-style: none;
  margin: 60px 0;
  padding: 0;
}

.pricing-wrapper-card .card-description li {
  color: rgba(0, 0, 0, 0.6);
  font-size: 15px;
  margin: 0 0 15px;
}

.pricing-wrapper-card .card-description li::before {
  font-family: FontAwesome;
  content: "\\f00c";
  padding: 0 5px 0 0;
  color: rgba(0, 0, 0, 0.15);
}

.pricing-wrapper-card .card-action button {
  background: transparent;
  border: 2px solid #ab8ce4;
  border-radius: 30px;
  color: #ab8ce4;
  cursor: pointer;
  display: block;
  font-size: 15px;
  font-weight: bold;
  padding: 20px;
  width: 100%;
  height: 60px;
  text-transform: uppercase;
  transition: all 0.3s ease-in-out;
}

.pricing-wrapper-card .card-action button:hover {
  background-color: #ab8ce4;
  box-shadow: 0 2px 4px #ab8ce4;
  color: #fff;
}

.pricing-wrapper-card .card-action button:focus {
  outline: none !important;
}

/**=====================
    34. Pricing CSS Ends
==========================**/
/**=====================
     35. Form builder css start
==========================**/
.form-builder .help-block {
  margin-bottom: 0;
  color: #999999;
  text-transform: capitalize;
}

.form-builder .btn-light {
  color: #999999;
}

.form-builder .copy-btn {
  padding: 8px;
}

.form-builder .nav-primary .nav-link.active,
.form-builder .nav-primary .nav-primary .show>.nav-link,
.form-builder .nav-primary .nav-pills.nav-primary .nav-link.active,
.form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {
  border-radius: 4px;
}

.form-builder .nav-primary .nav-link,
.form-builder .nav-primary .nav-pills.nav-primary .nav-link {
  color: #000;
  font-weight: 500;
}

.form-builder #components {
  margin-top: 30px;
}

.form-builder #components #viewhtml {
  height: 526px;
}

/**=====================
    35. Form builder css Ends
==========================**/
/**=====================
     36. NAV CSS Start
==========================**/
.nav-list {
  padding: 30px;
}

.nav-list .nav-list-disc {
  text-align: left;
  color: #717171;
}

.nav-list .nav-list-disc li {
  padding: 9px 0;
}

.nav-list .nav-list-disc li:first-child {
  padding-top: 0;
}

.nav-list .nav-list-disc li:last-child {
  padding-bottom: 0;
}

.nav-list .nav-list-disc li a {
  color: #717171;
}

.nav-list .nav-list-disc li a .fa {
  width: 14px;
  font-size: 16px;
}

.nav-list .nav-list-disc li:hover {
  color: #ab8ce4;
}

.nav-list .nav-list-disc li:hover a {
  color: #ab8ce4;
}

.navs-icon {
  padding: 30px;
}

.navs-icon i {
  font-size: 21px;
  margin-right: 10px;
}

.navs-icon .fa {
  font-size: 16px;
}

.navs-icon li {
  padding: 9px 0;
}

.navs-icon li:first-child {
  padding-top: 0;
}

.navs-icon li:last-child {
  padding-bottom: 0;
}

.navs-icon li a {
  display: flex;
  align-items: center;
}

.navs-icon li ul {
  padding-top: 9px;
}

.navs-icon li ul li {
  line-height: 1;
}

.navs-icon li ul li:first-child {
  padding-top: 9px;
}

.navs-icon li ul li:hover {
  color: #ab8ce4;
}

.navs-icon li ul li:hover a {
  color: #ab8ce4;
}

.navs-icon li a {
  color: #717171;
}

.navs-icon li a:hover {
  color: #ab8ce4;
}

.navs-icon li a.active {
  color: #ab8ce4;
}

.navs-icon li a span {
  font-family: Raleway;
}

.navs-icon li button:hover a {
  color: #FFf;
}

.navs-icon .main-section {
  padding-top: 30px;
}

.navs-icon .separator {
  border-bottom: 1px solid #dee2e6;
  margin: 30px 0;
  padding: 0;
}

.navs-icon .btn-link {
  text-decoration: none;
  line-height: 1;
  padding: 0;
  padding-bottom: 6px;
}

.navs-icon .btn-link:hover {
  text-decoration: none;
}

#accordionoc #collapseicon,
#accordionoc #collapseicon1 {
  padding-top: 0px;
}

#accordionoc li button {
  display: flex;
  align-items: center;
}

.navs-icon.default-according.style-1 li button {
  position: relative;
}

.navs-icon.default-according.style-1 li button:hover {
  color: #ab8ce4 !important;
}

.navs-icon.default-according.style-1 li button[aria-expanded="true"]:before {
  right: 2px;
  top: 6px;
}

.navs-icon.default-according.style-1 li button[aria-expanded="false"]:before {
  right: 2px;
  top: 6px;
}

.navs-dropdown button {
  margin-top: 30px;
}

.navs-dropdown .onhover-show-div {
  width: 250px;
  border-radius: 4px;
  box-shadow: 0 0 2px 2px #eeeeee;
}

.navs-dropdown .onhover-show-div button {
  margin-top: 0px;
}

.navs-dropdown .onhover-show-div .navs-icon li {
  text-align: left;
}

.onhover-dropdown.navs-dropdown:hover .onhover-show-div:before {
  right: 77px;
  left: auto;
  left: initial;
}

.onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {
  right: 77px;
  left: auto;
  left: initial;
}

.icon-lists {
  font-family: Raleway;
}

.pl-navs-inline {
  padding-left: 30px !important;
}

.inline-nav li {
  line-height: 1.3;
}

/**=====================
     36. NAV CSS Ends
==========================**/
/**=====================
    37. Dropdown CSS Start
==========================**/
.dropdown-basic {
  margin-bottom: -10px;
}

.dropdown-basic .btn-group {
  margin-right: 18px;
}

.dropdown-basic .btn-group .btn-round {
  border-radius: 50px;
}

.dropdown-basic .separated-btn {
  margin-left: -6px;
}

.dropdown-basic .separated-btn .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 10px;
}

.dropdown-basic button {
  max-height: 43px;
}

.dropdown-basic .dropdown {
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
}

.dropdown-basic .dropdown .dropbtn {
  color: white;
  padding: 12px;
  border: none;
  cursor: pointer;
}

.dropdown-basic .dropdown .dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: #f9f9f9;
  min-width: 170px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  left: 0;
  top: 45px;
}

.dropdown-basic .dropdown .dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-basic .dropdown .dropdown-content .dropdown-header {
  padding: 12px 16px;
}

.dropdown-basic .dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown-basic .dropdown:hover .dropdown-content {
  display: block;
}

.dropup-basic .dropup {
  position: relative;
  display: inline-block;
}

.dropup-basic .dropup .dropbtn {
  color: white;
  padding: 12px;
  border: none;
}

.dropup-basic .dropup .dropup-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 170px;
  bottom: 45px;
  z-index: 999;
  left: 0;
}

.dropup-basic .dropup .dropup-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropup-basic .dropup .dropup-content a:hover {
  background-color: #f1f1f1;
}

.dropup-basic .dropup:hover .dropup-content {
  display: block;
}

.dropup-basic .dropup:hover .dropup-content a.active {
  background-color: #f1f1f1;
}

/**=====================
    37. Dropdown CSS Ends
==========================**/
/**=====================
     38. Landing CSS Start
==========================**/
.tap-top {
  width: 50px;
  height: 50px;
  position: fixed;
  bottom: 40px;
  right: 30px;
  z-index: 99;
  color: white;
  text-align: center;
  background: linear-gradient(to top, #ab8ce4, #4099ff);
  border-radius: 100%;
  font-size: 22px;
  cursor: pointer;
  line-height: 2.2;
  display: none;
  border: 1px solid white;
}

.landing-main .landing-home {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
}

.landing-main .landing-home .landing-left {
  height: 100%;
  display: flex;
  align-items: center;
}

.landing-main .landing-home .landing-left h5 {
  margin-bottom: 20px;
  line-height: 1.5;
}

.landing-main .landing-home .landing-left h1 {
  font-weight: 900;
  margin-bottom: 30px;
}

.landing-main .landing-home .landing-left p {
  font-size: 15px;
  margin-bottom: 25px;
}

.landing-main .landing-home .landing-left .button-bottom .btn-outline-primary-2x {
  background-color: #fff;
}

.landing-main .landing-home .landing-body {
  height: calc(100vh - 100px);
  display: flex;
  align-items: center;
}

.landing-main .live-box {
  padding: 8px;
  background-color: #fff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  position: relative;
}

.landing-main .live-box:hover:before {
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s ease;
}

.landing-main .live-box:hover .btn {
  opacity: 1;
  transition: all 0.3s ease;
}

.landing-main .live-box:before {
  opacity: 0;
  content: "";
  position: absolute;
  background-color: rgba(255, 255, 255, 0.2);
  z-index: 2;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  transform: scale(0);
  transition: all 0.3s ease;
}

.landing-main .live-box .btn {
  position: absolute;
  top: 45%;
  left: 30%;
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 3;
}

.landing-main .gray-section-bg {
  background-color: #f9f9f9;
}

.landing-main .navbar-expand-lg .navbar-brand {
  padding-left: 18px;
}

.landing-main .navbar-expand-lg .navbar-collapse {
  flex-flow: row nowrap;
  justify-content: flex-end;
}

.landing-main .navbar-expand-lg .navbar-collapse .navbar-nav .nav-item a {
  color: #fff;
  text-transform: uppercase;
  padding: 20px;
  font-weight: 600;
  opacity: 0.8;
  transition: all 0.3s ease;
}

.landing-main .navbar-expand-lg .navbar-collapse .navbar-nav .nav-item a:hover {
  opacity: 1;
  transition: all 0.3s ease;
}

.landing-main .section-space {
  padding: 80px 0;
  text-align: center;
}

.landing-main .section-space p {
  font-size: 15px;
}

.landing-main .landing-header h2 {
  text-transform: uppercase;
  margin-bottom: 20px;
  font-weight: 700;
  color: #36404a;
}

.landing-main .landing-header .line {
  position: relative;
  height: 3px;
  width: 70px;
  background-color: #4099ff;
  content: "";
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
  margin-bottom: 60px;
}

.landing-main .admin-options .live-demo-btn {
  margin-top: 30px;
  margin-bottom: 70px;
}

.landing-main .admin-options .live-demo-btn a {
  text-transform: uppercase;
  color: #fff;
}

.landing-main .admin-options .live-demo-btn a:focus {
  box-shadow: none;
}

.landing-main .updates-features .row {
  justify-content: center;
}

.landing-main .updates-features .landing-header h2 {
  margin-bottom: 20px;
}

.landing-main .updates-features .landing-header p {
  color: #828282;
  margin: 0 auto;
  padding-bottom: 20px;
}

.landing-main .updates-features h6 {
  margin-top: 30px;
  text-transform: uppercase;
  font-weight: 700;
}

.landing-main .advance-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  background-position: center;
}

.landing-main .application-section .nav-pills {
  justify-content: center;
}

.landing-main .application-section .nav-pills .nav-item {
  position: relative;
}

.landing-main .application-section .nav-pills .nav-item .nav-link {
  font-size: 17px;
  padding: 12px 30px;
  line-height: 1;
}

.landing-main .application-section .nav-pills .nav-item a {
  color: #000;
}

.landing-main .application-section .nav-pills .nav-item a.active {
  color: #fff;
  background-color: #4099ff;
}

.landing-main .application-section .nav-pills .nav-item a.active:before {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #4099ff;
  content: "";
  bottom: -7px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 2;
}

.landing-main .application-section .nav-pills .nav-item a.active:after {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #4099ff;
  content: "";
  bottom: -7px;
  position: absolute;
  margin: 0 auto;
  left: 0;
  right: 0;
  z-index: 1;
}

.landing-main .application-section .nav-pills .application-icons i {
  font-size: 24px;
  margin-right: 0;
}

.landing-main .application-section .tab-content img {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border: 1px solid #f1f1f1;
}

.landing-main .application-section .tab-content.active {
  animation: fadeInDown 0.3s linear;
}

.landing-main .application-section .landing-header h2 {
  margin-bottom: 20px;
}

.landing-main .application-section .landing-header p {
  margin-bottom: 20px;
  color: #828282;
}

.landing-main .advance-widget {
  background-color: #fafafa;
}

.landing-main .advance-widget .widgets-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  height: 600px;
  animation: widget-animation 110s linear infinite reverse;
  -webkit-animation: widget-animation 110s linear infinite reverse;
  background-repeat: repeat-x;
}

@keyframes widget-animation {
  0% {
    background-position-x: 0;
  }

  100% {
    background-position-x: 1920px;
  }
}

.landing-main .key-features-section .feature-main {
  padding: 0 25px 25px 25px;
}

.landing-main .key-features-section .feature-main .feature-icon {
  width: 50px;
  margin: 0 auto;
}

.landing-main .key-features-section .feature-main .feature-content {
  margin-top: 35px;
}

.landing-main .key-features-section .feature-main .feature-content h5 {
  font-weight: 600;
  margin-bottom: 15px;
}

.landing-main .key-features-section .feature-main .feature-content p {
  color: #828282;
}

.landing-main .many-feature-section h5 {
  text-align: left;
  margin-bottom: 20px;
}

.landing-main .many-feature-section h5 span {
  margin-left: 15px;
}

.landing-main .exclusive-features {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.landing-main .exclusive-features .container .row:last-child {
  margin-bottom: 0;
}

.landing-main .exclusive-features .container>.row:nth-child(odd) .inner-block {
  background-image: linear-gradient(to right, rgba(255, 0, 0, 0), #f3f3f3);
}

.landing-main .exclusive-features .container>.row .inner-block {
  height: calc(100% - 30px);
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(to left, rgba(255, 0, 0, 0), #f3f3f3);
  padding: 50px;
  margin-bottom: 50px;
}

.landing-main .landing-components i {
  font-size: 35px;
  background-color: #fff;
  padding: 25px;
  border-radius: 50%;
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);
}

.landing-main .landing-components p {
  font-size: 14px;
}

.landing-main .landing-components h4 {
  text-transform: capitalize;
  margin-bottom: 15px;
}

.landing-main .landing-components .tour-mb {
  margin-bottom: 2px;
  font-weight: 600;
}

.landing-main .support-section i {
  font-size: 45px;
  background-color: #fff;
  padding: 25px;
  border-radius: 50%;
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);
}

.landing-main .support-section h6 {
  margin-top: 40px;
  font-weight: 600;
}

.landing-main .support-section p {
  font-size: 14px;
  margin-bottom: 0;
}

.landing-main .cd-timeline-content .cd-date {
  text-align: left;
}

.landing-main .cd-timeline-img i {
  left: 13%;
}

.landing-main .footer-bg {
  text-align: center;
  background-color: #4099ff;
  background: linear-gradient(to right, #9f75ec 0%, #7183ef 100%);
}

.landing-main .footer-bg h2 {
  font-size: 36px;
  text-transform: uppercase;
  color: #fff;
  font-weight: 700;
  letter-spacing: 1px;
}

.landing-main .footer-bg .star-rate {
  margin: 40px 0;
}

.landing-main .footer-bg .star-rate i {
  font-size: 45px;
  margin-right: 10px;
}

.landing-main .footer-bg .star-rate i:last-child {
  margin-right: 0;
}

.landing-main .footer-bg button {
  text-transform: uppercase;
}

.customizer-img {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border: 1px solid #f1f1f1;
}

/**=====================
      document css
==========================**/
.document.page-wrapper .page-sidebar {
  top: 100px;
  padding: 30px 20px;
}

.document.page-wrapper .page-body-wrapper .page-body {
  margin-top: 130px;
}

.document .particles-headline {
  background-position: top;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  background-image: linear-gradient(-90deg, #536dfe, #fff);
}

.page-wrapper.document .page-body {
  min-height: 0;
  min-height: initial;
}

.document-content ul.nav-pills {
  overflow-y: scroll;
  max-height: calc(100vh - 180px);
  display: block;
}

.document-content ul.nav-pills li {
  line-height: 25px;
}

.document-content ul.nav-pills li .nav-link {
  border-radius: .25rem;
  font-size: 15px;
  display: block;
  text-decoration: none;
  line-height: 40px;
  color: #4c5667;
  font-weight: 500;
  padding: 0;
}

.document-content ul.nav-pills li .nav-link i {
  margin-top: 3px;
  text-decoration: none;
  line-height: 25px;
  color: #ab8ce4;
  margin-right: 20px;
}

.document-content ul.nav-pills li .nav-link.active {
  background-color: transparent !important;
  background-color: initial !important;
  color: #ab8ce4;
}

.document-content ul.nav-pills li .show>.nav-link {
  background-color: transparent !important;
  background-color: initial !important;
  color: #ab8ce4;
}

.document-content .table thead th {
  width: 50%;
}

.document-content .set-flex {
  display: flex;
}

.document-content i.fa-star {
  color: #ffd042;
}

.document-content .col-9 {
  padding-left: 40px;
}

.document-content .col-9 .set-height {
  overflow: scroll;
  overflow-x: hidden;
}

.document-content .col-9 .tab-content {
  overflow: auto;
  overflow-x: hidden;
  max-height: calc(100% - 200px);
  position: fixed;
  width: 976px;
  margin-left: 30px;
  -o-box-shadow: 0 0 15px 0 rgba(220, 220, 220, 0.4);
  box-shadow: 0 0 15px 0 rgba(220, 220, 220, 0.4);
}

.document-content .col-9 .tab-content .section-head {
  font-weight: 600;
  font-size: 32px;
  margin-bottom: 40px;
  padding: 0;
}

.document-content .card-body.tree-color {
  padding: 0;
}

.document-content .jstree-default {
  padding: 30px;
  background-color: #36404a;
  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);
}

.document-content .jstree-default .jstree-anchor {
  color: #a6aaaf;
}

.document-content .jstree-default .jstree-hovered {
  background-color: #303841;
  border: 1px solid #4b5469;
}

.document-content .jstree-default .jstree-clicked {
  color: white !important;
  background: transparent !important;
}

.document-content .jstree-default .jstree-icon {
  color: #656b78 !important;
}

.document-content hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.document-content .html-editor {
  color: rgba(255, 255, 255, 0.7);
  background-color: #2b2b2b;
}

.document-content .html-editor pre {
  color: rgba(255, 255, 255, 0.7);
  background-color: #000;
}

.document-content .progress {
  margin-bottom: 10px;
}

.document-content ul.list-ticked li {
  margin-bottom: 10px;
  padding-left: 1rem;
}

.document-content.faq {
  font-size: 18px;
}

.document-content.faq .btn {
  font-size: 18px;
  font-weight: 600;
  color: #ab8ce4;
}

.document-content.faq .btn.btn-link {
  color: #000;
}

.document-content.faq .btn.btn-link.collapsed {
  color: #ab8ce4;
}

.document-content.faq ul {
  border: medium none currentColor;
  border: initial;
}

.document-content.faq ul.nav {
  display: block;
}

.document-content.faq ul.nav li .nav-link {
  border-radius: .25rem;
  font-size: 18px;
  display: block;
  padding: 3px 20px 3px 30px;
  text-decoration: none;
  line-height: 30px;
  color: #4c5667;
  font-weight: 500;
  border: medium none currentColor;
  border: initial;
}

.document-content.faq ul.nav li .nav-link i {
  margin-top: 3px;
  text-decoration: none;
  line-height: 25px;
  color: #ab8ce4;
  margin-right: 20px;
}

.document-content.faq ul.nav li .nav-link.active {
  color: #ab8ce4;
  background-color: transparent;
  background-color: initial;
  border: medium none currentColor;
  border: initial;
}

.document-content.faq ul.nav li .nav-link:hover {
  border: medium none currentColor;
  border: initial;
}

.document-content .reviews {
  background-color: #fff;
  padding: 30px 0;
  margin-bottom: 30px;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);
}

.document-content .reviews h1 {
  text-transform: uppercase;
  font-weight: 600;
}

.document-content .reviews h5 {
  text-transform: capitalize;
}

/**=====================
      document css end
==========================**/
/**=====================
     38. Landing CSS Ends
==========================**/
/**=====================
     39. Table  CSS Start
==========================**/
.table {
  margin-bottom: 0;
}

.table th,
.table td {
  color: #333333;
}

.table [class*='bg-'] {
  color: #fff;
}

.table .bg-light {
  color: #333333;
}

.table tfoot {
  font-weight: bold;
}

.table-inverse th,
.table-inverse td {
  color: #fff;
}

.table[class*='bg-'] th,
.table[class*='bg-'] td {
  color: #fff;
}

.table-hover tbody tr:hover {
  background-color: #f6f6f6;
}

.table-xl td,
.table-xl th {
  padding: 1.25rem 2rem;
  font-size: 120%;
}

.table-lg td,
.table-lg th {
  padding: .9rem 2rem;
  font-size: 110%;
}

.table-de td,
.table-de th {
  padding: .75rem 2rem;
}

.table-sm th,
.table-sm td {
  padding: .5rem 2rem;
  font-size: 90%;
}

.table-xs th,
.table-xs td {
  padding: 0.2rem 2rem;
  font-size: 80%;
}

.table-border-horizontal tr,
.table-border-horizontal th,
.table-border-horizontal td {
  border-top: 1px solid #dee2e6;
  padding: .75rem 2rem;
}

.table-border-vertical tr,
.table-border-vertical th,
.table-border-vertical td {
  border-top: 0;
  border-right: 1px solid #dee2e6;
}

.table-border-vertical tr td:last-child {
  border-right: none;
}

.table-bordernone td {
  border: 0;
}

.table-bordernone .bd-t-none {
  border-top: none;
}

.table-bordernone .u-s-tb {
  padding: 11px;
}

.table-inverse {
  color: #fff;
  background-color: #292b2c;
}

.table-inverse th,
.table-inverse td {
  border-color: #fff;
}

.table-inverse.table-bordered {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(245, 247, 250, 0.5);
}

.table-bordered td,
.table-bordered th {
  border-color: #f6f6f6;
}

/**=====================
     39.Table CSS Ends
==========================**/
/**=====================
    40. Alertbox-call-out CSS start
==========================**/
.bs-callout-info {
  display: block;
  border-color: #ab8ce4 !important;
  background-color: #ab8ce4;
  border-radius: 0.25rem;
  color: #000;
}

/**=====================
     40. Alertbox-call-out CSS End
==========================**/
/**=====================
    41. Chart CSS Start
==========================**/
.radial-bar.radial-bar-lg:after,
.radial-bar.radial-bar-lg>img {
  width: 70px;
  height: 70px;
  margin-left: 15px;
  margin-top: 15px;
  line-height: 70px;
}

.radial-bar.radial-bar-sm:after,
.radial-bar.radial-bar-sm>img {
  width: 35px;
  height: 35px;
  margin-left: 7.5px;
  margin-top: 7.5px;
  line-height: 35px;
}

.radial-bar.radial-bar-xs:after,
.radial-bar.radial-bar-xs>img {
  width: 20px;
  height: 20px;
  margin-left: 5.5px;
  margin-top: 4.5px;
  line-height: 21px;
}

.chart-block canvas {
  width: 100% !important;
}

.chart-block .chart-overflow {
  overflow: hidden;
  text-align: center;
}

.candidcahrt {
  width: 100%;
  height: 470px;
}

.amcharts-export-canvas {
  position: absolute;
  display: none;
  z-index: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #fff;
}

.amcharts-export-canvas .canvas-container {
  transition: opacity .5s ease-out;
}

.amcharts-export-canvas.active {
  display: block;
}

.amcharts-export-canvas.dropbox .canvas-container {
  opacity: .5;
}

.flot-chart-container {
  box-sizing: border-box;
  width: 100%;
  height: 400px;
}

.flot-chart-container #toggling-series-flot {
  width: 79% !important;
}

.flot-chart-placeholder {
  width: 100%;
  height: 100%;
  font-size: 14px;
  line-height: 1.2em;
  text-align: center;
}

.flot-chart-placeholder .legend table {
  border-spacing: 5px;
}

.morris-hover {
  position: absolute;
  z-index: 8;
}

.morris-hover.morris-default-style {
  border-radius: 10px;
  padding: 6px;
  color: #717171;
  background: #fff;
  border: solid 1px #cccccc;
  font-family: sans-serif;
  font-size: 12px;
  text-align: center;
}

.morris-hover.morris-default-style .morris-hover-row-label {
  font-weight: bold;
  margin: 0.25em 0;
}

.morris-hover.morris-default-style .morris-hover-point {
  white-space: nowrap;
  margin: 0.1em 0;
}

.chart-sparkline {
  position: absolute;
  left: 0;
  top: 0;
  visibility: hidden;
  background: #999999 transparent;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);
  color: #fff;
  font: 10px arial, sans-serif;
  text-align: left;
  white-space: nowrap;
  padding: 5px;
  border: 1px solid #fff;
  box-sizing: content-box;
  z-index: 10000;
}

.chart-sparkline .jqsfield {
  color: #fff;
  font: 10px arial, sans-serif;
  text-align: left;
}

.radial-bar {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  background-color: transparent;
  box-sizing: content-box;
  width: 80px;
  height: 80px;
  font-size: 18px;
  font-family: Open Sans, sans-serif;
  background-clip: content-box;
}

.radial-bar:after {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  text-align: center;
  font-weight: 500;
  color: #455a64;
  content: attr(data-label);
  background-color: #fff;
  z-index: 1;
  width: 56px;
  height: 56px;
  margin-left: 12px;
  margin-top: 12px;
  line-height: 56px;
}

.radial-bar>img {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
  text-align: center;
  font-weight: 500;
  color: #455a64;
  z-index: 3;
  width: 56px;
  height: 56px;
  margin-left: 12px;
  margin-top: 12px;
  line-height: 56px;
}

.radial-bar.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-50 {
  background-image: linear-gradient(270deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-55 {
  background-image: linear-gradient(288deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-60 {
  background-image: linear-gradient(306deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-65 {
  background-image: linear-gradient(324deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-70 {
  background-image: linear-gradient(342deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-75 {
  background-image: linear-gradient(360deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-80 {
  background-image: linear-gradient(378deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-85 {
  background-image: linear-gradient(396deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-90 {
  background-image: linear-gradient(414deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-95 {
  background-image: linear-gradient(432deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-100 {
  background-image: linear-gradient(450deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-50 {
  background-image: linear-gradient(270deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-55 {
  background-image: linear-gradient(288deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-60 {
  background-image: linear-gradient(306deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-65 {
  background-image: linear-gradient(324deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-70 {
  background-image: linear-gradient(342deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-75 {
  background-image: linear-gradient(360deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-80 {
  background-image: linear-gradient(378deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-85 {
  background-image: linear-gradient(396deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-90 {
  background-image: linear-gradient(414deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-95 {
  background-image: linear-gradient(432deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-primary.radial-bar-100 {
  background-image: linear-gradient(450deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-50 {
  background-image: linear-gradient(270deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-55 {
  background-image: linear-gradient(288deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-60 {
  background-image: linear-gradient(306deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-65 {
  background-image: linear-gradient(324deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-70 {
  background-image: linear-gradient(342deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-75 {
  background-image: linear-gradient(360deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-80 {
  background-image: linear-gradient(378deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-85 {
  background-image: linear-gradient(396deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-90 {
  background-image: linear-gradient(414deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-95 {
  background-image: linear-gradient(432deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-secondary.radial-bar-100 {
  background-image: linear-gradient(450deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-50 {
  background-image: linear-gradient(270deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-55 {
  background-image: linear-gradient(288deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-60 {
  background-image: linear-gradient(306deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-65 {
  background-image: linear-gradient(324deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-70 {
  background-image: linear-gradient(342deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-75 {
  background-image: linear-gradient(360deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-80 {
  background-image: linear-gradient(378deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-85 {
  background-image: linear-gradient(396deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-90 {
  background-image: linear-gradient(414deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-95 {
  background-image: linear-gradient(432deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-success.radial-bar-100 {
  background-image: linear-gradient(450deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-50 {
  background-image: linear-gradient(270deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-55 {
  background-image: linear-gradient(288deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-60 {
  background-image: linear-gradient(306deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-65 {
  background-image: linear-gradient(324deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-70 {
  background-image: linear-gradient(342deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-75 {
  background-image: linear-gradient(360deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-80 {
  background-image: linear-gradient(378deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-85 {
  background-image: linear-gradient(396deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-90 {
  background-image: linear-gradient(414deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-95 {
  background-image: linear-gradient(432deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-info.radial-bar-100 {
  background-image: linear-gradient(450deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-50 {
  background-image: linear-gradient(270deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-55 {
  background-image: linear-gradient(288deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-60 {
  background-image: linear-gradient(306deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-65 {
  background-image: linear-gradient(324deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-70 {
  background-image: linear-gradient(342deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-75 {
  background-image: linear-gradient(360deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-80 {
  background-image: linear-gradient(378deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-85 {
  background-image: linear-gradient(396deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-90 {
  background-image: linear-gradient(414deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-95 {
  background-image: linear-gradient(432deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-warning.radial-bar-100 {
  background-image: linear-gradient(450deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-50 {
  background-image: linear-gradient(270deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-55 {
  background-image: linear-gradient(288deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-60 {
  background-image: linear-gradient(306deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-65 {
  background-image: linear-gradient(324deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-70 {
  background-image: linear-gradient(342deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-75 {
  background-image: linear-gradient(360deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-80 {
  background-image: linear-gradient(378deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-85 {
  background-image: linear-gradient(396deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-90 {
  background-image: linear-gradient(414deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-95 {
  background-image: linear-gradient(432deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-danger.radial-bar-100 {
  background-image: linear-gradient(450deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-50 {
  background-image: linear-gradient(270deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-55 {
  background-image: linear-gradient(288deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-60 {
  background-image: linear-gradient(306deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-65 {
  background-image: linear-gradient(324deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-70 {
  background-image: linear-gradient(342deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-75 {
  background-image: linear-gradient(360deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-80 {
  background-image: linear-gradient(378deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-85 {
  background-image: linear-gradient(396deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-90 {
  background-image: linear-gradient(414deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-95 {
  background-image: linear-gradient(432deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-default.radial-bar-100 {
  background-image: linear-gradient(450deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-50 {
  background-image: linear-gradient(270deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-55 {
  background-image: linear-gradient(288deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-60 {
  background-image: linear-gradient(306deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-65 {
  background-image: linear-gradient(324deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-70 {
  background-image: linear-gradient(342deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-75 {
  background-image: linear-gradient(360deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-80 {
  background-image: linear-gradient(378deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-85 {
  background-image: linear-gradient(396deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-90 {
  background-image: linear-gradient(414deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-95 {
  background-image: linear-gradient(432deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-pink.radial-bar-100 {
  background-image: linear-gradient(450deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-50 {
  background-image: linear-gradient(270deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-55 {
  background-image: linear-gradient(288deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-60 {
  background-image: linear-gradient(306deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-65 {
  background-image: linear-gradient(324deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-70 {
  background-image: linear-gradient(342deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-75 {
  background-image: linear-gradient(360deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-80 {
  background-image: linear-gradient(378deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-85 {
  background-image: linear-gradient(396deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-90 {
  background-image: linear-gradient(414deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-95 {
  background-image: linear-gradient(432deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-purple.radial-bar-100 {
  background-image: linear-gradient(450deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-0 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-5 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-10 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-15 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-20 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-25 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-30 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-35 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-40 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-45 {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-50 {
  background-image: linear-gradient(270deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-55 {
  background-image: linear-gradient(288deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-60 {
  background-image: linear-gradient(306deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-65 {
  background-image: linear-gradient(324deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-70 {
  background-image: linear-gradient(342deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-75 {
  background-image: linear-gradient(360deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-80 {
  background-image: linear-gradient(378deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-85 {
  background-image: linear-gradient(396deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-90 {
  background-image: linear-gradient(414deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-95 {
  background-image: linear-gradient(432deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar-inverse.radial-bar-100 {
  background-image: linear-gradient(450deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);
}

.radial-bar.radial-bar-lg {
  width: 100px;
  height: 100px;
  font-size: 20px;
}

.radial-bar.radial-bar-sm {
  width: 50px;
  height: 50px;
  font-size: 12px;
}

.radial-bar.radial-bar-xs {
  width: 30px;
  height: 30px;
  font-size: 8px;
}

.pieLabel div {
  color: #fff !important;
}

.pieLabel div input[type=checkbox] {
  margin: 7px;
}

/**=====================
     41. Chart CSS End
==========================**/
/**=====================
     42. Timeline CSS Start
==========================**/
.cd-container {
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
}

.cd-container::after {
  content: '';
  display: table;
  clear: both;
}

header {
  height: 200px;
  line-height: 200px;
  text-align: center;
  background: #2a3142;
}

header h1 {
  color: #fff;
  font-size: 18px;
}

@media only screen and (min-width: 1170px) {
  header {
    height: 300px;
    line-height: 300px;
  }

  header h1 {
    font-size: 24px;
  }

  #cd-timeline::before {
    left: 50% !important;
    margin-left: -2px;
  }

  .cd-timeline-block {
    margin: 4em 0;
  }

  .cd-timeline-block:first-child {
    margin-top: 0;
  }

  .cd-timeline-block:last-child {
    margin-bottom: 0;
  }

  .cd-timeline-block:nth-child(even) .cd-timeline-content {
    float: right;
  }

  .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {
    left: auto;
    right: 122%;
    text-align: right;
  }

  .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
    top: 24px;
    left: auto;
    right: 100%;
    border-color: transparent;
    border-right-color: #eeeeee;
  }

  .cd-timeline-img {
    width: 60px;
    height: 60px;
    left: 50%;
    margin-left: -30px;
  }

  .cd-timeline-img>i {
    font-size: 18px;
    top: 50%;
    left: 50%;
    padding: 3px;
  }

  .cssanimations .cd-timeline-img.is-hidden {
    visibility: hidden;
  }

  .cssanimations .cd-timeline-img.bounce-in {
    visibility: visible;
    animation: cd-bounce-1 0.6s;
  }

  .cssanimations .cd-timeline-content.is-hidden {
    visibility: hidden;
  }

  .cssanimations .cd-timeline-content.bounce-in {
    visibility: visible;
    animation: cd-bounce-2 0.6s;
  }

  .cssanimations .cd-timeline-block:nth-child(even) .cd-timeline-content.bounce-in {
    animation: cd-bounce-2-inverse 0.6s;
  }

  .cd-timeline-content {
    margin-left: 0;
    padding: 1.6em;
    width: 45%;
  }

  .cd-timeline-content .cd-date {
    position: absolute;
    width: 100%;
    left: 122%;
    top: 6px;
    font-size: 16px;
  }

  .cd-timeline-content::before {
    top: 24px;
    left: 100%;
    border-color: transparent;
    border-left-color: #fff;
  }
}

#cd-timeline {
  position: relative;
  padding: 2em 0;
}

#cd-timeline::before {
  content: '';
  position: absolute;
  top: 0;
  font-size: 1.5rem;
  height: 100%;
  width: 2px;
  background: #eeeeee;
  left: -15px;
}

.cd-timeline-block {
  position: relative;
  margin: 30px 0;
}

.cd-timeline-block:after {
  content: "";
  display: table;
  clear: both;
}

.cd-timeline-block:first-child {
  margin-top: 0;
}

.cd-timeline-block:last-child {
  margin-bottom: 0;
}

.cd-timeline-img {
  width: 60px;
  height: 60px;
  left: 50%;
  margin-left: -30px;
  -webkit-transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  position: absolute;
  top: 0;
  border-radius: 4px;
}

.cd-timeline-img i {
  display: block;
  position: relative;
  left: 45%;
  top: 44%;
  margin-left: -12px;
  margin-top: -12px;
  font-size: 27px;
  color: #fff;
}

@keyframes cd-bounce-1 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }

  60% {
    opacity: 1;
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

.cd-timeline-content {
  position: relative;
  background: #f6f6f6;
  border-radius: 4px;
  padding: 30px;
  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);
}

.cd-timeline-content p {
  padding-top: 9px;
}

.cd-timeline-content h4 {
  margin-bottom: 0;
}

.cd-timeline-content:after {
  content: "";
  display: table;
  clear: both;
}

.cd-timeline-content audio {
  width: 100%;
}

.cd-timeline-content .cd-date {
  font-size: 13px;
  display: inline-block;
  float: left;
  padding: .8em 0 0;
  opacity: .7;
}

.cd-timeline-content::before {
  content: '';
  position: absolute;
  top: 16px;
  right: 100%;
  height: 0;
  width: 0;
  border: 7px solid transparent;
  border-left: 7px solid #eeeeee;
}

@media only screen and (min-width: 768px) {
  .cd-timeline-content .cd-date {
    font-size: 14px;
    padding-bottom: 0;
  }
}

@keyframes cd-bounce-2 {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }

  60% {
    opacity: 1;
    transform: translateX(20px);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes cd-bounce-2-inverse {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }

  60% {
    opacity: 1;
    transform: translateX(-20px);
  }

  100% {
    transform: translateX(0);
  }
}

@media only screen and (max-width: 1169px) {
  .cd-timeline-block .cd-timeline-img {
    left: -2px;
    height: 30px;
    width: 30px;
    margin-left: -30px;
    top: 14px;
    z-index: 8;
  }

  .cd-timeline-block .cd-timeline-img>i {
    font-size: 15px;
    top: 16px;
    left: 17px;
    padding: 3px;
  }

  .landing-main #cd-timeline::before {
    left: -39px;
  }

  .landing-main .cd-timeline-block .cd-timeline-img {
    left: -34px;
    height: 50px;
    width: 50px;
    top: 1px;
    z-index: 8;
  }

  .landing-main .cd-timeline-block .cd-timeline-img>i {
    font-size: 23px;
    top: 21px;
    left: 7px;
    padding: 3px;
  }
}

@media only screen and (max-width: 576px) {
  .cd-timeline-content {
    padding: 15px;
  }

  .cd-timeline-content h4 {
    font-size: 18px;
  }
}

/**=====================
     42. Timeline  CSS Ends
==========================**/
/**=====================
    43. Timeline 2 CSS Start
==========================**/
.timeliny {
  position: relative;
  display: block;
  padding: 10rem 0;
  width: 100%;
  border-top: 1px solid #f6f6f6;
  border-bottom: 1px solid #f6f6f6;
  text-rendering: optimizeLegibility;
  color: #eeeeee;
  opacity: 0;
  overflow: hidden;
  cursor: move;
}

.timeliny.loaded {
  opacity: 1;
}

.timeliny::before {
  content: '';
  position: absolute;
  background-color: #717171;
  width: 100%;
  height: 1px;
  top: 50%;
  left: 0;
}

.timeliny .timeliny-wrapper {
  display: block;
  margin: auto;
  width: 100%;
  max-width: 1024px;
}

.timeliny .timeliny-dot {
  transition: all 0.35s ease-in-out;
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -0.6rem;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  border: 1px solid #717171;
  background-color: #fff;
}

.timeliny .timeliny-dot::before {
  transition: all 0.35s ease-in-out;
  content: attr(data-year);
  display: block;
  position: absolute;
  top: -5rem;
  left: 1.25rem;
  color: #2a3142;
  font-family: Open Sans;
  font-size: 22px;
}

.timeliny .timeliny-dot::after {
  transition: all 0.35s ease-in-out;
  transform: translateY(-50%);
  content: attr(data-text);
  display: block;
  position: absolute;
  width: 256px;
  top: 5.6rem;
  left: 1.25rem;
  color: #eeeeee;
  opacity: 0;
  font-size: 0.9em;
}

@media (min-width: 768px) {
  .timeliny .timeliny-dot::after {
    width: 341.3333333333px;
  }
}

.timeliny .timeliny-timeline {
  position: absolute;
  top: 50%;
  left: 0;
  display: table;
  width: 100%;
  z-index: 5;
}

.timeliny .timeliny-timeline .timeliny-timeblock {
  display: table-cell;
  position: relative;
}

.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot {
  border-color: #ab8ce4;
  background-color: #ab8ce4;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.33);
}

.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {
  color: #2a3142;
}

.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::after {
  color: #2a3142;
  opacity: 1;
  background-color: #ddcef7;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
}

.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot {
  cursor: move;
}

.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot::before {
  color: #eeeeee;
}

.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {
  border-color: #2a3142;
  background-color: #2a3142;
}

.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {
  color: #2a3142;
}

.timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {
  color: #2a3142;
  opacity: 1;
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
}

.timeliny .timeliny-vertical-line {
  position: absolute;
  display: block;
  z-index: 1;
  left: 16%;
  top: 0;
  width: 1px;
  height: 100%;
  background-color: #ab8ce4;
}

@media (min-width: 768px) {
  .timeliny .timeliny-vertical-line {
    left: 32%;
  }
}

.timeliny .timeliny-vertical-line::before {
  content: '';
  position: absolute;
  top: 0;
  left: -7px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #ab8ce4;
}

.timeliny .timeliny-vertical-line::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: -7px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #ab8ce4;
}

/**=====================
     43. Timeline 2 CSS Ends
==========================**/
/**=====================
    44. Tabs CSS Start
==========================**/
.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  background-color: #ab8ce4;
}

.nav i {
  margin-right: 10px;
}

.nav-theme .nav-link,
.nav-pills.nav-theme .nav-link {
  color: #ab8ce4;
}

.nav-theme .nav-link.active,
.nav-theme .show>.nav-link,
.nav-pills.nav-theme .nav-link.active,
.nav-pills.nav-theme .show>.nav-link {
  background-color: #ab8ce4;
  color: #fff;
}

.nav-primary .nav-link,
.nav-pills.nav-primary .nav-link {
  color: #ab8ce4;
}

.nav-primary .nav-link.active,
.nav-primary .show>.nav-link,
.nav-pills.nav-primary .nav-link.active,
.nav-pills.nav-primary .show>.nav-link {
  background-color: #ab8ce4;
  color: #fff;
}

.nav-secondary .nav-link,
.nav-pills.nav-secondary .nav-link {
  color: #26c6da;
}

.nav-secondary .nav-link.active,
.nav-secondary .show>.nav-link,
.nav-pills.nav-secondary .nav-link.active,
.nav-pills.nav-secondary .show>.nav-link {
  background-color: #26c6da;
  color: #fff;
}

.nav-success .nav-link,
.nav-pills.nav-success .nav-link {
  color: #00c292;
}

.nav-success .nav-link.active,
.nav-success .show>.nav-link,
.nav-pills.nav-success .nav-link.active,
.nav-pills.nav-success .show>.nav-link {
  background-color: #00c292;
  color: #fff;
}

.nav-danger .nav-link,
.nav-pills.nav-danger .nav-link {
  color: #FF5370;
}

.nav-danger .nav-link.active,
.nav-danger .show>.nav-link,
.nav-pills.nav-danger .nav-link.active,
.nav-pills.nav-danger .show>.nav-link {
  background-color: #FF5370;
  color: #fff;
}

.nav-info .nav-link,
.nav-pills.nav-info .nav-link {
  color: #4099ff;
}

.nav-info .nav-link.active,
.nav-info .show>.nav-link,
.nav-pills.nav-info .nav-link.active,
.nav-pills.nav-info .show>.nav-link {
  background-color: #4099ff;
  color: #fff;
}

.nav-light .nav-link,
.nav-pills.nav-light .nav-link {
  color: #eeeeee;
}

.nav-light .nav-link.active,
.nav-light .show>.nav-link,
.nav-pills.nav-light .nav-link.active,
.nav-pills.nav-light .show>.nav-link {
  background-color: #eeeeee;
  color: #fff;
}

.nav-dark .nav-link,
.nav-pills.nav-dark .nav-link {
  color: #2a3142;
}

.nav-dark .nav-link.active,
.nav-dark .show>.nav-link,
.nav-pills.nav-dark .nav-link.active,
.nav-pills.nav-dark .show>.nav-link {
  background-color: #2a3142;
  color: #fff;
}

.nav-warning .nav-link,
.nav-pills.nav-warning .nav-link {
  color: #f3d800;
}

.nav-warning .nav-link.active,
.nav-warning .show>.nav-link,
.nav-pills.nav-warning .nav-link.active,
.nav-pills.nav-warning .show>.nav-link {
  background-color: #f3d800;
  color: #fff;
}

.nav-right {
  justify-content: flex-end;
}

.nav-tabs.nav-bottom .nav-item .nav-link.active,
.nav-tabs.nav-bottom .nav-item .nav-link.focus,
.nav-tabs.nav-bottom .nav-item .nav-link.hover {
  border-color: #fff #eeeeee #ddd;
}

.tab-content~.nav-tabs.nav-material {
  margin-bottom: 0;
  margin-top: 30px;
}

.nav-material.nav-tabs {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 30px;
}

.nav-material.nav-tabs .nav-item .nav-link {
  font-size: 16px;
  color: #2a3142;
  text-align: center;
  padding: 10px 25px;
  border: 0;
}

.nav-material.nav-tabs .nav-link.active,
.nav-material.nav-tabs .nav-item.show,
.nav-material.nav-tabs .nav-link:focus,
.nav-material.nav-tabs .nav-link:hover {
  color: #ab8ce4;
}

.nav-material.nav-tabs .material-border {
  border-bottom: 2px solid #ab8ce4;
  transition: all 0.3s ease;
  opacity: 0;
}

.nav-material.nav-tabs .nav-link.active~.material-border {
  transition: all 0.3s ease;
  opacity: 1;
}

.nav-material.nav-left .nav-link {
  border-left: 2px solid transparent;
  transition: all 0.3s ease;
  color: #2a3142;
}

.nav-material.nav-left .nav-link.active,
.nav-material.nav-left .show>.nav-link {
  background-color: transparent;
  border-left-color: #ab8ce4;
  color: #ab8ce4;
  border-radius: 0;
  transition: all 0.3s ease;
}

.nav-material.nav-right .nav-link {
  border-right: 2px solid transparent;
  transition: all 0.3s ease;
  color: #2a3142;
  text-align: right;
}

.nav-material.nav-right .nav-link.active,
.nav-material.nav-right .show>.nav-link {
  background-color: transparent;
  border-right-color: #ab8ce4;
  color: #ab8ce4;
  border-radius: 0;
  transition: all 0.3s ease;
}

.nav-material.nav-theme .nav-link.active,
.nav-material.nav-theme .nav-item.show,
.nav-material.nav-theme .nav-link:focus,
.nav-material.nav-theme .nav-link:hover {
  color: #ab8ce4;
  background-color: transparent;
}

.nav-material.nav-theme .material-border {
  border-bottom: 2px solid #ab8ce4;
}

.nav-material.nav-left.nav-theme .nav-link.active,
.nav-material.nav-left.nav-theme .show>.nav-link {
  border-left-color: #ab8ce4;
  color: #ab8ce4;
}

.nav-material.nav-right.nav-theme .nav-link.active,
.nav-material.nav-right.nav-theme .show>.nav-link {
  border-right-color: #ab8ce4;
  color: #ab8ce4;
}

.nav-material.nav-primary .nav-link.active,
.nav-material.nav-primary .nav-item.show,
.nav-material.nav-primary .nav-link:focus,
.nav-material.nav-primary .nav-link:hover {
  color: #ab8ce4;
  background-color: transparent;
}

.nav-material.nav-primary .material-border {
  border-bottom: 2px solid #ab8ce4;
}

.nav-material.nav-left.nav-primary .nav-link.active,
.nav-material.nav-left.nav-primary .show>.nav-link {
  border-left-color: #ab8ce4;
  color: #ab8ce4;
}

.nav-material.nav-right.nav-primary .nav-link.active,
.nav-material.nav-right.nav-primary .show>.nav-link {
  border-right-color: #ab8ce4;
  color: #ab8ce4;
}

.nav-material.nav-secondary .nav-link.active,
.nav-material.nav-secondary .nav-item.show,
.nav-material.nav-secondary .nav-link:focus,
.nav-material.nav-secondary .nav-link:hover {
  color: #26c6da;
  background-color: transparent;
}

.nav-material.nav-secondary .material-border {
  border-bottom: 2px solid #26c6da;
}

.nav-material.nav-left.nav-secondary .nav-link.active,
.nav-material.nav-left.nav-secondary .show>.nav-link {
  border-left-color: #26c6da;
  color: #26c6da;
}

.nav-material.nav-right.nav-secondary .nav-link.active,
.nav-material.nav-right.nav-secondary .show>.nav-link {
  border-right-color: #26c6da;
  color: #26c6da;
}

.nav-material.nav-success .nav-link.active,
.nav-material.nav-success .nav-item.show,
.nav-material.nav-success .nav-link:focus,
.nav-material.nav-success .nav-link:hover {
  color: #00c292;
  background-color: transparent;
}

.nav-material.nav-success .material-border {
  border-bottom: 2px solid #00c292;
}

.nav-material.nav-left.nav-success .nav-link.active,
.nav-material.nav-left.nav-success .show>.nav-link {
  border-left-color: #00c292;
  color: #00c292;
}

.nav-material.nav-right.nav-success .nav-link.active,
.nav-material.nav-right.nav-success .show>.nav-link {
  border-right-color: #00c292;
  color: #00c292;
}

.nav-material.nav-danger .nav-link.active,
.nav-material.nav-danger .nav-item.show,
.nav-material.nav-danger .nav-link:focus,
.nav-material.nav-danger .nav-link:hover {
  color: #FF5370;
  background-color: transparent;
}

.nav-material.nav-danger .material-border {
  border-bottom: 2px solid #FF5370;
}

.nav-material.nav-left.nav-danger .nav-link.active,
.nav-material.nav-left.nav-danger .show>.nav-link {
  border-left-color: #FF5370;
  color: #FF5370;
}

.nav-material.nav-right.nav-danger .nav-link.active,
.nav-material.nav-right.nav-danger .show>.nav-link {
  border-right-color: #FF5370;
  color: #FF5370;
}

.nav-material.nav-info .nav-link.active,
.nav-material.nav-info .nav-item.show,
.nav-material.nav-info .nav-link:focus,
.nav-material.nav-info .nav-link:hover {
  color: #4099ff;
  background-color: transparent;
}

.nav-material.nav-info .material-border {
  border-bottom: 2px solid #4099ff;
}

.nav-material.nav-left.nav-info .nav-link.active,
.nav-material.nav-left.nav-info .show>.nav-link {
  border-left-color: #4099ff;
  color: #4099ff;
}

.nav-material.nav-right.nav-info .nav-link.active,
.nav-material.nav-right.nav-info .show>.nav-link {
  border-right-color: #4099ff;
  color: #4099ff;
}

.nav-material.nav-light .nav-link.active,
.nav-material.nav-light .nav-item.show,
.nav-material.nav-light .nav-link:focus,
.nav-material.nav-light .nav-link:hover {
  color: #eeeeee;
  background-color: transparent;
}

.nav-material.nav-light .material-border {
  border-bottom: 2px solid #eeeeee;
}

.nav-material.nav-left.nav-light .nav-link.active,
.nav-material.nav-left.nav-light .show>.nav-link {
  border-left-color: #eeeeee;
  color: #eeeeee;
}

.nav-material.nav-right.nav-light .nav-link.active,
.nav-material.nav-right.nav-light .show>.nav-link {
  border-right-color: #eeeeee;
  color: #eeeeee;
}

.nav-material.nav-dark .nav-link.active,
.nav-material.nav-dark .nav-item.show,
.nav-material.nav-dark .nav-link:focus,
.nav-material.nav-dark .nav-link:hover {
  color: #2a3142;
  background-color: transparent;
}

.nav-material.nav-dark .material-border {
  border-bottom: 2px solid #2a3142;
}

.nav-material.nav-left.nav-dark .nav-link.active,
.nav-material.nav-left.nav-dark .show>.nav-link {
  border-left-color: #2a3142;
  color: #2a3142;
}

.nav-material.nav-right.nav-dark .nav-link.active,
.nav-material.nav-right.nav-dark .show>.nav-link {
  border-right-color: #2a3142;
  color: #2a3142;
}

.nav-material.nav-warning .nav-link.active,
.nav-material.nav-warning .nav-item.show,
.nav-material.nav-warning .nav-link:focus,
.nav-material.nav-warning .nav-link:hover {
  color: #f3d800;
  background-color: transparent;
}

.nav-material.nav-warning .material-border {
  border-bottom: 2px solid #f3d800;
}

.nav-material.nav-left.nav-warning .nav-link.active,
.nav-material.nav-left.nav-warning .show>.nav-link {
  border-left-color: #f3d800;
  color: #f3d800;
}

.nav-material.nav-right.nav-warning .nav-link.active,
.nav-material.nav-right.nav-warning .show>.nav-link {
  border-right-color: #f3d800;
  color: #f3d800;
}

.tabbed-card ul {
  position: absolute;
  right: 15px;
  top: 22px;
}

.tabbed-card ul.nav-material.nav-tabs {
  top: 0;
}

.tabbed-card ul.nav-material.nav-tabs .nav-item {
  float: right;
}

.tabbed-card ul.nav-material.nav-tabs .nav-item .nav-link {
  padding: 28px 15px;
}

/**=====================
     44. Tabs CSS Ends
==========================**/
/**=====================
     45. Gallery CSS Start
==========================**/
.gallery {
  margin-bottom: -30px;
}

.gallery>a {
  margin-bottom: 30px;
}

.gallery>a:before {
  content: "\\edee";
  font-family: IcoFont;
  position: absolute;
  height: calc(100% - 10px);
  left: 20px;
  width: calc(100% - 40px);
  background-color: rgba(255, 255, 255, 0.27);
  top: 5px;
  transform: scale(0);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: #000;
}

.gallery>a:hover:before {
  transform: scale(1);
  transition: all 0.3s ease;
}

.gallery>a .img-thumbnail {
  border-radius: 0;
}

.gallery-with-description {
  margin-bottom: -30px;
}

.gallery-with-description a>div {
  padding: 10px;
  border: 1px solid #e4e6ee;
  margin-bottom: 30px;
}

.gallery-with-description a:hover {
  text-decoration: none !important;
}

.gallery-with-description h4 {
  color: #2a3142;
  margin-top: 15px;
  font-size: 18px;
}

.gallery-with-description p {
  color: #b1b1b1;
}

.lg-backdrop {
  background-color: #fff;
}

.lg-outer .lg-actions .lg-next,
.lg-outer .lg-actions .lg-prev {
  background-color: white;
  border: 1px solid #ddd;
}

.lg-outer .lg-actions .lg-next:hover,
.lg-outer .lg-actions .lg-prev:hover {
  color: #2a3142;
}

.lg-outer .lg-toolbar {
  background-color: rgba(255, 255, 255, 0.45);
  border-bottom: 1px solid #2a3142;
}

.lg-outer .lg-toolbar .lg-icon:hover {
  color: #2a3142;
}

.lg-outer #lg-counter {
  color: #2a3142;
}

.lg-outer .lg-sub-html {
  background-color: rgba(255, 255, 255, 0.45);
}

.lg-outer .lg-sub-html h4 {
  font-size: inherit;
  color: #2a3142;
}

.lg-outer .lg-sub-html p {
  color: #2a3142;
}

.lg-outer .lg-thumb-outer {
  background-color: #cccccc;
}

.lg-outer .lg-thumb-item {
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 0;
}

.lg-outer .lg-thumb-item .active,
.lg-outer .lg-thumb-item:hover {
  border-color: #000;
}

.gallery a:before,
.gallery a:after {
  content: none;
}

.gallery .img-hover>div {
  overflow: hidden;
}

.gallery .hover-1 img {
  transform: scale(1);
  transition: .3s ease-in-out;
}

.gallery .hover-1 img:hover {
  transform: scale(1.2);
}

.gallery .hover-2 img {
  width: 100%;
  height: auto;
  transition: .3s ease-in-out;
  transform: translateX(0px);
}

.gallery .hover-2:hover img {
  transform: translateX(40px) scale(1.2);
}

.gallery .hover-3 img {
  transform: scale(1.2);
  transition: .3s ease-in-out;
}

.gallery .hover-3:hover img {
  transform: scale(1);
}

.gallery .hover-4 img {
  transform: scale(1.5);
  transition: .3s ease-in-out;
}

.gallery .hover-4:hover img {
  transform: scale(1);
}

.gallery .hover-5 img {
  margin-left: 30px;
  transform: scale(1.3);
  transition: .3s ease-in-out;
}

.gallery .hover-5:hover img {
  margin-left: 0;
}

.gallery .hover-6 img {
  transform: rotate(15deg) scale(1.4);
  transition: .3s ease-in-out;
}

.gallery .hover-6:hover img {
  transform: rotate(0) scale(1);
}

.gallery .hover-7 img {
  filter: blur(3px);
  transition: .3s ease-in-out;
}

.gallery .hover-7:hover img {
  filter: blur(0);
}

.gallery .hover-8 img {
  filter: grayscale(100%);
  transition: .3s ease-in-out;
}

.gallery .hover-8:hover img {
  filter: grayscale(0);
}

.gallery .hover-9 img {
  filter: sepia(100%);
  transition: .3s ease-in-out;
}

.gallery .hover-9:hover img {
  filter: sepia(0);
}

.gallery .hover-10 img {
  filter: grayscale(0) blur(0);
  transition: .3s ease-in-out;
}

.gallery .hover-10:hover img {
  filter: grayscale(100%) blur(3px);
}

.gallery .hover-11 img {
  opacity: 1;
  transition: .3s ease-in-out;
}

.gallery .hover-11:hover img {
  opacity: .5;
}

.gallery .hover-12>div {
  background: #ab8ce4;
}

.gallery .hover-12>div img {
  opacity: 1;
  transition: .3s ease-in-out;
}

.gallery .hover-12>div:hover img {
  opacity: .7;
}

@keyframes flash {
  0% {
    opacity: .4;
  }

  100% {
    opacity: 1;
  }
}

.gallery .hover-13:hover img {
  opacity: 1;
  animation: flash 1.5s;
}

@keyframes shine {
  100% {
    left: 125%;
  }
}

.gallery .hover-14 div {
  position: relative;
}

.gallery .hover-14 div:before {
  position: absolute;
  top: 0;
  left: -75%;
  z-index: 2;
  display: block;
  content: '';
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);
  transform: skewX(-25deg);
}

.gallery .hover-14 div:hover:before {
  animation: shine .75s;
}

.gallery .hover-15 div {
  position: relative;
}

.gallery .hover-15 div:before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  display: block;
  content: '';
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.gallery .hover-15 div:hover:before {
  animation: circle .75s;
}

@keyframes circle {
  0% {
    opacity: 1;
  }

  40% {
    opacity: 1;
  }

  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}

* {
  box-sizing: border-box;
}

*:after,
*:before {
  box-sizing: border-box;
}

.grid {
  position: relative;
}

/* clear fix */
.grid:after {
  content: '';
  display: block;
  clear: both;
}

/* ---- .grid-item ---- */
.grid-item img {
  max-width: 100%;
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.gallery-with-description .grid-item img {
  border: 0;
  padding: 0;
}

/**=====================
     45. Gallery CSS Ends
==========================**/
/**=====================
    46. Blog CSS start
==========================**/
.blog-box img {
  border-radius: 0.25rem;
}

.blog-box .top-radius-blog {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.blog-box h6 {
  font-weight: 600;
  margin: 15px 0;
}

.blog-box .blog-details {
  padding-right: 20px;
}

.blog-box .blog-details .blog-social {
  margin-top: 30px;
}

.blog-box .blog-details .blog-social li {
  display: inline-block;
  font-size: 12px;
  color: #777777;
}

.blog-box .blog-details .blog-social li+li {
  padding-left: 40px;
  line-height: 1;
  padding-right: 0;
}

.blog-box .blog-details .blog-social li i {
  padding-right: 5px;
}

.blog-box .blog-details .blog-social li:first-child {
  border-right: 1px solid #777777;
  padding-right: 40px;
}

.blog-box .blog-details-main .blog-social {
  margin: 20px 0;
}

.blog-box .blog-details-main .blog-social li {
  display: inline-block;
  font-size: 12px;
  color: #777777;
  padding: 0 24px;
  border-right: 1px solid;
}

.blog-box .blog-details-main .blog-social li:last-child {
  border-right: 0;
}

.blog-box .blog-details-main .blog-social li i {
  padding-right: 5px;
}

.blog-box .blog-details-main .blog-bottom-details {
  margin: 20px;
  font-size: 14px;
  line-height: 1.714;
  font-weight: 700;
}

.blog-box .blog-date {
  color: #777777;
}

.blog-box .blog-date span {
  font-size: 36px;
  font-weight: 500;
  padding-right: 5px;
}

.blog-box.blog-shadow:before {
  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease;
  border-radius: 5px;
  content: "";
  position: absolute;
  height: 100%;
  top: 0;
  width: 100%;
  bottom: 0;
}

.blog-box.blog-shadow:hover:before {
  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.65);
  transition: all 0.3s ease;
}

.blog-box.blog-shadow .blog-details {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 40px;
}

.blog-box.blog-shadow .blog-details h4 {
  color: #fff;
  margin-bottom: 0;
}

.blog-box.blog-shadow .blog-details p {
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
}

.blog-box.blog-shadow .blog-details .blog-social li {
  color: #fff;
}

.blog-list .blog-details .blog-social {
  margin-top: 0;
}

.blog-list .blog-details h6 {
  margin-top: 0;
}

.blog-list .blog-details hr {
  margin-top: 10px;
  margin-bottom: 10px;
}

.blog-list img {
  padding: 17px;
}

.blog-grid img {
  width: 100%;
}

.blog-grid .blog-details {
  padding: 20px;
}

.blog-grid .blog-details h6 {
  font-size: 14px;
  margin-bottom: 0;
  line-height: 1.8;
}

.blog-box {
  position: relative;
  max-height: 100%;
  align-items: center;
}

.blog-box .blog-details p {
  font-size: 14px;
  line-height: 2;
  letter-spacing: 0.7px;
  margin-top: 30px;
  margin-bottom: 0;
  color: #777777;
}

.blog-box .blog-details h4 {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  margin-top: 20px;
  margin-bottom: 0;
}

.blog-box .blog-details .single-blog-content-top {
  margin-top: 30px;
  border-top: 1px solid #ddd;
}

.blog-box .blog-details .blog-social li,
.blog-box .blog-details .comment-social li {
  font-size: 14px;
}

.comment-box {
  padding-top: 60px;
  padding-bottom: 60px;
}

.comment-box hr {
  margin-top: 20px;
  margin-bottom: 30px;
}

.comment-box li {
  margin-bottom: 30px;
}

.comment-box li:last-child {
  margin-bottom: 0;
}

.comment-box ul ul {
  margin-left: 135px;
}

.comment-box p {
  font-size: 14px;
  line-height: 2;
  color: #777777;
  text-align: justify;
  margin-bottom: 0;
}

.comment-box h4 {
  font-weight: 700;
  letter-spacing: 3px;
}

.comment-box .media img {
  margin-right: 45px;
  border-radius: 50%;
  height: 90px;
  padding: 7px;
  width: 90px;
  border: 1px solid #ddd;
}

.comment-box .media h6 {
  font-weight: 600;
  margin-bottom: 20px;
}

.comment-box .media h6 span {
  padding-left: 10px;
  font-size: 13px;
  color: #777777;
  font-weight: 400;
}

.comment-box .comment-social li {
  display: inline-block;
  color: #999999;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 600;
  text-transform: uppercase;
}

.comment-box .comment-social li:first-child {
  border-right: 1px solid #ddd;
  padding-right: 20px;
}

.comment-box .comment-social li i {
  padding-right: 10px;
}

/**=====================
    46. Blog CSS ends
==========================**/
/**=====================
     47. Footer CSS Start
==========================**/
.footer-links {
  text-align: right;
}

.footer-links li {
  display: inline-block;
  padding-right: 15px;
}

.footer-links li a {
  font-size: 12px;
}

footer {
  background-color: #fff;
  border-top: 1px solid #eeeeee;
  padding: 15px;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}

footer a {
  font-weight: 600;
}

footer.footer-starter-kit {
  bottom: -52px;
}

.dark-footer {
  background-color: #36404a;
}

.dark-footer p {
  color: #fff;
}

.dark-footer li a {
  color: #fff;
}

.page-wrapper .page-body-wrapper .footer-fix {
  position: fixed;
  margin-left: 250px;
  transition: all 0.3s ease;
  padding-right: 250px;
  bottom: 0;
}

.page-wrapper .sidebar-close .footer-fix {
  margin-left: 0;
  transition: all 0.3s ease;
}

/**=====================
     47. Footer CSS Ends
==========================**/
/**=====================
     48. Form Wizard CSS Start
==========================**/
/*Form Wizard One Start*/
.form-wizard .tab {
  display: none;
}

.form-wizard .btn-mb {
  margin-bottom: 30px;
}

.form-wizard .step {
  height: 10px;
  width: 10px;
  margin: 0 2px;
  background-color: #ab8ce4;
  border: none;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

.form-wizard .step.active {
  opacity: 1;
}

.form-wizard .step.finish {
  background-color: #26c6da;
}

/*Form Wizard One ends*/
/*Form Wizard Two Start*/
.stepwizard {
  display: table;
  width: 100%;
  position: relative;
  margin-bottom: 30px;
}

.stepwizard .stepwizard-row {
  display: table-row;
}

.stepwizard .stepwizard-row:before {
  top: 16px;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 100%;
  height: 1px;
  background-color: #cccccc;
}

.stepwizard .stepwizard-row .stepwizard-step {
  display: table-cell;
  text-align: center;
  position: relative;
}

.stepwizard .stepwizard-row .stepwizard-step p {
  margin-top: 10px;
}

.stepwizard .stepwizard-row .stepwizard-step button[disabled] {
  opacity: 1 !important;
  filter: alpha(opacity=100) !important;
}

/*Form Wizard Two Ends*/
/*Form Wizard Three Start*/
.f1 fieldset {
  display: none;
}

.f1 .input-error {
  border-color: #FF5370;
}

.f1 .f1-steps {
  overflow: hidden;
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
}

.f1 .f1-steps .f1-progress {
  position: absolute;
  top: 24px;
  width: 100%;
  height: 1px;
  background: #717171;
}

.f1 .f1-steps .f1-progress .f1-progress-line {
  height: 1px;
  background: #ab8ce4;
  width: 16%;
}

.f1 .f1-steps .f1-step {
  position: relative;
  float: left;
  width: 33.333333%;
  text-align: center;
}

.f1 .f1-steps .f1-step.activated .f1-step-icon {
  background: #fff;
  border: 1px solid #ab8ce4;
  color: #ab8ce4;
  line-height: 38px;
}

.f1 .f1-steps .f1-step.activated p {
  color: #ab8ce4;
}

.f1 .f1-steps .f1-step.active .f1-step-icon {
  width: 48px;
  height: 48px;
  background: #ab8ce4;
  font-size: 22px;
  line-height: 48px;
}

.f1 .f1-steps .f1-step.active p {
  color: #ab8ce4;
}

.f1 .f1-steps .f1-step p {
  color: #717171;
}

.f1 .f1-steps .f1-step .f1-step-icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: #717171;
  font-size: 16px;
  color: #fff;
  line-height: 40px;
  border-radius: 50%;
}

.f1 .f1-buttons {
  text-align: right;
}

/*Form Wizard Three ends*/
/*Form Wizard Four Start*/
.wizard-4 .buttonDisabled {
  color: #2a3142;
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
  cursor: text;
}

.wizard-4 .action-bar .btn {
  float: right;
  margin: 0 5px;
}

.wizard-4 .step-container {
  position: relative;
  margin: 0;
  padding: 0;
  border: 0 solid #cccccc;
  overflow: hidden;
  clear: right;
  width: 70%;
  box-sizing: border-box;
}

.wizard-4 .step-container div.content {
  display: block;
  position: absolute;
  float: left;
  height: 295px;
  text-align: left;
  overflow: auto;
  z-index: 1;
  width: 100%;
  box-sizing: border-box;
  clear: both;
}

.wizard-4 .loader {
  display: none;
}

.wizard-4 .msg-box {
  position: absolute;
  display: none;
  padding: 5px 10px;
  background-color: #ab8ce4;
  left: 32%;
  bottom: 30px;
  border-radius: 2px;
}

.wizard-4 .msg-box .content {
  padding: 0;
  float: left;
  padding-top: 3px;
  color: #fff;
}

.wizard-4 .msg-box .close {
  text-shadow: none;
  color: #fff;
  margin-left: 10px;
  opacity: 1;
}

.wizard-4 ul.anchor {
  position: relative;
  display: block;
  float: left;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 0 solid #cccccc;
  background: transparent;
  width: 30%;
  box-sizing: border-box;
  padding-right: 30px;
}

.wizard-4 ul.anchor li {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  padding-bottom: 19px;
  float: left;
  clear: both;
  width: 100%;
  box-sizing: border-box;
  z-index: 0;
}

.wizard-4 ul.anchor li a {
  display: block;
  position: relative;
  float: left;
  margin: 0;
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;
  outline-style: none;
  z-index: 1;
  font-size: 18px;
}

.wizard-4 ul.anchor li a small {
  display: block;
  font-size: 14px;
}

.wizard-4 ul.anchor li a .stepNumber {
  position: relative;
  float: left;
  width: 30px;
  text-align: center;
  padding: 5px;
  padding-top: 0;
}

.wizard-4 ul.anchor li a.selected {
  color: #fff;
  background: #ab8ce4;
  cursor: text;
  border-radius: 5px;
}

.wizard-4 ul.anchor li a.done {
  position: relative;
  color: #fff;
  background: #26c6da;
  z-index: 99;
  border-radius: 5px;
}

.wizard-4 ul.anchor li a.disabled {
  color: #717171;
  background: #eeeeee;
  cursor: text;
  border-radius: 5px;
}

.wizard-4 ul.anchor li a.error {
  color: #717171;
  background: #fe8a7d;
  border: 1px solid #FF5370;
}

.wizard-4 ul.anchor li a.error:hover {
  color: #000;
}

/*Form Wizard Four Ends*/
/**=====================
    48. Form Wizard CSS Ends
==========================**/
/**=====================
    49. Badge CSS start
==========================**/
.badge {
  padding: 0.44em 0.7em;
}

/**=====================
    49. Badge CSS Ends
==========================**/
/**=====================
     50. Tree  CSS Start
==========================**/
.jstree-default .jstree-clicked {
  background-color: white;
  box-shadow: none;
  color: #2a3142;
}

.vakata-context,
.vakata-context ul {
  background-color: #fff;
  border: none;
  box-shadow: 0 0 2px 2px #ddd;
}

.vakata-context li a .vakata-contextmenu-sep,
.vakata-context ul li a .vakata-contextmenu-sep {
  display: none;
}

.vakata-context li a:hover,
.vakata-context ul li a:hover {
  background-color: white;
  box-shadow: None;
}

.vakata-context .vakata-context-separator,
.vakata-context ul .vakata-context-separator {
  display: none;
}

/**=====================
     50. Tree CSS Ends
==========================**/
/**=====================
     51. Search CSS Start
==========================**/
.search-page .search-form input {
  background-position: 99%;
}

.search-page .nav-link {
  font-weight: 500;
  text-transform: uppercase;
}

.search-page .info-block+.info-block {
  padding-top: 30px;
  border-top: 1px solid #eeeeee;
  margin-top: 30px;
}

.search-page .nav-material.nav-tabs {
  align-items: left;
  justify-content: end;
}

.search-page .nav-material.nav-tabs .nav-item {
  width: auto;
}

.search-page .search-links h6 {
  margin-bottom: 0;
}

.search-page p {
  text-transform: lowercase;
  margin-bottom: 0;
  color: #999999;
}

.search-page ul.search-info li {
  display: inline-block;
  font-size: 12px;
  line-height: 1;
  font-family: Open Sans;
  color: #cccccc;
}

.search-page ul.search-info li+li {
  border-left: 1px solid #a5afc6;
  padding-left: 8px;
  margin-left: 8px;
}

.search-page ul.search-info li i {
  color: #f3d800;
}

.search-page #video-links .embed-responsive+.embed-responsive {
  margin-top: 30px;
}

/**=====================
    51. Search CSS Ends
==========================**/
/**=====================
    52. Datepicker CSS Start
==========================**/
.datepicker--day-name {
  color: #000;
  font-weight: bold;
}

.datepicker--cell.-current- {
  color: #000;
  border-radius: 5px;
  font-weight: bold;
  border: 2px solid #ab8ce4;
}

.datepicker--cell.-focus- {
  background: #ab8ce4;
  color: #fff;
}

.datepicker--cell.-selected- {
  background: #ab8ce4;
}

.daterangepicker.ltr {
  color: #717171;
  z-index: 8;
}

.daterangepicker.ltr tr {
  font-size: 13px;
}

.daterangepicker.ltr tr td {
  height: 34px;
  width: 34px;
}

.daterangepicker.ltr tr td.in-range {
  background-color: #fafafa;
}

.daterangepicker.ltr tr td.active {
  background-color: #ab8ce4;
}

.daterangepicker.ltr .ranges {
  float: none;
}

.daterangepicker.ltr .ranges li {
  color: #ab8ce4;
}

.daterangepicker.ltr .ranges li:hover {
  background-color: #ab8ce4;
  border: 1px solid #ab8ce4;
  color: #fff;
}

.daterangepicker.ltr .ranges li.active {
  background-color: #ab8ce4;
  border: 1px solid #ab8ce4;
  color: #fff;
}

.daterangepicker.ltr .calendar-time select {
  color: #717171;
}

.datetime-picker .bootstrap-datetimepicker-widget.dropdown-menu {
  width: auto;
}

.date-range-picker .theme-form {
  margin-bottom: 30px;
}

.date-range-picker>div:last-child .theme-form {
  margin-bottom: 0px;
}

.daterangepicker:before {
  border-bottom: 7px solid #ddd;
}

.daterangepicker .daterangepicker_input i {
  font-size: 14px;
  color: #aaaaaa;
}

.daterangepicker .input-mini {
  border-color: #ddd !important;
  font-size: 14px;
  color: #aaaaaa;
}

.daterangepicker th,
.daterangepicker td {
  height: 34px;
  width: 34px;
}

.daterangepicker th:hover,
.daterangepicker td:hover {
  color: #2a3142;
}

.daterangepicker th.prev,
.daterangepicker th.next,
.daterangepicker td.prev,
.daterangepicker td.next {
  color: #fff;
  height: 34px;
  width: 34px;
  background-color: #ab8ce4;
}

.daterangepicker th.month,
.daterangepicker td.month {
  color: #ab8ce4;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/**=====================
   52. Datepicker CSS End
==========================**/
/**=====================
    53. Dashboard CSS Start
==========================**/
.chart-sparkline {
  background-color: rgba(0, 0, 0, 0.8);
}

.top-sale-chart canvas {
  min-width: 100%;
}

.border-widgets>.row>div+div {
  border-left: 1px solid #ddd;
}

.crm-top-widget {
  text-align: center;
}

.crm-top-widget .media {
  display: inline-flex;
}

.crm-top-widget .media i {
  font-size: 40px;
}

.crm-top-widget .media .media-body {
  text-align: left;
}

.crm-top-widget .media .media-body span {
  margin-bottom: 0;
  color: #777777;
}

.crm-top-widget .media .media-body h4 {
  font-family: Open Sans;
  font-weight: 600;
  color: #333333;
}

@keyframes animate {
  from {
    background-position: 0 0;
  }

  to {
    background-position: 500px 0;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.whether-widget .whether-widget-top {
  background-color: #ab8ce4;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  animation: animate 10s linear 0s normal none infinite;
  background-size: cover;
}

.whether-widget .whether-widget-top .details {
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 20px;
}

.whether-widget .whether-widget-top .details h4 {
  font-family: Open Sans;
  color: #fff;
  text-shadow: 1px 1px 1px #000000ab;
  font-weight: 600;
  margin-top: 5px;
}

.whether-widget .whether-widget-top span {
  color: #fff;
  margin-bottom: 0;
  text-shadow: 1px 1px 1px #000000ab;
  padding-top: 20px;
}

.whether-widget .whether-widget-top .block_whether_bottom {
  display: block;
}

.whether-widget .whether-widget-top img {
  height: 158px;
  animation: rotate 10s linear 0s normal none infinite;
}

.whether-widget .whether-widget-bottom .row div .media {
  padding-top: 30px;
}

.whether-widget .whether-widget-bottom h5 {
  font-family: Open Sans;
  font-weight: 600;
}

.whether-widget .whether-widget-bottom h5 span {
  color: #000;
}

.whether-widget .whether-widget-bottom span {
  margin-bottom: 0;
  color: #777777;
}

.crm-activity>li+li {
  border-top: 1px solid #ddd;
  margin-top: 15px;
  padding-top: 15px;
}

.crm-activity>li+li h6 {
  font-size: 14px;
}

.crm-activity>li h6 {
  font-size: 14px;
}

.crm-activity span {
  font-size: 40px;
}

.crm-activity ul.dates h6 {
  color: #333333;
}

.crm-activity ul.dates li {
  color: #777777;
  font-size: 12px;
  display: inline-block;
  line-height: 1;
}

.crm-activity ul.dates li+li {
  border-left: 1px solid #ddd;
  padding-left: 10px;
  margin-left: 5px;
}

.combo-chart {
  height: 380px;
}

.total-chart {
  height: 300px;
}

.crm-overall {
  margin: 0 -30px -30px;
  background-color: #ab8ce4;
  border-radius: 0 0 5px 5px;
}

.crm-overall div {
  padding: 12px;
}

.crm-numbers {
  padding-bottom: 30px;
}

.crm-numbers .col {
  text-align: center;
}

.crm-numbers .col>span {
  color: #777777;
}

.crm-numbers .col h4 {
  font-family: Open Sans;
  padding-top: 7px;
  font-weight: 600;
  margin-bottom: 0;
}
.crm-numbers .col h6 {
  font-family: Open Sans;
  font-weight: 600;
  margin-bottom: 0;
}

.crm-numbers .col+.col {
  border-left: 1px solid #ddd;
}

.dashboard-card {
  padding-top: 17px;
}

.ecommerce-widget .total-num {
  font-family: Open Sans;
  font-weight: 600;
  color: #333333;
  margin: 0;
  letter-spacing: 1px;
}

.ecommerce-widget .total-num span {
  color: #000;
}

.ecommerce-widget .row {
  align-items: center;
}

.ecommerce-widget .progress-showcase {
  margin-top: 30px;
}

.ecommerce-widget span {
  color: #777777;
  margin: 0;
}

.ecommerce-widget .icon {
  color: #ddd;
  font-size: 40px;
}

.ecommerce-widget .product-stts {
  font-family: Open Sans;
}

.ecommerce-widget .flot-chart-container {
  height: 100px;
  padding: 0;
  margin: 0;
  border: transparent;
}

.ecommerce-widget .morris-default-style {
  display: none !important;
}

.ecommerce-widget svg {
  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));
}

.flot-chart-container-small {
  text-align: center;
  height: 280px;
  background-color: #fff;
  border-top: 1px solid #eeeeee;
}

.flot-chart-container-small svg {
  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.1));
  margin: 0 auto;
}

.customer-review .media {
  margin-bottom: 30px;
}

.customer-review .media img {
  margin-right: 25px;
}

.customer-review .media-body .cust-name {
  margin-right: 10px;
  text-transform: uppercase;
  color: #333333;
  font-weight: 600;
}

.customer-review .media-body .cust-des {
  color: #777777;
}

.yearly-chart {
  text-align: center;
}

.yearly-chart svg {
  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.1));
  margin: 0 auto;
}

.yearly-chart .flot-chart-container {
  border: none;
  margin: 0 auto;
}

.static-top-widget:hover .icon-bg {
  transform: rotate(-5deg) scale(1.1);
  transition: all 0.3s ease;
}

.static-top-widget div.align-self-center {
  font-size: 40px;
}

.static-top-widget .media-body {
  align-self: center !important;
  padding-left: 30px;
}

.static-top-widget .media-body h4 {
  font-family: Open Sans;
}

.static-top-widget .media-body .icon-bg {
  position: absolute;
  right: -20px;
  font-size: 140px;
  top: 0;
  opacity: 0.2;
  transition: all 0.3s ease;
}

.bg-info .media.static-top-widget .align-self-center {
  background-color: #4099ff;
}

.bg-primary .media.static-top-widget .align-self-center {
  background-color: #ab8ce4;
}

.bg-secondary .media.static-top-widget .align-self-center {
  background-color: #26c6da;
}

.bg-danger .media.static-top-widget .align-self-center {
  background-color: #FF5370;
}

.widget-joins:before {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  background-color: #ddd;
  left: calc(50% - 1px);
}

.widget-joins:after {
  content: "";
  position: absolute;
  height: 1px;
  width: 100%;
  background-color: #ddd;
  left: 0;
  top: 50%;
}

.widget-joins .media {
  padding: 30px;
  text-align: center;
  align-items: center;
}

.widget-joins .media .details {
  border-left: 1px solid #ddd;
  padding: 1px 0;
}

.widget-joins .media .media-body {
  text-align: left;
}

.widget-joins .media .media-body span {
  font-family: Open Sans;
}

.widget-joins .media .media-body>span {
  color: #777777;
}

.widget-joins .media .media-body i {
  font-size: 40px;
}

.widget-joins .media .media-body h6 {
  font-family: Open Sans;
  font-weight: 600;
}

.widget-joins .media .media-body h6 span {
  color: #000;
}

.redial-social-widget {
  border-radius: 100%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  margin: 0 auto;
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(90deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget i {
  background-color: #fff;
  height: 80px;
  width: 80px;
  border-radius: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.redial-social-widget.radial-bar-5 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(108deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-10 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(126deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-15 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(144deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-20 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(162deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-25 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(180deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-30 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(198deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-35 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(216deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-40 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(234deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-45 {
  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(252deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-50 {
  background-image: linear-gradient(270deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-55 {
  background-image: linear-gradient(288deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-60 {
  background-image: linear-gradient(306deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-65 {
  background-image: linear-gradient(324deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-70 {
  background-image: linear-gradient(342deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-75 {
  background-image: linear-gradient(360deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-80 {
  background-image: linear-gradient(378deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-85 {
  background-image: linear-gradient(396deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-90 {
  background-image: linear-gradient(414deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-95 {
  background-image: linear-gradient(432deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.redial-social-widget.radial-bar-100 {
  background-image: linear-gradient(450deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);
}

.social-widget .radial-bar {
  margin-top: 0;
  margin-bottom: 0;
}

.social-widget-card span {
  color: #777777;
  text-transform: uppercase;
  margin-bottom: 0;
}

.social-widget-card h4 {
  font-family: Open Sans;
  color: #333333;
}

.social-widget-card h5 {
  color: #777777;
  text-transform: uppercase;
  text-align: center;
  padding: 30px 0;
  font-weight: 600;
  margin-bottom: 30px;
}

.browser-widget:hover img {
  filter: grayscale(0%);
  transition: all 0.3s ease;
  transform: scale(1.1) rotate(5deg);
}

.browser-widget img {
  height: 80px;
  filter: grayscale(100%);
  transform: scale(1) rotate(0deg);
  transition: all 0.3s ease;
}

.browser-widget .media-body {
  text-align: center;
  column-count: 3;
  column-rule: 1px solid #eeeeee;
}

.browser-widget .media-body span {
  margin-bottom: 0;
  color: #777777;
}

.browser-widget .media-body h4 {
  font-family: Open Sans;
  color: #333333;
  margin-bottom: 0;
}

.browser-widget .media-body h4 span {
  color: #333333;
}

.testimonial i {
  font-size: 60px;
  color: #eeeeee;
}

.testimonial p {
  color: #777777;
  font-style: italic;
  margin-bottom: 30px;
  margin-top: 30px;
}

.testimonial h5 {
  color: #333333;
  padding-top: 10px;
}

.testimonial span {
  color: #777777;
}

.testimonial img {
  margin: 0 auto;
}

.stat-widget-dashboard h4 {
  font-family: Open Sans;
  font-weight: 600;
}

.stat-widget-dashboard span {
  color: #333333;
  text-transform: capitalize;
}

.stat-widget-dashboard .media {
  width: 100%;
  margin-bottom: 15px;
}

.stat-widget-dashboard .media i {
  font-size: 50px;
}

.stat-widget-dashboard .media img {
  width: 35px;
}

.social-media-counter .font-primary {
  color: rgba(188, 160, 238, 0.8) !important;
}

.social-media-counter .font-secondary {
  color: rgba(56, 211, 231, 0.8) !important;
}

.social-media-counter .font-success {
  color: rgba(0, 194, 146, 0.8) !important;
}

.social-media-counter .counter {
  font-family: Open Sans, sans-serif;
}

.social-media-counter h4 {
  font-weight: 600;
  margin-bottom: 0;
}

.social-media-counter i {
  font-size: 50px;
  display: inline-block;
}

.testimonial-default .slide--item p {
  font-weight: 500;
  font-size: 15px;
  margin-bottom: 0;
}

.testimonial-default .slide--item .media {
  padding-top: 30px;
}

.default-widget-count .left {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  position: relative;
  text-align: center;
}

.default-widget-count .left .bg {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0.6;
  border-radius: 100%;
  z-index: 0;
}

.default-widget-count .left i {
  font-size: 35px;
  color: #fff;
  text-shadow: 1px 1px 1px #aaaaaa;
  position: relative;
  line-height: 2.2;
}

.default-widget-count .icon-bg {
  font-size: 60px;
  color: #eeeeee;
  position: absolute;
  top: 30px;
  right: 15px;
}

.default-widget-count h4 {
  margin-bottom: 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #333333;
}

.default-widget-count span {
  color: #777777;
  margin-bottom: 0;
}

.default-dashboard-main-chart {
  height: 313px;
}

.mobile-clock-widget .sec,
.min,
.hour {
  position: absolute;
  width: 24px;
  height: 234px;
  top: 0;
  left: 102px;
  margin-top: -30px;
  margin-left: -25px;
}

.cal-date-widget .datepicker {
  padding: 20px;
}

.cal-date-widget .cal-info h2 {
  font-size: 100px;
  font-family: Open Sans;
  color: #cccccc;
}

.cal-date-widget .cal-datepicker .datepicker--nav {
  font-family: Open Sans;
}

.weather-widget-two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  height: 380px;
  border-radius: 4px;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.weather-widget-two svg path.climacon_component-stroke {
  fill: #fff;
}

.weather-widget-two .num {
  font-family: Open Sans;
  font-weight: 600;
}

.weather-widget-two .climacon_component-stroke {
  stroke: #fff;
}

.weather-widget-two .bottom-whetherinfo i {
  font-size: 151px;
  opacity: 0.1;
  color: #fff;
  position: relative;
  top: 0;
  left: -35px;
}

.weather-widget-two .bottom-whetherinfo .whether-content {
  text-align: right;
  position: relative;
  top: 1px;
  color: #fff;
}

.mobile-clock-widget {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 380px;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-clock-widget .clock {
  padding: 0;
  position: relative;
  list-style: none;
  margin: 0 auto;
  height: 175px;
  width: 175px;
  display: block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) 5% center no-repeat;
}

.mobile-clock-widget .date {
  font-family: Open Sans;
}

.mobile-clock-widget .sec {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  z-index: 3;
}

.mobile-clock-widget .min {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  z-index: 2;
}

.mobile-clock-widget .hour {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  z-index: 1;
}

.business-top-widget {
  text-align: center;
}

.business-top-widget .media {
  align-items: center;
}

.business-top-widget .media .media-body {
  margin-right: 40px;
}

.business-top-widget .media .total-value {
  font-weight: 700;
  font-family: Open Sans;
  text-align: left;
}

.business-top-widget .media span {
  color: #777777;
  text-align: left;
}

.business-top-widget .media i {
  font-size: 70px;
}

.business-card {
  padding-left: 0 !important;
}

.business-card .logo {
  width: 115px;
}

.business-card table {
  margin-left: 35px;
}

.business-card table tr {
  line-height: 2.245;
}

.business-card table th {
  vertical-align: text-top;
  text-align: right;
  padding-right: 15px;
  color: #333333;
  font-weight: 500;
}

.business-card table td {
  color: #777777;
}

.social-widget .social-icons {
  height: 60px;
  width: 60px;
  background-color: #fff;
  border-radius: 100%;
  margin-top: 10px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 25px;
}

.social-widget .media .social-sub-title {
  color: #777777;
  text-transform: uppercase;
}

.social-widget .total-value {
  font-weight: 600;
  font-family: Open Sans;
  color: #333333;
}

.social-widget .radial-bar:after {
  display: none;
}

.business-chart-widget {
  border-radius: 0.25rem;
  overflow: hidden;
}

.business-chart-widget .total-num {
  font-family: Open Sans;
  font-weight: bold;
  color: #fff;
  margin: 0;
  letter-spacing: 1px;
}

.business-chart-widget span {
  color: #eeeeee;
  margin: 0;
}

.business-chart-widget .icon {
  color: #fff;
  font-size: 60px;
  line-height: 1;
}

.business-chart-widget .icon-bg {
  position: absolute;
  right: -50px;
  font-size: 140px;
  top: -75px;
  opacity: 0.1;
  transition: all 0.3s ease;
  overflow: hidden;
  z-index: 0;
  color: #fff;
}

.business-chart-widget .icon-bg:hover {
  transform: rotate(-5deg);
  transition: all 0.3s ease;
}

.business-chart-widget canvas {
  width: 100% !important;
}

.business-chart-widget .flot-chart-container {
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  padding: 0;
  margin: 20px 0 0;
  border: none;
}

.flot-chart-container {
  height: 472px;
}

.review-box .customer-name {
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.review-box .testimonial {
  margin-top: 12px;
}

.review-box .testimonial .content {
  padding: 30px;
  border: 1px solid #eeeeee;
  position: relative;
  border-radius: 4px;
}

.review-box .testimonial .content:before {
  content: "";
  border-bottom: 10px solid #eeeeee;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: absolute;
  top: -10px;
  left: 40px;
}

.review-box .testimonial .content:after {
  content: "";
  border-bottom: 9px solid #fff;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  position: absolute;
  top: -8px;
  left: 40px;
}

.review-box .testimonial .description {
  letter-spacing: 1px;
  margin: 0;
}

.calender-widget .cal-img {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: cover;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  height: 300px;
}

.calender-widget .cal-date {
  font-family: Open Sans;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  text-align: center;
  background-color: #fff;
  border-radius: 50%;
  margin-top: -45px;
  border: 1px solid #cccccc;
}

.calender-widget .cal-date h5 {
  margin-bottom: 0;
  line-height: 1.5;
  padding: 17px;
  font-weight: 600;
}

.calender-widget .cal-desc h6 {
  padding-bottom: 6px;
}

.calender-widget .cal-desc span {
  line-height: 1.6;
}

.contact-form .theme-form {
  border: 1px solid #eeeeee;
  padding: 30px;
  border-radius: 4px;
}

.contact-form .theme-form .form-icon {
  width: 53px;
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 100%;
  font-size: 21px;
  background-color: #fff;
  color: #717171;
  margin-top: -55px;
  margin-bottom: 15px;
}

.contact-form .theme-form .form-group {
  margin-bottom: 10px;
}

.contact-form .theme-form .form-group label {
  font-weight: 600;
}

.contact-form .btn {
  padding: 10px 30px;
}

.support-ticket .bg-primary {
  background-color: rgba(171, 140, 228, 0.6) !important;
}

.support-ticket .bg-secondary {
  background-color: rgba(38, 198, 218, 0.6) !important;
}

.support-ticket .bg-success {
  background-color: rgba(0, 194, 146, 0.6) !important;
}

.support-ticket .left {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  font-weight: 600;
}

.support-ticket table tr td:nth-child(2) {
  width: 15%;
}

.support-ticket table tr+tr {
  border-top: 1px solid #eeeeee;
}

.support-ticket table .w-23 {
  width: 23%;
}

.support-ticket table td {
  vertical-align: middle;
}

.support-ticket table td span {
  text-transform: uppercase;
  color: #333333;
  font-weight: 600;
  padding-top: 10px;
}

.support-ticket table td h6 {
  color: #777777;
  font-size: 12px;
  font-family: "\$font-open-sans", sans-serif;
  text-transform: capitalize;
  margin-bottom: 0;
}

.support-ticket table td p {
  color: #777777;
  margin-bottom: 0;
}

.chart-widget-top {
  border-radius: 4px;
}

.chart-widget-top .num {
  font-family: Open Sans;
}

.chart-widget-top .total-value {
  letter-spacing: 2px;
  font-weight: 600;
}

.bar-chart-widget .top-content {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.bar-chart-widget .earning-details {
  height: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
  display: flex;
  letter-spacing: 1px;
}

.bar-chart-widget .earning-details i {
  font-size: 230px;
  position: absolute;
  opacity: 0.1;
  right: -30px;
  top: 0;
}

.bar-chart-widget .earning-details i:hover {
  transform: rotate(-5deg) scale(1.1);
  transition: all 0.3s ease;
}

.bar-chart-widget .num {
  font-family: Open Sans;
  font-weight: 600;
}

.bar-chart-widget .num .color-bottom {
  color: #000;
}

.bottom-content span {
  color: #777777;
}

.bottom-content .block-bottom {
  display: block;
}

.user-status table tbody tr td {
  vertical-align: middle;
}

.user-status table tbody tr td .d-inline-block {
  margin-top: 11px;
}

.user-status table tbody tr td .image-sm-size img {
  width: 41px;
}

.user-status table tbody tr:last-child td {
  padding-bottom: 0;
}

.user-status table thead tr th {
  border-top: 0;
  font-size: 16px;
  color: #2a3142;
  font-weight: 600;
  padding-top: 0;
}

.height-scroll {
  max-height: 296px;
  overflow-y: auto;
}

@keyframes am-moving-dashes {
  100% {
    stroke-dashoffset: -30px;
  }
}

@keyframes am-pulsating {
  0% {
    stroke-opacity: 1;
    stroke-width: 0;
  }

  100% {
    stroke-opacity: 0;
    stroke-width: 50px;
  }
}

@keyframes am-draw {
  0% {
    stroke-dashoffset: 500%;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

.serial-chart .chart-container {
  width: 100%;
  height: 500px;
}

.serial-chart .chart-container .lastBullet {
  animation: am-pulsating 1s ease-out infinite;
}

.serial-chart .chart-container .amcharts-graph-column-front {
  transition: all .3s .3s ease-out;
}

.serial-chart .chart-container .amcharts-graph-column-front:hover {
  fill: #26c6da;
  stroke: #26c6da;
  transition: all .3s ease-out;
}

.serial-chart .chart-container .amcharts-graph-g3 {
  stroke-linejoin: round;
  stroke-linecap: round;
  stroke-dasharray: 0;
  stroke-dashoffset: 0;
  animation: am-draw 40s;
}

.serial-chart .chart-container .amcharts-graph-g2 .amcharts-graph-stroke {
  stroke-dasharray: 3px 3px;
  stroke-linejoin: round;
  stroke-linecap: round;
  animation: am-moving-dashes 1s linear infinite;
}

.speed-chart .chart-container {
  width: 100%;
  height: 530px;
}

.speed-chart .content {
  margin-top: -200px;
  margin-bottom: 20px;
}

.speed-chart .content h4 {
  font-family: Open Sans;
  font-weight: 600;
  padding-top: 2px;
}

.status-widget .status-chart {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.small-chart-widget .chart-container {
  height: 300px;
  padding: 0;
  margin: 0;
  border: none;
}

.donut-chart-widget .chart-container {
  height: 300px;
  border: 0;
  margin: 0;
  padding: 0;
}

.status-details h4 {
  font-family: Open Sans;
  font-weight: 600;
}

.status-details h4 span {
  color: inherit;
}

.status-details span {
  color: #777777;
}

.status-chart .chart-container {
  height: 200px;
  border: 0;
  padding: 0;
  margin: 0;
}

.map-chart .chart-container {
  width: 100%;
  height: 500px;
}

.serial-chart {
  width: 100%;
}

.yearly-chart .ct-series-a .ct-point,
.yearly-chart .ct-series-a .ct-line,
.yearly-chart .ct-series-a .ct-bar,
.yearly-chart .ct-series-a .ct-slice-donut {
  stroke: #4099ff;
}

.yearly-chart .ct-series-b .ct-point,
.yearly-chart .ct-series-b .ct-line,
.yearly-chart .ct-series-b .ct-bar,
.yearly-chart .ct-series-b .ct-slice-donut {
  stroke: #FF5370;
}

.yearly-chart .ct-series-c .ct-point,
.yearly-chart .ct-series-c .ct-line,
.yearly-chart .ct-series-c .ct-bar,
.yearly-chart .ct-series-c .ct-slice-donut {
  stroke: #ab8ce4;
}

.yearly-chart .ct-series-d .ct-point,
.yearly-chart .ct-series-d .ct-line,
.yearly-chart .ct-series-d .ct-bar,
.yearly-chart .ct-series-d .ct-slice-donut {
  stroke: #26c6da;
}

.live-products,
.turnover,
.uses,
.monthly {
  height: 300px;
}

.live-products .ct-series-a .ct-area,
.live-products .ct-series-a .ct-point,
.live-products .ct-series-a .ct-line,
.live-products .ct-series-a .ct-bar,
.live-products .ct-series-a .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.77);
}

.live-products .ct-label {
  fill: #fff;
  color: #fff;
}

.live-products .ct-grid {
  stroke: rgba(255, 255, 255, 0.7);
}

.turnover .ct-series-a .ct-area,
.turnover .ct-series-a .ct-point,
.turnover .ct-series-a .ct-line,
.turnover .ct-series-a .ct-bar,
.turnover .ct-series-a .ct-slice-donut,
.uses .ct-series-a .ct-area,
.uses .ct-series-a .ct-point,
.uses .ct-series-a .ct-line,
.uses .ct-series-a .ct-bar,
.uses .ct-series-a .ct-slice-donut,
.monthly .ct-series-a .ct-area,
.monthly .ct-series-a .ct-point,
.monthly .ct-series-a .ct-line,
.monthly .ct-series-a .ct-bar,
.monthly .ct-series-a .ct-slice-donut {
  stroke: white;
  fill: transparent;
}

.turnover .ct-series-b .ct-area,
.turnover .ct-series-b .ct-point,
.turnover .ct-series-b .ct-line,
.turnover .ct-series-b .ct-bar,
.turnover .ct-series-b .ct-slice-donut,
.uses .ct-series-b .ct-area,
.uses .ct-series-b .ct-point,
.uses .ct-series-b .ct-line,
.uses .ct-series-b .ct-bar,
.uses .ct-series-b .ct-slice-donut,
.monthly .ct-series-b .ct-area,
.monthly .ct-series-b .ct-point,
.monthly .ct-series-b .ct-line,
.monthly .ct-series-b .ct-bar,
.monthly .ct-series-b .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.7);
  fill: transparent;
}

.turnover .ct-series-c .ct-area,
.turnover .ct-series-c .ct-point,
.turnover .ct-series-c .ct-line,
.turnover .ct-series-c .ct-bar,
.turnover .ct-series-c .ct-slice-donut,
.uses .ct-series-c .ct-area,
.uses .ct-series-c .ct-point,
.uses .ct-series-c .ct-line,
.uses .ct-series-c .ct-bar,
.uses .ct-series-c .ct-slice-donut,
.monthly .ct-series-c .ct-area,
.monthly .ct-series-c .ct-point,
.monthly .ct-series-c .ct-line,
.monthly .ct-series-c .ct-bar,
.monthly .ct-series-c .ct-slice-donut {
  stroke: rgba(255, 255, 255, 0.4);
  fill: transparent;
}

.turnover .ct-label,
.uses .ct-label,
.monthly .ct-label {
  fill: #fff;
  color: #fff;
}

.turnover .ct-grid,
.uses .ct-grid,
.monthly .ct-grid {
  stroke: rgba(255, 255, 255, 0.7);
}

#draggableMultiple .ui-sortable-handle .card {
  cursor: move;
}

.tilt-showcase ul li .line {
  padding-top: 10px;
}

.tilt-showcase .pre-mt {
  margin-top: 5px;
}

.wow-title h5 {
  display: flex;
  align-items: center;
}

.alert-center {
  display: flex !important;
  align-items: center;
}

.box-shadow-title .sub-title {
  margin: 30px 0;
}

.hovercard .info .social-media ul li {
  padding-top: 3px;
}

.hovercard .cardheader {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.sticky-header-main .card .card-header h5 {
  line-height: 35px;
}

.sticky-header-main .card .card-header h5 a {
  color: #fff;
}

.custom-radio-ml {
  margin-left: 3px;
}

.daterangepicker .ltr tr td.active {
  color: #fff;
}

#scrollable-dropdown-menu .twitter-typeahead .tt-menu .tt-dataset {
  max-height: 100px;
  overflow-y: auto;
}

.btn-showcase a {
  color: #fff;
}

.card-block .table-responsive .table caption {
  padding-left: 10px;
}

.card-block .table-responsive .table-bordered td {
  vertical-align: middle;
}

.card-block .table-border-radius {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.card-block .default-checkbox-align #checkbox1 {
  margin-right: 10px;
}

.card-block .default-checkbox-align #radio {
  margin-right: 5px;
}

#example-style-3_wrapper #example-style-3 tfoot {
  border-top: 2px solid #ddd;
}

.chart-vertical-center {
  display: flex;
  justify-content: center;
}

.chart-vertical-center #myDoughnutGraph,
.chart-vertical-center #myPolarGraph {
  width: auto !important;
}

.gmap-header-align h5 {
  padding-top: 8px;
}

.cke_focus {
  padding: 15px;
  margin-top: 13px;
}

#editor .ace_scroller .ace_content .ace_layer .ace_print-margin {
  visibility: hidden !important;
}

.helper-classes {
  padding: 30px;
  margin-bottom: 0;
  white-space: pre-line;
}

.starter-main {
  min-height: calc(100% - 32px);
}

.starter-main .card-body p {
  font-size: 14px;
}

.starter-main .card-body ul {
  padding-left: 30px;
  list-style-type: disc;
  margin-bottom: 15px;
}

.starter-main .card-body h5 {
  font-size: 18px;
}

.starter-main .card-body pre {
  white-space: pre-line;
  padding: 30px;
}

.starter-main .card-body .alert-primary.inverse:before {
  top: 32px;
}

.starter-main .alert {
  background-color: rgba(171, 140, 228, 0.2);
}

.starter-main .alert i {
  display: flex;
  align-items: center;
}

footer.blockquote-footer {
  bottom: auto;
  bottom: initial;
}

.rtl .alert-primary.inverse {
  background-color: transparent;
  padding: 13px 65px 13px 20px;
}

.rtl .starter-main .card-body ul {
  padding-right: 30px;
}

/**=====================
  53. Dashboard CSS Ends
==========================**/
/**=====================
     54. Tour  CSS Start
==========================**/
.introjs-overlay {
  position: absolute;
  box-sizing: content-box;
  z-index: 99999;
  background-color: #000;
  opacity: 0;
  background: radial-gradient(center, ellipse cover, rgba(0, 0, 0, 0.9) 0, rgba(0, 0, 0, 0.9) 100%);
  filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr='#66000000',endColorstr='#e6000000',GradientType=1)";
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
  filter: alpha(opacity=50);
  transition: all 0.3s ease-out;
}

.introjs-fixParent {
  z-index: auto !important;
  opacity: 1.0 !important;
  transform: none !important;
}

.introjs-showElement {
  z-index: 9999999 !important;
}

tr.introjs-showElement>td,
tr.introjs-showElement>th {
  z-index: 9999999 !important;
}

.introjs-disableInteraction {
  z-index: 99999999 !important;
  position: absolute;
  background-color: #fff;
  opacity: 0;
  filter: alpha(opacity=0);
}

.introjs-relativePosition {
  position: relative;
}

tr.introjs-showElement>td,
tr.introjs-showElement>th {
  position: relative;
}

.introjs-helperLayer {
  box-sizing: content-box;
  position: absolute;
  z-index: 9999998;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #777777;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease-out;
}

.introjs-tooltipReferenceLayer {
  box-sizing: content-box;
  position: absolute;
  visibility: hidden;
  z-index: 100000000;
  background-color: transparent;
  transition: all 0.3s ease-out;
}

.introjs-helperLayer * {
  -ms-box-sizing: content-box;
  -o-box-sizing: content-box;
  box-sizing: content-box;
}

.introjs-helperLayer *:before,
.introjs-helperLayer *:after {
  -ms-box-sizing: content-box;
  -o-box-sizing: content-box;
  box-sizing: content-box;
}

.introjs-helperNumberLayer {
  box-sizing: content-box;
  position: absolute;
  visibility: visible;
  top: -16px;
  left: -16px;
  z-index: 9999999999 !important;
  padding: 2px;
  font-family: Arial, verdana, tahoma;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  background: #FF5370;
  /* Old browsers */
  /* Chrome10+,Safari5.1+ */
  /* Chrome,Safari4+ */
  /* FF3.6+ */
  /* IE10+ */
  /* Opera 11.10+ */
  background: linear-gradient(to bottom, #fb6d9d 0%, #FF5370 100%);
  /* W3C */
  background: linear-gradient(to bottom, #ab8ce4 0%, #ab8ce4 100%);
  width: 20px;
  height: 20px;
  line-height: 20px;
  border: 3px solid #fff;
  border-radius: 50%;
  filter: "progid:DXImageTransform.Microsoft.Shadow(direction=135, strength=2, color=ff0000)";
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
}

.introjs-arrow {
  border: 12px solid #fff;
  content: '';
  position: absolute;
}

.introjs-arrow.top {
  top: -20px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: #ab8ce4;
  border-left-color: transparent;
}

.introjs-arrow.top-right {
  top: -10px;
  right: 10px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: #ab8ce4;
  border-left-color: transparent;
}

.introjs-arrow.top-middle {
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: #ab8ce4;
  border-left-color: transparent;
}

.introjs-arrow.right {
  right: -30px;
  top: 10px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: #ab8ce4;
}

.introjs-arrow.right-bottom {
  bottom: 10px;
  right: -30px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: #ab8ce4;
}

.introjs-arrow.bottom {
  bottom: -20px;
  border-top-color: #ab8ce4;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.introjs-arrow.left {
  left: -30px;
  top: 10px;
  border-top-color: transparent;
  border-right-color: #ab8ce4;
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.introjs-arrow.left-bottom {
  left: -30px;
  bottom: 10px;
  border-top-color: transparent;
  border-right-color: #ab8ce4;
  border-bottom-color: transparent;
  border-left-color: transparent;
}

.introjs-tooltip {
  box-sizing: content-box;
  position: absolute;
  visibility: visible;
  padding: 15px;
  background-color: #ab8ce4;
  min-width: 250px;
  max-width: 300px;
  border-radius: 3px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);
  transition: opacity 0.1s ease-out;
  border: 0;
  color: #fff;
}

.introjs-tooltipbuttons {
  text-align: right;
  white-space: nowrap;
}

.introjs-button {
  box-sizing: content-box;
  position: relative;
  overflow: visible;
  display: inline-block;
  padding: 0.3em 0.8em;
  border: 1px solid #ddd;
  margin: 0;
  text-decoration: none;
  text-shadow: 1px 1px 0 #fff;
  font-size: 11px;
  color: #333333 !important;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  background-color: #fff;
  background-image: linear-gradient(#fff, #fff);
  -webkit-background-clip: padding;
  -moz-background-clip: padding;
  -o-background-clip: padding-box;
  border-radius: 0.2em;
  zoom: 1;
  display: inline;
  margin-top: 10px;
}

.introjs-button:hover {
  border-color: #ddd;
  text-decoration: none;
  box-shadow: none;
}

.introjs-button:focus,
.introjs-button:active {
  background-image: linear-gradient(#cccccc, #ddd);
}

.introjs-button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

/* overrides extra padding on button elements in Firefox */
.introjs-skipbutton {
  box-sizing: content-box;
  margin-right: 5px;
  color: #ab8ce4;
}

.introjs-prevbutton {
  border-radius: 0.2em 0 0 0.2em;
  border-right: none;
}

.introjs-prevbutton.introjs-fullbutton {
  border: 1px solid #ddd;
  border-radius: 0.2em;
}

.introjs-nextbutton {
  border-radius: 0 0.2em 0.2em 0;
}

.introjs-nextbutton.introjs-fullbutton {
  border-radius: 0.2em;
}

.introjs-disabled {
  color: #ab8ce4;
  border-color: #ddd;
  box-shadow: none;
  cursor: default;
  background-image: none;
  text-decoration: none;
}

.introjs-disabled:hover,
.introjs-disabled:focus {
  color: #ab8ce4;
  border-color: #ddd;
  box-shadow: none;
  cursor: default;
  background-image: none;
  text-decoration: none;
}

.introjs-hidden {
  display: none;
}

.introjs-bullets {
  text-align: center;
}

.introjs-bullets ul {
  box-sizing: content-box;
  clear: both;
  margin: 15px auto 0;
  padding: 0;
  display: inline-block;
}

.introjs-bullets ul li {
  box-sizing: content-box;
  list-style: none;
  float: left;
  margin: 0 2px;
}

.introjs-bullets ul li a {
  box-sizing: content-box;
  display: block;
  width: 6px;
  height: 6px;
  background: #cccccc;
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  text-decoration: none;
  cursor: pointer;
}

.introjs-bullets ul li a:hover {
  background: #fff;
}

.introjs-bullets ul li a.active {
  background: #fff;
}

.introjs-progress {
  box-sizing: content-box;
  overflow: hidden;
  height: 10px;
  margin: 10px 0 5px 0;
  border-radius: 4px;
  background-color: #eeeeee;
}

.introjs-progressbar {
  box-sizing: content-box;
  float: left;
  width: 0;
  height: 100%;
  font-size: 10px;
  line-height: 10px;
  text-align: center;
  background-color: #4099ff;
}

.introjsFloatingElement {
  position: absolute;
  height: 0;
  width: 0;
  left: 50%;
  top: 50%;
}

.introjs-fixedTooltip {
  position: fixed;
}

.introjs-hint {
  box-sizing: content-box;
  position: absolute;
  background: transparent;
  width: 20px;
  height: 15px;
  cursor: pointer;
}

.introjs-hint:focus {
  border: 0;
  outline: 0;
}

.introjs-hidehint {
  display: none;
}

.introjs-fixedhint {
  position: fixed;
}

.introjs-hint:hover>.introjs-hint-pulse {
  border: 5px solid rgba(60, 60, 60, 0.57);
}

.introjs-hint-pulse {
  box-sizing: content-box;
  width: 10px;
  height: 10px;
  border: 5px solid rgba(60, 60, 60, 0.27);
  border-radius: 30px;
  background-color: rgba(136, 136, 136, 0.24);
  z-index: 10;
  position: absolute;
  transition: all 0.2s ease-out;
}

.introjs-hint-no-anim .introjs-hint-dot {
  animation: none;
}

.introjs-hint-dot {
  box-sizing: content-box;
  border: 10px solid rgba(146, 146, 146, 0.36);
  background: transparent;
  border-radius: 60px;
  height: 50px;
  width: 50px;
  animation: introjspulse 3s ease-out;
  animation-iteration-count: infinite;
  position: absolute;
  top: -25px;
  left: -25px;
  z-index: 1;
  opacity: 0;
}

@keyframes introjspulse {
  0% {
    transform: scale(0);
    opacity: 0.0;
  }

  25% {
    transform: scale(0);
    opacity: 0.1;
  }

  50% {
    transform: scale(0.1);
    opacity: 0.3;
  }

  75% {
    transform: scale(0.5);
    opacity: 0.5;
  }

  100% {
    transform: scale(1);
    opacity: 0.0;
  }
}

/**=====================
    54. Tour  CSS Ends
==========================**/
/**=====================
   55. theme layout CSS Start
==========================**/
body[main-theme-layout="main-theme-layout-1"] .sidebar-widget .sidebar-widget-bottom {
  background-color: #30384b;
}

body[main-theme-layout="main-theme-layout-1"] .sidebar-widget .sidebar-widget-bottom p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-1"] .sidebar-widget .sidebar-widget-top i {
  background-color: #343d52;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper {
  /* sidebar start */
  /* sidebar end */
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,
body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar {
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {
  background-blend-mode: overlay;
  background-color: #17191d;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar.navigation-bordered .sidebar-header {
  border-bottom: 1px solid rgba(241, 241, 241, 0.15);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {
  background-color: #36404a;
  box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {
  color: #eeeeee;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {
  color: #ab8ce4;
  border-bottom: 1px solid rgba(241, 241, 241, 0.35);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {
  margin-top: 3px;
  margin-right: 5px;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {
  color: #f3d800;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {
  color: #eeeeee;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top i {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-bottom {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-body {
  background-color: rgba(246, 246, 246, 0.6);
}

body[main-theme-layout="main-theme-layout-1"] .page-wrapper .page-body-wrapper .page-header .breadcrumb {
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-2"] .flot-chart-container .legend .table tbody {
  background-color: #36404a;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .flot-chart-container .legend .table tbody .legendLabel {
  padding-left: 5px;
}

body[main-theme-layout="main-theme-layout-2"] .nav-dark .nav-link,
body[main-theme-layout="main-theme-layout-2"] .nav-pills.nav-dark .nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header {
  color: #000;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .default-according .card .btn-link {
  background-color: #fff;
  border: 1px solid #eeeeee;
  color: #000;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .collapse .card-body {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .theme-form .form-group input[type=email],
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .theme-form .form-group textarea {
  border-color: #eeeeee;
  background-color: #fff;
  color: #000;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .theme-form .form-group label {
  color: #000;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header #accordionoc #collapseicon,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header #accordionoc #collapseicon1 {
  background-color: #fff;
}

@media only screen and (max-width: 575px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .nav-right>ul .search-form .mobile-search {
    filter: brightness(1) invert(100%);
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-main-header .nav-right>ul .search-form .form-control-plaintext {
    background-color: #303841;
    filter: brightness(1) invert(9%) !important;
    border: 1px solid #4b5469;
    color: rgba(255, 255, 255, 0.7);
  }
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper {
  /* body start*/
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {
  border-bottom: none !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .custom-card .card-header img {
  background-color: #000;
  opacity: 0.1;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-header .row h3 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-header .breadcrumb-item.active {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  /* body end*/
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card {
  background-color: #36404a;
  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header {
  background-color: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header h1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header h2,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header h3,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header h4,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header h5,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-header .card-header-right i {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline-2x,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card #animation-box .animate-widget p {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .grid-item img {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .line {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table td {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table thead th {
  border-bottom: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table thead .border-bottom-primary th {
  border-bottom: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger td {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-primary,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-secondary,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-success,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-info,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-warning,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-danger {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-light {
  color: #000;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .thead-light th {
  color: #000;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .double,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .dotted,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table .dashed {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary td {
  border-bottom: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table td {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered th {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-inverse tbody tr:nth-of-type(odd):hover td {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical tr,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical td {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .card-footer {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .switch .switch-state {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .switch input:checked+.switch-state {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .bg-white {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .business-top-widget .media span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .b-l-light {
  border-left: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .business-card table td {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .business-card table th {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .business-card .logo {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .media .social-sub-title {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .total-value {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .social-icons {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .ct-grid {
  stroke: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .ct-label {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .text-muted {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:before {
  border-bottom: 10px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:after {
  border-bottom: 9px solid #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .calender-widget .cal-date {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form .form-icon {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-dark {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .btn-light {
  color: #303841 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .btn-light:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .border-right {
  border-right: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder .flot-text {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#line-chart rect,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart1 rect,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart2 rect {
  fill: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>rect {
  fill: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>g>g text {
  fill: #b1b1b2;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .radial-bar:after {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num .color-bottom {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .b-r-light {
  border-right: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-labels .ct-label {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-grid,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-grid,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-grid,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-grid {
  stroke: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #browser-uses-chart svg text,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #website-visiter-chart svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .status-details span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .clipboaard-container .form-control {
  background-color: #303841;
  color: #98a6ad;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .img-thumbnail {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard .media img {
  filter: brightness(0) invert(75%);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr+tr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td p,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_info,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_processing,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter input[type="search"] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover>.sorting_1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover>.sorting_1 {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd>.sorting_1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even>.sorting_1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even>.sorting_1 {
  background-color: rgba(53, 59, 74, 0.3);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead td {
  border-bottom: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable input,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody tr {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody td {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even:hover>.sorting_1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover>.sorting_1 {
  background-color: #2c3239;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.hover tbody tr:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td {
  border-top: 1px solid #4b5469;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th:first-child,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td:first-child {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_2,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_3,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_2,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_3 {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card #example-style-3_wrapper #example-style-3 tfoot {
  border-top: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .page-item.disabled .page-link {
  background-color: #36404a;
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .page-link {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .page-link:hover {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .page-item.active .page-link {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .icon {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col+.col {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-container-small {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li:hover {
  background-color: #000;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td span,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .product-table h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:focus,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-selected {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a {
  border: 2px solid #4b5469;
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-selected {
  border: 2px solid #ab8ce4;
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a:after,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a:after {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-selected:after,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-active:after,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-active:after {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .scroll-demo {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .search-form input {
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content::before {
  border-left: 7px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
  border-right-color: #4b5469;
  border-left: transparent;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .breadcrumb {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .user-status table td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card .user-status table th {
  border-top: none !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris-daily svg,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris svg,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card #browser-uses-chart svg,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card #website-visiter-chart svg {
  opacity: 0.5;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-des {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show>.nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #viewhtml .render {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {
  border: 1px dotted #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description a>div {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell {
  background: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell input,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell input,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell input,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell input {
  background-color: #303841;
  border-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {
  background-color: #303841;
  border-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-row>.jsgrid-cell {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row>.jsgrid-cell {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row>.jsgrid-cell {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*="jsgrid-pager"] {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 700;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .sub-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {
  color: #ab8ce4 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {
  background-color: #36404a;
  box-shadow: 0 0 2px 2px #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {
  border-bottom: 7px solid #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .border {
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {
  color: #98a6ad;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {
  border-right: none;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .comment-box .media img {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .comment-box p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .comment-box hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover td,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover th {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body ul.the-icons li {
  border: 1px dotted #4b5469;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-agendaWeek-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicDay-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaWeek-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaDay-button {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .border-widgets>.row>div+div {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top .details h4 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom h5 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li+li {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .default-widget-count h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .default-widget-count span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .icon-bg {
  color: #2e3945;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .left i {
  color: #303841;
  text-shadow: 1px 1px 1px #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .testimonial-default .slide--item p {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div+div {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .checkbox label::before,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .radio label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {
  column-rule: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {
  border: 2px solid #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .icon-lists div i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .media-body>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .details {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .widget-joins:before,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .widget-joins:after {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h5,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .social-widget-card span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .b-b-light {
  border-bottom: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .b-r-dark {
  border-right: 1px solid #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .testimonial i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .testimonial p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .testimonial h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .testimonial span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .grid-showcase span {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .grid-align .row {
  background-color: #4b5469;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .border-style .card {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .offer-style .card {
  border: 1px dashed #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {
  background-color: #36404a;
  color: #98a6ad !important;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {
  border-left: 3px solid #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {
  color: #98a6ad;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {
  border: 1px solid #4b5469;
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {
  background-color: #303841;
  border-color: #4b5469;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .pricing-card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h3 {
  color: rgba(206, 212, 218, 0.3);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-price h1 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li::before {
  color: rgba(255, 255, 255, 0.15);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .search-page .info-block+.info-block {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper footer {
  border-top: 1px solid #303841;
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .custom-select,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .custom-file-label {
  background: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .page-body-wrapper .footer-fix {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .dt-button-info {
  background-color: #36404a;
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .dt-button-info h2 {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .about .name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu .nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {
  background-color: #36404a;
  box-shadow: 1px 1px 3px 1px #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {
  border: 5px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu .user-profile .social-media a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu .user-profile .follow span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .status {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .status p {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-history .call-icons ul li {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-history .call-icons ul li a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper pre {
  background-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .scorlled {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .input-group-air {
  box-shadow: 0 3px 20px 0 #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .input-group-solid .input-group-text,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .input-group-solid .form-control {
  background: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .semilight-bg-color,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .header-bg-color {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item {
  background-color: #36404a;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item.active {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item:hover,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item:focus {
  z-index: 1;
  text-decoration: none;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-action:hover:not(.active),
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-action:focus {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-flush .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-primary {
  color: #004085;
  background-color: #b8daff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-success {
  color: #155724;
  background-color: #c3e6cb;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-warning {
  color: #856404;
  background-color: #ffeeba;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {
  color: rgba(255, 255, 255, 0.7);
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box h3,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box h4,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg .authentication-box h6 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video .authentication-box h4,
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video .authentication-box h3 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video .authentication-box h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .error-wrapper .maintenance-icons li i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .modal-content {
  background-color: #36404a;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .modal-content .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .modal-content .modal-header .close {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .modal-content .modal-footer {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .comingsoon {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.8);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .comingsoon .comingsoon-inner h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .comingsoon .comingsoon-inner .countdown {
  border-top: 1px solid #4b5469;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .comingsoon .comingsoon-inner .countdown .title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .comingsoon .comingsoon-inner img {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerleft {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), rgba(54, 64, 74, 0.9);
  background-blend-mode: overlay;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerleft .text-center img {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerleft .social-media li {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .authentication-box h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .authentication-box h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .authentication-box h3 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .default-according .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .default-according .card .btn-link {
  background-color: #36404a;
  border: 1px solid #36404a;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .default-according .card .text-muted {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .default-according .bg-primary .btn-link {
  background-color: #ab8ce4;
  border: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .default-according .bg-secondary .btn-link {
  background-color: #26c6da;
  border: 1px solid #26c6da;
}

body[main-theme-layout="main-theme-layout-2"] .page-wrapper .collapse .card-body {
  background-color: #36404a;
}

@media screen and (max-width: 1660px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-history .call-icons ul li {
    border: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-history .total-time h2 {
    color: rgba(255, 255, 255, 0.7);
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .caller-img img {
    opacity: 0.7;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-box .chat-history .call-content>div {
    background-color: rgba(0, 0, 0, 0.75);
    background-blend-mode: overlay;
  }
}

@media only screen and (max-width: 1366px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .crm-numbers .col {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .crm-numbers .col+.col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .crm-numbers .col+.col+.col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 1199px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .chat-menu {
    border-top: 1px solid #4b5469;
    background-color: #36404a;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .error-wrapper .maintenance-icons li i {
    color: #2a3142;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .border-widgets>.row>div:nth-child(1) {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .border-widgets>.row>div:nth-child(2) {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .crm-numbers .col+.col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 991px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 767px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .border-widgets>.row>div+div {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 575px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .user-profile .hovercard .info .user-designation {
    border-top: 1px solid #4b5469;
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .border-widgets>.row>div+div {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .widget-joins .border-after-xs:after {
    background-color: #4b5469;
  }
}

@media only screen and (max-width: 480px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .business-card .b-l-light {
    border-left: 1px solid #4b5469 !important;
  }
}

@media only screen and (max-width: 360px) {
  body[main-theme-layout="main-theme-layout-2"] .page-wrapper .border-widgets>.row>div+div+div {
    border-bottom: 1px solid #4b5469;
  }
}

body[main-theme-layout="main-theme-layout-2"] .lg-backdrop {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .lg-outer .lg-thumb-outer {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .drag {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .drag form {
  background: #36404a;
  box-shadow: 0 0 30px #4b5469;
  border: 1px dotted #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .drag form input {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .drag form .help-block {
  text-transform: capitalize;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .draggable input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .draggable p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .draggable select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .draggable .radio label::before,
body[main-theme-layout="main-theme-layout-2"] .draggable .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .select2-container--default .select2-selection--multiple,
body[main-theme-layout="main-theme-layout-2"] .select2-container--default .select2-selection--single {
  background-color: #303841;
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-container--default .select2-search--inline .select2-search__field {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .select2-container--default .select2-search--dropdown .select2-search__field {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .select2-dropdown {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-primary {
  border-color: #ab8ce4 !important;
  color: #ab8ce4 !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-secondary {
  border-color: #26c6da !important;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-success {
  border-color: #00c292 !important;
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-info {
  border-color: #4099ff !important;
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-warning {
  border-color: #f3d800 !important;
  color: #f3d800 !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-danger {
  border-color: #FF5370 !important;
  color: #FF5370 !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-inverse {
  border-color: #fff !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-primary-fill {
  background-color: #ab8ce4 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-secondary-fill {
  background-color: #26c6da !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-success-fill {
  background-color: #00c292 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-info-fill {
  background-color: #4099ff !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-warning-fill {
  background-color: #f3d800 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-danger-fill {
  background-color: #FF5370 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-drpdwn .form-control-inverse-fill {
  background-color: #fff !important;
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-2"] .select2-container--default.select2-container--disabled .select2-selection--single {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group select.form-control:not([size]):not([multiple]) {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=email],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=search],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=password],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=number],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=tel],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=date],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=datetime-local],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=time],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=datetime-local],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=month],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=week],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=url],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=file],
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group select {
  border-color: #4b5469;
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=text]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=email]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=search]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=password]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=number]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=tel]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=date]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=time]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=month]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=week]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=url]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group input[type=file]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group select::-webkit-input-placeholder {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .theme-form .form-group textarea {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .theme-form .form-divider {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .theme-form .form-divider::before {
  background: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .CodeMirror {
  background: #36404a;
  border: 1px solid #98a6ad;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .CodeMirror .CodeMirror-code pre {
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .editor-toolbar {
  border-top: 1px solid #98a6ad;
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .editor-toolbar a {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-2"] .editor-toolbar a:hover,
body[main-theme-layout="main-theme-layout-2"] .editor-toolbar a.active {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .editor-toolbar i.separator {
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .editor-toolbar.disabled-for-preview a:not(.no-disable) {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .editor-preview {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .editor-toolbar.fullscreen,
body[main-theme-layout="main-theme-layout-2"] .editor-preview-side {
  background: #36404a;
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .u-step {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .u-step.active,
body[main-theme-layout="main-theme-layout-2"] .u-step.current {
  background: #ab8ce4;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .u-step-title,
body[main-theme-layout="main-theme-layout-2"] .u-pearl-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .u-step-number {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .u-pearl:before {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .u-pearl-number,
body[main-theme-layout="main-theme-layout-2"] .u-pearl-icon {
  background: #303841;
  border: 2px solid #303841;
}

body[main-theme-layout="main-theme-layout-2"] .u-pearl.disabled .u-pearl-icon,
body[main-theme-layout="main-theme-layout-2"] .u-pearl.disabled .u-pearl-number {
  background: #4b5469;
  border: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .u-pearl.disabled:after {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-2"] .u-pearl.error:after {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .note-editor.note-frame {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .note-editor.note-frame .note-editing-area .note-editable {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .swal-modal {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .swal-modal .swal-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .swal-modal .swal-text {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .swal-modal .swal-content__input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .nav-tabs .nav-link.active {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469 #4b5469 #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .nav-tabs .nav-link:hover,
body[main-theme-layout="main-theme-layout-2"] .nav-tabs .nav-link:focus {
  border-color: #4b5469 #4b5469 #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .nav-tabs .nav-item.show .nav-link {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #98a6ad #4b5469 #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .nav-tabs.nav-bottom .nav-item .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .nav-tabs.nav-bottom .nav-item .nav-link.focus,
body[main-theme-layout="main-theme-layout-2"] .nav-tabs.nav-bottom .nav-item .nav-link.hover {
  border-color: #36404a #4b5469 #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left .nav-link,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right .nav-link.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left .show>.nav-link,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right .show>.nav-link {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-secondary .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-secondary .nav-link:focus,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-secondary .nav-link:hover {
  border-left-color: #26c6da;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-secondary .show>.nav-link {
  border-left-color: #26c6da;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-secondary .nav-item.show {
  color: #26c6da !important;
  border-left-color: #26c6da;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-success .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-success .nav-link:focus,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-success .nav-link:hover {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-success .show>.nav-link {
  border-left-color: #00c292;
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-left.nav-success .nav-item.show {
  color: #00c292 !important;
  border-left-color: #00c292;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right.nav-info .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right.nav-info .nav-link:focus,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right.nav-info .nav-link:hover {
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right.nav-info .show>.nav-link {
  border-left-color: #4099ff;
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-right.nav-info .nav-item.show {
  color: #4099ff !important;
  border-left-color: #4099ff;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-secondary .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-secondary .nav-link:focus,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-secondary .nav-link:hover {
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-secondary .nav-item.show {
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-success .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-success .nav-link:focus,
body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-success .nav-link:hover {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-2"] .nav-material.nav-success .nav-item.show {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-2"] .dropdown-divider {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .icon-hover-bottom {
  background-color: #36404a;
  box-shadow: 0px 0px 1px 1px #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .icon-hover-bottom .icon-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .icon-hover-bottom span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .icon-hover-bottom .form-group input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .icon-hover-bottom .icon-first i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] code {
  background-color: #434f5a;
}

body[main-theme-layout="main-theme-layout-2"] #cd-timeline::before {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .timeliny {
  border-top: 1px solid #4b5469;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .timeliny::before {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .timeliny .timeliny-dot {
  background-color: #36404a;
  border: 1px solid #fff;
}

body[main-theme-layout="main-theme-layout-2"] .timeliny .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .todo .todo-list-wrapper #todo-list li .task-container {
  background: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .todo .todo-list-wrapper #todo-list li .task-container .task-label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .todo .todo-list-wrapper #todo-list li .task-container:hover h4 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {
  background: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-2"] .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {
  border: 1px solid #00c292 !important;
}

body[main-theme-layout="main-theme-layout-2"] .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .ttl-info h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .ttl-info span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .hovercard .info .title a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .hovercard .user-image .avatar img {
  border: 10px solid #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .hovercard .user-image .icon-wrapper {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .profile-img-style .user-name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .user-profile .profile-img-style p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .introjs-helperLayer {
  background-color: rgba(54, 64, 74, 0.9);
  border: rgba(255, 255, 255, 0.5);
}

body[main-theme-layout="main-theme-layout-2"] .jstree-default .jstree-node,
body[main-theme-layout="main-theme-layout-2"] .jstree-default .jstree-icon {
  color: #434f5a !important;
}

body[main-theme-layout="main-theme-layout-2"] .jstree-default .jstree-anchor {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .jstree-default .jstree-clicked {
  color: #fff;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-2"] .jstree-default .jstree-hovered {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] span.twitter-typeahead .tt-menu {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] span.twitter-typeahead .tt-suggestion {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] span.twitter-typeahead .tt-suggestion:hover,
body[main-theme-layout="main-theme-layout-2"] span.twitter-typeahead .tt-suggestion:focus {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .typography small {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .blockquote-footer {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper {
  background-color: #36404a;
  box-shadow: 0 0 9px #4b5469;
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .quickview-box:before,
body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .quickview-recent-activity:before {
  background-color: #36404a;
  box-shadow: 0 0 9px #4b5469;
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .quickview-box:after,
body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .quickview-recent-activity:after {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .nav-material.nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .nav-material.nav-primary .nav-link.active,
body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .nav-material.nav-primary .nav-link :hover {
  color: #ab8ce4;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .nav-material.nav-primary .nav-item.show,
body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .nav-material.nav-primary .nav-link:focus {
  color: #ab8ce4;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .modal-header .modal-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .modal-header i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .friend-list-search {
  background-color: #2f3841;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .friend-list-search input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .recent-activity .activity-content h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .recent-activity .activity-content hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .recent-activity .user-first-letter:after {
  border: 1px dashed #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .quickview-wrapper .chat-box .about .name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .code-box-copy pre {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .code-box-copy pre code {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .code-box-copy pre[class*="language-"] {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .code-box-copy .code-box-copy__btn {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-2"] .code-box-copy code[class*=language-],
body[main-theme-layout="main-theme-layout-2"] .code-box-copy pre[class*=language-] {
  text-shadow: 0px 1px #000;
}

body[main-theme-layout="main-theme-layout-2"] .code-box-copy code[class*=language-] ::selection,
body[main-theme-layout="main-theme-layout-2"] .code-box-copy pre[class*=language-] ::selection {
  text-shadow: none;
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] table.fixedHeader-floating {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-2"] .dt-button-info {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .dt-button-info h2 {
  background-color: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] #keytable_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #column-selector_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #auto-fill_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #custom-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #class-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #keyboard-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #multilevel-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #pagelength-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #basic-colreorder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #state-saving_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #real-time_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #basic-fixed-header_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #fixed-header-footer_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #export-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #excel-cust-bolder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #cust-json_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #basic-key-table_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #focus-cell_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #responsive_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #new-cons_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #show-hidden-row_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #basic-row-reorder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #full-row_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-2"] #rest-column_wrapper .dataTables_paginate {
  border: none;
}

body[main-theme-layout="main-theme-layout-2"] #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,
body[main-theme-layout="main-theme-layout-2"] #example-style-8_wrapper table.dataTable.display tbody tr.odd {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .error-wrapper {
  background-color: rgba(54, 64, 74, 0.8);
}

body[main-theme-layout="main-theme-layout-2"] .error-wrapper .sub-content {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .b-light {
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-2"] .modal-content {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .modal-content .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .modal-content .ui-front .form-control {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-2"] .stepwizard .stepwizard-row:before {
  background-color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-2"] .modal .theme-close {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-2"] .token.atrule,
body[main-theme-layout="main-theme-layout-2"] .token.attr-value,
body[main-theme-layout="main-theme-layout-2"] .token.keyword {
  color: #4099ff;
}

body[main-theme-layout="main-theme-layout-2"] .token.boolean,
body[main-theme-layout="main-theme-layout-2"] .token.constant,
body[main-theme-layout="main-theme-layout-2"] .token.deleted,
body[main-theme-layout="main-theme-layout-2"] .token.number,
body[main-theme-layout="main-theme-layout-2"] .token.property,
body[main-theme-layout="main-theme-layout-2"] .token.symbol,
body[main-theme-layout="main-theme-layout-2"] .token.tag {
  color: #FF5370;
}

body[main-theme-layout="main-theme-layout-2"] .loader-box.card-loader {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-2"] .my-gallery.gallery-with-description img {
  border: 1px solid #4b5469 !important;
  border-bottom: none !important;
}

body[main-theme-layout="main-theme-layout-2"] .alert-primary.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .alert-secondary.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .alert-success.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .alert-danger.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .alert-warning.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .alert-info.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .alert-light.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-2"] .alert-dark.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] {
  color: rgba(255, 255, 255, 0.7);
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .flot-chart-container .legend .table tbody {
  background-color: #36404a;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .flot-chart-container .legend .table tbody .legendLabel {
  padding-left: 5px;
}

body[main-theme-layout="main-theme-layout-3"] .nav-dark .nav-link,
body[main-theme-layout="main-theme-layout-3"] .nav-pills.nav-dark .nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header {
  color: #000;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .default-according .card .btn-link {
  background-color: #fff;
  border: 1px solid #eeeeee;
  color: #000;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .collapse .card-body {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .theme-form .form-group input[type=email],
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .theme-form .form-group textarea {
  border-color: #eeeeee;
  background-color: #fff;
  color: #000;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .theme-form .form-group label {
  color: #000;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header #accordionoc #collapseicon,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header #accordionoc #collapseicon1 {
  background-color: #fff;
}

@media only screen and (max-width: 575px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .nav-right>ul .search-form .mobile-search {
    filter: brightness(1) invert(100%);
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-main-header .nav-right>ul .search-form .form-control-plaintext {
    background-color: #303841;
    filter: brightness(1) invert(9%) !important;
    border: 1px solid #4b5469;
    color: rgba(255, 255, 255, 0.7);
  }
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper {
  /* sidebar start */
  /* sidebar end */
  /* body start*/
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar {
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {
  background-blend-mode: overlay;
  background-color: #17191d;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar.navigation-bordered .sidebar-header {
  border-bottom: 1px solid rgba(241, 241, 241, 0.35);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {
  background-color: #36404a;
  box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {
  color: #eeeeee;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {
  color: #ab8ce4;
  border-bottom: 1px solid rgba(241, 241, 241, 0.35);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {
  margin-top: 3px;
  margin-right: 5px;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {
  color: #f3d800;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {
  color: #eeeeee;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top i {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-bottom {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {
  border-bottom: none !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .custom-card .card-header img {
  background-color: #000;
  opacity: 0.1;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-header .row h3 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-header .breadcrumb-item.active {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body {
  background-color: #303841;
  /* body end*/
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card {
  background-color: #36404a;
  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header {
  background-color: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header h1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header h2,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header h3,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header h4,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header h5,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-header .card-header-right i {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline-2x,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card #animation-box .animate-widget p {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .grid-item img {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .line {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table td {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table thead th {
  border-bottom: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table thead .border-bottom-primary th {
  border-bottom: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger td {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-primary,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-secondary,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-success,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-info,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-warning,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-danger {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-light {
  color: #000;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .thead-light th {
  color: #000;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .double,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .dotted,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table .dashed {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary td {
  border-bottom: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table td {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered th {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-inverse tbody tr:nth-of-type(odd):hover td {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical tr,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical td {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .card-footer {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .switch .switch-state {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .switch input:checked+.switch-state {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .bg-white {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .business-top-widget .media span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .b-l-light {
  border-left: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .business-card table td {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .business-card table th {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .business-card .logo {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .media .social-sub-title {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .total-value {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .social-icons {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .ct-grid {
  stroke: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .ct-label {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .text-muted {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:before {
  border-bottom: 10px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:after {
  border-bottom: 9px solid #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .calender-widget .cal-date {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form .form-icon {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-dark {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .btn-light {
  color: #303841 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .btn-light:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .border-right {
  border-right: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder .flot-text {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#line-chart rect,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart1 rect,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart2 rect {
  fill: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>rect {
  fill: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>g>g text {
  fill: #b1b1b2;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .radial-bar:after {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num .color-bottom {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .b-r-light {
  border-right: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-labels .ct-label {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-grid,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-grid,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-grid,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-grid {
  stroke: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #browser-uses-chart svg text,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #website-visiter-chart svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .status-details span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .clipboaard-container .form-control {
  background-color: #303841;
  color: #98a6ad;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .img-thumbnail {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard .media img {
  filter: brightness(0) invert(75%);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr+tr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td p,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_info,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_processing,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter input[type="search"] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover>.sorting_1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover>.sorting_1 {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd>.sorting_1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even>.sorting_1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even>.sorting_1 {
  background-color: rgba(53, 59, 74, 0.3);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead td {
  border-bottom: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable input,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody tr {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody td {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even:hover>.sorting_1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover>.sorting_1 {
  background-color: #2c3239;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.hover tbody tr:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td {
  border-top: 1px solid #4b5469;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th:first-child,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td:first-child {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_2,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_3,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_2,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_3 {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card #example-style-3_wrapper #example-style-3 tfoot {
  border-top: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .page-item.disabled .page-link {
  background-color: #36404a;
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .page-link {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .page-link:hover {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .page-item.active .page-link {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .icon {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col+.col {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-container-small {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li:hover {
  background-color: #000;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td span,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .product-table h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:focus,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-selected {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a {
  border: 2px solid #4b5469;
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-selected {
  border: 2px solid #ab8ce4;
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a:after,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a:after {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-selected:after,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-active:after,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-active:after {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .scroll-demo {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .search-form input {
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content::before {
  border-left: 7px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
  border-right-color: #4b5469;
  border-left: transparent;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .breadcrumb {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .user-status table td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card .user-status table th {
  border-top: none !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris-daily svg,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris svg,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card #browser-uses-chart svg,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card #website-visiter-chart svg {
  opacity: 0.5;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-des {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show>.nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #viewhtml .render {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {
  border: 1px dotted #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description a>div {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell {
  background: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell input,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell input,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell input,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell input {
  background-color: #303841;
  border-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {
  background-color: #303841;
  border-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-row>.jsgrid-cell {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row>.jsgrid-cell {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row>.jsgrid-cell {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*="jsgrid-pager"] {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 700;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .sub-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {
  color: #ab8ce4 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {
  background-color: #36404a;
  box-shadow: 0 0 2px 2px #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {
  border-bottom: 7px solid #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .border {
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {
  color: #98a6ad;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {
  border-right: none;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .comment-box .media img {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .comment-box p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .comment-box hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover td,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover th {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body ul.the-icons li {
  border: 1px dotted #4b5469;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-agendaWeek-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicDay-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaWeek-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaDay-button {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .border-widgets>.row>div+div {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top .details h4 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom h5 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li+li {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .default-widget-count h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .default-widget-count span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .icon-bg {
  color: #2e3945;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .left i {
  color: #303841;
  text-shadow: 1px 1px 1px #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .testimonial-default .slide--item p {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div+div {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .checkbox label::before,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .radio label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {
  column-rule: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {
  border: 2px solid #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .icon-lists div i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .media-body>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .details {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .widget-joins:before,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .widget-joins:after {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h5,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .social-widget-card span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .b-b-light {
  border-bottom: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .b-r-dark {
  border-right: 1px solid #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .testimonial i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .testimonial p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .testimonial h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .testimonial span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .grid-showcase span {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .grid-align .row {
  background-color: #4b5469;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .border-style .card {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .offer-style .card {
  border: 1px dashed #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {
  background-color: #36404a;
  color: #98a6ad !important;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {
  border-left: 3px solid #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {
  color: #98a6ad;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {
  border: 1px solid #4b5469;
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {
  background-color: #303841;
  border-color: #4b5469;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .pricing-card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h3 {
  color: rgba(206, 212, 218, 0.3);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-price h1 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li::before {
  color: rgba(255, 255, 255, 0.15);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .search-page .info-block+.info-block {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper footer {
  border-top: 1px solid #303841;
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .custom-select,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .custom-file-label {
  background: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .page-body-wrapper .footer-fix {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .dt-button-info {
  background-color: #36404a;
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .dt-button-info h2 {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .about .name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu .nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {
  background-color: #36404a;
  box-shadow: 1px 1px 3px 1px #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {
  border: 5px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu .user-profile .social-media a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu .user-profile .follow span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .status {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .status p {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-history .call-icons ul li {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-history .call-icons ul li a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper pre {
  background-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .scorlled {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .input-group-air {
  box-shadow: 0 3px 20px 0 #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .input-group-solid .input-group-text,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .input-group-solid .form-control {
  background: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .semilight-bg-color,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .header-bg-color {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item {
  background-color: #36404a;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item.active {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item:hover,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item:focus {
  z-index: 1;
  text-decoration: none;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-action:hover:not(.active),
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-action:focus {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-flush .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-primary {
  color: #004085;
  background-color: #b8daff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-success {
  color: #155724;
  background-color: #c3e6cb;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-warning {
  color: #856404;
  background-color: #ffeeba;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {
  color: rgba(255, 255, 255, 0.7);
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box h3,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box h4,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg .authentication-box h6 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video .authentication-box h4,
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video .authentication-box h3 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video .authentication-box h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .error-wrapper .maintenance-icons li i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .modal-content {
  background-color: #36404a;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .modal-content .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .modal-content .modal-header .close {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .modal-content .modal-footer {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .comingsoon {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.8);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .comingsoon .comingsoon-inner h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .comingsoon .comingsoon-inner .countdown {
  border-top: 1px solid #4b5469;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .comingsoon .comingsoon-inner .countdown .title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .comingsoon .comingsoon-inner img {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerleft {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), rgba(54, 64, 74, 0.9);
  background-blend-mode: overlay;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerleft .text-center img {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerleft .social-media li {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .authentication-box h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .authentication-box h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .authentication-box h3 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .default-according .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .default-according .card .btn-link {
  background-color: #36404a;
  border: 1px solid #36404a;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .default-according .card .text-muted {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .default-according .bg-primary .btn-link {
  background-color: #ab8ce4;
  border: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .default-according .bg-secondary .btn-link {
  background-color: #26c6da;
  border: 1px solid #26c6da;
}

body[main-theme-layout="main-theme-layout-3"] .page-wrapper .collapse .card-body {
  background-color: #36404a;
}

@media screen and (max-width: 1660px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-history .call-icons ul li {
    border: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-history .total-time h2 {
    color: rgba(255, 255, 255, 0.7);
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .caller-img img {
    opacity: 0.7;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-box .chat-history .call-content>div {
    background-color: rgba(0, 0, 0, 0.75);
    background-blend-mode: overlay;
  }
}

@media only screen and (max-width: 1366px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .crm-numbers .col {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .crm-numbers .col+.col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .crm-numbers .col+.col+.col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 1199px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .chat-menu {
    border-top: 1px solid #4b5469;
    background-color: #36404a;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .error-wrapper .maintenance-icons li i {
    color: #2a3142;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .border-widgets>.row>div:nth-child(1) {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .border-widgets>.row>div:nth-child(2) {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .crm-numbers .col+.col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 991px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 767px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .border-widgets>.row>div+div {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 575px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .user-profile .hovercard .info .user-designation {
    border-top: 1px solid #4b5469;
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .border-widgets>.row>div+div {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .widget-joins .border-after-xs:after {
    background-color: #4b5469;
  }
}

@media only screen and (max-width: 480px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .business-card .b-l-light {
    border-left: 1px solid #4b5469 !important;
  }
}

@media only screen and (max-width: 360px) {
  body[main-theme-layout="main-theme-layout-3"] .page-wrapper .border-widgets>.row>div+div+div {
    border-bottom: 1px solid #4b5469;
  }
}

body[main-theme-layout="main-theme-layout-3"] .lg-backdrop {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .lg-outer .lg-thumb-outer {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .drag {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .drag form {
  background: #36404a;
  box-shadow: 0 0 30px #4b5469;
  border: 1px dotted #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .drag form input {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .drag form .help-block {
  text-transform: capitalize;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .draggable input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .draggable p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .draggable select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .draggable .radio label::before,
body[main-theme-layout="main-theme-layout-3"] .draggable .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .select2-container--default .select2-selection--multiple,
body[main-theme-layout="main-theme-layout-3"] .select2-container--default .select2-selection--single {
  background-color: #303841;
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-container--default .select2-search--inline .select2-search__field {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .select2-container--default .select2-search--dropdown .select2-search__field {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .select2-dropdown {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-primary {
  border-color: #ab8ce4 !important;
  color: #ab8ce4 !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-secondary {
  border-color: #26c6da !important;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-success {
  border-color: #00c292 !important;
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-info {
  border-color: #4099ff !important;
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-warning {
  border-color: #f3d800 !important;
  color: #f3d800 !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-danger {
  border-color: #FF5370 !important;
  color: #FF5370 !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-inverse {
  border-color: #fff !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-primary-fill {
  background-color: #ab8ce4 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-secondary-fill {
  background-color: #26c6da !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-success-fill {
  background-color: #00c292 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-info-fill {
  background-color: #4099ff !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-warning-fill {
  background-color: #f3d800 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-danger-fill {
  background-color: #FF5370 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-drpdwn .form-control-inverse-fill {
  background-color: #fff !important;
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-3"] .select2-container--default.select2-container--disabled .select2-selection--single {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group select.form-control:not([size]):not([multiple]) {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=email],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=search],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=password],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=number],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=tel],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=date],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=datetime-local],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=time],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=datetime-local],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=month],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=week],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=url],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=file],
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group select {
  border-color: #4b5469;
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=text]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=email]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=search]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=password]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=number]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=tel]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=date]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=time]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=month]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=week]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=url]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group input[type=file]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group select::-webkit-input-placeholder {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .theme-form .form-group textarea {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .theme-form .form-divider {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .theme-form .form-divider::before {
  background: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .CodeMirror {
  background: #36404a;
  border: 1px solid #98a6ad;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .CodeMirror .CodeMirror-code pre {
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .editor-toolbar {
  border-top: 1px solid #98a6ad;
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .editor-toolbar a {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-3"] .editor-toolbar a:hover,
body[main-theme-layout="main-theme-layout-3"] .editor-toolbar a.active {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .editor-toolbar i.separator {
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .editor-toolbar.disabled-for-preview a:not(.no-disable) {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .editor-preview {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .editor-toolbar.fullscreen,
body[main-theme-layout="main-theme-layout-3"] .editor-preview-side {
  background: #36404a;
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .u-step {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .u-step.active,
body[main-theme-layout="main-theme-layout-3"] .u-step.current {
  background: #ab8ce4;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .u-step-title,
body[main-theme-layout="main-theme-layout-3"] .u-pearl-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .u-step-number {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .u-pearl:before {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .u-pearl-number,
body[main-theme-layout="main-theme-layout-3"] .u-pearl-icon {
  background: #303841;
  border: 2px solid #303841;
}

body[main-theme-layout="main-theme-layout-3"] .u-pearl.disabled .u-pearl-icon,
body[main-theme-layout="main-theme-layout-3"] .u-pearl.disabled .u-pearl-number {
  background: #4b5469;
  border: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .u-pearl.disabled:after {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-3"] .u-pearl.error:after {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .note-editor.note-frame {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .note-editor.note-frame .note-editing-area .note-editable {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .swal-modal {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .swal-modal .swal-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .swal-modal .swal-text {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .swal-modal .swal-content__input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .nav-tabs .nav-link.active {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469 #4b5469 #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .nav-tabs .nav-link:hover,
body[main-theme-layout="main-theme-layout-3"] .nav-tabs .nav-link:focus {
  border-color: #4b5469 #4b5469 #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .nav-tabs .nav-item.show .nav-link {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #98a6ad #4b5469 #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .nav-tabs.nav-bottom .nav-item .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .nav-tabs.nav-bottom .nav-item .nav-link.focus,
body[main-theme-layout="main-theme-layout-3"] .nav-tabs.nav-bottom .nav-item .nav-link.hover {
  border-color: #36404a #4b5469 #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left .nav-link,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right .nav-link.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left .show>.nav-link,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right .show>.nav-link {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-secondary .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-secondary .nav-link:focus,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-secondary .nav-link:hover {
  border-left-color: #26c6da;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-secondary .show>.nav-link {
  border-left-color: #26c6da;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-secondary .nav-item.show {
  color: #26c6da !important;
  border-left-color: #26c6da;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-success .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-success .nav-link:focus,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-success .nav-link:hover {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-success .show>.nav-link {
  border-left-color: #00c292;
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-left.nav-success .nav-item.show {
  color: #00c292 !important;
  border-left-color: #00c292;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right.nav-info .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right.nav-info .nav-link:focus,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right.nav-info .nav-link:hover {
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right.nav-info .show>.nav-link {
  border-left-color: #4099ff;
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-right.nav-info .nav-item.show {
  color: #4099ff !important;
  border-left-color: #4099ff;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-secondary .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-secondary .nav-link:focus,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-secondary .nav-link:hover {
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-secondary .nav-item.show {
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-success .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-success .nav-link:focus,
body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-success .nav-link:hover {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-3"] .nav-material.nav-success .nav-item.show {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-3"] .dropdown-divider {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .icon-hover-bottom {
  background-color: #36404a;
  box-shadow: 0px 0px 1px 1px #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .icon-hover-bottom .icon-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .icon-hover-bottom span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .icon-hover-bottom .form-group input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .icon-hover-bottom .icon-first i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] code {
  background-color: #434f5a;
}

body[main-theme-layout="main-theme-layout-3"] #cd-timeline::before {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .timeliny {
  border-top: 1px solid #4b5469;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .timeliny::before {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .timeliny .timeliny-dot {
  background-color: #36404a;
  border: 1px solid #fff;
}

body[main-theme-layout="main-theme-layout-3"] .timeliny .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .todo .todo-list-wrapper #todo-list li .task-container {
  background: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .todo .todo-list-wrapper #todo-list li .task-container .task-label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .todo .todo-list-wrapper #todo-list li .task-container:hover h4 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {
  background: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-3"] .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {
  border: 1px solid #00c292 !important;
}

body[main-theme-layout="main-theme-layout-3"] .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .ttl-info h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .ttl-info span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .hovercard .info .title a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .hovercard .user-image .avatar img {
  border: 10px solid #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .hovercard .user-image .icon-wrapper {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .profile-img-style .user-name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .user-profile .profile-img-style p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .introjs-helperLayer {
  background-color: rgba(54, 64, 74, 0.9);
  border: rgba(255, 255, 255, 0.5);
}

body[main-theme-layout="main-theme-layout-3"] .jstree-default .jstree-node,
body[main-theme-layout="main-theme-layout-3"] .jstree-default .jstree-icon {
  color: #434f5a !important;
}

body[main-theme-layout="main-theme-layout-3"] .jstree-default .jstree-anchor {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .jstree-default .jstree-clicked {
  color: #fff;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-3"] .jstree-default .jstree-hovered {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] span.twitter-typeahead .tt-menu {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] span.twitter-typeahead .tt-suggestion {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] span.twitter-typeahead .tt-suggestion:hover,
body[main-theme-layout="main-theme-layout-3"] span.twitter-typeahead .tt-suggestion:focus {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .typography small {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .blockquote-footer {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper {
  background-color: #36404a;
  box-shadow: 0 0 9px #4b5469;
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .quickview-box:before,
body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .quickview-recent-activity:before {
  background-color: #36404a;
  box-shadow: 0 0 9px #4b5469;
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .quickview-box:after,
body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .quickview-recent-activity:after {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .nav-material.nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .nav-material.nav-primary .nav-link.active,
body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .nav-material.nav-primary .nav-link :hover {
  color: #ab8ce4;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .nav-material.nav-primary .nav-item.show,
body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .nav-material.nav-primary .nav-link:focus {
  color: #ab8ce4;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .modal-header .modal-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .modal-header i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .friend-list-search {
  background-color: #2f3841;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .friend-list-search input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .recent-activity .activity-content h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .recent-activity .activity-content hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .recent-activity .user-first-letter:after {
  border: 1px dashed #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .quickview-wrapper .chat-box .about .name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .code-box-copy pre {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .code-box-copy pre code {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .code-box-copy pre[class*="language-"] {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .code-box-copy .code-box-copy__btn {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-3"] .code-box-copy code[class*=language-],
body[main-theme-layout="main-theme-layout-3"] .code-box-copy pre[class*=language-] {
  text-shadow: 0px 1px #000;
}

body[main-theme-layout="main-theme-layout-3"] .code-box-copy code[class*=language-] ::selection,
body[main-theme-layout="main-theme-layout-3"] .code-box-copy pre[class*=language-] ::selection {
  text-shadow: none;
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] table.fixedHeader-floating {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-3"] .dt-button-info {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .dt-button-info h2 {
  background-color: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] #keytable_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #column-selector_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #auto-fill_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #custom-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #class-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #keyboard-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #multilevel-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #pagelength-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #basic-colreorder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #state-saving_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #real-time_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #basic-fixed-header_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #fixed-header-footer_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #export-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #excel-cust-bolder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #cust-json_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #basic-key-table_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #focus-cell_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #responsive_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #new-cons_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #show-hidden-row_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #basic-row-reorder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #full-row_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-3"] #rest-column_wrapper .dataTables_paginate {
  border: none;
}

body[main-theme-layout="main-theme-layout-3"] #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,
body[main-theme-layout="main-theme-layout-3"] #example-style-8_wrapper table.dataTable.display tbody tr.odd {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .error-wrapper {
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .error-wrapper .sub-content {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-3"] .b-light {
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-3"] .modal-content {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .modal-content .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .modal-content .ui-front .form-control {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-3"] .stepwizard .stepwizard-row:before {
  background-color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-3"] .modal .theme-close {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-3"] .token.atrule,
body[main-theme-layout="main-theme-layout-3"] .token.attr-value,
body[main-theme-layout="main-theme-layout-3"] .token.keyword {
  color: #4099ff;
}

body[main-theme-layout="main-theme-layout-3"] .token.boolean,
body[main-theme-layout="main-theme-layout-3"] .token.constant,
body[main-theme-layout="main-theme-layout-3"] .token.deleted,
body[main-theme-layout="main-theme-layout-3"] .token.number,
body[main-theme-layout="main-theme-layout-3"] .token.property,
body[main-theme-layout="main-theme-layout-3"] .token.symbol,
body[main-theme-layout="main-theme-layout-3"] .token.tag {
  color: #FF5370;
}

body[main-theme-layout="main-theme-layout-3"] .loader-box.card-loader {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-3"] .my-gallery.gallery-with-description img {
  border: 1px solid #4b5469 !important;
  border-bottom: none !important;
}

body[main-theme-layout="main-theme-layout-4"] {
  color: rgba(255, 255, 255, 0.7);
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .flot-chart-container .legend .table tbody {
  background-color: #36404a;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .flot-chart-container .legend .table tbody .legendLabel {
  padding-left: 5px;
}

body[main-theme-layout="main-theme-layout-4"] .google-visualization-tooltip text {
  fill: rgba(0, 0, 0, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-dark .nav-link,
body[main-theme-layout="main-theme-layout-4"] .nav-pills.nav-dark .nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .loader-wrapper {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .loader-wrapper .loader {
  background-color: #303841 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper {
  /* Main Header start */
  /* Main Header ends */
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header {
  background-color: #36404a;
  box-shadow: 0px 0px 1px 1px rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right li i {
  color: #eeeeee;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .form-inline .form-control-plaintext {
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li a img {
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .media img {
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .media .media-body .txt-dark {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .onhover-show-div {
  background-color: #303841;
  box-shadow: 0 0 2px 2px #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .onhover-show-div:before {
  border-bottom: 7px solid #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .onhover-show-div:after {
  border-bottom: 7px solid #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .notification-dropdown.onhover-show-div li {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .notification-dropdown.onhover-show-div li span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .language-dropdown li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .profile-dropdown li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right .search-form input {
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li a img {
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .media img {
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .media .media-body .txt-dark {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .onhover-show-div {
  background-color: #303841;
  box-shadow: 0 0 2px 2px #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .onhover-show-div:before {
  border-bottom: 7px solid #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .onhover-show-div:after {
  border-bottom: 7px solid #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .notification-dropdown.onhover-show-div li {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .notification-dropdown.onhover-show-div li span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .language-dropdown li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .mega-menu-header .vertical-menu-main .main-nav .main-menu li {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-left {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-left .logo-wrapper a .image-dark {
  display: none;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-left .logo-wrapper a .image-light {
  display: block;
}

@media only screen and (max-width: 991px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .main-header-right .nav-right>ul {
    background-color: #36404a;
    box-shadow: 0 2px 2px 2px #4b5469;
  }
}

@media only screen and (max-width: 575px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .nav-right>ul .search-form .mobile-search {
    filter: brightness(1) invert(100%);
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-main-header .nav-right>ul .search-form .form-control-plaintext {
    background-color: #303841;
    filter: brightness(1) invert(9%) !important;
    border: 1px solid #4b5469;
    color: rgba(255, 255, 255, 0.7);
  }
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper {
  /* sidebar start */
  /* sidebar end */
  /* body start*/
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {
  border-bottom: none !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .custom-card .card-header img {
  background-color: #000;
  opacity: 0.1;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar {
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {
  background-blend-mode: overlay;
  background-color: #17191d;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar.navigation-bordered .sidebar-header {
  border-bottom: 1px solid rgba(241, 241, 241, 0.15);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {
  background-color: #36404a;
  box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {
  color: #ab8ce4;
  border-bottom: 1px solid rgba(241, 241, 241, 0.35);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {
  margin-top: 3px;
  margin-right: 5px;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {
  color: #f3d800;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {
  color: #eeeeee;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top i {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-bottom {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-header .row h3 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-header .breadcrumb-item.active {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body {
  background-color: #303841;
  /* body end*/
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card {
  background-color: #36404a;
  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header {
  background-color: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header h1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header h2,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header h3,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header h4,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header h5,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-header .card-header-right i {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline-2x,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card #animation-box .animate-widget p {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .grid-item img {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .line {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table td {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table thead th {
  border-bottom: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table thead .border-bottom-primary th {
  border-bottom: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger td {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-primary,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-secondary,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-success,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-info,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-warning,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-danger {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-light {
  color: #000;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .thead-light th {
  color: #000;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .double,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .dotted,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table .dashed {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary td {
  border-bottom: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table td {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered th {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-inverse tbody tr:nth-of-type(odd):hover td {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical tr,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical td {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody td {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .card-footer {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .switch .switch-state {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .switch input:checked+.switch-state {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .bg-white {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .business-top-widget .media span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .b-l-light {
  border-left: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .business-card table td {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .business-card table th {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .business-card .logo {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .media .social-sub-title {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .total-value {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .social-icons {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .ct-grid {
  stroke: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .ct-label {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .text-muted {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:before {
  border-bottom: 10px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:after {
  border-bottom: 9px solid #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .calender-widget .cal-date {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form .form-icon {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-dark {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .btn-light {
  color: #303841 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .btn-light:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .border-right {
  border-right: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder .flot-text {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#line-chart rect,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart1 rect,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart2 rect {
  fill: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>rect {
  fill: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>g>g text {
  fill: #b1b1b2;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .radial-bar:after {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num .color-bottom {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .b-r-light {
  border-right: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-labels .ct-label,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-labels .ct-label {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-grid,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-grid,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-grid,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-grid {
  stroke: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #browser-uses-chart svg text,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #website-visiter-chart svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .status-details span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .clipboaard-container .form-control {
  background-color: #303841;
  color: #98a6ad;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .img-thumbnail {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard .media img {
  filter: brightness(0) invert(75%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr+tr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td p,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_info,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_processing,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter input[type="search"] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover>.sorting_1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover>.sorting_1 {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd>.sorting_1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even>.sorting_1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even>.sorting_1 {
  background-color: rgba(53, 59, 74, 0.3);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead td {
  border-bottom: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable input,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody tr {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody td {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even:hover>.sorting_1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover>.sorting_1 {
  background-color: #2c3239;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.hover tbody tr:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td {
  border-top: 1px solid #4b5469;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th:first-child,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td:first-child {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_2,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_3,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_2,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_3 {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card #example-style-3_wrapper #example-style-3 tfoot {
  border-top: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .page-item.disabled .page-link {
  background-color: #36404a;
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .page-link {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .page-link:hover {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .page-item.active .page-link {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .icon {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col+.col {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-container-small {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li:hover {
  background-color: #000;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td span,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .product-table h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:focus,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-selected,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-selected {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a {
  border: 2px solid #4b5469;
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-selected {
  border: 2px solid #ab8ce4;
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a:after,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a:after {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-selected:after,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-active:after,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-active:after {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .scroll-demo {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .search-form input {
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
  filter: brightness(0) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content::before {
  border-left: 7px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
  border-right-color: #4b5469;
  border-left: transparent;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .breadcrumb {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .user-status table td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card .user-status table th {
  border-top: none !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris-daily svg,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris svg,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card #browser-uses-chart svg,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card #website-visiter-chart svg {
  opacity: 0.5;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-des {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show>.nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #viewhtml .render {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {
  border: 1px dotted #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description a>div {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell {
  background: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell input,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell input,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell input,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell input {
  background-color: #303841;
  border-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {
  background-color: #303841;
  border-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-row>.jsgrid-cell {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row>.jsgrid-cell {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row>.jsgrid-cell {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*="jsgrid-pager"] {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 700;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .sub-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {
  color: #ab8ce4 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {
  background-color: #36404a;
  box-shadow: 0 0 2px 2px #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {
  border-bottom: 7px solid #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .border {
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {
  color: #98a6ad;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {
  border-right: none;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .comment-box .media img {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .comment-box p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .comment-box hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover td,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover th {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body ul.the-icons li {
  border: 1px dotted #4b5469;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-agendaWeek-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicDay-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaWeek-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaDay-button {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light:hover {
  background-color: #303841 !important;
  border: 1px solid #303841 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .border-widgets>.row>div+div {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top {
  background-color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top .details h4 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom h5 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li+li {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .default-widget-count h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .default-widget-count span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .icon-bg {
  color: #2e3945;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .left i {
  color: #303841;
  text-shadow: 1px 1px 1px #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {
  fill: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .testimonial-default .slide--item p {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div+div {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .checkbox label::before,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .radio label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {
  column-rule: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {
  border: 2px solid #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .icon-lists div i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .media-body>span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .details {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .widget-joins:before,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .widget-joins:after {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h5,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .social-widget-card span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .b-b-light {
  border-bottom: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .b-r-dark {
  border-right: 1px solid #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .testimonial i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .testimonial p {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .testimonial h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .testimonial span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .grid-showcase span {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .grid-align .row {
  background-color: #4b5469;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .border-style .card {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .offer-style .card {
  border: 1px dashed #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {
  background-color: #36404a;
  color: #98a6ad !important;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {
  border-left: 3px solid #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {
  color: #98a6ad;
  border-right: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {
  border: 1px solid #4b5469;
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {
  background-color: #303841;
  border-color: #4b5469;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .pricing-card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h3 {
  color: rgba(206, 212, 218, 0.3);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-price h1 small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li::before {
  color: rgba(255, 255, 255, 0.15);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .search-page .info-block+.info-block {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper footer {
  border-top: 1px solid #303841;
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .custom-select,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .custom-file-label {
  background: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .page-body-wrapper .footer-fix {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .dt-button-info {
  background-color: #36404a;
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .dt-button-info h2 {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .about .name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu {
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu .nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {
  background-color: #36404a;
  box-shadow: 1px 1px 3px 1px #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {
  border: 5px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu .user-profile .social-media a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu .user-profile .follow span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .status {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .status p {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message {
  background-color: #36404a;
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-history .call-icons ul li {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-history .call-icons ul li a {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper pre {
  background-color: #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .scorlled {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .input-group-air {
  box-shadow: 0 3px 20px 0 #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .input-group-solid .input-group-text,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .input-group-solid .form-control {
  background: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .semilight-bg-color,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .header-bg-color {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item {
  background-color: #36404a;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item.active {
  background-color: #ab8ce4;
  border-color: #ab8ce4;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item:hover,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item:focus {
  z-index: 1;
  text-decoration: none;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-action:hover:not(.active),
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-action:focus {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-flush .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-primary {
  color: #004085;
  background-color: #b8daff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-secondary {
  color: #383d41;
  background-color: #d6d8db;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-success {
  color: #155724;
  background-color: #c3e6cb;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-danger {
  color: #721c24;
  background-color: #f5c6cb;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-warning {
  color: #856404;
  background-color: #ffeeba;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-info {
  color: #0c5460;
  background-color: #bee5eb;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-light {
  color: #818182;
  background-color: #fdfdfe;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {
  color: rgba(255, 255, 255, 0.7);
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box h3,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box h4,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg .authentication-box h6 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video .authentication-box h4,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video .authentication-box h3 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video .authentication-box h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .error-wrapper .maintenance-icons li i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {
  color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .modal-content {
  background-color: #36404a;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .modal-content .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .modal-content .modal-header .close {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .modal-content .modal-footer {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .comingsoon {
  background-blend-mode: overlay;
  background-color: rgba(54, 64, 74, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .comingsoon .comingsoon-inner h5 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .comingsoon .comingsoon-inner .countdown {
  border-top: 1px solid #4b5469;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .comingsoon .comingsoon-inner .countdown .title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .comingsoon .comingsoon-inner img {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerleft {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), rgba(54, 64, 74, 0.9);
  background-blend-mode: overlay;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerleft .text-center img {
  filter: brightness(1) invert(100%);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerleft .social-media li {
  color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .authentication-box h4 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .authentication-box h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .authentication-box h3 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .vertical-menu-main {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap a:focus,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap a:active,
body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap a:hover {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap>li>a.highlighted:before {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap>li>a.highlighted:after {
  background-color: #4b5469;
}

@media (min-width: 1200px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul {
    background: #303841;
    border: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a:hover,
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a:focus,
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a:active,
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a.highlighted {
    color: #ab8ce4;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a.current {
    background-color: #303841;
    color: #ab8ce4;
  }
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .mega-menu .title {
  color: rgba(255, 255, 255, 0.7);
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .mega-menu .galleria-list .galleria>div .username {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .mega-menu .galleria-list .galleria>div .username small {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .mega-menu .list-unstyled div a:hover {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .default-according .card {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .default-according .card .btn-link {
  background-color: #36404a;
  border: 1px solid #36404a;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .default-according .card .text-muted {
  color: #98a6ad !important;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .default-according .bg-primary .btn-link {
  background-color: #ab8ce4;
  border: 1px solid #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .default-according .bg-secondary .btn-link {
  background-color: #26c6da;
  border: 1px solid #26c6da;
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .collapse .card-body {
  background-color: #36404a;
}

@media screen and (max-width: 1660px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-history .call-icons ul li {
    border: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-history .total-time h2 {
    color: rgba(255, 255, 255, 0.7);
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .caller-img img {
    opacity: 0.7;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-box .chat-history .call-content>div {
    background-color: rgba(0, 0, 0, 0.75);
    background-blend-mode: overlay;
  }
}

@media only screen and (max-width: 1366px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .crm-numbers .col {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .crm-numbers .col+.col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .crm-numbers .col+.col+.col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 1199px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .sm {
    background-color: #36404a;
    border: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap .mobile-back {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul li {
    border-top: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a {
    background: #36404a;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a:hover,
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a:focus,
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul a:active {
    background: #36404a;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .chat-menu {
    border-top: 1px solid #4b5469;
    background-color: #36404a;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .error-wrapper .maintenance-icons li i {
    color: #2a3142;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .border-widgets>.row>div:nth-child(1) {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .border-widgets>.row>div:nth-child(2) {
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .crm-numbers .col+.col+.col {
    border-left: 1px solid #4b5469;
  }
}

body[main-theme-layout="main-theme-layout-4"] .page-wrapper .pixelstrap ul {
  background: #36404a;
}

@media only screen and (max-width: 991px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .crm-numbers .col+.col {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 767px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .border-widgets>.row>div+div {
    border-left: 1px solid #4b5469;
  }
}

@media only screen and (max-width: 575px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .user-profile .hovercard .info .user-designation {
    border-top: 1px solid #4b5469;
    border-bottom: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .border-widgets>.row>div+div {
    border-left: 1px solid #4b5469;
  }

  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .widget-joins .border-after-xs:after {
    background-color: #4b5469;
  }
}

@media only screen and (max-width: 480px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .business-card .b-l-light {
    border-left: 1px solid #4b5469 !important;
  }
}

@media only screen and (max-width: 360px) {
  body[main-theme-layout="main-theme-layout-4"] .page-wrapper .border-widgets>.row>div+div+div {
    border-bottom: 1px solid #4b5469;
  }
}

body[main-theme-layout="main-theme-layout-4"] .lg-backdrop {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .lg-outer .lg-thumb-outer {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .drag {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .drag form {
  background: #36404a;
  box-shadow: 0 0 30px #4b5469;
  border: 1px dotted #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .drag form input {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .drag form .help-block {
  text-transform: capitalize;
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .draggable input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .draggable p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .draggable select {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .draggable .radio label::before,
body[main-theme-layout="main-theme-layout-4"] .draggable .checkbox label::before {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .select2-container--default .select2-selection--multiple,
body[main-theme-layout="main-theme-layout-4"] .select2-container--default .select2-selection--single {
  background-color: #303841;
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-container--default .select2-search--inline .select2-search__field {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .select2-container--default .select2-search--dropdown .select2-search__field {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .select2-dropdown {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-primary {
  border-color: #ab8ce4 !important;
  color: #ab8ce4 !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-secondary {
  border-color: #26c6da !important;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-success {
  border-color: #00c292 !important;
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-info {
  border-color: #4099ff !important;
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-warning {
  border-color: #f3d800 !important;
  color: #f3d800 !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-danger {
  border-color: #FF5370 !important;
  color: #FF5370 !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-inverse {
  border-color: #fff !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-primary-fill {
  background-color: #ab8ce4 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-secondary-fill {
  background-color: #26c6da !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-success-fill {
  background-color: #00c292 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-info-fill {
  background-color: #4099ff !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-warning-fill {
  background-color: #f3d800 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-danger-fill {
  background-color: #FF5370 !important;
  color: #fff !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-drpdwn .form-control-inverse-fill {
  background-color: #fff !important;
  color: #000 !important;
}

body[main-theme-layout="main-theme-layout-4"] .select2-container--default.select2-container--disabled .select2-selection--single {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group select.form-control:not([size]):not([multiple]) {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=text],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=email],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=search],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=password],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=number],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=tel],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=date],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=datetime-local],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=time],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=datetime-local],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=month],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=week],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=url],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=file],
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group select {
  border-color: #4b5469;
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=text]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=email]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=search]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=password]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=number]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=tel]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=date]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=time]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=month]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=week]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=url]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group input[type=file]::-webkit-input-placeholder,
body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group select::-webkit-input-placeholder {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group .form-control {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .theme-form .form-group textarea {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .theme-form .form-divider {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .theme-form .form-divider::before {
  background: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .CodeMirror {
  background: #36404a;
  border: 1px solid #98a6ad;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .CodeMirror .CodeMirror-code pre {
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .editor-toolbar {
  border-top: 1px solid #98a6ad;
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .editor-toolbar a {
  color: rgba(255, 255, 255, 0.7) !important;
}

body[main-theme-layout="main-theme-layout-4"] .editor-toolbar a:hover,
body[main-theme-layout="main-theme-layout-4"] .editor-toolbar a.active {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .editor-toolbar i.separator {
  border-left: 1px solid #98a6ad;
  border-right: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .editor-toolbar.disabled-for-preview a:not(.no-disable) {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .editor-preview {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .editor-toolbar.fullscreen,
body[main-theme-layout="main-theme-layout-4"] .editor-preview-side {
  background: #36404a;
  border: 1px solid #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .u-step {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .u-step.active,
body[main-theme-layout="main-theme-layout-4"] .u-step.current {
  background: #ab8ce4;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .u-step-title,
body[main-theme-layout="main-theme-layout-4"] .u-pearl-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .u-step-number {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .u-pearl:before {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .u-pearl-number,
body[main-theme-layout="main-theme-layout-4"] .u-pearl-icon {
  background: #303841;
  border: 2px solid #303841;
}

body[main-theme-layout="main-theme-layout-4"] .u-pearl.disabled .u-pearl-icon,
body[main-theme-layout="main-theme-layout-4"] .u-pearl.disabled .u-pearl-number {
  background: #4b5469;
  border: 2px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .u-pearl.disabled:after {
  background-color: #2e353d;
}

body[main-theme-layout="main-theme-layout-4"] .u-pearl.error:after {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .note-editor.note-frame {
  border-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .note-editor.note-frame .note-editing-area .note-editable {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .swal-modal {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .swal-modal .swal-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .swal-modal .swal-text {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .swal-modal .swal-content__input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .nav-tabs {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .nav-tabs .nav-link.active {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #4b5469 #4b5469 #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .nav-tabs .nav-link:hover,
body[main-theme-layout="main-theme-layout-4"] .nav-tabs .nav-link:focus {
  border-color: #4b5469 #4b5469 #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .nav-tabs .nav-item.show .nav-link {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border-color: #98a6ad #4b5469 #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .nav-tabs.nav-bottom .nav-item .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .nav-tabs.nav-bottom .nav-item .nav-link.focus,
body[main-theme-layout="main-theme-layout-4"] .nav-tabs.nav-bottom .nav-item .nav-link.hover {
  border-color: #36404a #4b5469 #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left .nav-link,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right .nav-link.active {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left .show>.nav-link,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right .show>.nav-link {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-secondary .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-secondary .nav-link:focus,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-secondary .nav-link:hover {
  border-left-color: #26c6da;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-secondary .show>.nav-link {
  border-left-color: #26c6da;
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-secondary .nav-item.show {
  color: #26c6da !important;
  border-left-color: #26c6da;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-success .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-success .nav-link:focus,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-success .nav-link:hover {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-success .show>.nav-link {
  border-left-color: #00c292;
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-left.nav-success .nav-item.show {
  color: #00c292 !important;
  border-left-color: #00c292;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right.nav-info .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right.nav-info .nav-link:focus,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right.nav-info .nav-link:hover {
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right.nav-info .show>.nav-link {
  border-left-color: #4099ff;
  color: #4099ff !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-right.nav-info .nav-item.show {
  color: #4099ff !important;
  border-left-color: #4099ff;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-secondary .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-secondary .nav-link:focus,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-secondary .nav-link:hover {
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-secondary .nav-item.show {
  color: #26c6da !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-success .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-success .nav-link:focus,
body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-success .nav-link:hover {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-4"] .nav-material.nav-success .nav-item.show {
  color: #00c292 !important;
}

body[main-theme-layout="main-theme-layout-4"] .dropdown-divider {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .icon-hover-bottom {
  background-color: #36404a;
  box-shadow: 0px 0px 1px 1px #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .icon-hover-bottom .icon-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .icon-hover-bottom span {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .icon-hover-bottom .form-group input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .icon-hover-bottom .icon-first i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] code {
  background-color: #434f5a;
}

body[main-theme-layout="main-theme-layout-4"] #cd-timeline::before {
  background: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .timeliny {
  border-top: 1px solid #4b5469;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .timeliny::before {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .timeliny .timeliny-dot {
  background-color: #36404a;
  border: 1px solid #fff;
}

body[main-theme-layout="main-theme-layout-4"] .timeliny .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {
  background-color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .todo .todo-list-wrapper #todo-list li .task-container {
  background: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .todo .todo-list-wrapper #todo-list li .task-container .task-label {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .todo .todo-list-wrapper #todo-list li .task-container:hover h4 {
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {
  background: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {
  color: #ab8ce4;
}

body[main-theme-layout="main-theme-layout-4"] .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {
  border: 1px solid #00c292 !important;
}

body[main-theme-layout="main-theme-layout-4"] .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {
  background-color: #36404a;
  border: 1px solid #4b5469;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .ttl-info h6 {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .ttl-info span {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .hovercard .info .title a {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .hovercard .user-image .avatar img {
  border: 10px solid #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .hovercard .user-image .icon-wrapper {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .follow .follow-num {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .profile-img-style .user-name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .user-profile .profile-img-style p {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .introjs-helperLayer {
  background-color: rgba(54, 64, 74, 0.9);
  border: rgba(255, 255, 255, 0.5);
}

body[main-theme-layout="main-theme-layout-4"] .jstree-default .jstree-node,
body[main-theme-layout="main-theme-layout-4"] .jstree-default .jstree-icon {
  color: #434f5a !important;
}

body[main-theme-layout="main-theme-layout-4"] .jstree-default .jstree-anchor {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .jstree-default .jstree-clicked {
  color: #fff;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-4"] .jstree-default .jstree-hovered {
  background-color: #303841;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] span.twitter-typeahead .tt-menu {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] span.twitter-typeahead .tt-suggestion {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] span.twitter-typeahead .tt-suggestion:hover,
body[main-theme-layout="main-theme-layout-4"] span.twitter-typeahead .tt-suggestion:focus {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .typography small {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .blockquote-footer {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper {
  background-color: #36404a;
  box-shadow: 0 0 9px #4b5469;
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .quickview-box:before,
body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .quickview-recent-activity:before {
  background-color: #36404a;
  box-shadow: 0 0 9px #4b5469;
  border-left: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .quickview-box:after,
body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .quickview-recent-activity:after {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .nav-material.nav-tabs .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .nav-material.nav-primary .nav-link.active,
body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .nav-material.nav-primary .nav-link :hover {
  color: #ab8ce4;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .nav-material.nav-primary .nav-item.show,
body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .nav-material.nav-primary .nav-link:focus {
  color: #ab8ce4;
  background-color: transparent;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .modal-header .modal-title {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .modal-header i {
  color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .friend-list-search {
  background-color: #2f3841;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .friend-list-search input {
  background-color: #303841;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .recent-activity .activity-content h6 {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .recent-activity .activity-content hr {
  border-top: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .recent-activity .user-first-letter:after {
  border: 1px dashed #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .quickview-wrapper .chat-box .about .name {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .code-box-copy pre {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .code-box-copy pre code {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .code-box-copy pre[class*="language-"] {
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .code-box-copy .code-box-copy__btn {
  background-color: #303841;
  border: 1px solid #4b5469;
  color: #fff;
}

body[main-theme-layout="main-theme-layout-4"] .code-box-copy code[class*=language-],
body[main-theme-layout="main-theme-layout-4"] .code-box-copy pre[class*=language-] {
  text-shadow: 0px 1px #000;
}

body[main-theme-layout="main-theme-layout-4"] .code-box-copy code[class*=language-] ::selection,
body[main-theme-layout="main-theme-layout-4"] .code-box-copy pre[class*=language-] ::selection {
  text-shadow: none;
  background: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] table.fixedHeader-floating {
  background-color: #303841;
}

body[main-theme-layout="main-theme-layout-4"] .dt-button-info {
  background-color: #36404a;
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .dt-button-info h2 {
  background-color: #36404a;
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] #keytable_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #column-selector_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #auto-fill_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #custom-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #class-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #keyboard-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #multilevel-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #pagelength-btn_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #basic-colreorder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #state-saving_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #real-time_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #basic-fixed-header_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #fixed-header-footer_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #export-button_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #excel-cust-bolder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #cust-json_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #basic-key-table_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #focus-cell_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #responsive_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #new-cons_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #show-hidden-row_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #basic-row-reorder_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #full-row_wrapper .dataTables_paginate,
body[main-theme-layout="main-theme-layout-4"] #rest-column_wrapper .dataTables_paginate {
  border: none;
}

body[main-theme-layout="main-theme-layout-4"] #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,
body[main-theme-layout="main-theme-layout-4"] #example-style-8_wrapper table.dataTable.display tbody tr.odd {
  background-color: #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .error-wrapper {
  background-color: rgba(54, 64, 74, 0.8);
}

body[main-theme-layout="main-theme-layout-4"] .error-wrapper .sub-content {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .b-light {
  border: 1px solid #4b5469 !important;
}

body[main-theme-layout="main-theme-layout-4"] .modal-content {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .modal-content .modal-header {
  border-bottom: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .modal-content .ui-front .form-control {
  background-color: #36404a;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #4b5469;
}

body[main-theme-layout="main-theme-layout-4"] .stepwizard .stepwizard-row:before {
  background-color: #98a6ad;
}

body[main-theme-layout="main-theme-layout-4"] .modal .theme-close {
  background-color: #36404a !important;
}

body[main-theme-layout="main-theme-layout-4"] .token.atrule,
body[main-theme-layout="main-theme-layout-4"] .token.attr-value,
body[main-theme-layout="main-theme-layout-4"] .token.keyword {
  color: #4099ff;
}

body[main-theme-layout="main-theme-layout-4"] .token.boolean,
body[main-theme-layout="main-theme-layout-4"] .token.constant,
body[main-theme-layout="main-theme-layout-4"] .token.deleted,
body[main-theme-layout="main-theme-layout-4"] .token.number,
body[main-theme-layout="main-theme-layout-4"] .token.property,
body[main-theme-layout="main-theme-layout-4"] .token.symbol,
body[main-theme-layout="main-theme-layout-4"] .token.tag {
  color: #FF5370;
}

body[main-theme-layout="main-theme-layout-4"] .loader-box.card-loader {
  background-color: #36404a;
}

body[main-theme-layout="main-theme-layout-4"] .my-gallery.gallery-with-description img {
  border: 1px solid #4b5469 !important;
  border-bottom: none !important;
}

body[main-theme-layout="main-theme-layout-4"] .alert-primary.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .alert-secondary.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .alert-success.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .alert-danger.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .alert-warning.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .alert-info.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .alert-light.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body[main-theme-layout="main-theme-layout-4"] .alert-dark.inverse {
  color: rgba(255, 255, 255, 0.7);
}

body .page-sidebar[navigation-layout="navigation-bordered"] .sidebar-header {
  border-bottom: 1px solid #eeeeee;
}

body .page-sidebar.navigation-bordered .sidebar-header {
  border-bottom: 1px solid #eeeeee;
}

body .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-header>span {
  margin-left: 5px;
}

body .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-menu>li>a i {
  margin-right: 0;
  margin-left: 7px;
}

body .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-menu>li>a i:first-child {
  float: right;
}

body .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-menu>li>a i:last-child {
  float: left;
}

body .page-sidebar[navigation-layout="right-side-menu"] .sidebar-menu>li>a i:first-child {
  float: right;
}

body .page-sidebar[navigation-layout="right-side-menu"] .sidebar-menu>li>a i:last-child {
  float: left;
}

body .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

body .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg .sidebar-user {
  background: transparent;
}

/**=====================
   55. theme layout CSS ends
==========================**/
/**=====================
    56.  Ribbon CSS Start
==========================**/
.ribbon-wrapper,
.ribbon-wrapper-right,
.ribbon-wrapper-bottom,
.ribbon-wrapper-right-bottom {
  position: relative;
  padding-top: 40px;
}

.ribbon-vertical-left-wrapper {
  padding-left: 40px;
  position: relative;
}

.ribbon-overflow {
  overflow: hidden;
}

.ribbon-vertical-right-wrapper {
  padding-right: 40px;
}

.ribbon-wrapper-bottom {
  padding-bottom: 40px;
  padding-top: 0;
}

.ribbon-wrapper-right-bottom {
  padding-right: 40px;
}

.ribbon-content {
  margin-bottom: 0;
}

.ribbon {
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  clear: left;
  position: absolute;
  top: 12px;
  left: 0px;
  color: #fff;
  z-index: 2;
}

.ribbon-space-bottom {
  top: 0px;
}

.ribbon-clip {
  left: -14px;
}

.ribbon-clip:before {
  position: absolute;
  top: 30px;
  left: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2a3142;
  border-right-color: #2a3142;
}

.ribbon-bookmark:before {
  position: absolute;
  top: 0;
  left: 100%;
  display: block;
  width: 0;
  height: 0;
  content: '';
  border: 15px solid #2a3142;
  border-right: 10px solid transparent;
}

.ribbon-right {
  left: auto;
  right: -2px;
}

.ribbon-clip-right {
  right: -14px;
}

.ribbon-clip-right:before {
  position: absolute;
  top: 30px;
  right: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2a3142;
  border-right-color: #2a3142;
}

.ribbon-clip-bottom {
  left: -14px;
  bottom: 12px;
  top: auto;
}

.ribbon-clip-bottom:before {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2a3142;
  border-right-color: #2a3142;
}

.ribbon-clip-bottom-right {
  right: -14px;
  left: auto;
  bottom: 12px;
  top: auto;
}

.ribbon-clip-bottom-right:before {
  position: absolute;
  bottom: 30px;
  right: 0;
  width: 0;
  height: 0;
  content: "";
  border: 7px solid transparent;
  border-top-color: #2a3142;
  border-right-color: #2a3142;
}

.ribbon-bookmark.ribbon-right:before {
  right: 100%;
  left: auto;
  border-right: 15px solid #2a3142;
  border-left: 10px solid transparent;
}

.ribbon-vertical-left {
  clear: none;
  padding: 0 5px;
  height: 70px;
  width: 30px;
  line-height: 70px;
  text-align: center;
  left: 12px;
  top: -2px;
}

.ribbon-vertical-right {
  clear: none;
  padding: 0 5px;
  height: 70px;
  width: 30px;
  line-height: 70px;
  text-align: center;
  top: -2px;
  left: auto;
  right: 12px;
}

.ribbon-bookmark.ribbon-vertical-left:before,
.ribbon-bookmark.ribbon-vertical-right:before {
  top: 100%;
  left: 0;
  margin-top: -14px;
  border-right: 15px solid #2a3142;
  border-bottom: 10px solid transparent;
}

.ribbon-primary {
  background: #ab8ce4;
}

.ribbon-primary {
  background: #ab8ce4;
}

.ribbon-bookmark.ribbon-primary:before {
  border-color: #ab8ce4;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-primary:before {
  border-right-color: #ab8ce4;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-primary:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-primary:before {
  border-right-color: #ab8ce4;
  border-bottom-color: transparent;
}

.ribbon-primary.ribbon-corner:before {
  border-top-color: #ab8ce4;
  border-left-color: #ab8ce4;
}

.ribbon-primary.ribbon-corner.ribbon-right:before {
  border-right-color: #ab8ce4;
  border-left-color: transparent;
}

.ribbon-primary.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #ab8ce4;
}

.ribbon-primary.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #8d63da;
  border-right-color: #8d63da;
}

.ribbon-primary.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #8d63da;
  border-left-color: #8d63da;
}

.ribbon-primary.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #8d63da;
  border-right-color: #8d63da;
}

.ribbon-primary.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #8d63da;
  border-right-color: transparent;
  border-left-color: #8d63da;
}

.ribbon-secondary {
  background: #26c6da;
}

.ribbon-secondary {
  background: #26c6da;
}

.ribbon-bookmark.ribbon-secondary:before {
  border-color: #26c6da;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-secondary:before {
  border-right-color: #26c6da;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-secondary:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-secondary:before {
  border-right-color: #26c6da;
  border-bottom-color: transparent;
}

.ribbon-secondary.ribbon-corner:before {
  border-top-color: #26c6da;
  border-left-color: #26c6da;
}

.ribbon-secondary.ribbon-corner.ribbon-right:before {
  border-right-color: #26c6da;
  border-left-color: transparent;
}

.ribbon-secondary.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #26c6da;
}

.ribbon-secondary.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #1e9faf;
  border-right-color: #1e9faf;
}

.ribbon-secondary.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #1e9faf;
  border-left-color: #1e9faf;
}

.ribbon-secondary.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #1e9faf;
  border-right-color: #1e9faf;
}

.ribbon-secondary.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #1e9faf;
  border-right-color: transparent;
  border-left-color: #1e9faf;
}

.ribbon-success {
  background: #00c292;
}

.ribbon-success {
  background: #00c292;
}

.ribbon-bookmark.ribbon-success:before {
  border-color: #00c292;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-success:before {
  border-right-color: #00c292;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-success:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-success:before {
  border-right-color: #00c292;
  border-bottom-color: transparent;
}

.ribbon-success.ribbon-corner:before {
  border-top-color: #00c292;
  border-left-color: #00c292;
}

.ribbon-success.ribbon-corner.ribbon-right:before {
  border-right-color: #00c292;
  border-left-color: transparent;
}

.ribbon-success.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #00c292;
}

.ribbon-success.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #008f6c;
  border-right-color: #008f6c;
}

.ribbon-success.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #008f6c;
  border-left-color: #008f6c;
}

.ribbon-success.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #008f6c;
  border-right-color: #008f6c;
}

.ribbon-success.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #008f6c;
  border-right-color: transparent;
  border-left-color: #008f6c;
}

.ribbon-danger {
  background: #FF5370;
}

.ribbon-danger {
  background: #FF5370;
}

.ribbon-bookmark.ribbon-danger:before {
  border-color: #FF5370;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-danger:before {
  border-right-color: #FF5370;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-danger:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-danger:before {
  border-right-color: #FF5370;
  border-bottom-color: transparent;
}

.ribbon-danger.ribbon-corner:before {
  border-top-color: #FF5370;
  border-left-color: #FF5370;
}

.ribbon-danger.ribbon-corner.ribbon-right:before {
  border-right-color: #FF5370;
  border-left-color: transparent;
}

.ribbon-danger.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #FF5370;
}

.ribbon-danger.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #ff2046;
  border-right-color: #ff2046;
}

.ribbon-danger.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #ff2046;
  border-left-color: #ff2046;
}

.ribbon-danger.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #ff2046;
  border-right-color: #ff2046;
}

.ribbon-danger.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #ff2046;
  border-right-color: transparent;
  border-left-color: #ff2046;
}

.ribbon-info {
  background: #4099ff;
}

.ribbon-info {
  background: #4099ff;
}

.ribbon-bookmark.ribbon-info:before {
  border-color: #4099ff;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-info:before {
  border-right-color: #4099ff;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-info:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-info:before {
  border-right-color: #4099ff;
  border-bottom-color: transparent;
}

.ribbon-info.ribbon-corner:before {
  border-top-color: #4099ff;
  border-left-color: #4099ff;
}

.ribbon-info.ribbon-corner.ribbon-right:before {
  border-right-color: #4099ff;
  border-left-color: transparent;
}

.ribbon-info.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #4099ff;
}

.ribbon-info.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #0d7eff;
  border-right-color: #0d7eff;
}

.ribbon-info.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #0d7eff;
  border-left-color: #0d7eff;
}

.ribbon-info.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #0d7eff;
  border-right-color: #0d7eff;
}

.ribbon-info.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #0d7eff;
  border-right-color: transparent;
  border-left-color: #0d7eff;
}

.ribbon-light {
  background: #eeeeee;
}

.ribbon-light {
  background: #eeeeee;
}

.ribbon-bookmark.ribbon-light:before {
  border-color: #eeeeee;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-light:before {
  border-right-color: #eeeeee;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-light:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-light:before {
  border-right-color: #eeeeee;
  border-bottom-color: transparent;
}

.ribbon-light.ribbon-corner:before {
  border-top-color: #eeeeee;
  border-left-color: #eeeeee;
}

.ribbon-light.ribbon-corner.ribbon-right:before {
  border-right-color: #eeeeee;
  border-left-color: transparent;
}

.ribbon-light.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #eeeeee;
}

.ribbon-light.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #d5d5d5;
  border-right-color: #d5d5d5;
}

.ribbon-light.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #d5d5d5;
  border-left-color: #d5d5d5;
}

.ribbon-light.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #d5d5d5;
  border-right-color: #d5d5d5;
}

.ribbon-light.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #d5d5d5;
  border-right-color: transparent;
  border-left-color: #d5d5d5;
}

.ribbon-dark {
  background: #2a3142;
}

.ribbon-dark {
  background: #2a3142;
}

.ribbon-bookmark.ribbon-dark:before {
  border-color: #2a3142;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-dark:before {
  border-right-color: #2a3142;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-dark:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-dark:before {
  border-right-color: #2a3142;
  border-bottom-color: transparent;
}

.ribbon-dark.ribbon-corner:before {
  border-top-color: #2a3142;
  border-left-color: #2a3142;
}

.ribbon-dark.ribbon-corner.ribbon-right:before {
  border-right-color: #2a3142;
  border-left-color: transparent;
}

.ribbon-dark.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #2a3142;
}

.ribbon-dark.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #161a23;
  border-right-color: #161a23;
}

.ribbon-dark.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #161a23;
  border-left-color: #161a23;
}

.ribbon-dark.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #161a23;
  border-right-color: #161a23;
}

.ribbon-dark.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #161a23;
  border-right-color: transparent;
  border-left-color: #161a23;
}

.ribbon-warning {
  background: #f3d800;
}

.ribbon-warning {
  background: #f3d800;
}

.ribbon-bookmark.ribbon-warning:before {
  border-color: #f3d800;
  border-right-color: transparent;
}

.ribbon-bookmark.ribbon-right.ribbon-warning:before {
  border-right-color: #f3d800;
  border-left-color: transparent;
}

.ribbon-bookmark.ribbon-vertical-left.ribbon-warning:before,
.ribbon-bookmark.ribbon-vertical-right.ribbon-warning:before {
  border-right-color: #f3d800;
  border-bottom-color: transparent;
}

.ribbon-warning.ribbon-corner:before {
  border-top-color: #f3d800;
  border-left-color: #f3d800;
}

.ribbon-warning.ribbon-corner.ribbon-right:before {
  border-right-color: #f3d800;
  border-left-color: transparent;
}

.ribbon-warning.ribbon-corner.ribbon-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #f3d800;
}

.ribbon-warning.ribbon-clip:before {
  border-color: transparent;
  border-top-color: #c0ab00;
  border-right-color: #c0ab00;
}

.ribbon-warning.ribbon-clip-right:before {
  border-right-color: transparent;
  border-top-color: #c0ab00;
  border-left-color: #c0ab00;
}

.ribbon-warning.ribbon-clip-bottom:before {
  border-top-color: transparent;
  border-bottom-color: #c0ab00;
  border-right-color: #c0ab00;
}

.ribbon-warning.ribbon-clip-bottom-right:before {
  border-top-color: transparent;
  border-bottom-color: #c0ab00;
  border-right-color: transparent;
  border-left-color: #c0ab00;
}

/**=====================
     56. Ribbon CSS Ends
==========================**/
/**=====================
    57. breadcrumb CSS Start
==========================**/
.breadcrumb-colored li a {
  color: #fff;
}

.breadcrumb-colored li.active {
  color: #fff;
  opacity: 0.7;
}

.breadcrumb-colored .breadcrumb-item:before {
  color: #fff;
}

.breadcrumb-colored .breadcrumb-item.txt-dark:before {
  color: #000;
}

.breadcrumb-item.active {
  text-transform: capitalize;
}

/**=====================
    57. breadcrumb CSS ends
==========================**/
/**=====================
    58. Steps  CSS Start
==========================**/
.u-steps {
  margin: 0;
}

.u-step {
  position: relative;
  padding: 12px 20px;
  margin: 0;
  font-size: inherit;
  color: #a3afb7;
  vertical-align: top;
  background-color: #eeeeee;
  border-radius: 0;
}

.u-step-icon {
  float: left;
  margin-right: .5em;
  font-size: 20px;
}

.u-step-number {
  position: absolute;
  top: 50%;
  left: 20px;
  width: 40px;
  height: 40px;
  font-size: 24px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  background: #ced7da;
  border-radius: 50%;
  transform: translateY(-50%);
  font-family: Open Sans;
}

.u-step-number~.u-step-desc {
  min-height: 40px;
  margin-left: 50px;
}

.u-step-title {
  margin-bottom: 0;
  font-size: 20px;
  color: #526069;
}

.u-step-desc {
  text-align: left;
}

.u-step-desc p {
  margin-bottom: 0;
}

.u-steps-vertical {
  flex-direction: column;
}

.u-step.active,
.u-step.current {
  color: #fff;
  background-color: #ab8ce4;
}

.u-step.active .u-step-title,
.u-step.current .u-step-title {
  color: #fff;
}

.u-step.active .u-step-number,
.u-step.current .u-step-number {
  color: #ab8ce4;
  background-color: #fff;
}

.u-step.disabled {
  color: #cccccc;
  pointer-events: none;
  cursor: auto;
}

.u-step.disabled .u-step-title {
  color: #cccccc;
}

.u-step.disabled .u-step-number {
  background-color: #cccccc;
}

.u-step.error {
  color: #fff;
  background-color: #FF5370;
}

.u-step.error .u-step-title {
  color: #fff;
}

.u-step.error .u-step-number {
  color: #FF5370;
  background-color: #fff;
}

.u-step.done {
  color: #fff;
  background-color: #00c292;
}

.u-step.done .u-step-title {
  color: #fff;
}

.u-step.done .u-step-number {
  color: #00c292;
  background-color: #fff;
}

.u-steps-lg .u-step {
  font-size: 16px;
}

.u-steps-lg .u-step-icon,
.u-steps-lg .u-step-title {
  font-size: 22px;
}

.u-steps-lg .u-step-number {
  width: 46px;
  height: 46px;
  font-size: 28px;
  line-height: 46px;
}

.u-steps-lg .u-step-number~.u-step-desc {
  min-height: 46px;
  margin-left: 56px;
}

.u-steps-sm .u-step {
  font-size: 12px;
}

.u-steps-sm .u-step-icon,
.u-steps-sm .u-step-title {
  font-size: 18px;
}

.u-steps-sm .u-step-number {
  width: 30px;
  height: 30px;
  font-size: 24px;
  line-height: 30px;
}

.u-steps-sm .u-step-number~.u-step-desc {
  min-height: 30px;
  margin-left: 40px;
}

.u-steps-xs .u-step {
  font-size: 10px;
}

.u-steps-xs .u-step-icon,
.u-steps-xs .u-step-title {
  font-size: 16px;
}

.u-steps-xs .u-step-number {
  width: 24px;
  height: 24px;
  font-size: 20px;
  line-height: 24px;
}

.u-steps-xs .u-step-number~.u-step-desc {
  min-height: 24px;
  margin-left: 34px;
}

.u-pearl {
  position: relative;
  padding: 0;
  margin: 0;
  text-align: center;
}

.u-pearl:after {
  position: absolute;
  top: 18px;
  z-index: 0;
  width: 50%;
  height: 4px;
  content: "";
  background-color: #eeeeee;
}

.u-pearl:before {
  position: absolute;
  top: 18px;
  z-index: 0;
  width: 50%;
  height: 4px;
  content: "";
  background-color: #eeeeee;
  left: 0;
}

.u-pearl:after {
  right: 0;
}

.u-pearl:first-child:before,
.u-pearl:last-child:after {
  display: none !important;
}

.u-pearl-icon {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 36px;
  height: 36px;
  line-height: 32px;
  color: #fff;
  text-align: center;
  background: #cccccc;
  border: 2px solid #cccccc;
  border-radius: 50%;
}

.u-pearl-icon i {
  position: absolute;
  top: 7px;
  left: 8px;
}

.u-pearl-icon .icon-check {
  left: 7px;
}

.u-pearl-number {
  position: relative;
  z-index: 1;
  display: inline-block;
  width: 36px;
  height: 36px;
  line-height: 32px;
  color: #fff;
  text-align: center;
  background: #cccccc;
  border: 2px solid #cccccc;
  border-radius: 50%;
  font-size: 18px;
}

.u-pearl-icon {
  font-size: 18px;
}

.u-pearl-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  margin-top: .5em;
  margin-bottom: 0;
  font-size: 16px;
  color: #526069;
}

.u-pearl.active:after,
.u-pearl.active:before {
  background-color: #ab8ce4;
}

.u-pearl.current:after,
.u-pearl.current:before {
  background-color: #ab8ce4;
}

.u-pearl.active .u-pearl-icon,
.u-pearl.active .u-pearl-number {
  color: #ab8ce4;
  background-color: #fff;
  border-color: #ab8ce4;
  transform: scale(1.3);
}

.u-pearl.current .u-pearl-icon,
.u-pearl.current .u-pearl-number {
  color: #ab8ce4;
  background-color: #fff;
  border-color: #ab8ce4;
  transform: scale(1.3);
}

.u-pearl.disabled {
  pointer-events: none;
  cursor: auto;
}

.u-pearl.disabled:after,
.u-pearl.disabled:before {
  background-color: #eeeeee;
}

.u-pearl.disabled .u-pearl-icon,
.u-pearl.disabled .u-pearl-number {
  color: #fff;
  background-color: #cccccc;
  border-color: #cccccc;
}

.u-pearl.error:before {
  background-color: #ab8ce4;
}

.u-pearl.error:after {
  background-color: #eeeeee;
}

.u-pearl.error .u-pearl-icon,
.u-pearl.error .u-pearl-number {
  color: #FF5370;
  background-color: #fff;
  border-color: #FF5370;
}

.u-pearl.done:after,
.u-pearl.done:before {
  background-color: #ab8ce4;
}

.u-pearl.done .u-pearl-icon,
.u-pearl.done .u-pearl-number {
  color: #fff;
  background-color: #ab8ce4;
  border-color: #ab8ce4;
}

.u-pearls-lg .u-pearl:after,
.u-pearls-lg .u-pearl:before {
  top: 20px;
}

.u-pearls-lg .u-pearl-title {
  font-size: 18px;
}

.u-pearls-lg .u-pearl-icon,
.u-pearls-lg .u-pearl-number {
  width: 40px;
  height: 40px;
  line-height: 36px;
}

.u-pearls-lg .u-pearl-icon,
.u-pearls-lg .u-pearl-number {
  font-size: 20px;
}

.u-pearls-sm .u-pearl:after,
.u-pearls-sm .u-pearl:before {
  top: 16px;
}

.u-pearls-sm .u-pearl-title {
  font-size: 14px;
}

.u-pearls-sm .u-pearl-icon {
  width: 32px;
  height: 32px;
  line-height: 28px;
}

.u-pearls-sm .u-pearl-number {
  width: 32px;
  height: 32px;
  line-height: 28px;
  font-size: 16px;
}

.u-pearls-sm .u-pearl-icon {
  font-size: 14px;
}

.u-pearls-xs .u-pearl:after,
.u-pearls-xs .u-pearl:before {
  top: 12px;
  height: 2px;
}

.u-pearls-xs .u-pearl-title {
  font-size: 12px;
}

.u-pearls-xs .u-pearl-icon {
  width: 24px;
  height: 24px;
  line-height: 20px;
}

.u-pearls-xs .u-pearl-number {
  width: 24px;
  height: 24px;
  line-height: 20px;
  font-size: 12px;
}

.u-pearls-xs .u-pearl-icon {
  font-size: 12px;
}

.u-pearl.current .u-pearl-icon i {
  left: 6px;
}

/**=====================
    58. Steps  CSS ends
==========================**/
/**=====================
   59. Customizer  CSS Start
==========================**/
.main-theme-layout-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.floated-customizer-panel {
  background-color: #fff;
  position: fixed;
  right: -85px;
  box-shadow: 0 15px 125px rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  color: #2a3142;
  bottom: 70px;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: all 0.7s ease;
  transform: translateY(110%) scale(0);
  height: 650px;
  overflow: auto;
  width: 0;
}

.floated-customizer-panel.active {
  visibility: visible;
  width: 400px;
  right: 35px;
  opacity: 1;
  transform: translateY(0px) scale(1);
}

.floated-customizer-panel .close-customizer-btn {
  position: absolute;
  top: 30px;
  right: 30px;
  cursor: pointer;
  transition: all 0.1s ease;
}

.floated-customizer-panel .customizer-title {
  border-bottom: 1px solid #eeeeee;
  padding: 20px 20px 15px;
}

.floated-customizer-panel .customizer-title h5 {
  margin-bottom: 0;
  font-weight: 700;
}

.floated-customizer-panel .fcp-group {
  padding: 20px;
  border-bottom: 1px solid #eeeeee;
}

.floated-customizer-panel .fcp-header {
  font-weight: 500;
  font-family: inherit;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  color: #2a3142;
  font-size: 1.08rem;
}

.floated-customizer-panel .fcp-header span {
  display: inline-block;
  vertical-align: middle;
}

.floated-customizer-panel .fcp-header .icon-w {
  display: inline-block;
  vertical-align: middle;
  color: #4099ff;
  font-size: 24px;
  margin-right: 10px;
}

.floated-customizer-panel .fcp-header .icon-w i {
  display: inline-block;
  vertical-align: middle;
}

.floated-customizer-panel .fcp-content .navigation-color-option .radio {
  height: 40px;
  width: 40px;
  display: inline-block;
}

.floated-customizer-panel .fcp-content .navigation-color-option .radio label:before {
  width: 35px;
  height: 35px;
  border-radius: 5px;
}

.floated-customizer-panel .fcp-content .navigation-color-option .radio label:after {
  width: 25px;
  height: 25px;
  border-radius: 5px;
}

.floated-customizer-panel .fcp-content .fcp-group-header {
  font-weight: 600;
  font-family: inherit;
  text-transform: uppercase;
  margin-bottom: 10px;
  padding-bottom: 10px;
  color: #fff;
  background-color: #ab8ce4;
  padding-top: 10px;
  text-align: center;
  border-radius: 4px;
}

.floated-customizer-panel .fcp-content .fcp-group-header-sub {
  color: #2a3142;
  font-weight: 600;
  font-family: inherit;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .nav-tabs {
  margin-bottom: 20px;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .nav-tabs .nav-item {
  width: 100%;
  font-weight: 500;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .nav-tabs .nav-item .nav-link.active {
  background-color: #ab8ce4;
  color: #fff;
  padding: 6px;
  font-size: 15px;
  border-radius: 5px;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 7px;
  margin-bottom: 7px;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field label {
  font-size: .9rem;
  flex: 0 0 54%;
  padding-right: 10px;
  margin: 0;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors {
  margin-left: auto;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-selector {
  display: inline-block;
  vertical-align: middle;
  height: 14px;
  width: 14px;
  border-radius: 10px;
  margin: 0px 5px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-selector.selected,
.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-selector:hover {
  box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 4px #88b8ff;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-bright {
  background-color: #4099ff;
  border: 1px solid #4099ff;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-dark {
  background-color: #2a3142;
  border: 1px solid #2a3142;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-light {
  background-color: #fff;
  border: 1px solid #eeeeee;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-transparent {
  background-color: #fff;
  border: 1px solid #eeeeee;
  position: relative;
  overflow: hidden;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-transparent:before {
  content: "";
  width: 4px;
  height: 4px;
  position: absolute;
  top: 6px;
  left: 6px;
  background-color: #cccccc;
}

.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-transparent:after {
  content: "";
  width: 4px;
  height: 4px;
  position: absolute;
  top: 2px;
  left: 2px;
  background-color: #cccccc;
}

.floated-customizer-btn {
  animation-name: jumpUp;
  animation-duration: 0.5s;
  animation-delay: 0.2s;
  animation-fill-mode: both;
  z-index: 9;
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: #ab8ce4;
  box-shadow: 0 5px 10px rgba(19, 19, 19, 0.17);
  border-radius: 5px;
  color: #fff;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  vertical-align: middle;
  font-size: 1.08rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.floated-customizer-btn.third-floated-btn {
  right: 35px;
}

.floated-customizer-btn>.icon-w {
  line-height: 1;
  vertical-align: middle;
  display: inline-block;
  animation: os-rotating 2s linear infinite;
}

.floated-customizer-btn>.icon-w i {
  font-size: 24px;
}

.floated-customizer-btn>span {
  margin-left: 10px;
  vertical-align: middle;
  display: inline-block;
  font-weight: 500;
}

.floated-customizer-btn>span+span {
  margin-left: 5px;
}

.floated-customizer-btn:hover {
  transform: scale(1.05);
  background-color: #2a3142;
}

.floated-customizer-panel::-webkit-scrollbar {
  width: 3px;
}

.floated-customizer-panel::-webkit-scrollbar-thumb {
  background-color: #ab8ce4;
}

.floated-customizer-panel::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #cccccc;
}

.nav-navigation-main {
  border-bottom: 1px solid #ab8ce4;
}

.nav-navigation-main li {
  width: 50%;
  text-align: center;
}

.nav-navigation-color-main {
  border-bottom: 1px solid #ab8ce4;
}

.nav-navigation-color-main li {
  width: 33.33%;
  text-align: center;
}

/*======= Brand css starts ===========*/
[semilight-bg-color='bg-primary'],
[header-bg-color='bg-primary'] {
  background-color: #ab8ce4 !important;
}

[header-bg-color='bg-primary'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-primary'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-primary'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-primary'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-primary'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #ab8ce4 !important;
}

[semilight-bg-color='bg-primary-light-color'],
[header-bg-color='bg-primary-light-color'] {
  background-color: #8d63da !important;
}

[header-bg-color='bg-primary-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-primary-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-primary-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-primary-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-primary-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #ab8ce4 !important;
}

[semilight-bg-color='bg-secondary'],
[header-bg-color='bg-secondary'] {
  background-color: #26c6da !important;
}

[header-bg-color='bg-secondary'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-secondary'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-secondary'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-secondary'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-secondary'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #26c6da !important;
}

[semilight-bg-color='bg-secondary-light-color'],
[header-bg-color='bg-secondary-light-color'] {
  background-color: #1a8b99 !important;
}

[header-bg-color='bg-secondary-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-secondary-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-secondary-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-secondary-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-secondary-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #26c6da !important;
}

[semilight-bg-color='bg-success'],
[header-bg-color='bg-success'] {
  background-color: #00c292 !important;
}

[header-bg-color='bg-success'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-success'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-success'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-success'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-success'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #00c292 !important;
}

[semilight-bg-color='bg-success-light-color'],
[header-bg-color='bg-success-light-color'] {
  background-color: #007658 !important;
}

[header-bg-color='bg-success-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-success-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-success-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-success-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-success-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #00c292 !important;
}

[semilight-bg-color='bg-danger'],
[header-bg-color='bg-danger'] {
  background-color: #FF5370 !important;
}

[header-bg-color='bg-danger'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-danger'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-danger'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-danger'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-danger'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #FF5370 !important;
}

[semilight-bg-color='bg-danger-light-color'],
[header-bg-color='bg-danger-light-color'] {
  background-color: #ff0730 !important;
}

[header-bg-color='bg-danger-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-danger-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-danger-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-danger-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-danger-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #FF5370 !important;
}

[semilight-bg-color='bg-info'],
[header-bg-color='bg-info'] {
  background-color: #4099ff !important;
}

[header-bg-color='bg-info'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-info'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-info'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-info'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-info'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #4099ff !important;
}

[semilight-bg-color='bg-info-light-color'],
[header-bg-color='bg-info-light-color'] {
  background-color: #0071f3 !important;
}

[header-bg-color='bg-info-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-info-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-info-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-info-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-info-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #4099ff !important;
}

[semilight-bg-color='bg-light'],
[header-bg-color='bg-light'] {
  background-color: #eeeeee !important;
}

[header-bg-color='bg-light'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-light'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-light'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-light'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-light'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #eeeeee !important;
}

[semilight-bg-color='bg-light-light-color'],
[header-bg-color='bg-light-light-color'] {
  background-color: #c8c8c8 !important;
}

[header-bg-color='bg-light-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-light-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-light-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-light-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-light-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #eeeeee !important;
}

[semilight-bg-color='bg-dark'],
[header-bg-color='bg-dark'] {
  background-color: #2a3142 !important;
}

[header-bg-color='bg-dark'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-dark'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-dark'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-dark'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-dark'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #2a3142 !important;
}

[semilight-bg-color='bg-dark-light-color'],
[header-bg-color='bg-dark-light-color'] {
  background-color: #0c0e13 !important;
}

[header-bg-color='bg-dark-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-dark-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-dark-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-dark-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-dark-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #2a3142 !important;
}

[semilight-bg-color='bg-warning'],
[header-bg-color='bg-warning'] {
  background-color: #f3d800 !important;
}

[header-bg-color='bg-warning'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-warning'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-warning'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-warning'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-warning'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #f3d800 !important;
}

[semilight-bg-color='bg-warning-light-color'],
[header-bg-color='bg-warning-light-color'] {
  background-color: #a79400 !important;
}

[header-bg-color='bg-warning-light-color'] img {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-warning-light-color'] .txt-dark {
  color: #fff !important;
}

[header-bg-color='bg-warning-light-color'] .search-form input {
  filter: brightness(0) invert(1);
}

[header-bg-color='bg-warning-light-color'] .switch input:checked+.switch-state {
  background-color: #cccccc;
}

[header-bg-color='bg-warning-light-color'] .nav-right .notification {
  border: 1px solid #fff;
  padding: 2px 4px !important;
  background-color: #f3d800 !important;
}

/*======= Brand css ends ===========*/
/**=====================
     59.Customizer CSS Ends
==========================**/
/**=====================
    60. RTL CSS Start
==========================**/
.rtl .modal-dialog .modal-content .modal-body p a {
  margin-left: 0;
}

.rtl .drag-box fieldset .component .form-group .text-lg-left {
  text-align: right !important;
}

.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn,
.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn-right,
.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .checkbox-radius {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .drag-box fieldset .component .form-group .input-group #prependedcheckbox {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rtl .drag-box fieldset .component .form-group .input-group #appendedcheckbox {
  border-right-color: #ddd;
}

.rtl .drag-box fieldset .component .form-group .input-group #buttondropdown {
  margin-right: 0;
  margin-right: initial;
  margin-left: -1px;
}

.rtl .drag form {
  text-align: right;
}

.rtl .drag form input {
  text-align: right;
}

.rtl .drag form label {
  text-align: right !important;
}

.rtl .drag form .form-group .input-group .input-group-prepend .btn,
.rtl .drag form .form-group .input-group .input-group-prepend .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.rtl .drag form .form-group .input-group .input-group-prepend .btn-right,
.rtl .drag form .form-group .input-group .input-group-prepend .checkbox-radius {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .drag form .form-group .input-group #buttondropdown {
  margin-right: 0;
  margin-right: initial;
  margin-left: -1px;
}

.rtl .draggable label {
  text-align: right;
}

.rtl .form-builder-column .tab-content .tab-pane .theme-form .ui-draggable .input-group>.input-group-prepend>.input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.rtl .form-builder-column #pills-tabContent .theme-form .form-group .input-group #buttondropdown,
.rtl .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group #buttondropdown {
  margin-right: 0;
  margin-right: initial;
  margin-left: 15px;
}

.rtl .form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-btn button,
.rtl .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-btn button {
  border-radius: 4px !important;
}

.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .text-lg-left {
  text-align: right !important;
}

.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn,
.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .input-group-text {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn-right,
.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .checkbox-radius {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #prependedcheckbox {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #appendedcheckbox {
  border-right-color: #ddd;
}

.rtl .form-builder .component .form-group .input-group #buttondropdown {
  margin-right: 0;
  margin-right: initial;
  margin-left: -1px;
}

.rtl .form-builder .component .form-group .pl-md-radios {
  padding-right: 37px;
  padding-left: 0;
  padding-left: initial;
}

.rtl .page-main-header .main-header-right .nav-right .notification {
  right: -9px;
}

.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar {
  transform: translate(180px);
}

.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-user,
.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-header {
  text-align: left !important;
}

.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover {
  transform: translate(0px);
}

.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-user {
  text-align: center !important;
}

.rtl .page-wrapper .sidebar-close .page-sidebar {
  transform: translate(255px);
}

@media only screen and (max-width: 1199px) {
  .rtl .crm-numbers .col+.col+.col {
    border-left: none;
  }

  .rtl .business-card .b-r-light {
    border-right: none !important;
  }

  .rtl .business-card table {
    width: 60%;
    margin: 20px auto 0 auto;
  }
}

@media only screen and (max-width: 991px) {
  .rtl .page-wrapper .page-body-wrapper .page-header .breadcrumb {
    float: right;
  }

  .rtl .page-wrapper .page-body-wrapper .page-sidebar~.page-body {
    margin-right: 0px !important;
  }
}

.rtl .page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar~.page-body {
  margin-right: 0 !important;
  transition: all 0.3s ease;
}

.rtl .page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar-open {
  right: -150px;
  left: auto;
  left: initial;
  transition: all 0.5s ease;
}

.rtl .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar~.page-body {
  margin-right: 150px !important;
  margin-left: 0;
  transition: all 0.3s ease;
}

.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-body {
  margin-left: 0 !important;
  margin-left: initial !important;
  margin-right: 75px !important;
}

.rtl .page-wrapper .sidebar-hover .page-sidebar:hover .sidebar-menu .sidebar-header {
  text-align: right !important;
}

.rtl .whether-widget .whether-widget-top .details {
  text-align: left;
  left: 20px;
  right: auto;
  right: initial;
}

.rtl .vertical-menu-mt .page-header div .pull-right {
  float: right;
}

.rtl .page-wrapper .sidebar-icon .page-sidebar {
  left: auto;
  left: initial;
  right: 0;
}

.rtl .page-wrapper .sidebar-icon .page-sidebar~.page-body {
  margin-left: 0;
  margin-left: initial;
}

.rtl .search-page .nav i {
  margin-left: 10px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .alert {
  text-align: right;
}

.rtl .sm li {
  direction: rtl;
  text-align: right;
}

.rtl .sm .mobile-back .pl-2 {
  padding-right: 4px !important;
  padding-left: 0 !important;
  padding-left: initial !important;
}

.rtl .vertical-menu-main #main-nav #main-menu li a i {
  margin-left: 8px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .pixelstrap a .sub-arrow {
  right: auto;
  left: 5px;
}

@media (min-width: 1200px) {
  .rtl .pixelstrap ul:not(.mega-menu) li a:before {
    left: auto;
    left: initial;
    right: 20px;
  }

  .rtl .pixelstrap a .sub-arrow {
    right: auto;
    right: initial;
    left: 3px;
  }
}

.rtl .business-top-widget .media .media-body {
  margin-right: 0;
  margin-right: initial;
  margin-left: 40px;
}

.rtl .business-chart-widget .icon.text-md-right {
  text-align: left !important;
}

.rtl .business-chart-widget .icon-bg {
  left: -50px;
  right: auto;
  right: initial;
}

.rtl .social-widget .mr-3 {
  margin-left: 1rem !important;
}

.rtl .social-widget .social-icons {
  margin-right: 10px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .review-box .testimonial .content:before,
.rtl .review-box .testimonial .content:after {
  right: 40px;
  left: auto;
  left: initial;
}

.rtl code[class*=language-],
.rtl pre[class*=language-] {
  text-align: right;
}

@media (min-width: 768px) {
  .rtl .ecommerce-widget .text-md-right {
    text-align: left !important;
  }
}

@media (max-width: 767px) {
  .rtl .ecommerce-widget .text-md-right {
    text-align: left !important;
  }

  .rtl .business-chart-widget .icon-bg {
    left: -27px;
  }

  .rtl .business-card table {
    margin: 0px auto 0 auto !important;
  }

  .rtl .bar-chart-widget .earning-details i {
    left: -147px !important;
  }
}

@media only screen and (max-width: 575px) {
  .rtl .business-card table {
    width: 100% !important;
  }
}

.rtl .ml-2 {
  margin-right: 0.5rem !important;
}

.rtl .product-stts {
  display: inline-block;
}

.rtl .product-stts .ml-1 {
  margin-right: 0.25rem !important;
  margin-left: 0 !important;
  margin-left: initial !important;
}

.rtl .customer-review .media-body .cust-name {
  margin-left: 10px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .pr-2 {
  padding-right: 0 !important;
  padding-right: initial !important;
  padding-left: 0.5rem !important;
}

.rtl .mega-menu .default-according .card .btn-link {
  text-align: right;
}

.rtl .mega-menu .default-according.style-1 button[aria-expanded="true"]:before,
.rtl .mega-menu .default-according.style-1 button[aria-expanded="false"]:before {
  right: auto;
  right: initial;
  left: 20px;
}

.rtl .search-form input {
  background-position: 5%;
  text-align: right;
}

.rtl .pull-right {
  float: left;
}

.rtl .card {
  text-align: right;
}

.rtl .card .card-header .card-header-right {
  left: 20px;
  right: auto;
  right: initial;
}

.rtl .form-inline .form-group {
  margin-left: 15px;
  margin-right: 0;
}

.rtl .icon-hover-bottom .icon-title {
  text-align: right;
}

.rtl .floated-customizer-btn.third-floated-btn {
  left: 35px;
  right: auto;
  right: initial;
}

.rtl .floated-customizer-btn>span {
  margin-right: 10px;
}

.rtl .breadcrumb-item+.breadcrumb-item {
  padding-right: 0.5rem;
  padding-left: 0;
  padding-left: initial;
}

.rtl .breadcrumb-item+.breadcrumb-item::before {
  padding-left: 0.5rem;
  padding-right: 0;
  padding-right: initial;
}

.rtl .floated-customizer-panel {
  text-align: right;
  left: -85px;
  right: auto;
  right: initial;
}

.rtl .floated-customizer-panel.active {
  left: 35px;
  right: auto;
  right: initial;
}

.rtl .floated-customizer-panel .close-customizer-btn {
  left: 30px;
  right: auto;
  right: initial;
}

.rtl .floated-customizer-panel ul {
  padding-right: 0;
}

.rtl .radio label {
  padding-left: 0;
  padding-right: 15px;
}

.rtl .radio label::before {
  right: 0;
  margin-right: -20px;
  left: auto;
  left: initial;
}

.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {
  text-align: right;
}

.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>a>.fa-angle-right {
  vertical-align: 7px;
}

.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i {
  margin-left: 7px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu {
  padding-right: 0;
  text-align: right;
  right: 135px;
}

.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {
  text-align: right;
}

.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>.fa {
  margin-right: 10px;
}

.rtl .page-wrapper .page-body-wrapper .page-sidebar~.page-body {
  margin-right: 250px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .page-wrapper .page-body-wrapper .page-header .row h3 {
  text-align: right;
}

.rtl .page-wrapper .page-body-wrapper .footer-fix {
  margin-right: 250px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .page-wrapper .sidebar-close .page-body {
  margin-right: 0 !important;
}

.rtl .page-main-header .main-header-right .nav-right {
  text-align: left;
}

.rtl .page-main-header .main-header-right .nav-right ul li {
  margin-left: 0;
  margin-left: initial;
  text-align: right;
}

.rtl .page-main-header .main-header-right .nav-right ul li.onhover-dropdown {
  margin-right: 20px;
}

.rtl .page-main-header .main-header-right .nav-right ul li.onhover-dropdown:hover .onhover-show-div:before {
  right: 10px;
  left: auto;
  left: initial;
}

.rtl .page-main-header .main-header-right .nav-right ul li.onhover-dropdown:hover .onhover-show-div:after {
  right: 10px;
  left: auto;
  left: initial;
}

.rtl .page-main-header .main-header-right .nav-right ul li i.ml-2 {
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
  margin-left: initial !important;
}

.rtl .page-main-header .main-header-right .nav-right ul li .pull-right {
  margin-right: 0 !important;
  margin-right: initial !important;
  margin-left: 0.5rem !important;
}

.rtl .page-main-header .main-header-right .nav-right .language-dropdown {
  text-align: right;
}

.rtl .page-main-header .main-header-right .nav-right .language-dropdown li a i {
  margin-left: 10px;
}

.rtl .page-main-header .main-header-right .nav-right .profile-dropdown li i {
  margin-left: 10px;
}

.rtl ul.notification-dropdown.onhover-show-div {
  right: auto;
  right: initial;
  left: -30px;
  padding-right: 0;
}

.rtl ul.notification-dropdown.onhover-show-div:before {
  right: inherit !important;
  left: 35px !important;
}

.rtl ul.notification-dropdown.onhover-show-div:after {
  right: inherit !important;
  left: 35px !important;
}

.rtl ul.notification-dropdown.onhover-show-div li {
  margin-right: 0 !important;
}

.rtl ul.notification-dropdown.onhover-show-div li span.badge {
  margin-left: 0 !important;
  margin-left: initial !important;
}

.rtl ul.notification-dropdown.onhover-show-div li .notification-icon {
  margin-left: 20px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .alert i {
  margin-left: 5px;
  margin-right: 0;
}

.rtl .inverse.alert-dismissible {
  padding: 13px 65px 13px 20px;
}

.rtl .inverse i {
  left: auto;
  left: initial;
  right: 0;
}

.rtl .alert-primary.inverse:before {
  border-right: 7px solid #ab8ce4;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-secondary.inverse:before {
  border-right: 7px solid #26c6da;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-success.inverse:before {
  border-right: 7px solid #00c292;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-danger.inverse:before {
  border-right: 7px solid #FF5370;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-warning.inverse:before {
  border-right: 7px solid #f3d800;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-info.inverse:before {
  border-right: 7px solid #4099ff;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-light.inverse:before {
  border-right: 7px solid #eeeeee;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-dark.inverse:before {
  border-right: 7px solid #2a3142;
  right: 54px;
  left: auto;
  left: initial;
  border-left: 0;
  border-left: initial;
}

.rtl .alert-dismissible {
  padding: 13px 20px 13px 65px;
}

.rtl .alert-dismissible .close {
  left: 0;
  right: auto;
  right: initial;
}

.rtl .icofont.icofont-truck {
  display: inline-block;
}

.rtl .blog-box .blog-details {
  padding-left: 20px;
  text-align: right;
}

.rtl .blog-box .blog-details .blog-social {
  padding-right: 0;
}

.rtl .blog-box .blog-details .blog-social li {
  padding-left: 40px;
  padding-right: 0;
  padding-right: initial;
}

.rtl .blog-box .blog-details .blog-social li:first-child {
  border-left: 1px solid #777777;
  border-right: 0;
  border-right: initial;
  padding-left: 40px;
  padding-right: 0;
  padding-right: initial;
}

.rtl .blog-box .blog-details .blog-social li+li {
  margin-right: 30px;
  margin-left: 0;
  margin-left: initial;
  padding-left: 0;
}

.rtl .blog-box .blog-details-main .blog-social li {
  border-left: 1px solid;
  border-right: 0;
  border-right: initial;
}

.rtl .blog-box .blog-details-main .blog-social li:last-child {
  border-left: none;
}

.rtl .blog-box .blog-date span {
  font-size: 36px;
  font-weight: 500;
  padding-left: 5px;
}

.rtl .card {
  text-align: right;
}

.rtl .card .card-header .card-header-right {
  left: 20px;
  right: auto;
  right: initial;
}

.rtl .card .card-header .card-header-right .card-option {
  text-align: left;
}

.rtl .card .card-header .card-header-right .card-option.list-unstyled {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}

.rtl .card.full-card {
  left: 0;
  right: auto;
  right: initial;
}

.rtl .comment-box .media img {
  margin-left: 45px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .comment-box .media h6 {
  text-align: right;
}

.rtl .comment-box ul ul {
  margin-right: 135px;
  margin-left: 0;
  margin-left: initial;
  padding-right: 0;
}

.rtl .comment-box .comment-social {
  text-align: left;
}

.rtl .comment-box .comment-social li {
  padding-left: 0;
  padding-right: 20px;
}

.rtl .comment-box .comment-social li:first-child {
  border-left: 1px solid #ddd;
  border-right: 0;
  border-right: initial;
  padding-right: 0;
  padding-left: 20px;
}

.rtl .business-card table tr th {
  padding-left: 15px;
  padding-right: 0;
  text-align: left;
  width: 91px;
}

.rtl .social-widget .radial-bar {
  margin-right: 0;
  margin-left: 16px;
}

.rtl .button-builder-wrap .form-group .btn {
  margin-left: 15px;
  margin-right: 0;
}

.rtl .button-builder ul.the-icons {
  padding-right: 0 !important;
}

.rtl .calendar-wrap .fc {
  direction: rtl;
  text-align: right;
}

.rtl .calendar-wrap .fc .fc-toolbar .fc-left {
  float: right;
}

.rtl .calendar-wrap .fc .fc-toolbar .fc-right {
  float: left;
}

.rtl .calendar-wrap .fc .fc-toolbar>*>* {
  margin-left: 0;
}

.rtl .calendar-wrap .fc-events-container {
  text-align: right;
}

.rtl .fc-agenda-view .fc-day-grid .fc-row {
  margin-right: 0 !important;
}

.rtl .fc-unthemed .fc-row {
  margin-right: 0 !important;
}

.rtl .chat-box .user-image {
  float: right;
}

.rtl .chat-box .people-list .search i {
  left: 10px;
  right: auto;
  right: initial;
}

.rtl .chat-box .about {
  float: right;
  padding-right: 10px;
  padding-left: 0;
  padding-left: initial;
  text-align: right;
}

.rtl .chat-box .chat-menu {
  border-right: 1px solid #eeeeee;
  border-left: 0;
  border-left: initial;
}

.rtl .chat-box .chat-menu .nav {
  padding-right: 0;
}

.rtl .chat-left-aside .status-circle {
  left: auto;
  left: initial;
  right: 40px;
}

.rtl .chat-right-aside .chat .chat-header .chat-menu-icons {
  padding-left: 0;
  padding-right: 0;
  padding-right: initial;
}

.rtl .chat-right-aside .chat .chat-header .chat-menu-icons.float-sm-right {
  float: left !important;
}

.rtl .chat-right-aside .chat .chat-header img {
  float: right;
}

.rtl .cke_toolbar,
.rtl .cke_toolgroup,
.rtl a.cke_button,
.rtl .cke_combo_text {
  float: right;
}

.rtl .cke_reset_all,
.rtl .cke_reset_all *,
.rtl .cke_reset_all a,
.rtl .cke_reset_all textarea {
  text-align: right;
}

.rtl .cke_combo_text {
  padding-left: 0;
  padding-left: initial;
  padding-right: 10px;
}

.rtl #editor1 #cke_editor1 #cke_1_contents iframe html {
  direction: rtl !important;
}

.rtl #clockdiv ul {
  padding-right: 0;
}

.rtl .sidebar-toggle-btn {
  margin-right: 10px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .default-widget-count .icon-bg {
  left: 15px;
  right: auto;
  right: initial;
}

.rtl .custom-card .card-footer>div+div {
  border-right: 1px solid #ddd;
  border-left: 0;
  border-left: initial;
}

.rtl .card-social {
  padding-right: 0;
}

.rtl .card-absolute .card-header {
  right: 15px;
  left: auto;
  left: initial;
}

.rtl .card {
  text-align: right;
}

.rtl .card .card-header .card-header-right {
  left: 20px;
  right: auto;
  right: initial;
}

.rtl .card .card-header .card-header-right .card-option {
  text-align: left;
}

.rtl .card .card-header .card-header-right .card-option.list-unstyled {
  padding-right: 0;
  padding-left: 0;
  padding-left: initial;
}

.rtl .card.full-card {
  left: 0;
  right: auto;
  right: initial;
}

.rtl .dataTables_wrapper .dataTables_filter input[type="search"] {
  margin-right: 10px;
  margin-left: 0;
}

.rtl .dataTables_wrapper .dataTables_length {
  float: right;
}

.rtl .dataTables_wrapper .dataTables_filter {
  margin-left: 0;
  margin-left: initial;
  margin-right: 15px;
  float: left;
}

.rtl .dataTables_wrapper .dataTables_info {
  float: right;
}

.rtl .dataTables_wrapper .advance-5_filter {
  margin-left: 0;
}

.rtl div.dataTables_wrapper div.dataTables_paginate {
  margin-right: 15px !important;
  margin-left: 0 !important;
  float: left;
}

.rtl table.dataTable thead>tr>th {
  padding-left: 30px;
  padding-right: 12px;
}

.rtl table.dataTable thead>tr>th:before {
  left: 1em !important;
  right: auto;
  right: initial;
}

.rtl table.dataTable thead>tr>th:after {
  left: 0.5em !important;
  right: auto;
  right: initial;
}

.rtl table.dataTable thead .sorting:before,
.rtl table.dataTable thead .sorting_asc:before,
.rtl table.dataTable thead .sorting_desc:before,
.rtl table.dataTable thead .sorting_asc_disabled:before,
.rtl table.dataTable thead .sorting_desc_disabled:before {
  left: 1em !important;
  right: auto;
  right: initial;
}

.rtl .dataTables_scrollHeadInner {
  padding-right: 0;
  padding-right: initial;
  padding-left: 0 !important;
}

.rtl div.table-responsive>div.dataTables_wrapper>div.row>div[class^="col-"]:first-child {
  padding-right: 0;
  padding-left: 0;
}

.rtl div.table-responsive>div.dataTables_wrapper>div.row>div[class^="col-"]:last-child {
  padding-right: 0;
  padding-left: 0;
}

.rtl .dt-plugin-buttons button.m-r-10 {
  margin-left: 10px;
  margin-right: 0;
}

.rtl .datetime-picker .theme-form .form-group label {
  text-align: left !important;
}

.rtl .datetime-picker .theme-form .form-group .input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .datetime-picker .theme-form .form-group .input-group .form-control {
  border-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rtl .form-inline .form-group .col-form-label {
  margin-left: 5px;
  margin-right: 0;
}

.rtl .dropdown-basic .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rtl .dropdown-basic .separated-btn .btn {
  border-radius: 0.25rem;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rtl .error-wrapper .col-md-8.offset-md-2 {
  margin: 0 auto !important;
}

.rtl .email-wrap .email-app-sidebar ul {
  padding-right: 0;
}

.rtl .email-wrap .email-app-sidebar .main-menu>li a i {
  margin-right: 0;
  margin-right: initial;
  margin-left: 10px;
}

.rtl .email-wrap .email-content .email-top .user-emailid:after {
  float: left;
}

.rtl .crm-numbers .col+.col {
  border-left: 0;
  border-left: initial;
  border-right: 1px solid #ddd;
}

.rtl .product-price del {
  padding-left: 20px;
  padding-right: 0;
}

.rtl .product-hover ul {
  padding-right: 0;
}

.rtl .customer-review .media img {
  margin-left: 25px;
  margin-right: 0;
}

.rtl .icon-lists div i {
  margin: 0 10px 0 15px;
}

.rtl .btn-showcase .btn {
  margin-right: 0;
  margin-right: initial;
  margin-left: 18px;
}

.rtl .nav {
  padding-right: 0;
}

.rtl .btn-square.dropdown-toggle {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rtl .form-builder-2-header>div nav {
  float: left;
}

.rtl .custom-file-label::after {
  left: 0;
  right: auto;
  right: initial;
}

.rtl .wizard-4 ul.anchor {
  float: right;
  padding-right: 0;
  padding-left: 30px;
}

.rtl .wizard-4 .step-container {
  clear: none;
  clear: initial;
}

.rtl .wizard-4 .form-group {
  text-align: right;
}

.rtl .wizard-4 .action-bar .btn {
  float: left;
}

.rtl .f1 .f1-buttons {
  text-align: left;
}

.rtl .f1 .f1-steps .f1-step {
  float: right;
}

.rtl .chat-box .user-image {
  margin-left: 5px;
  margin-right: 0;
}

.rtl .chat-box .chat-right-aside .chat .chat-message .smiley-box {
  margin-left: 0.5rem;
  margin-right: 0;
  margin-right: initial;
}

.rtl .chat-box .chat .chat-message .text-box .input-group-append {
  margin-right: -2px;
}

.rtl .input-group>.input-group-append>.btn,
.rtl .input-group>.input-group-append>.input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.rtl .input-group>.input-group-prepend:not(:first-child)>.btn,
.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text,
.rtl .input-group>.input-group-prepend:not(:first-child)>.btn:not(:first-child),
.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text:not(:first-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .input-group>.form-control:not(:first-child),
.rtl .input-group>.custom-select:not(:first-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.rtl .input-group>.form-control:not(:last-child),
.rtl .input-group>.custom-select:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.rtl .chat-msg-box ul {
  padding-right: 0;
}

.rtl .static-top-widget .media-body {
  padding-right: 30px;
  padding-left: 0;
  padding-left: initial;
}

.rtl .static-top-widget .media-body .icon-bg {
  left: -20px;
  right: auto;
  right: initial;
}

.rtl .widget-joins .media .details {
  border-right: 1px solid #ddd;
  border-left: 0;
  border-left: initial;
}

.rtl .widget-joins .media .media-body {
  text-align: right;
}

.rtl .img-cropper .btn-group {
  margin-right: 0;
  margin-left: 10px;
}

.rtl .img-cropper .btn-group button:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.rtl .img-cropper .btn-group button:first-child {
  border-top-right-radius: .25rem;
  border-bottom-right-radius: .25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rtl .landing-main .landing-left {
  padding-right: 100px;
  padding-left: 0;
}

.rtl .list-group {
  padding-right: 0;
}

.rtl .list-group i,
.rtl .list-group img {
  margin-left: 10px;
  margin-right: 0;
}

.rtl .authentication-box {
  text-align: right;
}

.rtl .mega-horizontal .offset-sm-3 {
  margin-right: 25%;
  margin-left: 0;
  margin-left: initial;
}

.rtl .modal-header .close {
  margin-left: 0;
}

.rtl .modal-footer> :not(:first-child) {
  margin-right: .50rem;
  margin-left: 0;
}

.rtl .navs-icon i {
  margin-left: 10px;
  margin-right: 0;
}

.rtl .nav-list .nav-list-disc {
  text-align: right;
  padding-right: 0;
}

.rtl .pl-navs-inline {
  padding-right: 30px !important;
  padding-left: 0 !important;
}

.rtl .icon-lists ul {
  padding-right: 0;
}

.rtl .onhover-show-div {
  right: 0;
}

.rtl .pagination {
  padding-right: 0;
}

.rtl .pricing-wrapper-card .card-price h1 sup {
  margin-right: -20px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .pricing-wrapper-card .card-ribbon {
  right: -10px;
  left: auto;
  left: initial;
}

.rtl .pricing-wrapper-card .card-ribbon ::before {
  left: 0;
  right: auto;
  right: initial;
}

.rtl .pricing-wrapper-card .card-ribbon ::after {
  bottom: 0;
  right: 0;
  left: auto;
  left: initial;
}

.rtl .pricing-wrapper-card .card-ribbon span {
  right: -35px;
  left: auto;
  left: initial;
  transform: rotate(45deg);
}

.rtl .product-page-details span {
  padding-right: 15px;
  padding-left: 0;
}

.rtl .m-checkbox-inline label {
  margin-left: 20px;
  margin-right: 0;
}

.rtl .form-label-align-right label {
  text-align: left;
}

.rtl .br-theme-bars-reversed .br-widget .br-current-rating,
.rtl .br-theme-bars-movie .br-widget .br-current-rating,
.rtl .br-theme-bars-1to10 .br-widget .br-current-rating,
.rtl .br-theme-bars-square .br-widget .br-current-rating {
  float: right;
}

.rtl .br-theme-bars-reversed .br-widget a,
.rtl .br-theme-bars-movie .br-widget a,
.rtl .br-theme-bars-1to10 .br-widget a,
.rtl .br-theme-bars-square .br-widget a {
  float: right;
}

.rtl .ribbon-left {
  right: auto;
  left: -2px;
}

.rtl .ribbon-vertical-left {
  right: auto;
  left: 12px;
}

.rtl .ribbon-vertical-right {
  right: auto;
  left: 12px;
}

.rtl .search-page .search-form input {
  background-position: 1%;
}

.rtl .star-ratings ul.search-info {
  padding-right: 0;
}

.rtl .star-ratings ul.search-info li+li {
  border-right: 1px solid #a5afc6;
  border-left: 0;
  border-left: initial;
  padding-right: 8px;
  padding-left: 0;
  margin-right: 8px;
  margin-left: 0;
}

.rtl .select2-container--default .select2-selection--single .select2-selection__arrow {
  left: 10px !important;
  right: auto !important;
  right: initial !important;
}

.rtl .editor-statusbar {
  text-align: left;
}

.rtl .editor-statusbar span {
  margin-right: 1em;
  margin-left: 0;
  margin-left: initial;
}

.rtl .CodeMirror-scroll {
  margin-left: -30px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .primary-color ul,
.rtl .yellow-color ul {
  padding-right: 0;
}

.rtl .u-step-desc {
  text-align: right;
}

.rtl .u-step-number {
  right: 20px;
  left: auto;
  left: initial;
}

.rtl .u-step-number~.u-step-desc {
  margin-right: 50px;
}

.rtl .u-pearl:after {
  left: 0;
  right: auto;
  right: initial;
}

.rtl .u-pearl:before {
  right: 0;
  left: auto;
  left: initial;
}

.rtl .note {
  float: right;
}

.rtl .list-icons {
  padding-right: 0;
}

.rtl .dropdown-toggle::after {
  margin-right: 0.255em;
  margin-left: 0;
  margin-left: initial;
}

.rtl .flex-column a {
  text-align: center !important;
}

.rtl .tabbed-card ul {
  left: 15px;
  right: auto;
  right: initial;
}

.rtl .card .card-header .pull-left {
  float: right;
}

.rtl .checkbox label {
  padding-right: 16px;
  padding-left: 0;
  padding-left: initial;
}

.rtl .checkbox label::before {
  right: 0;
  left: auto;
  left: initial;
  margin-right: -16px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .radio label::after {
  right: 5px;
  left: auto;
  left: initial;
  margin-right: -20px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .cd-timeline-content::before {
  border-right: 7px solid #eeeeee;
  border-left-color: transparent;
}

.rtl .cd-timeline-img i {
  right: 45%;
  left: auto;
  left: initial;
  margin-right: -12px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .cd-timeline-block:nth-child(even) .cd-timeline-content {
  float: left;
  border-left: 7px solid #eeeeee;
  border-right: 0;
  border-right: initial;
}

.rtl .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {
  right: auto;
  left: 122%;
  text-align: left;
}

.rtl .cd-timeline-block:nth-child(even) .cd-timeline-content::before {
  right: auto;
  left: 100%;
  border-left-color: #eeeeee;
  border-right-color: transparent;
}

.rtl .cd-timeline-content .cd-date {
  right: 122%;
  left: auto;
  left: initial;
}

.rtl .todo .todo-list-wrapper .mark-all-tasks {
  left: 30px;
  right: auto;
  right: initial;
}

.rtl .todo .todo-list-wrapper .mark-all-tasks .btn-label {
  margin-left: 5px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn {
  text-align: left;
}

.rtl .todo .notification-popup {
  left: 10px;
  right: auto;
  right: initial;
}

.rtl .introjs-tooltip {
  right: 0;
  left: auto;
  left: initial;
}

.rtl .introjs-helperNumberLayer {
  right: -16px;
  left: auto;
  left: initial;
}

.rtl .list-inline-item:not(:last-child) {
  margin-left: 0.5rem;
  margin-right: 0;
  margin-right: initial;
}

.rtl .like-comment ul.list-inline {
  padding-right: 0;
}

.rtl .typeahead {
  text-align: right;
}

.rtl .listing ul {
  padding-right: 0;
}

.rtl .listing ul .icofont {
  float: right;
}

.rtl .quickview-wrapper {
  left: -285px;
  right: auto;
  right: initial;
}

.rtl .quickview-wrapper .quickview-box:before,
.rtl .quickview-wrapper .quickview-recent-activity:before {
  right: -47px;
  left: auto;
  left: initial;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.rtl .quickview-wrapper .quickview-box .quickview-box-toggle,
.rtl .quickview-wrapper .quickview-recent-activity .quickview-box-toggle {
  right: -50px;
  left: auto;
  left: initial;
}

.rtl .quickview-wrapper.open {
  transform: translate3d(100%, 0, 0);
}

.rtl .quickview-wrapper .nav-tabs .nav-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rtl .chat-quickview {
  left: -400px;
  right: auto;
  right: initial;
}

.rtl .quickview-wrapper .friend-list-search .fa {
  right: auto;
  right: initial;
  left: 35px;
}

.rtl .border-widgets>.row>div+div {
  border-right: 1px solid #ddd;
  border-left: 0;
  border-left: initial;
}

.rtl .button-builder ul.the-icons {
  padding-right: 0;
}

.rtl ul {
  padding-right: 0;
}

.rtl ul.icon-lists {
  padding-right: 30px;
}

.rtl .gallery .hover-5 img {
  margin-right: 30px;
}

.rtl .gallery .hover-5:hover img {
  margin-right: 0;
}

.rtl .lg-outer {
  text-align: right;
}

.rtl .lg-toolbar .lg-icon {
  float: left;
}

.rtl #lg-counter {
  padding-right: 20px;
  padding-left: 0;
  padding-left: initial;
  float: right;
}

.rtl #friendlist-tab .modal-header h6.modal-title,
.rtl #recentactivity-tab .modal-header h6.modal-title {
  text-align: right;
}

.rtl #friendlist-tab .modal-header .col-sm-4.text-right,
.rtl #recentactivity-tab .modal-header .col-sm-4.text-right {
  text-align: left !important;
}

.rtl .quickview-wrapper .recent-activity {
  margin-right: 25px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .quickview-wrapper .recent-activity .user-first-letter span {
  right: -23px;
  left: auto;
  left: initial;
}

.rtl .quickview-wrapper .recent-activity .user-first-letter:after {
  right: 0;
  left: auto;
  left: initial;
}

.rtl .chart-widget-top .text-right {
  text-align: left !important;
}

.rtl .chart-widget-top .num .ml-1 {
  margin-right: 0.25rem !important;
}

.rtl .bar-chart-widget .earning-details i {
  left: -240px;
}

.rtl .bar-chart-widget .bottom-content .b-r-light {
  border-left: 1px solid #eeeeee !important;
  border-right: 0 !important;
  border-right: initial !important;
}

.rtl .bar-chart-widget .bottom-content .num .ml-1 {
  margin-right: 0.25rem !important;
}

.rtl .chart-vertical-center #myDoughnutGraph,
.rtl .chart-vertical-center #myPolarGraph {
  width: auto !important;
}

.rtl .crm-activity ul.dates li+li {
  border-right: 1px solid #ddd;
  padding-right: 10px;
  margin-right: 5px;
  border-left: 0;
  border-left: initial;
  padding-left: 0;
  padding-left: initial;
  margin-left: 0;
  margin-left: initial;
}

.rtl div.dt-buttons {
  float: right;
}

.rtl .dt-button-collection {
  left: -39px !important;
}

.rtl .dropzone .dz-preview .dz-error-mark,
.rtl .dropzone .dz-preview .dz-success-mark {
  right: 50%;
  margin-right: -27px;
  margin-left: 0;
  margin-left: initial;
  left: auto;
  left: initial;
}

.rtl .email-wrap .email-app-sidebar .main-menu>li {
  text-align: right;
}

.rtl .icon-hover-bottom .icon-popup .icon-last .form-inline .form-group .btn {
  margin-right: 15px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .footer-copyright {
  text-align: right;
}

.rtl .footer-links {
  text-align: left;
}

.rtl .weather-widget-two .bottom-whetherinfo .whether-content {
  text-align: left;
}

.rtl .docs-toggles .btn-group .btn {
  border-radius: 0;
}

.rtl .docs-toggles .btn-group .btn:last-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.rtl .docs-toggles .btn-group .btn:first-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.rtl .btn-group>.btn:not(:last-child):not(.dropdown-toggle)>.btn-group:not(:last-child)>.btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .jsgrid-button+.jsgrid-button {
  margin-right: 5px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .offset-xl-3 {
  margin-right: 25%;
}

.rtl .onhover-dropdown.navs-dropdown:hover .onhover-show-div:before {
  left: 77px;
  right: auto;
  right: initial;
}

.rtl .onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {
  left: 77px;
  right: auto;
  right: initial;
}

.rtl .navs-dropdown .onhover-show-div .navs-icon li {
  text-align: right;
}

.rtl .navs-icon.default-according.style-1 li button[aria-expanded="true"]:before {
  left: 2px;
  right: auto;
  right: initial;
}

.rtl .navs-icon.default-according.style-1 li button[aria-expanded="false"]:before {
  left: 2px;
  right: auto;
  right: initial;
}

.rtl .page-item:first-child .page-link {
  margin-right: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rtl .page-item:last-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .product-box .ribbon-bookmark.ribbon-secondary:before {
  border-left-color: transparent;
  border-right-coolor: none;
}

.rtl .product-box .ribbon-bookmark:before {
  right: 100%;
  border-left: 10px solid transparent;
  border-right: 0;
  border-right: initial;
}

.rtl .product-box .ribbon-warning.ribbon-clip:before {
  border-left-color: #c0ab00;
  border-right-color: currentColor;
  border-right-color: initial;
}

.rtl .product-box .ribbon-clip {
  right: -14px;
  left: auto;
  left: initial;
}

.rtl .product-box .ribbon-clip:before {
  right: 0;
  left: auto;
  left: initial;
}

.rtl .u-step-icon {
  float: right;
  margin-left: .5em;
  margin-right: 0;
  margin-right: initial;
}

.rtl .card-header.note-toolbar .note-color .dropdown-toggle {
  padding-right: 5px;
}

.rtl .card-header.note-toolbar .form-group.draggable {
  text-align: right;
}

.rtl .card-header.note-toolbar .form-check {
  padding-right: 24px;
  padding-left: 0;
  padding-left: initial;
}

.rtl .card-header.note-toolbar form .custom-control {
  padding-right: 24px;
  padding-left: 0;
  padding-left: initial;
}

.rtl .card-header.note-toolbar form .custom-control .custom-control-label::after {
  right: 0;
  left: auto;
  left: initial;
}

.rtl .card-header.note-toolbar form .custom-control .custom-control-label::before {
  right: 0;
  left: auto;
  left: initial;
}

.rtl .left-order {
  order: 3;
}

.rtl .right-order {
  order: -1;
}

.rtl .popover.top>.arrow:after,
.rtl .popover.bottom>.arrow:after {
  margin-right: -10px;
  margin-left: 0;
  margin-left: initial;
}

.rtl .bootstrap-touchspin>.input-group-append>.btn,
.rtl .bootstrap-touchspin>.input-group-append>.input-group-text {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rtl .bootstrap-touchspin>.form-control:not(:last-child),
.rtl .bootstrap-touchspin>.custom-select:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltiptext {
  text-align: right;
}

.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons {
  text-align: left;
}

.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-skipbutton {
  margin-left: 5px;
  margin-right: 0;
  margin-right: initial;
}

.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-nextbutton {
  border-radius: 0.2em 0 0 0.2em;
}

.rtl .typeahead span.twitter-typeahead .tt-suggestion {
  text-align: right;
}

.rtl .typeahead .league-name {
  text-align: right;
  margin-right: 5px;
}

.rtl .follow .text-md-right {
  text-align: right !important;
}

.rtl .jvectormap-zoomin,
.rtl .jvectormap-zoomout,
.rtl .jvectormap-goback {
  right: 10px;
  left: auto;
  left: initial;
}

/**=====================
    60. RTL CSS Ends
==========================**/
/**=====================
      Modern layout CSS Start
==========================**/
.svg-animation .wave-template {
  opacity: 0;
  position: absolute;
}

.svg-animation circle {
  fill: #ac68fd;
  opacity: 0.3;
}

.svg-animation svg>use {
  transform: translate(50%, 50%);
}

.svg-animation svg>circle:last-child {
  fill: #5934fc;
  opacity: 1;
}

.svg-animation #rp1 {
  animation: ripple1 1s linear infinite;
}

.svg-animation #rp2 {
  animation: ripple2 1s linear infinite;
}

.svg-animation #rp3 {
  animation: ripple3 1s linear infinite;
}

.svg-animation .svg-container {
  position: absolute;
  z-index: 10;
}

.svg-animation .effect-svg1 {
  top: -65%;
  left: -5%;
  transform: scale(0.5);
}

.svg-animation .effect-svg2 {
  top: -88%;
  left: 30%;
}

.svg-animation .effect-svg3 {
  top: -28%;
  right: -5%;
}

.svg-animation .effect-svg4 {
  top: 113%;
  left: 0;
}

@keyframes ripple2 {
  0% {
    transform: scale(3.5);
  }

  100% {
    transform: scale(5.5);
  }
}

@keyframes ripple3 {
  0% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(3.5);
  }
}

@keyframes ripple1 {
  0% {
    transform: scale(5.5);
    opacity: 0.3;
  }

  100% {
    transform: scale(8.5);
    opacity: 0.0;
  }
}

.modern-layout .b-danger {
  border: 4px solid #e4326b !important;
}

.modern-layout .annual-report {
  height: 147px;
}

.modern-layout .media-width {
  max-width: 100px;
}

.modern-layout .set-image-border img {
  padding: 10px 9px;
  border-radius: 50%;
  border: 1px solid #ddd;
}

.modern-layout .finance-status-image {
  padding-top: 10px;
}

.modern-layout .annual-report-detail li {
  font-weight: 600;
  margin-bottom: 15px;
}

.modern-layout .annual-report-detail li:last-child {
  margin-bottom: 0;
}

.modern-layout .annual-report-detail li span {
  font-weight: normal;
}

.modern-layout .annual-report-detail li .number {
  position: relative;
  padding-left: 45px;
}

.modern-layout .annual-report-detail li .number:before {
  width: 36px;
  height: 14px;
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  border-radius: 25px;
}

.modern-layout .annual-report-detail li .success-number:before {
  background-color: #88d563;
}

.modern-layout .annual-report-detail li .info-number:before {
  background-color: #5934fc;
}

.modern-layout .annual-report-detail li .danger-number:before {
  background-color: #e4326b;
}

.modern-layout .annual-report-detail li .primary-number:before {
  background-color: #a34ffe;
}

.modern-layout .header {
  height: 400px;
  background: linear-gradient(22deg, #5934fc 0, #a34ffe 100%);
}

.modern-layout .header .page-main-header {
  position: relative;
  left: 0;
  right: 0;
  box-shadow: none;
  display: block;
  height: auto;
  background: transparent;
  z-index: 2;
  border-bottom: 1px solid #a34ffe;
}

.modern-layout .header .page-main-header .modern-header .main-header-right {
  float: right;
  width: auto;
  padding: 0;
}

.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .notification {
  top: 50px;
}

.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .onhover-show-div {
  top: 100px;
}

.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right>ul>li {
  padding: 60px 0;
}

.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right ul li i {
  font-size: 20px;
}

.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right ul .onhover-dropdown a .badge {
  background-color: #fff;
}

.modern-layout .header .page-main-header .modern-header .header-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.modern-layout .header .page-main-header .modern-header .search-form input {
  color: #cccccc;
  border: none;
  border-radius: 20px;
  background-color: #9173ef54;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.modern-layout .header .page-main-header .modern-header .search-form input:-ms-input-placeholder {
  color: #a34ffe;
}

.modern-layout .header .page-main-header .modern-header .search-form input:-moz-placeholder {
  color: #a34ffe;
}

.modern-layout .header .page-main-header .modern-header .search-form input:focus {
  outline: none;
}

.modern-layout .header .page-main-header .modern-header .search-form input::-webkit-input-placeholder {
  color: #a34ffe;
}

.modern-layout .header .page-main-header .modern-header .search-form input::-moz-placeholder {
  color: #a34ffe;
}

.modern-layout .header .vertical-menu-main {
  position: absolute;
  background: transparent;
  top: 159px;
  width: 58%;
  margin: 0 auto;
  left: 0;
  right: 0;
  box-shadow: none;
}

.modern-layout .header .vertical-menu-main nav ul li a {
  color: #fff;
  border-right: 1px solid #a34ffe;
}

.modern-layout .header .vertical-menu-main nav ul li:last-child a {
  border-right: none;
}

.modern-layout .header .vertical-menu-main nav ul li ul li a {
  color: #333333;
  border-right: none;
}

@media (min-width: 1200px) {

  .modern-layout .header .pixelstrap ul a:hover,
  .modern-layout .header .pixelstrap ul a:focus,
  .modern-layout .header .pixelstrap ul a:active,
  .modern-layout .header .pixelstrap ul a.highlighted {
    color: #ab8ce4;
  }
}

.modern-layout .number {
  font-family: Open Sans, sans-serif;
}

.modern-layout button {
  border-radius: 20px;
  background-color: transparent;
  border: 1px solid #ddd;
  color: #000;
  text-align: left;
  font-weight: 600;
  padding: 6px 15px;
}

.modern-layout .dropdown-menu {
  border-radius: 20px;
}

.modern-layout .dropdown {
  position: relative;
}

.modern-layout .dropdown .arrow-after-dropdown::after {
  content: "\\f107";
  font-family: FontAwesome;
  position: absolute;
  border-top: none;
  color: #6c757d;
  right: 20px;
}

.modern-layout .font-danger {
  color: #e4326b !important;
}

.modern-layout .font-success {
  color: #88d563 !important;
}

.modern-layout .font-primary {
  color: #a34ffe !important;
}

.modern-layout .font-info {
  color: #5934fc !important;
}

.modern-layout .card {
  border-radius: 0;
}

.modern-layout .card .card-header {
  border-bottom: none;
  padding: 30px;
}

.modern-layout .card .card-header h5 {
  font-weight: 700;
  letter-spacing: 1px;
}

.modern-layout .finance-stts {
  border: none;
  padding: 0;
  margin: 0;
  height: 257px;
}

.modern-layout .finance-stts .ct-series-a .ct-point,
.modern-layout .finance-stts .ct-series-a .ct-line,
.modern-layout .finance-stts .ct-series-a .ct-bar,
.modern-layout .finance-stts .ct-series-a .ct-slice-donut {
  stroke: #a34ffe;
}

.modern-layout .top-charts {
  margin-top: -180px;
}

.modern-layout .top-charts .card-header h5 {
  padding-top: 7px;
}

.modern-layout .top-charts .sales-report-chart .flot-chart-container {
  border: 0;
  padding: 0;
  height: 415px;
}

.modern-layout .top-charts .total-earning .flot-chart-container {
  border: 0;
  margin: 0;
  padding: 0;
  height: 322px;
}

.modern-layout footer {
  position: relative;
  background: linear-gradient(22deg, #5934fc 0, #a34ffe 100%);
  padding: 25px;
  bottom: 0;
}

.modern-layout .page-body-wrapper .page-body {
  background-color: #eeeeee;
  min-height: calc(100vh - 400px);
  margin-top: 0 !important;
}

.modern-layout .testimonial p {
  line-height: 2;
  font-style: normal;
  margin: 0;
}

.modern-layout .testimonial .owl-dots {
  display: none;
}

.modern-layout .testimonial.owl-theme .owl-nav {
  position: absolute;
  top: -110px;
  right: 0;
}

.modern-layout .testimonial.owl-theme .owl-nav button span {
  color: #000;
  font-size: 30px;
}

.modern-layout .testimonial.owl-theme .owl-nav [class*='owl-']:hover {
  background: #fff;
  text-decoration: none;
  border: none;
}

.modern-layout .widget-joins .media {
  padding: 42px 35px 50px 50px;
}

.modern-layout .widget-joins .media .media-body h3 {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
}

.modern-layout .annual-report canvas {
  position: relative;
  right: 60px;
  top: -20px;
}

.modern-layout .production-chart .flot-chart-container {
  border: none;
  padding: 0;
  margin: 0;
  height: 163px;
}

.modern-layout .tech-chart .flot-chart-container {
  border: none;
  padding: 0;
  margin: 0;
  height: 181px;
}

.modern-layout .tech-chart .flot-chart-container #tech-chart svg {
  filter: drop-shadow(12px 12px 7px rgba(119, 119, 119, 0.4));
}

.modern-layout .products-listing .flot-chart-container {
  padding: 0;
  margin: 0;
  border: none;
  top: 25px;
  position: relative;
  height: 300px;
  margin-top: -150px;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1366px) {
  .modern-layout .sales-report-chart .flot-chart-container {
    height: 472px;
  }

  .modern-layout .annual-report {
    height: 153px;
  }
}

@media only screen and (max-width: 1366px) {
  .modern-layout .svg-animation .effect-svg3 {
    top: -56%;
    right: -4%;
    transform: scale(0.4);
  }

  .modern-layout .svg-animation .effect-svg4 {
    top: 113%;
    left: -8%;
    transform: scale(0.4);
  }

  .modern-layout .svg-animation .effect-svg2 {
    transform: scale(0.4);
  }

  .modern-layout .svg-animation .effect-svg1 {
    transform: scale(0.4);
  }

  .modern-layout .widget-joins:before {
    display: block;
  }

  .modern-layout .widget-joins:after {
    display: block;
  }

  .modern-layout .widget-joins .media {
    padding: 50px;
  }

  .modern-layout .widget-joins .media .media-body h3 {
    font-size: 20px;
  }

  .modern-layout .header .vertical-menu-main {
    width: 82%;
  }
}

@media only screen and (max-width: 1199px) {
  .modern-layout .annual-report {
    height: auto;
  }

  .modern-layout .vertical-menu-main nav ul li a {
    color: #333333 !important;
    border-right: none !important;
  }

  .modern-layout .sm {
    top: 151px;
  }

  .modern-layout .top-charts {
    margin-top: -249px;
  }

  .modern-layout .header .page-main-header {
    border-bottom: none;
  }

  .modern-layout .vertical-mobile-sidebar {
    color: #fff;
    margin-right: 0;
  }

  .modern-layout .sales-report-chart .flot-chart-container {
    height: 375px;
  }

  .modern-layout .annual-report canvas {
    right: 0;
    width: 100% !important;
  }

  .modern-layout .widget-joins .media {
    padding: 35px;
  }

  .modern-layout .finance-status-image {
    padding-top: 4px;
  }

  .modern-layout .p-t-5 {
    padding-top: 11px !important;
  }

  .modern-layout .media-width {
    min-width: 97px;
  }
}

@media only screen and (max-width: 991px) {
  .modern-layout button {
    margin: 0 auto;
  }

  .modern-layout .sm {
    top: 156px;
  }

  .modern-layout .main-header-right .nav-right>.mobile-toggle .icon-more {
    vertical-align: middle;
    color: #fff;
  }

  .modern-layout .main-header-right .nav-right>ul {
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .modern-layout .main-header-right .nav-right>ul>li {
    padding: 20px 0 !important;
  }

  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .notification {
    top: 11px;
  }

  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .onhover-show-div {
    top: 60px;
  }

  .modern-layout .testimonial.owl-theme .owl-nav {
    top: -91px;
  }

  .modern-layout .page-body-wrapper .page-body .top-charts {
    margin-top: -244px !important;
  }

  .modern-layout .header-inner .logo-wrapper {
    width: 63%;
    margin-top: 20px;
  }

  .modern-layout .header-inner.float-sm-left {
    margin-top: 6px;
  }
}

@media only screen and (max-width: 767px) {

  .modern-layout .widget-joins:before,
  .modern-layout .widget-joins:after {
    display: none;
  }

  .modern-layout .widget-joins .row [class*="col-"] .media {
    border-bottom: 1px solid #ddd;
  }

  .modern-layout .widget-joins .row [class*="col-"] .media .media-body.pl-1 {
    padding-left: 12px !important;
  }

  .modern-layout .widget-joins .row [class*="col-"]:last-child .media {
    border-bottom: none;
  }

  .modern-layout .widget-joins .row [class*="col-"]:first-child .media .media-body {
    padding-left: 10px;
  }

  .modern-layout .svg-animation {
    display: none;
  }

  .modern-layout .b-r-light {
    border-right: none !important;
  }

  .modern-layout .header {
    padding-top: 35px;
  }

  .modern-layout .header .page-main-header .modern-header .header-inner {
    margin-top: 10px;
  }

  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right {
    text-align: center;
    margin: 15px 0;
  }

  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right>ul {
    top: 42px;
  }

  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right>ul li {
    padding: 5px 0;
  }

  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .notification-dropdown.onhover-show-div li {
    padding: 12px 20px;
  }

  .modern-layout .page-body-wrapper .page-body .top-charts {
    margin-top: -85px;
  }

  .modern-layout .page-body-wrapper .page-body .widget-joins .media .mr-3 {
    margin-right: 10px !important;
  }

  .modern-layout .annual-report canvas {
    right: auto;
    right: initial;
    top: 0;
    left: 0px;
    margin-top: 10px;
    width: 100% !important;
  }

  .modern-layout .products-listing .flot-chart-container {
    margin-top: -50px;
  }

  .modern-layout .header .page-main-header .modern-header .header-inner {
    margin-top: 0;
  }

  .modern-layout .header .page-main-header .modern-header .header-inner .logo-wrapper {
    width: 80%;
    margin-top: 0px;
  }
}

@media only screen and (max-width: 575px) {
  .modern-layout .sm {
    top: 121px;
  }

  .modern-layout .testimonial.owl-theme .owl-nav {
    top: -80px;
  }

  .modern-layout .header .page-main-header .modern-header .header-inner .logo-wrapper {
    width: 80%;
  }

  .modern-layout .header .page-main-header .header-inner .search-form .form-group {
    margin-bottom: 0;
  }

  .modern-layout .header .page-main-header .main-header-right .nav-right>ul {
    top: 29px !important;
  }

  .modern-layout .page-body-wrapper .page-body .top-charts {
    margin-top: -279px !important;
  }

  .modern-layout .page-body-wrapper .page-body .top-charts .text-md-right {
    text-align: center;
    margin-top: 15px;
  }

  .modern-layout .page-body-wrapper .page-body .p-t-5 {
    padding-top: 6px !important;
  }
}

@media only screen and (max-width: 360px) {
  .modern-layout .sm {
    top: 124px;
  }

  .modern-layout .page-body-wrapper .page-body .top-charts {
    margin-top: -276px !important;
  }

  .modern-layout .page-body-wrapper .page-body .top-charts .sales-report-chart .flot-chart-container {
    height: 300px;
  }

  .modern-layout .page-body-wrapper .page-body .top-charts .total-earning .flot-chart-container {
    height: 255px;
  }
}

/**=====================
      Modern layout CSS Ends
==========================**/
.classic-layout .margin-center-set {
  margin-top: 22px;
}

.classic-layout .switch-sm .switch .switch-state:before {
  bottom: 3px;
}

.classic-layout .card {
  border-radius: 0;
}

.classic-layout .card .card-header {
  border-bottom: none;
  padding: 30px;
}

.classic-layout .card .card-header h5 {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 1px;
}

.classic-layout .number {
  font-family: 'Open Sans', sans-serif;
}

.classic-layout .page-body-wrapper .page-sidebar {
  top: 0;
  height: 100vh;
}

.classic-layout .page-body-wrapper .page-sidebar .logo-wrapper {
  text-align: center;
  padding: 10px 0;
}

.classic-layout .page-body-wrapper .page-body {
  min-height: 100vh;
  margin-top: 0;
}

.classic-layout .page-main-header {
  position: static;
  position: initial;
  width: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: -22px;
}

.classic-layout .page-main-header .main-header-left {
  width: 310px;
  padding: 30px;
}

.classic-layout .page-main-header .main-header-left .mobile-sidebar .switch {
  margin-right: 40px;
  margin-top: 10px;
  margin-left: 0;
  margin-left: initial;
}

.classic-layout .page-main-header .main-header-left .search-form {
  width: 100%;
}

.classic-layout .page-main-header .main-header-left .search-form .form-group {
  width: 100%;
}

.classic-layout .page-main-header .main-header-left .search-form .form-group .form-control-plaintext {
  border-radius: 0;
}

.classic-layout .page-main-header .main-header-right {
  float: right;
  width: auto;
  display: contents;
}

.classic-layout .thin-bar-chart .flot-chart-container {
  height: 140px;
  padding: 0;
  margin: 0;
  border: none;
}

.classic-layout .thin-bar-chart .flot-chart-placeholder {
  top: 25px;
}

.classic-layout .thin-bar-chart .morris-hover.morris-default-style {
  display: none !important;
}

.classic-layout .thin-bar-chart .content .top-icon {
  font-size: 25px;
  color: #EFEFEF;
}

.classic-layout .thin-bar-chart .inner {
  margin-top: 60px;
}

.classic-layout .thin-bar-chart .inner span {
  color: #777777;
  margin-bottom: 0;
  letter-spacing: 1px;
}

.classic-layout .product-sale-chart {
  height: 474px;
}

.classic-layout .product-sale-chart svg .ct-labels .ct-label {
  color: #000;
}

.classic-layout .status-details h3 {
  color: #333333;
  font-weight: 600;
}

.classic-layout .status-details h3 span {
  color: #333333;
}

.classic-layout .status-details-color span {
  color: #fff;
}

.classic-layout .social-comment-widget {
  position: relative;
}

.classic-layout .social-comment-widget .user-name {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
}

.classic-layout .social-comment-widget .user-post {
  font-size: 12px;
}

.classic-layout .social-comment-widget p {
  color: #fff;
  line-height: 2;
  margin-top: 48px;
  font-size: 14px;
}

.classic-layout .social-comment-widget .social-icon {
  font-size: 30px;
}

.classic-layout .social-comment-widget .social-icon-bg {
  position: absolute;
  right: -49px;
  top: -10px;
  font-size: 195px;
  opacity: 0.1;
  transition: transform 0.5s;
}

.classic-layout .social-comment-widget .social-icon-bg:hover {
  transform: scale(1.3);
}

.classic-layout .status-yearly-chart .chart-container {
  height: 235px;
}

.classic-layout .status-monthly-chart .chart-container {
  height: 265px;
}

.classic-layout .growth-graph-first .flot-chart-placeholder {
  height: 95px;
}

.classic-layout .growth-graph-second .flot-chart-placeholder {
  height: 155px;
}

.classic-layout .whether-widget .whether-widget-top {
  padding: 35px;
  background-color: #4099ff;
  height: 307px;
}

.classic-layout .whether-widget .whether-widget-top span {
  text-shadow: none;
  font-size: 14px;
}

.classic-layout .whether-widget .whether-widget-top .details {
  text-align: left;
  left: 20px;
  bottom: -127px;
}

.classic-layout .whether-widget .whether-widget-top .details h3 {
  color: #fff;
}

.classic-layout .whether-widget .whether-widget-top .details h3 sup {
  color: #fff;
  font-size: 37px;
  font-weight: 600;
}

.classic-layout .whether-widget .whether-widget-top .details h3 span {
  font-size: 55px;
  font-weight: 600;
}

.classic-layout .whether-widget .whether-widget-top img {
  -moz-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.8));
  -ms-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.8));
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.8));
  height: 128px;
}

.classic-layout .whether-widget .whether-widget-bottom .climacon_component-fill,
.classic-layout .whether-widget .whether-widget-bottom .climacon_component-stroke {
  fill: #fff;
  stroke: #ddd;
}

.classic-layout .whether-widget .whether-widget-bottom .climacon_component-stroke {
  stroke-width: 3px;
}

.classic-layout .whether-widget .whether-widget-bottom .row div .media {
  padding-top: 0;
}

.classic-layout .whether-widget .whether-widget-bottom h4 span {
  color: #333333;
}

.classic-layout .whether-widget .whether-widget-bottom svg.climacon {
  height: 70px;
  width: 70px;
}

.classic-layout #employee svg g g g text {
  fill: #717171;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1366px) {
  .classic-layout .thin-bar-chart .flot-chart-container {
    height: 120px;
    margin-top: -15px;
  }

  .classic-layout .thin-bar-chart .content {
    float: none !important;
    text-align: center !important;
    margin-top: 0px;
  }

  .classic-layout .thin-bar-chart .inner {
    margin-top: 32px;
  }

  .classic-layout .thin-bar-chart .inner h6 {
    font-size: 12px;
  }

  .classic-layout .status-monthly-chart .chart-container {
    height: 235px;
  }

  .classic-layout .product-sale-chart {
    height: 445px !important;
  }

  .classic-layout .status-yearly-chart {
    margin-top: -20px;
  }
}

@media only screen and (max-width: 1199px) {
  .classic-layout .margin-center-set {
    margin-top: 0;
  }

  .classic-layout .product-sale-chart {
    height: 411px;
  }

  .classic-layout .lg-ml-details {
    margin-left: 15px;
  }

  .classic-layout .mt-3 {
    margin-top: 0px !important;
  }

  .classic-layout .growth-graph-second .flot-chart-placeholder {
    height: 95px;
  }

  .classic-layout .page-sidebar .sidebar-user .mt-3 {
    margin-top: 16px !important;
  }

  .classic-layout .status-monthly-chart .chart-container {
    height: 254px;
  }
}

@media only screen and (max-width: 991px) {
  .classic-layout .product-sale-chart {
    height: 391px;
  }

  .classic-layout .page-body-wrapper .page-sidebar {
    top: 122px !important;
  }

  .classic-layout .page-main-header .main-header-right .nav-right {
    padding-right: 25px;
  }

  .classic-layout .page-main-header .main-header-right .nav-right>ul {
    left: 25px !important;
  }
}

@media only screen and (max-width: 767px) {
  .classic-layout .margin-center-set {
    margin-top: 21px;
  }

  .classic-layout .growth-graph-second .flot-chart-placeholder {
    height: 134px;
  }

  .classic-layout .status-widget .status-yearly-chart {
    margin-top: -20px;
  }

  .classic-layout .status-monthly-chart .chart-container,
  .classic-layout .status-yearly-chart .chart-container {
    height: 200px;
  }

  .classic-layout .social-comment-widget .social-icon-bg {
    right: 0;
    top: 0;
    font-size: 120px;
  }
}

@media only screen and (max-width: 575px) {
  .classic-layout .page-main-header .main-header-left .search-form .form-group {
    margin-bottom: 0;
  }

  .classic-layout .page-main-header .main-header-right .nav-right>ul {
    left: 15px !important;
  }

  .classic-layout .margin-center-set {
    margin-top: 0px;
  }

  .classic-layout .product-sale-chart {
    height: 300px;
  }
}

@media only screen and (max-width: 360px) {
  .classic-layout .whether-widget .whether-widget-top .details h3 span {
    font-size: 41px;
  }

  .classic-layout .whether-widget .whether-widget-top .details h3 sup {
    font-size: 30px;
  }
}

.fixed-nav-layout {
  position: relative;
  background-blend-mode: overlay;
  background-attachment: fixed;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.fixed-nav-layout .container {
  max-width: none;
  max-width: initial;
  width: calc(100% - 400px);
}

.fixed-nav-layout .flot-chart-container svg {
  filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.2));
}

.fixed-nav-layout i,
.fixed-nav-layout [class="bottom-line-*"] {
  filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.3));
}

.fixed-nav-layout .sales-overview svg {
  filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.3));
}

.fixed-nav-layout.page-wrapper .page-body-wrapper .page-body {
  background-color: rgba(246, 247, 251, 0.75);
}

.fixed-nav-layout .page-main-header .main-header-left {
  padding: 10px;
}

.fixed-nav-layout .text-right ul li {
  text-align: center;
}

.fixed-nav-layout .text-right ul .list-inline-item:not(:last-child) {
  margin-right: 10px;
}

.fixed-nav-layout .main-header-right {
  float: right;
  width: 76%;
  padding: 0;
}

.fixed-nav-layout .site-visiter-chart ul {
  margin-bottom: 30px;
}

.fixed-nav-layout .site-visiter-chart ul li {
  width: 100px;
  text-align: center;
}

.fixed-nav-layout .site-visiter-chart .flot-chart-container {
  border: none;
  height: 350px;
}

.fixed-nav-layout .site-visiter-chart .flot-chart-container .ct-area {
  fill-opacity: 0;
}

.fixed-nav-layout .site-visiter-chart .bottom-line-info {
  border: 2px solid #4099ff;
}

.fixed-nav-layout .site-visiter-chart .bottom-line-primary {
  border: 2px solid #ab8ce4;
}

.fixed-nav-layout .site-visiter-chart .bottom-line-secondary {
  border: 2px solid #26c6da;
}

.fixed-nav-layout .site-visiter-chart .bottom-line-danger {
  border: 2px solid #FF5370;
}

.fixed-nav-layout .total-venders .flot-chart-container {
  height: 215px;
  border: none;
  padding: 0;
  margin: 0;
}

.fixed-nav-layout .total-venders .morris-hover.morris-default-style {
  display: none !important;
}

.fixed-nav-layout .card .card-header {
  border-bottom: none;
  text-transform: uppercase;
  padding: 25px;
}

.fixed-nav-layout .sales-overview .chart-block canvas {
  height: 305px !important;
}

.fixed-nav-layout .social-widget .media {
  padding: 30px;
}

.fixed-nav-layout .crm-top-widget .media .media-body h3 {
  font-weight: 600;
}

.fixed-nav-layout .crm-top-widget .media .media-body h3 span {
  color: #333333;
}

.fixed-nav-layout .ecommerce-widget .card-body {
  padding: 20px;
}

.fixed-nav-layout .ecommerce-widget .flot-chart-container {
  height: 85px;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {
  height: 100%;
  left: 220px;
  width: 160px;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar~.page-body {
  margin-left: 160px;
  box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.12);
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user {
  padding: 20px;
  background-color: #fafafa;
  box-shadow: none;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user h6 {
  letter-spacing: 1px;
  font-weight: 700;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user div {
  background-color: #f5f5f5;
  width: 60px;
  margin: 0 auto;
  padding: 5px 0;
  border-radius: 50%;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user div img {
  border: 3px solid #e6e6e6;
  box-shadow: none;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu {
  max-height: 100%;
  overflow: auto;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li .icon-sidebar {
  color: #333333;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li .sub-header-title {
  font-size: 12px;
  color: #333333;
  font-weight: 600;
  margin-top: 5px;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li:last-child .sidebar-header {
  border-bottom: none;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header {
  padding-top: 15px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #cacaca;
}

.fixed-nav-layout .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar {
  width: 0;
  transition: 0.5s;
  opacity: 0;
}

.fixed-nav-layout footer {
  bottom: -85px;
  padding: 30px;
  z-index: 999;
}

.fixed-nav-layout footer .footer-copyright p {
  font-size: 14px;
}

@media only screen and (max-width: 1500px) {
  .fixed-nav-layout .container {
    width: calc(100% - 100px);
    max-width: none;
    max-width: initial;
  }

  .fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {
    left: 70px;
  }
}

@media only screen and (max-width: 1199px) {
  .fixed-nav-layout .container {
    width: calc(100% - 30px);
    max-width: none;
    max-width: initial;
  }

  .fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {
    left: 30px;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(2) {
    border-bottom: none;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(1) {
    border-bottom: none;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) {
    border-left: 1px solid #ddd;
  }

  .fixed-nav-layout .main-header-right {
    width: 73%;
  }
}

@media only screen and (max-width: 991px) {
  .fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {
    left: 0;
  }

  .fixed-nav-layout .page-body-wrapper .page-sidebar {
    width: 0%;
    top: 60px;
    height: calc(100vh - 60px);
  }

  .fixed-nav-layout .page-body-wrapper .page-sidebar~.page-body {
    margin-left: 0px !important;
    padding-top: 0 !important;
  }

  .fixed-nav-layout .page-body-wrapper .page-sidebar-open {
    width: auto !important;
  }

  .fixed-nav-layout .page-main-header .main-header-left {
    padding: 0;
    width: 200px;
  }

  .fixed-nav-layout .page-main-header .main-header-left .logo-wrapper img {
    margin-top: 9px;
  }

  .fixed-nav-layout .page-main-header .main-header-right {
    width: 73%;
  }

  .fixed-nav-layout .page-main-header .main-header-right .mobile-sidebar {
    margin-top: 13px;
  }

  .fixed-nav-layout .page-main-header .main-header-right .nav-right>.mobile-toggle {
    padding-top: 21px;
  }
}

@media only screen and (max-width: 767px) {
  .fixed-nav-layout .site-visiter-chart ul li {
    width: 80px;
  }

  .fixed-nav-layout .page-body-wrapper .page-body {
    width: 100%;
  }

  .fixed-nav-layout .page-body-wrapper .page-body .user-status {
    min-width: 417px;
    overflow: auto;
  }

  .fixed-nav-layout .page-body-wrapper .page-body .site-visiter-chart ul li.list-inline-item:last-child {
    margin-top: 15px;
  }

  .fixed-nav-layout .page-main-header .main-header-left .logo-wrapper img {
    margin-top: 11px;
  }

  .fixed-nav-layout .page-main-header .main-header-right {
    width: 66%;
  }
}

@media only screen and (max-width: 575px) {
  .fixed-nav-layout .site-visiter-chart .flot-chart-container {
    height: 250px;
  }

  .fixed-nav-layout .site-visiter-chart ul li {
    width: 45%;
    margin: 2% !important;
  }

  .fixed-nav-layout .page-main-header .main-header-right {
    width: 56%;
  }

  .fixed-nav-layout .page-main-header .nav-right>ul .search-form .mobile-search {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    height: 15px;
    width: 15px;
    display: inline-block;
    background-size: cover;
    margin: 5px 0 0;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(1) {
    border-bottom: 1px solid #ddd;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(1) .crm-top-widget {
    margin-top: 0;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(2) {
    border-bottom: 1px solid #ddd;
    border-left: 0;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) {
    border-left: none;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) .crm-top-widget {
    margin-bottom: 0;
  }

  .fixed-nav-layout .crm-top-widget {
    margin: 15px 0;
  }

  .fixed-nav-layout .page-body-wrapper .page-body .user-status {
    min-width: 314px;
    overflow: auto;
  }
}

@media only screen and (max-width: 360px) {
  .fixed-nav-layout .page-main-header .main-header-left {
    width: 135px;
  }

  .fixed-nav-layout .page-main-header .main-header-right .mobile-sidebar {
    margin-top: 6px;
  }

  .fixed-nav-layout .page-main-header .main-header-right .nav-right>.mobile-toggle {
    padding-top: 13px;
  }

  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) {
    border-bottom: none;
  }

  .fixed-nav-layout .xs-col-100 {
    max-width: 100%;
    flex: 0 0 100%;
  }

  .fixed-nav-layout .xs-col-100.text-right {
    text-align: center !important;
    margin-top: 15px;
  }

  .fixed-nav-layout .page-body-wrapper .page-body .user-status {
    min-width: 233px;
    overflow: auto;
  }

  .fixed-nav-layout .page-body-wrapper .page-body .site-visiter-chart ul li.list-inline-item {
    width: 39%;
    margin-right: 10px !important;
  }
}

.solitary-layout .radial-bar-info {
  background-image: linear-gradient(360deg, #3185e6 50%, transparent 50%, transparent), linear-gradient(270deg, #3185e6 50%, #ddd 50%, #ddd);
}

.solitary-layout .radial-bar-success {
  background-image: linear-gradient(324deg, #4ed17d 50%, transparent 50%, transparent), linear-gradient(270deg, #4ed17d 50%, #ddd 50%, #ddd);
}

.solitary-layout .radial-bar-primary {
  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #6422d2 50%, #ddd 50%, #ddd);
}

.solitary-layout .radial-bar-danger {
  background-image: linear-gradient(270deg, #f31464 50%, transparent 50%, transparent), linear-gradient(270deg, #f31464 50%, #ddd 50%, #ddd);
}

.solitary-layout .dashboard-chart-container .flot-chart-placeholder {
  margin-bottom: -2px;
}

.solitary-layout a {
  color: #6422d2;
}

.solitary-layout a:hover {
  text-decoration: none;
}

.solitary-layout .switch input:checked+.switch-state {
  background-color: #6228d3;
  border: 1px solid #fff;
}

.solitary-layout .mobile-toggle i {
  color: #fff;
}

.solitary-layout #employee-act-chart svg text {
  fill: #5357e1;
}

.solitary-layout .font-purple {
  color: #6422d2 !important;
}

.solitary-layout .font-danger {
  color: #f31464 !important;
}

.solitary-layout .font-success {
  color: #4ed17d !important;
}

.solitary-layout .font-info {
  color: #3185e6 !important;
}

.solitary-layout .bg-purple {
  background-color: #6228d3;
}

.solitary-layout .bg-danger {
  background-color: #f31464 !important;
}

.solitary-layout .bg-success {
  background-color: #4ed17d !important;
}

.solitary-layout .bg-info {
  background-color: #3185e6 !important;
}

.solitary-layout #online-visitors h4 {
  font-weight: 600;
}

.solitary-layout #online-visitors .dropdown.float-right {
  margin-top: 5px;
}

.solitary-layout #income-chart ul li span {
  color: #7d8187;
}

.solitary-layout #income-chart ul li h5 {
  margin-top: 5px;
  margin-bottom: 10px;
}

.solitary-layout #income-chart ul li h5 span {
  color: #333333;
}

.solitary-layout .employee-activity-chart .row [class*="col-"] {
  display: flex;
  align-items: center;
}

.solitary-layout .employee-color {
  color: #97ffcd;
}

.solitary-layout .dropdown.float-md-right .btn-white {
  background-color: #fff;
}

.solitary-layout .stat-widget-dashboard .media .media-body h3 {
  font-weight: 600;
}

.solitary-layout .dark-success {
  background-color: #24d27e;
}

.solitary-layout .dark-success h5,
.solitary-layout .dark-success h4 {
  color: #fff;
}

.solitary-layout .bg-info {
  background-color: #3185e6 !important;
}

.solitary-layout .bg-success {
  background-color: #4ed17d !important;
}

.solitary-layout .bg-primary {
  background-color: #6422d2 !important;
}

.solitary-layout .bg-danger {
  background-color: #f31464 !important;
}

.solitary-layout button {
  border-radius: 20px;
  padding: 10px 19px;
  font-size: 12px;
}

.solitary-layout .float-lg-right .btn-gradien,
.solitary-layout .float-md-right .btn-gradien {
  background: linear-gradient(180deg, #3ca0f6 0, #6422d2 100%);
}

.solitary-layout .btn-gradien {
  background: linear-gradient(138deg, #3ca0f6 0, #6422d2 100%);
  color: #fff !important;
  border-radius: 25px;
  padding: 10px 28px;
}

.solitary-layout .card-header {
  border-bottom: none;
}

.solitary-layout .card-header h5 {
  font-size: 18px;
  font-weight: 600;
}

.solitary-layout .iconsidebar-menu {
  width: 290px;
  position: fixed;
  z-index: 10;
  top: 0;
}

.solitary-layout .iconsidebar-menu .logo-wrapper {
  background-color: #21262e;
  width: 120px;
  padding: 10px;
}

.solitary-layout .iconsidebar-menu .logo-wrapper img {
  width: 60px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar {
  width: 120px;
  background-color: #21262e;
  height: 100vh;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .bar-icons {
  display: block;
  text-align: center;
  padding: 25px;
  transition: all 0.3s ease;
  color: #3b434e;
  font-size: 30px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .bar-icons:hover {
  background-color: #293039;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu {
  position: fixed;
  top: 0;
  height: 100%;
  left: 120px;
  width: 253px;
  background-color: #293039;
  transition: all 0.3s ease-in-out;
  display: none;
  z-index: -1;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner {
  margin-top: 70px;
  padding: 0 45px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-header {
  color: #fff !important;
  font-size: 18px !important;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-header i {
  margin-top: 5px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-submenu li {
  margin-bottom: 20px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-submenu li a,
.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-submenu li i {
  font-size: 14px;
  color: #7d8187;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search {
  position: relative;
  color: #fff;
  font-size: 16px;
  padding: 30px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input {
  width: 100%;
  height: 35px;
  background: #21262e;
  border: none;
  border-radius: 20px;
  text-indent: 30px;
  color: #eee;
  padding-right: 35px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input:-ms-input-placeholder {
  color: #7d81879e;
  font-size: 14px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input:-moz-placeholder {
  color: #7d81879e;
  font-size: 14px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input:focus {
  outline: none;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search .fa-search {
  position: absolute;
  top: 40px;
  right: 45px;
  color: #7d81879e;
  font-size: 14px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input::-webkit-input-placeholder {
  color: #7d81879e;
  font-size: 14px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input::-moz-placeholder {
  color: #7d81879e;
  font-size: 14px;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar li.active {
  background: #293039;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar li.active i {
  color: #fff;
}

.solitary-layout .iconsidebar-menu .iconMenu-bar li.active .iconbar-mainmenu {
  display: block;
}

.solitary-layout .iconsidebar-menu .iconbar-mainmenu-close {
  display: none !important;
}

.solitary-layout .page-main-header {
  left: 0;
  right: 0;
  box-shadow: none;
  display: block;
  height: auto;
  background: linear-gradient(22deg, #3ca0f6 0, #6422d2 100%);
}

.solitary-layout .page-main-header .solitary-header .main-header-right {
  float: right;
  width: auto;
  padding: 0;
}

.solitary-layout .page-main-header .solitary-header .main-header-right .nav-right ul li i {
  font-size: inherit;
}

.solitary-layout .page-main-header .main-header-right .nav-right .notification {
  background-color: #fff;
}

.solitary-layout .iconbar-close .page-body {
  transition: 0.5s;
  margin-left: 120px !important;
}

.solitary-layout .iconbar-close .top-section {
  transition: 0.5s;
  margin-left: 120px !important;
  width: calc(100% - 120px) !important;
}

.solitary-layout .page-body-wrapper .page-header {
  padding: 0 20px;
}

.solitary-layout .page-body-wrapper .top-section {
  margin-left: 373px;
  top: 90px;
  padding: 35px 0;
  position: fixed;
  background-color: #fff;
  z-index: 2;
  width: calc(100% - 373px);
  box-shadow: 0 0 0 1px #eee;
}

.solitary-layout .page-body-wrapper .page-body {
  margin-left: 373px;
  min-height: calc(100vh - 90px);
  margin-top: 237px;
  padding-top: 40px;
  z-index: 1;
  position: relative;
  transition: 0.5s;
  background-color: #f2f2f2;
}

.solitary-layout .page-body-wrapper .page-body.inner-content-margin {
  margin-top: 189px;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce-right {
  padding-right: 0;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce-left {
  padding-left: 0;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce {
  padding: 0;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div:first-child .card {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div:nth-child(4) .card {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div:nth-child(5) .card {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div .card {
  border-radius: 0;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div .card .ecommerce-widget {
  border-right: 1px solid #f2f2f2;
}

.solitary-layout .page-body-wrapper .page-body #online-sales .row div .card .border-right-none {
  border-right: none;
}

.solitary-layout .solitary-scrollpy {
  position: relative;
  top: 36px;
}

.solitary-layout .solitary-scrollpy .nav-pills .nav-item a {
  color: #7d8187;
  letter-spacing: 1px;
  font-size: 14px;
  padding: 15px 20px;
  font-weight: 600;
}

.solitary-layout .solitary-scrollpy .nav-pills .nav-item .active {
  background-color: #f2f2f2;
  color: #21262e;
  border: 1px solid #eee;
  border-bottom: none;
  border-radius: 0;
}

.solitary-layout .solitary-scrollpy #mob_tab_cls {
  display: none;
}

.solitary-layout .annual-chart {
  border: none;
  padding: 0;
}

.solitary-layout .social-widget {
  position: relative;
  overflow: hidden;
}

.solitary-layout .social-widget .social-icons {
  font-size: 18px;
}

.solitary-layout .social-widget .icon-bg-right {
  position: absolute;
  right: -39px;
  bottom: 14px;
  color: #f2f2f2;
  font-size: 109px;
  z-index: 0;
  opacity: 0.5;
}

.solitary-layout .social-widget .icon-bg-right:hover {
  transform: rotate(-5deg) scale(1.1);
  transition: all 0.3s ease;
}

.solitary-layout .collection-chart .flot-chart-container {
  height: 231px;
  border: none;
  padding: 0;
  margin: 0;
}

.solitary-layout .employee-activity-chart .flot-chart-container {
  border: none;
  padding: 0;
  margin: 0;
  height: 315px;
}

.solitary-layout .employee-activity-chart .flot-chart-container svg {
  width: 100% !important;
}

.solitary-layout .employee-salary-chart canvas {
  height: 257px !important;
}

.solitary-layout .online-visitors-charts .flot-chart-container {
  border: none;
  padding: 0;
  margin: 0;
  height: 200px;
}

.solitary-layout .morris-hover {
  z-index: 0;
}

.solitary-layout .annual-chart svg {
  width: 100% !important;
}

@media only screen and (max-width: 1366px) {
  .solitary-layout .page-body #online-sales .row div:nth-child(2) .card {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  .solitary-layout .page-body #online-sales .row div:nth-child(3) .card {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .solitary-layout .page-body #online-sales .row div.lg-set-padding {
    padding-right: 15px !important;
  }

  .solitary-layout .page-body #online-sales .row div.lg-pl-set {
    padding-left: 15px !important;
  }

  .solitary-layout .page-body #online-sales .row div .card {
    border-radius: 0;
  }

  .solitary-layout .page-body #online-sales .row div .card .ecommerce-widget.border-lg-none {
    border-right: none;
  }
}

@media only screen and (max-width: 1199px) {
  .solitary-layout .iconsidebar-menu {
    width: 121px;
  }

  .solitary-layout .page-body-wrapper .page-body,
  .solitary-layout .page-body-wrapper .top-section {
    margin-left: 120px;
  }

  .solitary-layout .page-body-wrapper .top-section {
    width: calc(100% - 120px);
  }
}

@media only screen and (max-width: 991px) {
  .solitary-layout .page-body-wrapper .top-section {
    top: 60px;
  }

  .solitary-layout .page-body-wrapper .top-section .page-header {
    padding-top: 0;
    padding-bottom: 0;
  }

  .solitary-layout .page-body-wrapper .page-body {
    margin-top: 235px !important;
    padding-top: 40px !important;
    margin-left: 120px !important;
  }

  .solitary-layout .page-body-wrapper #employee .mt-3 {
    margin-top: 0 !important;
  }

  .solitary-layout .page-body-wrapper #employee .dark-success h5.p-t-5 {
    padding-top: 9px !important;
  }

  .solitary-layout .page-body-wrapper .social-widget .icon-bg-right {
    font-size: 93px;
  }

  .solitary-layout .page-body-wrapper #online-visitors .dropdown.float-right {
    margin-top: 4px;
  }

  .solitary-layout .page-body-wrapper .online-visitors-charts.p-l-30 {
    padding-left: 20px;
  }

  .solitary-layout .page-body-wrapper .online-visitors-charts.p-r-30 {
    padding-right: 20px;
  }

  .solitary-layout .page-main-header {
    padding-top: 0;
    padding-bottom: 0;
  }

  .solitary-layout .page-main-header .solitary-header .main-header-right {
    padding-top: 12px;
  }

  .solitary-layout .page-main-header .solitary-header .main-header-right .nav-right>ul {
    background-color: #21262e;
    box-shadow: none;
  }
}

@media only screen and (max-width: 767px) {
  .solitary-layout .page-body-wrapper #employee .mt-3 {
    margin-top: 20px !important;
  }

  .solitary-layout.page-wrapper .page-body {
    margin-left: 55px !important;
  }

  .solitary-layout.page-wrapper .top-section {
    margin-left: 40px !important;
    width: calc(100% - 40px) !important;
  }

  .solitary-layout.page-wrapper .iconsidebar-menu {
    top: 60px;
    width: 55px;
  }

  .solitary-layout.page-wrapper .iconsidebar-menu .logo-wrapper {
    width: 55px;
  }

  .solitary-layout.page-wrapper .iconsidebar-menu .iconMenu-bar {
    width: 55px;
  }

  .solitary-layout.page-wrapper .iconsidebar-menu .iconMenu-bar .bar-icons {
    font-size: 25px;
    padding: 10px;
  }

  .solitary-layout.page-wrapper .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu {
    left: 55px;
    width: 34%;
  }

  .solitary-layout.page-wrapper .solitary-scrollpy .nav-pills .nav-item a {
    padding: 15px 7px;
  }

  .solitary-layout.page-wrapper #income-chart .mt-3 {
    margin-top: 20px !important;
  }

  .solitary-layout.page-wrapper #online-visitors .social-widget .media {
    padding: 0 0;
  }
}

@media only screen and (max-width: 575px) {
  .solitary-layout.page-wrapper .page-body-wrapper .page-body {
    margin-top: 208px !important;
    padding-top: 20px !important;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce {
    padding: 0 15px !important;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce-left {
    padding-left: 15px !important;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div .card {
    border-radius: 0.25rem;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div .card .ecommerce-widget {
    border-right: none;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .p-set-ecommerce-right {
    padding-right: 15px !important;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .solitary-scrollpy #mob_tab_cls {
    display: block;
    font-size: 17px;
    margin-left: 10px;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .solitary-scrollpy .nav-pills .nav-item a {
    font-size: 10px;
    padding: 10px;
  }

  .solitary-layout.page-wrapper .page-body-wrapper #employee .p-t-10,
  .solitary-layout.page-wrapper .page-body-wrapper #income-chart .p-t-10 {
    padding-top: 0 !important;
  }

  .solitary-layout.page-wrapper .page-body-wrapper #employee .mt-3,
  .solitary-layout.page-wrapper .page-body-wrapper #income-chart .mt-3 {
    margin-top: 15px !important;
  }

  .solitary-layout.page-wrapper .page-body-wrapper #employee .employee-activity-chart .m-30,
  .solitary-layout.page-wrapper .page-body-wrapper #income-chart .employee-activity-chart .m-30 {
    margin: 15px !important;
  }

  .solitary-layout.page-wrapper .page-body-wrapper #solitary-scrollpy .nav-pills {
    display: none;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .online-visitors-charts.p-r-30 {
    padding-right: 15px;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .online-visitors-charts.p-l-30 {
    padding-left: 15px;
  }

  .solitary-layout.page-wrapper .page-body-wrapper .iconbar-close .page-body {
    margin-left: 55px !important;
    margin-top: 275px !important;
    padding-top: 15px !important;
  }

  .solitary-layout.page-wrapper .iconsidebar-menu .iconbar-mainmenu {
    width: 60% !important;
  }
}

@media only screen and (max-width: 360px) {
  .solitary-layout button:last-child {
    margin-top: 5px;
  }

  .solitary-layout .online-visitors-charts .flot-chart-container #west-zone-graph canvas {
    width: 202px !important;
  }
}

.vertical-layout .vertical-menu-main {
  top: 136px;
  background-color: #4099ff;
}

.vertical-layout .vertical-menu-main nav ul {
  width: 59%;
  margin: 0 auto;
}

.vertical-layout .vertical-menu-main nav ul li a {
  color: #fff;
}

.vertical-layout .vertical-menu-main nav ul li ul li a {
  color: #333333;
}

@media (min-width: 1200px) {

  .vertical-layout .vertical-menu-main .pixelstrap ul a:hover,
  .vertical-layout .vertical-menu-main .pixelstrap ul a:focus,
  .vertical-layout .vertical-menu-main .pixelstrap ul a:active,
  .vertical-layout .vertical-menu-main .pixelstrap ul a.highlighted {
    color: #ab8ce4;
  }
}

.vertical-layout .page-body-wrapper .page-body {
  min-height: calc(100vh - 80px);
}

.vertical-layout .page-body-wrapper .page-body.vertical-menu-mt {
  margin-top: 189px !important;
}

.vertical-layout .page-body-wrapper .table th,
.vertical-layout .page-body-wrapper .table td {
  vertical-align: middle;
}

.vertical-layout .page-body-wrapper .user-status tbody tr:first-child td {
  padding-top: 0;
}

.vertical-layout .page-body-wrapper .user-status tbody tr td:first-child {
  padding-left: 0;
}

.vertical-layout .page-body-wrapper .user-status tbody tr td .icon-box i {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 50%;
}

.vertical-layout .page-body-wrapper .user-status tbody tr td .icon-box i:first-child {
  padding: 9px 12px;
  margin-right: 2px;
}

.vertical-layout .page-body-wrapper .user-status tbody tr .bd-t-none .d-inline-block img {
  border: 3px solid #ab8ce4;
}

.vertical-layout .page-body-wrapper .image-border tr td:first-child {
  padding-left: 0;
}

.vertical-layout .page-body-wrapper .image-border tr td .d-inline-block img {
  border: 3px solid #ddd;
}

.vertical-layout .number {
  font-family: sans-serif;
}

.vertical-layout .onhover-show-div {
  top: 100px;
}

.vertical-layout .page-main-header {
  left: 0;
  right: 0;
  box-shadow: none;
  display: block;
  height: auto;
  background-color: #fff;
}

.vertical-layout .page-main-header .main-header-left {
  margin-top: 15px;
}

.vertical-layout .page-main-header .main-header-right {
  float: right;
  width: auto;
  padding: 0;
}

.vertical-layout .page-main-header .main-header-right .nav-right .notification {
  top: 37px;
}

.vertical-layout .page-main-header .main-header-right .nav-right>ul>li {
  padding: 45px 0;
}

.vertical-layout .page-main-header .main-header-right .nav-right .user-imgbg {
  margin: 0 auto;
  background: #4099ff;
  border-radius: 50%;
  padding: 3px;
}

.vertical-layout .search-form input {
  border-radius: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-color: #fff;
  color: #000;
  width: 275px;
  background-size: 12px;
  padding: 10px 20px;
}

.vertical-layout .search-form input:-ms-input-placeholder {
  color: #cccccc;
}

.vertical-layout .search-form input:-moz-placeholder {
  color: #cccccc;
}

.vertical-layout .search-form input:focus {
  outline: none;
}

.vertical-layout .search-form input::-webkit-input-placeholder {
  color: #cccccc;
}

.vertical-layout .search-form input::-moz-placeholder {
  color: #cccccc;
}

.vertical-layout .card {
  border-radius: 0px;
}

.vertical-layout .card .card-header {
  border-bottom: none;
  padding: 30px;
}

.vertical-layout .card .card-header h5 {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: bold;
}

.vertical-layout .browser-widget .media-body {
  column-count: auto;
  column-count: initial;
  column-rule: none;
}

.vertical-layout .browser-widget .media-body h3 {
  font-weight: 600;
}

.vertical-layout .browser-widget .media-body h3 span {
  color: #000;
}

.vertical-layout .speed-chart .chart-container {
  margin-top: -128px;
  height: 503px;
}

.vertical-layout .crm-overall .flot-chart-placeholder {
  height: 185px;
}

.vertical-layout .crm-overall {
  border-radius: 0;
}

.vertical-layout .chart-block #recent-act {
  height: 301px;
}

.vertical-layout footer {
  position: relative;
  background-color: #1A1C1D;
  padding: 25px;
}

.vertical-layout #ct-7.flot-chart-container {
  height: 400px !important;
}

@media screen and (max-device-width: 1366px) and (min-device-width: 1200px) {
  .vertical-layout .browser-widget img {
    height: 80px;
  }
}

@media only screen and (max-width: 1366px) {
  .vertical-layout .vertical-menu-main nav ul {
    width: 85%;
    margin: 0 auto;
  }

  .vertical-layout .pixelstrap a {
    padding: 15px 17px;
    padding-right: 25px;
  }

  .vertical-layout .pixelstrap a:hover,
  .vertical-layout .pixelstrap a:focus,
  .vertical-layout .pixelstrap a:active {
    padding: 15px 17px;
    padding-right: 25px;
  }

  .vertical-layout .browser-widget .media .media-body h3 {
    font-size: 28px;
  }

  .vertical-layout .chart-block #recent-act {
    height: 306px;
  }
}

@media only screen and (max-width: 1199px) {
  .vertical-layout .vertical-menu-main nav ul {
    width: 300px;
  }

  .vertical-layout .vertical-menu-main nav ul li a {
    color: #000;
  }

  .vertical-layout .sm {
    top: 129px;
  }

  .vertical-layout .crm-overall .flot-chart-placeholder {
    height: 180px;
  }

  .vertical-layout .chart-block #recent-act {
    height: 306px;
  }

  .vertical-layout .page-body-wrapper .page-body.vertical-menu-mt {
    margin-top: 136px !important;
  }

  .vertical-layout .page-body-wrapper .vertical-menu .navbar .nav-item .nav-link {
    padding: 10px;
    font-size: 12px;
  }
}

@media screen and (min-device-width: 768px) and (max-device-width: 992px) {
  .vertical-layout .crm-overall .flot-chart-placeholder {
    height: 280px;
  }
}

@media only screen and (max-width: 991px) {
  .vertical-layout .page-main-header {
    height: 75px !important;
  }

  .vertical-layout .page-main-header .main-header-left {
    margin-top: 0;
  }

  .vertical-layout .page-main-header .main-header-left .logo-wrapper img {
    margin-top: 0px;
  }

  .vertical-layout .page-main-header .main-header-right {
    margin-top: 12px;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right {
    text-align: center;
    margin: 15px 0;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right .onhover-show-div {
    display: block !important;
    top: 50px;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right .onhover-show-div li {
    padding: 12px 0px;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right .notification-dropdown.onhover-show-div li {
    padding: 12px 20px;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right ul {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right ul li {
    padding: 0px 0;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right .notification {
    top: 9px;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right .profile-dropdown li {
    padding: 0 0 5px 0px;
  }

  .vertical-layout .page-body-wrapper .vertical-menu~.page-body {
    margin-top: 260px;
  }

  .vertical-layout .page-body-wrapper .vertical-menu {
    top: 209px;
    padding: 10px 0;
    background: linear-gradient(22deg, #0bc0f4 0, #33e7d1 100%);
  }

  .vertical-layout .page-body-wrapper .vertical-menu .navbar .navbar-collapse .navbar-nav .nav-item .nav-link {
    color: #fff;
  }

  .vertical-layout .page-body-wrapper .vertical-menu .navbar .navbar-collapse .navbar-nav .nav-item .sub-menu>.nav-item .sub-menu {
    left: 0 !important;
    top: 50px !important;
  }

  .vertical-layout .page-body-wrapper .vertical-menu .navbar-toggler {
    background-color: #19c9ed;
    padding: 0;
  }

  .vertical-layout .page-body-wrapper .page-body.vertical-menu-mt {
    margin-top: 69px !important;
  }

  .vertical-layout .sm {
    top: 75px;
  }

  .vertical-layout .media-mb {
    margin-bottom: 20px;
  }

  .vertical-layout .chart-block #recent-act {
    height: 255px;
  }
}

@media only screen and (max-width: 767px) {
  .vertical-layout .page-main-header .main-header-left {
    margin-top: 0;
    width: 150px;
  }

  .vertical-layout .page-main-header .main-header-right {
    float: right;
  }

  .vertical-layout .page-main-header .main-header-right .search-form input {
    width: 100%;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right {
    text-align: center;
    margin: 15px 0;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right ul li {
    padding: 0px 0;
  }

  .vertical-layout .page-main-header .main-header-right .nav-right .profile-dropdown li {
    padding: 0 0 5px 0px;
  }

  .vertical-layout .page-body-wrapper .vertical-menu~.page-body {
    margin-top: 260px;
  }

  .vertical-layout .page-body-wrapper .vertical-menu {
    top: 208px;
    padding: 10px 0;
  }

  .vertical-layout .browser-widget .media .media-img {
    width: auto;
    margin-bottom: 0;
  }

  .vertical-layout .user-status tbody tr td {
    min-width: 90px;
  }
}

@media only screen and (max-width: 575px) {
  .vertical-layout .page-body-wrapper .vertical-menu~.page-body {
    margin-top: 257px;
  }

  .vertical-layout .page-body-wrapper .vertical-menu {
    top: 205px;
  }

  .vertical-layout .page-body-wrapper .vertical-menu .navbar .nav-item .sub-menu>.nav-item .sub-menu {
    left: 0 !important;
    top: 50px !important;
  }

  .vertical-layout .page-main-header .main-header-left .logo-wrapper img {
    height: 45px !important;
  }

  .vertical-layout .center-small-size {
    align-items: center;
    justify-content: center;
  }

  .vertical-layout .center-small-size .media-body {
    flex: 0 1;
    min-width: 21%;
  }

  .vertical-layout .media-mb {
    margin-bottom: 15px;
  }
}

@media only screen and (max-width: 360px) {
  .vertical-layout .chart-block #recent-act {
    height: 235px;
  }

  .vertical-layout .user-status table tbody img {
    height: auto;
  }

  .vertical-layout .user-status table tbody tr td {
    min-width: 108px;
  }

  .vertical-layout .center-small-size .media-body {
    min-width: 34%;
  }
}
.card .delivered-card-body {
  padding:15px 0px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwEE;AACF;;4BAE4B;AAC5B;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;EAYE,cAAc;EACd,aAAa;AACf;;AAEA;;;;;;;;;;;;EAYE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B,mCAAmC;AACnC;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC,wCAAwC;AACxC;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC,uCAAuC;AACvC;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC,0CAA0C;AAC1C;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,wCAAwC;AACxC,yCAAyC;AACzC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC,kCAAkC;AAClC;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC,sCAAsC;AACtC;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC,yCAAyC;AACzC;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uCAAuC;AACvC,uCAAuC;AACvC;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC,wCAAwC;AACxC;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC,yCAAyC;AACzC;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uCAAuC;AACvC,qCAAqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC,uCAAuC;AACvC;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC,sCAAsC;AACtC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,qBAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC,0CAA0C;AAC1C;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAiB;EAAjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC,iCAAiC;AACjC;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,+BAA+B;AAC/B,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC,uCAAuC;AACvC;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC,sCAAsC;AACtC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC,gDAAgD;AAChD;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,6CAA6C;AAC7C,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC,4CAA4C;AAC5C;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EAEE,gCAAgC;AAClC;;AAEA,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAEhC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EAErB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EAEZ,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,yDAAyD;AACzD;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA,uDAAuD;AACvD,6CAA6C;AAC7C;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C,iDAAiD;AACjD;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,+CAA+C;AAC/C,wCAAwC;AACxC;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EAEE,2CAA2C;EAC3C,mBAAmB;EACnB,SAAS;EAET,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;EAEzB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C,sCAAsC;AACtC;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,oCAAoC;AACpC,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC,wCAAwC;AACxC;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC,sCAAsC;AACtC;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EAEX,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,wBAAwB;EACxB,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAEhB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EAGZ,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;EAEd,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAElB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EAGd,mBAAmB;EAGnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EAEE,yCAAyC;EACzC,mBAAmB;EACnB,qBAAqB;EAErB,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAcA;EACE;IAEE,mBAAmB;EACrB;;EAEA;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAGlB,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EAEE,iCAAiC;EAEjC,sBAAsB;EAEtB,mCAAmC;EAEnC,sBAAsB;EACtB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AASA;EACE;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;;;;EAKE,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;EAEE,+BAA+B;EAE/B,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,UAAU;EAEV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EAGZ,oBAAoB;EACpB,YAAY;EACZ,aAAa;EAGb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EAEd,8BAA8B;AAChC;;AAoBA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;AACjB;;AAkCA;EACE;IAEE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IAEE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IAEE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IAEE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IAEE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAa;EAAb,aAAa;AACf;;AAEA;;EAEE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EAEtB,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC,yCAAyC;AACzC;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,MAAM;EACN,WAAW;EAGX,aAAa;EAGb,mBAAmB;EAEnB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,SAAS;EAET,wCAAwC;EACxC,0BAA0B;EAC1B,cAAc;EACd,UAAU;EAEV,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAElB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EAEtB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EAExB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,yDAAyI;EACzI,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EAEjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAEhB,yBAAyB;AAC3B;;AAEA;EAEE,wBAAwB;EAExB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EAEd,wBAAwB;EAExB,yBAAyB;EAGzB,wCAAwC;EAGxC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyI;EACzI,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EAEb,4BAA4B;EAE5B,0BAA0B;EAC1B,yDAAyI;EACzI,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EAEd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EAEd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAEhB,4BAA4B;AAC9B;;AAEA;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAEhB,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,UAAU;EAEV,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,UAAU;EACV,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC,mDAAmD;AACnD;;;EAGE,cAAc;EAEd,wBAAwB;EACxB,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAEhB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EAGE,aAAa;EAIb,mBAAmB;EAGnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,OAAO;EAEP,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EAEd,wBAAwB;EACxB,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAEhB,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iDAAiD;AACjD,oDAAoD;AACpD;EAEE,4BAA4B;EAE5B,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,mDAAmD;AACnD,oCAAoC;AACpC;EAEE,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EAEvB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;EACX,WAAW;EAEX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EAEV,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,WAAW;EAEX,6CAA6C;EAC7C,gDAAgD;EAGhD,gEAAgE;EAEhE,yBAAyB;AAC3B;;AAEA;EAEE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,SAAS;EACT,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;EAGf,mBAAmB;EAGnB,aAAa;EAGb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,WAAW;EAEX,6CAA6C;EAC7C,gDAAgD;EAChD,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,WAAW;EAEX,6CAA6C;EAC7C,gDAAgD;EAChD,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC,mBAAmB;AACnB;EACE,WAAW;EAEX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,6BAA6B;EAC7B,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,YAAY;EAEZ,wCAAwC;AAC1C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EAEb,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,2CAA2C;EAC3C,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EAGE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EAGE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,0BAA0B;EAC1B,UAAU;EAEV,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EAEtB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,mBAAmB;EAEnB,0BAA0B;EAE1B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,8DAA8D;AAChE;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EAEE,kFAAkF;EAClF,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;EAIE,gBAAgB;EAChB,iCAAiC;EAEjC,wFAAwF;AAC1F;;AAEA;EAEE,kFAAkF;EAClF,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;;EAKE,gBAAgB;EAChB,iCAAiC;EAEjC,wFAAwF;AAC1F;;AAEA;EAEE,kFAAkF;EAClF,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;;EAKE,gBAAgB;EAChB,iCAAiC;EAEjC,wFAAwF;AAC1F;;AAEA;EAEE,kFAAkF;EAClF,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;;EAKE,gBAAgB;EAChB,iCAAiC;EAEjC,wFAAwF;AAC1F;;AAEA;EAEE,kFAAkF;EAClF,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;;EAKE,gBAAgB;EAChB,iCAAiC;EAEjC,wFAAwF;AAC1F;;AAEA;EAEE,kFAAkF;EAClF,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;;EAKE,gBAAgB;EAChB,iCAAiC;EAEjC,wFAAwF;AAC1F;;AAEA;EAEE,8EAA8E;EAC9E,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;;EAKE,gBAAgB;EAChB,iCAAiC;EAEjC,sFAAsF;AACxF;;AAEA;EAEE,kFAAkF;EAClF,YAAY;EACZ,WAAW;EACX,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;;;;EAKE,gBAAgB;EAChB,iCAAiC;EAEjC,wFAAwF;AAC1F;;AAEA;EACE,yBAAyB;EAEzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,UAAU;EAEV,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EAEf,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EAEjB,oDAAoD;AACtD;;AAEA;EAEE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EAEX,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EAEX,6CAA6C;AAC/C;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EAGpB,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,OAAO;EAEP,mCAAmC;EACnC,YAAY;AACd;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAEhB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAGlB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EAGE,aAAa;EACb,kBAAkB;EAGlB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAcA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EAEZ,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EAGT,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EAEf,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EAGZ,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,WAAW;EACX,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EAEzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,sBAAsB;EAEtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,cAAc;EAEd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,UAAU;EAEV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EAEzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EAEX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,oBAAoB;EAGpB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAEb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAEb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EAEE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mDAAyC;EACzC,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EAGT,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAElB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;EAIE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yDAA+C;EAE/C,iCAAiC;EACjC,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EAGnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mDAAwC;EAGxC,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EAEb,4CAA4C;EAE5C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wDAAwD;EACxD,sBAAsB;EAEtB,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wDAAwD;EACxD,sBAAsB;EAEtB,4CAA4C;EAC5C,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wDAAwD;EACxD,sBAAsB;EAEtB,4CAA4C;EAC5C,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,wDAAwD;EACxD,sBAAsB;EAEtB,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAcA;EACE;IAEE,oBAAoB;EACtB;;EAEA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,uBAAuB;AACzB;;AAEA;EAEE,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;EAeE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;EAeE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,yDAAuD;EACvD,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,mDAA6C;EAC7C,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EAGE,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EAEb,4CAA4C;EAE5C,sBAAsB;AACxB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EAEtB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EAEtB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EAEzB,sBAAsB;EAGtB,8DAA8D;AAEhE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;EAEE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EAEE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EAEtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;EACrC,yCAAyC;EACzC,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;;;;;;;;;EAUE,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2EAAqE;EACrE,eAAe;AACjB;;AAEA;EACE,2EAAsE;AACxE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B,sBAAsB;AACtB;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,MAAM;EAGN,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,0CAA0C;EAC1C,UAAU;EACV,mBAAmB;EAEnB,mBAAmB;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EAErB,+CAA+C;EAC/C,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EAEX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iBAAiB;EAEjB,mBAAmB;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAElB,yCAAyC;EAGzC,SAAO;EACP,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAElB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;EAEzB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,SAAS;EAET,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EAEzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EAEzB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAElB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAEhB,+CAA+C;EAC/C,UAAU;EACV,OAAO;EACP,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAElB,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yDAAyD;EACzD,iCAAiC;EACjC,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EAGZ,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAG3B,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EAEtB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,UAAU;EAEV,mBAAmB;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EAEV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,MAAM;EACN,WAAW;EACX,YAAY;EACZ,OAAO;EAEP,mBAAmB;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EAEV,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAIE,qBAAqB;EAGrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,YAAY;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EAEV,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAGE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yDAAuD;EACvD,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EAGX,aAAa;EAGb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EAGE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EAEE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0DAAwD;EACxD,sBAAsB;EACtB,aAAa;EACb,wDAAwD;EACxD,gEAAgE;EAChE,2BAA2B;AAC7B;;AAYA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0DAA2D;AAC7D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EAGtB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EAEvB,uEAAuE;EACvE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAElB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAElB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EAEzB,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;4BAE4B;AAC5B;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,MAAM;EACN,WAAW;EAEX,wDAAwD;AAC1D;;AAEA;EACE,aAAiB;EAAjB,mBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wCAAkC;EAAlC,oCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,wCAAkC;EAAlC,oCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EAGE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,iBAAiB;EAEjB,kDAAkD;EAClD,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,yBAAyB;EAEzB,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAa;EAAb,eAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gCAAa;EAAb,eAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAAuB;EAAvB,yBAAuB;EACvB,gCAAa;EAAb,eAAa;AACf;;AAEA;EACE,gCAAa;EAAb,eAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EAEnB,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;;EAGE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,sBAAsB;AACxB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,+BAA+B;EAC/B,kGAAkG;EAClG,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EAEtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAE7B,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EAEE,qIAAqI;AACvI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IAEnB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IAEnB,2BAA2B;EAC7B;;EAEA;IAEE,mCAAmC;EACrC;;EAEA;IACE,cAAc;IACd,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAYA;EACE;IACE,UAAU;IAEV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IAEV,qBAAqB;EACvB;;EAEA;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EAEb,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,QAAQ;EACR,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAYA;EACE;IACE,UAAU;IAEV,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IAEV,2BAA2B;EAC7B;;EAEA;IAEE,wBAAwB;EAC1B;AACF;;AAYA;EACE;IACE,UAAU;IAEV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IAEV,4BAA4B;EAC9B;;EAEA;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EAEE,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EAEE,iCAAiC;EACjC,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EAEE,iCAAiC;EAEjC,2BAA2B;EAC3B,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,cAAc;EACd,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EAEzB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,SAAS;EACT,MAAM;EACN,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAEnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAEhC,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAElC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;EAC7B,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAEhB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EAEnC,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAEhB,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,wBAAwB;EACxB,2CAA2C;EAC3C,QAAQ;EAER,mBAAmB;EAEnB,yBAAyB;EAGzB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EAEE,mBAAmB;EAEnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,mBAAmB;EAEnB,2BAA2B;AAC7B;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,2BAA2B;EAE3B,0BAA0B;AAC5B;;AAEA;EAEE,sCAAsC;AACxC;;AAEA;EAEE,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EAEE,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EAEjB,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,mCAAmC;EAEnC,2BAA2B;AAC7B;;AAEA;EAEE,6BAA6B;AAC/B;;AAEA;EAEE,iBAAiB;EAEjB,2BAA2B;AAC7B;;AAEA;EAEE,eAAe;AACjB;;AAEA;EAEE,uBAAuB;EAEvB,2BAA2B;AAC7B;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,mBAAmB;EAEnB,2BAA2B;AAC7B;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EAEE,4BAA4B;EAE5B,2BAA2B;AAC7B;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EAEV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EAEV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAYA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EAEV,qBAAqB;AACvB;;AAQA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,cAAc;EACd,WAAW;EACX,UAAU;EACV,YAAY;EAEZ,+FAA+F;EAE/F,wBAAwB;AAC1B;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,WAAW;EACX,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EAEnB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EAEE,sBAAsB;AACxB;;AAkBA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EAEE,2DAA2D;EAE3D,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,WAAW;EACX,SAAS;AACX;;AAEA;EAEE,4DAA4D;EAE5D,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAGhB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,OAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAElB,yBAAyB;EACzB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB,wBAAwB;AACxB;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB,yBAAyB;AACzB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EAEV,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,WAAW;EAEX,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EAEV,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,WAAW;EAEX,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,WAAW;EAEX,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA,wBAAwB;AACxB;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,uBAAuB;EAEvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EAEZ,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;EAEvB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EAGE,iBAAiB;EAGjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAGE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAYA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IAEE,uBAAuB;EACzB;;EAEA;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,0DAAsD;EAEtD,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EAEb,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EAEE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EAEE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EAEE,mCAAmC;EAEnC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,YAAY;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,kBAAkB;EAGlB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EAGb,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EAEd,8IAA8I;AAChJ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAGlB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EAEE,+IAA+I;AACjJ;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EACE,+IAA+I;AACjJ;;AAEA;EAEE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EAEE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EACE,gJAAgJ;AAClJ;;AAEA;EAEE,gJAAgJ;AAClJ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EAEE,qBAAqB;EAErB,yBAAyB;EAEzB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EAEZ,uBAAuB;EAEvB,gCAAgC;EAEhC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAElB,eAAe;EAEf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,MAAM;EACN,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oDAA+C;EAC/C,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oDAAqD;EACrD,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAGlB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,cAAc;EACd,wEAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oDAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,oDAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,oDAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EAGjB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,YAAY;EAEZ,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EAEE,wBAAwB;EAExB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oDAA0C;EAC1C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EAGnB,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0CAA0C;EAC1C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EAGZ,mBAAmB;EAGnB,uBAAuB;EACvB,kBAAkB;EAGlB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,MAAM;AACR;;AAEA;EAEE,mCAAmC;EAEnC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAQA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAcA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EAEE,4CAA4C;AAC9C;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EAEf,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EAEpB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EAErB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;EAKE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;EAeE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;EAeE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;EAeE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;;EAGE,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EAGE,wBAAwB;EAGxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EAGE,aAAa;EAGb,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,YAAa;EAAb,eAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,kBAAkB;EAElB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,iGAAiG;EACjG,sHAAsH;EACtH,iEAAiE;EACjE,yBAAyB;EAEzB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EAEvB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAElB,yCAAyC;EAEzC,6BAA6B;AAC/B;;AAEA;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAE7B,6BAA6B;AAC/B;;AAEA;EAEE,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAGE,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,iBAAiB;EAEjB,gEAAgE;EAChE,QAAQ;EAER,gEAAgE;EAChE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,2FAA2F;EAE3F,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAElB,yCAAyC;EAEzC,iCAAiC;EACjC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EAEtB,6CAA6C;EAC7C,gCAAgC;EAChC,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EAErB,gBAAgB;AAClB;;AAEA;;EAGE,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA,0DAA0D;AAC1D;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAElB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAElB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EAEE,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EAEE,uBAAuB;EACvB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EAEE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAElB,6BAA6B;AAC/B;;AAEA;EAEE,eAAe;AACjB;;AAEA;EAEE,uBAAuB;EACvB,4CAA4C;EAC5C,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EAEX,mCAAmC;EAEnC,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AA6BA;EACE;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IAEE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IAEE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IAEE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EAEzB,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE;IAEE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IAEzB,2CAA2C;IAC3C,yBAAyB;IACzB,+BAA+B;EACjC;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;EAEzB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;EAcE,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;;;;EAKE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAE/B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EAEzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,0EAAgE;EAChE,8BAA8B;AAChC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EAEnB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;EAeE,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;EAeE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EAEzB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EAEzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EAEzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAQA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE;IAEE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IAEzB,2CAA2C;IAC3C,yBAAyB;IACzB,+BAA+B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EAEzB,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EAEzB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;EAcE,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;;;;EAKE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAE/B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EAEzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,0EAAgE;EAChE,8BAA8B;AAChC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EAEnB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;EAeE,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;EAeE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EAEzB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EAEzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EAEzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAQA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EAEzB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;IAEzB,iCAAiC;EACnC;AACF;;AAEA;EACE;IAEE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IAEzB,2CAA2C;IAC3C,yBAAyB;IACzB,+BAA+B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EAEzB,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EAEzB,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;EAcE,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;;;;EAKE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAE/B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;EAIE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;;;EAGE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EAEzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,0EAAgE;EAChE,8BAA8B;AAChC;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;;;;IAIE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EAEnB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;EAeE,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;EAeE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EAEzB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EAEzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EAEzB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAQA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0DAAiD;AACnD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;;;;EAIE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,QAAQ;EACR,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAElB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAIE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EAErB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EAErB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EAGE,aAAa;EAGb,mBAAmB;EAEnB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EAEZ,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EAGV,yBAAyB;EAEzB,oCAAoC;EACpC,aAAa;EACb,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,UAAU;EAEV,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAGhB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,eAAe;EAEf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAGE,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EAEE,sBAAsB;EAEtB,wBAAwB;EAExB,qBAAqB;EAErB,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EAEnB,6CAA6C;EAC7C,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAGlB,aAAa;EAGb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EAErB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,UAAW;EAAX,aAAW;EAEX,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,yBAA6B;EAA7B,+BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAW;EAAX,aAAW;EACX,QAAQ;AACV;;AAEA;EACE,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,0BAA8B;EAA9B,gCAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,UAAW;IAAX,aAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAY;IAAZ,cAAY;IACZ,SAAS;EACX;AACF;;AAEA;EACE,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,yBAA6B;EAA7B,+BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,2BAA+B;EAA/B,iCAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAY;EAAZ,cAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAoB;EAApB,sBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,mBAAmB;EACnB,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAkB;EAAlB,oBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,yBAA6B;EAA7B,+BAA6B;AAC/B;;AAEA;EACE,0BAA8B;EAA9B,gCAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAc;EAAd,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAA6B;EAA7B,+BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAW;EAAX,aAAW;EACX,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,UAAW;EAAX,aAAW;EACX,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAoB;EAApB,sBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,eAAmB;EAAnB,qBAAmB;EACnB,kBAAkB;EAClB,gBAAoB;EAApB,sBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAkB;EAAlB,oBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAmB;EAAnB,qBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAW;EAAX,aAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAoB;EAApB,sBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,eAAmB;EAAnB,qBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAkB;EAAlB,oBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAY;EAAZ,cAAY;AACd;;AAEA;;;;;EAKE,oBAAoB;EACpB,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,gBAAoB;EAApB,sBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAkB;EAAlB,oBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAmB;EAAnB,qBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;EAC7C,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,OAAO;EACP,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;;;;EAIE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,OAAO;EACP,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAW;EAAX,aAAW;EAEX,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAkB;EAAlB,oBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAuB;EAAvB,yBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,QAAQ;EACR,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAW;EAAX,aAAW;EACX,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,UAAW;EAAX,aAAW;EACX,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,UAAW;EAAX,aAAW;EACX,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,QAAQ;EACR,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAY;EAAZ,cAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,UAAW;EAAX,aAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,UAAW;EAAX,aAAW;AACb;;AAEA;EAEE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,WAAY;EAAZ,cAAY;EACZ,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,0BAA8B;EAA9B,gCAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,cAAkB;EAAlB,oBAAkB;EAClB,eAAmB;EAAnB,qBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;EAClB,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAY;EAAZ,cAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mCAAmC;EACnC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAyB;EAAzB,2BAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAW;EAAX,aAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAW;EAAX,aAAW;AACb;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAmB;EAAnB,qBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;EAGE,WAAW;EACX,UAAW;EAAX,aAAW;AACb;;AAEA;;4BAE4B;AAC5B;;4BAE4B;AAC5B;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EAEE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EAEE,qCAAqC;AACvC;;AAEA;EAEE,qCAAqC;AACvC;;AAEA;EAEE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAS;EAET,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,OAAO;AACT;;AAcA;EACE;IAEE,qBAAqB;EACvB;;EAEA;IAEE,qBAAqB;EACvB;AACF;;AAcA;EACE;IAEE,qBAAqB;EACvB;;EAEA;IAEE,qBAAqB;EACvB;AACF;;AAgBA;EACE;IAEE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IAEE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EAER,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,0DAA2D;AAC7D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,cAAc;EACd,OAAO;EACP,QAAQ;EAER,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE;;;;IAIE,cAAc;EAChB;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EAEE,2DAA2D;AAC7D;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IAEV,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT,SAAS;IAET,qBAAqB;EACvB;;EAEA;IAEE,qBAAqB;EACvB;;EAEA;IAEE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,wCAAwC;IAExC,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;;IAEE,aAAa;EACf;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAY;IAAZ,cAAY;IACZ,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;4BAE4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,MAAM;EACN,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAe;EAAf,iBAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAkB;EAAlB,oBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EAGZ,0BAA0B;AAE5B;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wDAAwD;EAExD,uDAAuD;EACvD,mDAAmD;EACnD,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,MAAM;IACN,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,0DAAmD;AACrD;;AAEA;EACE,eAAgB;EAAhB,kBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EAEE,mDAAmD;AACrD;;AAEA;;EAGE,mDAAmD;AACrD;;AAEA;EAEE,mDAAmD;AACrD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAElB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EAEzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EAER,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;IACzB,eAAgB;IAAhB,kBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAgB;IAAhB,kBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,OAAO;EACT;;EAEA;IACE,SAAS;IACT,SAAS;IACT,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,yDAAqD;IACrD,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,6BAA6B;IAC7B,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IAGf,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,0IAA0I;AAC5I;;AAEA;EACE,sIAAsI;AACxI;;AAEA;EAEE,0IAA0I;AAC5I;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAGE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;EAC5D,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EAEb,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yBAAyB;EAEzB,gCAAgC;EAChC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,QAAQ;EAER,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EAEE,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,yBAAyB;EAEzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAElB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EAEE,mCAAmC;EAEnC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,gCAAgC;IAChC,mCAAmC;EACrC;;EAEA;IACE,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IAEzB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,mCAAmC;EACrC;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;;;;IAIE,cAAc;EAChB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,QAAQ;EAER,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yDAAqD;EACrD,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EAEE,kBAAmB;EAAnB,qBAAmB;EAEnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IAGE,aAAa;IAGb,mBAAmB;IAGnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,2DAA2D;EAC7D;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IAGE,mBAAmB;IAGnB,uBAAuB;EACzB;;EAEA;IAGE,SAAO;IACP,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/*-----------------------------------------------------------------------------------\n\n    Template Name: Universal Admin\n    Template URI: themes.pixelstrap.com/universal\n    Description: This is Admin theme\n    Author: Pixelstrap\n    Author URI: https://themeforest.net/user/pixelstrap\n\n-----------------------------------------------------------------------------------\n\n01. General CSS\n  02. Generic CSS\n  03. Card CSS\n  04. Loader CSS\n  05. Header CSS\n  06. Button CSS\n  07. Color CSS\n  08. GRID CSS\n  09. Error-page  CSS\n  10. Icon css\n  11. Form Builder 1 CSS\n  12. Form Builder 2 CSS\n   13.  Email Application  CSS\n   14. Chat CSS\n   15. Alert CSS\n   16. Popover CSS\n   17. List CSS\n   18. Switch  CSS\n   19. Mega option CSS\n   20. Touchspin  CSS\n    21. Select 2 CSS\n\t22. User profile css\n\t23. Progress CSS\n\t24. According CSS\n\t25. Authentication CSS\n\t26. Form CSS\n\t27. Coming Soon CSS\n\t28. Radio CSS\n\t29. Form Input CSS\n\t30. Data-table CSS\n\t 31. JS datagrid CSS\n\t 32. Page CSS\n\t 33. Ecommerce  CSS\n\t 34. Pricing CSS\n\t 35. Form builder css\n\t 36. NAV CSS\n\t 37. Dropdown CSS\n\t 38. Landing CSS\n\t 39.Table  CSS\n\t 40. Alertbox-call-out CSS\n\t 41. Chart CSS\n\t 42. Timeline CSS\n\t 43. Timeline 2 CSS\n\t 44. Tabs CSS\n\t 45. Gallery CSS\n\t 46. Blog CSS\n\t 47. Footer CSS\n\t 48. Form Wizard\n\t 49. Badge CSS\n\t 50. Tree CSS\n\t 51. Search CSS\n\t 52. Datepicker CSS\n\t 53. Dashboard CSS  Dashboard CSS\n\t 54. Tour  CSS\n\t 55. theme layout CSS\n\t 56. Ribbon CSS\n\t 57. breadcrumb CSS\n\t 58. Steps  CSS\n\t 59.Customizer CSS\n\t 60. RTL CSS\n\t 62. base_inputs CSS\n\t 63. Responsive css\n */\n/**=====================\n     01. General CSS Start\n==========================**/\nbody {\n  background-color: rgba(246, 246, 246, 0.6);\n  font-size: 14px;\n  overflow-x: hidden;\n  font-family: Raleway;\n  color: #333333;\n}\n\nul {\n  padding-left: 0;\n  list-style-type: none;\n  margin-bottom: 0;\n}\n\n* a {\n  color: #ab8ce4;\n}\n\n*.btn:focus {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\np {\n  font-size: 13px;\n  line-height: 1.7;\n  letter-spacing: 0.7px;\n}\n\ncode {\n  color: #ab8ce4 !important;\n  background-color: #eeeeee;\n  padding: 3px;\n  margin: 0 3px;\n  border-radius: 2px;\n}\n\nblockquote {\n  border-left: 4px solid #cccccc;\n  padding: 15px;\n}\n\nblockquote.text-center {\n  border: none;\n  padding: 15px;\n}\n\nblockquote.text-right {\n  border-left: none;\n  border-right: 4px solid #cccccc;\n  padding: 15px;\n}\n\n:focus {\n  outline-color: #ab8ce4;\n}\n\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.ace-editor {\n  height: 400px;\n  width: 100%;\n}\n\n.editor-toolbar {\n  width: 100% !important;\n}\n\n.CodeMirror {\n  top: 0 !important;\n}\n\n.typography h1,\n.typography .h1,\n.typography h2,\n.typography .h2,\n.typography h3,\n.typography .h3,\n.typography h4,\n.typography .h4,\n.typography h5,\n.typography .h5,\n.typography h6,\n.typography .h6 {\n  margin: 20px 0;\n  margin-top: 0;\n}\n\n.typography h1:last-child,\n.typography .h1:last-child,\n.typography h2:last-child,\n.typography .h2:last-child,\n.typography h3:last-child,\n.typography .h3:last-child,\n.typography h4:last-child,\n.typography .h4:last-child,\n.typography h5:last-child,\n.typography .h5:last-child,\n.typography h6:last-child,\n.typography .h6:last-child {\n  margin-bottom: 0;\n}\n\n.typography small {\n  padding-left: 10px;\n  color: #2a3142;\n}\n\npre {\n  background-color: #f9f7ff;\n  padding: 20px 0;\n}\n\na:hover {\n  text-decoration: none;\n}\n\n.owl-theme .owl-dots .owl-dot span {\n  background: #e7dff7;\n}\n\n.owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n  background: #ab8ce4;\n}\n\n.owl-theme .owl-nav.disabled+.owl-dots {\n  margin-bottom: -10px;\n  margin-top: 25px;\n}\n\n.click2edit~.note-editor.note-frame {\n  margin-bottom: 30px;\n}\n\n.note-editor.note-frame {\n  border-color: #eeeeee;\n}\n\n.note-editor.note-frame {\n  border-color: #eeeeee;\n}\n\n.modal-dialog .modal-content .modal-body p a {\n  margin-right: 0;\n}\n\n/**=====================\n      01. General CSS Ends\n==========================**/\n/**=====================\n     02. Generic CSS Start\n==========================**/\n/*====== Padding css starts ======*/\n.p-0 {\n  padding: 0px;\n}\n\n.p-5 {\n  padding: 5px;\n}\n\n.p-10 {\n  padding: 10px;\n}\n\n.p-15 {\n  padding: 15px;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.p-25 {\n  padding: 25px;\n}\n\n.p-30 {\n  padding: 30px;\n}\n\n.p-35 {\n  padding: 35px;\n}\n\n.p-40 {\n  padding: 40px;\n}\n\n.p-45 {\n  padding: 45px;\n}\n\n.p-50 {\n  padding: 50px;\n}\n\n/*====== Padding css ends ======*/\n/*====== Padding-left css starts ======*/\n.p-l-0 {\n  padding-left: 0px;\n}\n\n.p-l-5 {\n  padding-left: 5px;\n}\n\n.p-l-10 {\n  padding-left: 10px;\n}\n\n.p-l-15 {\n  padding-left: 15px;\n}\n\n.p-l-20 {\n  padding-left: 20px;\n}\n\n.p-l-25 {\n  padding-left: 25px;\n}\n\n.p-l-30 {\n  padding-left: 30px;\n}\n\n.p-l-35 {\n  padding-left: 35px;\n}\n\n.p-l-40 {\n  padding-left: 40px;\n}\n\n.p-l-45 {\n  padding-left: 45px;\n}\n\n.p-l-50 {\n  padding-left: 50px;\n}\n\n/*====== Padding-left css ends ======*/\n/*====== Padding-top css starts ======*/\n.p-t-0 {\n  padding-top: 0px !important;\n}\n\n.p-t-5 {\n  padding-top: 5px !important;\n}\n\n.p-t-10 {\n  padding-top: 10px !important;\n}\n\n.p-t-15 {\n  padding-top: 15px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-25 {\n  padding-top: 25px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-35 {\n  padding-top: 35px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-45 {\n  padding-top: 45px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n/*====== Padding-top css ends ======*/\n/*====== Padding-bottom css starts ======*/\n.p-b-0 {\n  padding-bottom: 0px !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-15 {\n  padding-bottom: 15px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-35 {\n  padding-bottom: 35px !important;\n}\n\n.p-b-40 {\n  padding-bottom: 40px !important;\n}\n\n.p-b-45 {\n  padding-bottom: 45px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n/*====== Padding-bottom css ends ======*/\n/*====== Padding-right css starts ======*/\n.p-r-0 {\n  padding-right: 0px;\n}\n\n.p-r-5 {\n  padding-right: 5px;\n}\n\n.p-r-10 {\n  padding-right: 10px;\n}\n\n.p-r-15 {\n  padding-right: 15px;\n}\n\n.p-r-20 {\n  padding-right: 20px;\n}\n\n.p-r-25 {\n  padding-right: 25px;\n}\n\n.p-r-30 {\n  padding-right: 30px;\n}\n\n.p-r-35 {\n  padding-right: 35px;\n}\n\n.p-r-40 {\n  padding-right: 40px;\n}\n\n.p-r-45 {\n  padding-right: 45px;\n}\n\n.p-r-50 {\n  padding-right: 50px;\n}\n\n/*====== Padding-right css ends ======*/\n/*====== Margin css starts ======*/\n.m-0 {\n  margin: 0px !important;\n}\n\n.m-5 {\n  margin: 5px !important;\n}\n\n.m-10 {\n  margin: 10px !important;\n}\n\n.m-15 {\n  margin: 15px !important;\n}\n\n.m-20 {\n  margin: 20px !important;\n}\n\n.m-25 {\n  margin: 25px !important;\n}\n\n.m-30 {\n  margin: 30px !important;\n}\n\n.m-35 {\n  margin: 35px !important;\n}\n\n.m-40 {\n  margin: 40px !important;\n}\n\n.m-45 {\n  margin: 45px !important;\n}\n\n.m-50 {\n  margin: 50px !important;\n}\n\n/*====== Margin css ends ======*/\n/*====== Margin-top css starts ======*/\n.m-t-0 {\n  margin-top: 0px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-25 {\n  margin-top: 25px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-35 {\n  margin-top: 35px !important;\n}\n\n.m-t-40 {\n  margin-top: 40px !important;\n}\n\n.m-t-45 {\n  margin-top: 45px !important;\n}\n\n.m-t-50 {\n  margin-top: 50px !important;\n}\n\n/*====== Margin-top css ends ======*/\n/*====== Margin-Bottom css starts ======*/\n.m-b-0 {\n  margin-bottom: 0px !important;\n}\n\n.m-b-5 {\n  margin-bottom: 5px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-15 {\n  margin-bottom: 15px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-25 {\n  margin-bottom: 25px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-35 {\n  margin-bottom: 35px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-b-45 {\n  margin-bottom: 45px !important;\n}\n\n.m-b-50 {\n  margin-bottom: 50px !important;\n}\n\n/*====== Margin-Bottom css ends ======*/\n/*====== Margin-left css starts ======*/\n.m-l-0 {\n  margin-left: 0px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-15 {\n  margin-left: 15px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-25 {\n  margin-left: 25px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-l-45 {\n  margin-left: 45px !important;\n}\n\n.m-l-50 {\n  margin-left: 50px !important;\n}\n\n/*====== Margin-left css ends ======*/\n/*====== Margin-right css starts ======*/\n.m-r-0 {\n  margin-right: 0px;\n}\n\n.m-r-5 {\n  margin-right: 5px;\n}\n\n.m-r-10 {\n  margin-right: 10px;\n}\n\n.m-r-15 {\n  margin-right: 15px;\n}\n\n.m-r-20 {\n  margin-right: 20px;\n}\n\n.m-r-25 {\n  margin-right: 25px;\n}\n\n.m-r-30 {\n  margin-right: 30px;\n}\n\n.m-r-35 {\n  margin-right: 35px;\n}\n\n.m-r-40 {\n  margin-right: 40px;\n}\n\n.m-r-45 {\n  margin-right: 45px;\n}\n\n.m-r-50 {\n  margin-right: 50px;\n}\n\n/*====== Margin-right css ends ======*/\n/*====== Border-radius css starts ======*/\n.b-r-0 {\n  border-radius: 0px !important;\n}\n\n.b-r-1 {\n  border-radius: 1px !important;\n}\n\n.b-r-2 {\n  border-radius: 2px !important;\n}\n\n.b-r-3 {\n  border-radius: 3px !important;\n}\n\n.b-r-4 {\n  border-radius: 4px !important;\n}\n\n.b-r-5 {\n  border-radius: 5px !important;\n}\n\n.b-r-6 {\n  border-radius: 6px !important;\n}\n\n.b-r-7 {\n  border-radius: 7px !important;\n}\n\n.b-r-8 {\n  border-radius: 8px !important;\n}\n\n.b-r-9 {\n  border-radius: 9px !important;\n}\n\n.b-r-10 {\n  border-radius: 10px !important;\n}\n\n/*====== Border-radius css ends ======*/\n/*====== Font-size css starts ======*/\n.f-12 {\n  font-size: 12px;\n}\n\n.f-14 {\n  font-size: 14px;\n}\n\n.f-16 {\n  font-size: 16px;\n}\n\n.f-18 {\n  font-size: 18px;\n}\n\n.f-20 {\n  font-size: 20px;\n}\n\n.f-22 {\n  font-size: 22px;\n}\n\n.f-24 {\n  font-size: 24px;\n}\n\n.f-26 {\n  font-size: 26px;\n}\n\n.f-28 {\n  font-size: 28px;\n}\n\n.f-30 {\n  font-size: 30px;\n}\n\n.f-32 {\n  font-size: 32px;\n}\n\n.f-34 {\n  font-size: 34px;\n}\n\n.f-36 {\n  font-size: 36px;\n}\n\n.f-38 {\n  font-size: 38px;\n}\n\n.f-40 {\n  font-size: 40px;\n}\n\n.f-42 {\n  font-size: 42px;\n}\n\n.f-44 {\n  font-size: 44px;\n}\n\n.f-46 {\n  font-size: 46px;\n}\n\n.f-48 {\n  font-size: 48px;\n}\n\n.f-50 {\n  font-size: 50px;\n}\n\n.f-52 {\n  font-size: 52px;\n}\n\n.f-54 {\n  font-size: 54px;\n}\n\n.f-56 {\n  font-size: 56px;\n}\n\n.f-58 {\n  font-size: 58px;\n}\n\n.f-60 {\n  font-size: 60px;\n}\n\n.f-62 {\n  font-size: 62px;\n}\n\n.f-64 {\n  font-size: 64px;\n}\n\n.f-66 {\n  font-size: 66px;\n}\n\n.f-68 {\n  font-size: 68px;\n}\n\n.f-70 {\n  font-size: 70px;\n}\n\n.f-72 {\n  font-size: 72px;\n}\n\n.f-74 {\n  font-size: 74px;\n}\n\n.f-76 {\n  font-size: 76px;\n}\n\n.f-78 {\n  font-size: 78px;\n}\n\n.f-80 {\n  font-size: 80px;\n}\n\n.f-82 {\n  font-size: 82px;\n}\n\n.f-84 {\n  font-size: 84px;\n}\n\n.f-86 {\n  font-size: 86px;\n}\n\n.f-88 {\n  font-size: 88px;\n}\n\n.f-90 {\n  font-size: 90px;\n}\n\n.f-92 {\n  font-size: 92px;\n}\n\n.f-94 {\n  font-size: 94px;\n}\n\n.f-96 {\n  font-size: 96px;\n}\n\n.f-98 {\n  font-size: 98px;\n}\n\n.f-100 {\n  font-size: 100px;\n}\n\n/*====== Font-size css ends ======*/\n/*====== Font-weight css starts ======*/\n.f-w-100 {\n  font-weight: 100;\n}\n\n.f-w-300 {\n  font-weight: 300;\n}\n\n.f-w-400 {\n  font-weight: 400;\n}\n\n.f-w-600 {\n  font-weight: 600;\n}\n\n.f-w-700 {\n  font-weight: 700;\n}\n\n.f-w-900 {\n  font-weight: 900;\n}\n\n/*====== Font-weight css ends ======*/\n/*====== Font-style css starts ======*/\n.f-s-normal {\n  font-style: normal;\n}\n\n.f-s-italic {\n  font-style: italic;\n}\n\n.f-s-oblique {\n  font-style: oblique;\n}\n\n.f-s-initial {\n  font-style: initial;\n}\n\n.f-s-inherit {\n  font-style: inherit;\n}\n\n/*====== Font-style css ends ======*/\n/*====== Text-Decoration css starts ======*/\n.text-overline {\n  text-decoration: overline;\n}\n\n.text-line-through {\n  text-decoration: line-through;\n}\n\n.text-underline {\n  text-decoration: underline;\n}\n\n.text-dashed {\n  -webkit-text-decoration: dashed;\n  text-decoration: dashed;\n}\n\n.text-blink {\n  text-decoration: blink;\n}\n\n.text-dotted {\n  -webkit-text-decoration: dotted;\n  text-decoration: dotted;\n}\n\n.text-initial {\n  text-decoration: initial;\n}\n\n.text-none {\n  text-decoration: none;\n}\n\n.text-solid {\n  -webkit-text-decoration: solid;\n  text-decoration: solid;\n}\n\n.text-wavy {\n  -webkit-text-decoration: wavy;\n  text-decoration: wavy;\n}\n\n.text-inherit {\n  text-decoration: inherit;\n}\n\n.text-double {\n  -webkit-text-decoration: double;\n  text-decoration: double;\n}\n\n/*====== Text-Decoration css ends ======*/\n/*====== Vertical-Align css starts ======*/\n.baseline {\n  vertical-align: baseline;\n}\n\n.sub {\n  vertical-align: sub;\n}\n\n.super {\n  vertical-align: super;\n}\n\n.top {\n  vertical-align: top;\n}\n\n.text-top {\n  vertical-align: text-top;\n}\n\n.middle {\n  vertical-align: middle;\n}\n\n.bottom {\n  vertical-align: bottom;\n}\n\n.text-bottom {\n  vertical-align: text-bottom;\n}\n\n.initial {\n  vertical-align: initial;\n}\n\n.inherit {\n  vertical-align: inherit;\n}\n\n/*====== Vertical-Align css ends ======*/\n/*====== Position css starts ======*/\n.p-static {\n  position: static;\n}\n\n.p-absolute {\n  position: absolute;\n}\n\n.p-fixed {\n  position: fixed;\n}\n\n.p-relative {\n  position: relative;\n}\n\n.p-initial {\n  position: initial;\n}\n\n.p-inherit {\n  position: inherit;\n}\n\n/*====== Position css ends ======*/\n/*====== Float css starts ======*/\n.f-left {\n  float: left;\n}\n\n.f-right {\n  float: right;\n}\n\n.f-none {\n  float: none;\n}\n\n/*====== Float css ends ======*/\n/*====== Overflow css starts ======*/\n.o-hidden {\n  overflow: hidden;\n}\n\n.o-visible {\n  overflow: visible;\n}\n\n.o-auto {\n  overflow: auto;\n}\n\n/*====== Overflow css ends ======*/\n/*====== Image-sizes css starts ======*/\n.img-10 {\n  width: 10px !important;\n}\n\n.img-20 {\n  width: 20px !important;\n}\n\n.img-30 {\n  width: 30px !important;\n}\n\n.img-40 {\n  width: 40px !important;\n}\n\n.img-50 {\n  width: 50px !important;\n}\n\n.img-60 {\n  width: 60px !important;\n}\n\n.img-70 {\n  width: 70px !important;\n}\n\n.img-80 {\n  width: 80px !important;\n}\n\n.img-90 {\n  width: 90px !important;\n}\n\n.img-100 {\n  width: 100px !important;\n}\n\n/*====== Image-sizes css ends ======*/\n/*======= Text css starts ===========*/\n.font-primary {\n  color: #ab8ce4 !important;\n}\n\n.font-secondary {\n  color: #26c6da !important;\n}\n\n.font-success {\n  color: #00c292 !important;\n}\n\n.font-danger {\n  color: #FF5370 !important;\n}\n\n.font-info {\n  color: #4099ff !important;\n}\n\n.font-light {\n  color: #eeeeee !important;\n}\n\n.font-dark {\n  color: #2a3142 !important;\n}\n\n.font-warning {\n  color: #f3d800 !important;\n}\n\n/*======= Text css ends ===========*/\n/*======= Label-color css starts  ======= */\n.label {\n  border-radius: 2px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n  margin-bottom: 0;\n  text-transform: capitalize;\n}\n\n.label-theme {\n  background-color: #ab8ce4;\n}\n\n.label-primary {\n  background-color: #ab8ce4;\n}\n\n.label-secondary {\n  background-color: #26c6da;\n}\n\n.label-success {\n  background-color: #00c292;\n}\n\n.label-danger {\n  background-color: #FF5370;\n}\n\n.label-info {\n  background-color: #4099ff;\n}\n\n.label-light {\n  background-color: #eeeeee;\n}\n\n.label-dark {\n  background-color: #2a3142;\n}\n\n.label-warning {\n  background-color: #f3d800;\n}\n\n/*======= Label-color css ends  ======= */\n/*======= Badge-color css starts  ======= */\n.badge-primary {\n  background-color: #ab8ce4;\n}\n\n.badge-secondary {\n  background-color: #26c6da;\n}\n\n.badge-success {\n  background-color: #00c292;\n}\n\n.badge-danger {\n  background-color: #FF5370;\n}\n\n.badge-info {\n  background-color: #4099ff;\n}\n\n.badge-light {\n  background-color: #eeeeee;\n}\n\n.badge-dark {\n  background-color: #2a3142;\n}\n\n.badge-warning {\n  background-color: #f3d800;\n}\n\n/*======= Badge-color css end  ======= */\n/*======= Background-color css starts  ======= */\n.bg-primary {\n  background-color: #ab8ce4 !important;\n  color: #fff;\n}\n\n.bg-secondary {\n  background-color: #26c6da !important;\n  color: #fff;\n}\n\n.bg-success {\n  background-color: #00c292 !important;\n  color: #fff;\n}\n\n.bg-danger {\n  background-color: #FF5370 !important;\n  color: #fff;\n}\n\n.bg-info {\n  background-color: #4099ff !important;\n  color: #fff;\n}\n\n.bg-light {\n  background-color: #eeeeee !important;\n  color: #fff;\n}\n\n.bg-dark {\n  background-color: #2a3142 !important;\n  color: #fff;\n}\n\n.bg-warning {\n  background-color: #f3d800 !important;\n  color: #fff;\n}\n\n/*======= Background-color css end  ======= */\n/*======= Font-color css starts  ======= */\n.txt-primary {\n  color: #ab8ce4 !important;\n}\n\n.txt-secondary {\n  color: #26c6da !important;\n}\n\n.txt-success {\n  color: #00c292 !important;\n}\n\n.txt-danger {\n  color: #FF5370 !important;\n}\n\n.txt-info {\n  color: #4099ff !important;\n}\n\n.txt-light {\n  color: #eeeeee !important;\n}\n\n.txt-dark {\n  color: #2a3142 !important;\n}\n\n.txt-warning {\n  color: #f3d800 !important;\n}\n\n.txt-google-plus {\n  color: #c64e40 !important;\n}\n\n.txt-twitter {\n  color: #6fa2d8 !important;\n}\n\n.txt-linkedin {\n  color: #0077B5 !important;\n}\n\n.txt-fb {\n  color: #50598e !important;\n}\n\n.txt-white {\n  color: #fff !important;\n}\n\n/*======= Font-color css end  ======= */\n/*======= Button-color css starts  ======= */\n.btn-primary {\n  background-color: #ab8ce4 !important;\n  border-color: #ab8ce4 !important;\n}\n\n.btn-primary.disabled {\n  background-color: #ab8ce4 !important;\n  border-color: #ab8ce4 !important;\n}\n\n.btn-primary:disabled {\n  background-color: #ab8ce4 !important;\n  border-color: #ab8ce4 !important;\n}\n\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active {\n  background-color: #8d63da !important;\n  border-color: #8d63da !important;\n}\n\n.btn-primary:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem white;\n  box-shadow: 0 0 0 0.2rem white;\n}\n\n.btn-secondary {\n  background-color: #26c6da !important;\n  border-color: #26c6da !important;\n}\n\n.btn-secondary.disabled {\n  background-color: #26c6da !important;\n  border-color: #26c6da !important;\n}\n\n.btn-secondary:disabled {\n  background-color: #26c6da !important;\n  border-color: #26c6da !important;\n}\n\n.btn-secondary:hover,\n.btn-secondary:focus,\n.btn-secondary:active,\n.btn-secondary.active {\n  background-color: #1e9faf !important;\n  border-color: #1e9faf !important;\n}\n\n.btn-secondary:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem #a9e8f0;\n  box-shadow: 0 0 0 0.2rem #a9e8f0;\n}\n\n.btn-success {\n  background-color: #00c292 !important;\n  border-color: #00c292 !important;\n}\n\n.btn-success.disabled {\n  background-color: #00c292 !important;\n  border-color: #00c292 !important;\n}\n\n.btn-success:disabled {\n  background-color: #00c292 !important;\n  border-color: #00c292 !important;\n}\n\n.btn-success:hover,\n.btn-success:focus,\n.btn-success:active,\n.btn-success.active {\n  background-color: #008f6c !important;\n  border-color: #008f6c !important;\n}\n\n.btn-success:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem #5cffd7;\n  box-shadow: 0 0 0 0.2rem #5cffd7;\n}\n\n.btn-danger {\n  background-color: #FF5370 !important;\n  border-color: #FF5370 !important;\n}\n\n.btn-danger.disabled {\n  background-color: #FF5370 !important;\n  border-color: #FF5370 !important;\n}\n\n.btn-danger:disabled {\n  background-color: #FF5370 !important;\n  border-color: #FF5370 !important;\n}\n\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active {\n  background-color: #ff2046 !important;\n  border-color: #ff2046 !important;\n}\n\n.btn-danger:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem #ffecef;\n  box-shadow: 0 0 0 0.2rem #ffecef;\n}\n\n.btn-info {\n  background-color: #4099ff !important;\n  border-color: #4099ff !important;\n}\n\n.btn-info.disabled {\n  background-color: #4099ff !important;\n  border-color: #4099ff !important;\n}\n\n.btn-info:disabled {\n  background-color: #4099ff !important;\n  border-color: #4099ff !important;\n}\n\n.btn-info:hover,\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active {\n  background-color: #0d7eff !important;\n  border-color: #0d7eff !important;\n}\n\n.btn-info:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem #d9ebff;\n  box-shadow: 0 0 0 0.2rem #d9ebff;\n}\n\n.btn-light {\n  background-color: #eeeeee !important;\n  border-color: #eeeeee !important;\n}\n\n.btn-light.disabled {\n  background-color: #eeeeee !important;\n  border-color: #eeeeee !important;\n}\n\n.btn-light:disabled {\n  background-color: #eeeeee !important;\n  border-color: #eeeeee !important;\n}\n\n.btn-light:hover,\n.btn-light:focus,\n.btn-light:active,\n.btn-light.active {\n  background-color: #d5d5d5 !important;\n  border-color: #d5d5d5 !important;\n}\n\n.btn-light:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem white;\n  box-shadow: 0 0 0 0.2rem white;\n}\n\n.btn-dark {\n  background-color: #2a3142 !important;\n  border-color: #2a3142 !important;\n}\n\n.btn-dark.disabled {\n  background-color: #2a3142 !important;\n  border-color: #2a3142 !important;\n}\n\n.btn-dark:disabled {\n  background-color: #2a3142 !important;\n  border-color: #2a3142 !important;\n}\n\n.btn-dark:hover,\n.btn-dark:focus,\n.btn-dark:active,\n.btn-dark.active {\n  background-color: #161a23 !important;\n  border-color: #161a23 !important;\n}\n\n.btn-dark:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem #67779e;\n  box-shadow: 0 0 0 0.2rem #67779e;\n}\n\n.btn-warning {\n  background-color: #f3d800 !important;\n  border-color: #f3d800 !important;\n}\n\n.btn-warning.disabled {\n  background-color: #f3d800 !important;\n  border-color: #f3d800 !important;\n}\n\n.btn-warning:disabled {\n  background-color: #f3d800 !important;\n  border-color: #f3d800 !important;\n}\n\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning:active,\n.btn-warning.active {\n  background-color: #c0ab00 !important;\n  border-color: #c0ab00 !important;\n}\n\n.btn-warning:focus {\n  -webkit-box-shadow: 0 0 0 0.2rem #fff28d;\n  box-shadow: 0 0 0 0.2rem #fff28d;\n}\n\n/*======= Button-color css ends  ======= */\n.btn-outline-primary-2x {\n  border-width: 2px;\n  border-color: #ab8ce4;\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\n.btn-outline-primary-2x:hover,\n.btn-outline-primary-2x:focus,\n.btn-outline-primary-2x:active,\n.btn-outline-primary-2x.active {\n  color: white;\n  background-color: #8d63da !important;\n  border-color: #8d63da !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-secondary-2x {\n  border-width: 2px;\n  border-color: #26c6da;\n  color: #26c6da;\n  background-color: transparent;\n}\n\n.btn-outline-secondary-2x:hover,\n.btn-outline-secondary-2x:focus,\n.btn-outline-secondary-2x:active,\n.btn-outline-secondary-2x.active {\n  color: white;\n  background-color: #1e9faf !important;\n  border-color: #1e9faf !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-success-2x {\n  border-width: 2px;\n  border-color: #00c292;\n  color: #00c292;\n  background-color: transparent;\n}\n\n.btn-outline-success-2x:hover,\n.btn-outline-success-2x:focus,\n.btn-outline-success-2x:active,\n.btn-outline-success-2x.active {\n  color: white;\n  background-color: #008f6c !important;\n  border-color: #008f6c !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-danger-2x {\n  border-width: 2px;\n  border-color: #FF5370;\n  color: #FF5370;\n  background-color: transparent;\n}\n\n.btn-outline-danger-2x:hover,\n.btn-outline-danger-2x:focus,\n.btn-outline-danger-2x:active,\n.btn-outline-danger-2x.active {\n  color: white;\n  background-color: #ff2046 !important;\n  border-color: #ff2046 !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-info-2x {\n  border-width: 2px;\n  border-color: #4099ff;\n  color: #4099ff;\n  background-color: transparent;\n}\n\n.btn-outline-info-2x:hover,\n.btn-outline-info-2x:focus,\n.btn-outline-info-2x:active,\n.btn-outline-info-2x.active {\n  color: white;\n  background-color: #0d7eff !important;\n  border-color: #0d7eff !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-light-2x {\n  border-width: 2px;\n  border-color: #eeeeee;\n  color: #eeeeee;\n  background-color: transparent;\n}\n\n.btn-outline-light-2x:hover,\n.btn-outline-light-2x:focus,\n.btn-outline-light-2x:active,\n.btn-outline-light-2x.active {\n  color: white;\n  background-color: #d5d5d5 !important;\n  border-color: #d5d5d5 !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-dark-2x {\n  border-width: 2px;\n  border-color: #2a3142;\n  color: #2a3142;\n  background-color: transparent;\n}\n\n.btn-outline-dark-2x:hover,\n.btn-outline-dark-2x:focus,\n.btn-outline-dark-2x:active,\n.btn-outline-dark-2x.active {\n  color: white;\n  background-color: #161a23 !important;\n  border-color: #161a23 !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-warning-2x {\n  border-width: 2px;\n  border-color: #f3d800;\n  color: #f3d800;\n  background-color: transparent;\n}\n\n.btn-outline-warning-2x:hover,\n.btn-outline-warning-2x:focus,\n.btn-outline-warning-2x:active,\n.btn-outline-warning-2x.active {\n  color: white;\n  background-color: #c0ab00 !important;\n  border-color: #c0ab00 !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.btn-outline-primary {\n  border-color: #ab8ce4;\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\n.btn-outline-primary.disabled {\n  color: #ab8ce4;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:active,\n.btn-outline-primary.active {\n  color: white;\n  background-color: #8d63da !important;\n  border-color: #8d63da !important;\n}\n\n.btn-outline-secondary {\n  border-color: #26c6da;\n  color: #26c6da;\n  background-color: transparent;\n}\n\n.btn-outline-secondary.disabled {\n  color: #26c6da;\n}\n\n.btn-outline-secondary:hover,\n.btn-outline-secondary:focus,\n.btn-outline-secondary:active,\n.btn-outline-secondary.active {\n  color: white;\n  background-color: #1e9faf !important;\n  border-color: #1e9faf !important;\n}\n\n.btn-outline-success {\n  border-color: #00c292;\n  color: #00c292;\n  background-color: transparent;\n}\n\n.btn-outline-success.disabled {\n  color: #00c292;\n}\n\n.btn-outline-success:hover,\n.btn-outline-success:focus,\n.btn-outline-success:active,\n.btn-outline-success.active {\n  color: white;\n  background-color: #008f6c !important;\n  border-color: #008f6c !important;\n}\n\n.btn-outline-danger {\n  border-color: #FF5370;\n  color: #FF5370;\n  background-color: transparent;\n}\n\n.btn-outline-danger.disabled {\n  color: #FF5370;\n}\n\n.btn-outline-danger:hover,\n.btn-outline-danger:focus,\n.btn-outline-danger:active,\n.btn-outline-danger.active {\n  color: white;\n  background-color: #ff2046 !important;\n  border-color: #ff2046 !important;\n}\n\n.btn-outline-info {\n  border-color: #4099ff;\n  color: #4099ff;\n  background-color: transparent;\n}\n\n.btn-outline-info.disabled {\n  color: #4099ff;\n}\n\n.btn-outline-info:hover,\n.btn-outline-info:focus,\n.btn-outline-info:active,\n.btn-outline-info.active {\n  color: white;\n  background-color: #0d7eff !important;\n  border-color: #0d7eff !important;\n}\n\n.btn-outline-light {\n  border-color: #eeeeee;\n  color: #eeeeee;\n  background-color: transparent;\n  color: #2a3142;\n}\n\n.btn-outline-light.disabled {\n  color: #eeeeee;\n}\n\n.btn-outline-light:hover,\n.btn-outline-light:focus,\n.btn-outline-light:active,\n.btn-outline-light.active {\n  color: white;\n  background-color: #d5d5d5 !important;\n  border-color: #d5d5d5 !important;\n}\n\n.btn-outline-dark {\n  border-color: #2a3142;\n  color: #2a3142;\n  background-color: transparent;\n}\n\n.btn-outline-dark.disabled {\n  color: #2a3142;\n}\n\n.btn-outline-dark:hover,\n.btn-outline-dark:focus,\n.btn-outline-dark:active,\n.btn-outline-dark.active {\n  color: white;\n  background-color: #161a23 !important;\n  border-color: #161a23 !important;\n}\n\n.btn-outline-warning {\n  border-color: #f3d800;\n  color: #f3d800;\n  background-color: transparent;\n}\n\n.btn-outline-warning.disabled {\n  color: #f3d800;\n}\n\n.btn-outline-warning:hover,\n.btn-outline-warning:focus,\n.btn-outline-warning:active,\n.btn-outline-warning.active {\n  color: white;\n  background-color: #c0ab00 !important;\n  border-color: #c0ab00 !important;\n}\n\n.btn-primary:not([disabled]):not(.disabled).active {\n  background-color: #8d63da;\n  border-color: #8d63da;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-primary:not([disabled]):not(.disabled).active:hover,\n.btn-primary:not([disabled]):not(.disabled).active:focus,\n.btn-primary:not([disabled]):not(.disabled).active:active,\n.btn-primary:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #8d63da;\n  border-color: #8d63da;\n}\n\n.btn-secondary:not([disabled]):not(.disabled).active {\n  background-color: #1e9faf;\n  border-color: #1e9faf;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-secondary:not([disabled]):not(.disabled).active:hover,\n.btn-secondary:not([disabled]):not(.disabled).active:focus,\n.btn-secondary:not([disabled]):not(.disabled).active:active,\n.btn-secondary:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #1e9faf;\n  border-color: #1e9faf;\n}\n\n.btn-success:not([disabled]):not(.disabled).active {\n  background-color: #008f6c;\n  border-color: #008f6c;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-success:not([disabled]):not(.disabled).active:hover,\n.btn-success:not([disabled]):not(.disabled).active:focus,\n.btn-success:not([disabled]):not(.disabled).active:active,\n.btn-success:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #008f6c;\n  border-color: #008f6c;\n}\n\n.btn-danger:not([disabled]):not(.disabled).active {\n  background-color: #ff2046;\n  border-color: #ff2046;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-danger:not([disabled]):not(.disabled).active:hover,\n.btn-danger:not([disabled]):not(.disabled).active:focus,\n.btn-danger:not([disabled]):not(.disabled).active:active,\n.btn-danger:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #ff2046;\n  border-color: #ff2046;\n}\n\n.btn-info:not([disabled]):not(.disabled).active {\n  background-color: #0d7eff;\n  border-color: #0d7eff;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-info:not([disabled]):not(.disabled).active:hover,\n.btn-info:not([disabled]):not(.disabled).active:focus,\n.btn-info:not([disabled]):not(.disabled).active:active,\n.btn-info:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #0d7eff;\n  border-color: #0d7eff;\n}\n\n.btn-light:not([disabled]):not(.disabled).active {\n  background-color: #d5d5d5;\n  border-color: #d5d5d5;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-light:not([disabled]):not(.disabled).active:hover,\n.btn-light:not([disabled]):not(.disabled).active:focus,\n.btn-light:not([disabled]):not(.disabled).active:active,\n.btn-light:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #d5d5d5;\n  border-color: #d5d5d5;\n}\n\n.btn-dark:not([disabled]):not(.disabled).active {\n  background-color: #161a23;\n  border-color: #161a23;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-dark:not([disabled]):not(.disabled).active:hover,\n.btn-dark:not([disabled]):not(.disabled).active:focus,\n.btn-dark:not([disabled]):not(.disabled).active:active,\n.btn-dark:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #161a23;\n  border-color: #161a23;\n}\n\n.btn-warning:not([disabled]):not(.disabled).active {\n  background-color: #c0ab00;\n  border-color: #c0ab00;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.btn-warning:not([disabled]):not(.disabled).active:hover,\n.btn-warning:not([disabled]):not(.disabled).active:focus,\n.btn-warning:not([disabled]):not(.disabled).active:active,\n.btn-warning:not([disabled]):not(.disabled).active.active {\n  color: white;\n  background-color: #c0ab00;\n  border-color: #c0ab00;\n}\n\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-primary-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #8d63da !important;\n  border-color: #8d63da !important;\n}\n\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active {\n  background-color: #26c6da;\n  border-color: #26c6da;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-secondary-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #1e9faf !important;\n  border-color: #1e9faf !important;\n}\n\n.btn-outline-success-2x:not([disabled]):not(.disabled).active {\n  background-color: #00c292;\n  border-color: #00c292;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-success-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-success-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-success-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-success-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #008f6c !important;\n  border-color: #008f6c !important;\n}\n\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active {\n  background-color: #FF5370;\n  border-color: #FF5370;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-danger-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #ff2046 !important;\n  border-color: #ff2046 !important;\n}\n\n.btn-outline-info-2x:not([disabled]):not(.disabled).active {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-info-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-info-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-info-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-info-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #0d7eff !important;\n  border-color: #0d7eff !important;\n}\n\n.btn-outline-light-2x:not([disabled]):not(.disabled).active {\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-light-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-light-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-light-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-light-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #d5d5d5 !important;\n  border-color: #d5d5d5 !important;\n}\n\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active {\n  background-color: #2a3142;\n  border-color: #2a3142;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-dark-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #161a23 !important;\n  border-color: #161a23 !important;\n}\n\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active {\n  background-color: #f3d800;\n  border-color: #f3d800;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: white;\n}\n\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active:hover,\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active:focus,\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active:active,\n.btn-outline-warning-2x:not([disabled]):not(.disabled).active.active {\n  color: white;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  background-color: #c0ab00 !important;\n  border-color: #c0ab00 !important;\n}\n\n/*======= Table-Border-Bottom-color css starts  ======= */\ntable thead .border-bottom-primary th,\ntable tbody .border-bottom-primary th,\ntable tbody .border-bottom-primary td {\n  border-bottom: 1px solid #ab8ce4;\n}\n\ntable thead .border-bottom-secondary th,\ntable tbody .border-bottom-secondary th,\ntable tbody .border-bottom-secondary td {\n  border-bottom: 1px solid #26c6da;\n}\n\ntable thead .border-bottom-success th,\ntable tbody .border-bottom-success th,\ntable tbody .border-bottom-success td {\n  border-bottom: 1px solid #00c292;\n}\n\ntable thead .border-bottom-danger th,\ntable tbody .border-bottom-danger th,\ntable tbody .border-bottom-danger td {\n  border-bottom: 1px solid #FF5370;\n}\n\ntable thead .border-bottom-info th,\ntable tbody .border-bottom-info th,\ntable tbody .border-bottom-info td {\n  border-bottom: 1px solid #4099ff;\n}\n\ntable thead .border-bottom-light th,\ntable tbody .border-bottom-light th,\ntable tbody .border-bottom-light td {\n  border-bottom: 1px solid #eeeeee;\n}\n\ntable thead .border-bottom-dark th,\ntable tbody .border-bottom-dark th,\ntable tbody .border-bottom-dark td {\n  border-bottom: 1px solid #2a3142;\n}\n\ntable thead .border-bottom-warning th,\ntable tbody .border-bottom-warning th,\ntable tbody .border-bottom-warning td {\n  border-bottom: 1px solid #f3d800;\n}\n\n/*======= Table-Border-Bottom-color css ends  ======= */\n/*======= Table styling css starts  ======= */\n.table-styling .table-primary,\n.table-styling.table-primary {\n  background-color: #ab8ce4;\n  color: #fff;\n  border: 3px solid #ab8ce4;\n}\n\n.table-styling .table-primary thead,\n.table-styling.table-primary thead {\n  background-color: #8d63da;\n  border: 3px solid #8d63da;\n}\n\n.table-styling .table-secondary,\n.table-styling.table-secondary {\n  background-color: #26c6da;\n  color: #fff;\n  border: 3px solid #26c6da;\n}\n\n.table-styling .table-secondary thead,\n.table-styling.table-secondary thead {\n  background-color: #1e9faf;\n  border: 3px solid #1e9faf;\n}\n\n.table-styling .table-success,\n.table-styling.table-success {\n  background-color: #00c292;\n  color: #fff;\n  border: 3px solid #00c292;\n}\n\n.table-styling .table-success thead,\n.table-styling.table-success thead {\n  background-color: #008f6c;\n  border: 3px solid #008f6c;\n}\n\n.table-styling .table-danger,\n.table-styling.table-danger {\n  background-color: #FF5370;\n  color: #fff;\n  border: 3px solid #FF5370;\n}\n\n.table-styling .table-danger thead,\n.table-styling.table-danger thead {\n  background-color: #ff2046;\n  border: 3px solid #ff2046;\n}\n\n.table-styling .table-info,\n.table-styling.table-info {\n  background-color: #4099ff;\n  color: #fff;\n  border: 3px solid #4099ff;\n}\n\n.table-styling .table-info thead,\n.table-styling.table-info thead {\n  background-color: #0d7eff;\n  border: 3px solid #0d7eff;\n}\n\n.table-styling .table-light,\n.table-styling.table-light {\n  background-color: #eeeeee;\n  color: #fff;\n  border: 3px solid #eeeeee;\n}\n\n.table-styling .table-light thead,\n.table-styling.table-light thead {\n  background-color: #d5d5d5;\n  border: 3px solid #d5d5d5;\n}\n\n.table-styling .table-dark,\n.table-styling.table-dark {\n  background-color: #2a3142;\n  color: #fff;\n  border: 3px solid #2a3142;\n}\n\n.table-styling .table-dark thead,\n.table-styling.table-dark thead {\n  background-color: #161a23;\n  border: 3px solid #161a23;\n}\n\n.table-styling .table-warning,\n.table-styling.table-warning {\n  background-color: #f3d800;\n  color: #fff;\n  border: 3px solid #f3d800;\n}\n\n.table-styling .table-warning thead,\n.table-styling.table-warning thead {\n  background-color: #c0ab00;\n  border: 3px solid #c0ab00;\n}\n\n/*======= Table styling css ends  ======= */\n/*======= All-Borders-color css starts  ======= */\n.b-primary {\n  border: 1px solid #ab8ce4 !important;\n}\n\n.b-t-primary {\n  border-top: 1px solid #ab8ce4 !important;\n}\n\n.b-b-primary {\n  border-bottom: 1px solid #ab8ce4 !important;\n}\n\n.b-l-primary {\n  border-left: 1px solid #ab8ce4 !important;\n}\n\n.b-r-primary {\n  border-right: 1px solid #ab8ce4 !important;\n}\n\n.b-secondary {\n  border: 1px solid #26c6da !important;\n}\n\n.b-t-secondary {\n  border-top: 1px solid #26c6da !important;\n}\n\n.b-b-secondary {\n  border-bottom: 1px solid #26c6da !important;\n}\n\n.b-l-secondary {\n  border-left: 1px solid #26c6da !important;\n}\n\n.b-r-secondary {\n  border-right: 1px solid #26c6da !important;\n}\n\n.b-success {\n  border: 1px solid #00c292 !important;\n}\n\n.b-t-success {\n  border-top: 1px solid #00c292 !important;\n}\n\n.b-b-success {\n  border-bottom: 1px solid #00c292 !important;\n}\n\n.b-l-success {\n  border-left: 1px solid #00c292 !important;\n}\n\n.b-r-success {\n  border-right: 1px solid #00c292 !important;\n}\n\n.b-danger {\n  border: 1px solid #FF5370 !important;\n}\n\n.b-t-danger {\n  border-top: 1px solid #FF5370 !important;\n}\n\n.b-b-danger {\n  border-bottom: 1px solid #FF5370 !important;\n}\n\n.b-l-danger {\n  border-left: 1px solid #FF5370 !important;\n}\n\n.b-r-danger {\n  border-right: 1px solid #FF5370 !important;\n}\n\n.b-info {\n  border: 1px solid #4099ff !important;\n}\n\n.b-t-info {\n  border-top: 1px solid #4099ff !important;\n}\n\n.b-b-info {\n  border-bottom: 1px solid #4099ff !important;\n}\n\n.b-l-info {\n  border-left: 1px solid #4099ff !important;\n}\n\n.b-r-info {\n  border-right: 1px solid #4099ff !important;\n}\n\n.b-light {\n  border: 1px solid #eeeeee !important;\n}\n\n.b-t-light {\n  border-top: 1px solid #eeeeee !important;\n}\n\n.b-b-light {\n  border-bottom: 1px solid #eeeeee !important;\n}\n\n.b-l-light {\n  border-left: 1px solid #eeeeee !important;\n}\n\n.b-r-light {\n  border-right: 1px solid #eeeeee !important;\n}\n\n.b-dark {\n  border: 1px solid #2a3142 !important;\n}\n\n.b-t-dark {\n  border-top: 1px solid #2a3142 !important;\n}\n\n.b-b-dark {\n  border-bottom: 1px solid #2a3142 !important;\n}\n\n.b-l-dark {\n  border-left: 1px solid #2a3142 !important;\n}\n\n.b-r-dark {\n  border-right: 1px solid #2a3142 !important;\n}\n\n.b-warning {\n  border: 1px solid #f3d800 !important;\n}\n\n.b-t-warning {\n  border-top: 1px solid #f3d800 !important;\n}\n\n.b-b-warning {\n  border-bottom: 1px solid #f3d800 !important;\n}\n\n.b-l-warning {\n  border-left: 1px solid #f3d800 !important;\n}\n\n.b-r-warning {\n  border-right: 1px solid #f3d800 !important;\n}\n\n/*======= All-Borders-color css ends  ======= */\n/*====== Border width css starts ======*/\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-6 {\n  border-width: 6px !important;\n}\n\n.border-7 {\n  border-width: 7px !important;\n}\n\n.border-8 {\n  border-width: 8px !important;\n}\n\n.border-9 {\n  border-width: 9px !important;\n}\n\n.border-10 {\n  border-width: 10px !important;\n}\n\n/*====== Border width css ends ======*/\n.card {\n  -webkit-box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.1);\n  margin-bottom: 15px;\n  border: 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.card:hover {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  -webkit-box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.12);\n}\n\n.card .card-header {\n  background-color: #fff;\n  border-bottom: 1px solid #eeeeee;\n  padding: 30px;\n}\n\n.card .card-header h5 {\n  font-size: 18px;\n  margin-bottom: 0;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.card .card-header>span {\n  font-size: 12px;\n  margin-top: 5px;\n  display: block;\n  letter-spacing: 1px;\n  color: #777777;\n}\n\n.card .card-body2 {\n  padding:55px 0px;\n}\n.card .card-body {\n  padding:30px;\n}\n.card .card-body1 {\n  padding: 27px;\n}\n\n.card .card-body p:last-child {\n  margin-bottom: 0;\n}\n\n.card .sub-title {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding-bottom: 5px;\n  margin-bottom: 8px;\n  font-size: 18px;\n}\n\n.card .card-footer {\n  background-color: #fff;\n  border-top: 1px solid #eeeeee;\n  padding: 30px;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.shadow-0 {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.map-block {\n  height: 350px;\n  width: 100%;\n}\n\n/**====== custom scrollbar css start ======**/\n.digits {\n  font-family: Open Sans;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px #cccccc;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #cccccc;\n}\n\n/**====== Custom scrollbar css end ======**/\n/**====== Animation css Start ======**/\n.comment {\n  color: #9f9ba5;\n  font-style: italic;\n}\n\n.line {\n  color: #2a3142;\n}\n\n.line pre {\n  font-size: 100%;\n}\n\n/**====== Animation css end ======**/\n/**====== list style css Start ======**/\n.list-circle {\n  list-style: circle;\n}\n\n/**====== list style css end ======**/\n/**====== Modal style css Start ======**/\n.theme-close {\n  opacity: 1;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  z-index: 1;\n  right: 0;\n  background-color: #fff !important;\n  border-radius: 5px;\n}\n\n/**====== Modal style css end ======**/\n/**====== Animation css start ======**/\n.options>div {\n  color: #999999;\n  display: inline-block;\n  padding: 2px 10px;\n  border: 1px solid;\n  margin: 0 8px 8px 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.options>div:hover {\n  background-color: #999999;\n  color: #fff;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n/**====== Animation css Ends ======**/\n.modal-footer {\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.img-cropper #putData {\n  margin-bottom: 0;\n}\n\n.img-cropper .img-container {\n  min-height: auto;\n  margin-bottom: 0;\n}\n\n.img-cropper .docs-data>.input-group:last-child {\n  margin-bottom: 0;\n}\n\n.img-cropper .docs-preview {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.bootstrap-datetimepicker-widget {\n  font-family: Open Sans;\n}\n\n.dropzone .dz-preview .dz-error-message {\n  background: #fff !important;\n  color: #ab8ce4 !important;\n  border: 1px solid #ab8ce4;\n}\n\n.dropzone .dz-preview .dz-error-message:after {\n  border-bottom: 6px solid #ab8ce4 !important;\n}\n\n.typeahead .theme-form .form-group {\n  margin-bottom: 0;\n}\n\n.editor-statusbar {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.page-builder .ge-canvas.ge-editing .row {\n  padding: 30px;\n  margin-bottom: 0;\n}\n\n.page-builder .ge-canvas.ge-layout-desktop [class*=\"col-\"] {\n  width: inherit !important;\n}\n\n.page-builder .btn-screen {\n  padding: 0 18px 0 0;\n}\n\n.datepicker {\n  z-index: 99;\n}\n\n/**=====================\n     02. Generic CSS Ends\n==========================**/\n/**=====================\n    03.  Card CSS Start\n==========================**/\n.card .card-header .card-header-right {\n  border-radius: 0 0 0 7px;\n  right: 20px;\n  top: 23px;\n  display: inline-block;\n  float: right;\n  padding: 7px 0;\n  position: absolute;\n}\n\n.card .card-header .card-header-right .card-option {\n  text-align: right;\n  width: 35px;\n  height: 20px;\n  overflow: hidden;\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n\n.card .card-header .card-header-right .card-option li {\n  display: inline-block;\n}\n\n.card .card-header .card-header-right i {\n  margin: 0 5px;\n  cursor: pointer;\n  color: #2a3142;\n  line-height: 20px;\n}\n\n.card .card-header .card-header-right i.icofont-refresh {\n  font-size: 13px;\n}\n\n.card.card-load .card-loader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 999;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.card.card-load .card-loader i {\n  margin: 0 auto;\n  color: #ab8ce4;\n  font-size: 20px;\n}\n\n.card.full-card {\n  position: fixed;\n  top: 80px;\n  z-index: 99999;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  right: 0;\n  border-radius: 0;\n  border: 1px solid #ddd;\n  width: calc(100vw - 270px);\n  height: calc(100vh - 80px);\n}\n\n.card-absolute {\n  margin-top: 20px;\n}\n\n.card-absolute .card-header {\n  position: absolute;\n  top: -20px;\n  margin-bottom: 30px;\n  left: 15px;\n  border-radius: 0.25rem;\n  padding: 10px 15px;\n}\n\n.card-absolute .card-header h5 {\n  font-size: 17px;\n}\n\n.card-absolute .card-body {\n  margin-top: 10px;\n}\n\n.card-header .nav-material {\n  margin-bottom: -13px;\n}\n\n.custom-card {\n  overflow: hidden;\n  padding: 30px;\n}\n\n.custom-card .card-header {\n  padding: 0;\n}\n\n.custom-card .card-header img {\n  border-radius: 50%;\n  margin-top: -100px;\n  -webkit-transform: scale(1.5);\n  transform: scale(1.5);\n}\n\n.custom-card .card-profile {\n  text-align: center;\n}\n\n.custom-card .card-profile img {\n  height: 150px;\n  padding: 7px;\n  background-color: #fff;\n  z-index: 1;\n  position: relative;\n}\n\n.custom-card .card-social {\n  text-align: center;\n}\n\n.custom-card .card-social li {\n  display: inline-block;\n  padding: 15px 0;\n}\n\n.custom-card .card-social li a {\n  padding: 13px;\n  color: #ddd;\n  font-size: 16px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.custom-card .card-social li a:hover {\n  color: #ab8ce4;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.custom-card .profile-details h6 {\n  margin-bottom: 30px;\n  margin-top: 10px;\n  color: #777777;\n  font-size: 14px;\n}\n\n.custom-card .card-footer {\n  padding: 0;\n}\n\n.custom-card .card-footer>div {\n  padding: 15px;\n  text-align: center;\n}\n\n.custom-card .card-footer>div+div {\n  border-left: 1px solid #ddd;\n}\n\n.custom-card .card-footer>div h3 {\n  margin-bottom: 0;\n  font-family: Open Sans;\n  font-size: 24px;\n}\n\n.custom-card .card-footer>div h6 {\n  font-size: 14px;\n  color: #777777;\n}\n\n.custom-card .card-footer>div i {\n  font-size: 24px;\n  display: inline-block;\n  margin-bottom: 15px;\n}\n\n.custom-card .card-footer>div .m-b-card {\n  margin-bottom: 10px;\n}\n\n/**=====================\n    03. Card CSS End\n==========================**/\n/**=====================\n     04. Loader CSS Start\n==========================**/\n.loader-wrapper {\n  height: 100%;\n  width: 100%;\n  display: block;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  position: fixed;\n  background-color: #fff;\n  z-index: 11;\n  top: 0;\n}\n\n.loader-wrapper .loader {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  text-align: center;\n  right: 0;\n  margin: 0 auto;\n}\n\n.loader-wrapper .loader h4 {\n  margin-top: 50px;\n  margin-bottom: 0;\n}\n\n.loader-wrapper .loader h4 span {\n  font-size: 34px;\n  color: #FFC107;\n}\n\n.loader .line {\n  -webkit-animation: expand 1s ease-in-out infinite;\n  animation: expand 1s ease-in-out infinite;\n  border-radius: 10px;\n  display: inline-block;\n  -webkit-transform-origin: center center;\n  transform-origin: center center;\n  margin: 0 3px;\n  width: 1px;\n  height: 25px;\n}\n\n.loader .line:nth-child(1) {\n  background: #00c292;\n}\n\n.loader .line:nth-child(2) {\n  -webkit-animation-delay: 180ms;\n  animation-delay: 180ms;\n  background: #ab8ce4;\n}\n\n.loader .line:nth-child(3) {\n  -webkit-animation-delay: 360ms;\n  animation-delay: 360ms;\n  background: #FF5370;\n}\n\n.loader .line:nth-child(4) {\n  -webkit-animation-delay: 540ms;\n  animation-delay: 540ms;\n  background: #4099ff;\n}\n\n@-webkit-keyframes expand {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  25% {\n    -webkit-transform: scale(2);\n    transform: scale(2);\n  }\n}\n\n@keyframes expand {\n  0% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n\n  25% {\n    -webkit-transform: scale(2);\n    transform: scale(2);\n  }\n}\n\n.loader-box {\n  height: 150px;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.rotate {\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-duration: 3s;\n  animation-duration: 3s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-name: rotate;\n  animation-name: rotate;\n  border: 3px dotted #ab8ce4;\n  width: 50px;\n  height: 50px;\n  border-radius: 50px;\n  display: block;\n  margin: 1em;\n  float: left;\n}\n\n@-webkit-keyframes rotate {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.solid {\n  border-style: solid;\n  border-color: #00c292 #008f6c;\n}\n\n.dotted {\n  border-style: dotted;\n}\n\n.dashed {\n  border-style: dashed;\n}\n\n.double {\n  border-style: double;\n}\n\n.groove {\n  border-style: groove;\n}\n\n.ridge {\n  border-style: ridge;\n}\n\n.inset {\n  border-style: inset;\n}\n\n.outset {\n  border-style: outset;\n}\n\n.colored {\n  border-color: #FF5370 #ab8ce4 #00c292 #4099ff;\n}\n\n/**=====================\n     04. Loader CSS Ends\n==========================**/\n/**=====================\n    05. Header CSS Start\n==========================**/\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a,\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li.active>a,\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {\n  /* color: #000; */\n  color: #ab8ce4;;\n  border-left-color: #2a3142;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.onhover-show-div {\n  -webkit-box-shadow: 0 0 2px 2px #eeeeee;\n  box-shadow: 0 0 2px 2px #eeeeee;\n  -webkit-transform: translateY(30px);\n  transform: translateY(30px);\n  opacity: 0;\n  visibility: hidden;\n  left: 0;\n}\n\n.onhover-dropdown:hover .onhover-show-div {\n  opacity: 1;\n  -webkit-transform: translateY(0px);\n  transform: translateY(0px);\n  visibility: visible;\n}\n\n.onhover-dropdown:hover .onhover-show-div:before {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #fff;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  left: 10px;\n  z-index: 2;\n}\n\n.onhover-dropdown:hover .onhover-show-div:after {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid #717171;\n  content: \"\";\n  top: -7px;\n  position: absolute;\n  left: 10px;\n  z-index: 1;\n}\n\n/**======Main Header css Start ======**/\n.page-main-header {\n  max-width: 100vw;\n}\n\n.page-main-header .main-header-left {\n  width: 280px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 100%;\n  padding: 12px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #fff;\n  z-index: -9;\n}\n\n.page-main-header .main-header-left .logo-wrapper {\n  display: block;\n  position: relative;\n}\n\n.page-main-header .main-header-left .logo-wrapper img {\n  height: 65px;\n  margin-top: 10px;\n}\n\n.page-main-header .main-header-left .logo-wrapper a .image-dark {\n  display: block;\n}\n\n.page-main-header .main-header-left .logo-wrapper a .image-light {\n  display: none;\n}\n\n.page-main-header .main-header-left .mobile-sidebar {\n  display: inline-block;\n}\n\n.page-main-header .main-header-left .mobile-sidebar i {\n  color: #ab8ce4;\n  font-size: 20px;\n  margin-left: 30px;\n}\n\n.page-main-header .main-header-left .mobile-sidebar .switch {\n  margin-bottom: 0;\n  width: 30px;\n  height: 17px;\n  margin-left: 40px;\n  margin-top: 10px;\n}\n\n.page-main-header .main-header-left .mobile-sidebar .switch .switch-state:before {\n  height: 11px;\n  width: 11px;\n  background-color: #ffffff;\n}\n\n.page-main-header .main-header-left .mobile-sidebar input:checked+.switch-state:before {\n  left: -10px;\n}\n\n.page-main-header .main-header-right {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.page-main-header .main-header-right .switch-state {\n  background-color: transparent;\n  border: 1px solid #ab8ce4;\n}\n\n.page-main-header .main-header-right .switch-sm .switch .switch-state:before {\n  bottom: 3px;\n  background-color: #ab8ce4;\n}\n\n.page-main-header .main-header-right .switch input:checked+.switch-state:before {\n  background-color: #fff;\n}\n\n.page-main-header .main-header-right .nav-left i {\n  margin-right: 20px;\n}\n\n.page-main-header .main-header-right .nav-left input:focus {\n  outline: 0 !important;\n}\n\n.page-main-header .main-header-right .nav-right {\n  text-align: right;\n}\n\n.page-main-header .main-header-right .nav-right ul li i {\n  font-size: 20px;\n}\n\n.page-main-header .main-header-right .nav-right .notification {\n  position: absolute;\n  top: 21px;\n  right: -1px;\n  font-size: 9px;\n  -webkit-animation: blink 1.5s infinite;\n  animation: blink 1.5s infinite;\n}\n\n@-webkit-keyframes blink {\n  0% {\n    opacity: 1;\n  }\n\n  70% {\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n\n  70% {\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.page-main-header .main-header-right .nav-right .icon-user {\n  font-size: 16px;\n}\n\n@-webkit-keyframes heartbit {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n    opacity: 0;\n  }\n\n  25% {\n    -webkit-transform: scale(0.1);\n    transform: scale(0.1);\n    opacity: 0.1;\n  }\n\n  50% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    opacity: 0.3;\n  }\n\n  75% {\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n@keyframes heartbit {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n    opacity: 0;\n  }\n\n  25% {\n    -webkit-transform: scale(0.1);\n    transform: scale(0.1);\n    opacity: 0.1;\n  }\n\n  50% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    opacity: 0.3;\n  }\n\n  75% {\n    -webkit-transform: scale(0.8);\n    transform: scale(0.8);\n    opacity: 0.5;\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n\n.page-main-header .main-header-right .nav-right>ul {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.page-main-header .main-header-right .nav-right>ul>li {\n  margin-left: 20px;\n  position: relative;\n  /* padding: 30px 0; */\n}\n\n.page-main-header .main-header-right .nav-right>ul>li h6 {\n  color: #ab8ce4;\n}\n\n.page-main-header .main-header-right .nav-right>ul>li h6 ul {\n  left: inherit;\n  right: -10px;\n  width: 130px;\n}\n\n.page-main-header .main-header-right .nav-right>ul>li h6 ul:before,\n.page-main-header .main-header-right .nav-right>ul>li h6 ul:after {\n  left: inherit;\n  right: 10px;\n}\n\n.page-main-header .main-header-right .nav-right>ul>li h6 ul li {\n  display: block;\n}\n\n.page-main-header .main-header-right .nav-right>ul>li h6 ul li a {\n  font-size: 14px;\n  color: #2a3142;\n}\n\n.page-main-header .main-header-right .nav-right>ul>li h6 ul li a i {\n  margin-left: 10px;\n  font-size: 13px;\n  color: #2a3142;\n}\n\n.page-main-header .main-header-right .nav-right>ul .flag-icon {\n  font-size: 16px;\n}\n\n.page-main-header .main-header-right .nav-right .language-dropdown {\n  width: 160px;\n  text-align: left;\n}\n\n.page-main-header .main-header-right .nav-right .language-dropdown li {\n  padding-top: 10px;\n}\n\n.page-main-header .main-header-right .nav-right .language-dropdown li a {\n  color: #2a3142;\n}\n\n.page-main-header .main-header-right .nav-right .language-dropdown li a i {\n  margin-right: 10px;\n}\n\n.page-main-header .main-header-right .nav-right .language-dropdown li:first-child {\n  padding-top: 0;\n}\n\n.page-main-header .main-header-right .nav-right .profile-dropdown {\n  right: -10px;\n  left: inherit;\n  /* width: 150px; */\n  text-wrap: nowrap;\n}\n\n.page-main-header .main-header-right .nav-right .profile-dropdown:before,\n.page-main-header .main-header-right .nav-right .profile-dropdown:after {\n  left: inherit;\n  right: 10px;\n}\n\n.page-main-header .main-header-right .nav-right .profile-dropdown li {\n  display: block;\n  text-align: left;\n  padding-top: 10px;\n}\n\n.page-main-header .main-header-right .nav-right .profile-dropdown li:first-child {\n  padding-top: 0;\n}\n\n.page-main-header .main-header-right .nav-right .profile-dropdown li:hover a {\n  color: #ab8ce4;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-main-header .main-header-right .nav-right .profile-dropdown li a {\n  color: #2a3142;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-main-header .main-header-right .nav-right .profile-dropdown li i {\n  font-size: 16px;\n  margin-right: 10px;\n}\n\n.page-main-header .main-header-right li {\n  display: inline-block;\n  position: relative;\n}\n\n.onhover-dropdown {\n  cursor: pointer;\n  position: relative;\n}\n\nul.notification-dropdown.onhover-show-div {\n  width: 330px;\n  right: -30px;\n  left: initial;\n}\n\nul.notification-dropdown.onhover-show-div:before,\nul.notification-dropdown.onhover-show-div:after {\n  left: inherit !important;\n  right: 35px !important;\n}\n\nul.notification-dropdown.onhover-show-div li {\n  display: block;\n  padding: 12px 20px;\n  border-bottom: 1px solid #eeeeee;\n  text-align: left;\n}\n\nul.notification-dropdown.onhover-show-div li span {\n  font-size: 12px;\n  color: #2a3142;\n  font-family: Open Sans;\n}\n\nul.notification-dropdown.onhover-show-div li span i {\n  font-size: 11px !important;\n  color: #2a3142;\n}\n\nul.notification-dropdown.onhover-show-div li .notification-icon {\n  padding: 15px;\n  border-radius: 100%;\n  margin-right: 20px;\n}\n\n.onhover-show-div {\n  top: 80px;\n  position: absolute;\n  z-index: 9;\n  background-color: #fff;\n  -webkit-transition: all linear 0.3s;\n  transition: all linear 0.3s;\n}\n\n/**======Main Header css Ends ======**/\n/*======= Page Header css Start ======= */\n.page-wrapper .page-main-header {\n  background-color: #ffffff;\n  height: 80px;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 10;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-shadow: 0 0 1px 1px #eeeeee;\n  box-shadow: 0 0 1px 1px #eeeeee;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar-open {\n  left: -150px;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar~.page-body {\n  margin-left: 150px;\n  width: 100%;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar {\n  width: 255px;\n  position: fixed;\n  background: #ffffff;\n  top: 80px;\n  -webkit-box-shadow: 0 0 11px rgba(0, 0, 0, 0.13);\n  box-shadow: 0 0 11px rgba(0, 0, 0, 0.13);\n  height: calc(100vh - 80px);\n  overflow: auto;\n  z-index: 9;\n  -webkit-transform: translate(0px);\n  transform: translate(0px);\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {\n  background-color: #f6f7fb;\n  padding: 25px 10px;\n  -webkit-box-shadow: 3px 2px 8px -1px rgba(0, 0, 0, 0.13);\n  box-shadow: 3px 2px 8px -1px rgba(0, 0, 0, 0.13);\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user img {\n  border: 3px solid #fff;\n  -webkit-box-shadow: 0px 5px 22px 0px rgba(0, 0, 0, 0.2);\n  box-shadow: 0px 5px 22px 0px rgba(0, 0, 0, 0.2);\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {\n  color: #2a3142;\n  position: relative;\n  text-transform: uppercase;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 i {\n  margin-right: 10px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {\n  color: #fff;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown {\n  top: 44px;\n  right: 8px;\n  left: inherit;\n  width: 130px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown:before,\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown:after {\n  left: inherit;\n  right: 10px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown li {\n  display: block;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown li a {\n  padding-bottom: 10px;\n  display: block;\n  color: #2a3142;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user .profile-dropdown li:last-child a {\n  padding-bottom: 0;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar~.page-body {\n  /* margin-left: 250px; */\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {\n  list-style: none;\n  margin: 0;\n  padding: 20px;\n  list-style-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=);\n  list-style-type: none;\n  white-space: nowrap;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #ab8ce4;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eeeeee;\n  margin-bottom: 5px;\n  letter-spacing: 1px;\n  font-size: 14px;\n  margin-top: 25px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {\n  font-size: 13px;\n  letter-spacing: 1px;\n  padding-bottom: 7px;\n  padding-top: 7px;\n  /* text-transform: uppercase; */\n  font-weight: 500;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {\n  display: block;\n  color: #2a3142;\n  font-size: 14px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {\n  color: #ab8ce4;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {\n  color: #ab8ce4;\n  padding-left: 5px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i {\n  margin-right: 7px;\n  text-align: right;\n  margin-top: 3px;\n  font-size: 15px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i.pull-right {\n  position: absolute;\n  right: 20px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i~i {\n  margin-right: 0;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {\n  margin-top: 3px;\n  margin-right: 5px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .badge {\n  margin-top: 3px;\n  margin-right: 5px;\n  text-transform: capitalize;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {\n  margin-bottom: 0;\n  padding: 15px;\n  color: #ab8ce4;\n  font-weight: 600;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>a>.fa-angle-right {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  vertical-align: -7px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>.sidebar-submenu {\n  position: relative;\n  display: block;\n  -webkit-transform: rotateX(0deg);\n  transform: rotateX(0deg);\n  -webkit-transform-origin: 10% 10%;\n  transform-origin: 10% 10%;\n  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;\n  transition: opacity 0.3s, -webkit-transform 0.3s;\n  transition: transform 0.3s, opacity 0.3s;\n  transition: transform 0.3s, opacity 0.3s, -webkit-transform 0.3s;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  margin-left: 5px;\n  list-style: none;\n  list-style-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=);\n  list-style-type: none;\n  white-space: nowrap;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>.sidebar-submenu>li {\n  width: 100%;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>.sidebar-submenu>li>a {\n  width: 100%;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li>a>.fa-angle-down {\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin-right: 10px;\n  margin-top: 3px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {\n  color: #2a3142;\n  text-decoration: none;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu {\n  display: none;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  -webkit-transform: rotateX(-90deg);\n  transform: rotateX(-90deg);\n  list-style-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=);\n  list-style-type: none;\n  white-space: nowrap;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu .sidebar-submenu {\n  padding-left: 20px;\n  padding-top: 0 !important;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {\n  padding-bottom: 7px;\n  padding-top: 7px;\n  display: block;\n  font-size: 14px;\n  color: #333333;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  text-transform: capitalize;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>.fa {\n  width: 20px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>i {\n  width: auto;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>.fa-angle-down {\n  width: auto;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {\n  color: #ab8ce4;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  padding-left: 5px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {\n  color: #ab8ce4 !important;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li.active>a {\n  color: #2a3142;\n}\n\n.page-wrapper .page-body-wrapper .page-body {\n  min-height: calc(100vh - 80px);\n  margin-top: 80px;\n  padding: 0 20px;\n  position: relative;\n  background-color: #f6f7fb;\n}\n\n.page-wrapper .page-body-wrapper .page-header {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n\n.page-wrapper .page-body-wrapper .page-header .row {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.page-wrapper .page-body-wrapper .page-header .row h3 {\n  font-size: 24px;\n  margin-bottom: 0;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.page-wrapper .page-body-wrapper .page-header .row h3 small {\n  display: block;\n  font-size: 12px;\n  margin-top: 7px;\n  letter-spacing: 1px;\n  text-transform: capitalize;\n  color: #777777;\n}\n\n.page-wrapper .page-body-wrapper .page-header .breadcrumb {\n  background-color: transparent;\n  padding: 0;\n  margin-bottom: 0;\n}\n\n.page-wrapper .sidebar-close .page-sidebar {\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  -webkit-transform: translate(-255px);\n  transform: translate(-255px);\n}\n\n.page-wrapper .sidebar-close .page-body {\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  margin-left: 0 !important;\n}\n\n/*======= Page Header css ends  ======= */\nul .submenu {\n  width: 0;\n  overflow: hidden;\n  list-style-type: none;\n  background: #fff;\n  -webkit-transition: width 0.5s ease-out;\n  transition: width 0.5s ease-out;\n  position: absolute;\n  top: -8px;\n  right: -12px;\n}\n\nul .submenu input {\n  padding: 6px 12px;\n  width: 200px;\n}\n\n.scorlled .page-sidebar {\n  top: 0 !important;\n  height: 100vh !important;\n}\n\n/** ===== Vertical Menu css Start=====**/\n.page-wrapper .vertical-menu-main {\n  position: fixed;\n  top: 80px;\n  width: 100%;\n  z-index: 9;\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n}\n\n.vertical-menu-mt {\n  margin-top: 133px !important;\n}\n\n.vertical-menu-mt .custom-card .card-header img {\n  margin-top: -146px !important;\n}\n\n.vertical-menu-main #main-nav #main-menu li a i {\n  margin-right: 8px;\n  font-size: 15px;\n}\n\n.vertical-menu-main .mega-menu {\n  width: 1500px !important;\n  max-width: 1500px !important;\n  padding: 0;\n  left: -182px !important;\n}\n\n/** ===== Vertical Menu css Ends=====**/\n/* ========sidebar icon vertical menu start=======*/\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu,\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {\n  display: block;\n  -webkit-transform: rotateX(0deg);\n  transform: rotateX(0deg);\n  z-index: 1;\n  background-color: #fff;\n  color: #717171;\n  font-size: 14px;\n  opacity: 1;\n  margin-top: -70px;\n  padding: 10px 0;\n  text-align: left;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);\n  position: absolute;\n  width: 245px;\n  margin-left: 115px;\n}\n\n.compact-switch {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  position: relative;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-header {\n  margin-top: 5px;\n  text-align: center;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-header>span {\n  display: block !important;\n  font-size: 11px;\n  margin-top: 2px;\n  color: #777777;\n  letter-spacing: 0;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar {\n  opacity: 1;\n  z-index: 1;\n  position: fixed;\n  height: auto;\n  display: table;\n  width: 145px;\n  left: 0;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  min-height: calc(100vh - 80px);\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user {\n  padding: 10px;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu {\n  padding: 20px 0;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li {\n  padding: 0 20px;\n  width: 100%;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li.active a i,\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li.active a span {\n  color: #ab8ce4;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li a {\n  width: 100%;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li>a:hover {\n  padding-left: 0;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li>a:hover i,\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li>a:hover span {\n  color: #ab8ce4;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header {\n  margin-top: 5px;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {\n  font-size: 25px;\n  margin: 0;\n  color: #717171;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover ul li .sidebar-submenu {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li .icon-sidebar {\n  font-size: 25px;\n  margin: 0;\n  color: #717171;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li .sub-header-title {\n  display: block;\n  font-size: 11px;\n  margin-top: 2px;\n  color: #777777;\n  letter-spacing: 0;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li.active:hover>.sidebar-submenu {\n  display: block;\n  position: relative;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li.active>.sidebar-submenu {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li ul li:hover .sidebar-submenu {\n  display: block;\n  -webkit-transform: rotateX(0deg);\n  transform: rotateX(0deg);\n  z-index: 1;\n  background-color: #fff;\n  color: #717171;\n  font-size: 14px;\n  opacity: 1;\n  margin-top: -70px;\n  padding: 10px 0;\n  text-align: left;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.13);\n  position: absolute;\n  width: 245px;\n  margin-left: 225px;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .main-sidebar-menu {\n  padding: 0 !important;\n  text-align: center;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-title {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-submenu {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon.page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {\n  padding: 10px 20px;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-header span {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-icon .sidebar-menu>li>a .fa-angle-right {\n  display: none;\n}\n\n.sidebar-toggle-btn {\n  font-size: 18px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n/* ========sidebar icon vertical menu end=======*/\n/* ========sidebar hover vertical menu start=======*/\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar {\n  -webkit-transform: translate(-180px);\n  transform: translate(-180px);\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-user,\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-header {\n  text-align: right !important;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover {\n  -webkit-transform: translate(0px);\n  transform: translate(0px);\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-user {\n  text-align: center !important;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-header {\n  text-align: left !important;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-menu li .icon-sidebar {\n  margin-right: 5px;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-menu li .icon-sidebar {\n  margin: 0;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-menu li.active>.sidebar-submenu {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-menu li:hover ul li .sidebar-submenu {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-body {\n  margin-left: 75px !important;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .page-body #customer-review .owl-stage-outer {\n  width: 92%;\n  margin: 0 auto;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-title {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-submenu {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .active {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-menu .sidebar-header {\n  text-align: left;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-menu li.active>.sidebar-submenu {\n  display: inline-block;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-menu>li>a .fa-angle-right {\n  display: inline-block;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-user {\n  padding: 25px 10px;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-user h6 {\n  display: inline-block;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-title {\n  display: inline-block;\n  width: 100%;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .active {\n  display: inline-block;\n  width: 100%;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar:hover .sidebar-header span {\n  display: inline-block;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {\n  text-align: center;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover.page-body-wrapper .page-sidebar .sidebar-user h6 {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-header span {\n  display: none;\n}\n\n.page-wrapper .page-body-wrapper.sidebar-hover .sidebar-menu>li>a .fa-angle-right {\n  display: none;\n}\n\n/* ========sidebar hover vertical menu ends=======*/\n/*=======Mega menu css start=======*/\n.mega-menu {\n  -webkit-perspective: inherit;\n  perspective: inherit;\n  position: static !important;\n  padding-top: 5px;\n  padding-left: 30px;\n}\n\n.mega-menu .default-according .card .btn-link {\n  font-weight: 500;\n  color: gray;\n}\n\n.mega-menu .default-according .card .card-body {\n  font-size: 12px;\n}\n\n.mega-menu .onhover-show-div {\n  width: 1500px;\n}\n\n.mega-menu .card-body {\n  padding: 20px;\n}\n\n.mega-menu .title {\n  color: #333333;\n  font-weight: 600;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  text-transform: uppercase;\n}\n\n.mega-menu div>div a {\n  margin-bottom: 0px;\n  display: inline-block;\n  color: #777777;\n}\n\n.mega-menu .custom-nav-img {\n  position: static;\n}\n\n.mega-menu .custom-nav-img .desk {\n  line-height: 25px;\n  font-size: 14px;\n  color: #777777;\n}\n\n.mega-menu .list-unstyled div a {\n  padding: 8px 35px 8px 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.mega-menu .list-unstyled div a:hover {\n  padding: 8px 35px 8px 10px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.mega-menu .galleria div {\n  margin-bottom: 5px;\n}\n\n.mega-menu .galleria div:hover {\n  -webkit-transform: translateY(4px) scale(1.04);\n  transform: translateY(4px) scale(1.04);\n}\n\n.mega-menu .galleria-list .galleria>div {\n  width: 25%;\n  font-size: 12px;\n  float: left;\n  color: #000;\n  -webkit-transition: ease-in 0.3s;\n  transition: ease-in 0.3s;\n}\n\n.mega-menu .galleria-list .galleria>div>a {\n  display: block;\n  margin: 5px 0 10px;\n  padding: 0 0 !important;\n}\n\n.mega-menu .galleria-list .galleria>div img {\n  border-radius: 3px;\n  max-width: 100%;\n}\n\n.mega-menu .galleria-list .galleria>div .username {\n  font-size: 12px;\n  color: #333333;\n  margin-bottom: 5px;\n}\n\n.mega-menu .galleria-list .galleria>div .username small {\n  display: block;\n  font-size: 11px;\n  color: #777777;\n  margin-top: 3px;\n}\n\n.mega-menu .drilldown {\n  overflow: hidden;\n  width: 100%;\n  padding: 0;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.mega-menu .drilldown a {\n  width: 100%;\n}\n\n.mega-menu .drilldown a:hover {\n  background-color: transparent;\n  color: #ab8ce4;\n}\n\n.mega-menu .drilldown-sub {\n  display: none;\n}\n\n.mega-menu .drilldown-back {\n  font-weight: bold;\n}\n\n/*=======Mega menu css end=======*/\n/*page chat quickview model start*/\n.quickview-wrapper {\n  position: fixed;\n  right: -285px;\n  top: 80px;\n  width: 285px;\n  background: #fff;\n  bottom: 0;\n  z-index: 10;\n  -webkit-box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n  border-left: 1px solid rgba(222, 227, 231, 0.56);\n  -webkit-transition: -webkit-transform 400ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n  transition: -webkit-transform 400ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n  transition: transform 400ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n  transition: transform 400ms cubic-bezier(0.05, 0.74, 0.27, 0.99), -webkit-transform 400ms cubic-bezier(0.05, 0.74, 0.27, 0.99);\n  height: calc(100% - 80px);\n}\n\n.quickview-wrapper.open {\n  -webkit-transform: translate3d(-100%, 0, 0);\n  transform: translate3d(-100%, 0, 0);\n}\n\n.quickview-wrapper .friend-list-search {\n  position: relative;\n  background-color: #eeeeee;\n  padding: 20px;\n}\n\n.quickview-wrapper .friend-list-search input {\n  color: #717171;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #eeeeee;\n  padding: 10px 15px;\n  border-radius: 4px;\n  letter-spacing: 1px;\n}\n\n.quickview-wrapper .friend-list-search .fa {\n  position: absolute;\n  right: 35px;\n  top: 35px;\n  font-size: 14px;\n  color: #cccccc;\n}\n\n.quickview-wrapper .recent-activity {\n  padding: 20px 40px;\n  margin-left: 25px;\n  position: relative;\n}\n\n.quickview-wrapper .recent-activity .user-first-letter:after {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  left: 0;\n  top: 10px;\n  float: left;\n  border: 1px dashed #eeeeee;\n}\n\n.quickview-wrapper .recent-activity .user-first-letter span {\n  position: absolute;\n  left: -23px;\n  width: 45px;\n  text-align: center;\n  color: #fff;\n  height: 45px;\n  border-radius: 50%;\n  z-index: 1;\n  font-size: 20px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  top: 10px;\n}\n\n.quickview-wrapper .recent-activity .activity-content h6 {\n  color: #444444;\n}\n\n.quickview-wrapper .recent-activity .activity-content p {\n  font-size: 14px;\n  color: #aaaaaa;\n  margin: 0;\n}\n\n.quickview-wrapper .modal-header .modal-title {\n  font-size: 15px;\n  color: #444444;\n  letter-spacing: 1px;\n  font-weight: 500;\n}\n\n.quickview-wrapper .modal-header i {\n  font-size: 16px;\n  color: #717171;\n}\n\n.quickview-wrapper .quickview-box .quickview-box-toggle {\n  position: absolute;\n  width: 54px;\n  height: 50px;\n  top: 45%;\n  left: -50px;\n  text-align: center;\n  line-height: 54px;\n  cursor: pointer;\n  padding: 0 !important;\n}\n\n.quickview-wrapper .quickview-box:before {\n  position: absolute;\n  content: '';\n  width: 48px;\n  height: 50px;\n  background-color: #fff;\n  top: 45%;\n  left: -47px;\n  -webkit-box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n  border-left: 1px solid rgba(222, 227, 231, 0.56);\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.quickview-wrapper .quickview-box:after {\n  position: absolute;\n  content: '';\n  background-color: #fff;\n  width: 5px;\n  height: 50px;\n  left: 0;\n  top: 45%;\n}\n\n.quickview-wrapper .quickview-recent-activity .quickview-box-toggle {\n  position: absolute;\n  width: 54px;\n  height: 50px;\n  top: 52%;\n  left: -50px;\n  text-align: center;\n  line-height: 54px;\n  cursor: pointer;\n  padding: 0 !important;\n}\n\n.quickview-wrapper .quickview-recent-activity:before {\n  position: absolute;\n  content: '';\n  width: 48px;\n  height: 50px;\n  background-color: #fff;\n  top: 52%;\n  left: -47px;\n  -webkit-box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n  box-shadow: 0 0 9px rgba(191, 191, 191, 0.36);\n  border-left: 1px solid rgba(222, 227, 231, 0.56);\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n\n.quickview-wrapper .quickview-recent-activity:after {\n  position: absolute;\n  content: '';\n  background-color: #fff;\n  width: 5px;\n  height: 50px;\n  left: 0;\n  top: 52%;\n}\n\n.quickview-wrapper .chat-box .friend-list {\n  margin-top: 20px;\n}\n\n.chat-quickview {\n  right: -400px;\n  width: 400px;\n}\n\n.chat-quickview .chat-box .chat-left-aside .chat .chat-msg-box {\n  height: 650px;\n}\n\n.chat-quickview .chat-box .chat-left-aside .chat .chat-msg-box .message {\n  width: 100%;\n}\n\n.chat-quickview .chat-box .chat-left-aside .chat .chat-message {\n  padding: 30px 0;\n  margin: 30px 0;\n  border-top: 1px solid #eeeeee;\n}\n\n/*page chat quickview model end*/\n/*box layout start*/\n.box-layout.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar {\n  width: 75px;\n  -webkit-transform: translate(0px);\n  transform: translate(0px);\n}\n\n.box-layout.page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover {\n  width: 255px;\n}\n\n.box-layout.page-wrapper .sidebar-close .page-sidebar.page-sidebar-open {\n  display: none;\n}\n\n.box-layout.page-wrapper .page-body-wrapper.sidebar-close .page-sidebar {\n  display: none;\n}\n\n.box-layout.page-wrapper .page-body-wrapper.sidebar-icon {\n  overflow: hidden;\n}\n\n.box-layout.page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar-open {\n  -webkit-transform: translateX(-150px);\n  transform: translateX(-150px);\n  left: unset;\n}\n\n.box-layout.page-wrapper .sidebar-icon .page-sidebar {\n  position: absolute;\n}\n\n.box-layout.page-wrapper .sidebar-icon .page-sidebar>div {\n  position: fixed;\n  background-color: #fff;\n  height: 100vh;\n  width: 145px;\n  -webkit-box-shadow: 0 0 11px rgba(0, 0, 0, 0.13);\n  box-shadow: 0 0 11px rgba(0, 0, 0, 0.13);\n}\n\n.box-layout.page-wrapper .page-main-header .main-header-right {\n  margin: 0;\n}\n\n.box-layout.page-wrapper .page-main-header .vertical-menu-main .mega-menu {\n  width: 1050px !important;\n  max-width: 1050px !important;\n  left: -80px !important;\n}\n\n.box-layout.page-wrapper .page-body-wrapper {\n  width: 1280px;\n  -webkit-box-shadow: 1px 3px 25px rgba(0, 0, 0, 0.07);\n  box-shadow: 1px 3px 25px rgba(0, 0, 0, 0.07);\n  margin: 0 auto;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .footer-fix {\n  width: 1027px;\n  margin: 0 auto;\n  left: 256px;\n  right: 0;\n  padding-right: 0;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-width: 300px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content>div {\n  height: 450px;\n  z-index: 9;\n  background-color: rgba(255, 255, 255, 0.75);\n  background-blend-mode: overlay;\n  width: 100%;\n  padding: 30px;\n  left: 15px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-content button {\n  width: 40%;\n  font-size: 14px;\n  margin: 0 auto;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .call-icons ul li {\n  border: 1px solid #717171;\n  width: 50px;\n  height: 50px;\n  padding: 8px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .receiver-img img {\n  width: 38%;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-box .chat-history .total-time h2 {\n  font-size: 28px;\n  color: #717171;\n}\n\n.box-layout.page-wrapper .page-body-wrapper canvas#myLineCharts {\n  width: 100%;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .chat-right-aside {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 60%;\n  flex: 0 0 60%;\n  max-width: 60%;\n  overflow: hidden;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .caller-img {\n  position: absolute;\n  width: 100%;\n  max-width: 100%;\n  left: 15px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .caller-img img {\n  opacity: 0.7;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .browser-widget img {\n  height: 65px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .weather-widget-two .bottom-whetherinfo .whether-content {\n  top: 39px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .custom-card .card-header img {\n  margin-top: -73px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .custom-card .card-profile img {\n  height: 130px;\n  top: -17px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .height-scroll {\n  max-height: 444px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper .select2 {\n  width: 901.781px;\n}\n\n.box-layout.page-wrapper .page-body-wrapper.sidebar-hover .page-body #customer-review .owl-stage-outer {\n  width: 85%;\n}\n\n.box-layout.page-wrapper .page-main-header {\n  max-width: 1280px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n}\n\n.box-layout.page-wrapper .page-builder .ge-canvas.ge-layout-desktop {\n  margin-top: 50px;\n}\n\n.box-layout.page-wrapper .page-builder .ge-addRowGroup {\n  margin-bottom: 10px;\n}\n\n.box-layout.page-wrapper .pricing-wrapper-card {\n  padding: 50px 20px;\n}\n\n.box-layout.page-wrapper .card .blog-box.blog-grid.set-min-height {\n  min-height: 400px;\n}\n\n.box-layout.page-wrapper .card .card-body .top-sale-chart canvas#myLineCharts {\n  min-height: 410px;\n}\n\n.box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris-daily {\n  min-height: 430px;\n}\n\n.box-layout.page-wrapper .flot-chart-placeholder#donut-color-chart-morris {\n  min-height: 430px;\n}\n\n.box-layout.page-wrapper .set-col-12 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.box-layout.page-wrapper .set-col-6 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.box-layout.page-wrapper .set-col-3 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 25%;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.box-layout.page-wrapper .set-col-7 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 60%;\n  flex: 0 0 60%;\n  max-width: 60%;\n}\n\n.box-layout.page-wrapper .set-col-5 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 40%;\n  flex: 0 0 40%;\n  max-width: 40%;\n}\n\n.box-layout.page-wrapper .chat-box .chat-right-aside {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: calc(100% - 15px);\n  overflow: hidden;\n}\n\n.box-layout.page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n  font-size: 19px;\n}\n\n.box-layout.page-wrapper .chat-box .toogle-bar {\n  display: inline-block;\n  margin-right: 0 !important;\n}\n\n.box-layout.page-wrapper .chat-menu {\n  right: 0;\n  border-top: 1px solid #ddd;\n  opacity: 0;\n  -webkit-transform: translateY(-30px);\n  transform: translateY(-30px);\n  visibility: hidden;\n  top: 81px;\n  position: absolute;\n  z-index: 9;\n  background-color: #fff;\n  -webkit-transition: all linear 0.3s;\n  transition: all linear 0.3s;\n}\n\n.box-layout.page-wrapper .chat-menu.show {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transform: translateY(0px);\n  transform: translateY(0px);\n  -webkit-transition: all linear 0.3s;\n  transition: all linear 0.3s;\n  padding-bottom: 25px;\n}\n\n.box-layout.page-wrapper .ct-10.total-chart .ct-chart-bar .ct-series .ct-bar {\n  stroke-width: 23px !important;\n}\n\n.box-layout.page-wrapper .email-wrap .email-body .email-compose .cke_contents.cke_reset {\n  max-height: 197px;\n}\n\n.box-layout.page-wrapper .email-wrap .email-right-aside .email-body .inbox {\n  height: 734px;\n}\n\n.box-layout.page-wrapper .email-wrap .email-content .email-top .user-emailid:after {\n  right: -10px;\n  top: -21px;\n}\n\n.box-layout.page-wrapper .todo .notification-popup {\n  right: 320px;\n}\n\n.box-layout.page-wrapper .touchspin {\n  padding: 0 10px;\n}\n\n.box-layout.page-wrapper .vertical-menu-main {\n  width: 1280px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n}\n\n.box-layout.page-wrapper .vertical-menu-main .mega-menu {\n  width: 1050px !important;\n  max-width: 1050px !important;\n  left: -320px !important;\n}\n\n.box-layout.page-wrapper .comingsoon video {\n  min-width: 67%;\n  width: 67%;\n}\n\n.box-layout.page-wrapper .authentication-main .auth-innerleft {\n  width: 22.333333%;\n}\n\n.box-layout.page-wrapper .auth-bg-effect .second-effect {\n  left: 55%;\n}\n\n.box-layout.page-wrapper .auth-bg-video video {\n  min-width: 67%;\n  width: 67%;\n}\n\n/*box layout Ends*/\n.sidebar-widget {\n  padding-top: 20px;\n  border-top: 1px solid #eeeeee;\n  padding-bottom: 20px;\n}\n\n.sidebar-widget .sidebar-widget-top {\n  margin-bottom: -50px;\n}\n\n.sidebar-widget .sidebar-widget-top i {\n  height: 60px;\n  width: 60px;\n  background-color: #fff;\n  display: inline-block;\n  font-size: 24px;\n  border-radius: 100%;\n  line-height: 2.3;\n}\n\n.sidebar-widget .sidebar-widget-bottom {\n  background-color: #eeeeee;\n  text-align: center;\n}\n\n.sidebar-widget .sidebar-widget-bottom p {\n  line-height: 2.3;\n  padding-top: 26px;\n  font-size: 15px;\n  margin-bottom: 0;\n}\n\n/**=====================\n    05. Header CSS Ends\n==========================**/\n/**=====================\n    06. Button CSS start\n==========================**/\n.btn-air-primary {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-primary:hover,\n.btn-air-primary:active,\n.btn-air-primary:not([disabled]):not(.disabled):active {\n  background-color: #8d63da;\n  border-color: #8d63da;\n}\n\n.btn-air-secondary {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-secondary:hover,\n.btn-air-secondary:active,\n.btn-air-secondary:not([disabled]):not(.disabled):active {\n  background-color: #1e9faf;\n  border-color: #1e9faf;\n}\n\n.btn-air-success {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-success:hover,\n.btn-air-success:active,\n.btn-air-success:not([disabled]):not(.disabled):active {\n  background-color: #008f6c;\n  border-color: #008f6c;\n}\n\n.btn-air-danger {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-danger:hover,\n.btn-air-danger:active,\n.btn-air-danger:not([disabled]):not(.disabled):active {\n  background-color: #ff2046;\n  border-color: #ff2046;\n}\n\n.btn-air-info {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-info:hover,\n.btn-air-info:active,\n.btn-air-info:not([disabled]):not(.disabled):active {\n  background-color: #0d7eff;\n  border-color: #0d7eff;\n}\n\n.btn-air-light {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-light:hover,\n.btn-air-light:active,\n.btn-air-light:not([disabled]):not(.disabled):active {\n  background-color: #d5d5d5;\n  border-color: #d5d5d5;\n}\n\n.btn-air-dark {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-dark:hover,\n.btn-air-dark:active,\n.btn-air-dark:not([disabled]):not(.disabled):active {\n  background-color: #161a23;\n  border-color: #161a23;\n}\n\n.btn-air-warning {\n  -webkit-box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n  box-shadow: 0 5px 10px 2px rgba(88, 103, 221, 0.19) !important;\n}\n\n.btn-air-warning:hover,\n.btn-air-warning:active,\n.btn-air-warning:not([disabled]):not(.disabled):active {\n  background-color: #c0ab00;\n  border-color: #c0ab00;\n}\n\n.input-air-primary {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-primary:focus {\n  border-color: #ab8ce4;\n}\n\n.input-air-secondary {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-secondary:focus {\n  border-color: #26c6da;\n}\n\n.input-air-success {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-success:focus {\n  border-color: #00c292;\n}\n\n.input-air-danger {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-danger:focus {\n  border-color: #FF5370;\n}\n\n.input-air-info {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-info:focus {\n  border-color: #4099ff;\n}\n\n.input-air-light {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-light:focus {\n  border-color: #eeeeee;\n}\n\n.input-air-dark {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-dark:focus {\n  border-color: #2a3142;\n}\n\n.input-air-warning {\n  -webkit-box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n  box-shadow: 0 3px 5px 1px rgba(88, 103, 221, 0.15) !important;\n}\n\n.input-air-warning:focus {\n  border-color: #f3d800;\n}\n\n.form-bg-primary {\n  background: #ab8ce4;\n  border-color: #ab8ce4;\n  color: #fff;\n}\n\n.form-bg-primary:focus {\n  border-color: #ab8ce4;\n  background: #ab8ce4;\n  color: #fff;\n}\n\n.form-bg-primary:focus:active {\n  border-color: #ab8ce4;\n  background: #ab8ce4;\n  color: #fff;\n}\n\n.form-bg-secondary {\n  background: #26c6da;\n  border-color: #26c6da;\n  color: #fff;\n}\n\n.form-bg-secondary:focus {\n  border-color: #26c6da;\n  background: #26c6da;\n  color: #fff;\n}\n\n.form-bg-secondary:focus:active {\n  border-color: #26c6da;\n  background: #26c6da;\n  color: #fff;\n}\n\n.form-bg-success {\n  background: #00c292;\n  border-color: #00c292;\n  color: #fff;\n}\n\n.form-bg-success:focus {\n  border-color: #00c292;\n  background: #00c292;\n  color: #fff;\n}\n\n.form-bg-success:focus:active {\n  border-color: #00c292;\n  background: #00c292;\n  color: #fff;\n}\n\n.form-bg-danger {\n  background: #FF5370;\n  border-color: #FF5370;\n  color: #fff;\n}\n\n.form-bg-danger:focus {\n  border-color: #FF5370;\n  background: #FF5370;\n  color: #fff;\n}\n\n.form-bg-danger:focus:active {\n  border-color: #FF5370;\n  background: #FF5370;\n  color: #fff;\n}\n\n.form-bg-info {\n  background: #4099ff;\n  border-color: #4099ff;\n  color: #fff;\n}\n\n.form-bg-info:focus {\n  border-color: #4099ff;\n  background: #4099ff;\n  color: #fff;\n}\n\n.form-bg-info:focus:active {\n  border-color: #4099ff;\n  background: #4099ff;\n  color: #fff;\n}\n\n.form-bg-light {\n  background: #eeeeee;\n  border-color: #eeeeee;\n  color: #2a3142;\n}\n\n.form-bg-light:focus {\n  border-color: #eeeeee;\n  background: #eeeeee;\n  color: #2a3142;\n}\n\n.form-bg-light:focus:active {\n  border-color: #eeeeee;\n  background: #eeeeee;\n  color: #2a3142;\n}\n\n.form-bg-dark {\n  background: #2a3142;\n  border-color: #2a3142;\n  color: #fff;\n}\n\n.form-bg-dark:focus {\n  border-color: #2a3142;\n  background: #2a3142;\n  color: #fff;\n}\n\n.form-bg-dark:focus:active {\n  border-color: #2a3142;\n  background: #2a3142;\n  color: #fff;\n}\n\n.form-bg-warning {\n  background: #f3d800;\n  border-color: #f3d800;\n  color: #fff;\n}\n\n.form-bg-warning:focus {\n  border-color: #f3d800;\n  background: #f3d800;\n  color: #fff;\n}\n\n.form-bg-warning:focus:active {\n  border-color: #f3d800;\n  background: #f3d800;\n  color: #fff;\n}\n\n.btn-primary-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(#c3adec), color-stop(51%, #936bdc), to(#c3adec));\n  background-image: linear-gradient(to right, #c3adec 0%, #936bdc 51%, #c3adec 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-primary-gradien:focus,\n.btn-primary-gradien:active,\n.btn-primary-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(#c3adec), color-stop(0%), color-stop(#936bdc), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, #c3adec, 0%, #936bdc, 100%, #fff) !important;\n}\n\n.btn-secondary-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(#49cfe0), color-stop(51%, #1fa7b8), to(#49cfe0));\n  background-image: linear-gradient(to right, #49cfe0 0%, #1fa7b8 51%, #49cfe0 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-secondary-gradien:hover,\n.btn-secondary-gradien:focus,\n.btn-secondary-gradien:active,\n.btn-secondary-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(#49cfe0), color-stop(0%), color-stop(#1fa7b8), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, #49cfe0, 0%, #1fa7b8, 100%, #fff) !important;\n}\n\n.btn-success-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(#00ebb1), color-stop(51%, #009973), to(#00ebb1));\n  background-image: linear-gradient(to right, #00ebb1 0%, #009973 51%, #00ebb1 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-success-gradien:hover,\n.btn-success-gradien:focus,\n.btn-success-gradien:active,\n.btn-success-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(#00ebb1), color-stop(0%), color-stop(#009973), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, #00ebb1, 0%, #009973, 100%, #fff) !important;\n}\n\n.btn-danger-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(#ff7c92), color-stop(51%, #ff2a4e), to(#ff7c92));\n  background-image: linear-gradient(to right, #ff7c92 0%, #ff2a4e 51%, #ff7c92 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-danger-gradien:hover,\n.btn-danger-gradien:focus,\n.btn-danger-gradien:active,\n.btn-danger-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(#ff7c92), color-stop(0%), color-stop(#ff2a4e), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, #ff7c92, 0%, #ff2a4e, 100%, #fff) !important;\n}\n\n.btn-warning-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(#ffe61d), color-stop(51%, #cab400), to(#ffe61d));\n  background-image: linear-gradient(to right, #ffe61d 0%, #cab400 51%, #ffe61d 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-warning-gradien:hover,\n.btn-warning-gradien:focus,\n.btn-warning-gradien:active,\n.btn-warning-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(#ffe61d), color-stop(0%), color-stop(#cab400), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, #ffe61d, 0%, #cab400, 100%, #fff) !important;\n}\n\n.btn-info-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(#69afff), color-stop(51%, #1783ff), to(#69afff));\n  background-image: linear-gradient(to right, #69afff 0%, #1783ff 51%, #69afff 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-info-gradien:hover,\n.btn-info-gradien:focus,\n.btn-info-gradien:active,\n.btn-info-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(#69afff), color-stop(0%), color-stop(#1783ff), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, #69afff, 0%, #1783ff, 100%, #fff) !important;\n}\n\n.btn-light-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(white), color-stop(51%, #dadada), to(white));\n  background-image: linear-gradient(to right, white 0%, #dadada 51%, white 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-light-gradien:hover,\n.btn-light-gradien:focus,\n.btn-light-gradien:active,\n.btn-light-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(white), color-stop(0%), color-stop(#dadada), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, white, 0%, #dadada, 100%, #fff) !important;\n}\n\n.btn-dark-gradien {\n  background-image: -webkit-gradient(linear, left top, right top, from(#3a445b), color-stop(51%, #1a1e29), to(#3a445b));\n  background-image: linear-gradient(to right, #3a445b 0%, #1a1e29 51%, #3a445b 100%);\n  border: none;\n  color: #fff;\n  background-size: auto 200%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.btn-dark-gradien:hover,\n.btn-dark-gradien:focus,\n.btn-dark-gradien:active,\n.btn-dark-gradien.active {\n  -webkit-transition: 1.5s;\n  transition: 1.5s;\n  background-position: right center;\n  background-image: -webkit-gradient(linear, left top, right top, from(#3a445b), color-stop(0%), color-stop(#1a1e29), color-stop(100%), to(#fff)) !important;\n  background-image: linear-gradient(to right, #3a445b, 0%, #1a1e29, 100%, #fff) !important;\n}\n\n[class*='-gradien']:hover {\n  background-size: 50% 100%;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.large-btn {\n  margin-bottom: -20px;\n}\n\n.large-btn .btn {\n  margin-right: 5px;\n  margin-bottom: 15px;\n}\n\n.btn-square {\n  border-radius: 0px;\n}\n\n.btn-pill {\n  border-radius: 60px;\n}\n\n.btn-group-pill .btn:first-child {\n  border-radius: 60px 0 0 60px;\n}\n\n.btn-group-pill .btn:last-child {\n  border-radius: 0 60px 60px 0;\n}\n\n.btn-group-square .btn:first-child {\n  border-radius: 0px 0 0 0px;\n}\n\n.btn-group-square .btn:last-child {\n  border-radius: 0 0px 0px 0;\n}\n\n.btn-showcase {\n  margin-bottom: -10px;\n}\n\n.btn-showcase .btn {\n  margin-bottom: 10px;\n  margin-right: 18px;\n}\n\n.btn-dropdown-showcase {\n  margin-bottom: -10px;\n}\n\n.btn-dropdown-showcase .dropdown {\n  margin-bottom: 10px;\n  margin-right: 18px;\n}\n\n.btn-dropdown-showcase .btn-group {\n  margin-bottom: 10px;\n  margin-right: 18px;\n}\n\n.btn-group .radio label::before {\n  top: 2px;\n}\n\n.btn-group .radio label::after {\n  top: 7px;\n}\n\n.btn-group .checkbox label {\n  margin-top: 3px;\n}\n\n.btn-group-showcase>div {\n  margin-bottom: -20px;\n}\n\n.btn-group-showcase>div label {\n  margin-bottom: 0;\n}\n\n.btn-group-showcase .btn-group {\n  margin-right: 20px;\n  margin-bottom: 20px;\n}\n\n.btn {\n  font-size: 14px;\n  padding: 0.375rem 1.75rem;\n}\n\n.btn-lg {\n  font-size: 1.25rem;\n}\n\n.btn-sm {\n  font-size: 12px;\n}\n\n.btn-xs {\n  padding: 0.05rem 0.4rem;\n  font-size: 11px;\n}\n\n.tooltiptext {\n  visibility: visible;\n  width: 120px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -60px;\n  opacity: 1;\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n\n.tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n}\n\n/**=====================\n     06. Button CSS end\n==========================**/\n/**=====================\n     07. Color CSS Start\n==========================**/\n.color-box {\n  margin-bottom: -10px;\n}\n\n.primary-color ul li:nth-child(13) {\n  background-color: #b092e5;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(13) span:before {\n  content: \"#b092e5\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(12) {\n  background-color: #b498e7;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(12) span:before {\n  content: \"#b498e7\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(11) {\n  background-color: #b99fe8;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(11) span:before {\n  content: \"#b99fe8\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(10) {\n  background-color: #bda5ea;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(10) span:before {\n  content: \"#bda5ea\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(9) {\n  background-color: #c2abeb;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(9) span:before {\n  content: \"#c2abeb\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(8) {\n  background-color: #c6b1ed;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(8) span:before {\n  content: \"#c6b1ed\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(7) {\n  background-color: #cbb7ee;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(7) span:before {\n  content: \"#cbb7ee\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(6) {\n  background-color: #cfbef0;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(6) span:before {\n  content: \"#cfbef0\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(5) {\n  background-color: #d4c4f1;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(5) span:before {\n  content: \"#d4c4f1\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(4) {\n  background-color: #d8caf3;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(4) span:before {\n  content: \"#d8caf3\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(3) {\n  background-color: #ddd0f4;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(3) span:before {\n  content: \"#ddd0f4\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(2) {\n  background-color: #e1d6f5;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(2) span:before {\n  content: \"#e1d6f5\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.primary-color ul li:nth-child(1) {\n  background-color: #e6ddf7;\n  padding: 10px 15px;\n}\n\n.primary-color ul li:nth-child(1) span:before {\n  content: \"#e6ddf7\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(13) {\n  background-color: #33c9dc;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(13) span:before {\n  content: \"#33c9dc\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(12) {\n  background-color: #40cdde;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(12) span:before {\n  content: \"#40cdde\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(11) {\n  background-color: #4dd0e1;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(11) span:before {\n  content: \"#4dd0e1\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(10) {\n  background-color: #5ad4e3;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(10) span:before {\n  content: \"#5ad4e3\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(9) {\n  background-color: #67d7e5;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(9) span:before {\n  content: \"#67d7e5\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(8) {\n  background-color: #74dbe7;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(8) span:before {\n  content: \"#74dbe7\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(7) {\n  background-color: #81deea;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(7) span:before {\n  content: \"#81deea\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(6) {\n  background-color: #8fe1ec;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(6) span:before {\n  content: \"#8fe1ec\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(5) {\n  background-color: #9ce5ee;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(5) span:before {\n  content: \"#9ce5ee\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(4) {\n  background-color: #a9e8f0;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(4) span:before {\n  content: \"#a9e8f0\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(3) {\n  background-color: #b6ecf3;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(3) span:before {\n  content: \"#b6ecf3\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(2) {\n  background-color: #c3eff5;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(2) span:before {\n  content: \"#c3eff5\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.secondary-color ul li:nth-child(1) {\n  background-color: #d0f3f7;\n  padding: 10px 15px;\n}\n\n.secondary-color ul li:nth-child(1) span:before {\n  content: \"#d0f3f7\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(13) {\n  background-color: #00c795;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(13) span:before {\n  content: \"#00c795\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(12) {\n  background-color: #00cb99;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(12) span:before {\n  content: \"#00cb99\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(11) {\n  background-color: #00d09c;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(11) span:before {\n  content: \"#00d09c\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(10) {\n  background-color: #00d4a0;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(10) span:before {\n  content: \"#00d4a0\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(9) {\n  background-color: #00d9a3;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(9) span:before {\n  content: \"#00d9a3\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(8) {\n  background-color: #00dea7;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(8) span:before {\n  content: \"#00dea7\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(7) {\n  background-color: #00e2aa;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(7) span:before {\n  content: \"#00e2aa\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(6) {\n  background-color: #00e7ae;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(6) span:before {\n  content: \"#00e7ae\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(5) {\n  background-color: #00ebb1;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(5) span:before {\n  content: \"#00ebb1\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(4) {\n  background-color: #00f0b5;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(4) span:before {\n  content: \"#00f0b5\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(3) {\n  background-color: #00f4b8;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(3) span:before {\n  content: \"#00f4b8\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(2) {\n  background-color: #00f9bb;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(2) span:before {\n  content: \"#00f9bb\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.success-color ul li:nth-child(1) {\n  background-color: #00febf;\n  padding: 10px 15px;\n}\n\n.success-color ul li:nth-child(1) span:before {\n  content: \"#00febf\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(13) {\n  background-color: #4da0ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(13) span:before {\n  content: \"#4da0ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(12) {\n  background-color: #5aa7ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(12) span:before {\n  content: \"#5aa7ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(11) {\n  background-color: #66adff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(11) span:before {\n  content: \"#66adff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(10) {\n  background-color: #73b4ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(10) span:before {\n  content: \"#73b4ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(9) {\n  background-color: #80bbff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(9) span:before {\n  content: \"#80bbff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(8) {\n  background-color: #8dc2ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(8) span:before {\n  content: \"#8dc2ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(7) {\n  background-color: #99c9ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(7) span:before {\n  content: \"#99c9ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(6) {\n  background-color: #a6cfff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(6) span:before {\n  content: \"#a6cfff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(5) {\n  background-color: #b3d6ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(5) span:before {\n  content: \"#b3d6ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(4) {\n  background-color: #c0ddff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(4) span:before {\n  content: \"#c0ddff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(3) {\n  background-color: #cce4ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(3) span:before {\n  content: \"#cce4ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(2) {\n  background-color: #d9ebff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(2) span:before {\n  content: \"#d9ebff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.info-color ul li:nth-child(1) {\n  background-color: #e6f2ff;\n  padding: 10px 15px;\n}\n\n.info-color ul li:nth-child(1) span:before {\n  content: \"#e6f2ff\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(13) {\n  background-color: #ffe303;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(13) span:before {\n  content: \"#ffe303\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(12) {\n  background-color: #ffe513;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(12) span:before {\n  content: \"#ffe513\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(11) {\n  background-color: #ffe622;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(11) span:before {\n  content: \"#ffe622\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(10) {\n  background-color: #ffe831;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(10) span:before {\n  content: \"#ffe831\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(9) {\n  background-color: #ffea41;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(9) span:before {\n  content: \"#ffea41\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(8) {\n  background-color: #ffec50;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(8) span:before {\n  content: \"#ffec50\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(7) {\n  background-color: #ffed5f;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(7) span:before {\n  content: \"#ffed5f\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(6) {\n  background-color: #ffef6e;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(6) span:before {\n  content: \"#ffef6e\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(5) {\n  background-color: #fff17e;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(5) span:before {\n  content: \"#fff17e\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(4) {\n  background-color: #fff28d;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(4) span:before {\n  content: \"#fff28d\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(3) {\n  background-color: #fff49c;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(3) span:before {\n  content: \"#fff49c\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(2) {\n  background-color: #fff6ac;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(2) span:before {\n  content: \"#fff6ac\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.yellow-color ul li:nth-child(1) {\n  background-color: #fff7bb;\n  padding: 10px 15px;\n}\n\n.yellow-color ul li:nth-child(1) span:before {\n  content: \"#fff7bb\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(13) {\n  background-color: #ff5d78;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(13) span:before {\n  content: \"#ff5d78\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(12) {\n  background-color: #ff6781;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(12) span:before {\n  content: \"#ff6781\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(11) {\n  background-color: #ff7289;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(11) span:before {\n  content: \"#ff7289\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(10) {\n  background-color: #ff7c92;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(10) span:before {\n  content: \"#ff7c92\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(9) {\n  background-color: #ff869a;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(9) span:before {\n  content: \"#ff869a\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(8) {\n  background-color: #ff90a3;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(8) span:before {\n  content: \"#ff90a3\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(7) {\n  background-color: #ff9aab;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(7) span:before {\n  content: \"#ff9aab\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(6) {\n  background-color: #ffa5b4;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(6) span:before {\n  content: \"#ffa5b4\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(5) {\n  background-color: #ffafbc;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(5) span:before {\n  content: \"#ffafbc\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(4) {\n  background-color: #ffb9c5;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(4) span:before {\n  content: \"#ffb9c5\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(3) {\n  background-color: #ffc3cd;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(3) span:before {\n  content: \"#ffc3cd\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(2) {\n  background-color: #ffcdd6;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(2) span:before {\n  content: \"#ffcdd6\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.red-color ul li:nth-child(1) {\n  background-color: #ffd8de;\n  padding: 10px 15px;\n}\n\n.red-color ul li:nth-child(1) span:before {\n  content: \"#ffd8de\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(13) {\n  background-color: #eb2067;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(13) span:before {\n  content: \"#eb2067\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(12) {\n  background-color: #ec2e70;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(12) span:before {\n  content: \"#ec2e70\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(11) {\n  background-color: #ed3c7a;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(11) span:before {\n  content: \"#ed3c7a\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(10) {\n  background-color: #ee4a83;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(10) span:before {\n  content: \"#ee4a83\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(9) {\n  background-color: #f0588d;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(9) span:before {\n  content: \"#f0588d\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(8) {\n  background-color: #f16696;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(8) span:before {\n  content: \"#f16696\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(7) {\n  background-color: #f274a0;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(7) span:before {\n  content: \"#f274a0\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(6) {\n  background-color: #f482aa;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(6) span:before {\n  content: \"#f482aa\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(5) {\n  background-color: #f590b3;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(5) span:before {\n  content: \"#f590b3\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(4) {\n  background-color: #f69ebd;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(4) span:before {\n  content: \"#f69ebd\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(3) {\n  background-color: #f7acc6;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(3) span:before {\n  content: \"#f7acc6\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(2) {\n  background-color: #f9bad0;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(2) span:before {\n  content: \"#f9bad0\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.pink-color ul li:nth-child(1) {\n  background-color: #fac8d9;\n  padding: 10px 15px;\n}\n\n.pink-color ul li:nth-child(1) span:before {\n  content: \"#fac8d9\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(13) {\n  background-color: #797979;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(13) span:before {\n  content: \"#797979\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(12) {\n  background-color: gray;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(12) span:before {\n  content: \"gray\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(11) {\n  background-color: #888888;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(11) span:before {\n  content: \"#888888\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(10) {\n  background-color: #909090;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(10) span:before {\n  content: \"#909090\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(9) {\n  background-color: #979797;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(9) span:before {\n  content: \"#979797\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(8) {\n  background-color: #9f9f9f;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(8) span:before {\n  content: \"#9f9f9f\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(7) {\n  background-color: #a7a7a7;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(7) span:before {\n  content: \"#a7a7a7\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(6) {\n  background-color: #aeaeae;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(6) span:before {\n  content: \"#aeaeae\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(5) {\n  background-color: #b6b6b6;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(5) span:before {\n  content: \"#b6b6b6\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(4) {\n  background-color: #bebebe;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(4) span:before {\n  content: \"#bebebe\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(3) {\n  background-color: #c5c5c5;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(3) span:before {\n  content: \"#c5c5c5\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(2) {\n  background-color: #cdcdcd;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(2) span:before {\n  content: \"#cdcdcd\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n.gray-color ul li:nth-child(1) {\n  background-color: #d4d4d4;\n  padding: 10px 15px;\n}\n\n.gray-color ul li:nth-child(1) span:before {\n  content: \"#d4d4d4\";\n  display: block;\n  color: #fff;\n  text-align: center;\n}\n\n/**=====================\n     07. Color CSS Ends\n==========================**/\n/**=====================\n      08. GRID CSS Start\n==========================**/\n.grid-showcase {\n  margin-bottom: -10px;\n}\n\n.grid-showcase span {\n  display: block;\n  border: 1px solid #eeeeee;\n  padding: 10px;\n  margin-bottom: 10px;\n  text-align: center;\n  background-color: #fff;\n}\n\n.grid-align {\n  margin-bottom: -30px;\n}\n\n.grid-align .row {\n  padding: 15px 0;\n  min-height: 10rem;\n  border: 1px solid #eeeeee;\n  margin-bottom: 30px;\n  background-color: #eeeeee;\n}\n\n/**=====================\n      08. GRID CSS Ends\n==========================**/\n/**=====================\n     09. Error-page  CSS Start\n==========================**/\n.error-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-height: 100vh;\n  text-align: center;\n}\n\n.error-wrapper .maintenance-icons li i {\n  color: #eeeeee;\n  font-size: 50px;\n  -webkit-animation: rotate-effect 40s infinite linear reverse;\n  animation: rotate-effect 40s infinite linear reverse;\n}\n\n.error-wrapper .maintenance-icons li:nth-child(2) i {\n  font-size: 100px;\n  margin-left: 110px;\n  margin-top: -25px;\n  -webkit-animation: rotate-effect 40s linear infinite reverse;\n  animation: rotate-effect 40s linear infinite reverse;\n}\n\n.error-wrapper .maintenance-icons li:nth-child(3) i {\n  -webkit-animation: rotate-effect 30s infinite linear;\n  animation: rotate-effect 30s infinite linear;\n  font-size: 150px;\n  margin-top: -85px;\n  margin-right: 120px;\n}\n\n.error-wrapper .maintenance-heading {\n  margin-top: 70px;\n}\n\n.error-wrapper .maintenance-heading .cloud-first {\n  z-index: 0;\n  width: 600px;\n}\n\n.error-wrapper .maintenance-heading .cloud-second {\n  z-index: 3;\n  width: 400px;\n  margin-top: -55px;\n  position: relative;\n}\n\n.error-wrapper .maintenance-heading .headline {\n  font-size: 99px;\n  font-weight: 900;\n  letter-spacing: 10px;\n  color: #4099ff;\n  z-index: 2;\n  position: relative;\n  margin-top: -150px;\n}\n\n.error-wrapper .error-heading {\n  margin-top: 115px;\n}\n\n.error-wrapper .error-heading .cloud-first {\n  z-index: 0;\n  width: 755px;\n}\n\n.error-wrapper .error-heading .cloud-second {\n  z-index: 3;\n  width: 450px;\n  margin-top: -90px;\n  position: relative;\n}\n\n.error-wrapper .error-heading .headline {\n  font-size: 285px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-top: -370px;\n  font-family: Open Sans;\n}\n\n.error-wrapper .sub-content {\n  font-size: 18px;\n  color: #333333;\n  letter-spacing: 1px;\n  font-weight: normal;\n  line-height: 35px;\n  z-index: 3;\n  position: relative;\n  margin-top: 30px;\n  margin-bottom: 0;\n}\n\n.error-wrapper .btn {\n  margin-top: 40px;\n}\n\n.error {\n  margin: 70px 0 100px;\n  color: #000;\n}\n\n.error .error-title {\n  font-size: 9.5rem;\n  color: #fff;\n  text-shadow: 6px 6px 7px rgba(0, 0, 0, 0.32);\n}\n\n.error .line-bottom {\n  width: 10%;\n  height: 5px;\n  background-color: #f3d800;\n  border: none;\n}\n\n.error .c-white {\n  color: #fff;\n}\n\n.error .error-btn {\n  text-align: center;\n}\n\n.error .padd {\n  padding: 10px 30px 10px 30px;\n}\n\n.error .btn-back-home {\n  background-color: #eeeeee;\n  color: #000;\n}\n\n.error .btn-back-home:hover {\n  background-color: #f3d800;\n  color: #fff;\n  -webkit-box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n}\n\n.error .btn-adnc-serc {\n  background-color: #2a3142;\n  color: #fff;\n}\n\n.error .btn-adnc-serc:hover {\n  background-color: #f3d800;\n  color: #fff;\n  -webkit-box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n  box-shadow: 0 20px 35px 0 rgba(0, 0, 0, 0.21);\n}\n\n/**=====================\n     09. Error-page CSS Ends\n==========================**/\n/**=====================\n    10.  ICON CSS Start\n==========================**/\n.icons-page .notify-alert {\n  width: auto !important;\n  min-width: 170px;\n  padding: 7px 40px 7px 30px;\n  letter-spacing: 1.5px;\n  font-weight: 600;\n  background-color: #ab8ce4;\n}\n\n.icons-page .notify-alert button {\n  top: 3px !important;\n  color: #fff;\n}\n\n.icon-lists div {\n  cursor: pointer;\n  line-height: 60px;\n  white-space: nowrap;\n  border-radius: 4px;\n  font-family: Raleway;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.icon-lists div:hover {\n  background-color: #fafafa;\n}\n\n.icon-lists div i {\n  margin: 0 15px 0 10px;\n  font-size: 30px;\n  color: #717171;\n}\n\n.icon-lists.whether-icon svg {\n  height: 50px;\n  width: 50px;\n}\n\n.flag-icons {\n  margin-bottom: -15px;\n  margin-top: -15px;\n}\n\n.flag-icons div {\n  line-height: 1;\n  word-wrap: break-word;\n  overflow: auto;\n  font-family: Raleway;\n}\n\n.flag-icons div .flag-icon {\n  height: 50px;\n  width: 50px;\n}\n\n.flag-icons div .media {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.flag-icons div .media-body h6 {\n  margin-bottom: 0;\n  font-size: 14px;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.flag-icons div .media-body h5 {\n  background-color: #ab8ce4;\n  display: inline-block;\n  padding: 3px 5px;\n  font-size: 11px;\n  border-radius: 3px;\n  margin-bottom: 5px;\n  color: #fff;\n}\n\n.icon-hover-bottom {\n  background-color: #f6f6f6;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  -webkit-box-shadow: 0px 0px 1px 1px #eeeeee;\n  box-shadow: 0px 0px 1px 1px #eeeeee;\n  z-index: 999;\n}\n\n.icon-hover-bottom .icon-popup {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 100%;\n  padding: 20px;\n}\n\n.icon-hover-bottom .icon-popup .close-icon {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 20px;\n  color: #999999;\n  cursor: pointer;\n}\n\n.icon-hover-bottom .icon-popup>div {\n  display: inline-block;\n  font-family: Raleway;\n}\n\n.icon-hover-bottom .icon-popup>div .flag-icon {\n  width: 60px;\n  height: 60px;\n}\n\n.icon-hover-bottom .icon-popup .icon-class {\n  margin: 0 20px;\n  cursor: pointer;\n  font-family: Raleway;\n}\n\n.icon-hover-bottom .icon-title {\n  display: block;\n  color: #2a3142;\n  text-transform: uppercase;\n  font-weight: 500;\n  font-family: Raleway;\n}\n\n.icon-hover-bottom .form-group input {\n  min-width: 300px;\n  background-color: #fff;\n}\n\n.fa-fa-icon-show-div,\n.icons-show-div {\n  display: none;\n}\n\n.icon-first i {\n  color: #717171;\n}\n\n/**=====================\n    10.  ICON CSS Ends\n==========================**/\n/**=====================\n     11. Form Builder 1 CSS Start\n==========================**/\n.form-builder .drag-box {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.form-builder .drag-box fieldset {\n  border: 1px dotted #cccccc;\n  min-height: 655px;\n  padding: 30px;\n  width: 100%;\n  overflow: hidden;\n  margin-top: 30px;\n  border-radius: 4px;\n}\n\n.form-builder .component {\n  cursor: pointer;\n}\n\n.form-builder .component label {\n  padding-top: 8px;\n}\n\n.form-builder .component .form-group input,\n.form-builder .component .form-group textarea,\n.form-builder .component .form-group select {\n  border-radius: 4px;\n}\n\n.form-builder .component .form-group .input-group #prependedcheckbox,\n.form-builder .component .form-group .input-group #prependedtext {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-builder .component .form-group .input-group #appendedcheckbox {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right-color: transparent;\n}\n\n.form-builder .component .form-group .input-group #appendedtext,\n.form-builder .component .form-group .input-group #buttondropdown {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.form-builder .component .form-group .input-group #buttondropdown {\n  margin-right: -1px;\n}\n\n.form-builder .component .form-group .input-group .input-group-btn button {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-builder .component .form-group .input-group .input-group-prepend .btn-right,\n.form-builder .component .form-group .input-group .input-group-prepend .checkbox-radius {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-builder .component .form-group .pl-md-radios {\n  padding-left: 37px;\n}\n\n.form-builder input {\n  cursor: pointer;\n}\n\n.form-builder textarea {\n  resize: vertical;\n}\n\n.form-builder .popover {\n  z-index: 8;\n  opacity: 1;\n  left: -290px !important;\n  top: 95px !important;\n}\n\n.form-builder .popover .control-group {\n  cursor: default;\n}\n\n.form-builder .popover input {\n  cursor: pointer;\n}\n\n.form-builder .render {\n  min-height: 500px;\n  width: 100%;\n  border-radius: 4px;\n}\n\n.form-builder .popover .controls {\n  margin-left: 0;\n}\n\n.form-builder .popover .control-label {\n  text-align: left;\n}\n\n.form-builder .popover form {\n  width: 100%;\n}\n\n.form-builder .popover .fade.left.in {\n  left: -215px;\n}\n\n.form-builder .target:after {\n  float: left;\n  content: \" \";\n  height: 77px;\n  margin-top: 3px;\n  background: #eeeeee;\n  width: 100%;\n  border: 1px dashed #cccccc;\n}\n\n.drag form {\n  padding: 10px 5px;\n  border: 1px dotted #cccccc;\n  position: absolute;\n  background: #fff;\n  -webkit-box-shadow: 0 0 30px #cccccc;\n  box-shadow: 0 0 30px #cccccc;\n  overflow: hidden;\n}\n\n.drag form input {\n  border-radius: 5px;\n}\n\n.form-builder-header-1 {\n  background-color: #eeeeee;\n  padding: 15px;\n  border-radius: 5px;\n  min-height: 67px;\n}\n\n.form-builder-header-1 h6 {\n  margin-bottom: 0;\n  margin-top: 10px;\n}\n\n.form-builder .help-block {\n  font-size: 12px;\n}\n\n.form-builder input {\n  border-radius: 4px !important;\n}\n\n.form-builder .form-group .col-md-12 {\n  padding: 0;\n}\n\n.form-builder .popover {\n  width: 300px;\n}\n\n.form-builder .popover-header {\n  background-color: #ab8ce4;\n  padding: 15px;\n}\n\n.form-builder .popover-body {\n  padding: 15px;\n}\n\n/**=====================\n    11. Form Builder 1 CSS Ends\n==========================**/\n/**=====================\n     12. Form Builder 2 CSS Start\n==========================**/\n.form-builder-column #pills-tabContent .theme-form .form-group,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable {\n  margin-bottom: 0 !important;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group .checkbox label,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable .checkbox label {\n  margin-top: 0;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group input,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable input {\n  border-radius: 4px;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group .input-group #prependedcheckbox,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group #prependedcheckbox {\n  margin-right: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group .input-group input,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group input {\n  margin-right: 15px;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-prepend .input-group-text input,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-prepend .input-group-text input {\n  margin-right: 0;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-btn button,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-btn button {\n  border-radius: 4px;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group select,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable select {\n  border-radius: 4px;\n}\n\n.form-builder-column #pills-tabContent .theme-form .form-group .m-t-help-block,\n.form-builder-column #pills-tabContent .theme-form .ui-draggable .m-t-help-block {\n  margin-top: -3px;\n}\n\n.form-builder-column #pills-tabContent #pills-button .theme-form button {\n  margin-bottom: 6px;\n}\n\n.form-builder-column .droppable-active {\n  background-color: #ab8ce4 !important;\n  opacity: 0.1;\n}\n\n.form-builder-column .form-body {\n  min-height: 540px;\n}\n\n.form-builder-column .draggable {\n  cursor: move;\n}\n\n.form-builder-column .drag-bx {\n  border: 1px dotted #cccccc;\n  border-radius: 4px;\n}\n\n.form-builder-column .help-block {\n  color: #cccccc;\n}\n\n.form-builder-column .tools a {\n  cursor: pointer;\n  font-size: 80%;\n}\n\n.form-builder-2 .form-group {\n  margin-bottom: 0 !important;\n}\n\n.form-builder-2 .form-group .checkbox label {\n  margin-top: 0;\n}\n\n.form-builder-2 .form-group input {\n  border-radius: 4px;\n}\n\n.form-builder-2 .form-group .input-group #prependedcheckbox {\n  margin-right: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.form-builder-2 .form-group .input-group input {\n  margin-right: 15px;\n}\n\n.form-builder-2 .form-group .input-group .input-group-prepend .input-group-text input {\n  margin-right: 0;\n}\n\n.form-builder-2 .form-group .input-group .input-group-btn button {\n  border-radius: 4px;\n}\n\n.form-builder-2 .form-group select {\n  border-radius: 4px;\n}\n\n.form-builder-2 .form-group .m-t-help-block {\n  margin-top: -3px;\n}\n\n.form-builder-2-header {\n  background-color: #eeeeee;\n  padding: 15px;\n  border-radius: 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 30px;\n}\n\n.form-builder-2-header>div {\n  display: inline-block;\n  width: 49%;\n}\n\n.form-builder-2-header>div nav {\n  text-align: right;\n  float: right;\n}\n\n.draggable input {\n  border-radius: 5px;\n}\n\n.draggable select {\n  border-radius: 4px;\n}\n\n/**=====================\n     12. Form Builder 2 CSS Ends\n==========================**/\n/**=====================\n    13.  Email Application  CSS Start\n==========================**/\n.email-wrap .row .col-xl-3+.col-xl-3 {\n  padding-right: 0;\n}\n\n.email-wrap .row .col-xl-6 {\n  padding-left: 0;\n}\n\n.email-wrap .email-app-sidebar .media img {\n  border: 2px solid #cccccc;\n}\n\n.email-wrap .email-app-sidebar .main-menu>li {\n  width: 100%;\n  text-align: left;\n}\n\n.email-wrap .email-app-sidebar .main-menu>li a {\n  color: #717171;\n  line-height: 39px;\n  text-transform: uppercase;\n  border-radius: 3px;\n}\n\n.email-wrap .email-app-sidebar .main-menu>li a i {\n  margin-right: 10px;\n}\n\n.email-wrap .email-app-sidebar .main-menu>li a.active>a {\n  color: #000;\n}\n\n.email-wrap .email-app-sidebar .main-menu>li a:hover {\n  background-color: #eeeeee;\n  text-decoration: none;\n}\n\n.email-wrap .email-app-sidebar ul li a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 20px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.email-wrap .email-app-sidebar ul li a>.title {\n  width: 100%;\n}\n\n.email-wrap .email-app-sidebar ul li a>.badge {\n  -ms-flex-item-align: center;\n  align-self: center;\n}\n\n.email-wrap .email-left-aside {\n  float: left;\n  width: 100%;\n}\n\n.email-wrap .email-left-aside .card-body {\n  padding: 20px;\n}\n\n.email-wrap .email-right-aside .email-body {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.email-wrap .email-right-aside .email-body .inbox {\n  overflow: auto;\n}\n\n.email-wrap .email-right-aside .email-body .inbox .media {\n  padding: 20px;\n}\n\n.email-wrap .email-right-aside .email-body .inbox .media.active {\n  background-color: #f8f8f8;\n}\n\n.email-wrap .email-right-aside .radius-left {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n  border-radius: 4px;\n}\n\n.email-wrap .btn-mail {\n  border-radius: 2px;\n  text-align: left;\n  padding: 13px 15px;\n  margin: 20px 0 20px;\n  letter-spacing: 1px;\n  line-height: 12px !important;\n  color: #fff !important;\n}\n\n.email-wrap p {\n  margin-bottom: 0;\n  color: #717171;\n}\n\n.email-wrap .media-body {\n  margin-top: 5px;\n}\n\n.email-wrap .media-body h6 {\n  margin-bottom: 2px;\n  color: #444444;\n  margin-top: 3px;\n}\n\n.email-wrap .media-body h6 small span {\n  color: #777777;\n}\n\n.email-wrap .media-body p {\n  color: #777777;\n  font-size: 12px;\n}\n\n.email-wrap .email-top {\n  padding: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  line-height: 49px;\n}\n\n.email-wrap .email-top h5 {\n  margin-bottom: 0;\n  padding: 12px 0;\n}\n\n.email-wrap .email-top .d-flex {\n  padding: 13px 0;\n}\n\n.email-wrap .email-wrapper {\n  padding: 20px;\n}\n\n.email-wrap .email-wrapper hr {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.email-wrap .email-wrapper .d-inline-block {\n  width: 100%;\n}\n\n.email-wrap .email-wrapper h6 {\n  margin-bottom: 11px;\n  float: left;\n}\n\n.email-wrap .email-wrapper .right-download {\n  float: right;\n}\n\n.email-wrap .email-wrapper p+p {\n  margin-bottom: 20px;\n}\n\n.email-wrap .email-wrapper h5 {\n  margin-bottom: 20px;\n}\n\n.email-wrap .email-content .email-top .user-emailid:after {\n  content: \"\";\n  position: relative;\n  height: 20px;\n  width: 1px;\n  right: 0;\n  top: 3px;\n  z-index: 2;\n  border: 1px solid #ddd;\n  float: right;\n  padding: 0;\n  margin: 0 20px;\n}\n\n.email-wrap .email-body .attachment ul li img {\n  margin-bottom: 20px;\n  width: 117px;\n  height: 117px;\n}\n\n.email-wrap .email-body .attachment .list-inline .list-inline-item {\n  padding-right: 13px;\n}\n\n.email-wrap .email-body .email-compose .cke_contents.cke_reset {\n  max-height: 184px;\n  width: 100%;\n}\n\n.email-wrap .email-body .email-compose .email-top h4 {\n  padding: 11px 0;\n}\n\n.email-wrap .email-body .email-compose .compose-border {\n  margin: -1px;\n}\n\n.email-wrap .email-body .email-compose .compose-border .btn-middle {\n  padding-top: 5px;\n}\n\n.email-wrap .actions li {\n  display: inline-block;\n  margin-right: 25px;\n}\n\n/**=====================\n    13.  Email Application  CSS Ends\n==========================**/\n/**=====================\n     14. Chat CSS Start\n==========================**/\n.chat-box .toogle-bar {\n  display: none;\n}\n\n.chat-box .chat-menu {\n  max-width: 340px;\n}\n\n.chat-box .people-list .search {\n  position: relative;\n}\n\n.chat-box .people-list .search .form-control {\n  background-color: #f7f7f7;\n  border: 1px solid #eeeeee;\n}\n\n.chat-box .people-list .search .form-control::-webkit-input-placeholder {\n  color: #aaaaaa;\n}\n\n.chat-box .people-list .search .form-control:-ms-input-placeholder {\n  color: #aaaaaa;\n}\n\n.chat-box .people-list .search .form-control::-ms-input-placeholder {\n  color: #aaaaaa;\n}\n\n.chat-box .people-list .search .form-control::placeholder {\n  color: #aaaaaa;\n}\n\n.chat-box .people-list .search i {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 14px;\n  color: #cccccc;\n}\n\n.chat-box .people-list ul {\n  padding: 0;\n}\n\n.chat-box .people-list ul li {\n  padding-bottom: 15px;\n}\n\n.chat-box .people-list ul li:last-child {\n  padding-bottom: 0;\n}\n\n.chat-box .user-image {\n  float: left;\n  width: 52px;\n  height: 52px;\n  margin-bottom: 5px;\n  margin-right: 5px;\n}\n\n.chat-box .about {\n  float: left;\n  margin-top: 5px;\n  padding-left: 10px;\n}\n\n.chat-box .about .name {\n  color: #2a3142;\n  letter-spacing: 1px;\n  font-weight: 600;\n}\n\n.chat-box .status {\n  color: #aaaaaa;\n  letter-spacing: 1px;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n.chat-box .status .chat-status {\n  font-weight: 600;\n  color: #333333;\n}\n\n.chat-box .status p {\n  font-size: 14px;\n}\n\n.chat-box .chat-right-aside .chat .chat-header {\n  padding: 15px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.chat-box .chat-right-aside .chat .chat-header img {\n  float: left;\n  width: 50px;\n  height: 50px;\n  -webkit-box-shadow: 1px 1px 4px 1px #cccccc;\n  box-shadow: 1px 1px 4px 1px #cccccc;\n}\n\n.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons {\n  margin-top: 15px;\n}\n\n.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li {\n  margin-right: 24px;\n}\n\n.chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n  color: #777777;\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.chat-box .chat-right-aside .chat .chat-msg-box {\n  padding: 20px;\n  overflow-y: auto;\n  height: 560px;\n  margin-bottom: 90px;\n}\n\n.chat-box .chat-right-aside .chat .chat-msg-box .chat-user-img {\n  margin-top: -35px;\n}\n\n.chat-box .chat-right-aside .chat .chat-msg-box .message-data {\n  margin-bottom: 10px;\n}\n\n.chat-box .chat-right-aside .chat .chat-msg-box .message-data-time {\n  letter-spacing: 1px;\n  font-size: 12px;\n  color: #aaaaaa;\n  font-family: Raleway;\n}\n\n.chat-box .chat-right-aside .chat .chat-msg-box .message {\n  color: #2a3142;\n  padding: 20px;\n  line-height: 1.9;\n  letter-spacing: 1px;\n  font-size: 14px;\n  margin-bottom: 30px;\n  width: 50%;\n  position: relative;\n}\n\n.chat-box .chat-right-aside .chat .chat-msg-box .my-message {\n  border: 1px solid #eeeeee;\n  border-radius: 10px;\n  border-top-left-radius: 0;\n}\n\n.chat-box .chat-right-aside .chat .chat-msg-box .other-message {\n  background-color: #f6f6f6;\n  border-radius: 10px;\n  border-top-right-radius: 0;\n}\n\n.chat-box .chat-right-aside .chat .chat-message {\n  padding: 20px;\n  border-top: 1px solid #f7f7f7;\n  position: absolute;\n  width: calc(100% - 15px);\n  background-color: #fff;\n  bottom: 0;\n}\n\n.chat-box .chat-right-aside .chat .chat-message .smiley-box {\n  background: #ddd;\n  padding: 10px;\n  display: block;\n  border-radius: 4px;\n  margin-right: 0.5rem;\n}\n\n.chat-box .chat-right-aside .chat .chat-message .text-box {\n  position: relative;\n}\n\n.chat-box .chat-right-aside .chat .chat-message .text-box .input-txt-bx {\n  height: 50px;\n  border: 2px solid #ab8ce4;\n  padding-left: 18px;\n  font-size: 12px;\n  letter-spacing: 1px;\n}\n\n.chat-box .chat-right-aside .chat .chat-message .text-box i {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  font-size: 20px;\n  color: #cccccc;\n  cursor: pointer;\n}\n\n.chat-box .chat-right-aside .chat .chat-message .text-box .btn {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.chat-box .chat-menu {\n  border-left: 1px solid #eeeeee;\n}\n\n.chat-box .chat-menu .tab-pane {\n  padding: 0 15px;\n}\n\n.chat-box .chat-menu ul li .about .status i {\n  font-size: 10px;\n}\n\n.chat-box .chat-menu .user-profile {\n  margin-top: 30px;\n}\n\n.chat-box .chat-menu .user-profile .user-content h5 {\n  margin: 25px 0;\n}\n\n.chat-box .chat-menu .user-profile .user-content hr {\n  margin: 25px 0;\n}\n\n.chat-box .chat-menu .user-profile .user-content p {\n  font-size: 16px;\n}\n\n.chat-box .chat-menu .user-profile .image {\n  position: relative;\n}\n\n.chat-box .chat-menu .user-profile .image .icon-wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 55%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n  overflow: hidden;\n  margin: 0 auto;\n  font-size: 14px;\n  -webkit-box-shadow: 1px 1px 3px 1px #eeeeee;\n  box-shadow: 1px 1px 3px 1px #eeeeee;\n}\n\n.chat-box .chat-menu .user-profile .image .avatar img {\n  border-radius: 50%;\n  border: 5px solid #eeeeee;\n}\n\n.chat-box .chat-menu .user-profile .border-right {\n  border-right: 1px solid #eeeeee;\n}\n\n.chat-box .chat-menu .user-profile .follow {\n  margin-top: 0;\n}\n\n.chat-box .chat-menu .user-profile .follow .follow-num {\n  font-size: 22px;\n  color: #000;\n}\n\n.chat-box .chat-menu .user-profile .follow span {\n  color: #444444;\n  font-size: 14px;\n  letter-spacing: 1px;\n}\n\n.chat-box .chat-menu .user-profile .social-media a {\n  color: #aaaaaa;\n  font-size: 15px;\n  padding: 0 7px;\n}\n\n.chat-box .chat-menu .user-profile .chat-profile-contact p {\n  font-size: 14px;\n  color: #aaaaaa;\n}\n\n.chat-box .chat-menu .nav {\n  margin-bottom: 20px;\n}\n\n.chat-box .chat-menu .nav-tabs .nav-item {\n  width: 33.33%;\n}\n\n.chat-box .chat-menu .nav-tabs .nav-item a {\n  padding: 15px !important;\n  color: #aaaaaa !important;\n  letter-spacing: 1px;\n  font-size: 14px;\n  font-weight: 600;\n  height: 80px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.chat-box .chat-menu .nav-tabs .nav-item .material-border {\n  border-width: 1px;\n  border-color: #ab8ce4;\n}\n\n.chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {\n  color: #000 !important;\n}\n\n.chat-box .chat-history .call-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-width: 300px;\n}\n\n.chat-box .chat-history .total-time h2 {\n  font-size: 50px;\n  color: #ddd;\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n\n.chat-box .chat-history .receiver-img {\n  margin-top: 55px;\n}\n\n.chat-box .chat-history .receiver-img img {\n  border-radius: 5px;\n}\n\n.chat-box .chat-history .call-icons {\n  margin-bottom: 35px;\n}\n\n.chat-box .chat-history .call-icons ul li {\n  width: 60px;\n  height: 60px;\n  border: 1px solid #eeeeee;\n  border-radius: 50%;\n  padding: 12px;\n}\n\n.chat-box .chat-history .call-icons ul li+li {\n  margin-left: 10px;\n}\n\n.chat-box .chat-history .call-icons ul li a {\n  color: #999;\n  font-size: 25px;\n}\n\n.chat-left-aside>.media {\n  margin-bottom: 15px;\n}\n\n.chat-left-aside .people-list {\n  height: 625px;\n}\n\n.chat-left-aside ul li {\n  position: relative;\n}\n\n.chat-left-aside .status-circle {\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  border-radius: 50%;\n  border: 1px solid #fff;\n}\n\n.chat-left-aside .away {\n  background-color: #f3d800;\n}\n\n.chat-left-aside .online {\n  background-color: #00c292;\n}\n\n.chat-left-aside .offline {\n  background-color: #FF5370;\n}\n\n.chat-container .aside-chat-left {\n  width: 320px;\n}\n\n.chat-container .chat-right-aside {\n  width: 320px;\n}\n\n.call-chat-sidebar {\n  max-width: 320px;\n}\n\n.call-chat-sidebar .card .card-body,\n.chat-body .card .card-body {\n  padding: 15px;\n}\n\n/**=====================\n    14.  Chat CSS Ends\n==========================**/\n/**=====================\n     15. Alert CSS start\n==========================**/\n.alert-dismissible .close {\n  padding: 10px 1.25rem;\n  top: 2px;\n}\n\n.alert-dismissible .close:hover {\n  color: #2a3142;\n}\n\n.card-body .alert:last-child {\n  margin-bottom: 0;\n}\n\n.alert-primary {\n  background-color: rgba(171, 140, 228, 0.8);\n  border-color: rgba(171, 140, 228, 0.9);\n  color: #fff;\n}\n\n.alert-primary .progress {\n  height: 5px;\n  background-color: #a888e3;\n  border-radius: 0;\n}\n\n.alert-primary .progress-bar {\n  background-color: white;\n}\n\n.alert-primary .alert-link {\n  color: #ab8ce4;\n}\n\n.alert-primary hr {\n  border-top-color: #ab8ce4;\n}\n\n.alert-primary.dark {\n  background-color: #ab8ce4 !important;\n  border-color: #ab8ce4 !important;\n  color: #fafafa;\n}\n\n.alert-primary.dark .alert-link {\n  color: #fff;\n}\n\n.alert-primary.outline,\n.alert-primary.outline-2x {\n  background-color: transparent !important;\n  border-color: #ab8ce4 !important;\n  color: #ab8ce4;\n}\n\n.alert-primary.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #ab8ce4;\n  color: #333333;\n}\n\n.alert-primary.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #ab8ce4;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-primary.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #ab8ce4 !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.alert-secondary {\n  background-color: rgba(38, 198, 218, 0.8);\n  border-color: rgba(38, 198, 218, 0.9);\n  color: #fff;\n}\n\n.alert-secondary .progress {\n  height: 5px;\n  background-color: #25c3d6;\n  border-radius: 0;\n}\n\n.alert-secondary .progress-bar {\n  background-color: white;\n}\n\n.alert-secondary .alert-link {\n  color: #26c6da;\n}\n\n.alert-secondary hr {\n  border-top-color: #26c6da;\n}\n\n.alert-secondary.dark {\n  background-color: #26c6da !important;\n  border-color: #26c6da !important;\n  color: #fafafa;\n}\n\n.alert-secondary.dark .alert-link {\n  color: #fff;\n}\n\n.alert-secondary.outline,\n.alert-secondary.outline-2x {\n  background-color: transparent !important;\n  border-color: #26c6da !important;\n  color: #26c6da;\n}\n\n.alert-secondary.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #26c6da;\n  color: #333333;\n}\n\n.alert-secondary.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #26c6da;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-secondary.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #26c6da !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.alert-success {\n  background-color: rgba(0, 194, 146, 0.8);\n  border-color: rgba(0, 194, 146, 0.9);\n  color: #fff;\n}\n\n.alert-success .progress {\n  height: 5px;\n  background-color: #00bd8e;\n  border-radius: 0;\n}\n\n.alert-success .progress-bar {\n  background-color: #c2fff0;\n}\n\n.alert-success .alert-link {\n  color: #00c292;\n}\n\n.alert-success hr {\n  border-top-color: #00c292;\n}\n\n.alert-success.dark {\n  background-color: #00c292 !important;\n  border-color: #00c292 !important;\n  color: #fafafa;\n}\n\n.alert-success.dark .alert-link {\n  color: #fff;\n}\n\n.alert-success.outline,\n.alert-success.outline-2x {\n  background-color: transparent !important;\n  border-color: #00c292 !important;\n  color: #00c292;\n}\n\n.alert-success.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #00c292;\n  color: #333333;\n}\n\n.alert-success.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #00c292;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-success.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #00c292 !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.alert-danger {\n  background-color: rgba(255, 83, 112, 0.8);\n  border-color: rgba(255, 83, 112, 0.9);\n  color: #fff;\n}\n\n.alert-danger .progress {\n  height: 5px;\n  background-color: #ff4e6c;\n  border-radius: 0;\n}\n\n.alert-danger .progress-bar {\n  background-color: white;\n}\n\n.alert-danger .alert-link {\n  color: #FF5370;\n}\n\n.alert-danger hr {\n  border-top-color: #FF5370;\n}\n\n.alert-danger.dark {\n  background-color: #FF5370 !important;\n  border-color: #FF5370 !important;\n  color: #fafafa;\n}\n\n.alert-danger.dark .alert-link {\n  color: #fff;\n}\n\n.alert-danger.outline,\n.alert-danger.outline-2x {\n  background-color: transparent !important;\n  border-color: #FF5370 !important;\n  color: #FF5370;\n}\n\n.alert-danger.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #FF5370;\n  color: #333333;\n}\n\n.alert-danger.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #FF5370;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-danger.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #FF5370 !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.alert-warning {\n  background-color: rgba(243, 216, 0, 0.8);\n  border-color: rgba(243, 216, 0, 0.9);\n  color: #fff;\n}\n\n.alert-warning .progress {\n  height: 5px;\n  background-color: #eed300;\n  border-radius: 0;\n}\n\n.alert-warning .progress-bar {\n  background-color: #fffef3;\n}\n\n.alert-warning .alert-link {\n  color: #f3d800;\n}\n\n.alert-warning hr {\n  border-top-color: #f3d800;\n}\n\n.alert-warning.dark {\n  background-color: #f3d800 !important;\n  border-color: #f3d800 !important;\n  color: #fafafa;\n}\n\n.alert-warning.dark .alert-link {\n  color: #fff;\n}\n\n.alert-warning.outline,\n.alert-warning.outline-2x {\n  background-color: transparent !important;\n  border-color: #f3d800 !important;\n  color: #f3d800;\n}\n\n.alert-warning.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #f3d800;\n  color: #333333;\n}\n\n.alert-warning.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #f3d800;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-warning.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #f3d800 !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.alert-info {\n  background-color: rgba(64, 153, 255, 0.8);\n  border-color: rgba(64, 153, 255, 0.9);\n  color: #fff;\n}\n\n.alert-info .progress {\n  height: 5px;\n  background-color: #3b96ff;\n  border-radius: 0;\n}\n\n.alert-info .progress-bar {\n  background-color: white;\n}\n\n.alert-info .alert-link {\n  color: #4099ff;\n}\n\n.alert-info hr {\n  border-top-color: #4099ff;\n}\n\n.alert-info.dark {\n  background-color: #4099ff !important;\n  border-color: #4099ff !important;\n  color: #fafafa;\n}\n\n.alert-info.dark .alert-link {\n  color: #fff;\n}\n\n.alert-info.outline,\n.alert-info.outline-2x {\n  background-color: transparent !important;\n  border-color: #4099ff !important;\n  color: #4099ff;\n}\n\n.alert-info.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #4099ff;\n  color: #333333;\n}\n\n.alert-info.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #4099ff;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-info.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #4099ff !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.alert-light {\n  background-color: rgba(238, 238, 238, 0.8);\n  border-color: rgba(238, 238, 238, 0.9);\n  color: #fff;\n  color: #2a3142;\n  background-color: #eeeeee;\n}\n\n.alert-light .progress {\n  height: 5px;\n  background-color: #ebebeb;\n  border-radius: 0;\n}\n\n.alert-light .progress-bar {\n  background-color: white;\n}\n\n.alert-light .alert-link {\n  color: #eeeeee;\n  color: #2a3142;\n}\n\n.alert-light hr {\n  border-top-color: #eeeeee;\n}\n\n.alert-light.dark {\n  background-color: #eeeeee !important;\n  border-color: #eeeeee !important;\n  color: #fafafa;\n  color: #2a3142;\n}\n\n.alert-light.dark .alert-link {\n  color: #fff;\n  color: #2a3142;\n}\n\n.alert-light.outline,\n.alert-light.outline-2x {\n  background-color: transparent !important;\n  border-color: #eeeeee !important;\n  color: #eeeeee;\n  color: #2a3142;\n}\n\n.alert-light.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #eeeeee;\n  color: #333333;\n}\n\n.alert-light.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #eeeeee;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-light.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #eeeeee !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.alert-dark {\n  background-color: rgba(42, 49, 66, 0.8);\n  border-color: rgba(42, 49, 66, 0.9);\n  color: #fff;\n}\n\n.alert-dark .progress {\n  height: 5px;\n  background-color: #282f3f;\n  border-radius: 0;\n}\n\n.alert-dark .progress-bar {\n  background-color: #a5afc6;\n}\n\n.alert-dark .alert-link {\n  color: #2a3142;\n}\n\n.alert-dark hr {\n  border-top-color: #2a3142;\n}\n\n.alert-dark.dark {\n  background-color: #2a3142 !important;\n  border-color: #2a3142 !important;\n  color: #fafafa;\n}\n\n.alert-dark.dark .alert-link {\n  color: #fff;\n}\n\n.alert-dark.outline,\n.alert-dark.outline-2x {\n  background-color: transparent !important;\n  border-color: #2a3142 !important;\n  color: #2a3142;\n}\n\n.alert-dark.inverse {\n  background-color: transparent;\n  padding: 13px 20px 13px 65px;\n  border-color: #2a3142;\n  color: #333333;\n}\n\n.alert-dark.inverse:before {\n  top: 16px;\n  content: \"\";\n  position: absolute;\n  left: 54px;\n  width: 0;\n  height: 0;\n  border-left: 7px solid #2a3142;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.alert-dark.inverse i {\n  padding: 17px 20px;\n  display: inline-block;\n  background-color: #2a3142 !important;\n  color: #fff;\n  border-radius: 3px 0 0 3px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n\n.outline-2x {\n  border-width: 2px;\n  padding: 11px 1.25rem;\n}\n\n.alert {\n  border-radius: 0.15rem;\n  padding: 15px;\n}\n\n.alert .progress {\n  margin-top: 15px;\n}\n\n.alert [data-notify='message'] {\n  display: block;\n}\n\n.alert i {\n  margin-right: 5px;\n  font-size: 16px;\n}\n\n.alert p {\n  margin-bottom: 0;\n}\n\n.alert .close {\n  opacity: 1;\n}\n\n.alert .close span {\n  font-size: 24px;\n  font-weight: 400;\n  display: inline-block;\n  border-radius: 3px;\n  text-shadow: none;\n  padding: 0 5px;\n}\n\n/**=====================\n     15. Alert CSS end\n==========================**/\n/**=====================\n     16. Popover CSS Start\n==========================**/\n.popover-header {\n  background-color: #2a3142;\n  color: #fff;\n}\n\n.popover-main .btn-showcase a {\n  color: #fff;\n}\n\n.popover-main .btn-showcase button:last-child {\n  margin-right: 0;\n}\n\n/**=====================\n     16. Popover CSS Ends\n==========================**/\n/**=====================\n     17. List CSS Start\n==========================**/\n.list-group-item.active {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n}\n\n.list-group i {\n  margin-right: 10px;\n}\n\n.list-group img {\n  height: 40px;\n  width: 40px;\n  margin-right: 10px;\n}\n\n/**=====================\n     17. List CSS Ends\n==========================**/\n/**=====================\n    18. Switch  CSS Start\n==========================**/\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.switch input {\n  display: none;\n}\n\n.switch input:checked+.switch-state {\n  background-color: #ab8ce4;\n}\n\n.switch input:checked+.switch-state:before {\n  -webkit-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n.switch input:focus+.switch-state {\n  -webkit-box-shadow: 0 0 1px #ab8ce4;\n  box-shadow: 0 0 1px #ab8ce4;\n}\n\n.switch-state {\n  border-radius: 20px;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #eeeeee;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.switch-state:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: #fff;\n  -webkit-transition: .4s;\n  transition: .4s;\n  border-radius: 20px;\n}\n\n.icon-state .switch-state:after {\n  content: \"\\efb8\";\n  font-family: IcoFont;\n  left: 10px;\n  position: absolute;\n  top: 11px;\n  color: #2a3142;\n  -webkit-transition: .4s;\n  transition: .4s;\n  opacity: 0.3;\n}\n\n.icon-state input:checked+.switch-state:after {\n  content: \"\\efad\";\n  left: 35px;\n  opacity: 1;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.switch-lg .switch {\n  width: 75px;\n  height: 40px;\n}\n\n.switch-lg .switch .switch-state:before {\n  height: 30px;\n  width: 30px;\n  left: 7px;\n  bottom: 5px;\n  top: 4px;\n}\n\n.switch-sm .switch {\n  width: 25px;\n  height: 16px;\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\n.switch-sm .switch .switch-state:before {\n  height: 8px;\n  width: 8px;\n  left: 4px;\n  bottom: 4px;\n}\n\n.switch-sm input:checked+.switch-state:before {\n  left: -13px;\n}\n\n.switch-lg.icon-state .switch .switch-state:after {\n  left: 12px;\n  font-size: 18px;\n}\n\n.switch-lg.icon-state .switch input:checked+.switch-state:after {\n  left: 47px;\n}\n\n.switch-lg.icon-state .switch input:checked+.switch-state:before {\n  -webkit-transform: translateX(32px);\n  transform: translateX(32px);\n}\n\n.switch-sm.icon-state .switch .switch-state:after {\n  top: 4px;\n  left: 4px;\n  font-size: 8px;\n}\n\n.switch-sm.icon-state .switch input:checked+.switch-state:after {\n  left: 13px;\n  top: 4px;\n}\n\n.switch-outline .switch-state {\n  background-color: #fff;\n  border: 1px solid #ab8ce4;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.switch-outline .switch-state:before {\n  background-color: #eeeeee;\n  bottom: 3px;\n  color: #fff;\n}\n\n.switch-outline .switch input {\n  display: none;\n}\n\n.switch-outline .switch input:checked+.switch-state {\n  background-color: transparent;\n  border: 1px solid #ab8ce4;\n}\n\n.switch-outline .switch input:checked+.switch-state:before {\n  background-color: #ab8ce4;\n  bottom: 3px;\n  -webkit-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n.switch-outline .switch input:checked+.switch-state:after {\n  color: #fff;\n}\n\n.switch-outline .switch-state.bg-primary {\n  border: 1px solid #ab8ce4;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-primary {\n  background-color: transparent !important;\n  border: 1px solid #ab8ce4;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-primary:before {\n  background-color: #ab8ce4;\n}\n\n.switch-outline .switch-state.bg-dark {\n  border: 1px solid #2a3142;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-dark {\n  background-color: transparent !important;\n  border: 1px solid #2a3142;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-dark:before {\n  background-color: #2a3142;\n}\n\n.switch-outline .switch-state.bg-warning {\n  border: 1px solid #f3d800;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-warning {\n  background-color: transparent !important;\n  border: 1px solid #f3d800;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-warning:before {\n  background-color: #f3d800;\n}\n\n.switch-outline .switch-state.bg-success {\n  border: 1px solid #00c292;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-success {\n  background-color: transparent !important;\n  border: 1px solid #00c292;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-success:before {\n  background-color: #00c292;\n}\n\n.switch-outline .switch-state.bg-info {\n  border: 1px solid #4099ff;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-info {\n  background-color: transparent !important;\n  border: 1px solid #4099ff;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-info:before {\n  background-color: #4099ff;\n}\n\n.switch-outline .switch-state.bg-danger {\n  border: 1px solid #FF5370;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-danger {\n  background-color: transparent !important;\n  border: 1px solid #FF5370;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-danger:before {\n  background-color: #FF5370;\n}\n\n.switch-outline .switch-state.bg-primary {\n  border: 1px solid #ab8ce4;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-primary {\n  background-color: transparent !important;\n  border: 1px solid #ab8ce4;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-primary:before {\n  background-color: #ab8ce4;\n}\n\n.switch-outline .switch-state.bg-secondary {\n  border: 1px solid #26c6da;\n  background-color: transparent !important;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-secondary {\n  background-color: transparent !important;\n  border: 1px solid #26c6da;\n}\n\n.switch-outline .switch input:checked+.switch-state.bg-secondary:before {\n  background-color: #26c6da;\n}\n\n.switch-showcase {\n  margin-bottom: -8px;\n}\n\n.switch-showcase .media {\n  line-height: 1;\n}\n\n/**=====================\n     18. Switch  CSS Ends\n==========================**/\n/**=====================\n   19. Mega option CSS Start\n==========================**/\n.mega-inline {\n  margin-bottom: -30px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.mega-inline .mega-title-badge {\n  display: table;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.mega-inline .media .radio {\n  margin-left: 3px;\n}\n\n.mega-vertical {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.mega-vertical .mega-title-badge {\n  display: table;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.mega-vertical .media .radio {\n  margin-left: 3px;\n}\n\n.mega-title {\n  font-weight: 600;\n}\n\n.mega-horizontal {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.mega-horizontal .mega-title-badge {\n  display: table;\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.mega-horizontal .media .radio {\n  margin-left: 3px;\n}\n\n.plain-style .card {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.border-style .card {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px solid #cccccc;\n}\n\n.offer-style .card {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px dashed #cccccc;\n}\n\n.rating-star-wrapper {\n  color: #ddd;\n}\n\n/**=====================\n     19. Mega option CSS Ends\n==========================**/\n/**=====================\n    20.  Touchspin  CSS Start\n==========================**/\n.bootstrap-touchspin .touchspin-vertical-tab .input-group {\n  width: 98% !important;\n}\n\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical {\n  position: relative;\n  white-space: nowrap;\n  width: 1%;\n  vertical-align: middle;\n  display: table-cell;\n}\n\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical .bootstrap-touchspin-down {\n  margin-top: -2px;\n}\n\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical i {\n  position: absolute;\n  top: 5px;\n  left: 7px;\n  font-size: 10px;\n  font-weight: normal;\n}\n\n.bootstrap-touchspin .touchspin-vertical-tab .input-group .input-group-btn-vertical>.btn {\n  display: block;\n  float: none;\n  width: 100%;\n  max-width: 100%;\n  padding: 10px;\n  margin-left: -1px;\n  position: relative;\n}\n\n.bootstrap-touchspin .input-group {\n  font-family: Open Sans;\n}\n\n.bootstrap-touchspin .input-group .btn {\n  border-radius: 0;\n}\n\n.bootstrap-touchspin .dropdown-basic .dropdown .dropbtn {\n  padding: 12px 30px;\n}\n\n.bootstrap-touchspin .dropdown-basic .dropdown .dropdown-content {\n  z-index: 9999;\n}\n\n/**=====================\n     20. Touchspin  CSS Ends\n==========================**/\n/**=====================\n     21. Select 2 CSS Start\n==========================**/\n.select2-drpdwn .select2-selection {\n  border-radius: 0 !important;\n  border-color: #eeeeee !important;\n  height: 40px !important;\n  padding: 5px;\n}\n\n.select2-drpdwn .form-control {\n  border-radius: 5px;\n}\n\n.select2-drpdwn .form-control-primary {\n  border-color: #ab8ce4;\n  color: #ab8ce4;\n}\n\n.select2-drpdwn .form-control-secondary {\n  border-color: #26c6da;\n  color: #26c6da;\n}\n\n.select2-drpdwn .form-control-success {\n  border-color: #00c292;\n  color: #00c292;\n}\n\n.select2-drpdwn .form-control-info {\n  border-color: #4099ff;\n  color: #4099ff;\n}\n\n.select2-drpdwn .form-control-warning {\n  border-color: #f3d800;\n  color: #f3d800;\n}\n\n.select2-drpdwn .form-control-danger {\n  border-color: #FF5370;\n  color: #FF5370;\n}\n\n.select2-drpdwn .form-control-inverse {\n  border-color: #2a3142;\n  color: #2a3142;\n}\n\n.select2-drpdwn .form-control-primary-fill {\n  background-color: #ab8ce4;\n  color: #fff;\n}\n\n.select2-drpdwn .form-control-secondary-fill {\n  background-color: #26c6da;\n  color: #fff;\n}\n\n.select2-drpdwn .form-control-success-fill {\n  background-color: #00c292;\n  color: #fff;\n}\n\n.select2-drpdwn .form-control-info-fill {\n  background-color: #4099ff;\n  color: #fff;\n}\n\n.select2-drpdwn .form-control-warning-fill {\n  background-color: #f3d800;\n  color: #fff;\n}\n\n.select2-drpdwn .form-control-danger-fill {\n  background-color: #FF5370;\n  color: #fff;\n}\n\n.select2-drpdwn .form-control-inverse-fill {\n  background-color: #2a3142;\n  color: #fff;\n}\n\n.selection .select2-selection {\n  font-family: Open Sans;\n  border-radius: 5px !important;\n}\n\n.selection .select2-selection .select2-search__field {\n  margin-top: 0;\n  padding: 3px;\n}\n\n.select2-container--classic .select2-selection--multiple .select2-selection__choice {\n  padding: 2px 6px !important;\n  margin-top: 0 !important;\n  background-color: #ab8ce4 !important;\n  border-color: #8d63da !important;\n  color: #fff;\n  margin-right: 8px !important;\n}\n\n.select2-container--classic .select2-selection--multiple .select2-selection__choice__remove {\n  color: #fff !important;\n  float: right;\n  margin-left: 0.5rem;\n}\n\n.select2-container--classic .select2-results__option--highlighted[aria-selected] {\n  background-color: #e0e0e0 !important;\n  color: #424242 !important;\n}\n\n.select2-container--classic .select2-results__options .select2-results__option[aria-selected=true] {\n  background-color: #ab8ce4 !important;\n  color: #fff !important;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n  top: 7px !important;\n  right: 10px !important;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  padding: 2px 6px !important;\n  margin-top: 0 !important;\n  background-color: #ab8ce4 !important;\n  border-color: #8d63da !important;\n  color: #fff;\n  margin-right: 8px !important;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n  color: #fff !important;\n  float: right;\n  margin-left: 0.5rem;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #e0e0e0 !important;\n  color: #424242 !important;\n}\n\n.select2-container--default .select2-results__options .select2-results__option[aria-selected=true] {\n  background-color: #ab8ce4 !important;\n  color: #fff !important;\n}\n\n/**=====================\n     21. Select 2 CSS Ends\n==========================**/\n/**=====================\n     22. User profile css start\n==========================**/\n.user-profile .ttl-info h6 {\n  font-size: 12px;\n  color: #aaaaaa;\n}\n\n.user-profile .ttl-info span {\n  font-size: 14px;\n  color: #444444;\n  font-weight: 500;\n}\n\n.user-profile .border-right {\n  border-right: 1px solid #eeeeee;\n}\n\n.user-profile hr {\n  margin: 30px 0;\n}\n\n.user-profile .hovercard .cardheader {\n  background: url(../images/bg-profile.png);\n  background-size: cover;\n  background-position: 10%;\n  height: 470px;\n}\n\n.user-profile .hovercard .user-image {\n  position: relative;\n}\n\n.user-profile .hovercard .user-image .avatar {\n  margin-top: -90px;\n}\n\n.user-profile .hovercard .user-image .avatar img {\n  width: 155px;\n  height: 155px;\n  max-width: 155px;\n  max-height: 155px;\n  border-radius: 50%;\n  border: 10px solid #fff;\n}\n\n.user-profile .hovercard .user-image .icon-wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  background-color: #fff;\n  cursor: pointer;\n  overflow: hidden;\n  margin: 0 auto;\n  font-size: 17px;\n}\n\n.user-profile .hovercard .user-image .icon-wrapper:hover {\n  color: #ab8ce4;\n  font-size: 15px;\n}\n\n.user-profile .hovercard .info {\n  padding: 30px;\n}\n\n.user-profile .hovercard .info .title {\n  margin-bottom: 4px;\n  font-size: 24px;\n  line-height: 1;\n  color: #2a3142;\n  vertical-align: middle;\n}\n\n.user-profile .hovercard .info .title a {\n  color: #444444;\n  font-size: 24px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.user-profile .hovercard .info .desc {\n  overflow: hidden;\n  font-size: 14px;\n  line-height: 20px;\n  color: #aaaaaa;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n}\n\n.user-profile .follow {\n  margin-top: 20px;\n}\n\n.user-profile .follow .follow-num {\n  font-size: 36px;\n  color: #444444;\n  font-family: Open Sans;\n}\n\n.user-profile .follow span {\n  color: #aaaaaa;\n}\n\n.user-profile .profile-img-style {\n  padding: 30px;\n}\n\n.user-profile .profile-img-style .img-container {\n  margin-top: 30px;\n}\n\n.user-profile .profile-img-style .user-name {\n  font-size: 14px;\n  color: #444444;\n  margin: 0;\n  font-weight: 600;\n}\n\n.user-profile .profile-img-style p {\n  line-height: 30px;\n  font-size: 14px;\n  color: #717171;\n  margin-bottom: 0;\n}\n\n.user-profile .profile-img-style .media img {\n  width: 75px;\n}\n\n.user-profile .like-comment a {\n  color: #717171;\n}\n\n.user-profile .like-comment a:hover {\n  color: #FF5370;\n}\n\n.user-profile .like-comment span {\n  font-family: Open Sans;\n}\n\n.user-profile .social-media a {\n  padding: 0 15px;\n  color: #aaaaaa;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.user-profile .social-media a:hover {\n  color: #ab8ce4;\n}\n\n/**=====================\n     22. User profile css Ends\n==========================**/\n/**=====================\n     23. Progress CSS Start\n==========================**/\n.progress-showcase .progress {\n  margin-bottom: 10px;\n}\n\n.progress-showcase .progress:last-child {\n  margin-bottom: 0;\n}\n\n.sm-progress-bar {\n  height: 6px;\n}\n\n.lg-progress-bar {\n  height: 20px;\n}\n\n/**=====================\n     23. Progress CSS Ends\n==========================**/\n/**=====================\n    24. According CSS start\n==========================**/\n.default-according .card {\n  margin-bottom: 0;\n}\n\n.default-according .card+.card {\n  margin-top: 10px;\n}\n\n.default-according .card .btn-link {\n  font-weight: 600;\n  color: #333333;\n}\n\n.default-according .card .btn-link:focus,\n.default-according .card .btn-link:hover {\n  text-decoration: none;\n}\n\n.default-according .card .card-header {\n  padding: 0.75rem 1.25rem;\n}\n\n.default-according .card .card-header i {\n  position: absolute;\n  left: 18px;\n  font-size: 20px;\n  top: 20px;\n}\n\n.default-according .card .card-header h5 {\n  margin-top: 2px;\n}\n\n.default-according.style-1 button {\n  width: 100%;\n  text-align: left;\n}\n\n.default-according.style-1 button[aria-expanded=\"true\"]:before {\n  content: \"\\eb73\";\n  font-family: IcoFont;\n  right: 20px;\n  position: absolute;\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\n\n.default-according.style-1 button[aria-expanded=\"false\"]:before {\n  content: \"\\eb7a\";\n  font-family: IcoFont;\n  right: 20px;\n  position: absolute;\n}\n\n/**=====================\n     24. According CSS Ends\n==========================**/\n/**=====================\n    25. Authentication CSS Start\n==========================**/\n.authentication-main .auth-innerleft,\n.authentication-main .auth-innerright {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 50px 100px;\n}\n\n.authentication-main {\n  background: #fafafa;\n}\n\n.authentication-main .auth-innerleft {\n  background: url(../images/auth-layer.png), #fff;\n  -webkit-box-shadow: 1px 1px 1px 0 #eeeeee;\n  box-shadow: 1px 1px 1px 0 #eeeeee;\n  background-repeat: no-repeat;\n  position: fixed;\n  width: 33.3333333333%;\n  height: 100%;\n}\n\n.authentication-main .auth-innerleft hr {\n  width: 250px;\n}\n\n.authentication-main .auth-innerleft .logo-login {\n  width: 35%;\n}\n\n.authentication-main .auth-innerleft .social-media li {\n  color: #717171;\n  font-size: 18px;\n}\n\n.authentication-main .auth-innerleft .social-media li:hover {\n  color: #26c6da;\n  cursor: pointer;\n}\n\n.authentication-main .auth-innerright {\n  background: #fafafa;\n  -webkit-box-pack: left;\n  -ms-flex-pack: left;\n  justify-content: left;\n}\n\n.authentication-box {\n  width: 645px;\n  z-index: 2;\n}\n\n.authentication-box h3 {\n  color: #2a3142;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n\n.authentication-box h4 {\n  color: #333333;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n\n.authentication-box h6 {\n  color: #777777;\n  letter-spacing: 1px;\n  font-size: 14px;\n}\n\n.auth-bg {\n  background: url(../images/auth-bg-1.jpg);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 50px 100px;\n}\n\n.auth-bg-video {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-height: 100vh;\n  background-color: rgba(255, 255, 255, 0.31);\n  padding: 50px 0;\n}\n\n.auth-bg-video video {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -100;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n  -webkit-transition: 1s opacity;\n  transition: 1s opacity;\n}\n\n.auth-bg-effect {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n\n.auth-bg-effect .first-effect {\n  width: 250px;\n  height: 250px;\n  /* background: url(../images/flower/01.png) no-repeat; */\n  background-size: cover;\n  -webkit-animation: rotate-effect 40s infinite linear;\n  animation: rotate-effect 40s infinite linear;\n  position: absolute;\n  bottom: 130px;\n}\n\n.auth-bg-effect .second-effect {\n  width: 220px;\n  height: 220px;\n  /* background: url(../images/flower/02.png) no-repeat; */\n  background-size: cover;\n  -webkit-animation: rotate-effect 40s infinite linear;\n  animation: rotate-effect 40s infinite linear;\n  position: absolute;\n  bottom: 65px;\n  left: 61%;\n}\n\n.auth-bg-effect .third-effect {\n  width: 200px;\n  height: 200px;\n  /* background: url(../images/flower/03.png) no-repeat; */\n  background-size: cover;\n  -webkit-animation: rotate-effect 40s infinite linear;\n  animation: rotate-effect 40s infinite linear;\n  position: absolute;\n  bottom: 45px;\n  left: 38%;\n}\n\n.auth-bg-effect .fourth-effect {\n  width: 200px;\n  height: 200px;\n  /* background: url(../images/flower/04.png) no-repeat; */\n  background-size: cover;\n  -webkit-animation: rotate-effect 40s infinite linear;\n  animation: rotate-effect 40s infinite linear;\n  position: absolute;\n  bottom: 407px;\n  left: 1%;\n}\n\n.reset-password-box {\n  width: 645px;\n  z-index: 2;\n}\n\n.reset-password-box .card {\n  padding: 30px;\n}\n\n.reset-password-box .theme-form .form-group label {\n  font-size: 12px;\n  color: #777777;\n}\n\n.reset-password-box .theme-form .form-group .form-control {\n  font-size: 18px;\n}\n\n.reset-password-box .theme-form .form-group .btn {\n  font-size: 18px;\n  padding: 6px 24px;\n}\n\n.reset-password-box .theme-form .opt-box {\n  background: #f7f7f7;\n}\n\n.reset-password-box .theme-form .opt-box .opt-text {\n  font-size: 36px;\n  padding: 0;\n}\n\n.reset-password-box .reset-password-link {\n  color: #777777;\n}\n\n.reset-password-box .reset-password-box h6 {\n  letter-spacing: 1px;\n  font-size: 16px;\n}\n\n@-webkit-keyframes rotate-effect {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate-effect {\n  0% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n/**=====================\n    25. Authentication CSS Ends\n==========================**/\n/**=====================\n    26. Form CSS Start\n==========================**/\n.height-35 {\n  height: 35px !important;\n}\n\n.theme-form .form-control :focus {\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(171, 140, 228, 0.05);\n  box-shadow: 0 0 0 0.2rem rgba(171, 140, 228, 0.05);\n}\n\n.theme-form.sm-form .form-group {\n  margin-bottom: 14px;\n}\n\n.theme-form.form {\n  margin-bottom: -20px;\n}\n\n.theme-form .form-group {\n  margin-bottom: 20px;\n}\n\n.theme-form .form-group textarea {\n  border-color: #ddd;\n}\n\n.theme-form .form-group textarea::-webkit-input-placeholder {\n  color: #aaaaaa;\n  font-size: 14px;\n  letter-spacing: 1px;\n  font-weight: 100;\n}\n\n.theme-form .form-group input[type=text],\n.theme-form .form-group input[type=email],\n.theme-form .form-group input[type=search],\n.theme-form .form-group input[type=password],\n.theme-form .form-group input[type=number],\n.theme-form .form-group input[type=tel],\n.theme-form .form-group input[type=date],\n.theme-form .form-group input[type=datetime-local],\n.theme-form .form-group input[type=time],\n.theme-form .form-group input[type=datetime-local],\n.theme-form .form-group input[type=month],\n.theme-form .form-group input[type=week],\n.theme-form .form-group input[type=url],\n.theme-form .form-group input[type=file],\n.theme-form .form-group select {\n  border-color: #ddd;\n  background-color: #fff;\n  font-size: 14px;\n  color: #717171;\n  font-family: Open Sans;\n}\n\n.theme-form .form-group input[type=text]::-webkit-input-placeholder,\n.theme-form .form-group input[type=email]::-webkit-input-placeholder,\n.theme-form .form-group input[type=search]::-webkit-input-placeholder,\n.theme-form .form-group input[type=password]::-webkit-input-placeholder,\n.theme-form .form-group input[type=number]::-webkit-input-placeholder,\n.theme-form .form-group input[type=tel]::-webkit-input-placeholder,\n.theme-form .form-group input[type=date]::-webkit-input-placeholder,\n.theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\n.theme-form .form-group input[type=time]::-webkit-input-placeholder,\n.theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\n.theme-form .form-group input[type=month]::-webkit-input-placeholder,\n.theme-form .form-group input[type=week]::-webkit-input-placeholder,\n.theme-form .form-group input[type=url]::-webkit-input-placeholder,\n.theme-form .form-group input[type=file]::-webkit-input-placeholder,\n.theme-form .form-group select::-webkit-input-placeholder {\n  color: #717171;\n  font-size: 14px;\n  letter-spacing: 1px;\n  font-weight: 100;\n}\n\n.theme-form .form-group select.form-control:not([size]):not([multiple]) {\n  border-color: #ddd;\n  font-size: 14px;\n}\n\n.theme-form .checkbox label {\n  padding-left: 10px;\n}\n\n.theme-form .form-divider {\n  position: relative;\n  clear: both;\n  height: 0;\n  margin: 30px 0;\n  border-top: 1px solid #ddd;\n}\n\n.theme-form .form-divider:before {\n  position: absolute;\n  top: -11px;\n  left: 40%;\n  margin-left: -10px;\n  padding: 0 5px;\n  content: \"Or Signup With\";\n  color: #444444;\n  background: #fff;\n}\n\n.theme-form .btn-fb {\n  background-color: #50598e;\n  color: #fff;\n  width: 100%;\n}\n\n.theme-form .btn-twitter {\n  background-color: #6fa2d8;\n  color: #fff;\n  width: 100%;\n}\n\n.theme-form .btn-google {\n  background-color: #c64e40;\n  color: #fff;\n  width: 100%;\n}\n\n.form-inline .form-group {\n  margin-right: 15px;\n}\n\n.form-inline .form-group .col-form-label {\n  margin-right: 5px;\n}\n\n.search-form input {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 5px 10px;\n  background-image: url(\"../images/dashboard/search.png\");\n  background-repeat: no-repeat;\n  background-position: 95%;\n}\n\n.form-label-align-right label {\n  text-align: right;\n  padding-top: 17px;\n  font-weight: 500;\n}\n\n.custom-file-label {\n  line-height: 1.8;\n}\n\n.custom-file-label::after {\n  line-height: 1.8;\n}\n\n/**=====================\n    26. Form CSS Ends\n==========================**/\n/**=====================\n     27. Coming Soon CSS Start\n==========================**/\n.comingsoon-bgimg {\n  background: url(../images/coming-soon-bg.jpg);\n  background-position: bottom;\n  background-size: cover;\n}\n\n.comingsoon {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 50px 0;\n}\n\n.comingsoon .comingsoon-inner h5 {\n  font-size: 18px;\n  letter-spacing: 1px;\n  color: #777777;\n  font-weight: 500;\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\n\n.comingsoon .comingsoon-inner .countdown {\n  padding: 30px 0;\n  border-top: 1px solid #eeeeee;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.comingsoon .comingsoon-inner .countdown .time {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-radius: 50%;\n  color: #fff;\n  font-weight: 500;\n  width: 100px;\n  height: 100px;\n  font-size: 36px;\n  background: #4099ff;\n}\n\n.comingsoon .comingsoon-inner .countdown .title {\n  padding-top: 13px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #777777;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.comingsoon .comingsoon-inner .countdown ul li {\n  display: inline-block;\n  text-transform: uppercase;\n  margin: 0 20px;\n}\n\n.comingsoon .comingsoon-inner .countdown ul li span {\n  display: block;\n}\n\n.comingsoon .comingsoon-inner .coming-soon-bottom-link {\n  margin-top: 30px;\n}\n\n.comingsoon .comingsoon-inner .coming-soon-bottom-link a {\n  font-size: 18px;\n  color: #000;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.comingsoon video {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: -100;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n  transform: translateX(-50%) translateY(-50%);\n  -webkit-transition: 1s opacity;\n  transition: 1s opacity;\n}\n\n/**=====================\n    27. Coming Soon CSS Ends\n==========================**/\n/**=====================\n     28. Radio CSS Start\n==========================**/\n.checkbox label {\n  display: inline-block;\n  position: relative;\n  padding-left: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.checkbox label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 19px;\n  height: 19px;\n  left: 0;\n  margin-left: -16px;\n  border: 1px solid #cccccc;\n  border-radius: 3px;\n  background-color: #fff;\n  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\n}\n\n.checkbox label::after {\n  display: inline-block;\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  left: 0;\n  top: 0;\n  margin-left: -20px;\n  padding-left: 3px;\n  padding-top: 1px;\n  font-size: 11px;\n  color: #444444;\n}\n\n.checkbox input[type=\"checkbox\"] {\n  opacity: 0;\n}\n\n.checkbox input[type=\"checkbox\"]:focus {\n  outline-offset: -2px;\n}\n\n.checkbox input[type=\"checkbox\"]:focus+label::before {\n  outline-offset: -2px;\n}\n\n.checkbox input[type=\"checkbox\"]:checked+label::before {\n  font-family: themify;\n  content: \"\\e64c\";\n  text-align: center;\n  line-height: 1.2;\n}\n\n.checkbox input[type=\"checkbox\"]:disabled+label {\n  opacity: 0.65;\n}\n\n.checkbox input[type=\"checkbox\"]:disabled+label::before {\n  background-color: #eeeeee;\n  cursor: not-allowed;\n}\n\n.checkbox .checkbox-circle label::before {\n  border-radius: 50%;\n}\n\n.checkbox .checkbox-inline {\n  margin-top: 0;\n}\n\n.m-squar label::before {\n  border-radius: 0;\n}\n\n.m-squar .checkbox-circle label::before {\n  border-radius: 50%;\n}\n\n.m-squar .checkbox-inline {\n  margin-top: 0;\n}\n\n.checkbox-primary input[type=\"checkbox\"]:checked+label::before {\n  border-color: #ab8ce4;\n  color: #ab8ce4;\n}\n\n.checkbox-primary input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-secondary input[type=\"checkbox\"]:checked+label::before {\n  border-color: #26c6da;\n  color: #26c6da;\n}\n\n.checkbox-secondary input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-success input[type=\"checkbox\"]:checked+label::before {\n  border-color: #00c292;\n  color: #00c292;\n}\n\n.checkbox-success input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-danger input[type=\"checkbox\"]:checked+label::before {\n  border-color: #FF5370;\n  color: #FF5370;\n}\n\n.checkbox-danger input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-info input[type=\"checkbox\"]:checked+label::before {\n  border-color: #4099ff;\n  color: #4099ff;\n}\n\n.checkbox-info input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-light input[type=\"checkbox\"]:checked+label::before {\n  border-color: #eeeeee;\n  color: #eeeeee;\n}\n\n.checkbox-light input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-dark input[type=\"checkbox\"]:checked+label::before {\n  border-color: #2a3142;\n  color: #2a3142;\n}\n\n.checkbox-dark input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-warning input[type=\"checkbox\"]:checked+label::before {\n  border-color: #f3d800;\n  color: #f3d800;\n}\n\n.checkbox-warning input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-primary label:before {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  color: #fff;\n}\n\n.checkbox-solid-primary input[type=\"checkbox\"]:checked+label::before {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  color: #fff;\n}\n\n.checkbox-solid-primary input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-secondary label:before {\n  background-color: #26c6da;\n  border-color: #26c6da;\n  color: #fff;\n}\n\n.checkbox-solid-secondary input[type=\"checkbox\"]:checked+label::before {\n  background-color: #26c6da;\n  border-color: #26c6da;\n  color: #fff;\n}\n\n.checkbox-solid-secondary input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-success label:before {\n  background-color: #00c292;\n  border-color: #00c292;\n  color: #fff;\n}\n\n.checkbox-solid-success input[type=\"checkbox\"]:checked+label::before {\n  background-color: #00c292;\n  border-color: #00c292;\n  color: #fff;\n}\n\n.checkbox-solid-success input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-danger label:before {\n  background-color: #FF5370;\n  border-color: #FF5370;\n  color: #fff;\n}\n\n.checkbox-solid-danger input[type=\"checkbox\"]:checked+label::before {\n  background-color: #FF5370;\n  border-color: #FF5370;\n  color: #fff;\n}\n\n.checkbox-solid-danger input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-info label:before {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  color: #fff;\n}\n\n.checkbox-solid-info input[type=\"checkbox\"]:checked+label::before {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  color: #fff;\n}\n\n.checkbox-solid-info input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-light label:before {\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n  color: #fff;\n}\n\n.checkbox-solid-light input[type=\"checkbox\"]:checked+label::before {\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n  color: #fff;\n}\n\n.checkbox-solid-light input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-dark label:before {\n  background-color: #2a3142;\n  border-color: #2a3142;\n  color: #fff;\n}\n\n.checkbox-solid-dark input[type=\"checkbox\"]:checked+label::before {\n  background-color: #2a3142;\n  border-color: #2a3142;\n  color: #fff;\n}\n\n.checkbox-solid-dark input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-solid-warning label:before {\n  background-color: #f3d800;\n  border-color: #f3d800;\n  color: #fff;\n}\n\n.checkbox-solid-warning input[type=\"checkbox\"]:checked+label::before {\n  background-color: #f3d800;\n  border-color: #f3d800;\n  color: #fff;\n}\n\n.checkbox-solid-warning input[type=\"checkbox\"]:checked+label::after {\n  color: #fff;\n}\n\n.checkbox-primary label::before {\n  border-color: #ab8ce4;\n}\n\n.checkbox-secondary label::before {\n  border-color: #26c6da;\n}\n\n.checkbox-success label::before {\n  border-color: #00c292;\n}\n\n.checkbox-danger label::before {\n  border-color: #FF5370;\n}\n\n.checkbox-info label::before {\n  border-color: #4099ff;\n}\n\n.checkbox-light label::before {\n  border-color: #eeeeee;\n}\n\n.checkbox-dark label::before {\n  border-color: #2a3142;\n}\n\n.checkbox-warning label::before {\n  border-color: #f3d800;\n}\n\n.m-checkbox-inline .checkbox {\n  display: inline-block;\n}\n\n.m-checkbox-inline .radio {\n  display: inline-block;\n}\n\n.m-checkbox-inline label {\n  margin-right: 20px;\n}\n\n.radio label {\n  display: inline-block;\n  position: relative;\n  padding-left: 5px;\n  cursor: pointer;\n}\n\n.radio label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 19px;\n  height: 19px;\n  left: 0;\n  margin-left: -20px;\n  border: 1px solid #cccccc;\n  border-radius: 50%;\n  background-color: #fff;\n  -webkit-transition: border 0.15s ease-in-out;\n  transition: border 0.15s ease-in-out;\n}\n\n.radio label::after {\n  display: inline-block;\n  position: absolute;\n  content: \" \";\n  width: 9px;\n  height: 9px;\n  left: 5px;\n  top: 5px;\n  margin-left: -20px;\n  border-radius: 50%;\n  background-color: #717171;\n  -webkit-transform: scale(0, 0);\n  transform: scale(0, 0);\n  -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n  transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33), -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n}\n\n.radio input[type=\"radio\"] {\n  opacity: 0;\n}\n\n.radio input[type=\"radio\"]:focus+label::before {\n  outline-offset: -2px;\n}\n\n.radio input[type=\"radio\"]:checked+label::after {\n  -webkit-transform: scale(1, 1);\n  transform: scale(1, 1);\n}\n\n.radio input[type=\"radio\"]:disabled+label {\n  opacity: 0.65;\n}\n\n.radio input[type=\"radio\"]:disabled+label::before {\n  cursor: not-allowed;\n}\n\n.radio .radio-inline {\n  margin-top: 0;\n}\n\n.radio-primary input[type=\"radio\"]+label::before {\n  border-color: #ab8ce4;\n}\n\n.radio-primary input[type=\"radio\"]+label::after {\n  background-color: #ab8ce4;\n}\n\n.radio-primary input[type=\"radio\"]:checked+label::before {\n  border-color: #ab8ce4;\n}\n\n.radio-primary input[type=\"radio\"]:checked+label::after {\n  background-color: #ab8ce4;\n}\n\n.radio-secondary input[type=\"radio\"]+label::before {\n  border-color: #26c6da;\n}\n\n.radio-secondary input[type=\"radio\"]+label::after {\n  background-color: #26c6da;\n}\n\n.radio-secondary input[type=\"radio\"]:checked+label::before {\n  border-color: #26c6da;\n}\n\n.radio-secondary input[type=\"radio\"]:checked+label::after {\n  background-color: #26c6da;\n}\n\n.radio-success input[type=\"radio\"]+label::before {\n  border-color: #00c292;\n}\n\n.radio-success input[type=\"radio\"]+label::after {\n  background-color: #00c292;\n}\n\n.radio-success input[type=\"radio\"]:checked+label::before {\n  border-color: #00c292;\n}\n\n.radio-success input[type=\"radio\"]:checked+label::after {\n  background-color: #00c292;\n}\n\n.radio-danger input[type=\"radio\"]+label::before {\n  border-color: #FF5370;\n}\n\n.radio-danger input[type=\"radio\"]+label::after {\n  background-color: #FF5370;\n}\n\n.radio-danger input[type=\"radio\"]:checked+label::before {\n  border-color: #FF5370;\n}\n\n.radio-danger input[type=\"radio\"]:checked+label::after {\n  background-color: #FF5370;\n}\n\n.radio-info input[type=\"radio\"]+label::before {\n  border-color: #4099ff;\n}\n\n.radio-info input[type=\"radio\"]+label::after {\n  background-color: #4099ff;\n}\n\n.radio-info input[type=\"radio\"]:checked+label::before {\n  border-color: #4099ff;\n}\n\n.radio-info input[type=\"radio\"]:checked+label::after {\n  background-color: #4099ff;\n}\n\n.radio-light input[type=\"radio\"]+label::before {\n  border-color: #eeeeee;\n}\n\n.radio-light input[type=\"radio\"]+label::after {\n  background-color: #eeeeee;\n}\n\n.radio-light input[type=\"radio\"]:checked+label::before {\n  border-color: #eeeeee;\n}\n\n.radio-light input[type=\"radio\"]:checked+label::after {\n  background-color: #eeeeee;\n}\n\n.radio-dark input[type=\"radio\"]+label::before {\n  border-color: #2a3142;\n}\n\n.radio-dark input[type=\"radio\"]+label::after {\n  background-color: #2a3142;\n}\n\n.radio-dark input[type=\"radio\"]:checked+label::before {\n  border-color: #2a3142;\n}\n\n.radio-dark input[type=\"radio\"]:checked+label::after {\n  background-color: #2a3142;\n}\n\n.radio-warning input[type=\"radio\"]+label::before {\n  border-color: #f3d800;\n}\n\n.radio-warning input[type=\"radio\"]+label::after {\n  background-color: #f3d800;\n}\n\n.radio-warning input[type=\"radio\"]:checked+label::before {\n  border-color: #f3d800;\n}\n\n.radio-warning input[type=\"radio\"]:checked+label::after {\n  background-color: #f3d800;\n}\n\n/**=====================\n     28. Radio CSS Ends\n==========================**/\n/**=====================\n     29. Form Input CSS Start\n==========================**/\n.icon-addon .addon-md .glyphicon,\n.icon-addon .addon-md .fa {\n  position: absolute;\n  z-index: 2;\n  left: 10px;\n  font-size: 14px;\n  width: 20px;\n  margin-left: -2.5px;\n  text-align: center;\n  padding: 10px 0;\n  top: 1px;\n}\n\n.icon-addon .glyphicon,\n.icon-addon .fa {\n  position: absolute;\n  z-index: 2;\n  left: 10px;\n  font-size: 14px;\n  width: 20px;\n  margin-left: -2.5px;\n  text-align: center;\n  padding: 10px 0;\n  top: 1px;\n}\n\n.input-group-square .input-group-text,\n.input-group-square .form-control {\n  border-radius: 0;\n}\n\n.input-group-solid .input-group-text,\n.input-group-solid .form-control {\n  background: #eeeeee;\n}\n\n.input-group-air {\n  -webkit-box-shadow: 0 3px 20px 0 #ddd;\n  box-shadow: 0 3px 20px 0 #ddd;\n}\n\n.icon-addon {\n  position: relative;\n  color: #4c5667;\n  display: block;\n}\n\n.icon-addon:after {\n  display: table;\n  content: \"\";\n  clear: both;\n}\n\n.icon-addon:before {\n  display: table;\n  content: \"\";\n}\n\n.icon-addon .addon-md .form-control {\n  padding-left: 30px;\n  float: left;\n  font-weight: normal;\n}\n\n.icon-addon .form-control {\n  padding-left: 30px;\n  float: left;\n  font-weight: normal;\n}\n\n.pill-input-group div:last-child span {\n  border-top-right-radius: 1.3rem;\n  border-bottom-right-radius: 1.3rem;\n}\n\n.pill-input-group div:first-child span {\n  border-top-left-radius: 1.3rem;\n  border-bottom-left-radius: 1.3rem;\n}\n\n/**=====================\n     29. Form Input CSS Ends\n==========================**/\n/**=====================\n    30. Data-table CSS Start\n==========================**/\ndiv.dt-button-background {\n  display: none !important;\n}\n\n.dataTables_wrapper {\n  padding: 0;\n  width: 100%;\n}\n\n.dataTables_wrapper.no-footer .dataTables_scrollBody {\n  border-bottom: 1px solid #cccccc;\n}\n\n.dataTables_wrapper button {\n  font-weight: 400;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  border-radius: 0.25rem;\n  color: #fff;\n}\n\n.dataTables_wrapper+.dataTables_wrapper {\n  margin-top: 20px;\n}\n\n.dataTables_wrapper .dataTables_paginate {\n  margin-left: 15px !important;\n  border: 1px solid #eeeeee;\n  border-radius: 0.25rem;\n  padding-top: 0;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button {\n  margin: 0;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.current,\n.dataTables_wrapper .dataTables_paginate .paginate_button:active {\n  background: #ab8ce4;\n  color: #fff !important;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button:hover {\n  border: 1px solid #ab8ce4;\n  color: #2a3142 !important;\n  background: transparent !important;\n}\n\n.dataTables_wrapper .dataTables_length {\n  margin-bottom: 30px;\n}\n\n.dataTables_wrapper .dataTables_length select {\n  border-color: #eeeeee;\n  color: #2a3142;\n  padding: 0 10px;\n  margin: 0 10px;\n  height: 2.7142em;\n}\n\n.dataTables_wrapper table.dataTable {\n  border: 1px solid #ddd;\n}\n\n.dataTables_wrapper table.dataTable thead th,\n.dataTables_wrapper table.dataTable thead td {\n  border-bottom: 2px solid #ddd;\n}\n\n.dataTables_wrapper table.dataTable th,\n.dataTables_wrapper table.dataTable td {\n  padding: 0.75rem;\n}\n\n.dataTables_wrapper .dataTables_filter {\n  margin-bottom: 25px;\n  margin-left: 15px;\n}\n\n.dataTables_wrapper .dataTables_filter input[type=\"search\"] {\n  border: 1px solid #ddd;\n  padding: 0 10px;\n  margin-left: 10px;\n  height: 37px;\n  border-radius: 0;\n}\n\n.dataTables_scrollHeadInner {\n  width: 100% !important;\n}\n\ntable .fixedHeader-floating {\n  position: fixed !important;\n  background-color: #fff;\n}\n\ntable .box>div {\n  padding: 5px 15px;\n  background-color: #ab8ce4;\n  display: inline-block;\n  color: #fff;\n  border-radius: 5px;\n  margin-bottom: 15px;\n  margin-right: 15px;\n}\n\ntable.dataTable.fixedHeader-locked,\ntable.dataTable.fixedHeader-floating {\n  width: calc(100vw - 250px) !important;\n  max-width: calc(100vw - 250px) !important;\n  overflow: hidden !important;\n  right: 0 !important;\n  z-index: 99;\n  left: 260px !important;\n}\n\ntable.dataTable:not(.fixedHeader-locked):not(.fixedHeader-floating) {\n  width: 100% !important;\n}\n\ntable.dataTable {\n  border-collapse: collapse !important;\n  margin-top: 0 !important;\n}\n\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:before,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:after {\n  bottom: 12px !important;\n}\n\ntable.dataTable input,\ntable.dataTable select {\n  border: 1px solid #ddd;\n  padding: 0 10px;\n  height: 37px;\n}\n\n.toolbar {\n  padding: 5px 15px;\n  background-color: #ab8ce4;\n  display: inline-block;\n  color: #fff;\n  border-radius: 5px;\n  margin-bottom: 15px;\n  margin-right: 15px;\n}\n\ncode.option {\n  color: #FF5370 !important;\n}\n\ncode.api {\n  color: #00c292 !important;\n}\n\n.dt-ext .dataTables_wrapper .page-item.active .page-link {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  color: #fff;\n}\n\n.dt-ext .dataTables_wrapper .dataTables_paginate {\n  border: none;\n}\n\n.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button {\n  padding: 0;\n  border: none;\n}\n\n.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.disabled,\n.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.hover,\n.dt-ext .dataTables_wrapper .dataTables_paginate .paginate_button.active {\n  border: none !important;\n}\n\n.dt-ext .dataTables_wrapper .dataTables_paginate .page-link {\n  margin-left: 0px;\n  color: #ab8ce4;\n}\n\n.dt-ext .dataTables_wrapper button.dt-button,\n.dt-ext .dataTables_wrapper div.dt-button,\n.dt-ext .dataTables_wrapper a.dt-button,\n.dt-ext .dataTables_wrapper button.dt-button:focus:not(.disabled),\n.dt-ext .dataTables_wrapper div.dt-button:focus:not(.disabled),\n.dt-ext .dataTables_wrapper a.dt-button:focus:not(.disabled),\n.dt-ext .dataTables_wrapper button.dt-button:active:not(.disabled),\n.dt-ext .dataTables_wrapper button.dt-button.active:not(.disabled),\n.dt-ext .dataTables_wrapper div.dt-button:active:not(.disabled),\n.dt-ext .dataTables_wrapper div.dt-button.active:not(.disabled),\n.dt-ext .dataTables_wrapper a.dt-button:active:not(.disabled),\n.dt-ext .dataTables_wrapper a.dt-button.active:not(.disabled) {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  border-radius: 2px;\n  color: #fff;\n  background-image: none;\n  font-size: 14px;\n}\n\n.dt-ext .dataTables_wrapper button.dt-button.btn-success,\n.dt-ext .dataTables_wrapper div.dt-button.btn-success,\n.dt-ext .dataTables_wrapper a.dt-button.btn-success {\n  background-color: #00c292;\n  border-color: #00c292;\n}\n\n.dt-ext .dataTables_wrapper button.dt-button.btn-secondary,\n.dt-ext .dataTables_wrapper div.dt-button.btn-secondary,\n.dt-ext .dataTables_wrapper a.dt-button.btn-secondary {\n  background-color: #26c6da;\n  border-color: #26c6da;\n}\n\n.dt-ext .dataTables_wrapper button.dt-button.btn-danger,\n.dt-ext .dataTables_wrapper div.dt-button.btn-danger,\n.dt-ext .dataTables_wrapper a.dt-button.btn-danger {\n  background-color: #FF5370;\n  border-color: #FF5370;\n}\n\n.dt-ext .dataTables_wrapper table.dataTable th.focus,\n.dt-ext .dataTables_wrapper table.dataTable td.focus {\n  outline: 3px solid #ab8ce4;\n}\n\n.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.odd.selected>.sorting_1,\n.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody>tr.odd.selected>.sorting_1 {\n  background-color: #e7dff7;\n}\n\n.dt-ext .dataTables_wrapper table.dataTable.stripe tbody>tr.odd.selected,\n.dt-ext .dataTables_wrapper table.dataTable.stripe tbody>tr.odd>.selected,\n.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.odd.selected,\n.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.odd>.selected {\n  background-color: #e7dff7;\n}\n\n.dt-ext .dataTables_wrapper table.dataTable.display tbody>tr.even.selected>.sorting_1,\n.dt-ext .dataTables_wrapper table.dataTable.order-column.stripe tbody>tr.even.selected>.sorting_1 {\n  background-color: #e7dff7;\n}\n\n.dt-ext .dataTables_wrapper table.dataTable tbody>tr.selected,\n.dt-ext .dataTables_wrapper table.dataTable tbody>tr>.selected {\n  background-color: #e7dff7;\n}\n\ntd.highlight {\n  background-color: #eeeeee !important;\n}\n\ntd.details-control {\n  background: url(\"../images/details_open.png\") no-repeat center center;\n  cursor: pointer;\n}\n\ntr.shown td.details-control {\n  background: url(\"../images/details_close.png\") no-repeat center center;\n}\n\n.dataTables_scroll~.dataTables_paginate {\n  margin-top: 20px !important;\n}\n\n.product-table th:last-child {\n  min-width: 120px;\n}\n\n.product-table h6 {\n  font-weight: 600;\n  color: #2a3142;\n}\n\ntable.dataTable.display tbody tr.odd>.sorting_1 {\n  background-color: #f6f6f6;\n}\n\n/**=====================\n     30. Data-table CSS Ends\n==========================**/\n/**=====================\n     31. JS datagrid CSS Start\n==========================**/\n.jsgrid .jsgrid-grid-body .jsgrid-cell {\n  padding: 0.75rem;\n}\n\n.jsgrid .jsgrid-pager-container {\n  text-align: right;\n}\n\n.jsgrid .jsgrid-pager {\n  padding: 0;\n  margin-top: 20px;\n}\n\n.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button {\n  margin-right: -5px;\n}\n\n.jsgrid .jsgrid-pager .jsgrid-pager-nav-inactive-button:first-child {\n  border-radius: 5px 0 0 5px;\n}\n\n.jsgrid .jsgrid-pager .jsgrid-pager-page~.jsgrid-pager-nav-button {\n  margin-left: -5px;\n}\n\n.jsgrid .jsgrid-pager .jsgrid-pager-page~.jsgrid-pager-nav-button:last-child {\n  border-radius: 0 5px 5px 0;\n}\n\n.jsgrid .jsgrid-pager [class*=\"jsgrid-pager\"] {\n  display: inline-block;\n  min-width: 1.5em;\n  padding: 0.5em 1em;\n  border: 1px solid #eeeeee;\n}\n\n.jsgrid .jsgrid-pager .jsgrid-pager-page a {\n  color: #2a3142;\n}\n\n.jsgrid .jsgrid-pager .jsgrid-pager-current-page {\n  color: #2a3142;\n}\n\n.jsgrid .jsgrid-selected-row>.jsgrid-cell {\n  background: #eeeeee;\n  border-color: #fafafa;\n}\n\n.jsgrid .jsgrid-header-row>.jsgrid-header-cell {\n  padding: 0.75rem;\n}\n\n/**=====================\n     31. JS datagrid CSS Ends\n==========================**/\n/**=====================\n     32. Page CSS Start\n==========================**/\n/*test Nav bar color */\n.pagination-theme .page-item .page-link {\n  color: #ab8ce4;\n}\n\n.pagination-theme .page-item.active .page-link {\n  color: #fff;\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n}\n\n.pagination-primary .page-item .page-link {\n  color: #ab8ce4;\n}\n\n.pagination-primary .page-item.active .page-link {\n  color: #fff;\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n}\n\n.pagination-secondary .page-item .page-link {\n  color: #26c6da;\n}\n\n.pagination-secondary .page-item.active .page-link {\n  color: #fff;\n  background-color: #26c6da;\n  border-color: #26c6da;\n}\n\n.pagination-success .page-item .page-link {\n  color: #00c292;\n}\n\n.pagination-success .page-item.active .page-link {\n  color: #fff;\n  background-color: #00c292;\n  border-color: #00c292;\n}\n\n.pagination-danger .page-item .page-link {\n  color: #FF5370;\n}\n\n.pagination-danger .page-item.active .page-link {\n  color: #fff;\n  background-color: #FF5370;\n  border-color: #FF5370;\n}\n\n.pagination-info .page-item .page-link {\n  color: #4099ff;\n}\n\n.pagination-info .page-item.active .page-link {\n  color: #fff;\n  background-color: #4099ff;\n  border-color: #4099ff;\n}\n\n.pagination-dark .page-item .page-link {\n  color: #2a3142;\n}\n\n.pagination-dark .page-item.active .page-link {\n  color: #fff;\n  background-color: #2a3142;\n  border-color: #2a3142;\n}\n\n.pagination-warning .page-item .page-link {\n  color: #f3d800;\n}\n\n.pagination-warning .page-item.active .page-link {\n  color: #fff;\n  background-color: #f3d800;\n  border-color: #f3d800;\n}\n\n/**=====================\n     32. Page CSS Ends\n==========================**/\n/**=====================\n    33.  Ecommerce  CSS Start\n==========================**/\n/**====== Product Start ======**/\n.credit-card .text-center img {\n  margin-bottom: 20px;\n}\n\n.product-box .product-details {\n  padding: 25px;\n  text-align: center;\n}\n\n.product-box .product-details h6 {\n  color: #333333;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n}\n\n.product-box .product-details span {\n  color: #717171;\n}\n\n.product-box .product-img {\n  position: relative;\n}\n\n.product-box .product-img .product-hover {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.7);\n  opacity: 0;\n  border-radius: 100%;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.product-box .product-img .product-hover ul li {\n  display: inline-block;\n  -webkit-box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n  padding: 10px 15px;\n  background-color: #fff;\n  font-size: 18px;\n  border-radius: 5px;\n}\n\n.product-box .product-img .product-hover ul li:hover {\n  background-color: #333333;\n  color: #fff;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.product-box:hover .product-hover {\n  opacity: 1;\n  border-radius: 0%;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.product-page-main {\n  padding: 30px;\n}\n\n.product-page-main .owl-item .item {\n  border: 1px solid #eeeeee;\n  border-radius: 5px;\n}\n\n.product-page-main .owl-item.current .item {\n  border: 1px solid #ab8ce4;\n}\n\n.product-page-main .product-slider {\n  margin-bottom: 20px;\n}\n\n.product-page-details h4 {\n  color: #333333;\n  text-transform: uppercase;\n  font-size: 18px;\n}\n\n.product-page-details span {\n  padding-left: 15px;\n}\n\n.br-theme-fontawesome-stars .br-widget a,\n.br-theme-fontawesome-stars .br-widget a.br-selected:after,\n.br-theme-fontawesome-stars .br-widget a.br-active:after {\n  color: #ffa800;\n  font: normal normal normal 14px/1 FontAwesome;\n}\n\n.product-price {\n  font-size: 18px;\n  font-weight: 700;\n  font-family: Open Sans;\n}\n\n.product-price del {\n  color: #aaaaaa;\n  padding-right: 20px;\n}\n\n.product-color li {\n  display: inline-block;\n  border-radius: 100%;\n  height: 30px;\n  width: 30px;\n  margin: 0 2px;\n}\n\n.product-page-main p {\n  font-size: 15px;\n}\n\n.product-page-main .nav-link {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n/**====== Product  Ends ======**/\n.payment-opt li {\n  display: inline-block;\n}\n\n.payment-opt li img {\n  height: 20px;\n  margin: 15px 15px 0 0;\n}\n\n/**=====================\n    33. Ecommerce  CSS End\n==========================**/\n/**=====================\n     34. Pricing CSS Start\n==========================**/\n.pricing-wrapper-card .card-ribbon::before,\n.pricing-wrapper-card .card-ribbon::after {\n  position: absolute;\n  z-index: -1;\n  content: '';\n  display: block;\n  border: 5px solid #ab8ce4;\n  border-top-color: transparent;\n  border-left-color: transparent;\n}\n\n.pricing-wrapper-card {\n  padding: 50px 100px;\n}\n\n.pricing-wrapper-card .pricing-card {\n  background: #fff;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.11);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.11);\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  margin: 8px;\n  padding: 30px;\n  position: relative;\n  text-align: center;\n  -webkit-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n}\n\n.pricing-wrapper-card .pricing-card.popular {\n  margin-top: -10px;\n  margin-bottom: -10px;\n}\n\n.pricing-wrapper-card .pricing-card.popular .card-price {\n  margin: 50px;\n}\n\n.pricing-wrapper-card .pricing-card.popular .card-price h1 {\n  color: #ab8ce4;\n  font-size: 100px;\n}\n\n.pricing-wrapper-card .pricing-card.popular .card-title h3 {\n  color: #ab8ce4;\n  font-size: 22px;\n}\n\n.pricing-wrapper-card .pricing-card.popular .card-action button {\n  background-color: #ab8ce4;\n  border-radius: 80px;\n  color: #fff;\n  font-size: 17px;\n  margin-top: -15px;\n  padding: 15px;\n  height: 80px;\n}\n\n.pricing-wrapper-card .pricing-card.popular .card-action button:hover {\n  background-color: #ab8ce4;\n}\n\n.pricing-wrapper-card .pricing-card:hover {\n  -webkit-box-shadow: 6px 5px 17px 2px rgba(0, 0, 0, 0.08);\n  box-shadow: 6px 5px 17px 2px rgba(0, 0, 0, 0.08);\n}\n\n.pricing-wrapper-card .card-ribbon {\n  position: absolute;\n  overflow: hidden;\n  top: -10px;\n  left: -10px;\n  width: 114px;\n  height: 112px;\n}\n\n.pricing-wrapper-card .card-ribbon span {\n  position: absolute;\n  display: block;\n  width: 160px;\n  padding: 10px 0;\n  background-color: #ab8ce4;\n  -webkit-box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);\n  color: #fff;\n  font-size: 13px;\n  text-transform: uppercase;\n  text-align: center;\n  left: -35px;\n  top: 25px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n\n.pricing-wrapper-card .card-ribbon::before {\n  top: 0;\n  right: 0;\n}\n\n.pricing-wrapper-card .card-ribbon::after {\n  bottom: 0;\n  left: 0;\n}\n\n.pricing-wrapper-card .card-title h3 {\n  color: rgba(0, 0, 0, 0.3);\n  font-size: 15px;\n  text-transform: uppercase;\n}\n\n.pricing-wrapper-card .card-title h5 {\n  color: rgba(0, 0, 0, 0.6);\n  margin-top: 15px;\n  line-height: 1.8;\n}\n\n.pricing-wrapper-card .card-price {\n  margin: 60px 0;\n}\n\n.pricing-wrapper-card .card-price h1 {\n  font-size: 80px;\n}\n\n.pricing-wrapper-card .card-price h1 sup {\n  font-size: 15px;\n  display: inline-block;\n  margin-left: -20px;\n  width: 10px;\n}\n\n.pricing-wrapper-card .card-price h1 small {\n  color: rgba(0, 0, 0, 0.3);\n  display: block;\n  font-size: 11px;\n  text-transform: uppercase;\n}\n\n.pricing-wrapper-card .card-description ul {\n  display: block;\n  list-style: none;\n  margin: 60px 0;\n  padding: 0;\n}\n\n.pricing-wrapper-card .card-description li {\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 15px;\n  margin: 0 0 15px;\n}\n\n.pricing-wrapper-card .card-description li::before {\n  font-family: FontAwesome;\n  content: \"\\f00c\";\n  padding: 0 5px 0 0;\n  color: rgba(0, 0, 0, 0.15);\n}\n\n.pricing-wrapper-card .card-action button {\n  background: transparent;\n  border: 2px solid #ab8ce4;\n  border-radius: 30px;\n  color: #ab8ce4;\n  cursor: pointer;\n  display: block;\n  font-size: 15px;\n  font-weight: bold;\n  padding: 20px;\n  width: 100%;\n  height: 60px;\n  text-transform: uppercase;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.pricing-wrapper-card .card-action button:hover {\n  background-color: #ab8ce4;\n  -webkit-box-shadow: 0 2px 4px #ab8ce4;\n  box-shadow: 0 2px 4px #ab8ce4;\n  color: #fff;\n}\n\n.pricing-wrapper-card .card-action button:focus {\n  outline: none !important;\n}\n\n/**=====================\n    34. Pricing CSS Ends\n==========================**/\n/**=====================\n     35. Form builder css start\n==========================**/\n.form-builder .help-block {\n  margin-bottom: 0;\n  color: #999999;\n  text-transform: capitalize;\n}\n\n.form-builder .btn-light {\n  color: #999999;\n}\n\n.form-builder .copy-btn {\n  padding: 8px;\n}\n\n.form-builder .nav-primary .nav-link.active,\n.form-builder .nav-primary .nav-primary .show>.nav-link,\n.form-builder .nav-primary .nav-pills.nav-primary .nav-link.active,\n.form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {\n  border-radius: 4px;\n}\n\n.form-builder .nav-primary .nav-link,\n.form-builder .nav-primary .nav-pills.nav-primary .nav-link {\n  color: #000;\n  font-weight: 500;\n}\n\n.form-builder #components {\n  margin-top: 30px;\n}\n\n.form-builder #components #viewhtml {\n  height: 526px;\n}\n\n/**=====================\n    35. Form builder css Ends\n==========================**/\n/**=====================\n     36. NAV CSS Start\n==========================**/\n.nav-list {\n  padding: 30px;\n}\n\n.nav-list .nav-list-disc {\n  text-align: left;\n  color: #717171;\n}\n\n.nav-list .nav-list-disc li {\n  padding: 9px 0;\n}\n\n.nav-list .nav-list-disc li:first-child {\n  padding-top: 0;\n}\n\n.nav-list .nav-list-disc li:last-child {\n  padding-bottom: 0;\n}\n\n.nav-list .nav-list-disc li a {\n  color: #717171;\n}\n\n.nav-list .nav-list-disc li a .fa {\n  width: 14px;\n  font-size: 16px;\n}\n\n.nav-list .nav-list-disc li:hover {\n  color: #ab8ce4;\n}\n\n.nav-list .nav-list-disc li:hover a {\n  color: #ab8ce4;\n}\n\n.navs-icon {\n  padding: 30px;\n}\n\n.navs-icon i {\n  font-size: 21px;\n  margin-right: 10px;\n}\n\n.navs-icon .fa {\n  font-size: 16px;\n}\n\n.navs-icon li {\n  padding: 9px 0;\n}\n\n.navs-icon li:first-child {\n  padding-top: 0;\n}\n\n.navs-icon li:last-child {\n  padding-bottom: 0;\n}\n\n.navs-icon li a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.navs-icon li ul {\n  padding-top: 9px;\n}\n\n.navs-icon li ul li {\n  line-height: 1;\n}\n\n.navs-icon li ul li:first-child {\n  padding-top: 9px;\n}\n\n.navs-icon li ul li:hover {\n  color: #ab8ce4;\n}\n\n.navs-icon li ul li:hover a {\n  color: #ab8ce4;\n}\n\n.navs-icon li a {\n  color: #717171;\n}\n\n.navs-icon li a:hover {\n  color: #ab8ce4;\n}\n\n.navs-icon li a.active {\n  color: #ab8ce4;\n}\n\n.navs-icon li a span {\n  font-family: Raleway;\n}\n\n.navs-icon li button:hover a {\n  color: #FFf;\n}\n\n.navs-icon .main-section {\n  padding-top: 30px;\n}\n\n.navs-icon .separator {\n  border-bottom: 1px solid #dee2e6;\n  margin: 30px 0;\n  padding: 0;\n}\n\n.navs-icon .btn-link {\n  text-decoration: none;\n  line-height: 1;\n  padding: 0;\n  padding-bottom: 6px;\n}\n\n.navs-icon .btn-link:hover {\n  text-decoration: none;\n}\n\n#accordionoc #collapseicon,\n#accordionoc #collapseicon1 {\n  padding-top: 0px;\n}\n\n#accordionoc li button {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.navs-icon.default-according.style-1 li button {\n  position: relative;\n}\n\n.navs-icon.default-according.style-1 li button:hover {\n  color: #ab8ce4 !important;\n}\n\n.navs-icon.default-according.style-1 li button[aria-expanded=\"true\"]:before {\n  right: 2px;\n  top: 6px;\n}\n\n.navs-icon.default-according.style-1 li button[aria-expanded=\"false\"]:before {\n  right: 2px;\n  top: 6px;\n}\n\n.navs-dropdown button {\n  margin-top: 30px;\n}\n\n.navs-dropdown .onhover-show-div {\n  width: 250px;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 0 2px 2px #eeeeee;\n  box-shadow: 0 0 2px 2px #eeeeee;\n}\n\n.navs-dropdown .onhover-show-div button {\n  margin-top: 0px;\n}\n\n.navs-dropdown .onhover-show-div .navs-icon li {\n  text-align: left;\n}\n\n.onhover-dropdown.navs-dropdown:hover .onhover-show-div:before {\n  right: 77px;\n  left: unset;\n}\n\n.onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {\n  right: 77px;\n  left: unset;\n}\n\n.icon-lists {\n  font-family: Raleway;\n}\n\n.pl-navs-inline {\n  padding-left: 30px !important;\n}\n\n.inline-nav li {\n  line-height: 1.3;\n}\n\n/**=====================\n     36. NAV CSS Ends\n==========================**/\n/**=====================\n    37. Dropdown CSS Start\n==========================**/\n.dropdown-basic {\n  margin-bottom: -10px;\n}\n\n.dropdown-basic .btn-group {\n  margin-right: 18px;\n}\n\n.dropdown-basic .btn-group .btn-round {\n  border-radius: 50px;\n}\n\n.dropdown-basic .separated-btn {\n  margin-left: -6px;\n}\n\n.dropdown-basic .separated-btn .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 10px;\n}\n\n.dropdown-basic button {\n  max-height: 43px;\n}\n\n.dropdown-basic .dropdown {\n  position: relative;\n  display: inline-block;\n  margin-bottom: 10px;\n}\n\n.dropdown-basic .dropdown .dropbtn {\n  color: white;\n  padding: 12px;\n  border: none;\n  cursor: pointer;\n}\n\n.dropdown-basic .dropdown .dropdown-content {\n  display: none;\n  position: absolute;\n  right: 0;\n  background-color: #f9f9f9;\n  min-width: 170px;\n  -webkit-box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  left: 0;\n  top: 45px;\n}\n\n.dropdown-basic .dropdown .dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-basic .dropdown .dropdown-content .dropdown-header {\n  padding: 12px 16px;\n}\n\n.dropdown-basic .dropdown-content a:hover {\n  background-color: #f1f1f1;\n}\n\n.dropdown-basic .dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.dropup-basic .dropup {\n  position: relative;\n  display: inline-block;\n}\n\n.dropup-basic .dropup .dropbtn {\n  color: white;\n  padding: 12px;\n  border: none;\n}\n\n.dropup-basic .dropup .dropup-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 170px;\n  bottom: 45px;\n  z-index: 999;\n  left: 0;\n}\n\n.dropup-basic .dropup .dropup-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropup-basic .dropup .dropup-content a:hover {\n  background-color: #f1f1f1;\n}\n\n.dropup-basic .dropup:hover .dropup-content {\n  display: block;\n}\n\n.dropup-basic .dropup:hover .dropup-content a.active {\n  background-color: #f1f1f1;\n}\n\n/**=====================\n    37. Dropdown CSS Ends\n==========================**/\n/**=====================\n     38. Landing CSS Start\n==========================**/\n.tap-top {\n  width: 50px;\n  height: 50px;\n  position: fixed;\n  bottom: 40px;\n  right: 30px;\n  z-index: 99;\n  color: white;\n  text-align: center;\n  background: -webkit-gradient(linear, left bottom, left top, from(#ab8ce4), to(#4099ff));\n  background: linear-gradient(to top, #ab8ce4, #4099ff);\n  border-radius: 100%;\n  font-size: 22px;\n  cursor: pointer;\n  line-height: 2.2;\n  display: none;\n  border: 1px solid white;\n}\n\n.landing-main .landing-home {\n  background-image: url(../images/landing/home/main_bg.jpg);\n  background-position: right bottom;\n  background-repeat: no-repeat;\n  background-size: cover;\n  min-height: 100vh;\n}\n\n.landing-main .landing-home .landing-left {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.landing-main .landing-home .landing-left h5 {\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.landing-main .landing-home .landing-left h1 {\n  font-weight: 900;\n  margin-bottom: 30px;\n}\n\n.landing-main .landing-home .landing-left p {\n  font-size: 15px;\n  margin-bottom: 25px;\n}\n\n.landing-main .landing-home .landing-left .button-bottom .btn-outline-primary-2x {\n  background-color: #fff;\n}\n\n.landing-main .landing-home .landing-body {\n  height: calc(100vh - 100px);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.landing-main .live-box {\n  padding: 8px;\n  background-color: #fff;\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  position: relative;\n}\n\n.landing-main .live-box:hover:before {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.landing-main .live-box:hover .btn {\n  opacity: 1;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.landing-main .live-box:before {\n  opacity: 0;\n  content: \"\";\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0.2);\n  z-index: 2;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.landing-main .live-box .btn {\n  position: absolute;\n  top: 45%;\n  left: 30%;\n  opacity: 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  z-index: 3;\n}\n\n.landing-main .gray-section-bg {\n  background-color: #f9f9f9;\n}\n\n.landing-main .navbar-expand-lg .navbar-brand {\n  padding-left: 18px;\n}\n\n.landing-main .navbar-expand-lg .navbar-collapse {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: row nowrap;\n  flex-flow: row nowrap;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.landing-main .navbar-expand-lg .navbar-collapse .navbar-nav .nav-item a {\n  color: #fff;\n  text-transform: uppercase;\n  padding: 20px;\n  font-weight: 600;\n  opacity: 0.8;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.landing-main .navbar-expand-lg .navbar-collapse .navbar-nav .nav-item a:hover {\n  opacity: 1;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.landing-main .section-space {\n  padding: 80px 0;\n  text-align: center;\n}\n\n.landing-main .section-space p {\n  font-size: 15px;\n}\n\n.landing-main .landing-header h2 {\n  text-transform: uppercase;\n  margin-bottom: 20px;\n  font-weight: 700;\n  color: #36404a;\n}\n\n.landing-main .landing-header .line {\n  position: relative;\n  height: 3px;\n  width: 70px;\n  background-color: #4099ff;\n  content: \"\";\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  bottom: 0;\n  margin-bottom: 60px;\n}\n\n.landing-main .admin-options .live-demo-btn {\n  margin-top: 30px;\n  margin-bottom: 70px;\n}\n\n.landing-main .admin-options .live-demo-btn a {\n  text-transform: uppercase;\n  color: #fff;\n}\n\n.landing-main .admin-options .live-demo-btn a:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.landing-main .updates-features .row {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.landing-main .updates-features .landing-header h2 {\n  margin-bottom: 20px;\n}\n\n.landing-main .updates-features .landing-header p {\n  color: #828282;\n  margin: 0 auto;\n  padding-bottom: 20px;\n}\n\n.landing-main .updates-features h6 {\n  margin-top: 30px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.landing-main .advance-bg {\n  background-image: url(../images/landing/background.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-position: center;\n}\n\n.landing-main .application-section .nav-pills {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.landing-main .application-section .nav-pills .nav-item {\n  position: relative;\n}\n\n.landing-main .application-section .nav-pills .nav-item .nav-link {\n  font-size: 17px;\n  padding: 12px 30px;\n  line-height: 1;\n}\n\n.landing-main .application-section .nav-pills .nav-item a {\n  color: #000;\n}\n\n.landing-main .application-section .nav-pills .nav-item a.active {\n  color: #fff;\n  background-color: #4099ff;\n}\n\n.landing-main .application-section .nav-pills .nav-item a.active:before {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #4099ff;\n  content: \"\";\n  bottom: -7px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  z-index: 2;\n}\n\n.landing-main .application-section .nav-pills .nav-item a.active:after {\n  width: 0;\n  height: 0;\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-top: 7px solid #4099ff;\n  content: \"\";\n  bottom: -7px;\n  position: absolute;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\n.landing-main .application-section .nav-pills .application-icons i {\n  font-size: 24px;\n  margin-right: 0;\n}\n\n.landing-main .application-section .tab-content img {\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border: 1px solid #f1f1f1;\n}\n\n.landing-main .application-section .tab-content.active {\n  -webkit-animation: fadeInDown 0.3s linear;\n  animation: fadeInDown 0.3s linear;\n}\n\n.landing-main .application-section .landing-header h2 {\n  margin-bottom: 20px;\n}\n\n.landing-main .application-section .landing-header p {\n  margin-bottom: 20px;\n  color: #828282;\n}\n\n.landing-main .advance-widget {\n  background-color: #fafafa;\n}\n\n.landing-main .advance-widget .widgets-section {\n  background-image: url(../images/landing/widgets-bck.png);\n  background-size: cover;\n  height: 600px;\n  animation: widget-animation 110s linear infinite reverse;\n  -webkit-animation: widget-animation 110s linear infinite reverse;\n  background-repeat: repeat-x;\n}\n\n@-webkit-keyframes widget-animation {\n  0% {\n    background-position-x: 0;\n  }\n\n  100% {\n    background-position-x: 1920px;\n  }\n}\n\n@keyframes widget-animation {\n  0% {\n    background-position-x: 0;\n  }\n\n  100% {\n    background-position-x: 1920px;\n  }\n}\n\n.landing-main .key-features-section .feature-main {\n  padding: 0 25px 25px 25px;\n}\n\n.landing-main .key-features-section .feature-main .feature-icon {\n  width: 50px;\n  margin: 0 auto;\n}\n\n.landing-main .key-features-section .feature-main .feature-content {\n  margin-top: 35px;\n}\n\n.landing-main .key-features-section .feature-main .feature-content h5 {\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.landing-main .key-features-section .feature-main .feature-content p {\n  color: #828282;\n}\n\n.landing-main .many-feature-section h5 {\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.landing-main .many-feature-section h5 span {\n  margin-left: 15px;\n}\n\n.landing-main .exclusive-features {\n  background-image: url(\"../images/landing/home/pattern.jpg\");\n}\n\n.landing-main .exclusive-features .container .row:last-child {\n  margin-bottom: 0;\n}\n\n.landing-main .exclusive-features .container>.row:nth-child(odd) .inner-block {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 0, 0, 0)), to(#f3f3f3));\n  background-image: linear-gradient(to right, rgba(255, 0, 0, 0), #f3f3f3);\n}\n\n.landing-main .exclusive-features .container>.row .inner-block {\n  height: calc(100% - 30px);\n  background-color: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  background-image: -webkit-gradient(linear, right top, left top, from(rgba(255, 0, 0, 0)), to(#f3f3f3));\n  background-image: linear-gradient(to left, rgba(255, 0, 0, 0), #f3f3f3);\n  padding: 50px;\n  margin-bottom: 50px;\n}\n\n.landing-main .landing-components i {\n  font-size: 35px;\n  background-color: #fff;\n  padding: 25px;\n  border-radius: 50%;\n  -webkit-box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);\n  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);\n}\n\n.landing-main .landing-components p {\n  font-size: 14px;\n}\n\n.landing-main .landing-components h4 {\n  text-transform: capitalize;\n  margin-bottom: 15px;\n}\n\n.landing-main .landing-components .tour-mb {\n  margin-bottom: 2px;\n  font-weight: 600;\n}\n\n.landing-main .support-section i {\n  font-size: 45px;\n  background-color: #fff;\n  padding: 25px;\n  border-radius: 50%;\n  -webkit-box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);\n  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);\n}\n\n.landing-main .support-section h6 {\n  margin-top: 40px;\n  font-weight: 600;\n}\n\n.landing-main .support-section p {\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n.landing-main .cd-timeline-content .cd-date {\n  text-align: left;\n}\n\n.landing-main .cd-timeline-img i {\n  left: 13%;\n}\n\n.landing-main .footer-bg {\n  text-align: center;\n  background-color: #4099ff;\n  background: -webkit-gradient(linear, left top, right top, from(#9f75ec), to(#7183ef));\n  background: linear-gradient(to right, #9f75ec 0%, #7183ef 100%);\n}\n\n.landing-main .footer-bg h2 {\n  font-size: 36px;\n  text-transform: uppercase;\n  color: #fff;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.landing-main .footer-bg .star-rate {\n  margin: 40px 0;\n}\n\n.landing-main .footer-bg .star-rate i {\n  font-size: 45px;\n  margin-right: 10px;\n}\n\n.landing-main .footer-bg .star-rate i:last-child {\n  margin-right: 0;\n}\n\n.landing-main .footer-bg button {\n  text-transform: uppercase;\n}\n\n.customizer-img {\n  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border: 1px solid #f1f1f1;\n}\n\n/**=====================\n      document css\n==========================**/\n.document.page-wrapper .page-sidebar {\n  top: 100px;\n  padding: 30px 20px;\n}\n\n.document.page-wrapper .page-body-wrapper .page-body {\n  margin-top: 130px;\n}\n\n.document .particles-headline {\n  background-position: top;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 10;\n  background-image: -webkit-gradient(linear, right top, left top, from(#536dfe), to(#fff));\n  background-image: linear-gradient(-90deg, #536dfe, #fff);\n}\n\n.page-wrapper.document .page-body {\n  min-height: unset;\n}\n\n.document-content ul.nav-pills {\n  overflow-y: scroll;\n  max-height: calc(100vh - 180px);\n  display: block;\n}\n\n.document-content ul.nav-pills li {\n  line-height: 25px;\n}\n\n.document-content ul.nav-pills li .nav-link {\n  border-radius: .25rem;\n  font-size: 15px;\n  display: block;\n  text-decoration: none;\n  line-height: 40px;\n  color: #4c5667;\n  font-weight: 500;\n  padding: 0;\n}\n\n.document-content ul.nav-pills li .nav-link i {\n  margin-top: 3px;\n  text-decoration: none;\n  line-height: 25px;\n  color: #ab8ce4;\n  margin-right: 20px;\n}\n\n.document-content ul.nav-pills li .nav-link.active {\n  background-color: unset !important;\n  color: #ab8ce4;\n}\n\n.document-content ul.nav-pills li .show>.nav-link {\n  background-color: unset !important;\n  color: #ab8ce4;\n}\n\n.document-content .table thead th {\n  width: 50%;\n}\n\n.document-content .set-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.document-content i.fa-star {\n  color: #ffd042;\n}\n\n.document-content .col-9 {\n  padding-left: 40px;\n}\n\n.document-content .col-9 .set-height {\n  overflow: scroll;\n  overflow-x: hidden;\n}\n\n.document-content .col-9 .tab-content {\n  overflow: auto;\n  overflow-x: hidden;\n  max-height: calc(100% - 200px);\n  position: fixed;\n  width: 976px;\n  margin-left: 30px;\n  -webkit-box-shadow: 0 0 15px 0 rgba(220, 220, 220, 0.4);\n  -o-box-shadow: 0 0 15px 0 rgba(220, 220, 220, 0.4);\n  box-shadow: 0 0 15px 0 rgba(220, 220, 220, 0.4);\n}\n\n.document-content .col-9 .tab-content .section-head {\n  font-weight: 600;\n  font-size: 32px;\n  margin-bottom: 40px;\n  padding: 0;\n}\n\n.document-content .card-body.tree-color {\n  padding: 0;\n}\n\n.document-content .jstree-default {\n  padding: 30px;\n  background-color: #36404a;\n  -webkit-box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n}\n\n.document-content .jstree-default .jstree-anchor {\n  color: #a6aaaf;\n}\n\n.document-content .jstree-default .jstree-hovered {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\n.document-content .jstree-default .jstree-clicked {\n  color: white !important;\n  background: transparent !important;\n}\n\n.document-content .jstree-default .jstree-icon {\n  color: #656b78 !important;\n}\n\n.document-content hr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.document-content .html-editor {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #2b2b2b;\n}\n\n.document-content .html-editor pre {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #000;\n}\n\n.document-content .progress {\n  margin-bottom: 10px;\n}\n\n.document-content ul.list-ticked li {\n  margin-bottom: 10px;\n  padding-left: 1rem;\n}\n\n.document-content.faq {\n  font-size: 18px;\n}\n\n.document-content.faq .btn {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ab8ce4;\n}\n\n.document-content.faq .btn.btn-link {\n  color: #000;\n}\n\n.document-content.faq .btn.btn-link.collapsed {\n  color: #ab8ce4;\n}\n\n.document-content.faq ul {\n  border: unset;\n}\n\n.document-content.faq ul.nav {\n  display: block;\n}\n\n.document-content.faq ul.nav li .nav-link {\n  border-radius: .25rem;\n  font-size: 18px;\n  display: block;\n  padding: 3px 20px 3px 30px;\n  text-decoration: none;\n  line-height: 30px;\n  color: #4c5667;\n  font-weight: 500;\n  border: unset;\n}\n\n.document-content.faq ul.nav li .nav-link i {\n  margin-top: 3px;\n  text-decoration: none;\n  line-height: 25px;\n  color: #ab8ce4;\n  margin-right: 20px;\n}\n\n.document-content.faq ul.nav li .nav-link.active {\n  color: #ab8ce4;\n  background-color: unset;\n  border: unset;\n}\n\n.document-content.faq ul.nav li .nav-link:hover {\n  border: unset;\n}\n\n.document-content .reviews {\n  background-color: #fff;\n  padding: 30px 0;\n  margin-bottom: 30px;\n  -webkit-box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n}\n\n.document-content .reviews h1 {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.document-content .reviews h5 {\n  text-transform: capitalize;\n}\n\n/**=====================\n      document css end\n==========================**/\n/**=====================\n     38. Landing CSS Ends\n==========================**/\n/**=====================\n     39. Table  CSS Start\n==========================**/\n.table {\n  margin-bottom: 0;\n}\n\n.table th,\n.table td {\n  color: #333333;\n}\n\n.table [class*='bg-'] {\n  color: #fff;\n}\n\n.table .bg-light {\n  color: #333333;\n}\n\n.table tfoot {\n  font-weight: bold;\n}\n\n.table-inverse th,\n.table-inverse td {\n  color: #fff;\n}\n\n.table[class*='bg-'] th,\n.table[class*='bg-'] td {\n  color: #fff;\n}\n\n.table-hover tbody tr:hover {\n  background-color: #f6f6f6;\n}\n\n.table-xl td,\n.table-xl th {\n  padding: 1.25rem 2rem;\n  font-size: 120%;\n}\n\n.table-lg td,\n.table-lg th {\n  padding: .9rem 2rem;\n  font-size: 110%;\n}\n\n.table-de td,\n.table-de th {\n  padding: .75rem 2rem;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: .5rem 2rem;\n  font-size: 90%;\n}\n\n.table-xs th,\n.table-xs td {\n  padding: 0.2rem 2rem;\n  font-size: 80%;\n}\n\n.table-border-horizontal tr,\n.table-border-horizontal th,\n.table-border-horizontal td {\n  border-top: 1px solid #dee2e6;\n  padding: .75rem 2rem;\n}\n\n.table-border-vertical tr,\n.table-border-vertical th,\n.table-border-vertical td {\n  border-top: 0;\n  border-right: 1px solid #dee2e6;\n}\n\n.table-border-vertical tr td:last-child {\n  border-right: none;\n}\n\n.table-bordernone td {\n  border: 0;\n}\n\n.table-bordernone .bd-t-none {\n  border-top: none;\n}\n\n.table-bordernone .u-s-tb {\n  padding: 11px;\n}\n\n.table-inverse {\n  color: #fff;\n  background-color: #292b2c;\n}\n\n.table-inverse th,\n.table-inverse td {\n  border-color: #fff;\n}\n\n.table-inverse.table-bordered {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(245, 247, 250, 0.5);\n}\n\n.table-bordered td,\n.table-bordered th {\n  border-color: #f6f6f6;\n}\n\n/**=====================\n     39.Table CSS Ends\n==========================**/\n/**=====================\n    40. Alertbox-call-out CSS start\n==========================**/\n.bs-callout-info {\n  display: block;\n  border-color: #ab8ce4 !important;\n  background-color: #ab8ce4;\n  border-radius: 0.25rem;\n  color: #000;\n}\n\n/**=====================\n     40. Alertbox-call-out CSS End\n==========================**/\n/**=====================\n    41. Chart CSS Start\n==========================**/\n.radial-bar.radial-bar-lg:after,\n.radial-bar.radial-bar-lg>img {\n  width: 70px;\n  height: 70px;\n  margin-left: 15px;\n  margin-top: 15px;\n  line-height: 70px;\n}\n\n.radial-bar.radial-bar-sm:after,\n.radial-bar.radial-bar-sm>img {\n  width: 35px;\n  height: 35px;\n  margin-left: 7.5px;\n  margin-top: 7.5px;\n  line-height: 35px;\n}\n\n.radial-bar.radial-bar-xs:after,\n.radial-bar.radial-bar-xs>img {\n  width: 20px;\n  height: 20px;\n  margin-left: 5.5px;\n  margin-top: 4.5px;\n  line-height: 21px;\n}\n\n.chart-block canvas {\n  width: 100% !important;\n}\n\n.chart-block .chart-overflow {\n  overflow: hidden;\n  text-align: center;\n}\n\n.candidcahrt {\n  width: 100%;\n  height: 470px;\n}\n\n.amcharts-export-canvas {\n  position: absolute;\n  display: none;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: #fff;\n}\n\n.amcharts-export-canvas .canvas-container {\n  -webkit-transition: opacity .5s ease-out;\n  transition: opacity .5s ease-out;\n}\n\n.amcharts-export-canvas.active {\n  display: block;\n}\n\n.amcharts-export-canvas.dropbox .canvas-container {\n  opacity: .5;\n}\n\n.flot-chart-container {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  width: 100%;\n  height: 400px;\n}\n\n.flot-chart-container #toggling-series-flot {\n  width: 79% !important;\n}\n\n.flot-chart-placeholder {\n  width: 100%;\n  height: 100%;\n  font-size: 14px;\n  line-height: 1.2em;\n  text-align: center;\n}\n\n.flot-chart-placeholder .legend table {\n  border-spacing: 5px;\n}\n\n.morris-hover {\n  position: absolute;\n  z-index: 8;\n}\n\n.morris-hover.morris-default-style {\n  border-radius: 10px;\n  padding: 6px;\n  color: #717171;\n  background: #fff;\n  border: solid 1px #cccccc;\n  font-family: sans-serif;\n  font-size: 12px;\n  text-align: center;\n}\n\n.morris-hover.morris-default-style .morris-hover-row-label {\n  font-weight: bold;\n  margin: 0.25em 0;\n}\n\n.morris-hover.morris-default-style .morris-hover-point {\n  white-space: nowrap;\n  margin: 0.1em 0;\n}\n\n.chart-sparkline {\n  position: absolute;\n  left: 0;\n  top: 0;\n  visibility: hidden;\n  background: #999999 transparent;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);\n  color: #fff;\n  font: 10px arial, sans-serif;\n  text-align: left;\n  white-space: nowrap;\n  padding: 5px;\n  border: 1px solid #fff;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  z-index: 10000;\n}\n\n.chart-sparkline .jqsfield {\n  color: #fff;\n  font: 10px arial, sans-serif;\n  text-align: left;\n}\n\n.radial-bar {\n  position: relative;\n  display: inline-block;\n  border-radius: 50%;\n  background-color: transparent;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  width: 80px;\n  height: 80px;\n  font-size: 18px;\n  font-family: Open Sans, sans-serif;\n  background-clip: content-box;\n}\n\n.radial-bar:after {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 500;\n  color: #455a64;\n  content: attr(data-label);\n  background-color: #fff;\n  z-index: 1;\n  width: 56px;\n  height: 56px;\n  margin-left: 12px;\n  margin-top: 12px;\n  line-height: 56px;\n}\n\n.radial-bar>img {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  text-align: center;\n  font-weight: 500;\n  color: #455a64;\n  z-index: 3;\n  width: 56px;\n  height: 56px;\n  margin-left: 12px;\n  margin-top: 12px;\n  line-height: 56px;\n}\n\n.radial-bar.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #448aff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #448aff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #448aff), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #448aff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-55 {\n  background-image: linear-gradient(288deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-60 {\n  background-image: linear-gradient(306deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-65 {\n  background-image: linear-gradient(324deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-70 {\n  background-image: linear-gradient(342deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #448aff), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #448aff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-80 {\n  background-image: linear-gradient(378deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-85 {\n  background-image: linear-gradient(396deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-90 {\n  background-image: linear-gradient(414deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-95 {\n  background-image: linear-gradient(432deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #448aff), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #448aff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #448aff 50%, transparent 50%, transparent), linear-gradient(270deg, #448aff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #ab8ce4), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #ab8ce4), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #ab8ce4), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #ab8ce4), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-55 {\n  background-image: linear-gradient(288deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-60 {\n  background-image: linear-gradient(306deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-65 {\n  background-image: linear-gradient(324deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-70 {\n  background-image: linear-gradient(342deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #ab8ce4), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #ab8ce4), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-80 {\n  background-image: linear-gradient(378deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-85 {\n  background-image: linear-gradient(396deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-90 {\n  background-image: linear-gradient(414deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-95 {\n  background-image: linear-gradient(432deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-primary.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ab8ce4), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #ab8ce4), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #ab8ce4 50%, transparent 50%, transparent), linear-gradient(270deg, #ab8ce4 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #26c6da), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #26c6da), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #26c6da), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #26c6da), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-55 {\n  background-image: linear-gradient(288deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-60 {\n  background-image: linear-gradient(306deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-65 {\n  background-image: linear-gradient(324deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-70 {\n  background-image: linear-gradient(342deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #26c6da), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #26c6da), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-80 {\n  background-image: linear-gradient(378deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-85 {\n  background-image: linear-gradient(396deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-90 {\n  background-image: linear-gradient(414deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-95 {\n  background-image: linear-gradient(432deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-secondary.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #26c6da), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #26c6da), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #26c6da 50%, transparent 50%, transparent), linear-gradient(270deg, #26c6da 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #00c292), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #00c292), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #00c292), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #00c292), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-55 {\n  background-image: linear-gradient(288deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-60 {\n  background-image: linear-gradient(306deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-65 {\n  background-image: linear-gradient(324deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-70 {\n  background-image: linear-gradient(342deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #00c292), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #00c292), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-80 {\n  background-image: linear-gradient(378deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-85 {\n  background-image: linear-gradient(396deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-90 {\n  background-image: linear-gradient(414deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-95 {\n  background-image: linear-gradient(432deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-success.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #00c292), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #00c292), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #00c292 50%, transparent 50%, transparent), linear-gradient(270deg, #00c292 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #4099ff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #4099ff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #4099ff), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #4099ff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-55 {\n  background-image: linear-gradient(288deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-60 {\n  background-image: linear-gradient(306deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-65 {\n  background-image: linear-gradient(324deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-70 {\n  background-image: linear-gradient(342deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #4099ff), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #4099ff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-80 {\n  background-image: linear-gradient(378deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-85 {\n  background-image: linear-gradient(396deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-90 {\n  background-image: linear-gradient(414deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-95 {\n  background-image: linear-gradient(432deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-info.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #4099ff), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #4099ff), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #4099ff 50%, transparent 50%, transparent), linear-gradient(270deg, #4099ff 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #f3d800), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #f3d800), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #f3d800), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #f3d800), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-55 {\n  background-image: linear-gradient(288deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-60 {\n  background-image: linear-gradient(306deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-65 {\n  background-image: linear-gradient(324deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-70 {\n  background-image: linear-gradient(342deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #f3d800), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #f3d800), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-80 {\n  background-image: linear-gradient(378deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-85 {\n  background-image: linear-gradient(396deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-90 {\n  background-image: linear-gradient(414deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-95 {\n  background-image: linear-gradient(432deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-warning.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #f3d800), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #f3d800), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #f3d800 50%, transparent 50%, transparent), linear-gradient(270deg, #f3d800 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #FF5370), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #FF5370), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #FF5370), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #FF5370), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-55 {\n  background-image: linear-gradient(288deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-60 {\n  background-image: linear-gradient(306deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-65 {\n  background-image: linear-gradient(324deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-70 {\n  background-image: linear-gradient(342deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #FF5370), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #FF5370), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-80 {\n  background-image: linear-gradient(378deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-85 {\n  background-image: linear-gradient(396deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-90 {\n  background-image: linear-gradient(414deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-95 {\n  background-image: linear-gradient(432deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-danger.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #FF5370), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #FF5370), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #FF5370 50%, transparent 50%, transparent), linear-gradient(270deg, #FF5370 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #fe8a7d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #fe8a7d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #fe8a7d), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #fe8a7d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-55 {\n  background-image: linear-gradient(288deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-60 {\n  background-image: linear-gradient(306deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-65 {\n  background-image: linear-gradient(324deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-70 {\n  background-image: linear-gradient(342deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #fe8a7d), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #fe8a7d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-80 {\n  background-image: linear-gradient(378deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-85 {\n  background-image: linear-gradient(396deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-90 {\n  background-image: linear-gradient(414deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-95 {\n  background-image: linear-gradient(432deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-default.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #fe8a7d), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #fe8a7d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fe8a7d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #fb6d9d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #fb6d9d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #fb6d9d), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #fb6d9d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-55 {\n  background-image: linear-gradient(288deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-60 {\n  background-image: linear-gradient(306deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-65 {\n  background-image: linear-gradient(324deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-70 {\n  background-image: linear-gradient(342deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #fb6d9d), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #fb6d9d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-80 {\n  background-image: linear-gradient(378deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-85 {\n  background-image: linear-gradient(396deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-90 {\n  background-image: linear-gradient(414deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-95 {\n  background-image: linear-gradient(432deg, #fb6d9d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-pink.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #fe8a7d), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #fb6d9d), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #fe8a7d 50%, transparent 50%, transparent), linear-gradient(270deg, #fb6d9d 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #536dfe), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #536dfe), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #536dfe), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #536dfe), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-55 {\n  background-image: linear-gradient(288deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-60 {\n  background-image: linear-gradient(306deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-65 {\n  background-image: linear-gradient(324deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-70 {\n  background-image: linear-gradient(342deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #536dfe), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #536dfe), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-80 {\n  background-image: linear-gradient(378deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-85 {\n  background-image: linear-gradient(396deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-90 {\n  background-image: linear-gradient(414deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-95 {\n  background-image: linear-gradient(432deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-purple.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #536dfe), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #536dfe), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #536dfe 50%, transparent 50%, transparent), linear-gradient(270deg, #536dfe 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-0 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #4c5667), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(90deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-5 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(108deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-10 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(126deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-15 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(144deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-20 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(162deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #ddd), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #4c5667), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(180deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-30 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(198deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-35 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-40 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(234deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-45 {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(252deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #4c5667), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #4c5667), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-55 {\n  background-image: linear-gradient(288deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-60 {\n  background-image: linear-gradient(306deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-65 {\n  background-image: linear-gradient(324deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-70 {\n  background-image: linear-gradient(342deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #4c5667), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #4c5667), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-80 {\n  background-image: linear-gradient(378deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-85 {\n  background-image: linear-gradient(396deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-90 {\n  background-image: linear-gradient(414deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-95 {\n  background-image: linear-gradient(432deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar-inverse.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #4c5667), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #4c5667), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(450deg, #4c5667 50%, transparent 50%, transparent), linear-gradient(270deg, #4c5667 50%, #ddd 50%, #ddd);\n}\n\n.radial-bar.radial-bar-lg {\n  width: 100px;\n  height: 100px;\n  font-size: 20px;\n}\n\n.radial-bar.radial-bar-sm {\n  width: 50px;\n  height: 50px;\n  font-size: 12px;\n}\n\n.radial-bar.radial-bar-xs {\n  width: 30px;\n  height: 30px;\n  font-size: 8px;\n}\n\n.pieLabel div {\n  color: #fff !important;\n}\n\n.pieLabel div input[type=checkbox] {\n  margin: 7px;\n}\n\n/**=====================\n     41. Chart CSS End\n==========================**/\n/**=====================\n     42. Timeline CSS Start\n==========================**/\n.cd-container {\n  width: 90%;\n  max-width: 1170px;\n  margin: 0 auto;\n}\n\n.cd-container::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n\nheader {\n  height: 200px;\n  line-height: 200px;\n  text-align: center;\n  background: #2a3142;\n}\n\nheader h1 {\n  color: #fff;\n  font-size: 18px;\n}\n\n@media only screen and (min-width: 1170px) {\n  header {\n    height: 300px;\n    line-height: 300px;\n  }\n\n  header h1 {\n    font-size: 24px;\n  }\n\n  #cd-timeline::before {\n    left: 50% !important;\n    margin-left: -2px;\n  }\n\n  .cd-timeline-block {\n    margin: 4em 0;\n  }\n\n  .cd-timeline-block:first-child {\n    margin-top: 0;\n  }\n\n  .cd-timeline-block:last-child {\n    margin-bottom: 0;\n  }\n\n  .cd-timeline-block:nth-child(even) .cd-timeline-content {\n    float: right;\n  }\n\n  .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {\n    left: auto;\n    right: 122%;\n    text-align: right;\n  }\n\n  .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n    top: 24px;\n    left: auto;\n    right: 100%;\n    border-color: transparent;\n    border-right-color: #eeeeee;\n  }\n\n  .cd-timeline-img {\n    width: 60px;\n    height: 60px;\n    left: 50%;\n    margin-left: -30px;\n  }\n\n  .cd-timeline-img>i {\n    font-size: 18px;\n    top: 50%;\n    left: 50%;\n    padding: 3px;\n  }\n\n  .cssanimations .cd-timeline-img.is-hidden {\n    visibility: hidden;\n  }\n\n  .cssanimations .cd-timeline-img.bounce-in {\n    visibility: visible;\n    -webkit-animation: cd-bounce-1 0.6s;\n    animation: cd-bounce-1 0.6s;\n  }\n\n  .cssanimations .cd-timeline-content.is-hidden {\n    visibility: hidden;\n  }\n\n  .cssanimations .cd-timeline-content.bounce-in {\n    visibility: visible;\n    -webkit-animation: cd-bounce-2 0.6s;\n    animation: cd-bounce-2 0.6s;\n  }\n\n  .cssanimations .cd-timeline-block:nth-child(even) .cd-timeline-content.bounce-in {\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n\n  .cd-timeline-content {\n    margin-left: 0;\n    padding: 1.6em;\n    width: 45%;\n  }\n\n  .cd-timeline-content .cd-date {\n    position: absolute;\n    width: 100%;\n    left: 122%;\n    top: 6px;\n    font-size: 16px;\n  }\n\n  .cd-timeline-content::before {\n    top: 24px;\n    left: 100%;\n    border-color: transparent;\n    border-left-color: #fff;\n  }\n}\n\n#cd-timeline {\n  position: relative;\n  padding: 2em 0;\n}\n\n#cd-timeline::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  font-size: 1.5rem;\n  height: 100%;\n  width: 2px;\n  background: #eeeeee;\n  left: -15px;\n}\n\n.cd-timeline-block {\n  position: relative;\n  margin: 30px 0;\n}\n\n.cd-timeline-block:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.cd-timeline-block:first-child {\n  margin-top: 0;\n}\n\n.cd-timeline-block:last-child {\n  margin-bottom: 0;\n}\n\n.cd-timeline-img {\n  width: 60px;\n  height: 60px;\n  left: 50%;\n  margin-left: -30px;\n  -webkit-transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  position: absolute;\n  top: 0;\n  border-radius: 4px;\n}\n\n.cd-timeline-img i {\n  display: block;\n  position: relative;\n  left: 45%;\n  top: 44%;\n  margin-left: -12px;\n  margin-top: -12px;\n  font-size: 27px;\n  color: #fff;\n}\n\n@-webkit-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n  }\n\n  60% {\n    opacity: 1;\n  }\n}\n\n@keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n.cd-timeline-content {\n  position: relative;\n  background: #f6f6f6;\n  border-radius: 4px;\n  padding: 30px;\n  -webkit-box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n  box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.08);\n}\n\n.cd-timeline-content p {\n  padding-top: 9px;\n}\n\n.cd-timeline-content h4 {\n  margin-bottom: 0;\n}\n\n.cd-timeline-content:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.cd-timeline-content audio {\n  width: 100%;\n}\n\n.cd-timeline-content .cd-date {\n  font-size: 13px;\n  display: inline-block;\n  float: left;\n  padding: .8em 0 0;\n  opacity: .7;\n}\n\n.cd-timeline-content::before {\n  content: '';\n  position: absolute;\n  top: 16px;\n  right: 100%;\n  height: 0;\n  width: 0;\n  border: 7px solid transparent;\n  border-left: 7px solid #eeeeee;\n}\n\n@media only screen and (min-width: 768px) {\n  .cd-timeline-content .cd-date {\n    font-size: 14px;\n    padding-bottom: 0;\n  }\n}\n\n@-webkit-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n  }\n\n  60% {\n    opacity: 1;\n  }\n}\n\n@keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n    transform: translateX(-100px);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    transform: translateX(20px);\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n@-webkit-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n  }\n\n  60% {\n    opacity: 1;\n  }\n}\n\n@keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    transform: translateX(100px);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    transform: translateX(-20px);\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n@media only screen and (max-width: 1169px) {\n  .cd-timeline-block .cd-timeline-img {\n    left: -2px;\n    height: 30px;\n    width: 30px;\n    margin-left: -30px;\n    top: 14px;\n    z-index: 8;\n  }\n\n  .cd-timeline-block .cd-timeline-img>i {\n    font-size: 15px;\n    top: 16px;\n    left: 17px;\n    padding: 3px;\n  }\n\n  .landing-main #cd-timeline::before {\n    left: -39px;\n  }\n\n  .landing-main .cd-timeline-block .cd-timeline-img {\n    left: -34px;\n    height: 50px;\n    width: 50px;\n    top: 1px;\n    z-index: 8;\n  }\n\n  .landing-main .cd-timeline-block .cd-timeline-img>i {\n    font-size: 23px;\n    top: 21px;\n    left: 7px;\n    padding: 3px;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .cd-timeline-content {\n    padding: 15px;\n  }\n\n  .cd-timeline-content h4 {\n    font-size: 18px;\n  }\n}\n\n/**=====================\n     42. Timeline  CSS Ends\n==========================**/\n/**=====================\n    43. Timeline 2 CSS Start\n==========================**/\n.timeliny {\n  position: relative;\n  display: block;\n  padding: 10rem 0;\n  width: 100%;\n  border-top: 1px solid #f6f6f6;\n  border-bottom: 1px solid #f6f6f6;\n  text-rendering: optimizeLegibility;\n  color: #eeeeee;\n  opacity: 0;\n  overflow: hidden;\n  cursor: move;\n}\n\n.timeliny.loaded {\n  opacity: 1;\n}\n\n.timeliny::before {\n  content: '';\n  position: absolute;\n  background-color: #717171;\n  width: 100%;\n  height: 1px;\n  top: 50%;\n  left: 0;\n}\n\n.timeliny .timeliny-wrapper {\n  display: block;\n  margin: auto;\n  width: 100%;\n  max-width: 1024px;\n}\n\n.timeliny .timeliny-dot {\n  -webkit-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  margin-top: -0.6rem;\n  width: 1.2rem;\n  height: 1.2rem;\n  border-radius: 50%;\n  border: 1px solid #717171;\n  background-color: #fff;\n}\n\n.timeliny .timeliny-dot::before {\n  -webkit-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  content: attr(data-year);\n  display: block;\n  position: absolute;\n  top: -5rem;\n  left: 1.25rem;\n  color: #2a3142;\n  font-family: Open Sans;\n  font-size: 22px;\n}\n\n.timeliny .timeliny-dot::after {\n  -webkit-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  content: attr(data-text);\n  display: block;\n  position: absolute;\n  width: 256px;\n  top: 5.6rem;\n  left: 1.25rem;\n  color: #eeeeee;\n  opacity: 0;\n  font-size: 0.9em;\n}\n\n@media (min-width: 768px) {\n  .timeliny .timeliny-dot::after {\n    width: 341.3333333333px;\n  }\n}\n\n.timeliny .timeliny-timeline {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  display: table;\n  width: 100%;\n  z-index: 5;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock {\n  display: table-cell;\n  position: relative;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot {\n  border-color: #ab8ce4;\n  background-color: #ab8ce4;\n  -webkit-box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.33);\n  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.33);\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {\n  color: #2a3142;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::after {\n  color: #2a3142;\n  opacity: 1;\n  background-color: #ddcef7;\n  border: 1px solid #ddd;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot {\n  cursor: move;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock.inactive .timeliny-dot::before {\n  color: #eeeeee;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {\n  border-color: #2a3142;\n  background-color: #2a3142;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {\n  color: #2a3142;\n}\n\n.timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {\n  color: #2a3142;\n  opacity: 1;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.timeliny .timeliny-vertical-line {\n  position: absolute;\n  display: block;\n  z-index: 1;\n  left: 16%;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  background-color: #ab8ce4;\n}\n\n@media (min-width: 768px) {\n  .timeliny .timeliny-vertical-line {\n    left: 32%;\n  }\n}\n\n.timeliny .timeliny-vertical-line::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -7px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #ab8ce4;\n}\n\n.timeliny .timeliny-vertical-line::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: -7px;\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid #ab8ce4;\n}\n\n/**=====================\n     43. Timeline 2 CSS Ends\n==========================**/\n/**=====================\n    44. Tabs CSS Start\n==========================**/\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  background-color: #ab8ce4;\n}\n\n.nav i {\n  margin-right: 10px;\n}\n\n.nav-theme .nav-link,\n.nav-pills.nav-theme .nav-link {\n  color: #ab8ce4;\n}\n\n.nav-theme .nav-link.active,\n.nav-theme .show>.nav-link,\n.nav-pills.nav-theme .nav-link.active,\n.nav-pills.nav-theme .show>.nav-link {\n  background-color: #ab8ce4;\n  color: #fff;\n}\n\n.nav-primary .nav-link,\n.nav-pills.nav-primary .nav-link {\n  color: #ab8ce4;\n}\n\n.nav-primary .nav-link.active,\n.nav-primary .show>.nav-link,\n.nav-pills.nav-primary .nav-link.active,\n.nav-pills.nav-primary .show>.nav-link {\n  background-color: #ab8ce4;\n  color: #fff;\n}\n\n.nav-secondary .nav-link,\n.nav-pills.nav-secondary .nav-link {\n  color: #26c6da;\n}\n\n.nav-secondary .nav-link.active,\n.nav-secondary .show>.nav-link,\n.nav-pills.nav-secondary .nav-link.active,\n.nav-pills.nav-secondary .show>.nav-link {\n  background-color: #26c6da;\n  color: #fff;\n}\n\n.nav-success .nav-link,\n.nav-pills.nav-success .nav-link {\n  color: #00c292;\n}\n\n.nav-success .nav-link.active,\n.nav-success .show>.nav-link,\n.nav-pills.nav-success .nav-link.active,\n.nav-pills.nav-success .show>.nav-link {\n  background-color: #00c292;\n  color: #fff;\n}\n\n.nav-danger .nav-link,\n.nav-pills.nav-danger .nav-link {\n  color: #FF5370;\n}\n\n.nav-danger .nav-link.active,\n.nav-danger .show>.nav-link,\n.nav-pills.nav-danger .nav-link.active,\n.nav-pills.nav-danger .show>.nav-link {\n  background-color: #FF5370;\n  color: #fff;\n}\n\n.nav-info .nav-link,\n.nav-pills.nav-info .nav-link {\n  color: #4099ff;\n}\n\n.nav-info .nav-link.active,\n.nav-info .show>.nav-link,\n.nav-pills.nav-info .nav-link.active,\n.nav-pills.nav-info .show>.nav-link {\n  background-color: #4099ff;\n  color: #fff;\n}\n\n.nav-light .nav-link,\n.nav-pills.nav-light .nav-link {\n  color: #eeeeee;\n}\n\n.nav-light .nav-link.active,\n.nav-light .show>.nav-link,\n.nav-pills.nav-light .nav-link.active,\n.nav-pills.nav-light .show>.nav-link {\n  background-color: #eeeeee;\n  color: #fff;\n}\n\n.nav-dark .nav-link,\n.nav-pills.nav-dark .nav-link {\n  color: #2a3142;\n}\n\n.nav-dark .nav-link.active,\n.nav-dark .show>.nav-link,\n.nav-pills.nav-dark .nav-link.active,\n.nav-pills.nav-dark .show>.nav-link {\n  background-color: #2a3142;\n  color: #fff;\n}\n\n.nav-warning .nav-link,\n.nav-pills.nav-warning .nav-link {\n  color: #f3d800;\n}\n\n.nav-warning .nav-link.active,\n.nav-warning .show>.nav-link,\n.nav-pills.nav-warning .nav-link.active,\n.nav-pills.nav-warning .show>.nav-link {\n  background-color: #f3d800;\n  color: #fff;\n}\n\n.nav-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.nav-tabs.nav-bottom .nav-item .nav-link.active,\n.nav-tabs.nav-bottom .nav-item .nav-link.focus,\n.nav-tabs.nav-bottom .nav-item .nav-link.hover {\n  border-color: #fff #eeeeee #ddd;\n}\n\n.tab-content~.nav-tabs.nav-material {\n  margin-bottom: 0;\n  margin-top: 30px;\n}\n\n.nav-material.nav-tabs {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-wrap: nowrap;\n  flex-wrap: nowrap;\n  margin-bottom: 30px;\n}\n\n.nav-material.nav-tabs .nav-item .nav-link {\n  font-size: 16px;\n  color: #2a3142;\n  text-align: center;\n  padding: 10px 25px;\n  border: 0;\n}\n\n.nav-material.nav-tabs .nav-link.active,\n.nav-material.nav-tabs .nav-item.show,\n.nav-material.nav-tabs .nav-link:focus,\n.nav-material.nav-tabs .nav-link:hover {\n  color: #ab8ce4;\n}\n\n.nav-material.nav-tabs .material-border {\n  border-bottom: 2px solid #ab8ce4;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  opacity: 0;\n}\n\n.nav-material.nav-tabs .nav-link.active~.material-border {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  opacity: 1;\n}\n\n.nav-material.nav-left .nav-link {\n  border-left: 2px solid transparent;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  color: #2a3142;\n}\n\n.nav-material.nav-left .nav-link.active,\n.nav-material.nav-left .show>.nav-link {\n  background-color: transparent;\n  border-left-color: #ab8ce4;\n  color: #ab8ce4;\n  border-radius: 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.nav-material.nav-right .nav-link {\n  border-right: 2px solid transparent;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  color: #2a3142;\n  text-align: right;\n}\n\n.nav-material.nav-right .nav-link.active,\n.nav-material.nav-right .show>.nav-link {\n  background-color: transparent;\n  border-right-color: #ab8ce4;\n  color: #ab8ce4;\n  border-radius: 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.nav-material.nav-theme .nav-link.active,\n.nav-material.nav-theme .nav-item.show,\n.nav-material.nav-theme .nav-link:focus,\n.nav-material.nav-theme .nav-link:hover {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\n.nav-material.nav-theme .material-border {\n  border-bottom: 2px solid #ab8ce4;\n}\n\n.nav-material.nav-left.nav-theme .nav-link.active,\n.nav-material.nav-left.nav-theme .show>.nav-link {\n  border-left-color: #ab8ce4;\n  color: #ab8ce4;\n}\n\n.nav-material.nav-right.nav-theme .nav-link.active,\n.nav-material.nav-right.nav-theme .show>.nav-link {\n  border-right-color: #ab8ce4;\n  color: #ab8ce4;\n}\n\n.nav-material.nav-primary .nav-link.active,\n.nav-material.nav-primary .nav-item.show,\n.nav-material.nav-primary .nav-link:focus,\n.nav-material.nav-primary .nav-link:hover {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\n.nav-material.nav-primary .material-border {\n  border-bottom: 2px solid #ab8ce4;\n}\n\n.nav-material.nav-left.nav-primary .nav-link.active,\n.nav-material.nav-left.nav-primary .show>.nav-link {\n  border-left-color: #ab8ce4;\n  color: #ab8ce4;\n}\n\n.nav-material.nav-right.nav-primary .nav-link.active,\n.nav-material.nav-right.nav-primary .show>.nav-link {\n  border-right-color: #ab8ce4;\n  color: #ab8ce4;\n}\n\n.nav-material.nav-secondary .nav-link.active,\n.nav-material.nav-secondary .nav-item.show,\n.nav-material.nav-secondary .nav-link:focus,\n.nav-material.nav-secondary .nav-link:hover {\n  color: #26c6da;\n  background-color: transparent;\n}\n\n.nav-material.nav-secondary .material-border {\n  border-bottom: 2px solid #26c6da;\n}\n\n.nav-material.nav-left.nav-secondary .nav-link.active,\n.nav-material.nav-left.nav-secondary .show>.nav-link {\n  border-left-color: #26c6da;\n  color: #26c6da;\n}\n\n.nav-material.nav-right.nav-secondary .nav-link.active,\n.nav-material.nav-right.nav-secondary .show>.nav-link {\n  border-right-color: #26c6da;\n  color: #26c6da;\n}\n\n.nav-material.nav-success .nav-link.active,\n.nav-material.nav-success .nav-item.show,\n.nav-material.nav-success .nav-link:focus,\n.nav-material.nav-success .nav-link:hover {\n  color: #00c292;\n  background-color: transparent;\n}\n\n.nav-material.nav-success .material-border {\n  border-bottom: 2px solid #00c292;\n}\n\n.nav-material.nav-left.nav-success .nav-link.active,\n.nav-material.nav-left.nav-success .show>.nav-link {\n  border-left-color: #00c292;\n  color: #00c292;\n}\n\n.nav-material.nav-right.nav-success .nav-link.active,\n.nav-material.nav-right.nav-success .show>.nav-link {\n  border-right-color: #00c292;\n  color: #00c292;\n}\n\n.nav-material.nav-danger .nav-link.active,\n.nav-material.nav-danger .nav-item.show,\n.nav-material.nav-danger .nav-link:focus,\n.nav-material.nav-danger .nav-link:hover {\n  color: #FF5370;\n  background-color: transparent;\n}\n\n.nav-material.nav-danger .material-border {\n  border-bottom: 2px solid #FF5370;\n}\n\n.nav-material.nav-left.nav-danger .nav-link.active,\n.nav-material.nav-left.nav-danger .show>.nav-link {\n  border-left-color: #FF5370;\n  color: #FF5370;\n}\n\n.nav-material.nav-right.nav-danger .nav-link.active,\n.nav-material.nav-right.nav-danger .show>.nav-link {\n  border-right-color: #FF5370;\n  color: #FF5370;\n}\n\n.nav-material.nav-info .nav-link.active,\n.nav-material.nav-info .nav-item.show,\n.nav-material.nav-info .nav-link:focus,\n.nav-material.nav-info .nav-link:hover {\n  color: #4099ff;\n  background-color: transparent;\n}\n\n.nav-material.nav-info .material-border {\n  border-bottom: 2px solid #4099ff;\n}\n\n.nav-material.nav-left.nav-info .nav-link.active,\n.nav-material.nav-left.nav-info .show>.nav-link {\n  border-left-color: #4099ff;\n  color: #4099ff;\n}\n\n.nav-material.nav-right.nav-info .nav-link.active,\n.nav-material.nav-right.nav-info .show>.nav-link {\n  border-right-color: #4099ff;\n  color: #4099ff;\n}\n\n.nav-material.nav-light .nav-link.active,\n.nav-material.nav-light .nav-item.show,\n.nav-material.nav-light .nav-link:focus,\n.nav-material.nav-light .nav-link:hover {\n  color: #eeeeee;\n  background-color: transparent;\n}\n\n.nav-material.nav-light .material-border {\n  border-bottom: 2px solid #eeeeee;\n}\n\n.nav-material.nav-left.nav-light .nav-link.active,\n.nav-material.nav-left.nav-light .show>.nav-link {\n  border-left-color: #eeeeee;\n  color: #eeeeee;\n}\n\n.nav-material.nav-right.nav-light .nav-link.active,\n.nav-material.nav-right.nav-light .show>.nav-link {\n  border-right-color: #eeeeee;\n  color: #eeeeee;\n}\n\n.nav-material.nav-dark .nav-link.active,\n.nav-material.nav-dark .nav-item.show,\n.nav-material.nav-dark .nav-link:focus,\n.nav-material.nav-dark .nav-link:hover {\n  color: #2a3142;\n  background-color: transparent;\n}\n\n.nav-material.nav-dark .material-border {\n  border-bottom: 2px solid #2a3142;\n}\n\n.nav-material.nav-left.nav-dark .nav-link.active,\n.nav-material.nav-left.nav-dark .show>.nav-link {\n  border-left-color: #2a3142;\n  color: #2a3142;\n}\n\n.nav-material.nav-right.nav-dark .nav-link.active,\n.nav-material.nav-right.nav-dark .show>.nav-link {\n  border-right-color: #2a3142;\n  color: #2a3142;\n}\n\n.nav-material.nav-warning .nav-link.active,\n.nav-material.nav-warning .nav-item.show,\n.nav-material.nav-warning .nav-link:focus,\n.nav-material.nav-warning .nav-link:hover {\n  color: #f3d800;\n  background-color: transparent;\n}\n\n.nav-material.nav-warning .material-border {\n  border-bottom: 2px solid #f3d800;\n}\n\n.nav-material.nav-left.nav-warning .nav-link.active,\n.nav-material.nav-left.nav-warning .show>.nav-link {\n  border-left-color: #f3d800;\n  color: #f3d800;\n}\n\n.nav-material.nav-right.nav-warning .nav-link.active,\n.nav-material.nav-right.nav-warning .show>.nav-link {\n  border-right-color: #f3d800;\n  color: #f3d800;\n}\n\n.tabbed-card ul {\n  position: absolute;\n  right: 15px;\n  top: 22px;\n}\n\n.tabbed-card ul.nav-material.nav-tabs {\n  top: 0;\n}\n\n.tabbed-card ul.nav-material.nav-tabs .nav-item {\n  float: right;\n}\n\n.tabbed-card ul.nav-material.nav-tabs .nav-item .nav-link {\n  padding: 28px 15px;\n}\n\n/**=====================\n     44. Tabs CSS Ends\n==========================**/\n/**=====================\n     45. Gallery CSS Start\n==========================**/\n.gallery {\n  margin-bottom: -30px;\n}\n\n.gallery>a {\n  margin-bottom: 30px;\n}\n\n.gallery>a:before {\n  content: \"\\edee\";\n  font-family: IcoFont;\n  position: absolute;\n  height: calc(100% - 10px);\n  left: 20px;\n  width: calc(100% - 40px);\n  background-color: rgba(255, 255, 255, 0.27);\n  top: 5px;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-size: 30px;\n  color: #000;\n}\n\n.gallery>a:hover:before {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.gallery>a .img-thumbnail {\n  border-radius: 0;\n}\n\n.gallery-with-description {\n  margin-bottom: -30px;\n}\n\n.gallery-with-description a>div {\n  padding: 10px;\n  border: 1px solid #e4e6ee;\n  margin-bottom: 30px;\n}\n\n.gallery-with-description a:hover {\n  text-decoration: none !important;\n}\n\n.gallery-with-description h4 {\n  color: #2a3142;\n  margin-top: 15px;\n  font-size: 18px;\n}\n\n.gallery-with-description p {\n  color: #b1b1b1;\n}\n\n.lg-backdrop {\n  background-color: #fff;\n}\n\n.lg-outer .lg-actions .lg-next,\n.lg-outer .lg-actions .lg-prev {\n  background-color: white;\n  border: 1px solid #ddd;\n}\n\n.lg-outer .lg-actions .lg-next:hover,\n.lg-outer .lg-actions .lg-prev:hover {\n  color: #2a3142;\n}\n\n.lg-outer .lg-toolbar {\n  background-color: rgba(255, 255, 255, 0.45);\n  border-bottom: 1px solid #2a3142;\n}\n\n.lg-outer .lg-toolbar .lg-icon:hover {\n  color: #2a3142;\n}\n\n.lg-outer #lg-counter {\n  color: #2a3142;\n}\n\n.lg-outer .lg-sub-html {\n  background-color: rgba(255, 255, 255, 0.45);\n}\n\n.lg-outer .lg-sub-html h4 {\n  font-size: inherit;\n  color: #2a3142;\n}\n\n.lg-outer .lg-sub-html p {\n  color: #2a3142;\n}\n\n.lg-outer .lg-thumb-outer {\n  background-color: #cccccc;\n}\n\n.lg-outer .lg-thumb-item {\n  padding: 4px;\n  border: 1px solid #ddd;\n  border-radius: 0;\n}\n\n.lg-outer .lg-thumb-item .active,\n.lg-outer .lg-thumb-item:hover {\n  border-color: #000;\n}\n\n.gallery a:before,\n.gallery a:after {\n  content: none;\n}\n\n.gallery .img-hover>div {\n  overflow: hidden;\n}\n\n.gallery .hover-1 img {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-1 img:hover {\n  -webkit-transform: scale(1.2);\n  transform: scale(1.2);\n}\n\n.gallery .hover-2 img {\n  width: 100%;\n  height: auto;\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n  -webkit-transform: translateX(0px);\n  transform: translateX(0px);\n}\n\n.gallery .hover-2:hover img {\n  -webkit-transform: translateX(40px) scale(1.2);\n  transform: translateX(40px) scale(1.2);\n}\n\n.gallery .hover-3 img {\n  -webkit-transform: scale(1.2);\n  transform: scale(1.2);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-3:hover img {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n.gallery .hover-4 img {\n  -webkit-transform: scale(1.5);\n  transform: scale(1.5);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-4:hover img {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n.gallery .hover-5 img {\n  margin-left: 30px;\n  -webkit-transform: scale(1.3);\n  transform: scale(1.3);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-5:hover img {\n  margin-left: 0;\n}\n\n.gallery .hover-6 img {\n  -webkit-transform: rotate(15deg) scale(1.4);\n  transform: rotate(15deg) scale(1.4);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-6:hover img {\n  -webkit-transform: rotate(0) scale(1);\n  transform: rotate(0) scale(1);\n}\n\n.gallery .hover-7 img {\n  -webkit-filter: blur(3px);\n  filter: blur(3px);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-7:hover img {\n  -webkit-filter: blur(0);\n  filter: blur(0);\n}\n\n.gallery .hover-8 img {\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-8:hover img {\n  -webkit-filter: grayscale(0);\n  filter: grayscale(0);\n}\n\n.gallery .hover-9 img {\n  -webkit-filter: sepia(100%);\n  filter: sepia(100%);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-9:hover img {\n  -webkit-filter: sepia(0);\n  filter: sepia(0);\n}\n\n.gallery .hover-10 img {\n  -webkit-filter: grayscale(0) blur(0);\n  filter: grayscale(0) blur(0);\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-10:hover img {\n  -webkit-filter: grayscale(100%) blur(3px);\n  filter: grayscale(100%) blur(3px);\n}\n\n.gallery .hover-11 img {\n  opacity: 1;\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-11:hover img {\n  opacity: .5;\n}\n\n.gallery .hover-12>div {\n  background: #ab8ce4;\n}\n\n.gallery .hover-12>div img {\n  opacity: 1;\n  -webkit-transition: .3s ease-in-out;\n  transition: .3s ease-in-out;\n}\n\n.gallery .hover-12>div:hover img {\n  opacity: .7;\n}\n\n@-webkit-keyframes flash {\n  0% {\n    opacity: .4;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes flash {\n  0% {\n    opacity: .4;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.gallery .hover-13:hover img {\n  opacity: 1;\n  -webkit-animation: flash 1.5s;\n  animation: flash 1.5s;\n}\n\n@-webkit-keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n\n@keyframes shine {\n  100% {\n    left: 125%;\n  }\n}\n\n.gallery .hover-14 div {\n  position: relative;\n}\n\n.gallery .hover-14 div:before {\n  position: absolute;\n  top: 0;\n  left: -75%;\n  z-index: 2;\n  display: block;\n  content: '';\n  width: 50%;\n  height: 100%;\n  background: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, 0)), to(rgba(255, 255, 255, 0.3)));\n  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);\n  -webkit-transform: skewX(-25deg);\n  transform: skewX(-25deg);\n}\n\n.gallery .hover-14 div:hover:before {\n  -webkit-animation: shine .75s;\n  animation: shine .75s;\n}\n\n.gallery .hover-15 div {\n  position: relative;\n}\n\n.gallery .hover-15 div:before {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 2;\n  display: block;\n  content: '';\n  width: 0;\n  height: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 100%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n\n.gallery .hover-15 div:hover:before {\n  -webkit-animation: circle .75s;\n  animation: circle .75s;\n}\n\n@-webkit-keyframes circle {\n  0% {\n    opacity: 1;\n  }\n\n  40% {\n    opacity: 1;\n  }\n\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n\n@keyframes circle {\n  0% {\n    opacity: 1;\n  }\n\n  40% {\n    opacity: 1;\n  }\n\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n\n* {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n*:after,\n*:before {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.grid {\n  position: relative;\n}\n\n/* clear fix */\n.grid:after {\n  content: '';\n  display: block;\n  clear: both;\n}\n\n/* ---- .grid-item ---- */\n.grid-item img {\n  max-width: 100%;\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n\n.gallery-with-description .grid-item img {\n  border: 0;\n  padding: 0;\n}\n\n/**=====================\n     45. Gallery CSS Ends\n==========================**/\n/**=====================\n    46. Blog CSS start\n==========================**/\n.blog-box img {\n  border-radius: 0.25rem;\n}\n\n.blog-box .top-radius-blog {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.blog-box h6 {\n  font-weight: 600;\n  margin: 15px 0;\n}\n\n.blog-box .blog-details {\n  padding-right: 20px;\n}\n\n.blog-box .blog-details .blog-social {\n  margin-top: 30px;\n}\n\n.blog-box .blog-details .blog-social li {\n  display: inline-block;\n  font-size: 12px;\n  color: #777777;\n}\n\n.blog-box .blog-details .blog-social li+li {\n  padding-left: 40px;\n  line-height: 1;\n  padding-right: 0;\n}\n\n.blog-box .blog-details .blog-social li i {\n  padding-right: 5px;\n}\n\n.blog-box .blog-details .blog-social li:first-child {\n  border-right: 1px solid #777777;\n  padding-right: 40px;\n}\n\n.blog-box .blog-details-main .blog-social {\n  margin: 20px 0;\n}\n\n.blog-box .blog-details-main .blog-social li {\n  display: inline-block;\n  font-size: 12px;\n  color: #777777;\n  padding: 0 24px;\n  border-right: 1px solid;\n}\n\n.blog-box .blog-details-main .blog-social li:last-child {\n  border-right: 0;\n}\n\n.blog-box .blog-details-main .blog-social li i {\n  padding-right: 5px;\n}\n\n.blog-box .blog-details-main .blog-bottom-details {\n  margin: 20px;\n  font-size: 14px;\n  line-height: 1.714;\n  font-weight: 700;\n}\n\n.blog-box .blog-date {\n  color: #777777;\n}\n\n.blog-box .blog-date span {\n  font-size: 36px;\n  font-weight: 500;\n  padding-right: 5px;\n}\n\n.blog-box.blog-shadow:before {\n  -webkit-box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.6);\n  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.6);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  border-radius: 5px;\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  top: 0;\n  width: 100%;\n  bottom: 0;\n}\n\n.blog-box.blog-shadow:hover:before {\n  -webkit-box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.65);\n  box-shadow: inset 0px -200px 100px -13px rgba(0, 0, 0, 0.65);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.blog-box.blog-shadow .blog-details {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  padding: 40px;\n}\n\n.blog-box.blog-shadow .blog-details h4 {\n  color: #fff;\n  margin-bottom: 0;\n}\n\n.blog-box.blog-shadow .blog-details p {\n  font-size: 14px;\n  color: #fff;\n  margin-bottom: 10px;\n}\n\n.blog-box.blog-shadow .blog-details .blog-social li {\n  color: #fff;\n}\n\n.blog-list .blog-details .blog-social {\n  margin-top: 0;\n}\n\n.blog-list .blog-details h6 {\n  margin-top: 0;\n}\n\n.blog-list .blog-details hr {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.blog-list img {\n  padding: 17px;\n}\n\n.blog-grid img {\n  width: 100%;\n}\n\n.blog-grid .blog-details {\n  padding: 20px;\n}\n\n.blog-grid .blog-details h6 {\n  font-size: 14px;\n  margin-bottom: 0;\n  line-height: 1.8;\n}\n\n.blog-box {\n  position: relative;\n  max-height: 100%;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.blog-box .blog-details p {\n  font-size: 14px;\n  line-height: 2;\n  letter-spacing: 0.7px;\n  margin-top: 30px;\n  margin-bottom: 0;\n  color: #777777;\n}\n\n.blog-box .blog-details h4 {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.5;\n  margin-top: 20px;\n  margin-bottom: 0;\n}\n\n.blog-box .blog-details .single-blog-content-top {\n  margin-top: 30px;\n  border-top: 1px solid #ddd;\n}\n\n.blog-box .blog-details .blog-social li,\n.blog-box .blog-details .comment-social li {\n  font-size: 14px;\n}\n\n.comment-box {\n  padding-top: 60px;\n  padding-bottom: 60px;\n}\n\n.comment-box hr {\n  margin-top: 20px;\n  margin-bottom: 30px;\n}\n\n.comment-box li {\n  margin-bottom: 30px;\n}\n\n.comment-box li:last-child {\n  margin-bottom: 0;\n}\n\n.comment-box ul ul {\n  margin-left: 135px;\n}\n\n.comment-box p {\n  font-size: 14px;\n  line-height: 2;\n  color: #777777;\n  text-align: justify;\n  margin-bottom: 0;\n}\n\n.comment-box h4 {\n  font-weight: 700;\n  letter-spacing: 3px;\n}\n\n.comment-box .media img {\n  margin-right: 45px;\n  border-radius: 50%;\n  height: 90px;\n  padding: 7px;\n  width: 90px;\n  border: 1px solid #ddd;\n}\n\n.comment-box .media h6 {\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.comment-box .media h6 span {\n  padding-left: 10px;\n  font-size: 13px;\n  color: #777777;\n  font-weight: 400;\n}\n\n.comment-box .comment-social li {\n  display: inline-block;\n  color: #999999;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.comment-box .comment-social li:first-child {\n  border-right: 1px solid #ddd;\n  padding-right: 20px;\n}\n\n.comment-box .comment-social li i {\n  padding-right: 10px;\n}\n\n/**=====================\n    46. Blog CSS ends\n==========================**/\n/**=====================\n     47. Footer CSS Start\n==========================**/\n.footer-links {\n  text-align: right;\n}\n\n.footer-links li {\n  display: inline-block;\n  padding-right: 15px;\n}\n\n.footer-links li a {\n  font-size: 12px;\n}\n\nfooter {\n  background-color: #fff;\n  border-top: 1px solid #eeeeee;\n  padding: 15px;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  left: 0;\n}\n\nfooter a {\n  font-weight: 600;\n}\n\nfooter.footer-starter-kit {\n  bottom: -52px;\n}\n\n.dark-footer {\n  background-color: #36404a;\n}\n\n.dark-footer p {\n  color: #fff;\n}\n\n.dark-footer li a {\n  color: #fff;\n}\n\n.page-wrapper .page-body-wrapper .footer-fix {\n  position: fixed;\n  margin-left: 250px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  padding-right: 250px;\n  bottom: 0;\n}\n\n.page-wrapper .sidebar-close .footer-fix {\n  margin-left: 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n/**=====================\n     47. Footer CSS Ends\n==========================**/\n/**=====================\n     48. Form Wizard CSS Start\n==========================**/\n/*Form Wizard One Start*/\n.form-wizard .tab {\n  display: none;\n}\n\n.form-wizard .btn-mb {\n  margin-bottom: 30px;\n}\n\n.form-wizard .step {\n  height: 10px;\n  width: 10px;\n  margin: 0 2px;\n  background-color: #ab8ce4;\n  border: none;\n  border-radius: 50%;\n  display: inline-block;\n  opacity: 0.5;\n}\n\n.form-wizard .step.active {\n  opacity: 1;\n}\n\n.form-wizard .step.finish {\n  background-color: #26c6da;\n}\n\n/*Form Wizard One ends*/\n/*Form Wizard Two Start*/\n.stepwizard {\n  display: table;\n  width: 100%;\n  position: relative;\n  margin-bottom: 30px;\n}\n\n.stepwizard .stepwizard-row {\n  display: table-row;\n}\n\n.stepwizard .stepwizard-row:before {\n  top: 16px;\n  bottom: 0;\n  position: absolute;\n  content: \" \";\n  width: 100%;\n  height: 1px;\n  background-color: #cccccc;\n}\n\n.stepwizard .stepwizard-row .stepwizard-step {\n  display: table-cell;\n  text-align: center;\n  position: relative;\n}\n\n.stepwizard .stepwizard-row .stepwizard-step p {\n  margin-top: 10px;\n}\n\n.stepwizard .stepwizard-row .stepwizard-step button[disabled] {\n  opacity: 1 !important;\n  filter: alpha(opacity=100) !important;\n}\n\n/*Form Wizard Two Ends*/\n/*Form Wizard Three Start*/\n.f1 fieldset {\n  display: none;\n}\n\n.f1 .input-error {\n  border-color: #FF5370;\n}\n\n.f1 .f1-steps {\n  overflow: hidden;\n  position: relative;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.f1 .f1-steps .f1-progress {\n  position: absolute;\n  top: 24px;\n  width: 100%;\n  height: 1px;\n  background: #717171;\n}\n\n.f1 .f1-steps .f1-progress .f1-progress-line {\n  height: 1px;\n  background: #ab8ce4;\n  width: 16%;\n}\n\n.f1 .f1-steps .f1-step {\n  position: relative;\n  float: left;\n  width: 33.333333%;\n  text-align: center;\n}\n\n.f1 .f1-steps .f1-step.activated .f1-step-icon {\n  background: #fff;\n  border: 1px solid #ab8ce4;\n  color: #ab8ce4;\n  line-height: 38px;\n}\n\n.f1 .f1-steps .f1-step.activated p {\n  color: #ab8ce4;\n}\n\n.f1 .f1-steps .f1-step.active .f1-step-icon {\n  width: 48px;\n  height: 48px;\n  background: #ab8ce4;\n  font-size: 22px;\n  line-height: 48px;\n}\n\n.f1 .f1-steps .f1-step.active p {\n  color: #ab8ce4;\n}\n\n.f1 .f1-steps .f1-step p {\n  color: #717171;\n}\n\n.f1 .f1-steps .f1-step .f1-step-icon {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  background: #717171;\n  font-size: 16px;\n  color: #fff;\n  line-height: 40px;\n  border-radius: 50%;\n}\n\n.f1 .f1-buttons {\n  text-align: right;\n}\n\n/*Form Wizard Three ends*/\n/*Form Wizard Four Start*/\n.wizard-4 .buttonDisabled {\n  color: #2a3142;\n  background-color: #eeeeee;\n  border: 1px solid #eeeeee;\n  cursor: text;\n}\n\n.wizard-4 .action-bar .btn {\n  float: right;\n  margin: 0 5px;\n}\n\n.wizard-4 .step-container {\n  position: relative;\n  margin: 0;\n  padding: 0;\n  border: 0 solid #cccccc;\n  overflow: hidden;\n  clear: right;\n  width: 70%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.wizard-4 .step-container div.content {\n  display: block;\n  position: absolute;\n  float: left;\n  height: 295px;\n  text-align: left;\n  overflow: auto;\n  z-index: 1;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  clear: both;\n}\n\n.wizard-4 .loader {\n  display: none;\n}\n\n.wizard-4 .msg-box {\n  position: absolute;\n  display: none;\n  padding: 5px 10px;\n  background-color: #ab8ce4;\n  left: 32%;\n  bottom: 30px;\n  border-radius: 2px;\n}\n\n.wizard-4 .msg-box .content {\n  padding: 0;\n  float: left;\n  padding-top: 3px;\n  color: #fff;\n}\n\n.wizard-4 .msg-box .close {\n  text-shadow: none;\n  color: #fff;\n  margin-left: 10px;\n  opacity: 1;\n}\n\n.wizard-4 ul.anchor {\n  position: relative;\n  display: block;\n  float: left;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border: 0 solid #cccccc;\n  background: transparent;\n  width: 30%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding-right: 30px;\n}\n\n.wizard-4 ul.anchor li {\n  position: relative;\n  display: block;\n  margin: 0;\n  padding: 0;\n  padding-bottom: 19px;\n  float: left;\n  clear: both;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  z-index: 0;\n}\n\n.wizard-4 ul.anchor li a {\n  display: block;\n  position: relative;\n  float: left;\n  margin: 0;\n  padding: 10px 20px;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  text-decoration: none;\n  outline-style: none;\n  z-index: 1;\n  font-size: 18px;\n}\n\n.wizard-4 ul.anchor li a small {\n  display: block;\n  font-size: 14px;\n}\n\n.wizard-4 ul.anchor li a .stepNumber {\n  position: relative;\n  float: left;\n  width: 30px;\n  text-align: center;\n  padding: 5px;\n  padding-top: 0;\n}\n\n.wizard-4 ul.anchor li a.selected {\n  color: #fff;\n  background: #ab8ce4;\n  cursor: text;\n  border-radius: 5px;\n}\n\n.wizard-4 ul.anchor li a.done {\n  position: relative;\n  color: #fff;\n  background: #26c6da;\n  z-index: 99;\n  border-radius: 5px;\n}\n\n.wizard-4 ul.anchor li a.disabled {\n  color: #717171;\n  background: #eeeeee;\n  cursor: text;\n  border-radius: 5px;\n}\n\n.wizard-4 ul.anchor li a.error {\n  color: #717171;\n  background: #fe8a7d;\n  border: 1px solid #FF5370;\n}\n\n.wizard-4 ul.anchor li a.error:hover {\n  color: #000;\n}\n\n/*Form Wizard Four Ends*/\n/**=====================\n    48. Form Wizard CSS Ends\n==========================**/\n/**=====================\n    49. Badge CSS start\n==========================**/\n.badge {\n  padding: 0.44em 0.7em;\n}\n\n/**=====================\n    49. Badge CSS Ends\n==========================**/\n/**=====================\n     50. Tree  CSS Start\n==========================**/\n.jstree-default .jstree-clicked {\n  background-color: white;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #2a3142;\n}\n\n.vakata-context,\n.vakata-context ul {\n  background-color: #fff;\n  border: none;\n  -webkit-box-shadow: 0 0 2px 2px #ddd;\n  box-shadow: 0 0 2px 2px #ddd;\n}\n\n.vakata-context li a .vakata-contextmenu-sep,\n.vakata-context ul li a .vakata-contextmenu-sep {\n  display: none;\n}\n\n.vakata-context li a:hover,\n.vakata-context ul li a:hover {\n  background-color: white;\n  -webkit-box-shadow: None;\n  box-shadow: None;\n}\n\n.vakata-context .vakata-context-separator,\n.vakata-context ul .vakata-context-separator {\n  display: none;\n}\n\n/**=====================\n     50. Tree CSS Ends\n==========================**/\n/**=====================\n     51. Search CSS Start\n==========================**/\n.search-page .search-form input {\n  background-position: 99%;\n}\n\n.search-page .nav-link {\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.search-page .info-block+.info-block {\n  padding-top: 30px;\n  border-top: 1px solid #eeeeee;\n  margin-top: 30px;\n}\n\n.search-page .nav-material.nav-tabs {\n  -webkit-box-align: left;\n  -ms-flex-align: left;\n  align-items: left;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: end;\n}\n\n.search-page .nav-material.nav-tabs .nav-item {\n  width: auto;\n}\n\n.search-page .search-links h6 {\n  margin-bottom: 0;\n}\n\n.search-page p {\n  text-transform: lowercase;\n  margin-bottom: 0;\n  color: #999999;\n}\n\n.search-page ul.search-info li {\n  display: inline-block;\n  font-size: 12px;\n  line-height: 1;\n  font-family: Open Sans;\n  color: #cccccc;\n}\n\n.search-page ul.search-info li+li {\n  border-left: 1px solid #a5afc6;\n  padding-left: 8px;\n  margin-left: 8px;\n}\n\n.search-page ul.search-info li i {\n  color: #f3d800;\n}\n\n.search-page #video-links .embed-responsive+.embed-responsive {\n  margin-top: 30px;\n}\n\n/**=====================\n    51. Search CSS Ends\n==========================**/\n/**=====================\n    52. Datepicker CSS Start\n==========================**/\n.datepicker--day-name {\n  color: #000;\n  font-weight: bold;\n}\n\n.datepicker--cell.-current- {\n  color: #000;\n  border-radius: 5px;\n  font-weight: bold;\n  border: 2px solid #ab8ce4;\n}\n\n.datepicker--cell.-focus- {\n  background: #ab8ce4;\n  color: #fff;\n}\n\n.datepicker--cell.-selected- {\n  background: #ab8ce4;\n}\n\n.daterangepicker.ltr {\n  color: #717171;\n  z-index: 8;\n}\n\n.daterangepicker.ltr tr {\n  font-size: 13px;\n}\n\n.daterangepicker.ltr tr td {\n  height: 34px;\n  width: 34px;\n}\n\n.daterangepicker.ltr tr td.in-range {\n  background-color: #fafafa;\n}\n\n.daterangepicker.ltr tr td.active {\n  background-color: #ab8ce4;\n}\n\n.daterangepicker.ltr .ranges {\n  float: none;\n}\n\n.daterangepicker.ltr .ranges li {\n  color: #ab8ce4;\n}\n\n.daterangepicker.ltr .ranges li:hover {\n  background-color: #ab8ce4;\n  border: 1px solid #ab8ce4;\n  color: #fff;\n}\n\n.daterangepicker.ltr .ranges li.active {\n  background-color: #ab8ce4;\n  border: 1px solid #ab8ce4;\n  color: #fff;\n}\n\n.daterangepicker.ltr .calendar-time select {\n  color: #717171;\n}\n\n.datetime-picker .bootstrap-datetimepicker-widget.dropdown-menu {\n  width: auto;\n}\n\n.date-range-picker .theme-form {\n  margin-bottom: 30px;\n}\n\n.date-range-picker>div:last-child .theme-form {\n  margin-bottom: 0px;\n}\n\n.daterangepicker:before {\n  border-bottom: 7px solid #ddd;\n}\n\n.daterangepicker .daterangepicker_input i {\n  font-size: 14px;\n  color: #aaaaaa;\n}\n\n.daterangepicker .input-mini {\n  border-color: #ddd !important;\n  font-size: 14px;\n  color: #aaaaaa;\n}\n\n.daterangepicker th,\n.daterangepicker td {\n  height: 34px;\n  width: 34px;\n}\n\n.daterangepicker th:hover,\n.daterangepicker td:hover {\n  color: #2a3142;\n}\n\n.daterangepicker th.prev,\n.daterangepicker th.next,\n.daterangepicker td.prev,\n.daterangepicker td.next {\n  color: #fff;\n  height: 34px;\n  width: 34px;\n  background-color: #ab8ce4;\n}\n\n.daterangepicker th.month,\n.daterangepicker td.month {\n  color: #ab8ce4;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n/**=====================\n   52. Datepicker CSS End\n==========================**/\n/**=====================\n    53. Dashboard CSS Start\n==========================**/\n.chart-sparkline {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.top-sale-chart canvas {\n  min-width: 100%;\n}\n\n.border-widgets>.row>div+div {\n  border-left: 1px solid #ddd;\n}\n\n.crm-top-widget {\n  text-align: center;\n}\n\n.crm-top-widget .media {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.crm-top-widget .media i {\n  font-size: 40px;\n}\n\n.crm-top-widget .media .media-body {\n  text-align: left;\n}\n\n.crm-top-widget .media .media-body span {\n  margin-bottom: 0;\n  color: #777777;\n}\n\n.crm-top-widget .media .media-body h4 {\n  font-family: Open Sans;\n  font-weight: 600;\n  color: #333333;\n}\n\n@-webkit-keyframes animate {\n  from {\n    background-position: 0 0;\n  }\n\n  to {\n    background-position: 500px 0;\n  }\n}\n\n@keyframes animate {\n  from {\n    background-position: 0 0;\n  }\n\n  to {\n    background-position: 500px 0;\n  }\n}\n\n@keyframes rotate {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.whether-widget .whether-widget-top {\n  background-color: #ab8ce4;\n  background-image: url(../images/dashboard/whether.png);\n  -webkit-animation: animate 10s linear 0s normal none infinite;\n  animation: animate 10s linear 0s normal none infinite;\n  background-size: cover;\n}\n\n.whether-widget .whether-widget-top .details {\n  text-align: right;\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n}\n\n.whether-widget .whether-widget-top .details h4 {\n  font-family: Open Sans;\n  color: #fff;\n  text-shadow: 1px 1px 1px #000000ab;\n  font-weight: 600;\n  margin-top: 5px;\n}\n\n.whether-widget .whether-widget-top span {\n  color: #fff;\n  margin-bottom: 0;\n  text-shadow: 1px 1px 1px #000000ab;\n  padding-top: 20px;\n}\n\n.whether-widget .whether-widget-top .block_whether_bottom {\n  display: block;\n}\n\n.whether-widget .whether-widget-top img {\n  height: 158px;\n  -webkit-animation: rotate 10s linear 0s normal none infinite;\n  animation: rotate 10s linear 0s normal none infinite;\n}\n\n.whether-widget .whether-widget-bottom .row div .media {\n  padding-top: 30px;\n}\n\n.whether-widget .whether-widget-bottom h5 {\n  font-family: Open Sans;\n  font-weight: 600;\n}\n\n.whether-widget .whether-widget-bottom h5 span {\n  color: #000;\n}\n\n.whether-widget .whether-widget-bottom span {\n  margin-bottom: 0;\n  color: #777777;\n}\n\n.crm-activity>li+li {\n  border-top: 1px solid #ddd;\n  margin-top: 15px;\n  padding-top: 15px;\n}\n\n.crm-activity>li+li h6 {\n  font-size: 14px;\n}\n\n.crm-activity>li h6 {\n  font-size: 14px;\n}\n\n.crm-activity span {\n  font-size: 40px;\n}\n\n.crm-activity ul.dates h6 {\n  color: #333333;\n}\n\n.crm-activity ul.dates li {\n  color: #777777;\n  font-size: 12px;\n  display: inline-block;\n  line-height: 1;\n}\n\n.crm-activity ul.dates li+li {\n  border-left: 1px solid #ddd;\n  padding-left: 10px;\n  margin-left: 5px;\n}\n\n.combo-chart {\n  height: 380px;\n}\n\n.total-chart {\n  height: 300px;\n}\n\n.crm-overall {\n  margin: 0 -30px -30px;\n  background-color: #ab8ce4;\n  border-radius: 0 0 5px 5px;\n}\n\n.crm-overall div {\n  padding: 12px;\n}\n\n.crm-numbers {\n  padding-bottom: 30px;\n}\n\n.crm-numbers .col {\n  text-align: center;\n}\n\n.crm-numbers .col>span {\n  color: #777777;\n}\n\n.crm-numbers .col h4 {\n  font-family: Open Sans;\n  padding-top: 7px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n.crm-numbers .col h6 {\n  font-family: Open Sans;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.crm-numbers .col+.col {\n  border-left: 1px solid #ddd;\n}\n\n.dashboard-card {\n  padding-top: 17px;\n}\n\n.ecommerce-widget .total-num {\n  font-family: Open Sans;\n  font-weight: 600;\n  color: #333333;\n  margin: 0;\n  letter-spacing: 1px;\n}\n\n.ecommerce-widget .total-num span {\n  color: #000;\n}\n\n.ecommerce-widget .row {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ecommerce-widget .progress-showcase {\n  margin-top: 30px;\n}\n\n.ecommerce-widget span {\n  color: #777777;\n  margin: 0;\n}\n\n.ecommerce-widget .icon {\n  color: #ddd;\n  font-size: 40px;\n}\n\n.ecommerce-widget .product-stts {\n  font-family: Open Sans;\n}\n\n.ecommerce-widget .flot-chart-container {\n  height: 100px;\n  padding: 0;\n  margin: 0;\n  border: transparent;\n}\n\n.ecommerce-widget .morris-default-style {\n  display: none !important;\n}\n\n.ecommerce-widget svg {\n  -webkit-filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));\n  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.3));\n}\n\n.flot-chart-container-small {\n  text-align: center;\n  height: 280px;\n  background-color: #fff;\n  border-top: 1px solid #eeeeee;\n}\n\n.flot-chart-container-small svg {\n  -webkit-filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.1));\n  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.1));\n  margin: 0 auto;\n}\n\n.customer-review .media {\n  margin-bottom: 30px;\n}\n\n.customer-review .media img {\n  margin-right: 25px;\n}\n\n.customer-review .media-body .cust-name {\n  margin-right: 10px;\n  text-transform: uppercase;\n  color: #333333;\n  font-weight: 600;\n}\n\n.customer-review .media-body .cust-des {\n  color: #777777;\n}\n\n.yearly-chart {\n  text-align: center;\n}\n\n.yearly-chart svg {\n  -webkit-filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.1));\n  filter: drop-shadow(12px 12px 7px rgba(0, 0, 0, 0.1));\n  margin: 0 auto;\n}\n\n.yearly-chart .flot-chart-container {\n  border: none;\n  margin: 0 auto;\n}\n\n.static-top-widget:hover .icon-bg {\n  -webkit-transform: rotate(-5deg) scale(1.1);\n  transform: rotate(-5deg) scale(1.1);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.static-top-widget div.align-self-center {\n  font-size: 40px;\n}\n\n.static-top-widget .media-body {\n  -ms-flex-item-align: center !important;\n  align-self: center !important;\n  padding-left: 30px;\n}\n\n.static-top-widget .media-body h4 {\n  font-family: Open Sans;\n}\n\n.static-top-widget .media-body .icon-bg {\n  position: absolute;\n  right: -20px;\n  font-size: 140px;\n  top: 0;\n  opacity: 0.2;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.bg-info .media.static-top-widget .align-self-center {\n  background-color: #4099ff;\n}\n\n.bg-primary .media.static-top-widget .align-self-center {\n  background-color: #ab8ce4;\n}\n\n.bg-secondary .media.static-top-widget .align-self-center {\n  background-color: #26c6da;\n}\n\n.bg-danger .media.static-top-widget .align-self-center {\n  background-color: #FF5370;\n}\n\n.widget-joins:before {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 1px;\n  background-color: #ddd;\n  left: calc(50% - 1px);\n}\n\n.widget-joins:after {\n  content: \"\";\n  position: absolute;\n  height: 1px;\n  width: 100%;\n  background-color: #ddd;\n  left: 0;\n  top: 50%;\n}\n\n.widget-joins .media {\n  padding: 30px;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.widget-joins .media .details {\n  border-left: 1px solid #ddd;\n  padding: 1px 0;\n}\n\n.widget-joins .media .media-body {\n  text-align: left;\n}\n\n.widget-joins .media .media-body span {\n  font-family: Open Sans;\n}\n\n.widget-joins .media .media-body>span {\n  color: #777777;\n}\n\n.widget-joins .media .media-body i {\n  font-size: 40px;\n}\n\n.widget-joins .media .media-body h6 {\n  font-family: Open Sans;\n  font-weight: 600;\n}\n\n.widget-joins .media .media-body h6 span {\n  color: #000;\n}\n\n.redial-social-widget {\n  border-radius: 100%;\n  width: 100px;\n  height: 100px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-size: 40px;\n  margin: 0 auto;\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #eeeeee), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, right top, color-stop(50%, #cccccc), color-stop(50%, #eeeeee), to(#eeeeee));\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(90deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget i {\n  background-color: #fff;\n  height: 80px;\n  width: 80px;\n  border-radius: 100%;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.redial-social-widget.radial-bar-5 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(108deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-10 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(126deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-15 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(144deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-20 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(162deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-25 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #eeeeee), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, left top, left bottom, color-stop(50%, #cccccc), color-stop(50%, #eeeeee), to(#eeeeee));\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(180deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-30 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(198deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-35 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(216deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-40 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(234deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-45 {\n  background-image: linear-gradient(90deg, #eeeeee 50%, transparent 50%, transparent), linear-gradient(252deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-50 {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #cccccc), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #cccccc), color-stop(50%, #eeeeee), to(#eeeeee));\n  background-image: linear-gradient(270deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-55 {\n  background-image: linear-gradient(288deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-60 {\n  background-image: linear-gradient(306deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-65 {\n  background-image: linear-gradient(324deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-70 {\n  background-image: linear-gradient(342deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-75 {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #cccccc), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #cccccc), color-stop(50%, #eeeeee), to(#eeeeee));\n  background-image: linear-gradient(360deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-80 {\n  background-image: linear-gradient(378deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-85 {\n  background-image: linear-gradient(396deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-90 {\n  background-image: linear-gradient(414deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-95 {\n  background-image: linear-gradient(432deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.redial-social-widget.radial-bar-100 {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(50%, #cccccc), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #cccccc), color-stop(50%, #eeeeee), to(#eeeeee));\n  background-image: linear-gradient(450deg, #cccccc 50%, transparent 50%, transparent), linear-gradient(270deg, #cccccc 50%, #eeeeee 50%, #eeeeee);\n}\n\n.social-widget .radial-bar {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.social-widget-card span {\n  color: #777777;\n  text-transform: uppercase;\n  margin-bottom: 0;\n}\n\n.social-widget-card h4 {\n  font-family: Open Sans;\n  color: #333333;\n}\n\n.social-widget-card h5 {\n  color: #777777;\n  text-transform: uppercase;\n  text-align: center;\n  padding: 30px 0;\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n\n.browser-widget:hover img {\n  -webkit-filter: grayscale(0%);\n  filter: grayscale(0%);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  -webkit-transform: scale(1.1) rotate(5deg);\n  transform: scale(1.1) rotate(5deg);\n}\n\n.browser-widget img {\n  height: 80px;\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n  -webkit-transform: scale(1) rotate(0deg);\n  transform: scale(1) rotate(0deg);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.browser-widget .media-body {\n  text-align: center;\n  -webkit-column-count: 3;\n  column-count: 3;\n  -webkit-column-rule: 1px solid #eeeeee;\n  column-rule: 1px solid #eeeeee;\n}\n\n.browser-widget .media-body span {\n  margin-bottom: 0;\n  color: #777777;\n}\n\n.browser-widget .media-body h4 {\n  font-family: Open Sans;\n  color: #333333;\n  margin-bottom: 0;\n}\n\n.browser-widget .media-body h4 span {\n  color: #333333;\n}\n\n.testimonial i {\n  font-size: 60px;\n  color: #eeeeee;\n}\n\n.testimonial p {\n  color: #777777;\n  font-style: italic;\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\n\n.testimonial h5 {\n  color: #333333;\n  padding-top: 10px;\n}\n\n.testimonial span {\n  color: #777777;\n}\n\n.testimonial img {\n  margin: 0 auto;\n}\n\n.stat-widget-dashboard h4 {\n  font-family: Open Sans;\n  font-weight: 600;\n}\n\n.stat-widget-dashboard span {\n  color: #333333;\n  text-transform: capitalize;\n}\n\n.stat-widget-dashboard .media {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.stat-widget-dashboard .media i {\n  font-size: 50px;\n}\n\n.stat-widget-dashboard .media img {\n  width: 35px;\n}\n\n.social-media-counter .font-primary {\n  color: rgba(188, 160, 238, 0.8) !important;\n}\n\n.social-media-counter .font-secondary {\n  color: rgba(56, 211, 231, 0.8) !important;\n}\n\n.social-media-counter .font-success {\n  color: rgba(0, 194, 146, 0.8) !important;\n}\n\n.social-media-counter .counter {\n  font-family: Open Sans, sans-serif;\n}\n\n.social-media-counter h4 {\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.social-media-counter i {\n  font-size: 50px;\n  display: inline-block;\n}\n\n.testimonial-default .slide--item p {\n  font-weight: 500;\n  font-size: 15px;\n  margin-bottom: 0;\n}\n\n.testimonial-default .slide--item .media {\n  padding-top: 30px;\n}\n\n.default-widget-count .left {\n  height: 80px;\n  width: 80px;\n  border-radius: 100%;\n  position: relative;\n  text-align: center;\n}\n\n.default-widget-count .left .bg {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  opacity: 0.6;\n  border-radius: 100%;\n  z-index: 0;\n}\n\n.default-widget-count .left i {\n  font-size: 35px;\n  color: #fff;\n  text-shadow: 1px 1px 1px #aaaaaa;\n  position: relative;\n  line-height: 2.2;\n}\n\n.default-widget-count .icon-bg {\n  font-size: 60px;\n  color: #eeeeee;\n  position: absolute;\n  top: 30px;\n  right: 15px;\n}\n\n.default-widget-count h4 {\n  margin-bottom: 0;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 600;\n  color: #333333;\n}\n\n.default-widget-count span {\n  color: #777777;\n  margin-bottom: 0;\n}\n\n.default-dashboard-main-chart {\n  height: 313px;\n}\n\n.mobile-clock-widget .sec,\n.min,\n.hour {\n  position: absolute;\n  width: 24px;\n  height: 234px;\n  top: 0;\n  left: 102px;\n  margin-top: -30px;\n  margin-left: -25px;\n}\n\n.cal-date-widget .datepicker {\n  padding: 20px;\n}\n\n.cal-date-widget .cal-info h2 {\n  font-size: 100px;\n  font-family: Open Sans;\n  color: #cccccc;\n}\n\n.cal-date-widget .cal-datepicker .datepicker--nav {\n  font-family: Open Sans;\n}\n\n.weather-widget-two {\n  background: url(../images/whether-widgetbg.jpg);\n  height: 380px;\n  border-radius: 4px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  overflow: hidden;\n}\n\n.weather-widget-two svg path.climacon_component-stroke {\n  fill: #fff;\n}\n\n.weather-widget-two .num {\n  font-family: Open Sans;\n  font-weight: 600;\n}\n\n.weather-widget-two .climacon_component-stroke {\n  stroke: #fff;\n}\n\n.weather-widget-two .bottom-whetherinfo i {\n  font-size: 151px;\n  opacity: 0.1;\n  color: #fff;\n  position: relative;\n  top: 0;\n  left: -35px;\n}\n\n.weather-widget-two .bottom-whetherinfo .whether-content {\n  text-align: right;\n  position: relative;\n  top: 1px;\n  color: #fff;\n}\n\n.mobile-clock-widget {\n  background: url(../images/mobile-clock-wallpaper.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 380px;\n  border-radius: 4px;\n  color: #fff;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.mobile-clock-widget .clock {\n  padding: 0;\n  position: relative;\n  list-style: none;\n  margin: 0 auto;\n  height: 175px;\n  width: 175px;\n  display: block;\n  background: url(../images/clock-face.png) 5% center no-repeat;\n}\n\n.mobile-clock-widget .date {\n  font-family: Open Sans;\n}\n\n.mobile-clock-widget .sec {\n  background: url(../images/sec.svg);\n  z-index: 3;\n}\n\n.mobile-clock-widget .min {\n  background: url(../images/min.svg);\n  z-index: 2;\n}\n\n.mobile-clock-widget .hour {\n  background: url(../images/hour.svg);\n  z-index: 1;\n}\n\n.business-top-widget {\n  text-align: center;\n}\n\n.business-top-widget .media {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.business-top-widget .media .media-body {\n  margin-right: 40px;\n}\n\n.business-top-widget .media .total-value {\n  font-weight: 700;\n  font-family: Open Sans;\n  text-align: left;\n}\n\n.business-top-widget .media span {\n  color: #777777;\n  text-align: left;\n}\n\n.business-top-widget .media i {\n  font-size: 70px;\n}\n\n.business-card {\n  padding-left: 0 !important;\n}\n\n.business-card .logo {\n  width: 115px;\n}\n\n.business-card table {\n  margin-left: 35px;\n}\n\n.business-card table tr {\n  line-height: 2.245;\n}\n\n.business-card table th {\n  vertical-align: text-top;\n  text-align: right;\n  padding-right: 15px;\n  color: #333333;\n  font-weight: 500;\n}\n\n.business-card table td {\n  color: #777777;\n}\n\n.social-widget .social-icons {\n  height: 60px;\n  width: 60px;\n  background-color: #fff;\n  border-radius: 100%;\n  margin-top: 10px;\n  margin-left: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 25px;\n}\n\n.social-widget .media .social-sub-title {\n  color: #777777;\n  text-transform: uppercase;\n}\n\n.social-widget .total-value {\n  font-weight: 600;\n  font-family: Open Sans;\n  color: #333333;\n}\n\n.social-widget .radial-bar:after {\n  display: none;\n}\n\n.business-chart-widget {\n  border-radius: 0.25rem;\n  overflow: hidden;\n}\n\n.business-chart-widget .total-num {\n  font-family: Open Sans;\n  font-weight: bold;\n  color: #fff;\n  margin: 0;\n  letter-spacing: 1px;\n}\n\n.business-chart-widget span {\n  color: #eeeeee;\n  margin: 0;\n}\n\n.business-chart-widget .icon {\n  color: #fff;\n  font-size: 60px;\n  line-height: 1;\n}\n\n.business-chart-widget .icon-bg {\n  position: absolute;\n  right: -50px;\n  font-size: 140px;\n  top: -75px;\n  opacity: 0.1;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  overflow: hidden;\n  z-index: 0;\n  color: #fff;\n}\n\n.business-chart-widget .icon-bg:hover {\n  -webkit-transform: rotate(-5deg);\n  transform: rotate(-5deg);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.business-chart-widget canvas {\n  width: 100% !important;\n}\n\n.business-chart-widget .flot-chart-container {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100px;\n  padding: 0;\n  margin: 20px 0 0;\n  border: none;\n}\n\n.flot-chart-container {\n  height: 472px;\n}\n\n.review-box .customer-name {\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.review-box .testimonial {\n  margin-top: 12px;\n}\n\n.review-box .testimonial .content {\n  padding: 30px;\n  border: 1px solid #eeeeee;\n  position: relative;\n  border-radius: 4px;\n}\n\n.review-box .testimonial .content:before {\n  content: \"\";\n  border-bottom: 10px solid #eeeeee;\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  position: absolute;\n  top: -10px;\n  left: 40px;\n}\n\n.review-box .testimonial .content:after {\n  content: \"\";\n  border-bottom: 9px solid #fff;\n  border-left: 9px solid transparent;\n  border-right: 9px solid transparent;\n  position: absolute;\n  top: -8px;\n  left: 40px;\n}\n\n.review-box .testimonial .description {\n  letter-spacing: 1px;\n  margin: 0;\n}\n\n.calender-widget .cal-img {\n  background: url(../images/calender-bg.png);\n  background-size: cover;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  height: 300px;\n}\n\n.calender-widget .cal-date {\n  font-family: Open Sans;\n  width: 100px;\n  height: 100px;\n  margin: 0 auto;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 50%;\n  margin-top: -45px;\n  border: 1px solid #cccccc;\n}\n\n.calender-widget .cal-date h5 {\n  margin-bottom: 0;\n  line-height: 1.5;\n  padding: 17px;\n  font-weight: 600;\n}\n\n.calender-widget .cal-desc h6 {\n  padding-bottom: 6px;\n}\n\n.calender-widget .cal-desc span {\n  line-height: 1.6;\n}\n\n.contact-form .theme-form {\n  border: 1px solid #eeeeee;\n  padding: 30px;\n  border-radius: 4px;\n}\n\n.contact-form .theme-form .form-icon {\n  width: 53px;\n  height: 53px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  border: 1px solid #ddd;\n  border-radius: 100%;\n  font-size: 21px;\n  background-color: #fff;\n  color: #717171;\n  margin-top: -55px;\n  margin-bottom: 15px;\n}\n\n.contact-form .theme-form .form-group {\n  margin-bottom: 10px;\n}\n\n.contact-form .theme-form .form-group label {\n  font-weight: 600;\n}\n\n.contact-form .btn {\n  padding: 10px 30px;\n}\n\n.support-ticket .bg-primary {\n  background-color: rgba(171, 140, 228, 0.6) !important;\n}\n\n.support-ticket .bg-secondary {\n  background-color: rgba(38, 198, 218, 0.6) !important;\n}\n\n.support-ticket .bg-success {\n  background-color: rgba(0, 194, 146, 0.6) !important;\n}\n\n.support-ticket .left {\n  height: 80px;\n  width: 80px;\n  border-radius: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-size: 40px;\n  font-weight: 600;\n}\n\n.support-ticket table tr td:nth-child(2) {\n  width: 15%;\n}\n\n.support-ticket table tr+tr {\n  border-top: 1px solid #eeeeee;\n}\n\n.support-ticket table .w-23 {\n  width: 23%;\n}\n\n.support-ticket table td {\n  vertical-align: middle;\n}\n\n.support-ticket table td span {\n  text-transform: uppercase;\n  color: #333333;\n  font-weight: 600;\n  padding-top: 10px;\n}\n\n.support-ticket table td h6 {\n  color: #777777;\n  font-size: 12px;\n  font-family: \"$font-open-sans\", sans-serif;\n  text-transform: capitalize;\n  margin-bottom: 0;\n}\n\n.support-ticket table td p {\n  color: #777777;\n  margin-bottom: 0;\n}\n\n.chart-widget-top {\n  border-radius: 4px;\n}\n\n.chart-widget-top .num {\n  font-family: Open Sans;\n}\n\n.chart-widget-top .total-value {\n  letter-spacing: 2px;\n  font-weight: 600;\n}\n\n.bar-chart-widget .top-content {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.bar-chart-widget .earning-details {\n  height: 100%;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  letter-spacing: 1px;\n}\n\n.bar-chart-widget .earning-details i {\n  font-size: 230px;\n  position: absolute;\n  opacity: 0.1;\n  right: -30px;\n  top: 0;\n}\n\n.bar-chart-widget .earning-details i:hover {\n  -webkit-transform: rotate(-5deg) scale(1.1);\n  transform: rotate(-5deg) scale(1.1);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.bar-chart-widget .num {\n  font-family: Open Sans;\n  font-weight: 600;\n}\n\n.bar-chart-widget .num .color-bottom {\n  color: #000;\n}\n\n.bottom-content span {\n  color: #777777;\n}\n\n.bottom-content .block-bottom {\n  display: block;\n}\n\n.user-status table tbody tr td {\n  vertical-align: middle;\n}\n\n.user-status table tbody tr td .d-inline-block {\n  margin-top: 11px;\n}\n\n.user-status table tbody tr td .image-sm-size img {\n  width: 41px;\n}\n\n.user-status table tbody tr:last-child td {\n  padding-bottom: 0;\n}\n\n.user-status table thead tr th {\n  border-top: 0;\n  font-size: 16px;\n  color: #2a3142;\n  font-weight: 600;\n  padding-top: 0;\n}\n\n.height-scroll {\n  max-height: 296px;\n  overflow-y: auto;\n}\n\n@-webkit-keyframes am-moving-dashes {\n  100% {\n    stroke-dashoffset: -30px;\n  }\n}\n\n@keyframes am-moving-dashes {\n  100% {\n    stroke-dashoffset: -30px;\n  }\n}\n\n@-webkit-keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0;\n  }\n\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 50px;\n  }\n}\n\n@keyframes am-pulsating {\n  0% {\n    stroke-opacity: 1;\n    stroke-width: 0;\n  }\n\n  100% {\n    stroke-opacity: 0;\n    stroke-width: 50px;\n  }\n}\n\n@-webkit-keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes am-draw {\n  0% {\n    stroke-dashoffset: 500%;\n  }\n\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n.serial-chart .chart-container {\n  width: 100%;\n  height: 500px;\n}\n\n.serial-chart .chart-container .lastBullet {\n  -webkit-animation: am-pulsating 1s ease-out infinite;\n  animation: am-pulsating 1s ease-out infinite;\n}\n\n.serial-chart .chart-container .amcharts-graph-column-front {\n  -webkit-transition: all .3s .3s ease-out;\n  transition: all .3s .3s ease-out;\n}\n\n.serial-chart .chart-container .amcharts-graph-column-front:hover {\n  fill: #26c6da;\n  stroke: #26c6da;\n  -webkit-transition: all .3s ease-out;\n  transition: all .3s ease-out;\n}\n\n.serial-chart .chart-container .amcharts-graph-g3 {\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  stroke-dasharray: 0;\n  stroke-dashoffset: 0;\n  -webkit-animation: am-draw 40s;\n  animation: am-draw 40s;\n}\n\n.serial-chart .chart-container .amcharts-graph-g2 .amcharts-graph-stroke {\n  stroke-dasharray: 3px 3px;\n  stroke-linejoin: round;\n  stroke-linecap: round;\n  -webkit-animation: am-moving-dashes 1s linear infinite;\n  animation: am-moving-dashes 1s linear infinite;\n}\n\n.speed-chart .chart-container {\n  width: 100%;\n  height: 530px;\n}\n\n.speed-chart .content {\n  margin-top: -200px;\n  margin-bottom: 20px;\n}\n\n.speed-chart .content h4 {\n  font-family: Open Sans;\n  font-weight: 600;\n  padding-top: 2px;\n}\n\n.status-widget .status-chart {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.small-chart-widget .chart-container {\n  height: 300px;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n\n.donut-chart-widget .chart-container {\n  height: 300px;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n.status-details h4 {\n  font-family: Open Sans;\n  font-weight: 600;\n}\n\n.status-details h4 span {\n  color: inherit;\n}\n\n.status-details span {\n  color: #777777;\n}\n\n.status-chart .chart-container {\n  height: 200px;\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.map-chart .chart-container {\n  width: 100%;\n  height: 500px;\n}\n\n.serial-chart {\n  width: 100%;\n}\n\n.yearly-chart .ct-series-a .ct-point,\n.yearly-chart .ct-series-a .ct-line,\n.yearly-chart .ct-series-a .ct-bar,\n.yearly-chart .ct-series-a .ct-slice-donut {\n  stroke: #4099ff;\n}\n\n.yearly-chart .ct-series-b .ct-point,\n.yearly-chart .ct-series-b .ct-line,\n.yearly-chart .ct-series-b .ct-bar,\n.yearly-chart .ct-series-b .ct-slice-donut {\n  stroke: #FF5370;\n}\n\n.yearly-chart .ct-series-c .ct-point,\n.yearly-chart .ct-series-c .ct-line,\n.yearly-chart .ct-series-c .ct-bar,\n.yearly-chart .ct-series-c .ct-slice-donut {\n  stroke: #ab8ce4;\n}\n\n.yearly-chart .ct-series-d .ct-point,\n.yearly-chart .ct-series-d .ct-line,\n.yearly-chart .ct-series-d .ct-bar,\n.yearly-chart .ct-series-d .ct-slice-donut {\n  stroke: #26c6da;\n}\n\n.live-products,\n.turnover,\n.uses,\n.monthly {\n  height: 300px;\n}\n\n.live-products .ct-series-a .ct-area,\n.live-products .ct-series-a .ct-point,\n.live-products .ct-series-a .ct-line,\n.live-products .ct-series-a .ct-bar,\n.live-products .ct-series-a .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.77);\n}\n\n.live-products .ct-label {\n  fill: #fff;\n  color: #fff;\n}\n\n.live-products .ct-grid {\n  stroke: rgba(255, 255, 255, 0.7);\n}\n\n.turnover .ct-series-a .ct-area,\n.turnover .ct-series-a .ct-point,\n.turnover .ct-series-a .ct-line,\n.turnover .ct-series-a .ct-bar,\n.turnover .ct-series-a .ct-slice-donut,\n.uses .ct-series-a .ct-area,\n.uses .ct-series-a .ct-point,\n.uses .ct-series-a .ct-line,\n.uses .ct-series-a .ct-bar,\n.uses .ct-series-a .ct-slice-donut,\n.monthly .ct-series-a .ct-area,\n.monthly .ct-series-a .ct-point,\n.monthly .ct-series-a .ct-line,\n.monthly .ct-series-a .ct-bar,\n.monthly .ct-series-a .ct-slice-donut {\n  stroke: white;\n  fill: transparent;\n}\n\n.turnover .ct-series-b .ct-area,\n.turnover .ct-series-b .ct-point,\n.turnover .ct-series-b .ct-line,\n.turnover .ct-series-b .ct-bar,\n.turnover .ct-series-b .ct-slice-donut,\n.uses .ct-series-b .ct-area,\n.uses .ct-series-b .ct-point,\n.uses .ct-series-b .ct-line,\n.uses .ct-series-b .ct-bar,\n.uses .ct-series-b .ct-slice-donut,\n.monthly .ct-series-b .ct-area,\n.monthly .ct-series-b .ct-point,\n.monthly .ct-series-b .ct-line,\n.monthly .ct-series-b .ct-bar,\n.monthly .ct-series-b .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.7);\n  fill: transparent;\n}\n\n.turnover .ct-series-c .ct-area,\n.turnover .ct-series-c .ct-point,\n.turnover .ct-series-c .ct-line,\n.turnover .ct-series-c .ct-bar,\n.turnover .ct-series-c .ct-slice-donut,\n.uses .ct-series-c .ct-area,\n.uses .ct-series-c .ct-point,\n.uses .ct-series-c .ct-line,\n.uses .ct-series-c .ct-bar,\n.uses .ct-series-c .ct-slice-donut,\n.monthly .ct-series-c .ct-area,\n.monthly .ct-series-c .ct-point,\n.monthly .ct-series-c .ct-line,\n.monthly .ct-series-c .ct-bar,\n.monthly .ct-series-c .ct-slice-donut {\n  stroke: rgba(255, 255, 255, 0.4);\n  fill: transparent;\n}\n\n.turnover .ct-label,\n.uses .ct-label,\n.monthly .ct-label {\n  fill: #fff;\n  color: #fff;\n}\n\n.turnover .ct-grid,\n.uses .ct-grid,\n.monthly .ct-grid {\n  stroke: rgba(255, 255, 255, 0.7);\n}\n\n#draggableMultiple .ui-sortable-handle .card {\n  cursor: move;\n}\n\n.tilt-showcase ul li .line {\n  padding-top: 10px;\n}\n\n.tilt-showcase .pre-mt {\n  margin-top: 5px;\n}\n\n.wow-title h5 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.alert-center {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.box-shadow-title .sub-title {\n  margin: 30px 0;\n}\n\n.hovercard .info .social-media ul li {\n  padding-top: 3px;\n}\n\n.hovercard .cardheader {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.sticky-header-main .card .card-header h5 {\n  line-height: 35px;\n}\n\n.sticky-header-main .card .card-header h5 a {\n  color: #fff;\n}\n\n.custom-radio-ml {\n  margin-left: 3px;\n}\n\n.daterangepicker .ltr tr td.active {\n  color: #fff;\n}\n\n#scrollable-dropdown-menu .twitter-typeahead .tt-menu .tt-dataset {\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.btn-showcase a {\n  color: #fff;\n}\n\n.card-block .table-responsive .table caption {\n  padding-left: 10px;\n}\n\n.card-block .table-responsive .table-bordered td {\n  vertical-align: middle;\n}\n\n.card-block .table-border-radius {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.card-block .default-checkbox-align #checkbox1 {\n  margin-right: 10px;\n}\n\n.card-block .default-checkbox-align #radio {\n  margin-right: 5px;\n}\n\n#example-style-3_wrapper #example-style-3 tfoot {\n  border-top: 2px solid #ddd;\n}\n\n.chart-vertical-center {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.chart-vertical-center #myDoughnutGraph,\n.chart-vertical-center #myPolarGraph {\n  width: auto !important;\n}\n\n.gmap-header-align h5 {\n  padding-top: 8px;\n}\n\n.cke_focus {\n  padding: 15px;\n  margin-top: 13px;\n}\n\n#editor .ace_scroller .ace_content .ace_layer .ace_print-margin {\n  visibility: hidden !important;\n}\n\n.helper-classes {\n  padding: 30px;\n  margin-bottom: 0;\n  white-space: pre-line;\n}\n\n.starter-main {\n  min-height: calc(100% - 32px);\n}\n\n.starter-main .card-body p {\n  font-size: 14px;\n}\n\n.starter-main .card-body ul {\n  padding-left: 30px;\n  list-style-type: disc;\n  margin-bottom: 15px;\n}\n\n.starter-main .card-body h5 {\n  font-size: 18px;\n}\n\n.starter-main .card-body pre {\n  white-space: pre-line;\n  padding: 30px;\n}\n\n.starter-main .card-body .alert-primary.inverse:before {\n  top: 32px;\n}\n\n.starter-main .alert {\n  background-color: rgba(171, 140, 228, 0.2);\n}\n\n.starter-main .alert i {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\nfooter.blockquote-footer {\n  bottom: unset;\n}\n\n.rtl .alert-primary.inverse {\n  background-color: transparent;\n  padding: 13px 65px 13px 20px;\n}\n\n.rtl .starter-main .card-body ul {\n  padding-right: 30px;\n}\n\n/**=====================\n  53. Dashboard CSS Ends\n==========================**/\n/**=====================\n     54. Tour  CSS Start\n==========================**/\n.introjs-overlay {\n  position: absolute;\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  z-index: 99999;\n  background-color: #000;\n  opacity: 0;\n  background: radial-gradient(center, ellipse cover, rgba(0, 0, 0, 0.9) 0, rgba(0, 0, 0, 0.9) 100%);\n  filter: \"progid:DXImageTransform.Microsoft.gradient(startColorstr='#66000000',endColorstr='#e6000000',GradientType=1)\";\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=50)\";\n  filter: alpha(opacity=50);\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n\n.introjs-fixParent {\n  z-index: auto !important;\n  opacity: 1.0 !important;\n  -webkit-transform: none !important;\n  transform: none !important;\n}\n\n.introjs-showElement {\n  z-index: 9999999 !important;\n}\n\ntr.introjs-showElement>td,\ntr.introjs-showElement>th {\n  z-index: 9999999 !important;\n}\n\n.introjs-disableInteraction {\n  z-index: 99999999 !important;\n  position: absolute;\n  background-color: #fff;\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n\n.introjs-relativePosition {\n  position: relative;\n}\n\ntr.introjs-showElement>td,\ntr.introjs-showElement>th {\n  position: relative;\n}\n\n.introjs-helperLayer {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  position: absolute;\n  z-index: 9999998;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.9);\n  border: 1px solid #777777;\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);\n  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.4);\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n\n.introjs-tooltipReferenceLayer {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  position: absolute;\n  visibility: hidden;\n  z-index: 100000000;\n  background-color: transparent;\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n}\n\n.introjs-helperLayer * {\n  -webkit-box-sizing: content-box;\n  -ms-box-sizing: content-box;\n  -o-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.introjs-helperLayer *:before,\n.introjs-helperLayer *:after {\n  -webkit-box-sizing: content-box;\n  -ms-box-sizing: content-box;\n  -o-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.introjs-helperNumberLayer {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  position: absolute;\n  visibility: visible;\n  top: -16px;\n  left: -16px;\n  z-index: 9999999999 !important;\n  padding: 2px;\n  font-family: Arial, verdana, tahoma;\n  font-size: 13px;\n  font-weight: bold;\n  color: #fff;\n  text-align: center;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);\n  background: #FF5370;\n  /* Old browsers */\n  /* Chrome10+,Safari5.1+ */\n  /* Chrome,Safari4+ */\n  /* FF3.6+ */\n  /* IE10+ */\n  /* Opera 11.10+ */\n  background: -webkit-gradient(linear, left top, left bottom, from(#fb6d9d), to(#FF5370));\n  background: linear-gradient(to bottom, #fb6d9d 0%, #FF5370 100%);\n  /* W3C */\n  background: -webkit-gradient(linear, left top, left bottom, from(#ab8ce4), to(#ab8ce4));\n  background: linear-gradient(to bottom, #ab8ce4 0%, #ab8ce4 100%);\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  filter: \"progid:DXImageTransform.Microsoft.Shadow(direction=135, strength=2, color=ff0000)\";\n  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n}\n\n.introjs-arrow {\n  border: 12px solid #fff;\n  content: '';\n  position: absolute;\n}\n\n.introjs-arrow.top {\n  top: -20px;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: #ab8ce4;\n  border-left-color: transparent;\n}\n\n.introjs-arrow.top-right {\n  top: -10px;\n  right: 10px;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: #ab8ce4;\n  border-left-color: transparent;\n}\n\n.introjs-arrow.top-middle {\n  top: -10px;\n  left: 50%;\n  margin-left: -5px;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: #ab8ce4;\n  border-left-color: transparent;\n}\n\n.introjs-arrow.right {\n  right: -30px;\n  top: 10px;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: #ab8ce4;\n}\n\n.introjs-arrow.right-bottom {\n  bottom: 10px;\n  right: -30px;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: #ab8ce4;\n}\n\n.introjs-arrow.bottom {\n  bottom: -20px;\n  border-top-color: #ab8ce4;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n}\n\n.introjs-arrow.left {\n  left: -30px;\n  top: 10px;\n  border-top-color: transparent;\n  border-right-color: #ab8ce4;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n}\n\n.introjs-arrow.left-bottom {\n  left: -30px;\n  bottom: 10px;\n  border-top-color: transparent;\n  border-right-color: #ab8ce4;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n}\n\n.introjs-tooltip {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  position: absolute;\n  visibility: visible;\n  padding: 15px;\n  background-color: #ab8ce4;\n  min-width: 250px;\n  max-width: 300px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);\n  -webkit-transition: opacity 0.1s ease-out;\n  transition: opacity 0.1s ease-out;\n  border: 0;\n  color: #fff;\n}\n\n.introjs-tooltipbuttons {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.introjs-button {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  position: relative;\n  overflow: visible;\n  display: inline-block;\n  padding: 0.3em 0.8em;\n  border: 1px solid #ddd;\n  margin: 0;\n  text-decoration: none;\n  text-shadow: 1px 1px 0 #fff;\n  font-size: 11px;\n  color: #333333 !important;\n  white-space: nowrap;\n  cursor: pointer;\n  outline: none;\n  background-color: #fff;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#fff));\n  background-image: linear-gradient(#fff, #fff);\n  -webkit-background-clip: padding;\n  -moz-background-clip: padding;\n  -o-background-clip: padding-box;\n  border-radius: 0.2em;\n  zoom: 1;\n  display: inline;\n  margin-top: 10px;\n}\n\n.introjs-button:hover {\n  border-color: #ddd;\n  text-decoration: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.introjs-button:focus,\n.introjs-button:active {\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#cccccc), to(#ddd));\n  background-image: linear-gradient(#cccccc, #ddd);\n}\n\n.introjs-button::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\n\n/* overrides extra padding on button elements in Firefox */\n.introjs-skipbutton {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  margin-right: 5px;\n  color: #ab8ce4;\n}\n\n.introjs-prevbutton {\n  border-radius: 0.2em 0 0 0.2em;\n  border-right: none;\n}\n\n.introjs-prevbutton.introjs-fullbutton {\n  border: 1px solid #ddd;\n  border-radius: 0.2em;\n}\n\n.introjs-nextbutton {\n  border-radius: 0 0.2em 0.2em 0;\n}\n\n.introjs-nextbutton.introjs-fullbutton {\n  border-radius: 0.2em;\n}\n\n.introjs-disabled {\n  color: #ab8ce4;\n  border-color: #ddd;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  cursor: default;\n  background-image: none;\n  text-decoration: none;\n}\n\n.introjs-disabled:hover,\n.introjs-disabled:focus {\n  color: #ab8ce4;\n  border-color: #ddd;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  cursor: default;\n  background-image: none;\n  text-decoration: none;\n}\n\n.introjs-hidden {\n  display: none;\n}\n\n.introjs-bullets {\n  text-align: center;\n}\n\n.introjs-bullets ul {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  clear: both;\n  margin: 15px auto 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.introjs-bullets ul li {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  list-style: none;\n  float: left;\n  margin: 0 2px;\n}\n\n.introjs-bullets ul li a {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  display: block;\n  width: 6px;\n  height: 6px;\n  background: #cccccc;\n  border-radius: 10px;\n  -moz-border-radius: 10px;\n  -webkit-border-radius: 10px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.introjs-bullets ul li a:hover {\n  background: #fff;\n}\n\n.introjs-bullets ul li a.active {\n  background: #fff;\n}\n\n.introjs-progress {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  overflow: hidden;\n  height: 10px;\n  margin: 10px 0 5px 0;\n  border-radius: 4px;\n  background-color: #eeeeee;\n}\n\n.introjs-progressbar {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  float: left;\n  width: 0;\n  height: 100%;\n  font-size: 10px;\n  line-height: 10px;\n  text-align: center;\n  background-color: #4099ff;\n}\n\n.introjsFloatingElement {\n  position: absolute;\n  height: 0;\n  width: 0;\n  left: 50%;\n  top: 50%;\n}\n\n.introjs-fixedTooltip {\n  position: fixed;\n}\n\n.introjs-hint {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  position: absolute;\n  background: transparent;\n  width: 20px;\n  height: 15px;\n  cursor: pointer;\n}\n\n.introjs-hint:focus {\n  border: 0;\n  outline: 0;\n}\n\n.introjs-hidehint {\n  display: none;\n}\n\n.introjs-fixedhint {\n  position: fixed;\n}\n\n.introjs-hint:hover>.introjs-hint-pulse {\n  border: 5px solid rgba(60, 60, 60, 0.57);\n}\n\n.introjs-hint-pulse {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  width: 10px;\n  height: 10px;\n  border: 5px solid rgba(60, 60, 60, 0.27);\n  border-radius: 30px;\n  background-color: rgba(136, 136, 136, 0.24);\n  z-index: 10;\n  position: absolute;\n  -webkit-transition: all 0.2s ease-out;\n  transition: all 0.2s ease-out;\n}\n\n.introjs-hint-no-anim .introjs-hint-dot {\n  -webkit-animation: none;\n  animation: none;\n}\n\n.introjs-hint-dot {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  border: 10px solid rgba(146, 146, 146, 0.36);\n  background: transparent;\n  border-radius: 60px;\n  height: 50px;\n  width: 50px;\n  -webkit-animation: introjspulse 3s ease-out;\n  animation: introjspulse 3s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  position: absolute;\n  top: -25px;\n  left: -25px;\n  z-index: 1;\n  opacity: 0;\n}\n\n@-webkit-keyframes introjspulse {\n  0% {\n    -webkit-transform: scale(0);\n    opacity: 0.0;\n  }\n\n  25% {\n    -webkit-transform: scale(0);\n    opacity: 0.1;\n  }\n\n  50% {\n    -webkit-transform: scale(0.1);\n    opacity: 0.3;\n  }\n\n  75% {\n    -webkit-transform: scale(0.5);\n    opacity: 0.5;\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    opacity: 0.0;\n  }\n}\n\n@keyframes introjspulse {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n    opacity: 0.0;\n  }\n\n  25% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n    opacity: 0.1;\n  }\n\n  50% {\n    -webkit-transform: scale(0.1);\n    transform: scale(0.1);\n    opacity: 0.3;\n  }\n\n  75% {\n    -webkit-transform: scale(0.5);\n    transform: scale(0.5);\n    opacity: 0.5;\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    opacity: 0.0;\n  }\n}\n\n/**=====================\n    54. Tour  CSS Ends\n==========================**/\n/**=====================\n   55. theme layout CSS Start\n==========================**/\nbody[main-theme-layout=\"main-theme-layout-1\"] .sidebar-widget .sidebar-widget-bottom {\n  background-color: #30384b;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .sidebar-widget .sidebar-widget-bottom p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .sidebar-widget .sidebar-widget-top i {\n  background-color: #343d52;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper {\n  /* sidebar start */\n  /* sidebar end */\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar {\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {\n  background-blend-mode: overlay;\n  background-color: #17191d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar.navigation-bordered .sidebar-header {\n  border-bottom: 1px solid rgba(241, 241, 241, 0.15);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {\n  background-color: #36404a;\n  -webkit-box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);\n  box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {\n  color: #eeeeee;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {\n  color: #ab8ce4;\n  border-bottom: 1px solid rgba(241, 241, 241, 0.35);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {\n  margin-top: 3px;\n  margin-right: 5px;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {\n  color: #f3d800;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {\n  color: #eeeeee;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top i {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-bottom {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-body {\n  background-color: rgba(246, 246, 246, 0.6);\n}\n\nbody[main-theme-layout=\"main-theme-layout-1\"] .page-wrapper .page-body-wrapper .page-header .breadcrumb {\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .flot-chart-container .legend .table tbody {\n  background-color: #36404a;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .flot-chart-container .legend .table tbody .legendLabel {\n  padding-left: 5px;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-dark .nav-link,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-pills.nav-dark .nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .default-according .card .btn-link {\n  background-color: #fff;\n  border: 1px solid #eeeeee;\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .collapse .card-body {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .theme-form .form-group input[type=email],\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .theme-form .form-group textarea {\n  border-color: #eeeeee;\n  background-color: #fff;\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .theme-form .form-group label {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header #accordionoc #collapseicon,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header #accordionoc #collapseicon1 {\n  background-color: #fff;\n}\n\n@media only screen and (max-width: 575px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .nav-right>ul .search-form .mobile-search {\n    -webkit-filter: brightness(1) invert(100%);\n    filter: brightness(1) invert(100%);\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-main-header .nav-right>ul .search-form .form-control-plaintext {\n    background-color: #303841;\n    -webkit-filter: brightness(1) invert(9%) !important;\n    filter: brightness(1) invert(9%) !important;\n    border: 1px solid #4b5469;\n    color: rgba(255, 255, 255, 0.7);\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper {\n  /* body start*/\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {\n  border-bottom: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .custom-card .card-header img {\n  background-color: #000;\n  opacity: 0.1;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-header .row h3 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-header .breadcrumb-item.active {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  /* body end*/\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card {\n  background-color: #36404a;\n  -webkit-box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header {\n  background-color: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h2,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h3,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h4,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h5,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-header .card-header-right i {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline-2x,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card #animation-box .animate-widget p {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .grid-item img {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .line {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table td {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table thead th {\n  border-bottom: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table thead .border-bottom-primary th {\n  border-bottom: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger td {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-primary,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-secondary,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-success,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-info,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-warning,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-danger {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-light {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .thead-light th {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .double,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .dotted,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table .dashed {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary td {\n  border-bottom: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table td {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered th {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-inverse tbody tr:nth-of-type(odd):hover td {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical tr,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical td {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .card-footer {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .switch .switch-state {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .switch input:checked+.switch-state {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .bg-white {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .business-top-widget .media span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .b-l-light {\n  border-left: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .business-card table td {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .business-card table th {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .business-card .logo {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .media .social-sub-title {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .total-value {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .social-icons {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .ct-grid {\n  stroke: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .ct-label {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .text-muted {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:before {\n  border-bottom: 10px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:after {\n  border-bottom: 9px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .calender-widget .cal-date {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form .form-icon {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-dark {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .btn-light {\n  color: #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .btn-light:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .border-right {\n  border-right: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder .flot-text {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#line-chart rect,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart1 rect,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart2 rect {\n  fill: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>rect {\n  fill: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>g>g text {\n  fill: #b1b1b2;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .radial-bar:after {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num .color-bottom {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .b-r-light {\n  border-right: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-labels .ct-label {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-grid {\n  stroke: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #browser-uses-chart svg text,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #website-visiter-chart svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .status-details span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .clipboaard-container .form-control {\n  background-color: #303841;\n  color: #98a6ad;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .img-thumbnail {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard .media img {\n  -webkit-filter: brightness(0) invert(75%);\n  filter: brightness(0) invert(75%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr+tr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td p,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_info,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_processing,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter input[type=\"search\"] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover>.sorting_1 {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even>.sorting_1 {\n  background-color: rgba(53, 59, 74, 0.3);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead td {\n  border-bottom: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable input,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody tr {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody td {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even:hover>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover>.sorting_1 {\n  background-color: #2c3239;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.hover tbody tr:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td {\n  border-top: 1px solid #4b5469;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th:first-child,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td:first-child {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_2,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_3,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_2,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_3 {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card #example-style-3_wrapper #example-style-3 tfoot {\n  border-top: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .page-item.disabled .page-link {\n  background-color: #36404a;\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .page-link {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .page-link:hover {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .page-item.active .page-link {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .icon {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col+.col {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-container-small {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li:hover {\n  background-color: #000;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td span,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .product-table h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-selected {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a {\n  border: 2px solid #4b5469;\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-selected {\n  border: 2px solid #ab8ce4;\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a:after,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a:after {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-selected:after,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-active:after,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-active:after {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .scroll-demo {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .search-form input {\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content::before {\n  border-left: 7px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n  border-right-color: #4b5469;\n  border-left: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .breadcrumb {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .user-status table td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card .user-status table th {\n  border-top: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris-daily svg,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris svg,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card #browser-uses-chart svg,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card #website-visiter-chart svg {\n  opacity: 0.5;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-des {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show>.nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #viewhtml .render {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {\n  border: 1px dotted #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description a>div {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell {\n  background: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell input,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell input,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell input,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell input {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-row>.jsgrid-cell {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row>.jsgrid-cell {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row>.jsgrid-cell {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*=\"jsgrid-pager\"] {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 700;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .sub-title {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {\n  color: #ab8ce4 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 2px 2px #4b5469;\n  box-shadow: 0 0 2px 2px #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {\n  border-bottom: 7px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .border {\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {\n  color: #98a6ad;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {\n  border-right: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .comment-box .media img {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .comment-box p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .comment-box hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover td,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover th {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body ul.the-icons li {\n  border: 1px dotted #4b5469;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-agendaWeek-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicDay-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaWeek-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaDay-button {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .border-widgets>.row>div+div {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top .details h4 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom h5 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li+li {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .icon-bg {\n  color: #2e3945;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .left i {\n  color: #303841;\n  text-shadow: 1px 1px 1px #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .testimonial-default .slide--item p {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div+div {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .checkbox label::before,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .radio label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {\n  -webkit-column-rule: 1px solid #4b5469;\n  column-rule: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {\n  border: 2px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .icon-lists div i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .media-body>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .details {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .widget-joins:before,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .widget-joins:after {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h5,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .b-b-light {\n  border-bottom: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .b-r-dark {\n  border-right: 1px solid #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .testimonial i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .testimonial p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .testimonial h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .testimonial span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .grid-showcase span {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .grid-align .row {\n  background-color: #4b5469;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .border-style .card {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .offer-style .card {\n  border: 1px dashed #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {\n  background-color: #36404a;\n  color: #98a6ad !important;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {\n  border-left: 3px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {\n  color: #98a6ad;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {\n  border: 1px solid #4b5469;\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .pricing-card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h3 {\n  color: rgba(206, 212, 218, 0.3);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-price h1 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li::before {\n  color: rgba(255, 255, 255, 0.15);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .search-page .info-block+.info-block {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper footer {\n  border-top: 1px solid #303841;\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .custom-select,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .custom-file-label {\n  background: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .page-body-wrapper .footer-fix {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .dt-button-info {\n  background-color: #36404a;\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .dt-button-info h2 {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .about .name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu .nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {\n  background-color: #36404a;\n  -webkit-box-shadow: 1px 1px 3px 1px #303841;\n  box-shadow: 1px 1px 3px 1px #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {\n  border: 5px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu .user-profile .social-media a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu .user-profile .follow span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .status {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .status p {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-history .call-icons ul li {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-history .call-icons ul li a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper pre {\n  background-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .scorlled {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .input-group-air {\n  -webkit-box-shadow: 0 3px 20px 0 #4b5469;\n  box-shadow: 0 3px 20px 0 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .input-group-solid .input-group-text,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .input-group-solid .form-control {\n  background: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .semilight-bg-color,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .header-bg-color {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item {\n  background-color: #36404a;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item.active {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item:focus {\n  z-index: 1;\n  text-decoration: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-action:hover:not(.active),\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-action:focus {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-flush .list-group-item {\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-primary {\n  color: #004085;\n  background-color: #b8daff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-success {\n  color: #155724;\n  background-color: #c3e6cb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-danger {\n  color: #721c24;\n  background-color: #f5c6cb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-info {\n  color: #0c5460;\n  background-color: #bee5eb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box h3,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box h4,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg .authentication-box h6 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video .authentication-box h4,\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video .authentication-box h3 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video .authentication-box h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .error-wrapper .maintenance-icons li i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .modal-content {\n  background-color: #36404a;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .modal-content .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .modal-content .modal-header .close {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .modal-content .modal-footer {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .comingsoon {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.8);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .comingsoon .comingsoon-inner h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .comingsoon .comingsoon-inner .countdown {\n  border-top: 1px solid #4b5469;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .comingsoon .comingsoon-inner .countdown .title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .comingsoon .comingsoon-inner img {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerleft {\n  background: url(../images/auth-layer.png), rgba(54, 64, 74, 0.9);\n  background-blend-mode: overlay;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerleft .text-center img {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerleft .social-media li {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h3 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .default-according .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .default-according .card .btn-link {\n  background-color: #36404a;\n  border: 1px solid #36404a;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .default-according .card .text-muted {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .default-according .bg-primary .btn-link {\n  background-color: #ab8ce4;\n  border: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .default-according .bg-secondary .btn-link {\n  background-color: #26c6da;\n  border: 1px solid #26c6da;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .collapse .card-body {\n  background-color: #36404a;\n}\n\n@media screen and (max-width: 1660px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-history .call-icons ul li {\n    border: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-history .total-time h2 {\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .caller-img img {\n    opacity: 0.7;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-box .chat-history .call-content>div {\n    background-color: rgba(0, 0, 0, 0.75);\n    background-blend-mode: overlay;\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .crm-numbers .col {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .crm-numbers .col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .crm-numbers .col+.col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .chat-menu {\n    border-top: 1px solid #4b5469;\n    background-color: #36404a;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .error-wrapper .maintenance-icons li i {\n    color: #2a3142;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .border-widgets>.row>div:nth-child(1) {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .border-widgets>.row>div:nth-child(2) {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .crm-numbers .col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .border-widgets>.row>div+div {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .user-profile .hovercard .info .user-designation {\n    border-top: 1px solid #4b5469;\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .border-widgets>.row>div+div {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .widget-joins .border-after-xs:after {\n    background-color: #4b5469;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .business-card .b-l-light {\n    border-left: 1px solid #4b5469 !important;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  body[main-theme-layout=\"main-theme-layout-2\"] .page-wrapper .border-widgets>.row>div+div+div {\n    border-bottom: 1px solid #4b5469;\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .lg-backdrop {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .lg-outer .lg-thumb-outer {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .drag {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .drag form {\n  background: #36404a;\n  -webkit-box-shadow: 0 0 30px #4b5469;\n  box-shadow: 0 0 30px #4b5469;\n  border: 1px dotted #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .drag form input {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .drag form .help-block {\n  text-transform: capitalize;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .draggable input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .draggable p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .draggable select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .draggable .radio label::before,\nbody[main-theme-layout=\"main-theme-layout-2\"] .draggable .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-container--default .select2-selection--multiple,\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-container--default .select2-selection--single {\n  background-color: #303841;\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-container--default .select2-search--inline .select2-search__field {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-container--default .select2-search--dropdown .select2-search__field {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-dropdown {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-primary {\n  border-color: #ab8ce4 !important;\n  color: #ab8ce4 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-secondary {\n  border-color: #26c6da !important;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-success {\n  border-color: #00c292 !important;\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-info {\n  border-color: #4099ff !important;\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-warning {\n  border-color: #f3d800 !important;\n  color: #f3d800 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-danger {\n  border-color: #FF5370 !important;\n  color: #FF5370 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-inverse {\n  border-color: #fff !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-primary-fill {\n  background-color: #ab8ce4 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-secondary-fill {\n  background-color: #26c6da !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-success-fill {\n  background-color: #00c292 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-info-fill {\n  background-color: #4099ff !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-warning-fill {\n  background-color: #f3d800 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-danger-fill {\n  background-color: #FF5370 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-drpdwn .form-control-inverse-fill {\n  background-color: #fff !important;\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .select2-container--default.select2-container--disabled .select2-selection--single {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group select.form-control:not([size]):not([multiple]) {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=email],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=search],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=password],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=number],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=tel],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=date],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=datetime-local],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=time],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=datetime-local],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=month],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=week],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=url],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=file],\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group select {\n  border-color: #4b5469;\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=text]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=email]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=search]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=password]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=number]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=tel]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=date]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=time]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=month]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=week]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=url]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group input[type=file]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group select::-webkit-input-placeholder {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-group textarea {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-divider {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .theme-form .form-divider::before {\n  background: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .CodeMirror {\n  background: #36404a;\n  border: 1px solid #98a6ad;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .CodeMirror .CodeMirror-code pre {\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-toolbar {\n  border-top: 1px solid #98a6ad;\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-toolbar a {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-toolbar a:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-toolbar a.active {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-toolbar i.separator {\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-toolbar.disabled-for-preview a:not(.no-disable) {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-preview {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-toolbar.fullscreen,\nbody[main-theme-layout=\"main-theme-layout-2\"] .editor-preview-side {\n  background: #36404a;\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-step {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-step.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-step.current {\n  background: #ab8ce4;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-step-title,\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-step-number {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl:before {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl-number,\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl-icon {\n  background: #303841;\n  border: 2px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl.disabled .u-pearl-icon,\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl.disabled .u-pearl-number {\n  background: #4b5469;\n  border: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl.disabled:after {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .u-pearl.error:after {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .note-editor.note-frame {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .note-editor.note-frame .note-editing-area .note-editable {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .swal-modal {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .swal-modal .swal-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .swal-modal .swal-text {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .swal-modal .swal-content__input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs .nav-link.active {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469 #4b5469 #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs .nav-link:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs .nav-link:focus {\n  border-color: #4b5469 #4b5469 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs .nav-item.show .nav-link {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #98a6ad #4b5469 #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs.nav-bottom .nav-item .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs.nav-bottom .nav-item .nav-link.focus,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-tabs.nav-bottom .nav-item .nav-link.hover {\n  border-color: #36404a #4b5469 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left .nav-link,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right .nav-link.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left .show>.nav-link,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right .show>.nav-link {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-secondary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-secondary .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-secondary .nav-link:hover {\n  border-left-color: #26c6da;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-secondary .show>.nav-link {\n  border-left-color: #26c6da;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-secondary .nav-item.show {\n  color: #26c6da !important;\n  border-left-color: #26c6da;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-success .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-success .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-success .nav-link:hover {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-success .show>.nav-link {\n  border-left-color: #00c292;\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-left.nav-success .nav-item.show {\n  color: #00c292 !important;\n  border-left-color: #00c292;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right.nav-info .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right.nav-info .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right.nav-info .nav-link:hover {\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right.nav-info .show>.nav-link {\n  border-left-color: #4099ff;\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-right.nav-info .nav-item.show {\n  color: #4099ff !important;\n  border-left-color: #4099ff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-secondary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-secondary .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-secondary .nav-link:hover {\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-secondary .nav-item.show {\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-success .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-success .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-success .nav-link:hover {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .nav-material.nav-success .nav-item.show {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .dropdown-divider {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .icon-hover-bottom {\n  background-color: #36404a;\n  -webkit-box-shadow: 0px 0px 1px 1px #4b5469;\n  box-shadow: 0px 0px 1px 1px #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .icon-hover-bottom .icon-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .icon-hover-bottom span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .icon-hover-bottom .form-group input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .icon-hover-bottom .icon-first i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] code {\n  background-color: #434f5a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] #cd-timeline::before {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny {\n  border-top: 1px solid #4b5469;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny::before {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny .timeliny-dot {\n  background-color: #36404a;\n  border: 1px solid #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .todo .todo-list-wrapper #todo-list li .task-container {\n  background: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .todo .todo-list-wrapper #todo-list li .task-container .task-label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .todo .todo-list-wrapper #todo-list li .task-container:hover h4 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {\n  background: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {\n  border: 1px solid #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .ttl-info h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .ttl-info span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .hovercard .info .title a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .hovercard .user-image .avatar img {\n  border: 10px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .hovercard .user-image .icon-wrapper {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .profile-img-style .user-name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .user-profile .profile-img-style p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .introjs-helperLayer {\n  background-color: rgba(54, 64, 74, 0.9);\n  border: rgba(255, 255, 255, 0.5);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .jstree-default .jstree-node,\nbody[main-theme-layout=\"main-theme-layout-2\"] .jstree-default .jstree-icon {\n  color: #434f5a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .jstree-default .jstree-anchor {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .jstree-default .jstree-clicked {\n  color: #fff;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .jstree-default .jstree-hovered {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] span.twitter-typeahead .tt-menu {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] span.twitter-typeahead .tt-suggestion {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] span.twitter-typeahead .tt-suggestion:hover,\nbody[main-theme-layout=\"main-theme-layout-2\"] span.twitter-typeahead .tt-suggestion:focus {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .typography small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .blockquote-footer {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 9px #4b5469;\n  box-shadow: 0 0 9px #4b5469;\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .quickview-box:before,\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .quickview-recent-activity:before {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 9px #4b5469;\n  box-shadow: 0 0 9px #4b5469;\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .quickview-box:after,\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .quickview-recent-activity:after {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .nav-material.nav-tabs .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .nav-material.nav-primary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .nav-material.nav-primary .nav-link :hover {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .nav-material.nav-primary .nav-item.show,\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .nav-material.nav-primary .nav-link:focus {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .modal-header .modal-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .modal-header i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .friend-list-search {\n  background-color: #2f3841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .friend-list-search input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .recent-activity .activity-content h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .recent-activity .activity-content hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .recent-activity .user-first-letter:after {\n  border: 1px dashed #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .quickview-wrapper .chat-box .about .name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy pre {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy pre code {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy pre[class*=\"language-\"] {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy .code-box-copy__btn {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy code[class*=language-],\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy pre[class*=language-] {\n  text-shadow: 0px 1px #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy code[class*=language-] ::-moz-selection,\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy pre[class*=language-] ::-moz-selection {\n  text-shadow: none;\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy code[class*=language-] ::selection,\nbody[main-theme-layout=\"main-theme-layout-2\"] .code-box-copy pre[class*=language-] ::selection {\n  text-shadow: none;\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] table.fixedHeader-floating {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .dt-button-info {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .dt-button-info h2 {\n  background-color: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] #keytable_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #column-selector_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #auto-fill_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #custom-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #class-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #keyboard-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #multilevel-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #pagelength-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #basic-colreorder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #state-saving_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #real-time_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #basic-fixed-header_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #fixed-header-footer_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #export-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #excel-cust-bolder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #cust-json_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #basic-key-table_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #focus-cell_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #responsive_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #new-cons_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #show-hidden-row_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #basic-row-reorder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #full-row_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-2\"] #rest-column_wrapper .dataTables_paginate {\n  border: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,\nbody[main-theme-layout=\"main-theme-layout-2\"] #example-style-8_wrapper table.dataTable.display tbody tr.odd {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .error-wrapper {\n  background-color: rgba(54, 64, 74, 0.8);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .error-wrapper .sub-content {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .b-light {\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .modal-content {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .modal-content .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .modal-content .ui-front .form-control {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .stepwizard .stepwizard-row:before {\n  background-color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .modal .theme-close {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.atrule,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.attr-value,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.keyword {\n  color: #4099ff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.boolean,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.constant,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.deleted,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.number,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.property,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.symbol,\nbody[main-theme-layout=\"main-theme-layout-2\"] .token.tag {\n  color: #FF5370;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .loader-box.card-loader {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .my-gallery.gallery-with-description img {\n  border: 1px solid #4b5469 !important;\n  border-bottom: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-primary.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-secondary.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-success.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-danger.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-warning.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-info.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-light.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-2\"] .alert-dark.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .flot-chart-container .legend .table tbody {\n  background-color: #36404a;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .flot-chart-container .legend .table tbody .legendLabel {\n  padding-left: 5px;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-dark .nav-link,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-pills.nav-dark .nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .default-according .card .btn-link {\n  background-color: #fff;\n  border: 1px solid #eeeeee;\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .collapse .card-body {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .theme-form .form-group input[type=email],\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .theme-form .form-group textarea {\n  border-color: #eeeeee;\n  background-color: #fff;\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .theme-form .form-group label {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header #accordionoc #collapseicon,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header #accordionoc #collapseicon1 {\n  background-color: #fff;\n}\n\n@media only screen and (max-width: 575px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .nav-right>ul .search-form .mobile-search {\n    -webkit-filter: brightness(1) invert(100%);\n    filter: brightness(1) invert(100%);\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-main-header .nav-right>ul .search-form .form-control-plaintext {\n    background-color: #303841;\n    -webkit-filter: brightness(1) invert(9%) !important;\n    filter: brightness(1) invert(9%) !important;\n    border: 1px solid #4b5469;\n    color: rgba(255, 255, 255, 0.7);\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper {\n  /* sidebar start */\n  /* sidebar end */\n  /* body start*/\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar {\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {\n  background-blend-mode: overlay;\n  background-color: #17191d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar.navigation-bordered .sidebar-header {\n  border-bottom: 1px solid rgba(241, 241, 241, 0.35);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {\n  background-color: #36404a;\n  -webkit-box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);\n  box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {\n  color: #eeeeee;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {\n  color: #ab8ce4;\n  border-bottom: 1px solid rgba(241, 241, 241, 0.35);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {\n  margin-top: 3px;\n  margin-right: 5px;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {\n  color: #f3d800;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {\n  color: #eeeeee;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top i {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-bottom {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {\n  border-bottom: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .custom-card .card-header img {\n  background-color: #000;\n  opacity: 0.1;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-header .row h3 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-header .breadcrumb-item.active {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body {\n  background-color: #303841;\n  /* body end*/\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card {\n  background-color: #36404a;\n  -webkit-box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header {\n  background-color: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h2,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h3,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h4,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h5,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-header .card-header-right i {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline-2x,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card #animation-box .animate-widget p {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .grid-item img {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .line {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table td {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table thead th {\n  border-bottom: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table thead .border-bottom-primary th {\n  border-bottom: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger td {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-primary,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-secondary,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-success,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-info,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-warning,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-danger {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-light {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .thead-light th {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .double,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .dotted,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table .dashed {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary td {\n  border-bottom: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table td {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered th {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-inverse tbody tr:nth-of-type(odd):hover td {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical tr,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical td {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .card-footer {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .switch .switch-state {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .switch input:checked+.switch-state {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .bg-white {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .business-top-widget .media span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .b-l-light {\n  border-left: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .business-card table td {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .business-card table th {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .business-card .logo {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .media .social-sub-title {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .total-value {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .social-icons {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .ct-grid {\n  stroke: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .ct-label {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .text-muted {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:before {\n  border-bottom: 10px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:after {\n  border-bottom: 9px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .calender-widget .cal-date {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form .form-icon {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-dark {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .btn-light {\n  color: #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .btn-light:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .border-right {\n  border-right: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder .flot-text {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#line-chart rect,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart1 rect,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart2 rect {\n  fill: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>rect {\n  fill: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>g>g text {\n  fill: #b1b1b2;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .radial-bar:after {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num .color-bottom {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .b-r-light {\n  border-right: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-labels .ct-label {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-grid {\n  stroke: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #browser-uses-chart svg text,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #website-visiter-chart svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .status-details span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .clipboaard-container .form-control {\n  background-color: #303841;\n  color: #98a6ad;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .img-thumbnail {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard .media img {\n  -webkit-filter: brightness(0) invert(75%);\n  filter: brightness(0) invert(75%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr+tr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td p,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_info,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_processing,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter input[type=\"search\"] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover>.sorting_1 {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even>.sorting_1 {\n  background-color: rgba(53, 59, 74, 0.3);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead td {\n  border-bottom: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable input,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody tr {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody td {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even:hover>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover>.sorting_1 {\n  background-color: #2c3239;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.hover tbody tr:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td {\n  border-top: 1px solid #4b5469;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th:first-child,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td:first-child {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_2,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_3,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_2,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_3 {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card #example-style-3_wrapper #example-style-3 tfoot {\n  border-top: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .page-item.disabled .page-link {\n  background-color: #36404a;\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .page-link {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .page-link:hover {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .page-item.active .page-link {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .icon {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col+.col {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-container-small {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li:hover {\n  background-color: #000;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td span,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .product-table h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-selected {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a {\n  border: 2px solid #4b5469;\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-selected {\n  border: 2px solid #ab8ce4;\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a:after,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a:after {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-selected:after,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-active:after,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-active:after {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .scroll-demo {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .search-form input {\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content::before {\n  border-left: 7px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n  border-right-color: #4b5469;\n  border-left: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .breadcrumb {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .user-status table td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card .user-status table th {\n  border-top: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris-daily svg,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris svg,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card #browser-uses-chart svg,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card #website-visiter-chart svg {\n  opacity: 0.5;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-des {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show>.nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #viewhtml .render {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {\n  border: 1px dotted #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description a>div {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell {\n  background: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell input,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell input,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell input,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell input {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-row>.jsgrid-cell {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row>.jsgrid-cell {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row>.jsgrid-cell {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*=\"jsgrid-pager\"] {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 700;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .sub-title {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {\n  color: #ab8ce4 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 2px 2px #4b5469;\n  box-shadow: 0 0 2px 2px #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {\n  border-bottom: 7px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .border {\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {\n  color: #98a6ad;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {\n  border-right: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .comment-box .media img {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .comment-box p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .comment-box hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover td,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover th {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body ul.the-icons li {\n  border: 1px dotted #4b5469;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-agendaWeek-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicDay-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaWeek-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaDay-button {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .border-widgets>.row>div+div {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top .details h4 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom h5 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li+li {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .icon-bg {\n  color: #2e3945;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .left i {\n  color: #303841;\n  text-shadow: 1px 1px 1px #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .testimonial-default .slide--item p {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div+div {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .checkbox label::before,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .radio label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {\n  -webkit-column-rule: 1px solid #4b5469;\n  column-rule: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {\n  border: 2px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .icon-lists div i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .media-body>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .details {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .widget-joins:before,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .widget-joins:after {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h5,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .b-b-light {\n  border-bottom: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .b-r-dark {\n  border-right: 1px solid #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .testimonial i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .testimonial p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .testimonial h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .testimonial span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .grid-showcase span {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .grid-align .row {\n  background-color: #4b5469;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .border-style .card {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .offer-style .card {\n  border: 1px dashed #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {\n  background-color: #36404a;\n  color: #98a6ad !important;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {\n  border-left: 3px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {\n  color: #98a6ad;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {\n  border: 1px solid #4b5469;\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .pricing-card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h3 {\n  color: rgba(206, 212, 218, 0.3);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-price h1 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li::before {\n  color: rgba(255, 255, 255, 0.15);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .search-page .info-block+.info-block {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper footer {\n  border-top: 1px solid #303841;\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .custom-select,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .custom-file-label {\n  background: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .page-body-wrapper .footer-fix {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .dt-button-info {\n  background-color: #36404a;\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .dt-button-info h2 {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .about .name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu .nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {\n  background-color: #36404a;\n  -webkit-box-shadow: 1px 1px 3px 1px #303841;\n  box-shadow: 1px 1px 3px 1px #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {\n  border: 5px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu .user-profile .social-media a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu .user-profile .follow span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .status {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .status p {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-history .call-icons ul li {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-history .call-icons ul li a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper pre {\n  background-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .scorlled {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .input-group-air {\n  -webkit-box-shadow: 0 3px 20px 0 #4b5469;\n  box-shadow: 0 3px 20px 0 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .input-group-solid .input-group-text,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .input-group-solid .form-control {\n  background: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .semilight-bg-color,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .header-bg-color {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item {\n  background-color: #36404a;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item.active {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item:focus {\n  z-index: 1;\n  text-decoration: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-action:hover:not(.active),\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-action:focus {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-flush .list-group-item {\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-primary {\n  color: #004085;\n  background-color: #b8daff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-success {\n  color: #155724;\n  background-color: #c3e6cb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-danger {\n  color: #721c24;\n  background-color: #f5c6cb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-info {\n  color: #0c5460;\n  background-color: #bee5eb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box h3,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box h4,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg .authentication-box h6 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video .authentication-box h4,\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video .authentication-box h3 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video .authentication-box h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .error-wrapper .maintenance-icons li i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .modal-content {\n  background-color: #36404a;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .modal-content .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .modal-content .modal-header .close {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .modal-content .modal-footer {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .comingsoon {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.8);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .comingsoon .comingsoon-inner h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .comingsoon .comingsoon-inner .countdown {\n  border-top: 1px solid #4b5469;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .comingsoon .comingsoon-inner .countdown .title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .comingsoon .comingsoon-inner img {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerleft {\n  background: url(../images/auth-layer.png), rgba(54, 64, 74, 0.9);\n  background-blend-mode: overlay;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerleft .text-center img {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerleft .social-media li {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h3 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .default-according .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .default-according .card .btn-link {\n  background-color: #36404a;\n  border: 1px solid #36404a;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .default-according .card .text-muted {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .default-according .bg-primary .btn-link {\n  background-color: #ab8ce4;\n  border: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .default-according .bg-secondary .btn-link {\n  background-color: #26c6da;\n  border: 1px solid #26c6da;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .collapse .card-body {\n  background-color: #36404a;\n}\n\n@media screen and (max-width: 1660px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-history .call-icons ul li {\n    border: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-history .total-time h2 {\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .caller-img img {\n    opacity: 0.7;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-box .chat-history .call-content>div {\n    background-color: rgba(0, 0, 0, 0.75);\n    background-blend-mode: overlay;\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .crm-numbers .col {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .crm-numbers .col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .crm-numbers .col+.col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .chat-menu {\n    border-top: 1px solid #4b5469;\n    background-color: #36404a;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .error-wrapper .maintenance-icons li i {\n    color: #2a3142;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .border-widgets>.row>div:nth-child(1) {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .border-widgets>.row>div:nth-child(2) {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .crm-numbers .col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .border-widgets>.row>div+div {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .user-profile .hovercard .info .user-designation {\n    border-top: 1px solid #4b5469;\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .border-widgets>.row>div+div {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .widget-joins .border-after-xs:after {\n    background-color: #4b5469;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .business-card .b-l-light {\n    border-left: 1px solid #4b5469 !important;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  body[main-theme-layout=\"main-theme-layout-3\"] .page-wrapper .border-widgets>.row>div+div+div {\n    border-bottom: 1px solid #4b5469;\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .lg-backdrop {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .lg-outer .lg-thumb-outer {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .drag {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .drag form {\n  background: #36404a;\n  -webkit-box-shadow: 0 0 30px #4b5469;\n  box-shadow: 0 0 30px #4b5469;\n  border: 1px dotted #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .drag form input {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .drag form .help-block {\n  text-transform: capitalize;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .draggable input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .draggable p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .draggable select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .draggable .radio label::before,\nbody[main-theme-layout=\"main-theme-layout-3\"] .draggable .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-container--default .select2-selection--multiple,\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-container--default .select2-selection--single {\n  background-color: #303841;\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-container--default .select2-search--inline .select2-search__field {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-container--default .select2-search--dropdown .select2-search__field {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-dropdown {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-primary {\n  border-color: #ab8ce4 !important;\n  color: #ab8ce4 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-secondary {\n  border-color: #26c6da !important;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-success {\n  border-color: #00c292 !important;\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-info {\n  border-color: #4099ff !important;\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-warning {\n  border-color: #f3d800 !important;\n  color: #f3d800 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-danger {\n  border-color: #FF5370 !important;\n  color: #FF5370 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-inverse {\n  border-color: #fff !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-primary-fill {\n  background-color: #ab8ce4 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-secondary-fill {\n  background-color: #26c6da !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-success-fill {\n  background-color: #00c292 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-info-fill {\n  background-color: #4099ff !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-warning-fill {\n  background-color: #f3d800 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-danger-fill {\n  background-color: #FF5370 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-drpdwn .form-control-inverse-fill {\n  background-color: #fff !important;\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .select2-container--default.select2-container--disabled .select2-selection--single {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group select.form-control:not([size]):not([multiple]) {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=email],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=search],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=password],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=number],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=tel],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=date],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=datetime-local],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=time],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=datetime-local],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=month],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=week],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=url],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=file],\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group select {\n  border-color: #4b5469;\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=text]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=email]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=search]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=password]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=number]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=tel]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=date]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=time]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=month]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=week]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=url]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group input[type=file]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group select::-webkit-input-placeholder {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-group textarea {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-divider {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .theme-form .form-divider::before {\n  background: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .CodeMirror {\n  background: #36404a;\n  border: 1px solid #98a6ad;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .CodeMirror .CodeMirror-code pre {\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-toolbar {\n  border-top: 1px solid #98a6ad;\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-toolbar a {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-toolbar a:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-toolbar a.active {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-toolbar i.separator {\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-toolbar.disabled-for-preview a:not(.no-disable) {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-preview {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-toolbar.fullscreen,\nbody[main-theme-layout=\"main-theme-layout-3\"] .editor-preview-side {\n  background: #36404a;\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-step {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-step.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-step.current {\n  background: #ab8ce4;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-step-title,\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-step-number {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl:before {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl-number,\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl-icon {\n  background: #303841;\n  border: 2px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl.disabled .u-pearl-icon,\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl.disabled .u-pearl-number {\n  background: #4b5469;\n  border: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl.disabled:after {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .u-pearl.error:after {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .note-editor.note-frame {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .note-editor.note-frame .note-editing-area .note-editable {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .swal-modal {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .swal-modal .swal-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .swal-modal .swal-text {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .swal-modal .swal-content__input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs .nav-link.active {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469 #4b5469 #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs .nav-link:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs .nav-link:focus {\n  border-color: #4b5469 #4b5469 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs .nav-item.show .nav-link {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #98a6ad #4b5469 #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs.nav-bottom .nav-item .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs.nav-bottom .nav-item .nav-link.focus,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-tabs.nav-bottom .nav-item .nav-link.hover {\n  border-color: #36404a #4b5469 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left .nav-link,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right .nav-link.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left .show>.nav-link,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right .show>.nav-link {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-secondary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-secondary .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-secondary .nav-link:hover {\n  border-left-color: #26c6da;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-secondary .show>.nav-link {\n  border-left-color: #26c6da;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-secondary .nav-item.show {\n  color: #26c6da !important;\n  border-left-color: #26c6da;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-success .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-success .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-success .nav-link:hover {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-success .show>.nav-link {\n  border-left-color: #00c292;\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-left.nav-success .nav-item.show {\n  color: #00c292 !important;\n  border-left-color: #00c292;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right.nav-info .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right.nav-info .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right.nav-info .nav-link:hover {\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right.nav-info .show>.nav-link {\n  border-left-color: #4099ff;\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-right.nav-info .nav-item.show {\n  color: #4099ff !important;\n  border-left-color: #4099ff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-secondary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-secondary .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-secondary .nav-link:hover {\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-secondary .nav-item.show {\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-success .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-success .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-success .nav-link:hover {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .nav-material.nav-success .nav-item.show {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .dropdown-divider {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .icon-hover-bottom {\n  background-color: #36404a;\n  -webkit-box-shadow: 0px 0px 1px 1px #4b5469;\n  box-shadow: 0px 0px 1px 1px #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .icon-hover-bottom .icon-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .icon-hover-bottom span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .icon-hover-bottom .form-group input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .icon-hover-bottom .icon-first i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] code {\n  background-color: #434f5a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] #cd-timeline::before {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny {\n  border-top: 1px solid #4b5469;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny::before {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny .timeliny-dot {\n  background-color: #36404a;\n  border: 1px solid #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .todo .todo-list-wrapper #todo-list li .task-container {\n  background: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .todo .todo-list-wrapper #todo-list li .task-container .task-label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .todo .todo-list-wrapper #todo-list li .task-container:hover h4 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {\n  background: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {\n  border: 1px solid #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .ttl-info h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .ttl-info span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .hovercard .info .title a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .hovercard .user-image .avatar img {\n  border: 10px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .hovercard .user-image .icon-wrapper {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .profile-img-style .user-name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .user-profile .profile-img-style p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .introjs-helperLayer {\n  background-color: rgba(54, 64, 74, 0.9);\n  border: rgba(255, 255, 255, 0.5);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .jstree-default .jstree-node,\nbody[main-theme-layout=\"main-theme-layout-3\"] .jstree-default .jstree-icon {\n  color: #434f5a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .jstree-default .jstree-anchor {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .jstree-default .jstree-clicked {\n  color: #fff;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .jstree-default .jstree-hovered {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] span.twitter-typeahead .tt-menu {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] span.twitter-typeahead .tt-suggestion {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] span.twitter-typeahead .tt-suggestion:hover,\nbody[main-theme-layout=\"main-theme-layout-3\"] span.twitter-typeahead .tt-suggestion:focus {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .typography small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .blockquote-footer {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 9px #4b5469;\n  box-shadow: 0 0 9px #4b5469;\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .quickview-box:before,\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .quickview-recent-activity:before {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 9px #4b5469;\n  box-shadow: 0 0 9px #4b5469;\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .quickview-box:after,\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .quickview-recent-activity:after {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .nav-material.nav-tabs .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .nav-material.nav-primary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .nav-material.nav-primary .nav-link :hover {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .nav-material.nav-primary .nav-item.show,\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .nav-material.nav-primary .nav-link:focus {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .modal-header .modal-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .modal-header i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .friend-list-search {\n  background-color: #2f3841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .friend-list-search input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .recent-activity .activity-content h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .recent-activity .activity-content hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .recent-activity .user-first-letter:after {\n  border: 1px dashed #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .quickview-wrapper .chat-box .about .name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy pre {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy pre code {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy pre[class*=\"language-\"] {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy .code-box-copy__btn {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy code[class*=language-],\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy pre[class*=language-] {\n  text-shadow: 0px 1px #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy code[class*=language-] ::-moz-selection,\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy pre[class*=language-] ::-moz-selection {\n  text-shadow: none;\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy code[class*=language-] ::selection,\nbody[main-theme-layout=\"main-theme-layout-3\"] .code-box-copy pre[class*=language-] ::selection {\n  text-shadow: none;\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] table.fixedHeader-floating {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .dt-button-info {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .dt-button-info h2 {\n  background-color: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] #keytable_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #column-selector_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #auto-fill_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #custom-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #class-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #keyboard-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #multilevel-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #pagelength-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #basic-colreorder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #state-saving_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #real-time_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #basic-fixed-header_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #fixed-header-footer_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #export-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #excel-cust-bolder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #cust-json_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #basic-key-table_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #focus-cell_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #responsive_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #new-cons_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #show-hidden-row_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #basic-row-reorder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #full-row_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-3\"] #rest-column_wrapper .dataTables_paginate {\n  border: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,\nbody[main-theme-layout=\"main-theme-layout-3\"] #example-style-8_wrapper table.dataTable.display tbody tr.odd {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .error-wrapper {\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .error-wrapper .sub-content {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .b-light {\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .modal-content {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .modal-content .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .modal-content .ui-front .form-control {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .stepwizard .stepwizard-row:before {\n  background-color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .modal .theme-close {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.atrule,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.attr-value,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.keyword {\n  color: #4099ff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.boolean,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.constant,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.deleted,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.number,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.property,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.symbol,\nbody[main-theme-layout=\"main-theme-layout-3\"] .token.tag {\n  color: #FF5370;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .loader-box.card-loader {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-3\"] .my-gallery.gallery-with-description img {\n  border: 1px solid #4b5469 !important;\n  border-bottom: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .flot-chart-container .legend .table tbody {\n  background-color: #36404a;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .flot-chart-container .legend .table tbody .legendLabel {\n  padding-left: 5px;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .google-visualization-tooltip text {\n  fill: rgba(0, 0, 0, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-dark .nav-link,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-pills.nav-dark .nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .loader-wrapper {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .loader-wrapper .loader {\n  background-color: #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper {\n  /* Main Header start */\n  /* Main Header ends */\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header {\n  background-color: #36404a;\n  -webkit-box-shadow: 0px 0px 1px 1px rgba(255, 255, 255, 0.7);\n  box-shadow: 0px 0px 1px 1px rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right li i {\n  color: #eeeeee;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .form-inline .form-control-plaintext {\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li a img {\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .media img {\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .media .media-body .txt-dark {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .onhover-show-div {\n  background-color: #303841;\n  -webkit-box-shadow: 0 0 2px 2px #36404a;\n  box-shadow: 0 0 2px 2px #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .onhover-show-div:before {\n  border-bottom: 7px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .onhover-show-div:after {\n  border-bottom: 7px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .notification-dropdown.onhover-show-div li {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .notification-dropdown.onhover-show-div li span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .nav-menus li .language-dropdown li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .profile-dropdown li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right .search-form input {\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li a img {\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .media img {\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .media .media-body .txt-dark {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .onhover-show-div {\n  background-color: #303841;\n  -webkit-box-shadow: 0 0 2px 2px #36404a;\n  box-shadow: 0 0 2px 2px #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .onhover-show-div:before {\n  border-bottom: 7px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .onhover-show-div:after {\n  border-bottom: 7px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .notification-dropdown.onhover-show-div li {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .notification-dropdown.onhover-show-div li span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul>li .language-dropdown li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .mega-menu-header .vertical-menu-main .main-nav .main-menu li {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-left {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-left .logo-wrapper a .image-dark {\n  display: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-left .logo-wrapper a .image-light {\n  display: block;\n}\n\n@media only screen and (max-width: 991px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .main-header-right .nav-right>ul {\n    background-color: #36404a;\n    -webkit-box-shadow: 0 2px 2px 2px #4b5469;\n    box-shadow: 0 2px 2px 2px #4b5469;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .nav-right>ul .search-form .mobile-search {\n    -webkit-filter: brightness(1) invert(100%);\n    filter: brightness(1) invert(100%);\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-main-header .nav-right>ul .search-form .form-control-plaintext {\n    background-color: #303841;\n    -webkit-filter: brightness(1) invert(9%) !important;\n    filter: brightness(1) invert(9%) !important;\n    border: 1px solid #4b5469;\n    color: rgba(255, 255, 255, 0.7);\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper {\n  /* sidebar start */\n  /* sidebar end */\n  /* body start*/\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header>i {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .single-header,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li:hover .sidebar-submenu {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu li a:hover+ul {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card.custom-card .card-header {\n  border-bottom: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .custom-card .card-header img {\n  background-color: #000;\n  opacity: 0.1;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar {\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {\n  background-blend-mode: overlay;\n  background-color: #17191d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar.navigation-bordered .sidebar-header {\n  border-bottom: 1px solid rgba(241, 241, 241, 0.15);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user {\n  background-color: #36404a;\n  -webkit-box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);\n  box-shadow: 3px 2px 8px -1px rgba(255, 255, 255, 0.13);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-user p {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-title {\n  color: #ab8ce4;\n  border-bottom: 1px solid rgba(241, 241, 241, 0.35);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li .label {\n  margin-top: 3px;\n  margin-right: 5px;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.sidebar-header {\n  color: #f3d800;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {\n  color: #eeeeee;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-top i {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-sidebar .sidebar-widget .sidebar-widget-bottom {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-header .row h3 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-header .breadcrumb-item.active {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body {\n  background-color: #303841;\n  /* body end*/\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card {\n  background-color: #36404a;\n  -webkit-box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n  box-shadow: 1px 1px 2px 1px rgba(255, 255, 255, 0.08);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header {\n  background-color: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h2,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h3,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h4,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h5,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-header .card-header-right i {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .alert-dark a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.outline-2x,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .alert-light.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card #animation-box .animate-widget p {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .grid-item img {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .line {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table td {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table thead th {\n  border-bottom: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table thead .border-bottom-primary th {\n  border-bottom: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-primary td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-secondary td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-success td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-info td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-warning td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-light td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .table-danger td {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-primary,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-secondary,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-success,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-info,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-warning,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-danger {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .bg-light {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .thead-light th {\n  color: #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .double,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .dotted,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table .dashed {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table tbody .border-bottom-primary td {\n  border-bottom: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-responsive .table td {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table[class*='bg-'] td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-striped tbody tr:nth-of-type(odd):hover td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-bordered th {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-inverse tbody tr:nth-of-type(odd):hover td {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical tr,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-border-vertical td {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling thead td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .table-styling tbody td {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .card-footer {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .switch .switch-state {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .switch input:checked+.switch-state {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .bg-white {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .business-top-widget .media span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .b-l-light {\n  border-left: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .business-card table td {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .business-card table th {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .business-card .logo {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .media .social-sub-title {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .total-value {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .social-widget .social-icons {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .ct-grid {\n  stroke: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .ct-label {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .text-muted {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:before {\n  border-bottom: 10px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .review-box .testimonial .content:after {\n  border-bottom: 9px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .calender-widget .cal-date {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .contact-form .theme-form .form-icon {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-dark {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .btn-outline-light:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .btn-light {\n  color: #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .btn-light:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .border-right {\n  border-right: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder .flot-text {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-placeholder svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#line-chart rect,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart1 rect,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow#column-chart2 rect {\n  fill: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>rect {\n  fill: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>g>g text {\n  fill: #b1b1b2;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-overflow svg>g>text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .radial-bar:after {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .bar-chart-widget .bottom-content .num .color-bottom {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .b-r-light {\n  border-right: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-labels .ct-label,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-labels .ct-label {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .live-products .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .turnover .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .monthly .ct-grid,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container .uses .ct-grid {\n  stroke: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #browser-uses-chart svg text,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .chart-container #website-visiter-chart svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .status-details h4 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .status-details span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .clipboaard-container .form-control {\n  background-color: #303841;\n  color: #98a6ad;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .img-thumbnail {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .crm-top-widget .media .media-body span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard .media img {\n  -webkit-filter: brightness(0) invert(75%);\n  filter: brightness(0) invert(75%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .stat-widget-dashboard span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr+tr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td p,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .support-ticket table tr td span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_length,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_info,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_processing,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_filter input[type=\"search\"] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr:hover>.sorting_1 {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.odd>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.odd>.sorting_1 {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.stripe tbody tr.even>.sorting_1 {\n  background-color: rgba(53, 59, 74, 0.3);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable thead td {\n  border-bottom: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable input,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody tr {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody td.select-checkbox:before,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable tbody th.select-checkbox:before {\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .table-striped tbody tr:nth-of-type(odd) {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper .dataTables_paginate .paginate_button.disabled :active {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.row-border tbody td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody td {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr.even:hover>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column.hover tbody tr.even:hover>.sorting_1 {\n  background-color: #2c3239;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.hover tbody tr:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr:hover {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td {\n  border-top: 1px solid #4b5469;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border th:first-child,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.cell-border td:first-child {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_2,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.order-column tbody tr>.sorting_3,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_2,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .dataTables_wrapper table.dataTable.display tbody tr>.sorting_3 {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card #example-style-3_wrapper #example-style-3 tfoot {\n  border-top: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .page-item.disabled .page-link {\n  background-color: #36404a;\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .page-link {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .page-link:hover {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .page-item.active .page-link {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .icon {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget .total-num span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .ecommerce-widget span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col+.col {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .crm-numbers .col>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .flot-chart-container-small {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-details span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .product-box .product-img .product-hover ul li:hover {\n  background-color: #000;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td span,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .product-table #API-2_wrapper #API-2 tbody td p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .product-table h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .nav-material.nav-tabs .nav-link:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-1to10 .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-movie .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-pill .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-reversed .br-widget a.br-selected,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-horizontal .br-widget a.br-selected {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a {\n  border: 2px solid #4b5469;\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-bars-square .br-widget a.br-selected {\n  border: 2px solid #ab8ce4;\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a:after,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a:after {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-selected:after,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars .br-widget a.br-active:after,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-selected:after,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .br-theme-fontawesome-stars-o .br-widget a.br-active:after {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .scroll-demo {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .search-form input {\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n  -webkit-filter: brightness(0) invert(100%);\n  filter: brightness(0) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-content::before {\n  border-left: 7px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n  border-right-color: #4b5469;\n  border-left: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .breadcrumb {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .user-status table td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card .user-status table th {\n  border-top: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris-daily svg,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card #donut-color-chart-morris svg,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card #browser-uses-chart svg,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card #website-visiter-chart svg {\n  opacity: 0.5;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .customer-review .media-body .cust-des {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder-header-1,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder-2-header {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .show>.nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-link.active {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .show>.nav-link {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .nav-primary .nav-pills.nav-primary .nav-link.active {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .drag-box fieldset {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder .help-block {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #viewhtml .render {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-builder-column .drag-bx {\n  border: 1px dotted #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .wizard-4 ul.anchor li a.disabled {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description a>div {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .gallery-with-description p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-header {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell {\n  background: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-header-cell input,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row>.jsgrid-cell input,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-header-cell input,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row>.jsgrid-cell input {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-header-row select,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-filter-row select {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-row>.jsgrid-cell {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-alt-row>.jsgrid-cell {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-cell,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-grid-body {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-selected-row>.jsgrid-cell {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager [class*=\"jsgrid-pager\"] {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid .jsgrid-pager .jsgrid-pager-page a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .jsgrid-pager-current-page {\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 700;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .sub-title {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .navs-icon li a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .navs-icon .separator {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .default-according li .text-muted {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .navs-icon.default-according.style-1 li button:hover {\n  color: #ab8ce4 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .nav-list .nav-list-disc li:hover a {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .navs-dropdown .onhover-show-div {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 2px 2px #4b5469;\n  box-shadow: 0 0 2px 2px #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .onhover-dropdown:hover .onhover-show-div:before {\n  border-bottom: 7px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .default-according .card .btn-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .default-according .card .card-body {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .border {\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-date {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li {\n  color: #98a6ad;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:first-child,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:first-child {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .blog-social li:last-child,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .blog-social li:last-child {\n  border-right: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details p,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details .single-blog-content-top p,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .blog-box .blog-details-main .single-blog-content-top p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .comment-box .media h6 span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .comment-box .media img {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .comment-box p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .comment-box .comment-social li:first-child {\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .comment-box hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover td,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .table-hover tbody tr:hover th {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body ul.the-icons li {\n  border: 1px dotted #4b5469;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .box {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap .button-preview h2 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .button-builder-wrap pre.well {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-next-button .fc-icon-right-single-arrow:after,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-next-button .fc-icon-right-single-arrow:after {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-prev-button .fc-icon-left-single-arrow:after,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .fc-prev-button .fc-icon-left-single-arrow:after {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-left .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic .fc-toolbar .fc-right .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-right .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-agendaWeek-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-basic-view .fc-toolbar .fc-left .fc-button-group .fc-month-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-basicDay-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaWeek-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-agendaDay-button {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-left .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-agenda-view .fc-toolbar .fc-right .fc-button-group .fc-agendaWeek-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .btn-light,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-basicWeek-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .btn-light {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button {\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-right .fc-button-group .fc-month-button:hover {\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .basic-calendar .fc-toolbar .fc-left .btn-light:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-bg-events .fc-toolbar .fc-left .btn-light:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #cal-event-colors .fc-toolbar .fc-left .btn-light:hover {\n  background-color: #303841 !important;\n  border: 1px solid #303841 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .border-widgets>.row>div+div {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top {\n  background-color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-top .details h4 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom h5 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .whether-widget .whether-widget-bottom span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li+li {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .crm-activity>li h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .crm-activity ul.dates li {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .icon-bg {\n  color: #2e3945;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .default-widget-count .left i {\n  color: #303841;\n  text-shadow: 1px 1px 1px #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris svg text,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body #donut-color-chart-morris-daily svg text {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .testimonial-default .slide--item p {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-profile img {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .custom-card .profile-details h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-social li a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .custom-card .card-footer>div+div {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .checkbox label::before,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .radio label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content a:hover {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropdown-basic .dropdown .dropdown-content .dropdown-divider {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropup-basic .dropup .dropup-content a.active {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropzone.dz-clickable .dz-message span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropzone .dz-preview .dz-details {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body {\n  -webkit-column-rule: 1px solid #4b5469;\n  column-rule: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body h4 span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .browser-widget .media-body span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .media img {\n  border: 2px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-app-sidebar .main-menu>li a:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-right-aside .email-body .inbox .media.active {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body h6 small span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .media-body p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-top {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .email-wrap .email-content .email-top .user-emailid:after {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .dropdown-menu a:hover {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .icon-lists div i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .icon-lists div:hover {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .media-body>span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .widget-joins .media .details {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .widget-joins:before,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .widget-joins:after {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .redial-social-widget i {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h5,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .social-widget-card span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .b-b-light {\n  border-bottom: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .b-r-dark {\n  border-right: 1px solid #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .testimonial i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .testimonial p {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .testimonial h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .testimonial span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .grid-showcase span {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .grid-align .row {\n  background-color: #4b5469;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .border-style .card {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .offer-style .card {\n  border: 1px dashed #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-grid {\n  background-color: #36404a;\n  color: #98a6ad !important;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-mainControls .ge-addRowGroup .ge-row-icon .column {\n  border-left: 3px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-code,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .btn-screen {\n  color: #98a6ad;\n  border-right: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .row {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .column {\n  border: 1px solid #4b5469;\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details input {\n  background-color: #303841;\n  border-color: #4b5469;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-canvas.ge-editing .ge-tools-drawer .ge-details .btn-group a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .page-builder .ge-content-type-ckeditor {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .pricing-card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h3 {\n  color: rgba(206, 212, 218, 0.3);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-title h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-price h1 small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .pricing-wrapper-card .card-description li::before {\n  color: rgba(255, 255, 255, 0.15);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .search-page .info-block+.info-block {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-primary h5,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .page-body .card-absolute .bg-secondary h5 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper footer {\n  border-top: 1px solid #303841;\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .custom-select,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .custom-file-label {\n  background: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .page-body-wrapper .footer-fix {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .dt-button-info {\n  background-color: #36404a;\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .dt-button-info h2 {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .about .name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu {\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu .nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu .nav-tabs .nav-item .nav-link.active {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu .user-profile .image .icon-wrapper {\n  background-color: #36404a;\n  -webkit-box-shadow: 1px 1px 3px 1px #303841;\n  box-shadow: 1px 1px 3px 1px #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu .user-profile .image .avatar img {\n  border: 5px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu .user-profile .social-media a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu .user-profile .follow span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-menu .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .status {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .status p {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-header .chat-menu-icons li a i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .my-message {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .message {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-msg-box .other-message {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message {\n  background-color: #36404a;\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-right-aside .chat .chat-message .input-group .form-control {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-history .call-icons ul li {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-history .call-icons ul li a {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper pre {\n  background-color: #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .scorlled {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .input-group-air {\n  -webkit-box-shadow: 0 3px 20px 0 #4b5469;\n  box-shadow: 0 3px 20px 0 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .input-group-solid .input-group-text,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .input-group-solid .form-control {\n  background: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .semilight-bg-color,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .header-bg-color {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item {\n  background-color: #36404a;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item.active {\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item:focus {\n  z-index: 1;\n  text-decoration: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-action:hover:not(.active),\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-action:focus {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-flush .list-group-item {\n  border-left: 0;\n  border-right: 0;\n  border-radius: 0;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-primary {\n  color: #004085;\n  background-color: #b8daff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-secondary {\n  color: #383d41;\n  background-color: #d6d8db;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-success {\n  color: #155724;\n  background-color: #c3e6cb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-danger {\n  color: #721c24;\n  background-color: #f5c6cb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-warning {\n  color: #856404;\n  background-color: #ffeeba;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-info {\n  color: #0c5460;\n  background-color: #bee5eb;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-light {\n  color: #818182;\n  background-color: #fdfdfe;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .list-group-item-dark {\n  color: #1b1e21;\n  background-color: #c6c8ca;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group input {\n  color: rgba(255, 255, 255, 0.7);\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .form-group label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box h3,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box h4,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg .authentication-box h6 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video .authentication-box h4,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video .authentication-box h3 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video .authentication-box h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .auth-bg-video .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .error-wrapper .maintenance-icons li i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .error-wrapper .maintenance-icons li:nth-child(3) i {\n  color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .modal-content {\n  background-color: #36404a;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .modal-content .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .modal-content .modal-header .close {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .modal-content .modal-footer {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .comingsoon {\n  background-blend-mode: overlay;\n  background-color: rgba(54, 64, 74, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .comingsoon .comingsoon-inner h5 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .comingsoon .comingsoon-inner .countdown {\n  border-top: 1px solid #4b5469;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .comingsoon .comingsoon-inner .countdown .title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .comingsoon .comingsoon-inner .coming-soon-bottom-link a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .comingsoon .comingsoon-inner img {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerleft {\n  background: url(../images/auth-layer.png), rgba(54, 64, 74, 0.9);\n  background-blend-mode: overlay;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerleft .text-center img {\n  -webkit-filter: brightness(1) invert(100%);\n  filter: brightness(1) invert(100%);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerleft .social-media li {\n  color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .reset-password-link {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group label {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .form-group .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .reset-password-box .theme-form .opt-box {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h4 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .authentication-box h3 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .form-group input[type=password] {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .authentication-main .auth-innerright .authentication-box .card .theme-form .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .vertical-menu-main {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap a:focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap a:active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap a:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap>li>a.highlighted:before {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap>li>a.highlighted:after {\n  background-color: #4b5469;\n}\n\n@media (min-width: 1200px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul {\n    background: #303841;\n    border: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a:hover,\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a:focus,\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a:active,\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a.highlighted {\n    color: #ab8ce4;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a.current {\n    background-color: #303841;\n    color: #ab8ce4;\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .mega-menu .title {\n  color: rgba(255, 255, 255, 0.7);\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .mega-menu .galleria-list .galleria>div .username {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .mega-menu .galleria-list .galleria>div .username small {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .mega-menu .list-unstyled div a:hover {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .default-according .card {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .default-according .card .btn-link {\n  background-color: #36404a;\n  border: 1px solid #36404a;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .default-according .card .text-muted {\n  color: #98a6ad !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .default-according .bg-primary .btn-link {\n  background-color: #ab8ce4;\n  border: 1px solid #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .default-according .bg-secondary .btn-link {\n  background-color: #26c6da;\n  border: 1px solid #26c6da;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .collapse .card-body {\n  background-color: #36404a;\n}\n\n@media screen and (max-width: 1660px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-history .call-icons ul li {\n    border: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-history .total-time h2 {\n    color: rgba(255, 255, 255, 0.7);\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .caller-img img {\n    opacity: 0.7;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-box .chat-history .call-content>div {\n    background-color: rgba(0, 0, 0, 0.75);\n    background-blend-mode: overlay;\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .crm-numbers .col {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .crm-numbers .col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .crm-numbers .col+.col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .sm {\n    background-color: #36404a;\n    border: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap .mobile-back {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul li {\n    border-top: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a {\n    background: #36404a;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a:hover,\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a:focus,\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul a:active {\n    background: #36404a;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .chat-menu {\n    border-top: 1px solid #4b5469;\n    background-color: #36404a;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .error-wrapper .maintenance-icons li i {\n    color: #2a3142;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .border-widgets>.row>div:nth-child(1) {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .border-widgets>.row>div:nth-child(2) {\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .crm-numbers .col+.col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .pixelstrap ul {\n  background: #36404a;\n}\n\n@media only screen and (max-width: 991px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .crm-numbers .col+.col {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .border-widgets>.row>div+div {\n    border-left: 1px solid #4b5469;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .user-profile .hovercard .info .user-designation {\n    border-top: 1px solid #4b5469;\n    border-bottom: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .border-widgets>.row>div+div {\n    border-left: 1px solid #4b5469;\n  }\n\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .widget-joins .border-after-xs:after {\n    background-color: #4b5469;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .business-card .b-l-light {\n    border-left: 1px solid #4b5469 !important;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  body[main-theme-layout=\"main-theme-layout-4\"] .page-wrapper .border-widgets>.row>div+div+div {\n    border-bottom: 1px solid #4b5469;\n  }\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .lg-backdrop {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .lg-outer .lg-thumb-outer {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .drag {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .drag form {\n  background: #36404a;\n  -webkit-box-shadow: 0 0 30px #4b5469;\n  box-shadow: 0 0 30px #4b5469;\n  border: 1px dotted #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .drag form input {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .drag form .help-block {\n  text-transform: capitalize;\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .draggable input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .draggable p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .draggable select {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .draggable .radio label::before,\nbody[main-theme-layout=\"main-theme-layout-4\"] .draggable .checkbox label::before {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-container--default .select2-selection--multiple,\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-container--default .select2-selection--single {\n  background-color: #303841;\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-container--default .select2-search--inline .select2-search__field {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-container--default .select2-selection--single .select2-selection__rendered {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-container--default .select2-search--dropdown .select2-search__field {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-dropdown {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-primary {\n  border-color: #ab8ce4 !important;\n  color: #ab8ce4 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-secondary {\n  border-color: #26c6da !important;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-success {\n  border-color: #00c292 !important;\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-info {\n  border-color: #4099ff !important;\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-warning {\n  border-color: #f3d800 !important;\n  color: #f3d800 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-danger {\n  border-color: #FF5370 !important;\n  color: #FF5370 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-inverse {\n  border-color: #fff !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-primary-fill {\n  background-color: #ab8ce4 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-secondary-fill {\n  background-color: #26c6da !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-success-fill {\n  background-color: #00c292 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-info-fill {\n  background-color: #4099ff !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-warning-fill {\n  background-color: #f3d800 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-danger-fill {\n  background-color: #FF5370 !important;\n  color: #fff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-drpdwn .form-control-inverse-fill {\n  background-color: #fff !important;\n  color: #000 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .select2-container--default.select2-container--disabled .select2-selection--single {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group select.form-control:not([size]):not([multiple]) {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=text],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=email],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=search],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=password],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=number],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=tel],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=date],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=datetime-local],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=time],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=datetime-local],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=month],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=week],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=url],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=file],\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group select {\n  border-color: #4b5469;\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=text]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=email]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=search]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=password]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=number]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=tel]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=date]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=time]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=datetime-local]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=month]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=week]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=url]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group input[type=file]::-webkit-input-placeholder,\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group select::-webkit-input-placeholder {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group .form-control {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-group textarea {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-divider {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .theme-form .form-divider::before {\n  background: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .CodeMirror {\n  background: #36404a;\n  border: 1px solid #98a6ad;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .CodeMirror .CodeMirror-code pre {\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-toolbar {\n  border-top: 1px solid #98a6ad;\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-toolbar a {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-toolbar a:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-toolbar a.active {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-toolbar i.separator {\n  border-left: 1px solid #98a6ad;\n  border-right: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-toolbar.disabled-for-preview a:not(.no-disable) {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-preview {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-toolbar.fullscreen,\nbody[main-theme-layout=\"main-theme-layout-4\"] .editor-preview-side {\n  background: #36404a;\n  border: 1px solid #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-step {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-step.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-step.current {\n  background: #ab8ce4;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-step-title,\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-step-number {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl:before {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl-number,\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl-icon {\n  background: #303841;\n  border: 2px solid #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl.disabled .u-pearl-icon,\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl.disabled .u-pearl-number {\n  background: #4b5469;\n  border: 2px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl.disabled:after {\n  background-color: #2e353d;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .u-pearl.error:after {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .note-editor.note-frame {\n  border-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .note-editor.note-frame .note-editing-area .note-editable {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .swal-modal {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .swal-modal .swal-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .swal-modal .swal-text {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .swal-modal .swal-content__input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs .nav-link.active {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #4b5469 #4b5469 #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs .nav-link:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs .nav-link:focus {\n  border-color: #4b5469 #4b5469 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs .nav-item.show .nav-link {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border-color: #98a6ad #4b5469 #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs.nav-bottom .nav-item .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs.nav-bottom .nav-item .nav-link.focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-tabs.nav-bottom .nav-item .nav-link.hover {\n  border-color: #36404a #4b5469 #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left .nav-link,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right .nav-link.active {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left .show>.nav-link,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right .show>.nav-link {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-secondary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-secondary .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-secondary .nav-link:hover {\n  border-left-color: #26c6da;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-secondary .show>.nav-link {\n  border-left-color: #26c6da;\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-secondary .nav-item.show {\n  color: #26c6da !important;\n  border-left-color: #26c6da;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-success .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-success .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-success .nav-link:hover {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-success .show>.nav-link {\n  border-left-color: #00c292;\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-left.nav-success .nav-item.show {\n  color: #00c292 !important;\n  border-left-color: #00c292;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right.nav-info .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right.nav-info .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right.nav-info .nav-link:hover {\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right.nav-info .show>.nav-link {\n  border-left-color: #4099ff;\n  color: #4099ff !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-right.nav-info .nav-item.show {\n  color: #4099ff !important;\n  border-left-color: #4099ff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-secondary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-secondary .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-secondary .nav-link:hover {\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-secondary .nav-item.show {\n  color: #26c6da !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-success .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-success .nav-link:focus,\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-success .nav-link:hover {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .nav-material.nav-success .nav-item.show {\n  color: #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .dropdown-divider {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .icon-hover-bottom {\n  background-color: #36404a;\n  -webkit-box-shadow: 0px 0px 1px 1px #4b5469;\n  box-shadow: 0px 0px 1px 1px #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .icon-hover-bottom .icon-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .icon-hover-bottom span {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .icon-hover-bottom .form-group input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .icon-hover-bottom .icon-first i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] code {\n  background-color: #434f5a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] #cd-timeline::before {\n  background: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny {\n  border-top: 1px solid #4b5469;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny::before {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny .timeliny-dot {\n  background-color: #36404a;\n  border: 1px solid #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny .timeliny-timeline .timeliny-timeblock.active .timeliny-dot::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover {\n  background-color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny .timeliny-timeline .timeliny-timeblock:not(.inactive):not(.active) .timeliny-dot:hover::before {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .timeliny .timeliny-timeline .timeliny-timeblock .timeliny-dot:hover::after {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .todo .todo-list-wrapper #todo-list li .task-container {\n  background: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .todo .todo-list-wrapper #todo-list li .task-container .task-label {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .todo .todo-list-wrapper #todo-list li .task-container:hover h4 {\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn .action-box:hover:not(.active) {\n  background: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .todo .todo-list-wrapper #todo-list li.completed .task-container .task-label {\n  color: #ab8ce4;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .todo .todo-list-wrapper #todo-list li.completed .task-container .complete-btn:hover {\n  border: 1px solid #00c292 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .todo .todo-list-wrapper .todo-list-footer .new-task-wrapper textarea {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .ttl-info h6 {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .ttl-info span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .hovercard .info .title a {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .hovercard .user-image .avatar img {\n  border: 10px solid #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .hovercard .user-image .icon-wrapper {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .follow .follow-num {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .profile-img-style .user-name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .user-profile .profile-img-style p {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .introjs-helperLayer {\n  background-color: rgba(54, 64, 74, 0.9);\n  border: rgba(255, 255, 255, 0.5);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .jstree-default .jstree-node,\nbody[main-theme-layout=\"main-theme-layout-4\"] .jstree-default .jstree-icon {\n  color: #434f5a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .jstree-default .jstree-anchor {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .jstree-default .jstree-clicked {\n  color: #fff;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .jstree-default .jstree-hovered {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] span.twitter-typeahead .tt-menu {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] span.twitter-typeahead .tt-suggestion {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] span.twitter-typeahead .tt-suggestion:hover,\nbody[main-theme-layout=\"main-theme-layout-4\"] span.twitter-typeahead .tt-suggestion:focus {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .typography small {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .blockquote-footer {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 9px #4b5469;\n  box-shadow: 0 0 9px #4b5469;\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .quickview-box:before,\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .quickview-recent-activity:before {\n  background-color: #36404a;\n  -webkit-box-shadow: 0 0 9px #4b5469;\n  box-shadow: 0 0 9px #4b5469;\n  border-left: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .quickview-box:after,\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .quickview-recent-activity:after {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .nav-material.nav-tabs .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .nav-material.nav-primary .nav-link.active,\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .nav-material.nav-primary .nav-link :hover {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .nav-material.nav-primary .nav-item.show,\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .nav-material.nav-primary .nav-link:focus {\n  color: #ab8ce4;\n  background-color: transparent;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .modal-header .modal-title {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .modal-header i {\n  color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .friend-list-search {\n  background-color: #2f3841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .friend-list-search input {\n  background-color: #303841;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .recent-activity .activity-content h6 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .recent-activity .activity-content hr {\n  border-top: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .recent-activity .user-first-letter:after {\n  border: 1px dashed #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .quickview-wrapper .chat-box .about .name {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy pre {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy pre code {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy pre[class*=\"language-\"] {\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy .code-box-copy__btn {\n  background-color: #303841;\n  border: 1px solid #4b5469;\n  color: #fff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy code[class*=language-],\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy pre[class*=language-] {\n  text-shadow: 0px 1px #000;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy code[class*=language-] ::-moz-selection,\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy pre[class*=language-] ::-moz-selection {\n  text-shadow: none;\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy code[class*=language-] ::selection,\nbody[main-theme-layout=\"main-theme-layout-4\"] .code-box-copy pre[class*=language-] ::selection {\n  text-shadow: none;\n  background: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] table.fixedHeader-floating {\n  background-color: #303841;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .dt-button-info {\n  background-color: #36404a;\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .dt-button-info h2 {\n  background-color: #36404a;\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] #keytable_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #column-selector_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #auto-fill_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #custom-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #class-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #keyboard-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #multilevel-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #pagelength-btn_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #basic-colreorder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #state-saving_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #real-time_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #basic-fixed-header_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #fixed-header-footer_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #export-button_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #excel-cust-bolder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #cust-json_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #basic-key-table_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #focus-cell_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #responsive_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #new-cons_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #show-hidden-row_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #basic-row-reorder_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #full-row_wrapper .dataTables_paginate,\nbody[main-theme-layout=\"main-theme-layout-4\"] #rest-column_wrapper .dataTables_paginate {\n  border: none;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] #example-style-8_wrapper table.dataTable.stripe tbody tr.odd,\nbody[main-theme-layout=\"main-theme-layout-4\"] #example-style-8_wrapper table.dataTable.display tbody tr.odd {\n  background-color: #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .error-wrapper {\n  background-color: rgba(54, 64, 74, 0.8);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .error-wrapper .sub-content {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .b-light {\n  border: 1px solid #4b5469 !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .modal-content {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .modal-content .modal-header {\n  border-bottom: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .modal-content .ui-front .form-control {\n  background-color: #36404a;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid #4b5469;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .stepwizard .stepwizard-row:before {\n  background-color: #98a6ad;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .modal .theme-close {\n  background-color: #36404a !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.atrule,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.attr-value,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.keyword {\n  color: #4099ff;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.boolean,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.constant,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.deleted,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.number,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.property,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.symbol,\nbody[main-theme-layout=\"main-theme-layout-4\"] .token.tag {\n  color: #FF5370;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .loader-box.card-loader {\n  background-color: #36404a;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .my-gallery.gallery-with-description img {\n  border: 1px solid #4b5469 !important;\n  border-bottom: none !important;\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-primary.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-secondary.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-success.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-danger.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-warning.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-info.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-light.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody[main-theme-layout=\"main-theme-layout-4\"] .alert-dark.inverse {\n  color: rgba(255, 255, 255, 0.7);\n}\n\nbody .page-sidebar[navigation-layout=\"navigation-bordered\"] .sidebar-header {\n  border-bottom: 1px solid #eeeeee;\n}\n\nbody .page-sidebar.navigation-bordered .sidebar-header {\n  border-bottom: 1px solid #eeeeee;\n}\n\nbody .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-header>span {\n  margin-left: 5px;\n}\n\nbody .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-menu>li>a i {\n  margin-right: 0;\n  margin-left: 7px;\n}\n\nbody .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-menu>li>a i:first-child {\n  float: right;\n}\n\nbody .page-wrapper .page-body-wrapper .page-sidebar.navigation-rightside .sidebar-menu>li>a i:last-child {\n  float: left;\n}\n\nbody .page-sidebar[navigation-layout=\"right-side-menu\"] .sidebar-menu>li>a i:first-child {\n  float: right;\n}\n\nbody .page-sidebar[navigation-layout=\"right-side-menu\"] .sidebar-menu>li>a i:last-child {\n  float: left;\n}\n\nbody .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg {\n  background-image: url(\"../images/sidebar-bg.jpg\");\n}\n\nbody .page-wrapper .page-body-wrapper .page-sidebar.native-image-bg .sidebar-user {\n  background: transparent;\n}\n\n/**=====================\n   55. theme layout CSS ends\n==========================**/\n/**=====================\n    56.  Ribbon CSS Start\n==========================**/\n.ribbon-wrapper,\n.ribbon-wrapper-right,\n.ribbon-wrapper-bottom,\n.ribbon-wrapper-right-bottom {\n  position: relative;\n  padding-top: 40px;\n}\n\n.ribbon-vertical-left-wrapper {\n  padding-left: 40px;\n  position: relative;\n}\n\n.ribbon-overflow {\n  overflow: hidden;\n}\n\n.ribbon-vertical-right-wrapper {\n  padding-right: 40px;\n}\n\n.ribbon-wrapper-bottom {\n  padding-bottom: 40px;\n  padding-top: 0;\n}\n\n.ribbon-wrapper-right-bottom {\n  padding-right: 40px;\n}\n\n.ribbon-content {\n  margin-bottom: 0;\n}\n\n.ribbon {\n  padding: 0 20px;\n  height: 30px;\n  line-height: 30px;\n  clear: left;\n  position: absolute;\n  top: 12px;\n  left: 0px;\n  color: #fff;\n  z-index: 2;\n}\n\n.ribbon-space-bottom {\n  top: 0px;\n}\n\n.ribbon-clip {\n  left: -14px;\n}\n\n.ribbon-clip:before {\n  position: absolute;\n  top: 30px;\n  left: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2a3142;\n  border-right-color: #2a3142;\n}\n\n.ribbon-bookmark:before {\n  position: absolute;\n  top: 0;\n  left: 100%;\n  display: block;\n  width: 0;\n  height: 0;\n  content: '';\n  border: 15px solid #2a3142;\n  border-right: 10px solid transparent;\n}\n\n.ribbon-right {\n  left: auto;\n  right: -2px;\n}\n\n.ribbon-clip-right {\n  right: -14px;\n}\n\n.ribbon-clip-right:before {\n  position: absolute;\n  top: 30px;\n  right: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2a3142;\n  border-right-color: #2a3142;\n}\n\n.ribbon-clip-bottom {\n  left: -14px;\n  bottom: 12px;\n  top: auto;\n}\n\n.ribbon-clip-bottom:before {\n  position: absolute;\n  bottom: 30px;\n  left: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2a3142;\n  border-right-color: #2a3142;\n}\n\n.ribbon-clip-bottom-right {\n  right: -14px;\n  left: auto;\n  bottom: 12px;\n  top: auto;\n}\n\n.ribbon-clip-bottom-right:before {\n  position: absolute;\n  bottom: 30px;\n  right: 0;\n  width: 0;\n  height: 0;\n  content: \"\";\n  border: 7px solid transparent;\n  border-top-color: #2a3142;\n  border-right-color: #2a3142;\n}\n\n.ribbon-bookmark.ribbon-right:before {\n  right: 100%;\n  left: auto;\n  border-right: 15px solid #2a3142;\n  border-left: 10px solid transparent;\n}\n\n.ribbon-vertical-left {\n  clear: none;\n  padding: 0 5px;\n  height: 70px;\n  width: 30px;\n  line-height: 70px;\n  text-align: center;\n  left: 12px;\n  top: -2px;\n}\n\n.ribbon-vertical-right {\n  clear: none;\n  padding: 0 5px;\n  height: 70px;\n  width: 30px;\n  line-height: 70px;\n  text-align: center;\n  top: -2px;\n  left: auto;\n  right: 12px;\n}\n\n.ribbon-bookmark.ribbon-vertical-left:before,\n.ribbon-bookmark.ribbon-vertical-right:before {\n  top: 100%;\n  left: 0;\n  margin-top: -14px;\n  border-right: 15px solid #2a3142;\n  border-bottom: 10px solid transparent;\n}\n\n.ribbon-primary {\n  background: #ab8ce4;\n}\n\n.ribbon-primary {\n  background: #ab8ce4;\n}\n\n.ribbon-bookmark.ribbon-primary:before {\n  border-color: #ab8ce4;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-primary:before {\n  border-right-color: #ab8ce4;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-primary:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-primary:before {\n  border-right-color: #ab8ce4;\n  border-bottom-color: transparent;\n}\n\n.ribbon-primary.ribbon-corner:before {\n  border-top-color: #ab8ce4;\n  border-left-color: #ab8ce4;\n}\n\n.ribbon-primary.ribbon-corner.ribbon-right:before {\n  border-right-color: #ab8ce4;\n  border-left-color: transparent;\n}\n\n.ribbon-primary.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #ab8ce4;\n}\n\n.ribbon-primary.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #8d63da;\n  border-right-color: #8d63da;\n}\n\n.ribbon-primary.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #8d63da;\n  border-left-color: #8d63da;\n}\n\n.ribbon-primary.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #8d63da;\n  border-right-color: #8d63da;\n}\n\n.ribbon-primary.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #8d63da;\n  border-right-color: transparent;\n  border-left-color: #8d63da;\n}\n\n.ribbon-secondary {\n  background: #26c6da;\n}\n\n.ribbon-secondary {\n  background: #26c6da;\n}\n\n.ribbon-bookmark.ribbon-secondary:before {\n  border-color: #26c6da;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-secondary:before {\n  border-right-color: #26c6da;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-secondary:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-secondary:before {\n  border-right-color: #26c6da;\n  border-bottom-color: transparent;\n}\n\n.ribbon-secondary.ribbon-corner:before {\n  border-top-color: #26c6da;\n  border-left-color: #26c6da;\n}\n\n.ribbon-secondary.ribbon-corner.ribbon-right:before {\n  border-right-color: #26c6da;\n  border-left-color: transparent;\n}\n\n.ribbon-secondary.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #26c6da;\n}\n\n.ribbon-secondary.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #1e9faf;\n  border-right-color: #1e9faf;\n}\n\n.ribbon-secondary.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #1e9faf;\n  border-left-color: #1e9faf;\n}\n\n.ribbon-secondary.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #1e9faf;\n  border-right-color: #1e9faf;\n}\n\n.ribbon-secondary.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #1e9faf;\n  border-right-color: transparent;\n  border-left-color: #1e9faf;\n}\n\n.ribbon-success {\n  background: #00c292;\n}\n\n.ribbon-success {\n  background: #00c292;\n}\n\n.ribbon-bookmark.ribbon-success:before {\n  border-color: #00c292;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-success:before {\n  border-right-color: #00c292;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-success:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-success:before {\n  border-right-color: #00c292;\n  border-bottom-color: transparent;\n}\n\n.ribbon-success.ribbon-corner:before {\n  border-top-color: #00c292;\n  border-left-color: #00c292;\n}\n\n.ribbon-success.ribbon-corner.ribbon-right:before {\n  border-right-color: #00c292;\n  border-left-color: transparent;\n}\n\n.ribbon-success.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #00c292;\n}\n\n.ribbon-success.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #008f6c;\n  border-right-color: #008f6c;\n}\n\n.ribbon-success.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #008f6c;\n  border-left-color: #008f6c;\n}\n\n.ribbon-success.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #008f6c;\n  border-right-color: #008f6c;\n}\n\n.ribbon-success.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #008f6c;\n  border-right-color: transparent;\n  border-left-color: #008f6c;\n}\n\n.ribbon-danger {\n  background: #FF5370;\n}\n\n.ribbon-danger {\n  background: #FF5370;\n}\n\n.ribbon-bookmark.ribbon-danger:before {\n  border-color: #FF5370;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-danger:before {\n  border-right-color: #FF5370;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-danger:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-danger:before {\n  border-right-color: #FF5370;\n  border-bottom-color: transparent;\n}\n\n.ribbon-danger.ribbon-corner:before {\n  border-top-color: #FF5370;\n  border-left-color: #FF5370;\n}\n\n.ribbon-danger.ribbon-corner.ribbon-right:before {\n  border-right-color: #FF5370;\n  border-left-color: transparent;\n}\n\n.ribbon-danger.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #FF5370;\n}\n\n.ribbon-danger.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #ff2046;\n  border-right-color: #ff2046;\n}\n\n.ribbon-danger.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #ff2046;\n  border-left-color: #ff2046;\n}\n\n.ribbon-danger.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #ff2046;\n  border-right-color: #ff2046;\n}\n\n.ribbon-danger.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #ff2046;\n  border-right-color: transparent;\n  border-left-color: #ff2046;\n}\n\n.ribbon-info {\n  background: #4099ff;\n}\n\n.ribbon-info {\n  background: #4099ff;\n}\n\n.ribbon-bookmark.ribbon-info:before {\n  border-color: #4099ff;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-info:before {\n  border-right-color: #4099ff;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-info:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-info:before {\n  border-right-color: #4099ff;\n  border-bottom-color: transparent;\n}\n\n.ribbon-info.ribbon-corner:before {\n  border-top-color: #4099ff;\n  border-left-color: #4099ff;\n}\n\n.ribbon-info.ribbon-corner.ribbon-right:before {\n  border-right-color: #4099ff;\n  border-left-color: transparent;\n}\n\n.ribbon-info.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #4099ff;\n}\n\n.ribbon-info.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #0d7eff;\n  border-right-color: #0d7eff;\n}\n\n.ribbon-info.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #0d7eff;\n  border-left-color: #0d7eff;\n}\n\n.ribbon-info.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #0d7eff;\n  border-right-color: #0d7eff;\n}\n\n.ribbon-info.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #0d7eff;\n  border-right-color: transparent;\n  border-left-color: #0d7eff;\n}\n\n.ribbon-light {\n  background: #eeeeee;\n}\n\n.ribbon-light {\n  background: #eeeeee;\n}\n\n.ribbon-bookmark.ribbon-light:before {\n  border-color: #eeeeee;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-light:before {\n  border-right-color: #eeeeee;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-light:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-light:before {\n  border-right-color: #eeeeee;\n  border-bottom-color: transparent;\n}\n\n.ribbon-light.ribbon-corner:before {\n  border-top-color: #eeeeee;\n  border-left-color: #eeeeee;\n}\n\n.ribbon-light.ribbon-corner.ribbon-right:before {\n  border-right-color: #eeeeee;\n  border-left-color: transparent;\n}\n\n.ribbon-light.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #eeeeee;\n}\n\n.ribbon-light.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #d5d5d5;\n  border-right-color: #d5d5d5;\n}\n\n.ribbon-light.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #d5d5d5;\n  border-left-color: #d5d5d5;\n}\n\n.ribbon-light.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #d5d5d5;\n  border-right-color: #d5d5d5;\n}\n\n.ribbon-light.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #d5d5d5;\n  border-right-color: transparent;\n  border-left-color: #d5d5d5;\n}\n\n.ribbon-dark {\n  background: #2a3142;\n}\n\n.ribbon-dark {\n  background: #2a3142;\n}\n\n.ribbon-bookmark.ribbon-dark:before {\n  border-color: #2a3142;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-dark:before {\n  border-right-color: #2a3142;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-dark:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-dark:before {\n  border-right-color: #2a3142;\n  border-bottom-color: transparent;\n}\n\n.ribbon-dark.ribbon-corner:before {\n  border-top-color: #2a3142;\n  border-left-color: #2a3142;\n}\n\n.ribbon-dark.ribbon-corner.ribbon-right:before {\n  border-right-color: #2a3142;\n  border-left-color: transparent;\n}\n\n.ribbon-dark.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #2a3142;\n}\n\n.ribbon-dark.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #161a23;\n  border-right-color: #161a23;\n}\n\n.ribbon-dark.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #161a23;\n  border-left-color: #161a23;\n}\n\n.ribbon-dark.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #161a23;\n  border-right-color: #161a23;\n}\n\n.ribbon-dark.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #161a23;\n  border-right-color: transparent;\n  border-left-color: #161a23;\n}\n\n.ribbon-warning {\n  background: #f3d800;\n}\n\n.ribbon-warning {\n  background: #f3d800;\n}\n\n.ribbon-bookmark.ribbon-warning:before {\n  border-color: #f3d800;\n  border-right-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-right.ribbon-warning:before {\n  border-right-color: #f3d800;\n  border-left-color: transparent;\n}\n\n.ribbon-bookmark.ribbon-vertical-left.ribbon-warning:before,\n.ribbon-bookmark.ribbon-vertical-right.ribbon-warning:before {\n  border-right-color: #f3d800;\n  border-bottom-color: transparent;\n}\n\n.ribbon-warning.ribbon-corner:before {\n  border-top-color: #f3d800;\n  border-left-color: #f3d800;\n}\n\n.ribbon-warning.ribbon-corner.ribbon-right:before {\n  border-right-color: #f3d800;\n  border-left-color: transparent;\n}\n\n.ribbon-warning.ribbon-corner.ribbon-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #f3d800;\n}\n\n.ribbon-warning.ribbon-clip:before {\n  border-color: transparent;\n  border-top-color: #c0ab00;\n  border-right-color: #c0ab00;\n}\n\n.ribbon-warning.ribbon-clip-right:before {\n  border-right-color: transparent;\n  border-top-color: #c0ab00;\n  border-left-color: #c0ab00;\n}\n\n.ribbon-warning.ribbon-clip-bottom:before {\n  border-top-color: transparent;\n  border-bottom-color: #c0ab00;\n  border-right-color: #c0ab00;\n}\n\n.ribbon-warning.ribbon-clip-bottom-right:before {\n  border-top-color: transparent;\n  border-bottom-color: #c0ab00;\n  border-right-color: transparent;\n  border-left-color: #c0ab00;\n}\n\n/**=====================\n     56. Ribbon CSS Ends\n==========================**/\n/**=====================\n    57. breadcrumb CSS Start\n==========================**/\n.breadcrumb-colored li a {\n  color: #fff;\n}\n\n.breadcrumb-colored li.active {\n  color: #fff;\n  opacity: 0.7;\n}\n\n.breadcrumb-colored .breadcrumb-item:before {\n  color: #fff;\n}\n\n.breadcrumb-colored .breadcrumb-item.txt-dark:before {\n  color: #000;\n}\n\n.breadcrumb-item.active {\n  text-transform: capitalize;\n}\n\n/**=====================\n    57. breadcrumb CSS ends\n==========================**/\n/**=====================\n    58. Steps  CSS Start\n==========================**/\n.u-steps {\n  margin: 0;\n}\n\n.u-step {\n  position: relative;\n  padding: 12px 20px;\n  margin: 0;\n  font-size: inherit;\n  color: #a3afb7;\n  vertical-align: top;\n  background-color: #eeeeee;\n  border-radius: 0;\n}\n\n.u-step-icon {\n  float: left;\n  margin-right: .5em;\n  font-size: 20px;\n}\n\n.u-step-number {\n  position: absolute;\n  top: 50%;\n  left: 20px;\n  width: 40px;\n  height: 40px;\n  font-size: 24px;\n  line-height: 40px;\n  color: #fff;\n  text-align: center;\n  background: #ced7da;\n  border-radius: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  font-family: Open Sans;\n}\n\n.u-step-number~.u-step-desc {\n  min-height: 40px;\n  margin-left: 50px;\n}\n\n.u-step-title {\n  margin-bottom: 0;\n  font-size: 20px;\n  color: #526069;\n}\n\n.u-step-desc {\n  text-align: left;\n}\n\n.u-step-desc p {\n  margin-bottom: 0;\n}\n\n.u-steps-vertical {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.u-step.active,\n.u-step.current {\n  color: #fff;\n  background-color: #ab8ce4;\n}\n\n.u-step.active .u-step-title,\n.u-step.current .u-step-title {\n  color: #fff;\n}\n\n.u-step.active .u-step-number,\n.u-step.current .u-step-number {\n  color: #ab8ce4;\n  background-color: #fff;\n}\n\n.u-step.disabled {\n  color: #cccccc;\n  pointer-events: none;\n  cursor: auto;\n}\n\n.u-step.disabled .u-step-title {\n  color: #cccccc;\n}\n\n.u-step.disabled .u-step-number {\n  background-color: #cccccc;\n}\n\n.u-step.error {\n  color: #fff;\n  background-color: #FF5370;\n}\n\n.u-step.error .u-step-title {\n  color: #fff;\n}\n\n.u-step.error .u-step-number {\n  color: #FF5370;\n  background-color: #fff;\n}\n\n.u-step.done {\n  color: #fff;\n  background-color: #00c292;\n}\n\n.u-step.done .u-step-title {\n  color: #fff;\n}\n\n.u-step.done .u-step-number {\n  color: #00c292;\n  background-color: #fff;\n}\n\n.u-steps-lg .u-step {\n  font-size: 16px;\n}\n\n.u-steps-lg .u-step-icon,\n.u-steps-lg .u-step-title {\n  font-size: 22px;\n}\n\n.u-steps-lg .u-step-number {\n  width: 46px;\n  height: 46px;\n  font-size: 28px;\n  line-height: 46px;\n}\n\n.u-steps-lg .u-step-number~.u-step-desc {\n  min-height: 46px;\n  margin-left: 56px;\n}\n\n.u-steps-sm .u-step {\n  font-size: 12px;\n}\n\n.u-steps-sm .u-step-icon,\n.u-steps-sm .u-step-title {\n  font-size: 18px;\n}\n\n.u-steps-sm .u-step-number {\n  width: 30px;\n  height: 30px;\n  font-size: 24px;\n  line-height: 30px;\n}\n\n.u-steps-sm .u-step-number~.u-step-desc {\n  min-height: 30px;\n  margin-left: 40px;\n}\n\n.u-steps-xs .u-step {\n  font-size: 10px;\n}\n\n.u-steps-xs .u-step-icon,\n.u-steps-xs .u-step-title {\n  font-size: 16px;\n}\n\n.u-steps-xs .u-step-number {\n  width: 24px;\n  height: 24px;\n  font-size: 20px;\n  line-height: 24px;\n}\n\n.u-steps-xs .u-step-number~.u-step-desc {\n  min-height: 24px;\n  margin-left: 34px;\n}\n\n.u-pearl {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n}\n\n.u-pearl:after {\n  position: absolute;\n  top: 18px;\n  z-index: 0;\n  width: 50%;\n  height: 4px;\n  content: \"\";\n  background-color: #eeeeee;\n}\n\n.u-pearl:before {\n  position: absolute;\n  top: 18px;\n  z-index: 0;\n  width: 50%;\n  height: 4px;\n  content: \"\";\n  background-color: #eeeeee;\n  left: 0;\n}\n\n.u-pearl:after {\n  right: 0;\n}\n\n.u-pearl:first-child:before,\n.u-pearl:last-child:after {\n  display: none !important;\n}\n\n.u-pearl-icon {\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  color: #fff;\n  text-align: center;\n  background: #cccccc;\n  border: 2px solid #cccccc;\n  border-radius: 50%;\n}\n\n.u-pearl-icon i {\n  position: absolute;\n  top: 7px;\n  left: 8px;\n}\n\n.u-pearl-icon .icon-check {\n  left: 7px;\n}\n\n.u-pearl-number {\n  position: relative;\n  z-index: 1;\n  display: inline-block;\n  width: 36px;\n  height: 36px;\n  line-height: 32px;\n  color: #fff;\n  text-align: center;\n  background: #cccccc;\n  border: 2px solid #cccccc;\n  border-radius: 50%;\n  font-size: 18px;\n}\n\n.u-pearl-icon {\n  font-size: 18px;\n}\n\n.u-pearl-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  margin-top: .5em;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: #526069;\n}\n\n.u-pearl.active:after,\n.u-pearl.active:before {\n  background-color: #ab8ce4;\n}\n\n.u-pearl.current:after,\n.u-pearl.current:before {\n  background-color: #ab8ce4;\n}\n\n.u-pearl.active .u-pearl-icon,\n.u-pearl.active .u-pearl-number {\n  color: #ab8ce4;\n  background-color: #fff;\n  border-color: #ab8ce4;\n  -webkit-transform: scale(1.3);\n  transform: scale(1.3);\n}\n\n.u-pearl.current .u-pearl-icon,\n.u-pearl.current .u-pearl-number {\n  color: #ab8ce4;\n  background-color: #fff;\n  border-color: #ab8ce4;\n  -webkit-transform: scale(1.3);\n  transform: scale(1.3);\n}\n\n.u-pearl.disabled {\n  pointer-events: none;\n  cursor: auto;\n}\n\n.u-pearl.disabled:after,\n.u-pearl.disabled:before {\n  background-color: #eeeeee;\n}\n\n.u-pearl.disabled .u-pearl-icon,\n.u-pearl.disabled .u-pearl-number {\n  color: #fff;\n  background-color: #cccccc;\n  border-color: #cccccc;\n}\n\n.u-pearl.error:before {\n  background-color: #ab8ce4;\n}\n\n.u-pearl.error:after {\n  background-color: #eeeeee;\n}\n\n.u-pearl.error .u-pearl-icon,\n.u-pearl.error .u-pearl-number {\n  color: #FF5370;\n  background-color: #fff;\n  border-color: #FF5370;\n}\n\n.u-pearl.done:after,\n.u-pearl.done:before {\n  background-color: #ab8ce4;\n}\n\n.u-pearl.done .u-pearl-icon,\n.u-pearl.done .u-pearl-number {\n  color: #fff;\n  background-color: #ab8ce4;\n  border-color: #ab8ce4;\n}\n\n.u-pearls-lg .u-pearl:after,\n.u-pearls-lg .u-pearl:before {\n  top: 20px;\n}\n\n.u-pearls-lg .u-pearl-title {\n  font-size: 18px;\n}\n\n.u-pearls-lg .u-pearl-icon,\n.u-pearls-lg .u-pearl-number {\n  width: 40px;\n  height: 40px;\n  line-height: 36px;\n}\n\n.u-pearls-lg .u-pearl-icon,\n.u-pearls-lg .u-pearl-number {\n  font-size: 20px;\n}\n\n.u-pearls-sm .u-pearl:after,\n.u-pearls-sm .u-pearl:before {\n  top: 16px;\n}\n\n.u-pearls-sm .u-pearl-title {\n  font-size: 14px;\n}\n\n.u-pearls-sm .u-pearl-icon {\n  width: 32px;\n  height: 32px;\n  line-height: 28px;\n}\n\n.u-pearls-sm .u-pearl-number {\n  width: 32px;\n  height: 32px;\n  line-height: 28px;\n  font-size: 16px;\n}\n\n.u-pearls-sm .u-pearl-icon {\n  font-size: 14px;\n}\n\n.u-pearls-xs .u-pearl:after,\n.u-pearls-xs .u-pearl:before {\n  top: 12px;\n  height: 2px;\n}\n\n.u-pearls-xs .u-pearl-title {\n  font-size: 12px;\n}\n\n.u-pearls-xs .u-pearl-icon {\n  width: 24px;\n  height: 24px;\n  line-height: 20px;\n}\n\n.u-pearls-xs .u-pearl-number {\n  width: 24px;\n  height: 24px;\n  line-height: 20px;\n  font-size: 12px;\n}\n\n.u-pearls-xs .u-pearl-icon {\n  font-size: 12px;\n}\n\n.u-pearl.current .u-pearl-icon i {\n  left: 6px;\n}\n\n/**=====================\n    58. Steps  CSS ends\n==========================**/\n/**=====================\n   59. Customizer  CSS Start\n==========================**/\n.main-theme-layout-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n\n.floated-customizer-panel {\n  background-color: #fff;\n  position: fixed;\n  right: -85px;\n  -webkit-box-shadow: 0 15px 125px rgba(0, 0, 0, 0.22);\n  box-shadow: 0 15px 125px rgba(0, 0, 0, 0.22);\n  border-radius: 6px;\n  color: #2a3142;\n  bottom: 70px;\n  z-index: 999;\n  visibility: hidden;\n  opacity: 0;\n  -webkit-transition: all 0.2s ease;\n  -webkit-transition: all 0.7s ease;\n  transition: all 0.7s ease;\n  -webkit-transform: translateY(110%) scale(0);\n  transform: translateY(110%) scale(0);\n  height: 650px;\n  overflow: auto;\n  width: 0;\n}\n\n.floated-customizer-panel.active {\n  visibility: visible;\n  width: 400px;\n  right: 35px;\n  opacity: 1;\n  -webkit-transform: translateY(0px) scale(1);\n  transform: translateY(0px) scale(1);\n}\n\n.floated-customizer-panel .close-customizer-btn {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  cursor: pointer;\n  -webkit-transition: all 0.1s ease;\n  transition: all 0.1s ease;\n}\n\n.floated-customizer-panel .customizer-title {\n  border-bottom: 1px solid #eeeeee;\n  padding: 20px 20px 15px;\n}\n\n.floated-customizer-panel .customizer-title h5 {\n  margin-bottom: 0;\n  font-weight: 700;\n}\n\n.floated-customizer-panel .fcp-group {\n  padding: 20px;\n  border-bottom: 1px solid #eeeeee;\n}\n\n.floated-customizer-panel .fcp-header {\n  font-weight: 500;\n  font-family: inherit;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  margin-bottom: 20px;\n  color: #2a3142;\n  font-size: 1.08rem;\n}\n\n.floated-customizer-panel .fcp-header span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.floated-customizer-panel .fcp-header .icon-w {\n  display: inline-block;\n  vertical-align: middle;\n  color: #4099ff;\n  font-size: 24px;\n  margin-right: 10px;\n}\n\n.floated-customizer-panel .fcp-header .icon-w i {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.floated-customizer-panel .fcp-content .navigation-color-option .radio {\n  height: 40px;\n  width: 40px;\n  display: inline-block;\n}\n\n.floated-customizer-panel .fcp-content .navigation-color-option .radio label:before {\n  width: 35px;\n  height: 35px;\n  border-radius: 5px;\n}\n\n.floated-customizer-panel .fcp-content .navigation-color-option .radio label:after {\n  width: 25px;\n  height: 25px;\n  border-radius: 5px;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-header {\n  font-weight: 600;\n  font-family: inherit;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  color: #fff;\n  background-color: #ab8ce4;\n  padding-top: 10px;\n  text-align: center;\n  border-radius: 4px;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-header-sub {\n  color: #2a3142;\n  font-weight: 600;\n  font-family: inherit;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .nav-tabs {\n  margin-bottom: 20px;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .nav-tabs .nav-item {\n  width: 100%;\n  font-weight: 500;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .nav-tabs .nav-item .nav-link.active {\n  background-color: #ab8ce4;\n  color: #fff;\n  padding: 6px;\n  font-size: 15px;\n  border-radius: 5px;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  padding-bottom: 7px;\n  margin-bottom: 7px;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field label {\n  font-size: .9rem;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 54%;\n  flex: 0 0 54%;\n  padding-right: 10px;\n  margin: 0;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors {\n  margin-left: auto;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-selector {\n  display: inline-block;\n  vertical-align: middle;\n  height: 14px;\n  width: 14px;\n  border-radius: 10px;\n  margin: 0px 5px;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-selector.selected,\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-selector:hover {\n  -webkit-box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 4px #88b8ff;\n  box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 4px #88b8ff;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-bright {\n  background-color: #4099ff;\n  border: 1px solid #4099ff;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-dark {\n  background-color: #2a3142;\n  border: 1px solid #2a3142;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-light {\n  background-color: #fff;\n  border: 1px solid #eeeeee;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-transparent {\n  background-color: #fff;\n  border: 1px solid #eeeeee;\n  position: relative;\n  overflow: hidden;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-transparent:before {\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  background-color: #cccccc;\n}\n\n.floated-customizer-panel .fcp-content .fcp-group-contents .fcp-field .fcp-colors .color-transparent:after {\n  content: \"\";\n  width: 4px;\n  height: 4px;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  background-color: #cccccc;\n}\n\n.floated-customizer-btn {\n  -webkit-animation-name: jumpUp;\n  animation-name: jumpUp;\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n  -webkit-animation-delay: 0.2s;\n  animation-delay: 0.2s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  z-index: 9;\n  position: fixed;\n  bottom: 10px;\n  right: 10px;\n  background: #ab8ce4;\n  -webkit-box-shadow: 0 5px 10px rgba(19, 19, 19, 0.17);\n  box-shadow: 0 5px 10px rgba(19, 19, 19, 0.17);\n  border-radius: 5px;\n  color: #fff;\n  padding: 12px 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  vertical-align: middle;\n  font-size: 1.08rem;\n  cursor: pointer;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n\n.floated-customizer-btn.third-floated-btn {\n  right: 35px;\n}\n\n.floated-customizer-btn>.icon-w {\n  line-height: 1;\n  vertical-align: middle;\n  display: inline-block;\n  -webkit-animation: os-rotating 2s linear infinite;\n  animation: os-rotating 2s linear infinite;\n}\n\n.floated-customizer-btn>.icon-w i {\n  font-size: 24px;\n}\n\n.floated-customizer-btn>span {\n  margin-left: 10px;\n  vertical-align: middle;\n  display: inline-block;\n  font-weight: 500;\n}\n\n.floated-customizer-btn>span+span {\n  margin-left: 5px;\n}\n\n.floated-customizer-btn:hover {\n  -webkit-transform: scale(1.05);\n  transform: scale(1.05);\n  background-color: #2a3142;\n}\n\n.floated-customizer-panel::-webkit-scrollbar {\n  width: 3px;\n}\n\n.floated-customizer-panel::-webkit-scrollbar-thumb {\n  background-color: #ab8ce4;\n}\n\n.floated-customizer-panel::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px #cccccc;\n}\n\n.nav-navigation-main {\n  border-bottom: 1px solid #ab8ce4;\n}\n\n.nav-navigation-main li {\n  width: 50%;\n  text-align: center;\n}\n\n.nav-navigation-color-main {\n  border-bottom: 1px solid #ab8ce4;\n}\n\n.nav-navigation-color-main li {\n  width: 33.33%;\n  text-align: center;\n}\n\n/*======= Brand css starts ===========*/\n[semilight-bg-color='bg-primary'],\n[header-bg-color='bg-primary'] {\n  background-color: #ab8ce4 !important;\n}\n\n[header-bg-color='bg-primary'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-primary'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-primary'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-primary'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-primary'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #ab8ce4 !important;\n}\n\n[semilight-bg-color='bg-primary-light-color'],\n[header-bg-color='bg-primary-light-color'] {\n  background-color: #8d63da !important;\n}\n\n[header-bg-color='bg-primary-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-primary-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-primary-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-primary-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-primary-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #ab8ce4 !important;\n}\n\n[semilight-bg-color='bg-secondary'],\n[header-bg-color='bg-secondary'] {\n  background-color: #26c6da !important;\n}\n\n[header-bg-color='bg-secondary'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-secondary'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-secondary'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-secondary'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-secondary'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #26c6da !important;\n}\n\n[semilight-bg-color='bg-secondary-light-color'],\n[header-bg-color='bg-secondary-light-color'] {\n  background-color: #1a8b99 !important;\n}\n\n[header-bg-color='bg-secondary-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-secondary-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-secondary-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-secondary-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-secondary-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #26c6da !important;\n}\n\n[semilight-bg-color='bg-success'],\n[header-bg-color='bg-success'] {\n  background-color: #00c292 !important;\n}\n\n[header-bg-color='bg-success'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-success'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-success'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-success'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-success'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #00c292 !important;\n}\n\n[semilight-bg-color='bg-success-light-color'],\n[header-bg-color='bg-success-light-color'] {\n  background-color: #007658 !important;\n}\n\n[header-bg-color='bg-success-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-success-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-success-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-success-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-success-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #00c292 !important;\n}\n\n[semilight-bg-color='bg-danger'],\n[header-bg-color='bg-danger'] {\n  background-color: #FF5370 !important;\n}\n\n[header-bg-color='bg-danger'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-danger'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-danger'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-danger'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-danger'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #FF5370 !important;\n}\n\n[semilight-bg-color='bg-danger-light-color'],\n[header-bg-color='bg-danger-light-color'] {\n  background-color: #ff0730 !important;\n}\n\n[header-bg-color='bg-danger-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-danger-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-danger-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-danger-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-danger-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #FF5370 !important;\n}\n\n[semilight-bg-color='bg-info'],\n[header-bg-color='bg-info'] {\n  background-color: #4099ff !important;\n}\n\n[header-bg-color='bg-info'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-info'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-info'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-info'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-info'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #4099ff !important;\n}\n\n[semilight-bg-color='bg-info-light-color'],\n[header-bg-color='bg-info-light-color'] {\n  background-color: #0071f3 !important;\n}\n\n[header-bg-color='bg-info-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-info-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-info-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-info-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-info-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #4099ff !important;\n}\n\n[semilight-bg-color='bg-light'],\n[header-bg-color='bg-light'] {\n  background-color: #eeeeee !important;\n}\n\n[header-bg-color='bg-light'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-light'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-light'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-light'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-light'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #eeeeee !important;\n}\n\n[semilight-bg-color='bg-light-light-color'],\n[header-bg-color='bg-light-light-color'] {\n  background-color: #c8c8c8 !important;\n}\n\n[header-bg-color='bg-light-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-light-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-light-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-light-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-light-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #eeeeee !important;\n}\n\n[semilight-bg-color='bg-dark'],\n[header-bg-color='bg-dark'] {\n  background-color: #2a3142 !important;\n}\n\n[header-bg-color='bg-dark'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-dark'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-dark'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-dark'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-dark'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #2a3142 !important;\n}\n\n[semilight-bg-color='bg-dark-light-color'],\n[header-bg-color='bg-dark-light-color'] {\n  background-color: #0c0e13 !important;\n}\n\n[header-bg-color='bg-dark-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-dark-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-dark-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-dark-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-dark-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #2a3142 !important;\n}\n\n[semilight-bg-color='bg-warning'],\n[header-bg-color='bg-warning'] {\n  background-color: #f3d800 !important;\n}\n\n[header-bg-color='bg-warning'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-warning'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-warning'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-warning'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-warning'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #f3d800 !important;\n}\n\n[semilight-bg-color='bg-warning-light-color'],\n[header-bg-color='bg-warning-light-color'] {\n  background-color: #a79400 !important;\n}\n\n[header-bg-color='bg-warning-light-color'] img {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-warning-light-color'] .txt-dark {\n  color: #fff !important;\n}\n\n[header-bg-color='bg-warning-light-color'] .search-form input {\n  -webkit-filter: brightness(0) invert(1);\n  filter: brightness(0) invert(1);\n}\n\n[header-bg-color='bg-warning-light-color'] .switch input:checked+.switch-state {\n  background-color: #cccccc;\n}\n\n[header-bg-color='bg-warning-light-color'] .nav-right .notification {\n  border: 1px solid #fff;\n  padding: 2px 4px !important;\n  background-color: #f3d800 !important;\n}\n\n/*======= Brand css ends ===========*/\n/**=====================\n     59.Customizer CSS Ends\n==========================**/\n/**=====================\n    60. RTL CSS Start\n==========================**/\n.rtl .modal-dialog .modal-content .modal-body p a {\n  margin-left: 0;\n}\n\n.rtl .drag-box fieldset .component .form-group .text-lg-left {\n  text-align: right !important;\n}\n\n.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn,\n.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .btn-right,\n.rtl .drag-box fieldset .component .form-group .input-group .input-group-prepend .checkbox-radius {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .drag-box fieldset .component .form-group .input-group #prependedcheckbox {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rtl .drag-box fieldset .component .form-group .input-group #appendedcheckbox {\n  border-right-color: #ddd;\n}\n\n.rtl .drag-box fieldset .component .form-group .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: -1px;\n}\n\n.rtl .drag form {\n  text-align: right;\n}\n\n.rtl .drag form input {\n  text-align: right;\n}\n\n.rtl .drag form label {\n  text-align: right !important;\n}\n\n.rtl .drag form .form-group .input-group .input-group-prepend .btn,\n.rtl .drag form .form-group .input-group .input-group-prepend .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rtl .drag form .form-group .input-group .input-group-prepend .btn-right,\n.rtl .drag form .form-group .input-group .input-group-prepend .checkbox-radius {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .drag form .form-group .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: -1px;\n}\n\n.rtl .draggable label {\n  text-align: right;\n}\n\n.rtl .form-builder-column .tab-content .tab-pane .theme-form .ui-draggable .input-group>.input-group-prepend>.input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rtl .form-builder-column #pills-tabContent .theme-form .form-group .input-group #buttondropdown,\n.rtl .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: 15px;\n}\n\n.rtl .form-builder-column #pills-tabContent .theme-form .form-group .input-group .input-group-btn button,\n.rtl .form-builder-column #pills-tabContent .theme-form .ui-draggable .input-group .input-group-btn button {\n  border-radius: 4px !important;\n}\n\n.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .text-lg-left {\n  text-align: right !important;\n}\n\n.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn,\n.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .input-group-text {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .btn-right,\n.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group .input-group-prepend .checkbox-radius {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #prependedcheckbox {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rtl .form-horizontal.theme-form fieldset .tab-content .tab-pane .component .form-group .input-group #appendedcheckbox {\n  border-right-color: #ddd;\n}\n\n.rtl .form-builder .component .form-group .input-group #buttondropdown {\n  margin-right: unset;\n  margin-left: -1px;\n}\n\n.rtl .form-builder .component .form-group .pl-md-radios {\n  padding-right: 37px;\n  padding-left: unset;\n}\n\n.rtl .page-main-header .main-header-right .nav-right .notification {\n  right: -9px;\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar {\n  -webkit-transform: translate(180px);\n  transform: translate(180px);\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-user,\n.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar .sidebar-header {\n  text-align: left !important;\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover {\n  -webkit-transform: translate(0px);\n  transform: translate(0px);\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-sidebar:hover .sidebar-user {\n  text-align: center !important;\n}\n\n.rtl .page-wrapper .sidebar-close .page-sidebar {\n  -webkit-transform: translate(255px);\n  transform: translate(255px);\n}\n\n@media only screen and (max-width: 1199px) {\n  .rtl .crm-numbers .col+.col+.col {\n    border-left: none;\n  }\n\n  .rtl .business-card .b-r-light {\n    border-right: none !important;\n  }\n\n  .rtl .business-card table {\n    width: 60%;\n    margin: 20px auto 0 auto;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .rtl .page-wrapper .page-body-wrapper .page-header .breadcrumb {\n    float: right;\n  }\n\n  .rtl .page-wrapper .page-body-wrapper .page-sidebar~.page-body {\n    margin-right: 0px !important;\n  }\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar~.page-body {\n  margin-right: 0 !important;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar-open {\n  right: -150px;\n  left: unset;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-icon .page-sidebar~.page-body {\n  margin-right: 150px !important;\n  margin-left: 0;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.rtl .page-wrapper .page-body-wrapper.sidebar-hover .page-body {\n  margin-left: unset !important;\n  margin-right: 75px !important;\n}\n\n.rtl .page-wrapper .sidebar-hover .page-sidebar:hover .sidebar-menu .sidebar-header {\n  text-align: right !important;\n}\n\n.rtl .whether-widget .whether-widget-top .details {\n  text-align: left;\n  left: 20px;\n  right: unset;\n}\n\n.rtl .vertical-menu-mt .page-header div .pull-right {\n  float: right;\n}\n\n.rtl .page-wrapper .sidebar-icon .page-sidebar {\n  left: unset;\n  right: 0;\n}\n\n.rtl .page-wrapper .sidebar-icon .page-sidebar~.page-body {\n  margin-left: unset;\n}\n\n.rtl .search-page .nav i {\n  margin-left: 10px;\n  margin-right: unset;\n}\n\n.rtl .alert {\n  text-align: right;\n}\n\n.rtl .sm li {\n  direction: rtl;\n  text-align: right;\n}\n\n.rtl .sm .mobile-back .pl-2 {\n  padding-right: 4px !important;\n  padding-left: unset !important;\n}\n\n.rtl .vertical-menu-main #main-nav #main-menu li a i {\n  margin-left: 8px;\n  margin-right: unset;\n}\n\n.rtl .pixelstrap a .sub-arrow {\n  right: auto;\n  left: 5px;\n}\n\n@media (min-width: 1200px) {\n  .rtl .pixelstrap ul:not(.mega-menu) li a:before {\n    left: unset;\n    right: 20px;\n  }\n\n  .rtl .pixelstrap a .sub-arrow {\n    right: unset;\n    left: 3px;\n  }\n}\n\n.rtl .business-top-widget .media .media-body {\n  margin-right: unset;\n  margin-left: 40px;\n}\n\n.rtl .business-chart-widget .icon.text-md-right {\n  text-align: left !important;\n}\n\n.rtl .business-chart-widget .icon-bg {\n  left: -50px;\n  right: unset;\n}\n\n.rtl .social-widget .mr-3 {\n  margin-left: 1rem !important;\n}\n\n.rtl .social-widget .social-icons {\n  margin-right: 10px;\n  margin-left: unset;\n}\n\n.rtl .review-box .testimonial .content:before,\n.rtl .review-box .testimonial .content:after {\n  right: 40px;\n  left: unset;\n}\n\n.rtl code[class*=language-],\n.rtl pre[class*=language-] {\n  text-align: right;\n}\n\n@media (min-width: 768px) {\n  .rtl .ecommerce-widget .text-md-right {\n    text-align: left !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .rtl .ecommerce-widget .text-md-right {\n    text-align: left !important;\n  }\n\n  .rtl .business-chart-widget .icon-bg {\n    left: -27px;\n  }\n\n  .rtl .business-card table {\n    margin: 0px auto 0 auto !important;\n  }\n\n  .rtl .bar-chart-widget .earning-details i {\n    left: -147px !important;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .rtl .business-card table {\n    width: 100% !important;\n  }\n}\n\n.rtl .ml-2 {\n  margin-right: 0.5rem !important;\n}\n\n.rtl .product-stts {\n  display: inline-block;\n}\n\n.rtl .product-stts .ml-1 {\n  margin-right: 0.25rem !important;\n  margin-left: unset !important;\n}\n\n.rtl .customer-review .media-body .cust-name {\n  margin-left: 10px;\n  margin-right: unset;\n}\n\n.rtl .pr-2 {\n  padding-right: unset !important;\n  padding-left: 0.5rem !important;\n}\n\n.rtl .mega-menu .default-according .card .btn-link {\n  text-align: right;\n}\n\n.rtl .mega-menu .default-according.style-1 button[aria-expanded=\"true\"]:before,\n.rtl .mega-menu .default-according.style-1 button[aria-expanded=\"false\"]:before {\n  right: unset;\n  left: 20px;\n}\n\n.rtl .search-form input {\n  background-position: 5%;\n  text-align: right;\n}\n\n.rtl .pull-right {\n  float: left;\n}\n\n.rtl .card {\n  text-align: right;\n}\n\n.rtl .card .card-header .card-header-right {\n  left: 20px;\n  right: unset;\n}\n\n.rtl .form-inline .form-group {\n  margin-left: 15px;\n  margin-right: 0;\n}\n\n.rtl .icon-hover-bottom .icon-title {\n  text-align: right;\n}\n\n.rtl .floated-customizer-btn.third-floated-btn {\n  left: 35px;\n  right: unset;\n}\n\n.rtl .floated-customizer-btn>span {\n  margin-right: 10px;\n}\n\n.rtl .breadcrumb-item+.breadcrumb-item {\n  padding-right: 0.5rem;\n  padding-left: unset;\n}\n\n.rtl .breadcrumb-item+.breadcrumb-item::before {\n  padding-left: 0.5rem;\n  padding-right: unset;\n}\n\n.rtl .floated-customizer-panel {\n  text-align: right;\n  left: -85px;\n  right: unset;\n}\n\n.rtl .floated-customizer-panel.active {\n  left: 35px;\n  right: unset;\n}\n\n.rtl .floated-customizer-panel .close-customizer-btn {\n  left: 30px;\n  right: unset;\n}\n\n.rtl .floated-customizer-panel ul {\n  padding-right: 0;\n}\n\n.rtl .radio label {\n  padding-left: 0;\n  padding-right: 15px;\n}\n\n.rtl .radio label::before {\n  right: 0;\n  margin-right: -20px;\n  left: unset;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {\n  text-align: right;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li.active>a>.fa-angle-right {\n  vertical-align: 7px;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a i {\n  margin-left: 7px;\n  margin-right: unset;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu {\n  padding-right: 0;\n  text-align: right;\n  right: 135px;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a {\n  text-align: right;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-submenu>li>a>.fa {\n  margin-right: 10px;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-sidebar~.page-body {\n  margin-right: 250px;\n  margin-left: unset;\n}\n\n.rtl .page-wrapper .page-body-wrapper .page-header .row h3 {\n  text-align: right;\n}\n\n.rtl .page-wrapper .page-body-wrapper .footer-fix {\n  margin-right: 250px;\n  margin-left: unset;\n}\n\n.rtl .page-wrapper .sidebar-close .page-body {\n  margin-right: 0 !important;\n}\n\n.rtl .page-main-header .main-header-right .nav-right {\n  text-align: left;\n}\n\n.rtl .page-main-header .main-header-right .nav-right ul li {\n  margin-left: unset;\n  text-align: right;\n}\n\n.rtl .page-main-header .main-header-right .nav-right ul li.onhover-dropdown {\n  margin-right: 20px;\n}\n\n.rtl .page-main-header .main-header-right .nav-right ul li.onhover-dropdown:hover .onhover-show-div:before {\n  right: 10px;\n  left: unset;\n}\n\n.rtl .page-main-header .main-header-right .nav-right ul li.onhover-dropdown:hover .onhover-show-div:after {\n  right: 10px;\n  left: unset;\n}\n\n.rtl .page-main-header .main-header-right .nav-right ul li i.ml-2 {\n  margin-right: 0.5rem !important;\n  margin-left: unset !important;\n}\n\n.rtl .page-main-header .main-header-right .nav-right ul li .pull-right {\n  margin-right: unset !important;\n  margin-left: 0.5rem !important;\n}\n\n.rtl .page-main-header .main-header-right .nav-right .language-dropdown {\n  text-align: right;\n}\n\n.rtl .page-main-header .main-header-right .nav-right .language-dropdown li a i {\n  margin-left: 10px;\n}\n\n.rtl .page-main-header .main-header-right .nav-right .profile-dropdown li i {\n  margin-left: 10px;\n}\n\n.rtl ul.notification-dropdown.onhover-show-div {\n  right: initial;\n  left: -30px;\n  padding-right: 0;\n}\n\n.rtl ul.notification-dropdown.onhover-show-div:before {\n  right: inherit !important;\n  left: 35px !important;\n}\n\n.rtl ul.notification-dropdown.onhover-show-div:after {\n  right: inherit !important;\n  left: 35px !important;\n}\n\n.rtl ul.notification-dropdown.onhover-show-div li {\n  margin-right: 0 !important;\n}\n\n.rtl ul.notification-dropdown.onhover-show-div li span.badge {\n  margin-left: unset !important;\n}\n\n.rtl ul.notification-dropdown.onhover-show-div li .notification-icon {\n  margin-left: 20px;\n  margin-right: unset;\n}\n\n.rtl .alert i {\n  margin-left: 5px;\n  margin-right: 0;\n}\n\n.rtl .inverse.alert-dismissible {\n  padding: 13px 65px 13px 20px;\n}\n\n.rtl .inverse i {\n  left: unset;\n  right: 0;\n}\n\n.rtl .alert-primary.inverse:before {\n  border-right: 7px solid #ab8ce4;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-secondary.inverse:before {\n  border-right: 7px solid #26c6da;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-success.inverse:before {\n  border-right: 7px solid #00c292;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-danger.inverse:before {\n  border-right: 7px solid #FF5370;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-warning.inverse:before {\n  border-right: 7px solid #f3d800;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-info.inverse:before {\n  border-right: 7px solid #4099ff;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-light.inverse:before {\n  border-right: 7px solid #eeeeee;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-dark.inverse:before {\n  border-right: 7px solid #2a3142;\n  right: 54px;\n  left: unset;\n  border-left: unset;\n}\n\n.rtl .alert-dismissible {\n  padding: 13px 20px 13px 65px;\n}\n\n.rtl .alert-dismissible .close {\n  left: 0;\n  right: unset;\n}\n\n.rtl .icofont.icofont-truck {\n  display: inline-block;\n}\n\n.rtl .blog-box .blog-details {\n  padding-left: 20px;\n  text-align: right;\n}\n\n.rtl .blog-box .blog-details .blog-social {\n  padding-right: 0;\n}\n\n.rtl .blog-box .blog-details .blog-social li {\n  padding-left: 40px;\n  padding-right: unset;\n}\n\n.rtl .blog-box .blog-details .blog-social li:first-child {\n  border-left: 1px solid #777777;\n  border-right: unset;\n  padding-left: 40px;\n  padding-right: unset;\n}\n\n.rtl .blog-box .blog-details .blog-social li+li {\n  margin-right: 30px;\n  margin-left: unset;\n  padding-left: 0;\n}\n\n.rtl .blog-box .blog-details-main .blog-social li {\n  border-left: 1px solid;\n  border-right: unset;\n}\n\n.rtl .blog-box .blog-details-main .blog-social li:last-child {\n  border-left: none;\n}\n\n.rtl .blog-box .blog-date span {\n  font-size: 36px;\n  font-weight: 500;\n  padding-left: 5px;\n}\n\n.rtl .card {\n  text-align: right;\n}\n\n.rtl .card .card-header .card-header-right {\n  left: 20px;\n  right: unset;\n}\n\n.rtl .card .card-header .card-header-right .card-option {\n  text-align: left;\n}\n\n.rtl .card .card-header .card-header-right .card-option.list-unstyled {\n  padding-right: 0;\n  padding-left: unset;\n}\n\n.rtl .card.full-card {\n  left: 0;\n  right: unset;\n}\n\n.rtl .comment-box .media img {\n  margin-left: 45px;\n  margin-right: unset;\n}\n\n.rtl .comment-box .media h6 {\n  text-align: right;\n}\n\n.rtl .comment-box ul ul {\n  margin-right: 135px;\n  margin-left: unset;\n  padding-right: 0;\n}\n\n.rtl .comment-box .comment-social {\n  text-align: left;\n}\n\n.rtl .comment-box .comment-social li {\n  padding-left: 0;\n  padding-right: 20px;\n}\n\n.rtl .comment-box .comment-social li:first-child {\n  border-left: 1px solid #ddd;\n  border-right: unset;\n  padding-right: 0;\n  padding-left: 20px;\n}\n\n.rtl .business-card table tr th {\n  padding-left: 15px;\n  padding-right: 0;\n  text-align: left;\n  width: 91px;\n}\n\n.rtl .social-widget .radial-bar {\n  margin-right: 0;\n  margin-left: 16px;\n}\n\n.rtl .button-builder-wrap .form-group .btn {\n  margin-left: 15px;\n  margin-right: 0;\n}\n\n.rtl .button-builder ul.the-icons {\n  padding-right: 0 !important;\n}\n\n.rtl .calendar-wrap .fc {\n  direction: rtl;\n  text-align: right;\n}\n\n.rtl .calendar-wrap .fc .fc-toolbar .fc-left {\n  float: right;\n}\n\n.rtl .calendar-wrap .fc .fc-toolbar .fc-right {\n  float: left;\n}\n\n.rtl .calendar-wrap .fc .fc-toolbar>*>* {\n  margin-left: 0;\n}\n\n.rtl .calendar-wrap .fc-events-container {\n  text-align: right;\n}\n\n.rtl .fc-agenda-view .fc-day-grid .fc-row {\n  margin-right: 0 !important;\n}\n\n.rtl .fc-unthemed .fc-row {\n  margin-right: 0 !important;\n}\n\n.rtl .chat-box .user-image {\n  float: right;\n}\n\n.rtl .chat-box .people-list .search i {\n  left: 10px;\n  right: unset;\n}\n\n.rtl .chat-box .about {\n  float: right;\n  padding-right: 10px;\n  padding-left: unset;\n  text-align: right;\n}\n\n.rtl .chat-box .chat-menu {\n  border-right: 1px solid #eeeeee;\n  border-left: unset;\n}\n\n.rtl .chat-box .chat-menu .nav {\n  padding-right: 0;\n}\n\n.rtl .chat-left-aside .status-circle {\n  left: unset;\n  right: 40px;\n}\n\n.rtl .chat-right-aside .chat .chat-header .chat-menu-icons {\n  padding-left: 0;\n  padding-right: unset;\n}\n\n.rtl .chat-right-aside .chat .chat-header .chat-menu-icons.float-sm-right {\n  float: left !important;\n}\n\n.rtl .chat-right-aside .chat .chat-header img {\n  float: right;\n}\n\n.rtl .cke_toolbar,\n.rtl .cke_toolgroup,\n.rtl a.cke_button,\n.rtl .cke_combo_text {\n  float: right;\n}\n\n.rtl .cke_reset_all,\n.rtl .cke_reset_all *,\n.rtl .cke_reset_all a,\n.rtl .cke_reset_all textarea {\n  text-align: right;\n}\n\n.rtl .cke_combo_text {\n  padding-left: unset;\n  padding-right: 10px;\n}\n\n.rtl #editor1 #cke_editor1 #cke_1_contents iframe html {\n  direction: rtl !important;\n}\n\n.rtl #clockdiv ul {\n  padding-right: 0;\n}\n\n.rtl .sidebar-toggle-btn {\n  margin-right: 10px;\n  margin-left: unset;\n}\n\n.rtl .default-widget-count .icon-bg {\n  left: 15px;\n  right: unset;\n}\n\n.rtl .custom-card .card-footer>div+div {\n  border-right: 1px solid #ddd;\n  border-left: unset;\n}\n\n.rtl .card-social {\n  padding-right: 0;\n}\n\n.rtl .card-absolute .card-header {\n  right: 15px;\n  left: unset;\n}\n\n.rtl .card {\n  text-align: right;\n}\n\n.rtl .card .card-header .card-header-right {\n  left: 20px;\n  right: unset;\n}\n\n.rtl .card .card-header .card-header-right .card-option {\n  text-align: left;\n}\n\n.rtl .card .card-header .card-header-right .card-option.list-unstyled {\n  padding-right: 0;\n  padding-left: unset;\n}\n\n.rtl .card.full-card {\n  left: 0;\n  right: unset;\n}\n\n.rtl .dataTables_wrapper .dataTables_filter input[type=\"search\"] {\n  margin-right: 10px;\n  margin-left: 0;\n}\n\n.rtl .dataTables_wrapper .dataTables_length {\n  float: right;\n}\n\n.rtl .dataTables_wrapper .dataTables_filter {\n  margin-left: unset;\n  margin-right: 15px;\n  float: left;\n}\n\n.rtl .dataTables_wrapper .dataTables_info {\n  float: right;\n}\n\n.rtl .dataTables_wrapper .advance-5_filter {\n  margin-left: 0;\n}\n\n.rtl div.dataTables_wrapper div.dataTables_paginate {\n  margin-right: 15px !important;\n  margin-left: 0 !important;\n  float: left;\n}\n\n.rtl table.dataTable thead>tr>th {\n  padding-left: 30px;\n  padding-right: 12px;\n}\n\n.rtl table.dataTable thead>tr>th:before {\n  left: 1em !important;\n  right: unset;\n}\n\n.rtl table.dataTable thead>tr>th:after {\n  left: 0.5em !important;\n  right: unset;\n}\n\n.rtl table.dataTable thead .sorting:before,\n.rtl table.dataTable thead .sorting_asc:before,\n.rtl table.dataTable thead .sorting_desc:before,\n.rtl table.dataTable thead .sorting_asc_disabled:before,\n.rtl table.dataTable thead .sorting_desc_disabled:before {\n  left: 1em !important;\n  right: unset;\n}\n\n.rtl .dataTables_scrollHeadInner {\n  padding-right: unset;\n  padding-left: 0 !important;\n}\n\n.rtl div.table-responsive>div.dataTables_wrapper>div.row>div[class^=\"col-\"]:first-child {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.rtl div.table-responsive>div.dataTables_wrapper>div.row>div[class^=\"col-\"]:last-child {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.rtl .dt-plugin-buttons button.m-r-10 {\n  margin-left: 10px;\n  margin-right: 0;\n}\n\n.rtl .datetime-picker .theme-form .form-group label {\n  text-align: left !important;\n}\n\n.rtl .datetime-picker .theme-form .form-group .input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .datetime-picker .theme-form .form-group .input-group .form-control {\n  border-radius: 0.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rtl .form-inline .form-group .col-form-label {\n  margin-left: 5px;\n  margin-right: 0;\n}\n\n.rtl .dropdown-basic .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rtl .dropdown-basic .separated-btn .btn {\n  border-radius: 0.25rem;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rtl .error-wrapper .col-md-8.offset-md-2 {\n  margin: 0 auto !important;\n}\n\n.rtl .email-wrap .email-app-sidebar ul {\n  padding-right: 0;\n}\n\n.rtl .email-wrap .email-app-sidebar .main-menu>li a i {\n  margin-right: unset;\n  margin-left: 10px;\n}\n\n.rtl .email-wrap .email-content .email-top .user-emailid:after {\n  float: left;\n}\n\n.rtl .crm-numbers .col+.col {\n  border-left: unset;\n  border-right: 1px solid #ddd;\n}\n\n.rtl .product-price del {\n  padding-left: 20px;\n  padding-right: 0;\n}\n\n.rtl .product-hover ul {\n  padding-right: 0;\n}\n\n.rtl .customer-review .media img {\n  margin-left: 25px;\n  margin-right: 0;\n}\n\n.rtl .icon-lists div i {\n  margin: 0 10px 0 15px;\n}\n\n.rtl .btn-showcase .btn {\n  margin-right: unset;\n  margin-left: 18px;\n}\n\n.rtl .nav {\n  padding-right: 0;\n}\n\n.rtl .btn-square.dropdown-toggle {\n  border-top-left-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rtl .form-builder-2-header>div nav {\n  float: left;\n}\n\n.rtl .custom-file-label::after {\n  left: 0;\n  right: unset;\n}\n\n.rtl .wizard-4 ul.anchor {\n  float: right;\n  padding-right: 0;\n  padding-left: 30px;\n}\n\n.rtl .wizard-4 .step-container {\n  clear: unset;\n}\n\n.rtl .wizard-4 .form-group {\n  text-align: right;\n}\n\n.rtl .wizard-4 .action-bar .btn {\n  float: left;\n}\n\n.rtl .f1 .f1-buttons {\n  text-align: left;\n}\n\n.rtl .f1 .f1-steps .f1-step {\n  float: right;\n}\n\n.rtl .chat-box .user-image {\n  margin-left: 5px;\n  margin-right: 0;\n}\n\n.rtl .chat-box .chat-right-aside .chat .chat-message .smiley-box {\n  margin-left: 0.5rem;\n  margin-right: unset;\n}\n\n.rtl .chat-box .chat .chat-message .text-box .input-group-append {\n  margin-right: -2px;\n}\n\n.rtl .input-group>.input-group-append>.btn,\n.rtl .input-group>.input-group-append>.input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.rtl .input-group>.input-group-prepend:not(:first-child)>.btn,\n.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text,\n.rtl .input-group>.input-group-prepend:not(:first-child)>.btn:not(:first-child),\n.rtl .input-group>.input-group-prepend:not(:first-child)>.input-group-text:not(:first-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .input-group>.form-control:not(:first-child),\n.rtl .input-group>.custom-select:not(:first-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.rtl .input-group>.form-control:not(:last-child),\n.rtl .input-group>.custom-select:not(:last-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rtl .chat-msg-box ul {\n  padding-right: 0;\n}\n\n.rtl .static-top-widget .media-body {\n  padding-right: 30px;\n  padding-left: unset;\n}\n\n.rtl .static-top-widget .media-body .icon-bg {\n  left: -20px;\n  right: unset;\n}\n\n.rtl .widget-joins .media .details {\n  border-right: 1px solid #ddd;\n  border-left: unset;\n}\n\n.rtl .widget-joins .media .media-body {\n  text-align: right;\n}\n\n.rtl .img-cropper .btn-group {\n  margin-right: 0;\n  margin-left: 10px;\n}\n\n.rtl .img-cropper .btn-group button:last-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.rtl .img-cropper .btn-group button:first-child {\n  border-top-right-radius: .25rem;\n  border-bottom-right-radius: .25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rtl .landing-main .landing-left {\n  padding-right: 100px;\n  padding-left: 0;\n}\n\n.rtl .list-group {\n  padding-right: 0;\n}\n\n.rtl .list-group i,\n.rtl .list-group img {\n  margin-left: 10px;\n  margin-right: 0;\n}\n\n.rtl .authentication-box {\n  text-align: right;\n}\n\n.rtl .mega-horizontal .offset-sm-3 {\n  margin-right: 25%;\n  margin-left: unset;\n}\n\n.rtl .modal-header .close {\n  margin-left: 0;\n}\n\n.rtl .modal-footer> :not(:first-child) {\n  margin-right: .50rem;\n  margin-left: 0;\n}\n\n.rtl .navs-icon i {\n  margin-left: 10px;\n  margin-right: 0;\n}\n\n.rtl .nav-list .nav-list-disc {\n  text-align: right;\n  padding-right: 0;\n}\n\n.rtl .pl-navs-inline {\n  padding-right: 30px !important;\n  padding-left: 0 !important;\n}\n\n.rtl .icon-lists ul {\n  padding-right: 0;\n}\n\n.rtl .onhover-show-div {\n  right: 0;\n}\n\n.rtl .pagination {\n  padding-right: 0;\n}\n\n.rtl .pricing-wrapper-card .card-price h1 sup {\n  margin-right: -20px;\n  margin-left: unset;\n}\n\n.rtl .pricing-wrapper-card .card-ribbon {\n  right: -10px;\n  left: unset;\n}\n\n.rtl .pricing-wrapper-card .card-ribbon ::before {\n  left: 0;\n  right: unset;\n}\n\n.rtl .pricing-wrapper-card .card-ribbon ::after {\n  bottom: 0;\n  right: 0;\n  left: unset;\n}\n\n.rtl .pricing-wrapper-card .card-ribbon span {\n  right: -35px;\n  left: unset;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.rtl .product-page-details span {\n  padding-right: 15px;\n  padding-left: 0;\n}\n\n.rtl .m-checkbox-inline label {\n  margin-left: 20px;\n  margin-right: 0;\n}\n\n.rtl .form-label-align-right label {\n  text-align: left;\n}\n\n.rtl .br-theme-bars-reversed .br-widget .br-current-rating,\n.rtl .br-theme-bars-movie .br-widget .br-current-rating,\n.rtl .br-theme-bars-1to10 .br-widget .br-current-rating,\n.rtl .br-theme-bars-square .br-widget .br-current-rating {\n  float: right;\n}\n\n.rtl .br-theme-bars-reversed .br-widget a,\n.rtl .br-theme-bars-movie .br-widget a,\n.rtl .br-theme-bars-1to10 .br-widget a,\n.rtl .br-theme-bars-square .br-widget a {\n  float: right;\n}\n\n.rtl .ribbon-left {\n  right: auto;\n  left: -2px;\n}\n\n.rtl .ribbon-vertical-left {\n  right: auto;\n  left: 12px;\n}\n\n.rtl .ribbon-vertical-right {\n  right: auto;\n  left: 12px;\n}\n\n.rtl .search-page .search-form input {\n  background-position: 1%;\n}\n\n.rtl .star-ratings ul.search-info {\n  padding-right: 0;\n}\n\n.rtl .star-ratings ul.search-info li+li {\n  border-right: 1px solid #a5afc6;\n  border-left: unset;\n  padding-right: 8px;\n  padding-left: 0;\n  margin-right: 8px;\n  margin-left: 0;\n}\n\n.rtl .select2-container--default .select2-selection--single .select2-selection__arrow {\n  left: 10px !important;\n  right: unset !important;\n}\n\n.rtl .editor-statusbar {\n  text-align: left;\n}\n\n.rtl .editor-statusbar span {\n  margin-right: 1em;\n  margin-left: unset;\n}\n\n.rtl .CodeMirror-scroll {\n  margin-left: -30px;\n  margin-right: unset;\n}\n\n.rtl .primary-color ul,\n.rtl .yellow-color ul {\n  padding-right: 0;\n}\n\n.rtl .u-step-desc {\n  text-align: right;\n}\n\n.rtl .u-step-number {\n  right: 20px;\n  left: unset;\n}\n\n.rtl .u-step-number~.u-step-desc {\n  margin-right: 50px;\n}\n\n.rtl .u-pearl:after {\n  left: 0;\n  right: unset;\n}\n\n.rtl .u-pearl:before {\n  right: 0;\n  left: unset;\n}\n\n.rtl .note {\n  float: right;\n}\n\n.rtl .list-icons {\n  padding-right: 0;\n}\n\n.rtl .dropdown-toggle::after {\n  margin-right: 0.255em;\n  margin-left: unset;\n}\n\n.rtl .flex-column a {\n  text-align: center !important;\n}\n\n.rtl .tabbed-card ul {\n  left: 15px;\n  right: unset;\n}\n\n.rtl .card .card-header .pull-left {\n  float: right;\n}\n\n.rtl .checkbox label {\n  padding-right: 16px;\n  padding-left: unset;\n}\n\n.rtl .checkbox label::before {\n  right: 0;\n  left: unset;\n  margin-right: -16px;\n  margin-left: unset;\n}\n\n.rtl .radio label::after {\n  right: 5px;\n  left: unset;\n  margin-right: -20px;\n  margin-left: unset;\n}\n\n.rtl .cd-timeline-content::before {\n  border-right: 7px solid #eeeeee;\n  border-left-color: transparent;\n}\n\n.rtl .cd-timeline-img i {\n  right: 45%;\n  left: unset;\n  margin-right: -12px;\n  margin-left: unset;\n}\n\n.rtl .cd-timeline-block:nth-child(even) .cd-timeline-content {\n  float: left;\n  border-left: 7px solid #eeeeee;\n  border-right: unset;\n}\n\n.rtl .cd-timeline-block:nth-child(even) .cd-timeline-content .cd-date {\n  right: auto;\n  left: 122%;\n  text-align: left;\n}\n\n.rtl .cd-timeline-block:nth-child(even) .cd-timeline-content::before {\n  right: auto;\n  left: 100%;\n  border-left-color: #eeeeee;\n  border-right-color: transparent;\n}\n\n.rtl .cd-timeline-content .cd-date {\n  right: 122%;\n  left: unset;\n}\n\n.rtl .todo .todo-list-wrapper .mark-all-tasks {\n  left: 30px;\n  right: unset;\n}\n\n.rtl .todo .todo-list-wrapper .mark-all-tasks .btn-label {\n  margin-left: 5px;\n  margin-right: unset;\n}\n\n.rtl .todo .todo-list-wrapper #todo-list li .task-container .task-action-btn {\n  text-align: left;\n}\n\n.rtl .todo .notification-popup {\n  left: 10px;\n  right: unset;\n}\n\n.rtl .introjs-tooltip {\n  right: 0;\n  left: unset;\n}\n\n.rtl .introjs-helperNumberLayer {\n  right: -16px;\n  left: unset;\n}\n\n.rtl .list-inline-item:not(:last-child) {\n  margin-left: 0.5rem;\n  margin-right: unset;\n}\n\n.rtl .like-comment ul.list-inline {\n  padding-right: 0;\n}\n\n.rtl .typeahead {\n  text-align: right;\n}\n\n.rtl .listing ul {\n  padding-right: 0;\n}\n\n.rtl .listing ul .icofont {\n  float: right;\n}\n\n.rtl .quickview-wrapper {\n  left: -285px;\n  right: unset;\n}\n\n.rtl .quickview-wrapper .quickview-box:before,\n.rtl .quickview-wrapper .quickview-recent-activity:before {\n  right: -47px;\n  left: unset;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.rtl .quickview-wrapper .quickview-box .quickview-box-toggle,\n.rtl .quickview-wrapper .quickview-recent-activity .quickview-box-toggle {\n  right: -50px;\n  left: unset;\n}\n\n.rtl .quickview-wrapper.open {\n  -webkit-transform: translate3d(100%, 0, 0);\n  transform: translate3d(100%, 0, 0);\n}\n\n.rtl .quickview-wrapper .nav-tabs .nav-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rtl .chat-quickview {\n  left: -400px;\n  right: unset;\n}\n\n.rtl .quickview-wrapper .friend-list-search .fa {\n  right: unset;\n  left: 35px;\n}\n\n.rtl .border-widgets>.row>div+div {\n  border-right: 1px solid #ddd;\n  border-left: unset;\n}\n\n.rtl .button-builder ul.the-icons {\n  padding-right: 0;\n}\n\n.rtl ul {\n  padding-right: 0;\n}\n\n.rtl ul.icon-lists {\n  padding-right: 30px;\n}\n\n.rtl .gallery .hover-5 img {\n  margin-right: 30px;\n}\n\n.rtl .gallery .hover-5:hover img {\n  margin-right: 0;\n}\n\n.rtl .lg-outer {\n  text-align: right;\n}\n\n.rtl .lg-toolbar .lg-icon {\n  float: left;\n}\n\n.rtl #lg-counter {\n  padding-right: 20px;\n  padding-left: unset;\n  float: right;\n}\n\n.rtl #friendlist-tab .modal-header h6.modal-title,\n.rtl #recentactivity-tab .modal-header h6.modal-title {\n  text-align: right;\n}\n\n.rtl #friendlist-tab .modal-header .col-sm-4.text-right,\n.rtl #recentactivity-tab .modal-header .col-sm-4.text-right {\n  text-align: left !important;\n}\n\n.rtl .quickview-wrapper .recent-activity {\n  margin-right: 25px;\n  margin-left: unset;\n}\n\n.rtl .quickview-wrapper .recent-activity .user-first-letter span {\n  right: -23px;\n  left: unset;\n}\n\n.rtl .quickview-wrapper .recent-activity .user-first-letter:after {\n  right: 0;\n  left: unset;\n}\n\n.rtl .chart-widget-top .text-right {\n  text-align: left !important;\n}\n\n.rtl .chart-widget-top .num .ml-1 {\n  margin-right: 0.25rem !important;\n}\n\n.rtl .bar-chart-widget .earning-details i {\n  left: -240px;\n}\n\n.rtl .bar-chart-widget .bottom-content .b-r-light {\n  border-left: 1px solid #eeeeee !important;\n  border-right: unset !important;\n}\n\n.rtl .bar-chart-widget .bottom-content .num .ml-1 {\n  margin-right: 0.25rem !important;\n}\n\n.rtl .chart-vertical-center #myDoughnutGraph,\n.rtl .chart-vertical-center #myPolarGraph {\n  width: auto !important;\n}\n\n.rtl .crm-activity ul.dates li+li {\n  border-right: 1px solid #ddd;\n  padding-right: 10px;\n  margin-right: 5px;\n  border-left: unset;\n  padding-left: unset;\n  margin-left: unset;\n}\n\n.rtl div.dt-buttons {\n  float: right;\n}\n\n.rtl .dt-button-collection {\n  left: -39px !important;\n}\n\n.rtl .dropzone .dz-preview .dz-error-mark,\n.rtl .dropzone .dz-preview .dz-success-mark {\n  right: 50%;\n  margin-right: -27px;\n  margin-left: unset;\n  left: unset;\n}\n\n.rtl .email-wrap .email-app-sidebar .main-menu>li {\n  text-align: right;\n}\n\n.rtl .icon-hover-bottom .icon-popup .icon-last .form-inline .form-group .btn {\n  margin-right: 15px;\n  margin-left: unset;\n}\n\n.rtl .footer-copyright {\n  text-align: right;\n}\n\n.rtl .footer-links {\n  text-align: left;\n}\n\n.rtl .weather-widget-two .bottom-whetherinfo .whether-content {\n  text-align: left;\n}\n\n.rtl .docs-toggles .btn-group .btn {\n  border-radius: 0;\n}\n\n.rtl .docs-toggles .btn-group .btn:last-child {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.rtl .docs-toggles .btn-group .btn:first-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rtl .btn-group>.btn:not(:last-child):not(.dropdown-toggle)>.btn-group:not(:last-child)>.btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .jsgrid-button+.jsgrid-button {\n  margin-right: 5px;\n  margin-left: unset;\n}\n\n.rtl .offset-xl-3 {\n  margin-right: 25%;\n}\n\n.rtl .onhover-dropdown.navs-dropdown:hover .onhover-show-div:before {\n  left: 77px;\n  right: unset;\n}\n\n.rtl .onhover-dropdown.navs-dropdown:hover .onhover-show-div:after {\n  left: 77px;\n  right: unset;\n}\n\n.rtl .navs-dropdown .onhover-show-div .navs-icon li {\n  text-align: right;\n}\n\n.rtl .navs-icon.default-according.style-1 li button[aria-expanded=\"true\"]:before {\n  left: 2px;\n  right: unset;\n}\n\n.rtl .navs-icon.default-according.style-1 li button[aria-expanded=\"false\"]:before {\n  left: 2px;\n  right: unset;\n}\n\n.rtl .page-item:first-child .page-link {\n  margin-right: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rtl .page-item:last-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .product-box .ribbon-bookmark.ribbon-secondary:before {\n  border-left-color: transparent;\n  border-right-coolor: none;\n}\n\n.rtl .product-box .ribbon-bookmark:before {\n  right: 100%;\n  border-left: 10px solid transparent;\n  border-right: unset;\n}\n\n.rtl .product-box .ribbon-warning.ribbon-clip:before {\n  border-left-color: #c0ab00;\n  border-right-color: unset;\n}\n\n.rtl .product-box .ribbon-clip {\n  right: -14px;\n  left: unset;\n}\n\n.rtl .product-box .ribbon-clip:before {\n  right: 0;\n  left: unset;\n}\n\n.rtl .u-step-icon {\n  float: right;\n  margin-left: .5em;\n  margin-right: unset;\n}\n\n.rtl .card-header.note-toolbar .note-color .dropdown-toggle {\n  padding-right: 5px;\n}\n\n.rtl .card-header.note-toolbar .form-group.draggable {\n  text-align: right;\n}\n\n.rtl .card-header.note-toolbar .form-check {\n  padding-right: 24px;\n  padding-left: unset;\n}\n\n.rtl .card-header.note-toolbar form .custom-control {\n  padding-right: 24px;\n  padding-left: unset;\n}\n\n.rtl .card-header.note-toolbar form .custom-control .custom-control-label::after {\n  right: 0;\n  left: unset;\n}\n\n.rtl .card-header.note-toolbar form .custom-control .custom-control-label::before {\n  right: 0;\n  left: unset;\n}\n\n.rtl .left-order {\n  -webkit-box-ordinal-group: 4;\n  -ms-flex-order: 3;\n  order: 3;\n}\n\n.rtl .right-order {\n  -webkit-box-ordinal-group: 0;\n  -ms-flex-order: -1;\n  order: -1;\n}\n\n.rtl .popover.top>.arrow:after,\n.rtl .popover.bottom>.arrow:after {\n  margin-right: -10px;\n  margin-left: unset;\n}\n\n.rtl .bootstrap-touchspin>.input-group-append>.btn,\n.rtl .bootstrap-touchspin>.input-group-append>.input-group-text {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rtl .bootstrap-touchspin>.form-control:not(:last-child),\n.rtl .bootstrap-touchspin>.custom-select:not(:last-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltiptext {\n  text-align: right;\n}\n\n.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons {\n  text-align: left;\n}\n\n.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-skipbutton {\n  margin-left: 5px;\n  margin-right: unset;\n}\n\n.rtl .introjs-tooltipReferenceLayer .introjs-tooltip .introjs-tooltipbuttons .introjs-nextbutton {\n  border-radius: 0.2em 0 0 0.2em;\n}\n\n.rtl .typeahead span.twitter-typeahead .tt-suggestion {\n  text-align: right;\n}\n\n.rtl .typeahead .league-name {\n  text-align: right;\n  margin-right: 5px;\n}\n\n.rtl .follow .text-md-right {\n  text-align: right !important;\n}\n\n.rtl .jvectormap-zoomin,\n.rtl .jvectormap-zoomout,\n.rtl .jvectormap-goback {\n  right: 10px;\n  left: unset;\n}\n\n/**=====================\n    60. RTL CSS Ends\n==========================**/\n/**=====================\n      Modern layout CSS Start\n==========================**/\n.svg-animation .wave-template {\n  opacity: 0;\n  position: absolute;\n}\n\n.svg-animation circle {\n  fill: #ac68fd;\n  opacity: 0.3;\n}\n\n.svg-animation svg>use {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n\n.svg-animation svg>circle:last-child {\n  fill: #5934fc;\n  opacity: 1;\n}\n\n.svg-animation #rp1 {\n  -webkit-animation: ripple1 1s linear infinite;\n  animation: ripple1 1s linear infinite;\n}\n\n.svg-animation #rp2 {\n  -webkit-animation: ripple2 1s linear infinite;\n  animation: ripple2 1s linear infinite;\n}\n\n.svg-animation #rp3 {\n  -webkit-animation: ripple3 1s linear infinite;\n  animation: ripple3 1s linear infinite;\n}\n\n.svg-animation .svg-container {\n  position: absolute;\n  z-index: 10;\n}\n\n.svg-animation .effect-svg1 {\n  top: -65%;\n  left: -5%;\n  -webkit-transform: scale(0.5);\n  transform: scale(0.5);\n}\n\n.svg-animation .effect-svg2 {\n  top: -88%;\n  left: 30%;\n}\n\n.svg-animation .effect-svg3 {\n  top: -28%;\n  right: -5%;\n}\n\n.svg-animation .effect-svg4 {\n  top: 113%;\n  left: 0;\n}\n\n@-webkit-keyframes ripple2 {\n  0% {\n    -webkit-transform: scale(3.5);\n    transform: scale(3.5);\n  }\n\n  100% {\n    -webkit-transform: scale(5.5);\n    transform: scale(5.5);\n  }\n}\n\n@keyframes ripple2 {\n  0% {\n    -webkit-transform: scale(3.5);\n    transform: scale(3.5);\n  }\n\n  100% {\n    -webkit-transform: scale(5.5);\n    transform: scale(5.5);\n  }\n}\n\n@-webkit-keyframes ripple3 {\n  0% {\n    -webkit-transform: scale(1.5);\n    transform: scale(1.5);\n  }\n\n  100% {\n    -webkit-transform: scale(3.5);\n    transform: scale(3.5);\n  }\n}\n\n@keyframes ripple3 {\n  0% {\n    -webkit-transform: scale(1.5);\n    transform: scale(1.5);\n  }\n\n  100% {\n    -webkit-transform: scale(3.5);\n    transform: scale(3.5);\n  }\n}\n\n@-webkit-keyframes ripple1 {\n  0% {\n    -webkit-transform: scale(5.5);\n    transform: scale(5.5);\n    opacity: 0.3;\n  }\n\n  100% {\n    -webkit-transform: scale(8.5);\n    transform: scale(8.5);\n    opacity: 0.0;\n  }\n}\n\n@keyframes ripple1 {\n  0% {\n    -webkit-transform: scale(5.5);\n    transform: scale(5.5);\n    opacity: 0.3;\n  }\n\n  100% {\n    -webkit-transform: scale(8.5);\n    transform: scale(8.5);\n    opacity: 0.0;\n  }\n}\n\n.modern-layout .b-danger {\n  border: 4px solid #e4326b !important;\n}\n\n.modern-layout .annual-report {\n  height: 147px;\n}\n\n.modern-layout .media-width {\n  max-width: 100px;\n}\n\n.modern-layout .set-image-border img {\n  padding: 10px 9px;\n  border-radius: 50%;\n  border: 1px solid #ddd;\n}\n\n.modern-layout .finance-status-image {\n  padding-top: 10px;\n}\n\n.modern-layout .annual-report-detail li {\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.modern-layout .annual-report-detail li:last-child {\n  margin-bottom: 0;\n}\n\n.modern-layout .annual-report-detail li span {\n  font-weight: normal;\n}\n\n.modern-layout .annual-report-detail li .number {\n  position: relative;\n  padding-left: 45px;\n}\n\n.modern-layout .annual-report-detail li .number:before {\n  width: 36px;\n  height: 14px;\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 3px;\n  border-radius: 25px;\n}\n\n.modern-layout .annual-report-detail li .success-number:before {\n  background-color: #88d563;\n}\n\n.modern-layout .annual-report-detail li .info-number:before {\n  background-color: #5934fc;\n}\n\n.modern-layout .annual-report-detail li .danger-number:before {\n  background-color: #e4326b;\n}\n\n.modern-layout .annual-report-detail li .primary-number:before {\n  background-color: #a34ffe;\n}\n\n.modern-layout .header {\n  height: 400px;\n  background: linear-gradient(22deg, #5934fc 0, #a34ffe 100%);\n}\n\n.modern-layout .header .page-main-header {\n  position: relative;\n  left: 0;\n  right: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  display: block;\n  height: auto;\n  background: transparent;\n  z-index: 2;\n  border-bottom: 1px solid #a34ffe;\n}\n\n.modern-layout .header .page-main-header .modern-header .main-header-right {\n  float: right;\n  width: auto;\n  padding: 0;\n}\n\n.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .notification {\n  top: 50px;\n}\n\n.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .onhover-show-div {\n  top: 100px;\n}\n\n.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right>ul>li {\n  padding: 60px 0;\n}\n\n.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right ul li i {\n  font-size: 20px;\n}\n\n.modern-layout .header .page-main-header .modern-header .main-header-right .nav-right ul .onhover-dropdown a .badge {\n  background-color: #fff;\n}\n\n.modern-layout .header .page-main-header .modern-header .header-inner {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  min-height: 100%;\n}\n\n.modern-layout .header .page-main-header .modern-header .search-form input {\n  color: #cccccc;\n  border: none;\n  border-radius: 20px;\n  background-color: #9173ef54;\n  background-image: url(../images/dashboard/search-white.png);\n}\n\n.modern-layout .header .page-main-header .modern-header .search-form input:-ms-input-placeholder {\n  color: #a34ffe;\n}\n\n.modern-layout .header .page-main-header .modern-header .search-form input:-moz-placeholder {\n  color: #a34ffe;\n}\n\n.modern-layout .header .page-main-header .modern-header .search-form input:focus {\n  outline: none;\n}\n\n.modern-layout .header .page-main-header .modern-header .search-form input::-webkit-input-placeholder {\n  color: #a34ffe;\n}\n\n.modern-layout .header .page-main-header .modern-header .search-form input::-moz-placeholder {\n  color: #a34ffe;\n}\n\n.modern-layout .header .vertical-menu-main {\n  position: absolute;\n  background: transparent;\n  top: 159px;\n  width: 58%;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.modern-layout .header .vertical-menu-main nav ul li a {\n  color: #fff;\n  border-right: 1px solid #a34ffe;\n}\n\n.modern-layout .header .vertical-menu-main nav ul li:last-child a {\n  border-right: none;\n}\n\n.modern-layout .header .vertical-menu-main nav ul li ul li a {\n  color: #333333;\n  border-right: none;\n}\n\n@media (min-width: 1200px) {\n\n  .modern-layout .header .pixelstrap ul a:hover,\n  .modern-layout .header .pixelstrap ul a:focus,\n  .modern-layout .header .pixelstrap ul a:active,\n  .modern-layout .header .pixelstrap ul a.highlighted {\n    color: #ab8ce4;\n  }\n}\n\n.modern-layout .number {\n  font-family: Open Sans, sans-serif;\n}\n\n.modern-layout button {\n  border-radius: 20px;\n  background-color: transparent;\n  border: 1px solid #ddd;\n  color: #000;\n  text-align: left;\n  font-weight: 600;\n  padding: 6px 15px;\n}\n\n.modern-layout .dropdown-menu {\n  border-radius: 20px;\n}\n\n.modern-layout .dropdown {\n  position: relative;\n}\n\n.modern-layout .dropdown .arrow-after-dropdown::after {\n  content: \"\\f107\";\n  font-family: FontAwesome;\n  position: absolute;\n  border-top: none;\n  color: #6c757d;\n  right: 20px;\n}\n\n.modern-layout .font-danger {\n  color: #e4326b !important;\n}\n\n.modern-layout .font-success {\n  color: #88d563 !important;\n}\n\n.modern-layout .font-primary {\n  color: #a34ffe !important;\n}\n\n.modern-layout .font-info {\n  color: #5934fc !important;\n}\n\n.modern-layout .card {\n  border-radius: 0;\n}\n\n.modern-layout .card .card-header {\n  border-bottom: none;\n  padding: 30px;\n}\n\n.modern-layout .card .card-header h5 {\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.modern-layout .finance-stts {\n  border: none;\n  padding: 0;\n  margin: 0;\n  height: 257px;\n}\n\n.modern-layout .finance-stts .ct-series-a .ct-point,\n.modern-layout .finance-stts .ct-series-a .ct-line,\n.modern-layout .finance-stts .ct-series-a .ct-bar,\n.modern-layout .finance-stts .ct-series-a .ct-slice-donut {\n  stroke: #a34ffe;\n}\n\n.modern-layout .top-charts {\n  margin-top: -180px;\n}\n\n.modern-layout .top-charts .card-header h5 {\n  padding-top: 7px;\n}\n\n.modern-layout .top-charts .sales-report-chart .flot-chart-container {\n  border: 0;\n  padding: 0;\n  height: 415px;\n}\n\n.modern-layout .top-charts .total-earning .flot-chart-container {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  height: 322px;\n}\n\n.modern-layout footer {\n  position: relative;\n  background: linear-gradient(22deg, #5934fc 0, #a34ffe 100%);\n  padding: 25px;\n  bottom: 0;\n}\n\n.modern-layout .page-body-wrapper .page-body {\n  background-color: #eeeeee;\n  min-height: calc(100vh - 400px);\n  margin-top: 0 !important;\n}\n\n.modern-layout .testimonial p {\n  line-height: 2;\n  font-style: normal;\n  margin: 0;\n}\n\n.modern-layout .testimonial .owl-dots {\n  display: none;\n}\n\n.modern-layout .testimonial.owl-theme .owl-nav {\n  position: absolute;\n  top: -110px;\n  right: 0;\n}\n\n.modern-layout .testimonial.owl-theme .owl-nav button span {\n  color: #000;\n  font-size: 30px;\n}\n\n.modern-layout .testimonial.owl-theme .owl-nav [class*='owl-']:hover {\n  background: #fff;\n  text-decoration: none;\n  border: none;\n}\n\n.modern-layout .widget-joins .media {\n  padding: 42px 35px 50px 50px;\n}\n\n.modern-layout .widget-joins .media .media-body h3 {\n  font-size: 24px;\n  font-weight: bold;\n  letter-spacing: 1px;\n}\n\n.modern-layout .annual-report canvas {\n  position: relative;\n  right: 60px;\n  top: -20px;\n}\n\n.modern-layout .production-chart .flot-chart-container {\n  border: none;\n  padding: 0;\n  margin: 0;\n  height: 163px;\n}\n\n.modern-layout .tech-chart .flot-chart-container {\n  border: none;\n  padding: 0;\n  margin: 0;\n  height: 181px;\n}\n\n.modern-layout .tech-chart .flot-chart-container #tech-chart svg {\n  -webkit-filter: drop-shadow(12px 12px 7px rgba(119, 119, 119, 0.4));\n  filter: drop-shadow(12px 12px 7px rgba(119, 119, 119, 0.4));\n}\n\n.modern-layout .products-listing .flot-chart-container {\n  padding: 0;\n  margin: 0;\n  border: none;\n  top: 25px;\n  position: relative;\n  height: 300px;\n  margin-top: -150px;\n}\n\n@media screen and (min-device-width: 1200px) and (max-device-width: 1366px) {\n  .modern-layout .sales-report-chart .flot-chart-container {\n    height: 472px;\n  }\n\n  .modern-layout .annual-report {\n    height: 153px;\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  .modern-layout .svg-animation .effect-svg3 {\n    top: -56%;\n    right: -4%;\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n  }\n\n  .modern-layout .svg-animation .effect-svg4 {\n    top: 113%;\n    left: -8%;\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n  }\n\n  .modern-layout .svg-animation .effect-svg2 {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n  }\n\n  .modern-layout .svg-animation .effect-svg1 {\n    -webkit-transform: scale(0.4);\n    transform: scale(0.4);\n  }\n\n  .modern-layout .widget-joins:before {\n    display: block;\n  }\n\n  .modern-layout .widget-joins:after {\n    display: block;\n  }\n\n  .modern-layout .widget-joins .media {\n    padding: 50px;\n  }\n\n  .modern-layout .widget-joins .media .media-body h3 {\n    font-size: 20px;\n  }\n\n  .modern-layout .header .vertical-menu-main {\n    width: 82%;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .modern-layout .annual-report {\n    height: auto;\n  }\n\n  .modern-layout .vertical-menu-main nav ul li a {\n    color: #333333 !important;\n    border-right: none !important;\n  }\n\n  .modern-layout .sm {\n    top: 151px;\n  }\n\n  .modern-layout .top-charts {\n    margin-top: -249px;\n  }\n\n  .modern-layout .header .page-main-header {\n    border-bottom: none;\n  }\n\n  .modern-layout .vertical-mobile-sidebar {\n    color: #fff;\n    margin-right: 0;\n  }\n\n  .modern-layout .sales-report-chart .flot-chart-container {\n    height: 375px;\n  }\n\n  .modern-layout .annual-report canvas {\n    right: 0;\n    width: 100% !important;\n  }\n\n  .modern-layout .widget-joins .media {\n    padding: 35px;\n  }\n\n  .modern-layout .finance-status-image {\n    padding-top: 4px;\n  }\n\n  .modern-layout .p-t-5 {\n    padding-top: 11px !important;\n  }\n\n  .modern-layout .media-width {\n    min-width: 97px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .modern-layout button {\n    margin: 0 auto;\n  }\n\n  .modern-layout .sm {\n    top: 156px;\n  }\n\n  .modern-layout .main-header-right .nav-right>.mobile-toggle .icon-more {\n    vertical-align: middle;\n    color: #fff;\n  }\n\n  .modern-layout .main-header-right .nav-right>ul {\n    background-color: transparent !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  .modern-layout .main-header-right .nav-right>ul>li {\n    padding: 20px 0 !important;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .notification {\n    top: 11px;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .onhover-show-div {\n    top: 60px;\n  }\n\n  .modern-layout .testimonial.owl-theme .owl-nav {\n    top: -91px;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .top-charts {\n    margin-top: -244px !important;\n  }\n\n  .modern-layout .header-inner .logo-wrapper {\n    width: 63%;\n    margin-top: 20px;\n  }\n\n  .modern-layout .header-inner.float-sm-left {\n    margin-top: 6px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n\n  .modern-layout .widget-joins:before,\n  .modern-layout .widget-joins:after {\n    display: none;\n  }\n\n  .modern-layout .widget-joins .row [class*=\"col-\"] .media {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .modern-layout .widget-joins .row [class*=\"col-\"] .media .media-body.pl-1 {\n    padding-left: 12px !important;\n  }\n\n  .modern-layout .widget-joins .row [class*=\"col-\"]:last-child .media {\n    border-bottom: none;\n  }\n\n  .modern-layout .widget-joins .row [class*=\"col-\"]:first-child .media .media-body {\n    padding-left: 10px;\n  }\n\n  .modern-layout .svg-animation {\n    display: none;\n  }\n\n  .modern-layout .b-r-light {\n    border-right: none !important;\n  }\n\n  .modern-layout .header {\n    padding-top: 35px;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .header-inner {\n    margin-top: 10px;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right {\n    text-align: center;\n    margin: 15px 0;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right>ul {\n    top: 42px;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right>ul li {\n    padding: 5px 0;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .main-header-right .nav-right .notification-dropdown.onhover-show-div li {\n    padding: 12px 20px;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .top-charts {\n    margin-top: -85px;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .widget-joins .media .mr-3 {\n    margin-right: 10px !important;\n  }\n\n  .modern-layout .annual-report canvas {\n    right: unset;\n    top: 0;\n    left: 0px;\n    margin-top: 10px;\n    width: 100% !important;\n  }\n\n  .modern-layout .products-listing .flot-chart-container {\n    margin-top: -50px;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .header-inner {\n    margin-top: 0;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .header-inner .logo-wrapper {\n    width: 80%;\n    margin-top: 0px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .modern-layout .sm {\n    top: 121px;\n  }\n\n  .modern-layout .testimonial.owl-theme .owl-nav {\n    top: -80px;\n  }\n\n  .modern-layout .header .page-main-header .modern-header .header-inner .logo-wrapper {\n    width: 80%;\n  }\n\n  .modern-layout .header .page-main-header .header-inner .search-form .form-group {\n    margin-bottom: 0;\n  }\n\n  .modern-layout .header .page-main-header .main-header-right .nav-right>ul {\n    top: 29px !important;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .top-charts {\n    margin-top: -279px !important;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .top-charts .text-md-right {\n    text-align: center;\n    margin-top: 15px;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .p-t-5 {\n    padding-top: 6px !important;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .modern-layout .sm {\n    top: 124px;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .top-charts {\n    margin-top: -276px !important;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .top-charts .sales-report-chart .flot-chart-container {\n    height: 300px;\n  }\n\n  .modern-layout .page-body-wrapper .page-body .top-charts .total-earning .flot-chart-container {\n    height: 255px;\n  }\n}\n\n/**=====================\n      Modern layout CSS Ends\n==========================**/\n.classic-layout .margin-center-set {\n  margin-top: 22px;\n}\n\n.classic-layout .switch-sm .switch .switch-state:before {\n  bottom: 3px;\n}\n\n.classic-layout .card {\n  border-radius: 0;\n}\n\n.classic-layout .card .card-header {\n  border-bottom: none;\n  padding: 30px;\n}\n\n.classic-layout .card .card-header h5 {\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: 1px;\n}\n\n.classic-layout .number {\n  font-family: 'Open Sans', sans-serif;\n}\n\n.classic-layout .page-body-wrapper .page-sidebar {\n  top: 0;\n  height: 100vh;\n}\n\n.classic-layout .page-body-wrapper .page-sidebar .logo-wrapper {\n  text-align: center;\n  padding: 10px 0;\n}\n\n.classic-layout .page-body-wrapper .page-body {\n  min-height: 100vh;\n  margin-top: 0;\n}\n\n.classic-layout .page-main-header {\n  position: unset;\n  width: auto;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  margin-right: -22px;\n}\n\n.classic-layout .page-main-header .main-header-left {\n  width: 310px;\n  padding: 30px;\n}\n\n.classic-layout .page-main-header .main-header-left .mobile-sidebar .switch {\n  margin-right: 40px;\n  margin-top: 10px;\n  margin-left: unset;\n}\n\n.classic-layout .page-main-header .main-header-left .search-form {\n  width: 100%;\n}\n\n.classic-layout .page-main-header .main-header-left .search-form .form-group {\n  width: 100%;\n}\n\n.classic-layout .page-main-header .main-header-left .search-form .form-group .form-control-plaintext {\n  border-radius: 0;\n}\n\n.classic-layout .page-main-header .main-header-right {\n  float: right;\n  width: auto;\n  display: contents;\n}\n\n.classic-layout .thin-bar-chart .flot-chart-container {\n  height: 140px;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n\n.classic-layout .thin-bar-chart .flot-chart-placeholder {\n  top: 25px;\n}\n\n.classic-layout .thin-bar-chart .morris-hover.morris-default-style {\n  display: none !important;\n}\n\n.classic-layout .thin-bar-chart .content .top-icon {\n  font-size: 25px;\n  color: #EFEFEF;\n}\n\n.classic-layout .thin-bar-chart .inner {\n  margin-top: 60px;\n}\n\n.classic-layout .thin-bar-chart .inner span {\n  color: #777777;\n  margin-bottom: 0;\n  letter-spacing: 1px;\n}\n\n.classic-layout .product-sale-chart {\n  height: 474px;\n}\n\n.classic-layout .product-sale-chart svg .ct-labels .ct-label {\n  color: #000;\n}\n\n.classic-layout .status-details h3 {\n  color: #333333;\n  font-weight: 600;\n}\n\n.classic-layout .status-details h3 span {\n  color: #333333;\n}\n\n.classic-layout .status-details-color span {\n  color: #fff;\n}\n\n.classic-layout .social-comment-widget {\n  position: relative;\n}\n\n.classic-layout .social-comment-widget .user-name {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.classic-layout .social-comment-widget .user-post {\n  font-size: 12px;\n}\n\n.classic-layout .social-comment-widget p {\n  color: #fff;\n  line-height: 2;\n  margin-top: 48px;\n  font-size: 14px;\n}\n\n.classic-layout .social-comment-widget .social-icon {\n  font-size: 30px;\n}\n\n.classic-layout .social-comment-widget .social-icon-bg {\n  position: absolute;\n  right: -49px;\n  top: -10px;\n  font-size: 195px;\n  opacity: 0.1;\n  -webkit-transition: -webkit-transform 0.5s;\n  transition: -webkit-transform 0.5s;\n  transition: transform 0.5s;\n  transition: transform 0.5s, -webkit-transform 0.5s;\n}\n\n.classic-layout .social-comment-widget .social-icon-bg:hover {\n  -webkit-transform: scale(1.3);\n  transform: scale(1.3);\n}\n\n.classic-layout .status-yearly-chart .chart-container {\n  height: 235px;\n}\n\n.classic-layout .status-monthly-chart .chart-container {\n  height: 265px;\n}\n\n.classic-layout .growth-graph-first .flot-chart-placeholder {\n  height: 95px;\n}\n\n.classic-layout .growth-graph-second .flot-chart-placeholder {\n  height: 155px;\n}\n\n.classic-layout .whether-widget .whether-widget-top {\n  padding: 35px;\n  background-color: #4099ff;\n  height: 307px;\n}\n\n.classic-layout .whether-widget .whether-widget-top span {\n  text-shadow: none;\n  font-size: 14px;\n}\n\n.classic-layout .whether-widget .whether-widget-top .details {\n  text-align: left;\n  left: 20px;\n  bottom: -127px;\n}\n\n.classic-layout .whether-widget .whether-widget-top .details h3 {\n  color: #fff;\n}\n\n.classic-layout .whether-widget .whether-widget-top .details h3 sup {\n  color: #fff;\n  font-size: 37px;\n  font-weight: 600;\n}\n\n.classic-layout .whether-widget .whether-widget-top .details h3 span {\n  font-size: 55px;\n  font-weight: 600;\n}\n\n.classic-layout .whether-widget .whether-widget-top img {\n  -moz-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.8));\n  -webkit-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.8));\n  -ms-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.8));\n  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.8));\n  height: 128px;\n}\n\n.classic-layout .whether-widget .whether-widget-bottom .climacon_component-fill,\n.classic-layout .whether-widget .whether-widget-bottom .climacon_component-stroke {\n  fill: #fff;\n  stroke: #ddd;\n}\n\n.classic-layout .whether-widget .whether-widget-bottom .climacon_component-stroke {\n  stroke-width: 3px;\n}\n\n.classic-layout .whether-widget .whether-widget-bottom .row div .media {\n  padding-top: 0;\n}\n\n.classic-layout .whether-widget .whether-widget-bottom h4 span {\n  color: #333333;\n}\n\n.classic-layout .whether-widget .whether-widget-bottom svg.climacon {\n  height: 70px;\n  width: 70px;\n}\n\n.classic-layout #employee svg g g g text {\n  fill: #717171;\n}\n\n@media screen and (min-device-width: 1200px) and (max-device-width: 1366px) {\n  .classic-layout .thin-bar-chart .flot-chart-container {\n    height: 120px;\n    margin-top: -15px;\n  }\n\n  .classic-layout .thin-bar-chart .content {\n    float: none !important;\n    text-align: center !important;\n    margin-top: 0px;\n  }\n\n  .classic-layout .thin-bar-chart .inner {\n    margin-top: 32px;\n  }\n\n  .classic-layout .thin-bar-chart .inner h6 {\n    font-size: 12px;\n  }\n\n  .classic-layout .status-monthly-chart .chart-container {\n    height: 235px;\n  }\n\n  .classic-layout .product-sale-chart {\n    height: 445px !important;\n  }\n\n  .classic-layout .status-yearly-chart {\n    margin-top: -20px;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .classic-layout .margin-center-set {\n    margin-top: 0;\n  }\n\n  .classic-layout .product-sale-chart {\n    height: 411px;\n  }\n\n  .classic-layout .lg-ml-details {\n    margin-left: 15px;\n  }\n\n  .classic-layout .mt-3 {\n    margin-top: 0px !important;\n  }\n\n  .classic-layout .growth-graph-second .flot-chart-placeholder {\n    height: 95px;\n  }\n\n  .classic-layout .page-sidebar .sidebar-user .mt-3 {\n    margin-top: 16px !important;\n  }\n\n  .classic-layout .status-monthly-chart .chart-container {\n    height: 254px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .classic-layout .product-sale-chart {\n    height: 391px;\n  }\n\n  .classic-layout .page-body-wrapper .page-sidebar {\n    top: 122px !important;\n  }\n\n  .classic-layout .page-main-header .main-header-right .nav-right {\n    padding-right: 25px;\n  }\n\n  .classic-layout .page-main-header .main-header-right .nav-right>ul {\n    left: 25px !important;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .classic-layout .margin-center-set {\n    margin-top: 21px;\n  }\n\n  .classic-layout .growth-graph-second .flot-chart-placeholder {\n    height: 134px;\n  }\n\n  .classic-layout .status-widget .status-yearly-chart {\n    margin-top: -20px;\n  }\n\n  .classic-layout .status-monthly-chart .chart-container,\n  .classic-layout .status-yearly-chart .chart-container {\n    height: 200px;\n  }\n\n  .classic-layout .social-comment-widget .social-icon-bg {\n    right: 0;\n    top: 0;\n    font-size: 120px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .classic-layout .page-main-header .main-header-left .search-form .form-group {\n    margin-bottom: 0;\n  }\n\n  .classic-layout .page-main-header .main-header-right .nav-right>ul {\n    left: 15px !important;\n  }\n\n  .classic-layout .margin-center-set {\n    margin-top: 0px;\n  }\n\n  .classic-layout .product-sale-chart {\n    height: 300px;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .classic-layout .whether-widget .whether-widget-top .details h3 span {\n    font-size: 41px;\n  }\n\n  .classic-layout .whether-widget .whether-widget-top .details h3 sup {\n    font-size: 30px;\n  }\n}\n\n.fixed-nav-layout {\n  position: relative;\n  background-blend-mode: overlay;\n  background-attachment: fixed;\n  background-image: url(\"../images/maintence-bg.jpg\");\n}\n\n.fixed-nav-layout .container {\n  max-width: unset;\n  width: calc(100% - 400px);\n}\n\n.fixed-nav-layout .flot-chart-container svg {\n  -webkit-filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.2));\n  filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.2));\n}\n\n.fixed-nav-layout i,\n.fixed-nav-layout [class=\"bottom-line-*\"] {\n  -webkit-filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.3));\n  filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.3));\n}\n\n.fixed-nav-layout .sales-overview svg {\n  -webkit-filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.3));\n  filter: drop-shadow(7px 7px 7px rgba(0, 0, 0, 0.3));\n}\n\n.fixed-nav-layout.page-wrapper .page-body-wrapper .page-body {\n  background-color: rgba(246, 247, 251, 0.75);\n}\n\n.fixed-nav-layout .page-main-header .main-header-left {\n  padding: 10px;\n}\n\n.fixed-nav-layout .text-right ul li {\n  text-align: center;\n}\n\n.fixed-nav-layout .text-right ul .list-inline-item:not(:last-child) {\n  margin-right: 10px;\n}\n\n.fixed-nav-layout .main-header-right {\n  float: right;\n  width: 76%;\n  padding: 0;\n}\n\n.fixed-nav-layout .site-visiter-chart ul {\n  margin-bottom: 30px;\n}\n\n.fixed-nav-layout .site-visiter-chart ul li {\n  width: 100px;\n  text-align: center;\n}\n\n.fixed-nav-layout .site-visiter-chart .flot-chart-container {\n  border: none;\n  height: 350px;\n}\n\n.fixed-nav-layout .site-visiter-chart .flot-chart-container .ct-area {\n  fill-opacity: 0;\n}\n\n.fixed-nav-layout .site-visiter-chart .bottom-line-info {\n  border: 2px solid #4099ff;\n}\n\n.fixed-nav-layout .site-visiter-chart .bottom-line-primary {\n  border: 2px solid #ab8ce4;\n}\n\n.fixed-nav-layout .site-visiter-chart .bottom-line-secondary {\n  border: 2px solid #26c6da;\n}\n\n.fixed-nav-layout .site-visiter-chart .bottom-line-danger {\n  border: 2px solid #FF5370;\n}\n\n.fixed-nav-layout .total-venders .flot-chart-container {\n  height: 215px;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.fixed-nav-layout .total-venders .morris-hover.morris-default-style {\n  display: none !important;\n}\n\n.fixed-nav-layout .card .card-header {\n  border-bottom: none;\n  text-transform: uppercase;\n  padding: 25px;\n}\n\n.fixed-nav-layout .sales-overview .chart-block canvas {\n  height: 305px !important;\n}\n\n.fixed-nav-layout .social-widget .media {\n  padding: 30px;\n}\n\n.fixed-nav-layout .crm-top-widget .media .media-body h3 {\n  font-weight: 600;\n}\n\n.fixed-nav-layout .crm-top-widget .media .media-body h3 span {\n  color: #333333;\n}\n\n.fixed-nav-layout .ecommerce-widget .card-body {\n  padding: 20px;\n}\n\n.fixed-nav-layout .ecommerce-widget .flot-chart-container {\n  height: 85px;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {\n  height: 100%;\n  left: 220px;\n  width: 160px;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar~.page-body {\n  margin-left: 160px;\n  -webkit-box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: 0 1px 11px 0 rgba(0, 0, 0, 0.12);\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user {\n  padding: 20px;\n  background-color: #fafafa;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user h6 {\n  letter-spacing: 1px;\n  font-weight: 700;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user div {\n  background-color: #f5f5f5;\n  width: 60px;\n  margin: 0 auto;\n  padding: 5px 0;\n  border-radius: 50%;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-user div img {\n  border: 3px solid #e6e6e6;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu {\n  max-height: 100%;\n  overflow: auto;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li .icon-sidebar {\n  color: #333333;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li .sub-header-title {\n  font-size: 12px;\n  color: #333333;\n  font-weight: 600;\n  margin-top: 5px;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu>li:last-child .sidebar-header {\n  border-bottom: none;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar .sidebar-menu .sidebar-header {\n  padding-top: 15px;\n  padding-bottom: 20px;\n  border-bottom: 1px dashed #cacaca;\n}\n\n.fixed-nav-layout .page-body-wrapper.sidebar-icon.sidebar-close .page-sidebar {\n  width: 0;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  opacity: 0;\n}\n\n.fixed-nav-layout footer {\n  bottom: -85px;\n  padding: 30px;\n  z-index: 999;\n}\n\n.fixed-nav-layout footer .footer-copyright p {\n  font-size: 14px;\n}\n\n@media only screen and (max-width: 1500px) {\n  .fixed-nav-layout .container {\n    width: calc(100% - 100px);\n    max-width: unset;\n  }\n\n  .fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {\n    left: 70px;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .fixed-nav-layout .container {\n    width: calc(100% - 30px);\n    max-width: unset;\n  }\n\n  .fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {\n    left: 30px;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(2) {\n    border-bottom: none;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(1) {\n    border-bottom: none;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) {\n    border-left: 1px solid #ddd;\n  }\n\n  .fixed-nav-layout .main-header-right {\n    width: 73%;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .fixed-nav-layout .page-body-wrapper.sidebar-icon .page-sidebar {\n    left: 0;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-sidebar {\n    width: 0%;\n    top: 60px;\n    height: calc(100vh - 60px);\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-sidebar~.page-body {\n    margin-left: 0px !important;\n    padding-top: 0 !important;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-sidebar-open {\n    width: auto !important;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-left {\n    padding: 0;\n    width: 200px;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-left .logo-wrapper img {\n    margin-top: 9px;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-right {\n    width: 73%;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-right .mobile-sidebar {\n    margin-top: 13px;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-right .nav-right>.mobile-toggle {\n    padding-top: 21px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .fixed-nav-layout .site-visiter-chart ul li {\n    width: 80px;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-body {\n    width: 100%;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-body .user-status {\n    min-width: 417px;\n    overflow: auto;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-body .site-visiter-chart ul li.list-inline-item:last-child {\n    margin-top: 15px;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-left .logo-wrapper img {\n    margin-top: 11px;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-right {\n    width: 66%;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .fixed-nav-layout .site-visiter-chart .flot-chart-container {\n    height: 250px;\n  }\n\n  .fixed-nav-layout .site-visiter-chart ul li {\n    width: 45%;\n    margin: 2% !important;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-right {\n    width: 56%;\n  }\n\n  .fixed-nav-layout .page-main-header .nav-right>ul .search-form .mobile-search {\n    background-image: url(../images/dashboard/search.png);\n    height: 15px;\n    width: 15px;\n    display: inline-block;\n    background-size: cover;\n    margin: 5px 0 0;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(1) {\n    border-bottom: 1px solid #ddd;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(1) .crm-top-widget {\n    margin-top: 0;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(2) {\n    border-bottom: 1px solid #ddd;\n    border-left: 0;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) {\n    border-left: none;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) .crm-top-widget {\n    margin-bottom: 0;\n  }\n\n  .fixed-nav-layout .crm-top-widget {\n    margin: 15px 0;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-body .user-status {\n    min-width: 314px;\n    overflow: auto;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .fixed-nav-layout .page-main-header .main-header-left {\n    width: 135px;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-right .mobile-sidebar {\n    margin-top: 6px;\n  }\n\n  .fixed-nav-layout .page-main-header .main-header-right .nav-right>.mobile-toggle {\n    padding-top: 13px;\n  }\n\n  .fixed-nav-layout .border-widgets>.row>div:nth-child(3) {\n    border-bottom: none;\n  }\n\n  .fixed-nav-layout .xs-col-100 {\n    max-width: 100%;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n  }\n\n  .fixed-nav-layout .xs-col-100.text-right {\n    text-align: center !important;\n    margin-top: 15px;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-body .user-status {\n    min-width: 233px;\n    overflow: auto;\n  }\n\n  .fixed-nav-layout .page-body-wrapper .page-body .site-visiter-chart ul li.list-inline-item {\n    width: 39%;\n    margin-right: 10px !important;\n  }\n}\n\n.solitary-layout .radial-bar-info {\n  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(50%, #3185e6), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #3185e6), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(360deg, #3185e6 50%, transparent 50%, transparent), linear-gradient(270deg, #3185e6 50%, #ddd 50%, #ddd);\n}\n\n.solitary-layout .radial-bar-success {\n  background-image: linear-gradient(324deg, #4ed17d 50%, transparent 50%, transparent), linear-gradient(270deg, #4ed17d 50%, #ddd 50%, #ddd);\n}\n\n.solitary-layout .radial-bar-primary {\n  background-image: linear-gradient(90deg, #ddd 50%, transparent 50%, transparent), linear-gradient(216deg, #6422d2 50%, #ddd 50%, #ddd);\n}\n\n.solitary-layout .radial-bar-danger {\n  background-image: -webkit-gradient(linear, right top, left top, color-stop(50%, #f31464), color-stop(50%, transparent), to(transparent)), -webkit-gradient(linear, right top, left top, color-stop(50%, #f31464), color-stop(50%, #ddd), to(#ddd));\n  background-image: linear-gradient(270deg, #f31464 50%, transparent 50%, transparent), linear-gradient(270deg, #f31464 50%, #ddd 50%, #ddd);\n}\n\n.solitary-layout .dashboard-chart-container .flot-chart-placeholder {\n  margin-bottom: -2px;\n}\n\n.solitary-layout a {\n  color: #6422d2;\n}\n\n.solitary-layout a:hover {\n  text-decoration: none;\n}\n\n.solitary-layout .switch input:checked+.switch-state {\n  background-color: #6228d3;\n  border: 1px solid #fff;\n}\n\n.solitary-layout .mobile-toggle i {\n  color: #fff;\n}\n\n.solitary-layout #employee-act-chart svg text {\n  fill: #5357e1;\n}\n\n.solitary-layout .font-purple {\n  color: #6422d2 !important;\n}\n\n.solitary-layout .font-danger {\n  color: #f31464 !important;\n}\n\n.solitary-layout .font-success {\n  color: #4ed17d !important;\n}\n\n.solitary-layout .font-info {\n  color: #3185e6 !important;\n}\n\n.solitary-layout .bg-purple {\n  background-color: #6228d3;\n}\n\n.solitary-layout .bg-danger {\n  background-color: #f31464 !important;\n}\n\n.solitary-layout .bg-success {\n  background-color: #4ed17d !important;\n}\n\n.solitary-layout .bg-info {\n  background-color: #3185e6 !important;\n}\n\n.solitary-layout #online-visitors h4 {\n  font-weight: 600;\n}\n\n.solitary-layout #online-visitors .dropdown.float-right {\n  margin-top: 5px;\n}\n\n.solitary-layout #income-chart ul li span {\n  color: #7d8187;\n}\n\n.solitary-layout #income-chart ul li h5 {\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n\n.solitary-layout #income-chart ul li h5 span {\n  color: #333333;\n}\n\n.solitary-layout .employee-activity-chart .row [class*=\"col-\"] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.solitary-layout .employee-color {\n  color: #97ffcd;\n}\n\n.solitary-layout .dropdown.float-md-right .btn-white {\n  background-color: #fff;\n}\n\n.solitary-layout .stat-widget-dashboard .media .media-body h3 {\n  font-weight: 600;\n}\n\n.solitary-layout .dark-success {\n  background-color: #24d27e;\n}\n\n.solitary-layout .dark-success h5,\n.solitary-layout .dark-success h4 {\n  color: #fff;\n}\n\n.solitary-layout .bg-info {\n  background-color: #3185e6 !important;\n}\n\n.solitary-layout .bg-success {\n  background-color: #4ed17d !important;\n}\n\n.solitary-layout .bg-primary {\n  background-color: #6422d2 !important;\n}\n\n.solitary-layout .bg-danger {\n  background-color: #f31464 !important;\n}\n\n.solitary-layout button {\n  border-radius: 20px;\n  padding: 10px 19px;\n  font-size: 12px;\n}\n\n.solitary-layout .float-lg-right .btn-gradien,\n.solitary-layout .float-md-right .btn-gradien {\n  background: -webkit-gradient(linear, left top, left bottom, color-stop(0, #3ca0f6), to(#6422d2));\n  background: linear-gradient(180deg, #3ca0f6 0, #6422d2 100%);\n}\n\n.solitary-layout .btn-gradien {\n  background: linear-gradient(138deg, #3ca0f6 0, #6422d2 100%);\n  color: #fff !important;\n  border-radius: 25px;\n  padding: 10px 28px;\n}\n\n.solitary-layout .card-header {\n  border-bottom: none;\n}\n\n.solitary-layout .card-header h5 {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.solitary-layout .iconsidebar-menu {\n  width: 290px;\n  position: fixed;\n  z-index: 10;\n  top: 0;\n}\n\n.solitary-layout .iconsidebar-menu .logo-wrapper {\n  background-color: #21262e;\n  width: 120px;\n  padding: 10px;\n}\n\n.solitary-layout .iconsidebar-menu .logo-wrapper img {\n  width: 60px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar {\n  width: 120px;\n  background-color: #21262e;\n  height: 100vh;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .bar-icons {\n  display: block;\n  text-align: center;\n  padding: 25px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  color: #3b434e;\n  font-size: 30px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .bar-icons:hover {\n  background-color: #293039;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu {\n  position: fixed;\n  top: 0;\n  height: 100%;\n  left: 120px;\n  width: 253px;\n  background-color: #293039;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  display: none;\n  z-index: -1;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner {\n  margin-top: 70px;\n  padding: 0 45px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-header {\n  color: #fff !important;\n  font-size: 18px !important;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-header i {\n  margin-top: 5px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-submenu li {\n  margin-bottom: 20px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-submenu li a,\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .submenu-inner .iconbar-submenu li i {\n  font-size: 14px;\n  color: #7d8187;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search {\n  position: relative;\n  color: #fff;\n  font-size: 16px;\n  padding: 30px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input {\n  width: 100%;\n  height: 35px;\n  background: #21262e;\n  border: none;\n  border-radius: 20px;\n  text-indent: 30px;\n  color: #eee;\n  padding-right: 35px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input:-ms-input-placeholder {\n  color: #7d81879e;\n  font-size: 14px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input:-moz-placeholder {\n  color: #7d81879e;\n  font-size: 14px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input:focus {\n  outline: none;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search .fa-search {\n  position: absolute;\n  top: 40px;\n  right: 45px;\n  color: #7d81879e;\n  font-size: 14px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input::-webkit-input-placeholder {\n  color: #7d81879e;\n  font-size: 14px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu .search input::-moz-placeholder {\n  color: #7d81879e;\n  font-size: 14px;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar li.active {\n  background: #293039;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar li.active i {\n  color: #fff;\n}\n\n.solitary-layout .iconsidebar-menu .iconMenu-bar li.active .iconbar-mainmenu {\n  display: block;\n}\n\n.solitary-layout .iconsidebar-menu .iconbar-mainmenu-close {\n  display: none !important;\n}\n\n.solitary-layout .page-main-header {\n  left: 0;\n  right: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  display: block;\n  height: auto;\n  background: linear-gradient(22deg, #3ca0f6 0, #6422d2 100%);\n}\n\n.solitary-layout .page-main-header .solitary-header .main-header-right {\n  float: right;\n  width: auto;\n  padding: 0;\n}\n\n.solitary-layout .page-main-header .solitary-header .main-header-right .nav-right ul li i {\n  font-size: unset;\n}\n\n.solitary-layout .page-main-header .main-header-right .nav-right .notification {\n  background-color: #fff;\n}\n\n.solitary-layout .iconbar-close .page-body {\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  margin-left: 120px !important;\n}\n\n.solitary-layout .iconbar-close .top-section {\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  margin-left: 120px !important;\n  width: calc(100% - 120px) !important;\n}\n\n.solitary-layout .page-body-wrapper .page-header {\n  padding: 0 20px;\n}\n\n.solitary-layout .page-body-wrapper .top-section {\n  margin-left: 373px;\n  top: 90px;\n  padding: 35px 0;\n  position: fixed;\n  background-color: #fff;\n  z-index: 2;\n  width: calc(100% - 373px);\n  -webkit-box-shadow: 0 0 0 1px #eee;\n  box-shadow: 0 0 0 1px #eee;\n}\n\n.solitary-layout .page-body-wrapper .page-body {\n  margin-left: 373px;\n  min-height: calc(100vh - 90px);\n  margin-top: 237px;\n  padding-top: 40px;\n  z-index: 1;\n  position: relative;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  background-color: #f2f2f2;\n}\n\n.solitary-layout .page-body-wrapper .page-body.inner-content-margin {\n  margin-top: 189px;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce-right {\n  padding-right: 0;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce-left {\n  padding-left: 0;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce {\n  padding: 0;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div:first-child .card {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div:nth-child(4) .card {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div:nth-child(5) .card {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div .card {\n  border-radius: 0;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div .card .ecommerce-widget {\n  border-right: 1px solid #f2f2f2;\n}\n\n.solitary-layout .page-body-wrapper .page-body #online-sales .row div .card .border-right-none {\n  border-right: none;\n}\n\n.solitary-layout .solitary-scrollpy {\n  position: relative;\n  top: 36px;\n}\n\n.solitary-layout .solitary-scrollpy .nav-pills .nav-item a {\n  color: #7d8187;\n  letter-spacing: 1px;\n  font-size: 14px;\n  padding: 15px 20px;\n  font-weight: 600;\n}\n\n.solitary-layout .solitary-scrollpy .nav-pills .nav-item .active {\n  background-color: #f2f2f2;\n  color: #21262e;\n  border: 1px solid #eee;\n  border-bottom: none;\n  border-radius: 0;\n}\n\n.solitary-layout .solitary-scrollpy #mob_tab_cls {\n  display: none;\n}\n\n.solitary-layout .annual-chart {\n  border: none;\n  padding: 0;\n}\n\n.solitary-layout .social-widget {\n  position: relative;\n  overflow: hidden;\n}\n\n.solitary-layout .social-widget .social-icons {\n  font-size: 18px;\n}\n\n.solitary-layout .social-widget .icon-bg-right {\n  position: absolute;\n  right: -39px;\n  bottom: 14px;\n  color: #f2f2f2;\n  font-size: 109px;\n  z-index: 0;\n  opacity: 0.5;\n}\n\n.solitary-layout .social-widget .icon-bg-right:hover {\n  -webkit-transform: rotate(-5deg) scale(1.1);\n  transform: rotate(-5deg) scale(1.1);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.solitary-layout .collection-chart .flot-chart-container {\n  height: 231px;\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.solitary-layout .employee-activity-chart .flot-chart-container {\n  border: none;\n  padding: 0;\n  margin: 0;\n  height: 315px;\n}\n\n.solitary-layout .employee-activity-chart .flot-chart-container svg {\n  width: 100% !important;\n}\n\n.solitary-layout .employee-salary-chart canvas {\n  height: 257px !important;\n}\n\n.solitary-layout .online-visitors-charts .flot-chart-container {\n  border: none;\n  padding: 0;\n  margin: 0;\n  height: 200px;\n}\n\n.solitary-layout .morris-hover {\n  z-index: 0;\n}\n\n.solitary-layout .annual-chart svg {\n  width: 100% !important;\n}\n\n@media only screen and (max-width: 1366px) {\n  .solitary-layout .page-body #online-sales .row div:nth-child(2) .card {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .solitary-layout .page-body #online-sales .row div:nth-child(3) .card {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .solitary-layout .page-body #online-sales .row div.lg-set-padding {\n    padding-right: 15px !important;\n  }\n\n  .solitary-layout .page-body #online-sales .row div.lg-pl-set {\n    padding-left: 15px !important;\n  }\n\n  .solitary-layout .page-body #online-sales .row div .card {\n    border-radius: 0;\n  }\n\n  .solitary-layout .page-body #online-sales .row div .card .ecommerce-widget.border-lg-none {\n    border-right: none;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .solitary-layout .iconsidebar-menu {\n    width: 121px;\n  }\n\n  .solitary-layout .page-body-wrapper .page-body,\n  .solitary-layout .page-body-wrapper .top-section {\n    margin-left: 120px;\n  }\n\n  .solitary-layout .page-body-wrapper .top-section {\n    width: calc(100% - 120px);\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .solitary-layout .page-body-wrapper .top-section {\n    top: 60px;\n  }\n\n  .solitary-layout .page-body-wrapper .top-section .page-header {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .solitary-layout .page-body-wrapper .page-body {\n    margin-top: 235px !important;\n    padding-top: 40px !important;\n    margin-left: 120px !important;\n  }\n\n  .solitary-layout .page-body-wrapper #employee .mt-3 {\n    margin-top: 0 !important;\n  }\n\n  .solitary-layout .page-body-wrapper #employee .dark-success h5.p-t-5 {\n    padding-top: 9px !important;\n  }\n\n  .solitary-layout .page-body-wrapper .social-widget .icon-bg-right {\n    font-size: 93px;\n  }\n\n  .solitary-layout .page-body-wrapper #online-visitors .dropdown.float-right {\n    margin-top: 4px;\n  }\n\n  .solitary-layout .page-body-wrapper .online-visitors-charts.p-l-30 {\n    padding-left: 20px;\n  }\n\n  .solitary-layout .page-body-wrapper .online-visitors-charts.p-r-30 {\n    padding-right: 20px;\n  }\n\n  .solitary-layout .page-main-header {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .solitary-layout .page-main-header .solitary-header .main-header-right {\n    padding-top: 12px;\n  }\n\n  .solitary-layout .page-main-header .solitary-header .main-header-right .nav-right>ul {\n    background-color: #21262e;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .solitary-layout .page-body-wrapper #employee .mt-3 {\n    margin-top: 20px !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body {\n    margin-left: 55px !important;\n  }\n\n  .solitary-layout.page-wrapper .top-section {\n    margin-left: 40px !important;\n    width: calc(100% - 40px) !important;\n  }\n\n  .solitary-layout.page-wrapper .iconsidebar-menu {\n    top: 60px;\n    width: 55px;\n  }\n\n  .solitary-layout.page-wrapper .iconsidebar-menu .logo-wrapper {\n    width: 55px;\n  }\n\n  .solitary-layout.page-wrapper .iconsidebar-menu .iconMenu-bar {\n    width: 55px;\n  }\n\n  .solitary-layout.page-wrapper .iconsidebar-menu .iconMenu-bar .bar-icons {\n    font-size: 25px;\n    padding: 10px;\n  }\n\n  .solitary-layout.page-wrapper .iconsidebar-menu .iconMenu-bar .iconbar-mainmenu {\n    left: 55px;\n    width: 34%;\n  }\n\n  .solitary-layout.page-wrapper .solitary-scrollpy .nav-pills .nav-item a {\n    padding: 15px 7px;\n  }\n\n  .solitary-layout.page-wrapper #income-chart .mt-3 {\n    margin-top: 20px !important;\n  }\n\n  .solitary-layout.page-wrapper #online-visitors .social-widget .media {\n    padding: 0 0;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .solitary-layout.page-wrapper .page-body-wrapper .page-body {\n    margin-top: 208px !important;\n    padding-top: 20px !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce {\n    padding: 0 15px !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div.p-set-ecommerce-left {\n    padding-left: 15px !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div .card {\n    border-radius: 0.25rem;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .row div .card .ecommerce-widget {\n    border-right: none;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .page-body #online-sales .p-set-ecommerce-right {\n    padding-right: 15px !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .solitary-scrollpy #mob_tab_cls {\n    display: block;\n    font-size: 17px;\n    margin-left: 10px;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .solitary-scrollpy .nav-pills .nav-item a {\n    font-size: 10px;\n    padding: 10px;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper #employee .p-t-10,\n  .solitary-layout.page-wrapper .page-body-wrapper #income-chart .p-t-10 {\n    padding-top: 0 !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper #employee .mt-3,\n  .solitary-layout.page-wrapper .page-body-wrapper #income-chart .mt-3 {\n    margin-top: 15px !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper #employee .employee-activity-chart .m-30,\n  .solitary-layout.page-wrapper .page-body-wrapper #income-chart .employee-activity-chart .m-30 {\n    margin: 15px !important;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper #solitary-scrollpy .nav-pills {\n    display: none;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .online-visitors-charts.p-r-30 {\n    padding-right: 15px;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .online-visitors-charts.p-l-30 {\n    padding-left: 15px;\n  }\n\n  .solitary-layout.page-wrapper .page-body-wrapper .iconbar-close .page-body {\n    margin-left: 55px !important;\n    margin-top: 275px !important;\n    padding-top: 15px !important;\n  }\n\n  .solitary-layout.page-wrapper .iconsidebar-menu .iconbar-mainmenu {\n    width: 60% !important;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .solitary-layout button:last-child {\n    margin-top: 5px;\n  }\n\n  .solitary-layout .online-visitors-charts .flot-chart-container #west-zone-graph canvas {\n    width: 202px !important;\n  }\n}\n\n.vertical-layout .vertical-menu-main {\n  top: 136px;\n  background-color: #4099ff;\n}\n\n.vertical-layout .vertical-menu-main nav ul {\n  width: 59%;\n  margin: 0 auto;\n}\n\n.vertical-layout .vertical-menu-main nav ul li a {\n  color: #fff;\n}\n\n.vertical-layout .vertical-menu-main nav ul li ul li a {\n  color: #333333;\n}\n\n@media (min-width: 1200px) {\n\n  .vertical-layout .vertical-menu-main .pixelstrap ul a:hover,\n  .vertical-layout .vertical-menu-main .pixelstrap ul a:focus,\n  .vertical-layout .vertical-menu-main .pixelstrap ul a:active,\n  .vertical-layout .vertical-menu-main .pixelstrap ul a.highlighted {\n    color: #ab8ce4;\n  }\n}\n\n.vertical-layout .page-body-wrapper .page-body {\n  min-height: calc(100vh - 80px);\n}\n\n.vertical-layout .page-body-wrapper .page-body.vertical-menu-mt {\n  margin-top: 189px !important;\n}\n\n.vertical-layout .page-body-wrapper .table th,\n.vertical-layout .page-body-wrapper .table td {\n  vertical-align: middle;\n}\n\n.vertical-layout .page-body-wrapper .user-status tbody tr:first-child td {\n  padding-top: 0;\n}\n\n.vertical-layout .page-body-wrapper .user-status tbody tr td:first-child {\n  padding-left: 0;\n}\n\n.vertical-layout .page-body-wrapper .user-status tbody tr td .icon-box i {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 50%;\n}\n\n.vertical-layout .page-body-wrapper .user-status tbody tr td .icon-box i:first-child {\n  padding: 9px 12px;\n  margin-right: 2px;\n}\n\n.vertical-layout .page-body-wrapper .user-status tbody tr .bd-t-none .d-inline-block img {\n  border: 3px solid #ab8ce4;\n}\n\n.vertical-layout .page-body-wrapper .image-border tr td:first-child {\n  padding-left: 0;\n}\n\n.vertical-layout .page-body-wrapper .image-border tr td .d-inline-block img {\n  border: 3px solid #ddd;\n}\n\n.vertical-layout .number {\n  font-family: sans-serif;\n}\n\n.vertical-layout .onhover-show-div {\n  top: 100px;\n}\n\n.vertical-layout .page-main-header {\n  left: 0;\n  right: 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  display: block;\n  height: auto;\n  background-color: #fff;\n}\n\n.vertical-layout .page-main-header .main-header-left {\n  margin-top: 15px;\n}\n\n.vertical-layout .page-main-header .main-header-right {\n  float: right;\n  width: auto;\n  padding: 0;\n}\n\n.vertical-layout .page-main-header .main-header-right .nav-right .notification {\n  top: 37px;\n}\n\n.vertical-layout .page-main-header .main-header-right .nav-right>ul>li {\n  padding: 45px 0;\n}\n\n.vertical-layout .page-main-header .main-header-right .nav-right .user-imgbg {\n  margin: 0 auto;\n  background: #4099ff;\n  border-radius: 50%;\n  padding: 3px;\n}\n\n.vertical-layout .search-form input {\n  border-radius: 20px;\n  background-image: url(../images/dashboard/search.png);\n  background-color: #fff;\n  color: #000;\n  width: 275px;\n  background-size: 12px;\n  padding: 10px 20px;\n}\n\n.vertical-layout .search-form input:-ms-input-placeholder {\n  color: #cccccc;\n}\n\n.vertical-layout .search-form input:-moz-placeholder {\n  color: #cccccc;\n}\n\n.vertical-layout .search-form input:focus {\n  outline: none;\n}\n\n.vertical-layout .search-form input::-webkit-input-placeholder {\n  color: #cccccc;\n}\n\n.vertical-layout .search-form input::-moz-placeholder {\n  color: #cccccc;\n}\n\n.vertical-layout .card {\n  border-radius: 0px;\n}\n\n.vertical-layout .card .card-header {\n  border-bottom: none;\n  padding: 30px;\n}\n\n.vertical-layout .card .card-header h5 {\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.vertical-layout .browser-widget .media-body {\n  -webkit-column-count: unset;\n  column-count: unset;\n  -webkit-column-rule: none;\n  column-rule: none;\n}\n\n.vertical-layout .browser-widget .media-body h3 {\n  font-weight: 600;\n}\n\n.vertical-layout .browser-widget .media-body h3 span {\n  color: #000;\n}\n\n.vertical-layout .speed-chart .chart-container {\n  margin-top: -128px;\n  height: 503px;\n}\n\n.vertical-layout .crm-overall .flot-chart-placeholder {\n  height: 185px;\n}\n\n.vertical-layout .crm-overall {\n  border-radius: 0;\n}\n\n.vertical-layout .chart-block #recent-act {\n  height: 301px;\n}\n\n.vertical-layout footer {\n  position: relative;\n  background-color: #1A1C1D;\n  padding: 25px;\n}\n\n.vertical-layout #ct-7.flot-chart-container {\n  height: 400px !important;\n}\n\n@media screen and (max-device-width: 1366px) and (min-device-width: 1200px) {\n  .vertical-layout .browser-widget img {\n    height: 80px;\n  }\n}\n\n@media only screen and (max-width: 1366px) {\n  .vertical-layout .vertical-menu-main nav ul {\n    width: 85%;\n    margin: 0 auto;\n  }\n\n  .vertical-layout .pixelstrap a {\n    padding: 15px 17px;\n    padding-right: 25px;\n  }\n\n  .vertical-layout .pixelstrap a:hover,\n  .vertical-layout .pixelstrap a:focus,\n  .vertical-layout .pixelstrap a:active {\n    padding: 15px 17px;\n    padding-right: 25px;\n  }\n\n  .vertical-layout .browser-widget .media .media-body h3 {\n    font-size: 28px;\n  }\n\n  .vertical-layout .chart-block #recent-act {\n    height: 306px;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .vertical-layout .vertical-menu-main nav ul {\n    width: 300px;\n  }\n\n  .vertical-layout .vertical-menu-main nav ul li a {\n    color: #000;\n  }\n\n  .vertical-layout .sm {\n    top: 129px;\n  }\n\n  .vertical-layout .crm-overall .flot-chart-placeholder {\n    height: 180px;\n  }\n\n  .vertical-layout .chart-block #recent-act {\n    height: 306px;\n  }\n\n  .vertical-layout .page-body-wrapper .page-body.vertical-menu-mt {\n    margin-top: 136px !important;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu .navbar .nav-item .nav-link {\n    padding: 10px;\n    font-size: 12px;\n  }\n}\n\n@media screen and (min-device-width: 768px) and (max-device-width: 992px) {\n  .vertical-layout .crm-overall .flot-chart-placeholder {\n    height: 280px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .vertical-layout .page-main-header {\n    height: 75px !important;\n  }\n\n  .vertical-layout .page-main-header .main-header-left {\n    margin-top: 0;\n  }\n\n  .vertical-layout .page-main-header .main-header-left .logo-wrapper img {\n    margin-top: 0px;\n  }\n\n  .vertical-layout .page-main-header .main-header-right {\n    margin-top: 12px;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right {\n    text-align: center;\n    margin: 15px 0;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right .onhover-show-div {\n    display: block !important;\n    top: 50px;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right .onhover-show-div li {\n    padding: 12px 0px;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right .notification-dropdown.onhover-show-div li {\n    padding: 12px 20px;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right ul {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right ul li {\n    padding: 0px 0;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right .notification {\n    top: 9px;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right .profile-dropdown li {\n    padding: 0 0 5px 0px;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu~.page-body {\n    margin-top: 260px;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu {\n    top: 209px;\n    padding: 10px 0;\n    background: linear-gradient(22deg, #0bc0f4 0, #33e7d1 100%);\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu .navbar .navbar-collapse .navbar-nav .nav-item .nav-link {\n    color: #fff;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu .navbar .navbar-collapse .navbar-nav .nav-item .sub-menu>.nav-item .sub-menu {\n    left: 0 !important;\n    top: 50px !important;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu .navbar-toggler {\n    background-color: #19c9ed;\n    padding: 0;\n  }\n\n  .vertical-layout .page-body-wrapper .page-body.vertical-menu-mt {\n    margin-top: 69px !important;\n  }\n\n  .vertical-layout .sm {\n    top: 75px;\n  }\n\n  .vertical-layout .media-mb {\n    margin-bottom: 20px;\n  }\n\n  .vertical-layout .chart-block #recent-act {\n    height: 255px;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .vertical-layout .page-main-header .main-header-left {\n    margin-top: 0;\n    width: 150px;\n  }\n\n  .vertical-layout .page-main-header .main-header-right {\n    float: right;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .search-form input {\n    width: 100%;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right {\n    text-align: center;\n    margin: 15px 0;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right ul li {\n    padding: 0px 0;\n  }\n\n  .vertical-layout .page-main-header .main-header-right .nav-right .profile-dropdown li {\n    padding: 0 0 5px 0px;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu~.page-body {\n    margin-top: 260px;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu {\n    top: 208px;\n    padding: 10px 0;\n  }\n\n  .vertical-layout .browser-widget .media .media-img {\n    width: auto;\n    margin-bottom: 0;\n  }\n\n  .vertical-layout .user-status tbody tr td {\n    min-width: 90px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .vertical-layout .page-body-wrapper .vertical-menu~.page-body {\n    margin-top: 257px;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu {\n    top: 205px;\n  }\n\n  .vertical-layout .page-body-wrapper .vertical-menu .navbar .nav-item .sub-menu>.nav-item .sub-menu {\n    left: 0 !important;\n    top: 50px !important;\n  }\n\n  .vertical-layout .page-main-header .main-header-left .logo-wrapper img {\n    height: 45px !important;\n  }\n\n  .vertical-layout .center-small-size {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n  }\n\n  .vertical-layout .center-small-size .media-body {\n    -webkit-box-flex: 0;\n    -ms-flex: 0;\n    flex: 0;\n    min-width: 21%;\n  }\n\n  .vertical-layout .media-mb {\n    margin-bottom: 15px;\n  }\n}\n\n@media only screen and (max-width: 360px) {\n  .vertical-layout .chart-block #recent-act {\n    height: 235px;\n  }\n\n  .vertical-layout .user-status table tbody img {\n    height: auto;\n  }\n\n  .vertical-layout .user-status table tbody tr td {\n    min-width: 108px;\n  }\n\n  .vertical-layout .center-small-size .media-body {\n    min-width: 34%;\n  }\n}\n.card .delivered-card-body {\n  padding:15px 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
